(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89wqa"));

});
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $dd934af551f44020$export$3ba232387fd5d6dd, (v) => $dd934af551f44020$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$3ba232387fd5d6dd;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
'use strict';
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
function $dd934af551f44020$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$3ba232387fd5d6dd = $dd934af551f44020$var$X;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = $dd934af551f44020$var$X;
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("4N26z", function(module, exports) {

$parcel$export(module.exports, "default", () => $37cd5f0a07c59c07$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $6hJZG = parcelRequire("6hJZG");

var $lwoFl = parcelRequire("lwoFl");

var $keK2j = parcelRequire("keK2j");

var $4XAnW = parcelRequire("4XAnW");

var $6sv0r = parcelRequire("6sv0r");

var $gKCqJ = parcelRequire("gKCqJ");

var $gIBjk = parcelRequire("gIBjk");

var $4iuFJ = parcelRequire("4iuFJ");

var $7TidC = parcelRequire("7TidC");

var $6nyQJ = parcelRequire("6nyQJ");

var $8NFma = parcelRequire("8NFma");

var $cfvjJ = parcelRequire("cfvjJ");

var $k2rc8 = parcelRequire("k2rc8");

var $bI73o = parcelRequire("bI73o");

var $e7fV1 = parcelRequire("e7fV1");

var $2RtS7 = parcelRequire("2RtS7");

var $9Kxbo = parcelRequire("9Kxbo");

var $d8f9m = parcelRequire("d8f9m");

var $kieyz = parcelRequire("kieyz");

var $eTp4F = parcelRequire("eTp4F");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $37cd5f0a07c59c07$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bI73o.default), {
        ...props,
        timeout: null
    });
}
function $37cd5f0a07c59c07$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $bI73o.default), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $37cd5f0a07c59c07$var$Modal = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $9Kxbo.default), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $8NFma.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $8NFma.useState)(false);
    const waitingForMouseUpRef = (0, $8NFma.useRef)(false);
    const ignoreBackdropClickRef = (0, $8NFma.useRef)(false);
    const removeStaticModalAnimationRef = (0, $8NFma.useRef)(null);
    const [modal, setModalRef] = (0, $gKCqJ.default)();
    const mergedRef = (0, $4iuFJ.default)(ref, setModalRef);
    const handleHide = (0, $gIBjk.default)(onHide);
    const isRTL = (0, $iQRYA.useIsRTL)();
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'modal');
    const modalContext = (0, $8NFma.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $k2rc8.getSharedManager)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $lwoFl.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $keK2j.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $6sv0r.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $6sv0r.default)() : undefined
        });
    }
    const handleWindowResize = (0, $gIBjk.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $7TidC.default)(()=>{
        (0, $4XAnW.default)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $6nyQJ.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $6hJZG.default)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $4XAnW.default)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $8NFma.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2RtS7.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $cfvjJ.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $37cd5f0a07c59c07$var$DialogTransition : undefined,
            backdropTransition: animation ? $37cd5f0a07c59c07$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$37cd5f0a07c59c07$var$Modal.displayName = 'Modal';
var $37cd5f0a07c59c07$export$2e2bcd8739ae039 = Object.assign($37cd5f0a07c59c07$var$Modal, {
    Body: (0, $e7fV1.default),
    Header: (0, $kieyz.default),
    Title: (0, $eTp4F.default),
    Footer: (0, $d8f9m.default),
    Dialog: (0, $9Kxbo.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

});
parcelRegister("lmhZG", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("6hJZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $493802086adc306f$export$2e2bcd8739ae039);
/* eslint-disable no-return-assign */ 
var $lwoFl = parcelRequire("lwoFl");
var $493802086adc306f$export$63fefd044b2bc624 = false;
var $493802086adc306f$export$a614c6b395900f69 = false;
try {
    var $493802086adc306f$var$options = {
        get passive () {
            return $493802086adc306f$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $493802086adc306f$export$a614c6b395900f69 = $493802086adc306f$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $lwoFl.default) {
        window.addEventListener('test', $493802086adc306f$var$options, $493802086adc306f$var$options);
        window.removeEventListener('test', $493802086adc306f$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $493802086adc306f$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$493802086adc306f$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$493802086adc306f$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $493802086adc306f$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $493802086adc306f$export$2e2bcd8739ae039 = $493802086adc306f$var$addEventListener;

});
parcelRegister("lwoFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $faafb845dd37e77c$export$2e2bcd8739ae039);
var $faafb845dd37e77c$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("keK2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb8d34d9b5cf8b7$export$2e2bcd8739ae039);
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $ebb8d34d9b5cf8b7$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("4XAnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $39c8e57760364d3f$export$2e2bcd8739ae039);
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $39c8e57760364d3f$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $39c8e57760364d3f$export$2e2bcd8739ae039 = $39c8e57760364d3f$var$removeEventListener;

});

parcelRegister("6sv0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b3d68bfa25a22bd$export$2e2bcd8739ae039);

var $lwoFl = parcelRequire("lwoFl");
var $4b3d68bfa25a22bd$var$size;
function $4b3d68bfa25a22bd$export$2e2bcd8739ae039(recalc) {
    if (!$4b3d68bfa25a22bd$var$size && $4b3d68bfa25a22bd$var$size !== 0 || recalc) {
        if (0, $lwoFl.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $4b3d68bfa25a22bd$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $4b3d68bfa25a22bd$var$size;
}

});

parcelRegister("gKCqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c31ec0ab3420d8e3$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $c31ec0ab3420d8e3$export$2e2bcd8739ae039() {
    return (0, $8NFma.useState)(null);
}

});

parcelRegister("gIBjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bdb2861596cd63$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $1u84O = parcelRequire("1u84O");
function $c2bdb2861596cd63$export$2e2bcd8739ae039(fn) {
    const ref = (0, $1u84O.default)(fn);
    return (0, $8NFma.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("1u84O", function(module, exports) {

$parcel$export(module.exports, "default", () => $114edba734da7d4a$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $114edba734da7d4a$var$useCommittedRef(value) {
    const ref = (0, $8NFma.useRef)(value);
    (0, $8NFma.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $114edba734da7d4a$export$2e2bcd8739ae039 = $114edba734da7d4a$var$useCommittedRef;

});


parcelRegister("4iuFJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3210a2ae82620b79$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
const $3210a2ae82620b79$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $3210a2ae82620b79$export$c9058316764c140e(refA, refB) {
    const a = $3210a2ae82620b79$var$toFnRef(refA);
    const b = $3210a2ae82620b79$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $3210a2ae82620b79$var$useMergedRefs(refA, refB) {
    return (0, $8NFma.useMemo)(()=>$3210a2ae82620b79$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $3210a2ae82620b79$export$2e2bcd8739ae039 = $3210a2ae82620b79$var$useMergedRefs;

});

parcelRegister("7TidC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bebcd50fbfc803a$export$2e2bcd8739ae039);

var $aWAew = parcelRequire("aWAew");

var $8NFma = parcelRequire("8NFma");
function $5bebcd50fbfc803a$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $aWAew.default)(fn);
    (0, $8NFma.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("aWAew", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7b6d540f90c06a$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $7f7b6d540f90c06a$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $8NFma.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("6nyQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a4fec73880d9784$export$2e2bcd8739ae039);

var $ek4P1 = parcelRequire("ek4P1");

var $aZ87u = parcelRequire("aZ87u");

var $9xeA6 = parcelRequire("9xeA6");
function $4a4fec73880d9784$var$parseDuration(node) {
    var str = (0, $ek4P1.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $4a4fec73880d9784$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $9xeA6.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $aZ87u.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $4a4fec73880d9784$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $4a4fec73880d9784$var$parseDuration(element) || 0;
    var removeEmulate = $4a4fec73880d9784$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $aZ87u.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("ek4P1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d6ac7aa5d4f8ad$export$2e2bcd8739ae039);

var $a1KWH = parcelRequire("a1KWH");

var $gMhci = parcelRequire("gMhci");

var $g3yGm = parcelRequire("g3yGm");
function $a6d6ac7aa5d4f8ad$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $gMhci.default)(property)) || (0, $a1KWH.default)(node).getPropertyValue((0, $gMhci.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $gMhci.default)(key));
        else if ((0, $g3yGm.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $gMhci.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $a6d6ac7aa5d4f8ad$export$2e2bcd8739ae039 = $a6d6ac7aa5d4f8ad$var$style;

});
parcelRegister("a1KWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ce69d9715410f5$export$2e2bcd8739ae039);

var $CqYY4 = parcelRequire("CqYY4");
function $74ce69d9715410f5$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $CqYY4.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("CqYY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $07387adba4574d99$export$2e2bcd8739ae039);

var $keK2j = parcelRequire("keK2j");
function $07387adba4574d99$export$2e2bcd8739ae039(node) {
    var doc = (0, $keK2j.default)(node);
    return doc && doc.defaultView || window;
}

});


parcelRegister("gMhci", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36e78113b1d3a8f$export$2e2bcd8739ae039);
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $jL6fn = parcelRequire("jL6fn");
var $c36e78113b1d3a8f$var$msPattern = /^ms-/;
function $c36e78113b1d3a8f$export$2e2bcd8739ae039(string) {
    return (0, $jL6fn.default)(string).replace($c36e78113b1d3a8f$var$msPattern, '-ms-');
}

});
parcelRegister("jL6fn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62740a6b1580678$export$2e2bcd8739ae039);
var $e62740a6b1580678$var$rUpper = /([A-Z])/g;
function $e62740a6b1580678$export$2e2bcd8739ae039(string) {
    return string.replace($e62740a6b1580678$var$rUpper, '-$1').toLowerCase();
}

});


parcelRegister("g3yGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb07d4561e1541de$export$2e2bcd8739ae039);
var $bb07d4561e1541de$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $bb07d4561e1541de$export$2e2bcd8739ae039(value) {
    return !!(value && $bb07d4561e1541de$var$supportedTransforms.test(value));
}

});


parcelRegister("aZ87u", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ff5e64bebde7f18$export$2e2bcd8739ae039);

var $6hJZG = parcelRequire("6hJZG");

var $4XAnW = parcelRequire("4XAnW");
function $7ff5e64bebde7f18$var$listen(node, eventName, handler, options) {
    (0, $6hJZG.default)(node, eventName, handler, options);
    return function() {
        (0, $4XAnW.default)(node, eventName, handler, options);
    };
}
var $7ff5e64bebde7f18$export$2e2bcd8739ae039 = $7ff5e64bebde7f18$var$listen;

});

parcelRegister("9xeA6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1281b0b3c0cf0d$export$2e2bcd8739ae039);
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $6f1281b0b3c0cf0d$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});


parcelRegister("cfvjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eaf2db299f2f6d5$export$2e2bcd8739ae039);

var $es2Ve = parcelRequire("es2Ve");

var $ahvoT = parcelRequire("ahvoT");

var $lwoFl = parcelRequire("lwoFl");

var $aZ87u = parcelRequire("aZ87u");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $awjVQ = parcelRequire("awjVQ");

var $cj0cL = parcelRequire("cj0cL");

var $AYjSz = parcelRequire("AYjSz");

var $i4XZL = parcelRequire("i4XZL");

var $bW5x7 = parcelRequire("bW5x7");

var $27oKv = parcelRequire("27oKv");

var $6Wy9W = parcelRequire("6Wy9W");

var $682Kc = parcelRequire("682Kc");

var $hKTCF = parcelRequire("hKTCF");

var $1IdZj = parcelRequire("1IdZj");
const $8eaf2db299f2f6d5$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $8eaf2db299f2f6d5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $8eaf2db299f2f6d5$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $8eaf2db299f2f6d5$var$getManager(window) {
    if (!$8eaf2db299f2f6d5$var$manager) $8eaf2db299f2f6d5$var$manager = new (0, $bW5x7.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $8eaf2db299f2f6d5$var$manager;
}
function $8eaf2db299f2f6d5$var$useModalManager(provided) {
    const window = (0, $6Wy9W.default)();
    const modalManager = provided || $8eaf2db299f2f6d5$var$getManager(window);
    const modal = (0, $8NFma.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $8NFma.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $8NFma.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $8eaf2db299f2f6d5$var$Modal = /*#__PURE__*/ (0, $8NFma.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $1IdZj.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $8eaf2db299f2f6d5$var$_objectWithoutPropertiesLoose(_ref, $8eaf2db299f2f6d5$var$_excluded);
    const ownerWindow = (0, $6Wy9W.default)();
    const container = (0, $27oKv.default)(containerRef);
    const modal = $8eaf2db299f2f6d5$var$useModalManager(providedManager);
    const isMounted = (0, $awjVQ.default)();
    const prevShow = (0, $AYjSz.default)(show);
    const [exited, setExited] = (0, $8NFma.useState)(!show);
    const lastFocusRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $lwoFl.default) && !prevShow && show) lastFocusRef.current = (0, $es2Ve.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $i4XZL.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $aZ87u.default)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $aZ87u.default)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $es2Ve.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $ahvoT.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $i4XZL.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $8NFma.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $8NFma.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $cj0cL.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $i4XZL.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $es2Ve.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $ahvoT.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $i4XZL.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $i4XZL.default)((e)=>{
        if (keyboard && (0, $hKTCF.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $8NFma.useRef)();
    const removeKeydownListenerRef = (0, $8NFma.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $1IdZj.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $8NFma.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $682Kc.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $682Kc.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).createPortal(/*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$8eaf2db299f2f6d5$var$Modal.displayName = 'Modal';
var $8eaf2db299f2f6d5$export$2e2bcd8739ae039 = Object.assign($8eaf2db299f2f6d5$var$Modal, {
    Manager: (0, $bW5x7.default)
});

});
parcelRegister("es2Ve", function(module, exports) {

$parcel$export(module.exports, "default", () => $a855f27f44c0dc6b$export$2e2bcd8739ae039);

var $keK2j = parcelRequire("keK2j");
function $a855f27f44c0dc6b$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $keK2j.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

});

parcelRegister("ahvoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $77c3d96c682bd18b$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $77c3d96c682bd18b$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("2pmb0", function(module, exports) {
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("23wBm"));

});
parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
'use strict';

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$Lg(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$Lg(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$Sg(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Ug = $17f526922e4a857c$var$Og(!0), $17f526922e4a857c$var$Vg = $17f526922e4a857c$var$Og(!1), $17f526922e4a857c$var$Wg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Xg = null, $17f526922e4a857c$var$Yg = null, $17f526922e4a857c$var$Zg = null;
function $17f526922e4a857c$var$$g() {
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Xg = null;
}
function $17f526922e4a857c$var$ah(a) {
    var b = $17f526922e4a857c$var$Wg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$ch(a, b) {
    $17f526922e4a857c$var$Xg = a;
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$dh = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$eh(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Yg) {
            if (null === $17f526922e4a857c$var$Xg) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Yg = a;
            $17f526922e4a857c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Yg.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$fh = null;
function $17f526922e4a857c$var$gh(a) {
    null === $17f526922e4a857c$var$fh ? $17f526922e4a857c$var$fh = [
        a
    ] : $17f526922e4a857c$var$fh.push(a);
}
function $17f526922e4a857c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$ih(a, d);
}
function $17f526922e4a857c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$jh = !1;
function $17f526922e4a857c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$ih(a, c);
}
function $17f526922e4a857c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$th = {}, $17f526922e4a857c$var$uh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$vh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$wh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th);
function $17f526922e4a857c$var$xh(a) {
    if (a === $17f526922e4a857c$var$th) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$yh(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$wh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, $17f526922e4a857c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, b);
}
function $17f526922e4a857c$var$zh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$vh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$wh);
}
function $17f526922e4a857c$var$Ah(a) {
    $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
    var b = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, c));
}
function $17f526922e4a857c$var$Bh(a) {
    $17f526922e4a857c$var$vh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$uh), $17f526922e4a857c$var$E($17f526922e4a857c$var$vh));
}
var $17f526922e4a857c$var$L = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Dh = [];
function $17f526922e4a857c$var$Eh() {
    for(var a = 0; a < $17f526922e4a857c$var$Dh.length; a++)$17f526922e4a857c$var$Dh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Dh.length = 0;
}
var $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Hh = 0, $17f526922e4a857c$var$M = null, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$Ih = !1, $17f526922e4a857c$var$Jh = !1, $17f526922e4a857c$var$Kh = 0, $17f526922e4a857c$var$Lh = 0;
function $17f526922e4a857c$var$P() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Nh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Hh = f;
    $17f526922e4a857c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Fh.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Oh : $17f526922e4a857c$var$Ph;
    a = c(d, e);
    if ($17f526922e4a857c$var$Jh) {
        f = 0;
        do {
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Qh;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Jh);
    }
    $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
    b = null !== $17f526922e4a857c$var$N && null !== $17f526922e4a857c$var$N.next;
    $17f526922e4a857c$var$Hh = 0;
    $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
    $17f526922e4a857c$var$Ih = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$Sh() {
    var a = 0 !== $17f526922e4a857c$var$Kh;
    $17f526922e4a857c$var$Kh = 0;
    return a;
}
function $17f526922e4a857c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Uh() {
    if (null === $17f526922e4a857c$var$N) {
        var a = $17f526922e4a857c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$N.next;
    var b = null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState : $17f526922e4a857c$var$O.next;
    if (null !== b) $17f526922e4a857c$var$O = b, $17f526922e4a857c$var$N = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$N = a;
        a = {
            memoizedState: $17f526922e4a857c$var$N.memoizedState,
            baseState: $17f526922e4a857c$var$N.baseState,
            baseQueue: $17f526922e4a857c$var$N.baseQueue,
            queue: $17f526922e4a857c$var$N.queue,
            next: null
        };
        null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    }
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$Wh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$M.lanes |= m;
                $17f526922e4a857c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$M.lanes |= f, $17f526922e4a857c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$Xh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$Yh() {}
function $17f526922e4a857c$var$Zh(a, b) {
    var c = $17f526922e4a857c$var$M, d = $17f526922e4a857c$var$Uh(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$dh = !0);
    d = d.queue;
    $17f526922e4a857c$var$$h($17f526922e4a857c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$O && $17f526922e4a857c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
}
function $17f526922e4a857c$var$ai(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
    });
}
function $17f526922e4a857c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$ih(a, 1);
    null !== b && $17f526922e4a857c$var$gi(b, a, 1, -1);
}
function $17f526922e4a857c$var$hi(a) {
    var b = $17f526922e4a857c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ii.bind(null, $17f526922e4a857c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$ji() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$ki(a, b, c, d) {
    var e = $17f526922e4a857c$var$Th();
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    var e = $17f526922e4a857c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$N) {
        var g = $17f526922e4a857c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Mh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$bi(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, f, d);
}
function $17f526922e4a857c$var$mi(a, b) {
    return $17f526922e4a857c$var$ki(8390656, 8, a, b);
}
function $17f526922e4a857c$var$$h(a, b) {
    return $17f526922e4a857c$var$li(2048, 8, a, b);
}
function $17f526922e4a857c$var$ni(a, b) {
    return $17f526922e4a857c$var$li(4, 2, a, b);
}
function $17f526922e4a857c$var$oi(a, b) {
    return $17f526922e4a857c$var$li(4, 4, a, b);
}
function $17f526922e4a857c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$li(4, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$ri() {}
function $17f526922e4a857c$var$si(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ti(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ui(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$dh = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$M.lanes |= c, $17f526922e4a857c$var$rh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$vi(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Gh.transition;
    $17f526922e4a857c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Gh.transition = d;
    }
}
function $17f526922e4a857c$var$wi() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$xi(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, c);
    else if (c = $17f526922e4a857c$var$hh(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$R();
        $17f526922e4a857c$var$gi(c, a, d, e);
        $17f526922e4a857c$var$Bi(c, b, d);
    }
}
function $17f526922e4a857c$var$ii(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$hh(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$R(), $17f526922e4a857c$var$gi(c, a, d, e), $17f526922e4a857c$var$Bi(c, b, d));
    }
}
function $17f526922e4a857c$var$zi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$M || null !== b && b === $17f526922e4a857c$var$M;
}
function $17f526922e4a857c$var$Ai(a, b) {
    $17f526922e4a857c$var$Jh = $17f526922e4a857c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$Rh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$P,
    useContext: $17f526922e4a857c$var$P,
    useEffect: $17f526922e4a857c$var$P,
    useImperativeHandle: $17f526922e4a857c$var$P,
    useInsertionEffect: $17f526922e4a857c$var$P,
    useLayoutEffect: $17f526922e4a857c$var$P,
    useMemo: $17f526922e4a857c$var$P,
    useReducer: $17f526922e4a857c$var$P,
    useRef: $17f526922e4a857c$var$P,
    useState: $17f526922e4a857c$var$P,
    useDebugValue: $17f526922e4a857c$var$P,
    useDeferredValue: $17f526922e4a857c$var$P,
    useTransition: $17f526922e4a857c$var$P,
    useMutableSource: $17f526922e4a857c$var$P,
    useSyncExternalStore: $17f526922e4a857c$var$P,
    useId: $17f526922e4a857c$var$P,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Oh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ki(4194308, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$xi.bind(null, $17f526922e4a857c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$hi,
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$hi(!1), b = a[0];
        a = $17f526922e4a857c$var$vi.bind(null, a[1]);
        $17f526922e4a857c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$M, e = $17f526922e4a857c$var$Th();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$mi($17f526922e4a857c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$Th(), b = $17f526922e4a857c$var$Q.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Ph = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Wh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Qh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Xh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return null === $17f526922e4a857c$var$N ? b.memoizedState = a : $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $17f526922e4a857c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$R(), d = $17f526922e4a857c$var$yi(a), e = $17f526922e4a857c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$nh(a, e, d);
        null !== b && ($17f526922e4a857c$var$gi(b, a, d, c), $17f526922e4a857c$var$oh(b, a, d));
    }
};
function $17f526922e4a857c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$eh(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $17f526922e4a857c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$eh(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$Ei.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Ni(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Oi || ($17f526922e4a857c$var$Oi = !0, $17f526922e4a857c$var$Pi = d);
        $17f526922e4a857c$var$Li(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Qi(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Li(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Ri ? $17f526922e4a857c$var$Ri = new Set([
            this
        ]) : $17f526922e4a857c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$mh(-1, 1), b.tag = 2, $17f526922e4a857c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Wi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$dh = !1;
function $17f526922e4a857c$var$Xi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Vg(b, null, c, d) : $17f526922e4a857c$var$Ug(b, a.child, c, d);
}
function $17f526922e4a857c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$ch(b, e);
    d = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$bj(a, b, f, d, e);
        a = $17f526922e4a857c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$dh = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$Zi(a, b, e);
        }
    }
    return $17f526922e4a857c$var$cj(a, b, c, d, e);
}
function $17f526922e4a857c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj);
            $17f526922e4a857c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= d;
    $17f526922e4a857c$var$Xi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$ch(b, e);
    c = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$ch(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$ij(a, b), $17f526922e4a857c$var$Gi(b, c, d), $17f526922e4a857c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$eh(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$Hi(b, g, d, l);
        $17f526922e4a857c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof m && ($17f526922e4a857c$var$Di(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$eh(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$Hi(b, g, d, k);
        $17f526922e4a857c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof y && ($17f526922e4a857c$var$Di(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$jj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$jj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$Zi(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Ug(b, a.child, null, f), b.child = $17f526922e4a857c$var$Ug(b, null, h, f)) : $17f526922e4a857c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$yh(a, b.containerInfo);
}
function $17f526922e4a857c$var$lj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Xi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$pj(g, d, 0, null), a = $17f526922e4a857c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$nj(c), b.memoizedState = $17f526922e4a857c$var$mj, a) : $17f526922e4a857c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$Pg(h, f) : (f = $17f526922e4a857c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$qj(a, b) {
    b = $17f526922e4a857c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$sj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Ug(b, a.child, null, c);
    a = $17f526922e4a857c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$nj(g);
        b.memoizedState = $17f526922e4a857c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Ki(f, d, void 0);
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$dh || h) {
        d = $17f526922e4a857c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$ih(a, e), $17f526922e4a857c$var$gi(d, a, e, -1));
        }
        $17f526922e4a857c$var$tj();
        d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$bh(a.return, b, c);
}
function $17f526922e4a857c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Xi(a, b, d.children, c);
    d = $17f526922e4a857c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$vj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$kj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Ah(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$oj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
                a = $17f526922e4a857c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$dj(a, b, c);
    }
    return $17f526922e4a857c$var$Zi(a, b, c);
}
var $17f526922e4a857c$var$zj, $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj;
$17f526922e4a857c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Aj = function() {};
$17f526922e4a857c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Dj(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$zh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Aj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Bh(b);
            var e = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
                $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$L.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$Aj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Dj(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Gj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$L.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$fj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Ij(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Bh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$L), null;
        case 4:
            return $17f526922e4a857c$var$zh(), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Jj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Nj = !1;
function $17f526922e4a857c$var$Oj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Nj;
    $17f526922e4a857c$var$Nj = !1;
    return n;
}
function $17f526922e4a857c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Vj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Vj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Xj = !1;
function $17f526922e4a857c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$Zj(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$Zj(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Lj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Xj = !0;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Mj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Yj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Yj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Yj(a, b, c);
    }
}
function $17f526922e4a857c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Kj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Xj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$Zj(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$dk(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Pj(3, a, a.return), $17f526922e4a857c$var$Qj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Pj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            break;
        case 13:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$fk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$ek(a);
    }
}
function $17f526922e4a857c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$hk(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$ik(a, b, c);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Jj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Jj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$jk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$jk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$ik(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Jj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$kk(a, b, c);
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Rj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$gk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$jk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Qj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$lk = Math.ceil, $17f526922e4a857c$var$mk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$fj = 0, $17f526922e4a857c$var$ej = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$pk = null, $17f526922e4a857c$var$rh = 0, $17f526922e4a857c$var$qk = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = null, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$fk = 0, $17f526922e4a857c$var$Gj = Infinity, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Oi = !1, $17f526922e4a857c$var$Pi = null, $17f526922e4a857c$var$Ri = null, $17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = null, $17f526922e4a857c$var$xk = 0, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, $17f526922e4a857c$var$Ak = -1, $17f526922e4a857c$var$Bk = 0;
function $17f526922e4a857c$var$R() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$Ak : $17f526922e4a857c$var$Ak = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Bk && ($17f526922e4a857c$var$Bk = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Bk;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$gi(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$yk) throw $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$Q) a === $17f526922e4a857c$var$Q && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$qk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Ck(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Dk(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Dk(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Ek.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Ek.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Fk(c, $17f526922e4a857c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Gk(a, b) {
    $17f526922e4a857c$var$Ak = -1;
    $17f526922e4a857c$var$Bk = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Hk() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Ik(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Jk();
        if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Kk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Lk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Mk(a, h);
        }
        $17f526922e4a857c$var$$g();
        $17f526922e4a857c$var$mk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Nk(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Ok(e) && (b = $17f526922e4a857c$var$Ik(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Nk(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$fk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Gk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Nk(a, b) {
    var c = $17f526922e4a857c$var$sk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Kk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Ik(a, b);
    2 !== a && (b = $17f526922e4a857c$var$tk, $17f526922e4a857c$var$tk = c, null !== b && $17f526922e4a857c$var$Fj(b));
    return a;
}
function $17f526922e4a857c$var$Fj(a) {
    null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = a : $17f526922e4a857c$var$tk.push.apply($17f526922e4a857c$var$tk, a);
}
function $17f526922e4a857c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Ck(a, b) {
    b &= ~$17f526922e4a857c$var$rk;
    b &= ~$17f526922e4a857c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Ek(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Nk(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, b), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Qk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Rk(a) {
    null !== $17f526922e4a857c$var$wk && 0 === $17f526922e4a857c$var$wk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$ok.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$ok.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Hj() {
    $17f526922e4a857c$var$fj = $17f526922e4a857c$var$ej.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$ej);
}
function $17f526922e4a857c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$zh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Eh();
                break;
            case 5:
                $17f526922e4a857c$var$Bh(d);
                break;
            case 4:
                $17f526922e4a857c$var$zh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 10:
                $17f526922e4a857c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Hj();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$Q = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$Pg(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$fj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$pk = null;
    $17f526922e4a857c$var$rk = $17f526922e4a857c$var$qk = $17f526922e4a857c$var$rh = 0;
    $17f526922e4a857c$var$tk = $17f526922e4a857c$var$sk = null;
    if (null !== $17f526922e4a857c$var$fh) {
        for(b = 0; b < $17f526922e4a857c$var$fh.length; b++)if (c = $17f526922e4a857c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$fh = null;
    }
    return a;
}
function $17f526922e4a857c$var$Mk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$$g();
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
            if ($17f526922e4a857c$var$Ih) {
                for(var d = $17f526922e4a857c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Ih = !1;
            }
            $17f526922e4a857c$var$Hh = 0;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            $17f526922e4a857c$var$nk.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$pk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Si(f, l, b);
                            $17f526922e4a857c$var$tj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Vi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ji(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$sk ? $17f526922e4a857c$var$sk = [
                    f
                ] : $17f526922e4a857c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Ni(f, k, b);
                            $17f526922e4a857c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Qi(f, h, b);
                                $17f526922e4a857c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Sk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Jk() {
    var a = $17f526922e4a857c$var$mk.current;
    $17f526922e4a857c$var$mk.current = $17f526922e4a857c$var$Rh;
    return null === a ? $17f526922e4a857c$var$Rh : a;
}
function $17f526922e4a857c$var$tj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$Q || 0 === ($17f526922e4a857c$var$rh & 268435455) && 0 === ($17f526922e4a857c$var$qk & 268435455) || $17f526922e4a857c$var$Ck($17f526922e4a857c$var$Q, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Ik(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Jk();
    if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Kk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Tk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Mk(a, e);
    }
    $17f526922e4a857c$var$$g();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$mk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$Q = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Tk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Lk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Uk(a) {
    var b = $17f526922e4a857c$var$Vk(a.alternate, a, $17f526922e4a857c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Sk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$nk.current = null;
}
function $17f526922e4a857c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Ej(c, b, $17f526922e4a857c$var$fj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Pk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$ok.transition;
    try {
        $17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Wk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$ok.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Wk(a, b, c, d) {
    do $17f526922e4a857c$var$Hk();
    while (null !== $17f526922e4a857c$var$wk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$Q && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$vk || ($17f526922e4a857c$var$vk = !0, $17f526922e4a857c$var$Fk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$ok.transition;
        $17f526922e4a857c$var$ok.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$nk.current = null;
        $17f526922e4a857c$var$Oj(a, c);
        $17f526922e4a857c$var$dk(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$hk(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$ok.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$vk && ($17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = a, $17f526922e4a857c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Ri = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Oi) throw $17f526922e4a857c$var$Oi = !1, a = $17f526922e4a857c$var$Pi, $17f526922e4a857c$var$Pi = null, a;
    0 !== ($17f526922e4a857c$var$xk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$zk ? $17f526922e4a857c$var$yk++ : ($17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = a) : $17f526922e4a857c$var$yk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Hk() {
    if (null !== $17f526922e4a857c$var$wk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$xk), b = $17f526922e4a857c$var$ok.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$ok.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$wk) var d = !1;
            else {
                a = $17f526922e4a857c$var$wk;
                $17f526922e4a857c$var$wk = null;
                $17f526922e4a857c$var$xk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Sj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$ok.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Xk(a, b, c) {
    b = $17f526922e4a857c$var$Ji(c, b);
    b = $17f526922e4a857c$var$Ni(a, b, 1);
    a = $17f526922e4a857c$var$nh(a, b, 1);
    b = $17f526922e4a857c$var$R();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Dk(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(d))) {
                a = $17f526922e4a857c$var$Ji(c, a);
                a = $17f526922e4a857c$var$Qi(b, a, 1);
                b = $17f526922e4a857c$var$nh(b, a, 1);
                a = $17f526922e4a857c$var$R();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$Q === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$fk ? $17f526922e4a857c$var$Kk(a, 0) : $17f526922e4a857c$var$rk |= c);
    $17f526922e4a857c$var$Dk(a, b);
}
function $17f526922e4a857c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$R();
    a = $17f526922e4a857c$var$ih(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Dk(a, c));
}
function $17f526922e4a857c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Yk(a, c);
}
function $17f526922e4a857c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Yk(a, c);
}
var $17f526922e4a857c$var$Vk;
$17f526922e4a857c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$yj(a, b, c);
            $17f526922e4a857c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$ij(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$ch(b, c);
            e = $17f526922e4a857c$var$Nh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$kh(b), e.updater = $17f526922e4a857c$var$Ei, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$Ii(b, d, a, c), b = $17f526922e4a857c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$Zk(d);
                a = $17f526922e4a857c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$$i(null, b, d, $17f526922e4a857c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$kj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$lh(a, b);
                $17f526922e4a857c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$Zi(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Ah(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$gj(a, b), $17f526922e4a857c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$oj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Ug(b, null, d, c) : $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$Yi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$ch(b, c), e = $17f526922e4a857c$var$eh(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Ci(d, b.pendingProps), e = $17f526922e4a857c$var$Ci(d.type, e), $17f526922e4a857c$var$$i(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$ij(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$ch(b, c), $17f526922e4a857c$var$Gi(b, d, e), $17f526922e4a857c$var$Ii(b, d, e, c), $17f526922e4a857c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$xj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$dj(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Fk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$$k(a, b, c, d);
}
function $17f526922e4a857c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$Zk(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Tg(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Tg(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$pj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$Qg(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$kh(f);
    return a;
}
function $17f526922e4a857c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$dl(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$dl(null);
    c = a.current;
    d = $17f526922e4a857c$var$R();
    e = $17f526922e4a857c$var$yi(c);
    f = $17f526922e4a857c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$nh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Dk(a, d);
    return a;
}
function $17f526922e4a857c$var$fl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$R(), g = $17f526922e4a857c$var$yi(e);
    c = $17f526922e4a857c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$nh(e, b, g);
    null !== a && ($17f526922e4a857c$var$gi(a, e, g, f), $17f526922e4a857c$var$oh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    $17f526922e4a857c$var$hl(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$hl(a, b);
}
function $17f526922e4a857c$var$jl() {
    return null;
}
var $17f526922e4a857c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ll(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.render = $17f526922e4a857c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$fl(a, b, null, null);
};
$17f526922e4a857c$var$ml.prototype.unmount = $17f526922e4a857c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Rk(function() {
            $17f526922e4a857c$var$fl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$pl() {}
function $17f526922e4a857c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$gl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$el(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$pl);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$gl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$bl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$pl);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$fl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$gl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$fl(b, g, a, e);
    } else g = $17f526922e4a857c$var$ql(c, b, a, e, d);
    return $17f526922e4a857c$var$gl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Dk(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Rk(function() {
                var b = $17f526922e4a857c$var$ih(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$R();
                    $17f526922e4a857c$var$gi(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$il(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$il(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$yi(a), c = $17f526922e4a857c$var$ih(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(c, a, b, d);
        }
        $17f526922e4a857c$var$il(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Rk;
var $17f526922e4a857c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Qk
    ]
}, $17f526922e4a857c$var$tl = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$ul = {
    bundleType: $17f526922e4a857c$var$tl.bundleType,
    version: $17f526922e4a857c$var$tl.version,
    rendererPackageName: $17f526922e4a857c$var$tl.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$tl.findFiberByHostInstance || $17f526922e4a857c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$vl.isDisabled && $17f526922e4a857c$var$vl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$vl.inject($17f526922e4a857c$var$ul), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$vl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$sl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$nl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$cl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ll(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Rk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$ol(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$rl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
'use strict';
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});




parcelRegister("awjVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8c5aa37df93116$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $7a8c5aa37df93116$export$2e2bcd8739ae039() {
    const mounted = (0, $8NFma.useRef)(true);
    const isMounted = (0, $8NFma.useRef)(()=>mounted.current);
    (0, $8NFma.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});

parcelRegister("cj0cL", function(module, exports) {

$parcel$export(module.exports, "default", () => $024fdc90d076bf80$export$2e2bcd8739ae039);

var $4YR4p = parcelRequire("4YR4p");

var $8NFma = parcelRequire("8NFma");
function $024fdc90d076bf80$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $4YR4p.default)(fn);
    (0, $8NFma.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("4YR4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a05eea9dc95d250$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $3a05eea9dc95d250$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $8NFma.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("AYjSz", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f2272154f3943f$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
function $06f2272154f3943f$export$2e2bcd8739ae039(value) {
    const ref = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

});

parcelRegister("i4XZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29723803ecc70eb$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lQCMt = parcelRequire("lQCMt");
function $d29723803ecc70eb$export$2e2bcd8739ae039(fn) {
    const ref = (0, $lQCMt.default)(fn);
    return (0, $8NFma.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("lQCMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7c8960ea86adfe$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $fe7c8960ea86adfe$var$useCommittedRef(value) {
    const ref = (0, $8NFma.useRef)(value);
    (0, $8NFma.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $fe7c8960ea86adfe$export$2e2bcd8739ae039 = $fe7c8960ea86adfe$var$useCommittedRef;

});


parcelRegister("bW5x7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b09673f0b373b53$export$2e2bcd8739ae039);

var $ek4P1 = parcelRequire("ek4P1");

var $2Jub8 = parcelRequire("2Jub8");

var $aXGKb = parcelRequire("aXGKb");
const $8b09673f0b373b53$export$1a88c12b8b979fa0 = (0, $2Jub8.dataAttr)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $8b09673f0b373b53$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $aXGKb.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $ek4P1.default)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($8b09673f0b373b53$export$1a88c12b8b979fa0, '');
        (0, $ek4P1.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($8b09673f0b373b53$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $8b09673f0b373b53$export$2e2bcd8739ae039 = $8b09673f0b373b53$var$ModalManager;

});
parcelRegister("2Jub8", function(module, exports) {

$parcel$export(module.exports, "dataAttr", () => $1fd73194b79e75fc$export$5cc3b7b83e34ade7);
const $1fd73194b79e75fc$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1fd73194b79e75fc$export$635202801f9383a0 = `rrUi`;
function $1fd73194b79e75fc$export$5cc3b7b83e34ade7(property) {
    return `${$1fd73194b79e75fc$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1fd73194b79e75fc$export$7776c0a7cd2eb3e0(property) {
    return `${$1fd73194b79e75fc$export$635202801f9383a0}${property}`;
}

});

parcelRegister("aXGKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb0921d3f154405$export$2e2bcd8739ae039);
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $7fb0921d3f154405$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

});


parcelRegister("27oKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $18af6eda58fdb7d2$export$2e2bcd8739ae039);

var $keK2j = parcelRequire("keK2j");

var $lwoFl = parcelRequire("lwoFl");

var $8NFma = parcelRequire("8NFma");

var $6Wy9W = parcelRequire("6Wy9W");
const $18af6eda58fdb7d2$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $lwoFl.default)) return null;
    if (ref == null) return (document || (0, $keK2j.default)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $18af6eda58fdb7d2$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $6Wy9W.default)();
    const [resolvedRef, setRef] = (0, $8NFma.useState)(()=>$18af6eda58fdb7d2$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $18af6eda58fdb7d2$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $8NFma.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $8NFma.useEffect)(()=>{
        const nextRef = $18af6eda58fdb7d2$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});
parcelRegister("6Wy9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e2a82e5d477195$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lwoFl = parcelRequire("lwoFl");
const $50e2a82e5d477195$var$Context = /*#__PURE__*/ (0, $8NFma.createContext)((0, $lwoFl.default) ? window : undefined);
const $50e2a82e5d477195$export$f7d306aeb1cf5fbc = $50e2a82e5d477195$var$Context.Provider;
function $50e2a82e5d477195$export$2e2bcd8739ae039() {
    return (0, $8NFma.useContext)($50e2a82e5d477195$var$Context);
}

});


parcelRegister("682Kc", function(module, exports) {

$parcel$export(module.exports, "renderTransition", () => $47659e61a2eaf020$export$f41d64aae6d6dba5);

var $4h9WR = parcelRequire("4h9WR");

var $i4XZL = parcelRequire("i4XZL");

var $jJaOJ = parcelRequire("jJaOJ");

var $8NFma = parcelRequire("8NFma");

var $7YHmA = parcelRequire("7YHmA");

var $aOecS = parcelRequire("aOecS");

var $hKTCF = parcelRequire("hKTCF");

var $1IdZj = parcelRequire("1IdZj");
function $47659e61a2eaf020$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $8NFma.useRef)(null);
    const isInitialRef = (0, $8NFma.useRef)(true);
    const handleTransition = (0, $i4XZL.default)(onTransition);
    (0, $jJaOJ.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $jJaOJ.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $47659e61a2eaf020$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $8NFma.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $47659e61a2eaf020$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $4h9WR.default)(ref, (0, $hKTCF.getChildRef)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $8NFma.cloneElement)(children, {
        ref: combinedRef
    });
}
function $47659e61a2eaf020$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $aOecS.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $1IdZj.jsx)($47659e61a2eaf020$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7YHmA.default), Object.assign({}, props));
}

});
parcelRegister("4h9WR", function(module, exports) {

$parcel$export(module.exports, "default", () => $31d0777e275ef650$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
const $31d0777e275ef650$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $31d0777e275ef650$export$c9058316764c140e(refA, refB) {
    const a = $31d0777e275ef650$var$toFnRef(refA);
    const b = $31d0777e275ef650$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $31d0777e275ef650$var$useMergedRefs(refA, refB) {
    return (0, $8NFma.useMemo)(()=>$31d0777e275ef650$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $31d0777e275ef650$export$2e2bcd8739ae039 = $31d0777e275ef650$var$useMergedRefs;

});

parcelRegister("jJaOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5ca9c61b35b629b$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
const $e5ca9c61b35b629b$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $e5ca9c61b35b629b$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $e5ca9c61b35b629b$export$2e2bcd8739ae039 = $e5ca9c61b35b629b$var$isDOM || $e5ca9c61b35b629b$var$isReactNative ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);

});

parcelRegister("7YHmA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cefc60823849c0a$export$2e2bcd8739ae039);

var $i4XZL = parcelRequire("i4XZL");

var $4h9WR = parcelRequire("4h9WR");

var $8NFma = parcelRequire("8NFma");

var $hKTCF = parcelRequire("hKTCF");
function $5cefc60823849c0a$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $8NFma.useRef)(null);
    const hasEnteredRef = (0, $8NFma.useRef)(inProp);
    const handleExited = (0, $i4XZL.default)(onExited);
    (0, $8NFma.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $4h9WR.default)(ref, (0, $hKTCF.getChildRef)(children));
    const child = /*#__PURE__*/ (0, $8NFma.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $5cefc60823849c0a$export$2e2bcd8739ae039 = $5cefc60823849c0a$var$NoopTransition;

});
parcelRegister("hKTCF", function(module, exports) {

$parcel$export(module.exports, "isEscKey", () => $ced1e10cf5f6842a$export$806fcc22e55e107d);
$parcel$export(module.exports, "getChildRef", () => $ced1e10cf5f6842a$export$87943f2672146d57);

var $8NFma = parcelRequire("8NFma");
function $ced1e10cf5f6842a$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $ced1e10cf5f6842a$export$13e065f3a74cfe36() {
    const parts = $8NFma.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $ced1e10cf5f6842a$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $ced1e10cf5f6842a$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}

});


parcelRegister("aOecS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de99811849b8d4d$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $6Syi3 = parcelRequire("6Syi3");

var $1IdZj = parcelRequire("1IdZj");
const $7de99811849b8d4d$var$_excluded = [
    "component"
];
function $7de99811849b8d4d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $7de99811849b8d4d$var$RTGTransition = /*#__PURE__*/ $8NFma.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $7de99811849b8d4d$var$_objectWithoutPropertiesLoose(_ref, $7de99811849b8d4d$var$_excluded);
    const transitionProps = (0, $6Syi3.default)(props);
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $7de99811849b8d4d$export$2e2bcd8739ae039 = $7de99811849b8d4d$var$RTGTransition;

});
parcelRegister("6Syi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $50226286c9709d5a$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $4h9WR = parcelRequire("4h9WR");

var $hKTCF = parcelRequire("hKTCF");
const $50226286c9709d5a$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $50226286c9709d5a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $50226286c9709d5a$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $50226286c9709d5a$var$_objectWithoutPropertiesLoose(_ref, $50226286c9709d5a$var$_excluded);
    const nodeRef = (0, $8NFma.useRef)(null);
    const mergedRef = (0, $4h9WR.default)(nodeRef, (0, $hKTCF.getChildRef)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $8NFma.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $8NFma.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $8NFma.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $8NFma.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $8NFma.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $8NFma.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $8NFma.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $8NFma.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

});




parcelRegister("k2rc8", function(module, exports) {

$parcel$export(module.exports, "getSharedManager", () => $e96916daa7037cc8$export$a03641438014b436);

var $haMLY = parcelRequire("haMLY");

var $ek4P1 = parcelRequire("ek4P1");

var $ace9D = parcelRequire("ace9D");

var $8dZJo = parcelRequire("8dZJo");

var $bW5x7 = parcelRequire("bW5x7");
const $e96916daa7037cc8$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $e96916daa7037cc8$var$BootstrapModalManager extends (0, $bW5x7.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $ek4P1.default)(element, {
            [prop]: `${parseFloat((0, $ek4P1.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $ek4P1.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $haMLY.default)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $ace9D.default)(container, $e96916daa7037cc8$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $ace9D.default)(container, $e96916daa7037cc8$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $ace9D.default)(container, $e96916daa7037cc8$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $8dZJo.default)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $ace9D.default)(container, $e96916daa7037cc8$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $ace9D.default)(container, $e96916daa7037cc8$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $ace9D.default)(container, $e96916daa7037cc8$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $e96916daa7037cc8$var$sharedManager;
function $e96916daa7037cc8$export$a03641438014b436(options) {
    if (!$e96916daa7037cc8$var$sharedManager) $e96916daa7037cc8$var$sharedManager = new $e96916daa7037cc8$var$BootstrapModalManager(options);
    return $e96916daa7037cc8$var$sharedManager;
}
var $e96916daa7037cc8$export$2e2bcd8739ae039 = $e96916daa7037cc8$var$BootstrapModalManager;

});
parcelRegister("haMLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c809341340fce654$export$2e2bcd8739ae039);

var $hdXrI = parcelRequire("hdXrI");
function $c809341340fce654$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $hdXrI.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("hdXrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a1c34a06a8c397$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $c8a1c34a06a8c397$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("ace9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c6011fa48dff10$export$2e2bcd8739ae039);
var $76c6011fa48dff10$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $76c6011fa48dff10$export$2e2bcd8739ae039(element, selector) {
    return $76c6011fa48dff10$var$toArray(element.querySelectorAll(selector));
}

});

parcelRegister("8dZJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fcf6c25c378978d$export$2e2bcd8739ae039);
function $5fcf6c25c378978d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $5fcf6c25c378978d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $5fcf6c25c378978d$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $5fcf6c25c378978d$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});


parcelRegister("bI73o", function(module, exports) {

$parcel$export(module.exports, "default", () => $88694683fc502408$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $4Z1kj = parcelRequire("4Z1kj");

var $hKTCF = parcelRequire("hKTCF");

var $7g1Uq = parcelRequire("7g1Uq");

var $hYbOH = parcelRequire("hYbOH");

var $3nchQ = parcelRequire("3nchQ");

var $1IdZj = parcelRequire("1IdZj");
const $88694683fc502408$var$fadeStyles = {
    [(0, $4Z1kj.ENTERING)]: 'show',
    [(0, $4Z1kj.ENTERED)]: 'show'
};
const $88694683fc502408$var$Fade = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $8NFma.useCallback)((node, isAppearing)=>{
        (0, $hYbOH.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $3nchQ.default), {
        ref: ref,
        addEndListener: (0, $7g1Uq.default),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $hKTCF.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $8NFma.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))('fade', className, children.props.className, $88694683fc502408$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$88694683fc502408$var$Fade.displayName = 'Fade';
var $88694683fc502408$export$2e2bcd8739ae039 = $88694683fc502408$var$Fade;

});
parcelRegister("4Z1kj", function(module, exports) {

$parcel$export(module.exports, "EXITED", () => $3a0de358fcee31a7$export$84cbff306f539230);
$parcel$export(module.exports, "ENTERING", () => $3a0de358fcee31a7$export$df38205c966be359);
$parcel$export(module.exports, "ENTERED", () => $3a0de358fcee31a7$export$78e9e6e3e014d60a);
$parcel$export(module.exports, "EXITING", () => $3a0de358fcee31a7$export$4aacc83d4d59139f);
$parcel$export(module.exports, "default", () => $3a0de358fcee31a7$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");

var $gvoty = parcelRequire("gvoty");


var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $adZnW = parcelRequire("adZnW");


var $6uueD = parcelRequire("6uueD");

var $fM6fj = parcelRequire("fM6fj");
var $3a0de358fcee31a7$export$bb38bb9a1161268 = 'unmounted';
var $3a0de358fcee31a7$export$84cbff306f539230 = 'exited';
var $3a0de358fcee31a7$export$df38205c966be359 = 'entering';
var $3a0de358fcee31a7$export$78e9e6e3e014d60a = 'entered';
var $3a0de358fcee31a7$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3a0de358fcee31a7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $gvoty.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
                _this.appearStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else initialStatus = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3a0de358fcee31a7$export$bb38bb9a1161268;
        else initialStatus = $3a0de358fcee31a7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3a0de358fcee31a7$export$bb38bb9a1161268) return {
            status: $3a0de358fcee31a7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3a0de358fcee31a7$export$df38205c966be359 && status !== $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$df38205c966be359;
            } else if (status === $3a0de358fcee31a7$export$df38205c966be359 || status === $3a0de358fcee31a7$export$78e9e6e3e014d60a) nextStatus = $3a0de358fcee31a7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3a0de358fcee31a7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $fM6fj.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3a0de358fcee31a7$export$84cbff306f539230) this.setState({
            status: $3a0de358fcee31a7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $adZnW.default).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3a0de358fcee31a7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $adZnW.default).disabled) {
            this.safeSetState({
                status: $3a0de358fcee31a7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3a0de358fcee31a7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3a0de358fcee31a7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3a0de358fcee31a7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hQtye.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6uueD.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$3a0de358fcee31a7$var$Transition.contextType = (0, $6uueD.default);
$3a0de358fcee31a7$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3a0de358fcee31a7$var$noop() {}
$3a0de358fcee31a7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3a0de358fcee31a7$var$noop,
    onEntering: $3a0de358fcee31a7$var$noop,
    onEntered: $3a0de358fcee31a7$var$noop,
    onExit: $3a0de358fcee31a7$var$noop,
    onExiting: $3a0de358fcee31a7$var$noop,
    onExited: $3a0de358fcee31a7$var$noop
};
$3a0de358fcee31a7$var$Transition.UNMOUNTED = $3a0de358fcee31a7$export$bb38bb9a1161268;
$3a0de358fcee31a7$var$Transition.EXITED = $3a0de358fcee31a7$export$84cbff306f539230;
$3a0de358fcee31a7$var$Transition.ENTERING = $3a0de358fcee31a7$export$df38205c966be359;
$3a0de358fcee31a7$var$Transition.ENTERED = $3a0de358fcee31a7$export$78e9e6e3e014d60a;
$3a0de358fcee31a7$var$Transition.EXITING = $3a0de358fcee31a7$export$4aacc83d4d59139f;
var $3a0de358fcee31a7$export$2e2bcd8739ae039 = $3a0de358fcee31a7$var$Transition;

});
parcelRegister("hQtye", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfde373be945f92b$export$2e2bcd8739ae039);
function $cfde373be945f92b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("gvoty", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04286edcac4109a$export$2e2bcd8739ae039);

var $5zL6F = parcelRequire("5zL6F");
function $c04286edcac4109a$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $5zL6F.default)(t, o);
}

});
parcelRegister("5zL6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f4c2feb843f2da$export$2e2bcd8739ae039);
function $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e) {
    return $40f4c2feb843f2da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("adZnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $771abc1b9c3ac5e0$export$2e2bcd8739ae039);
var $771abc1b9c3ac5e0$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("6uueD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9cff7e01ef990e$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
var $4b9cff7e01ef990e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(null);

});

parcelRegister("fM6fj", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $b7c02f0ad3191e79$export$7d26bbb1236dafd6);
var $b7c02f0ad3191e79$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("7g1Uq", function(module, exports) {

$parcel$export(module.exports, "default", () => $548b8223cb200315$export$2e2bcd8739ae039);

var $ek4P1 = parcelRequire("ek4P1");

var $6nyQJ = parcelRequire("6nyQJ");
function $548b8223cb200315$var$parseDuration(node, property) {
    const str = (0, $ek4P1.default)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $548b8223cb200315$export$2e2bcd8739ae039(element, handler) {
    const duration = $548b8223cb200315$var$parseDuration(element, 'transitionDuration');
    const delay = $548b8223cb200315$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $6nyQJ.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});

parcelRegister("hYbOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15134d83a76ae17$export$2e2bcd8739ae039);
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $d15134d83a76ae17$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});

parcelRegister("3nchQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $274d0d017c34ecfc$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $4Z1kj = parcelRequire("4Z1kj");

var $4iuFJ = parcelRequire("4iuFJ");

var $8KlYW = parcelRequire("8KlYW");

var $1IdZj = parcelRequire("1IdZj");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $274d0d017c34ecfc$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $8NFma.useRef)(null);
    const mergedRef = (0, $4iuFJ.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $8KlYW.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $8NFma.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $8NFma.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $8NFma.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $8NFma.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $8NFma.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $8NFma.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $8NFma.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4Z1kj.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $274d0d017c34ecfc$export$2e2bcd8739ae039 = $274d0d017c34ecfc$var$TransitionWrapper;

});
parcelRegister("8KlYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e3abc7b6bd279a$export$2e2bcd8739ae039);

var $2pmb0 = parcelRequire("2pmb0");
function $65e3abc7b6bd279a$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});



parcelRegister("e7fV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46e113cb897f30c$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $a46e113cb897f30c$var$ModalBody = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$a46e113cb897f30c$var$ModalBody.displayName = 'ModalBody';
var $a46e113cb897f30c$export$2e2bcd8739ae039 = $a46e113cb897f30c$var$ModalBody;

});
parcelRegister("iQRYA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_BREAKPOINTS", () => $db96f3e43e4bb66f$export$666ad80b5007f835);
$parcel$export(module.exports, "DEFAULT_MIN_BREAKPOINT", () => $db96f3e43e4bb66f$export$ff817e17bad2e091);
$parcel$export(module.exports, "useBootstrapPrefix", () => $db96f3e43e4bb66f$export$7f387860ebffb32c);
$parcel$export(module.exports, "useBootstrapBreakpoints", () => $db96f3e43e4bb66f$export$8970c8db816a5863);
$parcel$export(module.exports, "useBootstrapMinBreakpoint", () => $db96f3e43e4bb66f$export$d926d6ef38f3fd32);
$parcel$export(module.exports, "useIsRTL", () => $db96f3e43e4bb66f$export$35e511eefa30ac5a);

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $db96f3e43e4bb66f$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $db96f3e43e4bb66f$export$ff817e17bad2e091 = 'xs';
const $db96f3e43e4bb66f$var$ThemeContext = /*#__PURE__*/ $8NFma.createContext({
    prefixes: {},
    breakpoints: $db96f3e43e4bb66f$export$666ad80b5007f835,
    minBreakpoint: $db96f3e43e4bb66f$export$ff817e17bad2e091
});
const { Consumer: $db96f3e43e4bb66f$export$b631efc24e9d5e2f, Provider: $db96f3e43e4bb66f$var$Provider } = $db96f3e43e4bb66f$var$ThemeContext;
function $db96f3e43e4bb66f$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $db96f3e43e4bb66f$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $db96f3e43e4bb66f$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $8NFma.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($db96f3e43e4bb66f$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $db96f3e43e4bb66f$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $8NFma.useContext)($db96f3e43e4bb66f$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $db96f3e43e4bb66f$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $8NFma.useContext)($db96f3e43e4bb66f$var$ThemeContext);
    return breakpoints;
}
function $db96f3e43e4bb66f$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $8NFma.useContext)($db96f3e43e4bb66f$var$ThemeContext);
    return minBreakpoint;
}
function $db96f3e43e4bb66f$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $8NFma.useContext)($db96f3e43e4bb66f$var$ThemeContext);
    return dir === 'rtl';
}
function $db96f3e43e4bb66f$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $8NFma.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $db96f3e43e4bb66f$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $db96f3e43e4bb66f$export$2e2bcd8739ae039 = $db96f3e43e4bb66f$var$ThemeProvider;

});


parcelRegister("2RtS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2157b3ebb962d1a1$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
"use client";
const $2157b3ebb962d1a1$var$ModalContext = /*#__PURE__*/ $8NFma.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $2157b3ebb962d1a1$export$2e2bcd8739ae039 = $2157b3ebb962d1a1$var$ModalContext;

});

parcelRegister("9Kxbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7192265adbd70014$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $7192265adbd70014$var$ModalDialog = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$7192265adbd70014$var$ModalDialog.displayName = 'ModalDialog';
var $7192265adbd70014$export$2e2bcd8739ae039 = $7192265adbd70014$var$ModalDialog;

});

parcelRegister("d8f9m", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f7c62a48489bf4$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $98f7c62a48489bf4$var$ModalFooter = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$98f7c62a48489bf4$var$ModalFooter.displayName = 'ModalFooter';
var $98f7c62a48489bf4$export$2e2bcd8739ae039 = $98f7c62a48489bf4$var$ModalFooter;

});

parcelRegister("kieyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec60c7bceda4a22a$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $9Viur = parcelRequire("9Viur");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $ec60c7bceda4a22a$var$ModalHeader = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9Viur.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$ec60c7bceda4a22a$var$ModalHeader.displayName = 'ModalHeader';
var $ec60c7bceda4a22a$export$2e2bcd8739ae039 = $ec60c7bceda4a22a$var$ModalHeader;

});
parcelRegister("9Viur", function(module, exports) {

$parcel$export(module.exports, "default", () => $7397c7aa6e317c27$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $gIBjk = parcelRequire("gIBjk");

var $e7lBt = parcelRequire("e7lBt");

var $2RtS7 = parcelRequire("2RtS7");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $7397c7aa6e317c27$var$AbstractModalHeader = /*#__PURE__*/ $8NFma.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $8NFma.useContext)((0, $2RtS7.default));
    const handleClick = (0, $gIBjk.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e7lBt.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $7397c7aa6e317c27$export$2e2bcd8739ae039 = $7397c7aa6e317c27$var$AbstractModalHeader;

});
parcelRegister("e7lBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4727a198958cd45$export$2e2bcd8739ae039);

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $1IdZj = parcelRequire("1IdZj");
const $a4727a198958cd45$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).oneOf([
        'white'
    ])
};
const $a4727a198958cd45$var$CloseButton = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $1IdZj.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$a4727a198958cd45$var$CloseButton.displayName = 'CloseButton';
$a4727a198958cd45$var$CloseButton.propTypes = $a4727a198958cd45$var$propTypes;
var $a4727a198958cd45$export$2e2bcd8739ae039 = $a4727a198958cd45$var$CloseButton;

});
parcelRegister("fb0st", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6DzO8"))();

});
parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d840288929500773$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});






parcelRegister("eTp4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad79a6f4f809e6cb$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $g9yRG = parcelRequire("g9yRG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $ad79a6f4f809e6cb$var$DivStyledAsH4 = (0, $g9yRG.default)('h4');
const $ad79a6f4f809e6cb$var$ModalTitle = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $ad79a6f4f809e6cb$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$ad79a6f4f809e6cb$var$ModalTitle.displayName = 'ModalTitle';
var $ad79a6f4f809e6cb$export$2e2bcd8739ae039 = $ad79a6f4f809e6cb$var$ModalTitle;

});
parcelRegister("g9yRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc28880e5c4a6b82$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $1IdZj = parcelRequire("1IdZj");
var $bc28880e5c4a6b82$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $8NFma.forwardRef((p, ref)=>/*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(p.className, className)
        }));

});



parcelRegister("kKP1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bfafbe41989f3c$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $eAbEc = parcelRequire("eAbEc");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $f1bfafbe41989f3c$var$Button = /*#__PURE__*/ $8NFma.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $eAbEc.useButtonProps)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$f1bfafbe41989f3c$var$Button.displayName = 'Button';
var $f1bfafbe41989f3c$export$2e2bcd8739ae039 = $f1bfafbe41989f3c$var$Button;

});
parcelRegister("eAbEc", function(module, exports) {

$parcel$export(module.exports, "useButtonProps", () => $a9dd766ad22028a1$export$a0ee72f2c720a5c3);

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");
const $a9dd766ad22028a1$var$_excluded = [
    "as",
    "disabled"
];
function $a9dd766ad22028a1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a9dd766ad22028a1$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $a9dd766ad22028a1$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $a9dd766ad22028a1$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $a9dd766ad22028a1$var$Button = /*#__PURE__*/ $8NFma.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $a9dd766ad22028a1$var$_objectWithoutPropertiesLoose(_ref, $a9dd766ad22028a1$var$_excluded);
    const [buttonProps, { tagName: Component }] = $a9dd766ad22028a1$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$a9dd766ad22028a1$var$Button.displayName = 'Button';
var $a9dd766ad22028a1$export$2e2bcd8739ae039 = $a9dd766ad22028a1$var$Button;

});


parcelRegister("eWs7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae0c4c99706dcd14$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $ae0c4c99706dcd14$var$Badge = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$ae0c4c99706dcd14$var$Badge.displayName = 'Badge';
var $ae0c4c99706dcd14$export$2e2bcd8739ae039 = $ae0c4c99706dcd14$var$Badge;

});

parcelRegister("h9Lvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d820664f61b288$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $3ijm6 = parcelRequire("3ijm6");

var $k7xpN = parcelRequire("k7xpN");

var $eirdy = parcelRequire("eirdy");

var $byHhW = parcelRequire("byHhW");

var $aINdo = parcelRequire("aINdo");

var $hXn1t = parcelRequire("hXn1t");

var $bdazC = parcelRequire("bdazC");

var $eP5r0 = parcelRequire("eP5r0");

var $6Xx57 = parcelRequire("6Xx57");

var $gSACg = parcelRequire("gSACg");

var $1IdZj = parcelRequire("1IdZj");
const $c7d820664f61b288$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).elementType
};
const $c7d820664f61b288$var$Form = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, validated && 'was-validated')
    }));
$c7d820664f61b288$var$Form.displayName = 'Form';
$c7d820664f61b288$var$Form.propTypes = $c7d820664f61b288$var$propTypes;
var $c7d820664f61b288$export$2e2bcd8739ae039 = Object.assign($c7d820664f61b288$var$Form, {
    Group: (0, $byHhW.default),
    Control: (0, $k7xpN.default),
    Floating: (0, $eirdy.default),
    Check: (0, $3ijm6.default),
    Switch: $6Xx57.default,
    Label: (0, $aINdo.default),
    Text: (0, $eP5r0.default),
    Range: (0, $hXn1t.default),
    Select: (0, $bdazC.default),
    FloatingLabel: $gSACg.default
});

});
parcelRegister("3ijm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $26621123daf553ae$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $gU2J1 = parcelRequire("gU2J1");

var $5MSQH = parcelRequire("5MSQH");

var $8J3ne = parcelRequire("8J3ne");

var $7Lpg5 = parcelRequire("7Lpg5");

var $iQRYA = parcelRequire("iQRYA");

var $lgWW9 = parcelRequire("lgWW9");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $26621123daf553ae$var$FormCheck = /*#__PURE__*/ $8NFma.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $iQRYA.useBootstrapPrefix)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $8NFma.useContext)((0, $7Lpg5.default));
    const innerFormContext = (0, $8NFma.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $lgWW9.hasChildOfType)(children, (0, $8J3ne.default));
    const input = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5MSQH.default), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7Lpg5.default).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8J3ne.default), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $gU2J1.default), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$26621123daf553ae$var$FormCheck.displayName = 'FormCheck';
var $26621123daf553ae$export$2e2bcd8739ae039 = Object.assign($26621123daf553ae$var$FormCheck, {
    Input: (0, $5MSQH.default),
    Label: (0, $8J3ne.default)
});

});
parcelRegister("gU2J1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e3fd7b0e24c525$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $fb0st = parcelRequire("fb0st");

var $1IdZj = parcelRequire("1IdZj");
const $c4e3fd7b0e24c525$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).elementType
};
const $c4e3fd7b0e24c525$var$Feedback = /*#__PURE__*/ $8NFma.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$c4e3fd7b0e24c525$var$Feedback.displayName = 'Feedback';
$c4e3fd7b0e24c525$var$Feedback.propTypes = $c4e3fd7b0e24c525$var$propTypes;
var $c4e3fd7b0e24c525$export$2e2bcd8739ae039 = $c4e3fd7b0e24c525$var$Feedback;

});

parcelRegister("5MSQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $436bfb4caa8c6b94$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $7Lpg5 = parcelRequire("7Lpg5");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $436bfb4caa8c6b94$var$FormCheckInput = /*#__PURE__*/ $8NFma.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $8NFma.useContext)((0, $7Lpg5.default));
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$436bfb4caa8c6b94$var$FormCheckInput.displayName = 'FormCheckInput';
var $436bfb4caa8c6b94$export$2e2bcd8739ae039 = $436bfb4caa8c6b94$var$FormCheckInput;

});
parcelRegister("7Lpg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a7083fa90ef268d$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
"use client";
// TODO
const $5a7083fa90ef268d$var$FormContext = /*#__PURE__*/ $8NFma.createContext({});
var $5a7083fa90ef268d$export$2e2bcd8739ae039 = $5a7083fa90ef268d$var$FormContext;

});


parcelRegister("8J3ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $65a524a904ca9a54$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $7Lpg5 = parcelRequire("7Lpg5");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $65a524a904ca9a54$var$FormCheckLabel = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8NFma.useContext)((0, $7Lpg5.default));
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix)
    });
});
$65a524a904ca9a54$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $65a524a904ca9a54$export$2e2bcd8739ae039 = $65a524a904ca9a54$var$FormCheckLabel;

});

parcelRegister("lgWW9", function(module, exports) {

$parcel$export(module.exports, "hasChildOfType", () => $f7c8cf42304b1ee7$export$500fd6099226ffae);

var $8NFma = parcelRequire("8NFma");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $f7c8cf42304b1ee7$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $8NFma.Children.map(children, (child)=>/*#__PURE__*/ $8NFma.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $f7c8cf42304b1ee7$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $8NFma.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $8NFma.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $f7c8cf42304b1ee7$export$500fd6099226ffae(children, type) {
    return $8NFma.Children.toArray(children).some((child)=>/*#__PURE__*/ $8NFma.isValidElement(child) && child.type === type);
}

});


parcelRegister("k7xpN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea5e61a3c02e5ffa$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");
parcelRequire("7jOyK");

var $gU2J1 = parcelRequire("gU2J1");

var $7Lpg5 = parcelRequire("7Lpg5");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $ea5e61a3c02e5ffa$var$FormControl = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $8NFma.useContext)((0, $7Lpg5.default));
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$ea5e61a3c02e5ffa$var$FormControl.displayName = 'FormControl';
var $ea5e61a3c02e5ffa$export$2e2bcd8739ae039 = Object.assign($ea5e61a3c02e5ffa$var$FormControl, {
    Feedback: $gU2J1.default
});

});
parcelRegister("7jOyK", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $554186d44b3abd65$var$__DEV__ = false;
var $554186d44b3abd65$var$warning = function() {};
if ($554186d44b3abd65$var$__DEV__) {
    var $554186d44b3abd65$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $554186d44b3abd65$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $554186d44b3abd65$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $554186d44b3abd65$var$warning;

});


parcelRegister("eirdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a687dbf4a3c6e4ec$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $a687dbf4a3c6e4ec$var$FormFloating = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$a687dbf4a3c6e4ec$var$FormFloating.displayName = 'FormFloating';
var $a687dbf4a3c6e4ec$export$2e2bcd8739ae039 = $a687dbf4a3c6e4ec$var$FormFloating;

});

parcelRegister("byHhW", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a472d92094f123$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $7Lpg5 = parcelRequire("7Lpg5");

var $1IdZj = parcelRequire("1IdZj");
const $86a472d92094f123$var$FormGroup = /*#__PURE__*/ $8NFma.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $8NFma.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7Lpg5.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$86a472d92094f123$var$FormGroup.displayName = 'FormGroup';
var $86a472d92094f123$export$2e2bcd8739ae039 = $86a472d92094f123$var$FormGroup;

});

parcelRegister("aINdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0203ae33c7b714c0$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");
parcelRequire("7jOyK");

var $dtMZX = parcelRequire("dtMZX");

var $7Lpg5 = parcelRequire("7Lpg5");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $0203ae33c7b714c0$var$FormLabel = /*#__PURE__*/ $8NFma.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8NFma.useContext)((0, $7Lpg5.default));
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $dtMZX.default), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$0203ae33c7b714c0$var$FormLabel.displayName = 'FormLabel';
var $0203ae33c7b714c0$export$2e2bcd8739ae039 = $0203ae33c7b714c0$var$FormLabel;

});
parcelRegister("dtMZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d03fdd58993fb76$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
function $9d03fdd58993fb76$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'col');
    const breakpoints = (0, $iQRYA.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $iQRYA.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $9d03fdd58993fb76$var$Col = /*#__PURE__*/ $8NFma.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $9d03fdd58993fb76$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, !spans.length && bsPrefix)
    });
});
$9d03fdd58993fb76$var$Col.displayName = 'Col';
var $9d03fdd58993fb76$export$2e2bcd8739ae039 = $9d03fdd58993fb76$var$Col;

});


parcelRegister("hXn1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d129ce312625c6da$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $7Lpg5 = parcelRequire("7Lpg5");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $d129ce312625c6da$var$FormRange = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8NFma.useContext)((0, $7Lpg5.default));
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        id: id || controlId
    });
});
$d129ce312625c6da$var$FormRange.displayName = 'FormRange';
var $d129ce312625c6da$export$2e2bcd8739ae039 = $d129ce312625c6da$var$FormRange;

});

parcelRegister("bdazC", function(module, exports) {

$parcel$export(module.exports, "default", () => $82991c47ad8d0187$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $7Lpg5 = parcelRequire("7Lpg5");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $82991c47ad8d0187$var$FormSelect = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8NFma.useContext)((0, $7Lpg5.default));
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $1IdZj.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$82991c47ad8d0187$var$FormSelect.displayName = 'FormSelect';
var $82991c47ad8d0187$export$2e2bcd8739ae039 = $82991c47ad8d0187$var$FormSelect;

});

parcelRegister("eP5r0", function(module, exports) {

$parcel$export(module.exports, "default", () => $acaa0b49e4d3d3fb$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $acaa0b49e4d3d3fb$var$FormText = /*#__PURE__*/ $8NFma.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix, muted && 'text-muted')
    });
});
$acaa0b49e4d3d3fb$var$FormText.displayName = 'FormText';
var $acaa0b49e4d3d3fb$export$2e2bcd8739ae039 = $acaa0b49e4d3d3fb$var$FormText;

});

parcelRegister("6Xx57", function(module, exports) {

$parcel$export(module.exports, "default", () => $5111ea120521648f$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $3ijm6 = parcelRequire("3ijm6");

var $1IdZj = parcelRequire("1IdZj");
const $5111ea120521648f$var$Switch = /*#__PURE__*/ $8NFma.forwardRef((props, ref)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $3ijm6.default), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$5111ea120521648f$var$Switch.displayName = 'Switch';
var $5111ea120521648f$export$2e2bcd8739ae039 = Object.assign($5111ea120521648f$var$Switch, {
    Input: (0, $3ijm6.default).Input,
    Label: (0, $3ijm6.default).Label
});

});

parcelRegister("gSACg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49e17abab750074$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $byHhW = parcelRequire("byHhW");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $c49e17abab750074$var$FloatingLabel = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $byHhW.default), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$c49e17abab750074$var$FloatingLabel.displayName = 'FloatingLabel';
var $c49e17abab750074$export$2e2bcd8739ae039 = $c49e17abab750074$var$FloatingLabel;

});


parcelRegister("8B2uX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6423b78c3ad4dfab$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $8ilwy = parcelRequire("8ilwy");

var $kbSXv = parcelRequire("kbSXv");

var $5pGrC = parcelRequire("5pGrC");

var $2jMh4 = parcelRequire("2jMh4");

var $jJxGL = parcelRequire("jJxGL");

var $eGiql = parcelRequire("eGiql");

var $JjUV2 = parcelRequire("JjUV2");

var $24ZhZ = parcelRequire("24ZhZ");

var $8WhMN = parcelRequire("8WhMN");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $6423b78c3ad4dfab$var$Card = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8ilwy.default), {
            children: children
        }) : children
    });
});
$6423b78c3ad4dfab$var$Card.displayName = 'Card';
var $6423b78c3ad4dfab$export$2e2bcd8739ae039 = Object.assign($6423b78c3ad4dfab$var$Card, {
    Img: (0, $2jMh4.default),
    Title: (0, $8WhMN.default),
    Subtitle: (0, $JjUV2.default),
    Body: (0, $8ilwy.default),
    Link: (0, $eGiql.default),
    Text: (0, $24ZhZ.default),
    Header: (0, $5pGrC.default),
    Footer: (0, $kbSXv.default),
    ImgOverlay: (0, $jJxGL.default)
});

});
parcelRegister("8ilwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $60a0b364aa6d231d$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $60a0b364aa6d231d$var$CardBody = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$60a0b364aa6d231d$var$CardBody.displayName = 'CardBody';
var $60a0b364aa6d231d$export$2e2bcd8739ae039 = $60a0b364aa6d231d$var$CardBody;

});

parcelRegister("kbSXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2f776b11c22f43$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $eb2f776b11c22f43$var$CardFooter = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$eb2f776b11c22f43$var$CardFooter.displayName = 'CardFooter';
var $eb2f776b11c22f43$export$2e2bcd8739ae039 = $eb2f776b11c22f43$var$CardFooter;

});

parcelRegister("5pGrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f10361edc9d3059$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $6Poc7 = parcelRequire("6Poc7");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $3f10361edc9d3059$var$CardHeader = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-header');
    const contextValue = (0, $8NFma.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6Poc7.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, prefix)
        })
    });
});
$3f10361edc9d3059$var$CardHeader.displayName = 'CardHeader';
var $3f10361edc9d3059$export$2e2bcd8739ae039 = $3f10361edc9d3059$var$CardHeader;

});
parcelRegister("6Poc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8a4601e66ef192$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
"use client";
const $4f8a4601e66ef192$var$context = /*#__PURE__*/ $8NFma.createContext(null);
$4f8a4601e66ef192$var$context.displayName = 'CardHeaderContext';
var $4f8a4601e66ef192$export$2e2bcd8739ae039 = $4f8a4601e66ef192$var$context;

});


parcelRegister("2jMh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b02cd68bf521c00$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $1b02cd68bf521c00$var$CardImg = /*#__PURE__*/ $8NFma.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$1b02cd68bf521c00$var$CardImg.displayName = 'CardImg';
var $1b02cd68bf521c00$export$2e2bcd8739ae039 = $1b02cd68bf521c00$var$CardImg;

});

parcelRegister("jJxGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5dc5a2c6948b509$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $e5dc5a2c6948b509$var$CardImgOverlay = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$e5dc5a2c6948b509$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $e5dc5a2c6948b509$export$2e2bcd8739ae039 = $e5dc5a2c6948b509$var$CardImgOverlay;

});

parcelRegister("eGiql", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab03478bddb5639f$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $ab03478bddb5639f$var$CardLink = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$ab03478bddb5639f$var$CardLink.displayName = 'CardLink';
var $ab03478bddb5639f$export$2e2bcd8739ae039 = $ab03478bddb5639f$var$CardLink;

});

parcelRegister("JjUV2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0883a731c91f41dd$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $g9yRG = parcelRequire("g9yRG");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $0883a731c91f41dd$var$DivStyledAsH6 = (0, $g9yRG.default)('h6');
const $0883a731c91f41dd$var$CardSubtitle = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $0883a731c91f41dd$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$0883a731c91f41dd$var$CardSubtitle.displayName = 'CardSubtitle';
var $0883a731c91f41dd$export$2e2bcd8739ae039 = $0883a731c91f41dd$var$CardSubtitle;

});

parcelRegister("24ZhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $183b7f39806714fe$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $183b7f39806714fe$var$CardText = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$183b7f39806714fe$var$CardText.displayName = 'CardText';
var $183b7f39806714fe$export$2e2bcd8739ae039 = $183b7f39806714fe$var$CardText;

});

parcelRegister("8WhMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6821896e3c9695fc$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $lmhZG = parcelRequire("lmhZG");

var $iQRYA = parcelRequire("iQRYA");

var $g9yRG = parcelRequire("g9yRG");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $6821896e3c9695fc$var$DivStyledAsH5 = (0, $g9yRG.default)('h5');
const $6821896e3c9695fc$var$CardTitle = /*#__PURE__*/ $8NFma.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $6821896e3c9695fc$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, bsPrefix),
        ...props
    });
});
$6821896e3c9695fc$var$CardTitle.displayName = 'CardTitle';
var $6821896e3c9695fc$export$2e2bcd8739ae039 = $6821896e3c9695fc$var$CardTitle;

});


parcelRegister("1zKtH", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("81tj9")).default);

var $81tj9 = parcelRequire("81tj9");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $81tj9.default);

});
parcelRegister("81tj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $juuss = parcelRequire("juuss");

var $htyv1 = parcelRequire("htyv1");

var $8yOyy = parcelRequire("8yOyy");

var $4iFhx = parcelRequire("4iFhx");

var $lCgfr = parcelRequire("lCgfr");

var $6yYtd = parcelRequire("6yYtd");

var $lISaw = parcelRequire("lISaw");

var $6wIUo = parcelRequire("6wIUo");

var $albzn = parcelRequire("albzn");

var $1YbHN = parcelRequire("1YbHN");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");

var $kq2bQ = parcelRequire("kq2bQ");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $hBrVA.default)(defaultConfig);
    const instance = (0, $cG9HX.default)((0, $hBrVA.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $eFc3n.default).extend(instance, (0, $hBrVA.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $eFc3n.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $2PhsF.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $juuss.default));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $hBrVA.default);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $8yOyy.default);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $4iFhx.default);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $lCgfr.default);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $6yYtd.VERSION);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $lISaw.default);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $6wIUo.default);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $albzn.default);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $1YbHN.default);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $2PhsF.default);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $7hTsj.default);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $htyv1.default)((0, $eFc3n.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $ik8Aj.default).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $kq2bQ.default);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $aace3e920a0f1e4d$export$2e2bcd8739ae039);

var $cG9HX = parcelRequire("cG9HX");

var $ibaza = parcelRequire("ibaza");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== 'object') return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest('URLSearchParams');
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $cG9HX.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest('HTMLFormElement');
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest('RegExp');
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest('AsyncFunction');
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $aace3e920a0f1e4d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $aace3e920a0f1e4d$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $aace3e920a0f1e4d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $aace3e920a0f1e4d$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $aace3e920a0f1e4d$var$isFunction($aace3e920a0f1e4d$var$_global.postMessage));
const $aace3e920a0f1e4d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($aace3e920a0f1e4d$var$_global) : typeof $ibaza !== 'undefined' && $ibaza.nextTick || $aace3e920a0f1e4d$var$_setImmediate;
var // *********************
$aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable,
    setImmediate: $aace3e920a0f1e4d$var$_setImmediate,
    asap: $aace3e920a0f1e4d$var$asap
};

});
parcelRegister("cG9HX", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b0f01b05e2607a$export$2e2bcd8739ae039);
'use strict';
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});


parcelRegister("hBrVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd0b8e3cbef64068$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $cgfHI = parcelRequire("cgfHI");

var $8zXsW = parcelRequire("8zXsW");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
const $cd0b8e3cbef64068$var$validators = (0, $8zXsW.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $9ltoJ.default)(),
            response: new (0, $9ltoJ.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $2PhsF.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $8zXsW.default).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $eFc3n.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $8zXsW.default).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $8zXsW.default).assertOptions(config, {
            baseUrl: $cd0b8e3cbef64068$var$validators.spelling('baseURL'),
            withXsrfToken: $cd0b8e3cbef64068$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $eFc3n.default).merge(headers.common, headers[config.method]);
        headers && (0, $eFc3n.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $7hTsj.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $cUzFg.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $cUzFg.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $2PhsF.default)(this.defaults, config);
        const fullPath = (0, $cgfHI.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $iOHZJ.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $eFc3n.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $2PhsF.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $eFc3n.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $2PhsF.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2f05ec923f2ee7$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4uovm = parcelRequire("4uovm");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    if ((0, $eFc3n.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $eFc3n.default).isURLSearchParams(params) ? params.toString() : new (0, $4uovm.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("4uovm", function(module, exports) {

$parcel$export(module.exports, "default", () => $344cf8e4292137b6$export$2e2bcd8739ae039);

var $lISaw = parcelRequire("lISaw");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $lISaw.default)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;

});
parcelRegister("lISaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd07b9cb0132c1f6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $bAbs8 = parcelRequire("bAbs8");

var $N0o3H = parcelRequire("N0o3H");
var $fd07b9cb0132c1f6$require$Buffer = $N0o3H.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $eFc3n.default).isPlainObject(thing) || (0, $eFc3n.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $eFc3n.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $eFc3n.default).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $eFc3n.default).toFlatObject((0, $eFc3n.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $bAbs8.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $eFc3n.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $eFc3n.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $eFc3n.default).isSpecCompliantForm(formData);
    if (!(0, $eFc3n.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $eFc3n.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $eFc3n.default).isBlob(value)) throw new (0, $6wIUo.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $eFc3n.default).isArrayBuffer(value) || (0, $eFc3n.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $eFc3n.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $eFc3n.default).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $eFc3n.default).isFileList(value) || (0, $eFc3n.default).endsWith(key, '[]')) && (arr = (0, $eFc3n.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $eFc3n.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $eFc3n.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $eFc3n.default).forEach(value, function each(el, key) {
            const result = !((0, $eFc3n.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $eFc3n.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;

});
parcelRegister("6wIUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0139f1d30f4d6bd5$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $eFc3n.default).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $eFc3n.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $eFc3n.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;

});

parcelRegister("bAbs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ebf0c810395e29$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;

});

parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
var $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
var $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    var buf = $0934e0939605d48c$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    var buf = $0934e0939605d48c$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        var len = $0934e0939605d48c$var$checked(obj.length) | 0;
        var buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $0934e0939605d48c$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $0934e0939605d48c$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("9ltoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c17f80085c95b1$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $eFc3n.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $96666136aaccd2e5$export$2e2bcd8739ae039);

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $juuss = parcelRequire("juuss");

var $8yOyy = parcelRequire("8yOyy");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $8yOyy.default)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $7hTsj.default).from(config.headers);
    // Transform request data
    config.data = (0, $kgh03.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $ik8Aj.default).getAdapter(config.adapter || (0, $juuss.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $kgh03.default).call(config, config.transformResponse, response);
        response.headers = (0, $7hTsj.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $lCgfr.default)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $kgh03.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $7hTsj.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("kgh03", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec027d10dfede142$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $juuss = parcelRequire("juuss");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $juuss.default);
    const context = response || config;
    const headers = (0, $7hTsj.default).from(context.headers);
    let data = context.data;
    (0, $eFc3n.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("juuss", function(module, exports) {

$parcel$export(module.exports, "default", () => $e30871f78dcd7f19$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $49WWV = parcelRequire("49WWV");

var $lISaw = parcelRequire("lISaw");

var $eAUco = parcelRequire("eAUco");

var $bqN51 = parcelRequire("bqN51");

var $htyv1 = parcelRequire("htyv1");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $eFc3n.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $eFc3n.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $49WWV.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $eFc3n.default).isObject(data);
            if (isObjectPayload && (0, $eFc3n.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $eFc3n.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $htyv1.default)(data)) : data;
            if ((0, $eFc3n.default).isArrayBuffer(data) || (0, $eFc3n.default).isBuffer(data) || (0, $eFc3n.default).isStream(data) || (0, $eFc3n.default).isFile(data) || (0, $eFc3n.default).isBlob(data) || (0, $eFc3n.default).isReadableStream(data)) return data;
            if ((0, $eFc3n.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $eFc3n.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $eAUco.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $eFc3n.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $lISaw.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $eFc3n.default).isResponse(data) || (0, $eFc3n.default).isReadableStream(data)) return data;
            if (data && (0, $eFc3n.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6wIUo.default).from(e, (0, $6wIUo.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bqN51.default).classes.FormData,
        Blob: (0, $bqN51.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $eFc3n.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;

});
parcelRegister("49WWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3075bac9f30e7782$export$2e2bcd8739ae039);
'use strict';
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("eAUco", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa000567d8bb5ae2$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $lISaw = parcelRequire("lISaw");

var $bqN51 = parcelRequire("bqN51");
'use strict';
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $lISaw.default)(data, new (0, $bqN51.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bqN51.default).isNode && (0, $eFc3n.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("bqN51", function(module, exports) {

$parcel$export(module.exports, "default", () => $852831b4a152a7ad$export$2e2bcd8739ae039);

var $lyPzr = parcelRequire("lyPzr");

var $31g1y = parcelRequire("31g1y");
var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$31g1y,
    ...(0, $lyPzr.default)
};

});
parcelRegister("lyPzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb24c6d0b2a74508$export$2e2bcd8739ae039);

var $esdLz = parcelRequire("esdLz");

var $64i7Q = parcelRequire("64i7Q");

var $3YeiC = parcelRequire("3YeiC");
var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $esdLz.default,
        FormData: $64i7Q.default,
        Blob: $3YeiC.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("esdLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85e5bed82430d61$export$2e2bcd8739ae039);

var $4uovm = parcelRequire("4uovm");
'use strict';
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $4uovm.default);

});

parcelRegister("64i7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b12d255f217052$export$2e2bcd8739ae039);
'use strict';
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("3YeiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4211376cea43e6$export$2e2bcd8739ae039);
'use strict';
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("31g1y", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $232de52881daaba8$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $232de52881daaba8$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = $232de52881daaba8$export$c4996c4b7b93b0bf && (!$232de52881daaba8$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($232de52881daaba8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("htyv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8fe7f388dc4432$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $eFc3n.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $eFc3n.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $eFc3n.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $eFc3n.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $eFc3n.default).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $eFc3n.default).isFormData(formData) && (0, $eFc3n.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $eFc3n.default).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;

});


parcelRegister("7hTsj", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e5234108b8e954$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4Ik1V = parcelRequire("4Ik1V");
'use strict';
const $54e5234108b8e954$var$$internals = Symbol('internals');
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $eFc3n.default).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $eFc3n.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $eFc3n.default).isString(value)) return;
    if ((0, $eFc3n.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $eFc3n.default).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $eFc3n.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $eFc3n.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $eFc3n.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $eFc3n.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $eFc3n.default).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $4Ik1V.default)(header), valueOrRewrite);
        else if ((0, $eFc3n.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $eFc3n.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $eFc3n.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $eFc3n.default).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $eFc3n.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            const key = (0, $eFc3n.default).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $eFc3n.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $eFc3n.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $eFc3n.default).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $eFc3n.default).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;

});
parcelRegister("4Ik1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $36eacf0f5ae88424$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $eFc3n.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("lCgfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
'use strict';
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("8yOyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b8b72909769bf2$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6wIUo.default).call(this, message == null ? 'canceled' : message, (0, $6wIUo.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $eFc3n.default).inherits($63b8b72909769bf2$var$CanceledError, (0, $6wIUo.default), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;

});

parcelRegister("ik8Aj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d570c100e0cb7a05$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bAbs8 = parcelRequire("bAbs8");

var $8nTSD = parcelRequire("8nTSD");

var $6uoyO = parcelRequire("6uoyO");

var $6wIUo = parcelRequire("6wIUo");
const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $bAbs8.default),
    xhr: (0, $8nTSD.default),
    fetch: (0, $6uoyO.default)
};
(0, $eFc3n.default).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $eFc3n.default).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $eFc3n.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $6wIUo.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d570c100e0cb7a05$var$renderReason).join('\n') : ' ' + $d570c100e0cb7a05$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $6wIUo.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};

});
parcelRegister("8nTSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $61abd1574bd1dd32$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $49WWV = parcelRequire("49WWV");

var $6wIUo = parcelRequire("6wIUo");

var $8yOyy = parcelRequire("8yOyy");

var $drWk7 = parcelRequire("drWk7");

var $bqN51 = parcelRequire("bqN51");

var $7hTsj = parcelRequire("7hTsj");

var $dKk3V = parcelRequire("dKk3V");

var $l7Q05 = parcelRequire("l7Q05");
const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $l7Q05.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $7hTsj.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $7hTsj.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $gyIfz.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6wIUo.default)('Request aborted', (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6wIUo.default)('Network Error', (0, $6wIUo.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $49WWV.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6wIUo.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6wIUo.default).ETIMEDOUT : (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $eFc3n.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $eFc3n.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $dKk3V.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $dKk3V.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $8yOyy.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $drWk7.default)(_config.url);
        if (protocol && (0, $bqN51.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6wIUo.default)('Unsupported protocol ' + protocol + ':', (0, $6wIUo.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e22576f74b8071$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");
'use strict';
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6wIUo.default)('Request failed with status code ' + response.status, [
        (0, $6wIUo.default).ERR_BAD_REQUEST,
        (0, $6wIUo.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("drWk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cab09d0d089fc0e$export$2e2bcd8739ae039);
'use strict';
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("dKk3V", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $a01f222f203440ec$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $a01f222f203440ec$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $a01f222f203440ec$export$5d35863c355a22a9);

var $6eLe3 = parcelRequire("6eLe3");

var $g1MZz = parcelRequire("g1MZz");

var $eFc3n = parcelRequire("eFc3n");
const $a01f222f203440ec$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6eLe3.default)(50, 250);
    return (0, $g1MZz.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a01f222f203440ec$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a01f222f203440ec$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $eFc3n.default).asap(()=>fn(...args));

});
parcelRegister("6eLe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a8aeed25ee768a$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;

});

parcelRegister("g1MZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab2be24834f7155$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;

});


parcelRegister("l7Q05", function(module, exports) {

$parcel$export(module.exports, "default", () => $f612969e780f42a0$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");

var $eFc3n = parcelRequire("eFc3n");

var $4YUSN = parcelRequire("4YUSN");

var $6D8uh = parcelRequire("6D8uh");

var $cgfHI = parcelRequire("cgfHI");

var $2PhsF = parcelRequire("2PhsF");

var $7hTsj = parcelRequire("7hTsj");

var $iOHZJ = parcelRequire("iOHZJ");
var $f612969e780f42a0$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $2PhsF.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $7hTsj.default).from(headers);
    newConfig.url = (0, $iOHZJ.default)((0, $cgfHI.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $eFc3n.default).isFormData(data)) {
        if ((0, $bqN51.default).hasStandardBrowserEnv || (0, $bqN51.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bqN51.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $eFc3n.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $4YUSN.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $6D8uh.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("4YUSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a08e3bf7b3045fa$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bqN51.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bqN51.default).origin), (0, $bqN51.default).navigator && /(msie|trident)/i.test((0, $bqN51.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("6D8uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3cf801f7fd4dc6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bqN51 = parcelRequire("bqN51");
var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $eFc3n.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $eFc3n.default).isString(path) && cookie.push('path=' + path);
        (0, $eFc3n.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("cgfHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed3292b1f9dccb5$export$2e2bcd8739ae039);

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
'use strict';
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $uAxSn.default)(requestedURL);
    if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) return (0, $aFAjA.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("uAxSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $05bf269bfca011f3$export$2e2bcd8739ae039);
'use strict';
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("aFAjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c49e720f6231ba2$export$2e2bcd8739ae039);
'use strict';
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("2PhsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ede3a7e8b675d4$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $7hTsj.default) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $eFc3n.default).isPlainObject(target) && (0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge({}, source);
        else if ((0, $eFc3n.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), prop, true)
    };
    (0, $eFc3n.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $eFc3n.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("6uoyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9898a31eea6843$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $c046u = parcelRequire("c046u");

var $eMAze = parcelRequire("eMAze");

var $7hTsj = parcelRequire("7hTsj");

var $dKk3V = parcelRequire("dKk3V");

var $l7Q05 = parcelRequire("l7Q05");

var $gyIfz = parcelRequire("gyIfz");
const $4b9898a31eea6843$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $4b9898a31eea6843$var$isReadableStreamSupported = $4b9898a31eea6843$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $4b9898a31eea6843$var$encodeText = $4b9898a31eea6843$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $4b9898a31eea6843$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4b9898a31eea6843$var$supportsRequestStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bqN51.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const $4b9898a31eea6843$var$supportsResponseStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>(0, $eFc3n.default).isReadableStream(new Response('').body));
const $4b9898a31eea6843$var$resolvers = {
    stream: $4b9898a31eea6843$var$supportsResponseStream && ((res)=>res.body)
};
$4b9898a31eea6843$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$4b9898a31eea6843$var$resolvers[type] && ($4b9898a31eea6843$var$resolvers[type] = (0, $eFc3n.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $6wIUo.default)(`Response type '${type}' is not supported`, (0, $6wIUo.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $4b9898a31eea6843$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $eFc3n.default).isBlob(body)) return body.size;
    if ((0, $eFc3n.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bqN51.default).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $eFc3n.default).isArrayBufferView(body) || (0, $eFc3n.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $eFc3n.default).isURLSearchParams(body)) body = body + '';
    if ((0, $eFc3n.default).isString(body)) return (await $4b9898a31eea6843$var$encodeText(body)).byteLength;
};
const $4b9898a31eea6843$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $eFc3n.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $4b9898a31eea6843$var$getBodyLength(body) : length;
};
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $l7Q05.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $c046u.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $4b9898a31eea6843$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $4b9898a31eea6843$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $eFc3n.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $dKk3V.progressEventDecorator)(requestContentLength, (0, $dKk3V.progressEventReducer)((0, $dKk3V.asyncDecorator)(onUploadProgress)));
                data = (0, $eMAze.trackStream)(_request.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $eFc3n.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $4b9898a31eea6843$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($4b9898a31eea6843$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $eFc3n.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $dKk3V.progressEventDecorator)(responseContentLength, (0, $dKk3V.progressEventReducer)((0, $dKk3V.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $eMAze.trackStream)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $4b9898a31eea6843$var$resolvers[(0, $eFc3n.default).findKey($4b9898a31eea6843$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $gyIfz.default)(resolve, reject, {
                data: responseData,
                headers: (0, $7hTsj.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $6wIUo.default)('Network Error', (0, $6wIUo.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $6wIUo.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("c046u", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc8ab02f7e95517$export$2e2bcd8739ae039);

var $8yOyy = parcelRequire("8yOyy");

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $6wIUo.default) ? err : new (0, $8yOyy.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $6wIUo.default)(`timeout ${timeout} of ms exceeded`, (0, $6wIUo.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $eFc3n.default).asap(unsubscribe);
        return signal;
    }
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;

});

parcelRegister("eMAze", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $ac31e9e363273572$export$b0119225647bd83);
const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ac31e9e363273572$var$readStream(iterable))yield* $ac31e9e363273572$export$71b051935044bd5d(chunk, chunkSize);
};
const $ac31e9e363273572$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("8zXsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63efb8494987aa98$export$2e2bcd8739ae039);

var $6yYtd = parcelRequire("6yYtd");

var $6wIUo = parcelRequire("6wIUo");
'use strict';
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $6yYtd.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6wIUo.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6wIUo.default).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$63efb8494987aa98$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6wIUo.default)('options must be an object', (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6wIUo.default)('option ' + opt + ' must be ' + result, (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6wIUo.default)('Unknown option ' + opt, (0, $6wIUo.default).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("6yYtd", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $4c74d331112ba968$export$a4ad2735b021c132);
const $4c74d331112ba968$export$a4ad2735b021c132 = "1.8.2";

});



parcelRegister("4iFhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3218dd97b5460664$export$2e2bcd8739ae039);

var $8yOyy = parcelRequire("8yOyy");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $8yOyy.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7874d702b64e6994$export$2e2bcd8739ae039);
'use strict';
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("1YbHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f479813f4fb9c8$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $eFc3n.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("kq2bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;

});



parcelRegister("O6tRJ", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("6T1J1", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
'use strict';

var $2pmb0 = parcelRequire("2pmb0");
var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $2pmb0.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $2pmb0.hydrateRoot;

});

parcelRegister("4tbyZ", function(module, exports) {
"use client";
"use strict";
var $3412d7152e02b24a$var$q = Object.create;
var $3412d7152e02b24a$var$O = Object.defineProperty;
var $3412d7152e02b24a$var$G = Object.getOwnPropertyDescriptor;
var $3412d7152e02b24a$var$J = Object.getOwnPropertyNames;
var $3412d7152e02b24a$var$K = Object.getPrototypeOf, $3412d7152e02b24a$var$X = Object.prototype.hasOwnProperty;
var $3412d7152e02b24a$var$Z = (e, t)=>{
    for(var o in t)$3412d7152e02b24a$var$O(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $3412d7152e02b24a$var$H = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let a of $3412d7152e02b24a$var$J(t))!$3412d7152e02b24a$var$X.call(e, a) && a !== o && $3412d7152e02b24a$var$O(e, a, {
        get: ()=>t[a],
        enumerable: !(s = $3412d7152e02b24a$var$G(t, a)) || s.enumerable
    });
    return e;
};
var $3412d7152e02b24a$var$W = (e, t, o)=>(o = e != null ? $3412d7152e02b24a$var$q($3412d7152e02b24a$var$K(e)) : {}, $3412d7152e02b24a$var$H(t || !e || !e.__esModule ? $3412d7152e02b24a$var$O(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $3412d7152e02b24a$var$ee = (e)=>$3412d7152e02b24a$var$H($3412d7152e02b24a$var$O({}, "__esModule", {
        value: !0
    }), e);
var $3412d7152e02b24a$var$Ve = {};
$3412d7152e02b24a$var$Z($3412d7152e02b24a$var$Ve, {
    CheckmarkIcon: ()=>$3412d7152e02b24a$var$F,
    ErrorIcon: ()=>$3412d7152e02b24a$var$w,
    LoaderIcon: ()=>$3412d7152e02b24a$var$C,
    ToastBar: ()=>$3412d7152e02b24a$var$$,
    ToastIcon: ()=>$3412d7152e02b24a$var$U,
    Toaster: ()=>$3412d7152e02b24a$var$Y,
    default: ()=>$3412d7152e02b24a$var$ke,
    resolveValue: ()=>$3412d7152e02b24a$var$u,
    toast: ()=>$3412d7152e02b24a$var$n,
    useToaster: ()=>$3412d7152e02b24a$var$_,
    useToasterStore: ()=>$3412d7152e02b24a$var$V
});
module.exports = $3412d7152e02b24a$var$ee($3412d7152e02b24a$var$Ve);
var $3412d7152e02b24a$var$te = (e)=>typeof e == "function", $3412d7152e02b24a$var$u = (e, t)=>$3412d7152e02b24a$var$te(e) ? e(t) : e;
var $3412d7152e02b24a$var$j = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $3412d7152e02b24a$var$I = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $3412d7152e02b24a$var$oe = 20;
var $3412d7152e02b24a$var$Q = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $3412d7152e02b24a$var$oe)
            };
        case 1:
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: o } = t;
            return $3412d7152e02b24a$var$Q(e, {
                type: e.toasts.find((r)=>r.id === o.id) ? 1 : 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === s || s === void 0 ? {
                        ...r,
                        dismissed: !0,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let a = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + a
                    }))
            };
    }
}, $3412d7152e02b24a$var$k = [], $3412d7152e02b24a$var$y = {
    toasts: [],
    pausedAt: void 0
}, $3412d7152e02b24a$var$l = (e)=>{
    $3412d7152e02b24a$var$y = $3412d7152e02b24a$var$Q($3412d7152e02b24a$var$y, e), $3412d7152e02b24a$var$k.forEach((t)=>{
        t($3412d7152e02b24a$var$y);
    });
}, $3412d7152e02b24a$var$re = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $3412d7152e02b24a$var$V = (e = {})=>{
    let [t, o] = (0, (parcelRequire("8NFma")).useState)($3412d7152e02b24a$var$y), s = (0, (parcelRequire("8NFma")).useRef)($3412d7152e02b24a$var$y);
    (0, (parcelRequire("8NFma")).useEffect)(()=>(s.current !== $3412d7152e02b24a$var$y && o($3412d7152e02b24a$var$y), $3412d7152e02b24a$var$k.push(o), ()=>{
            let r = $3412d7152e02b24a$var$k.indexOf(o);
            r > -1 && $3412d7152e02b24a$var$k.splice(r, 1);
        }), []);
    let a = t.toasts.map((r)=>{
        var c, i, p;
        return {
            ...e,
            ...e[r.type],
            ...r,
            removeDelay: r.removeDelay || ((c = e[r.type]) == null ? void 0 : c.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: r.duration || ((i = e[r.type]) == null ? void 0 : i.duration) || (e == null ? void 0 : e.duration) || $3412d7152e02b24a$var$re[r.type],
            style: {
                ...e.style,
                ...(p = e[r.type]) == null ? void 0 : p.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: a
    };
};
var $3412d7152e02b24a$var$ae = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $3412d7152e02b24a$var$j()
    }), $3412d7152e02b24a$var$R = (e)=>(t, o)=>{
        let s = $3412d7152e02b24a$var$ae(t, e, o);
        return $3412d7152e02b24a$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $3412d7152e02b24a$var$n = (e, t)=>$3412d7152e02b24a$var$R("blank")(e, t);
$3412d7152e02b24a$var$n.error = $3412d7152e02b24a$var$R("error");
$3412d7152e02b24a$var$n.success = $3412d7152e02b24a$var$R("success");
$3412d7152e02b24a$var$n.loading = $3412d7152e02b24a$var$R("loading");
$3412d7152e02b24a$var$n.custom = $3412d7152e02b24a$var$R("custom");
$3412d7152e02b24a$var$n.dismiss = (e)=>{
    $3412d7152e02b24a$var$l({
        type: 3,
        toastId: e
    });
};
$3412d7152e02b24a$var$n.remove = (e)=>$3412d7152e02b24a$var$l({
        type: 4,
        toastId: e
    });
$3412d7152e02b24a$var$n.promise = (e, t, o)=>{
    let s = $3412d7152e02b24a$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return typeof e == "function" && (e = e()), e.then((a)=>{
        let r = t.success ? $3412d7152e02b24a$var$u(t.success, a) : void 0;
        return r ? $3412d7152e02b24a$var$n.success(r, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }) : $3412d7152e02b24a$var$n.dismiss(s), a;
    }).catch((a)=>{
        let r = t.error ? $3412d7152e02b24a$var$u(t.error, a) : void 0;
        r ? $3412d7152e02b24a$var$n.error(r, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        }) : $3412d7152e02b24a$var$n.dismiss(s);
    }), e;
};

var $3412d7152e02b24a$var$ie = (e, t)=>{
    $3412d7152e02b24a$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $3412d7152e02b24a$var$ne = ()=>{
    $3412d7152e02b24a$var$l({
        type: 5,
        time: Date.now()
    });
}, $3412d7152e02b24a$var$v = new Map, $3412d7152e02b24a$var$ce = 1e3, $3412d7152e02b24a$var$pe = (e, t = $3412d7152e02b24a$var$ce)=>{
    if ($3412d7152e02b24a$var$v.has(e)) return;
    let o = setTimeout(()=>{
        $3412d7152e02b24a$var$v.delete(e), $3412d7152e02b24a$var$l({
            type: 4,
            toastId: e
        });
    }, t);
    $3412d7152e02b24a$var$v.set(e, o);
}, $3412d7152e02b24a$var$_ = (e)=>{
    let { toasts: t, pausedAt: o } = $3412d7152e02b24a$var$V(e);
    (0, (parcelRequire("8NFma")).useEffect)(()=>{
        if (o) return;
        let r = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let p = (i.duration || 0) + i.pauseDuration - (r - i.createdAt);
            if (p < 0) {
                i.visible && $3412d7152e02b24a$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$3412d7152e02b24a$var$n.dismiss(i.id), p);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("8NFma")).useCallback)(()=>{
        o && $3412d7152e02b24a$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), a = (0, (parcelRequire("8NFma")).useCallback)((r, c)=>{
        let { reverseOrder: i = !1, gutter: p = 8, defaultPosition: d } = c || {}, h = t.filter((m)=>(m.position || d) === (r.position || d) && m.height), z = h.findIndex((m)=>m.id === r.id), D = h.filter((m, B)=>B < z && m.visible).length;
        return h.filter((m)=>m.visible).slice(...i ? [
            D + 1
        ] : [
            0,
            D
        ]).reduce((m, B)=>m + (B.height || 0) + p, 0);
    }, [
        t
    ]);
    return (0, (parcelRequire("8NFma")).useEffect)(()=>{
        t.forEach((r)=>{
            if (r.dismissed) $3412d7152e02b24a$var$pe(r.id, r.removeDelay);
            else {
                let c = $3412d7152e02b24a$var$v.get(r.id);
                c && (clearTimeout(c), $3412d7152e02b24a$var$v.delete(r.id));
            }
        });
    }, [
        t
    ]), {
        toasts: t,
        handlers: {
            updateHeight: $3412d7152e02b24a$var$ie,
            startPause: $3412d7152e02b24a$var$ne,
            endPause: s,
            calculateOffset: a
        }
    };
};

var $3412d7152e02b24a$var$f = $3412d7152e02b24a$var$W((parcelRequire("8NFma")));

var $9qMb0 = parcelRequire("9qMb0");

var $3412d7152e02b24a$var$g = $3412d7152e02b24a$var$W((parcelRequire("8NFma")));

var $9qMb0 = parcelRequire("9qMb0");

var $9qMb0 = parcelRequire("9qMb0");
var $3412d7152e02b24a$var$de = $9qMb0.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $3412d7152e02b24a$var$me = $9qMb0.keyframes`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3412d7152e02b24a$var$ue = $9qMb0.keyframes`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $3412d7152e02b24a$var$w = (0, $9qMb0.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3412d7152e02b24a$var$de} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$3412d7152e02b24a$var$me} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$3412d7152e02b24a$var$ue} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $9qMb0 = parcelRequire("9qMb0");
var $3412d7152e02b24a$var$le = $9qMb0.keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $3412d7152e02b24a$var$C = (0, $9qMb0.styled)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$3412d7152e02b24a$var$le} 1s linear infinite;
`;

var $9qMb0 = parcelRequire("9qMb0");
var $3412d7152e02b24a$var$fe = $9qMb0.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $3412d7152e02b24a$var$Te = $9qMb0.keyframes`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $3412d7152e02b24a$var$F = (0, $9qMb0.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3412d7152e02b24a$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$3412d7152e02b24a$var$Te} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $3412d7152e02b24a$var$ye = (0, $9qMb0.styled)("div")`
  position: absolute;
`, $3412d7152e02b24a$var$ge = (0, $9qMb0.styled)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $3412d7152e02b24a$var$he = $9qMb0.keyframes`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3412d7152e02b24a$var$xe = (0, $9qMb0.styled)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$3412d7152e02b24a$var$he} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $3412d7152e02b24a$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $3412d7152e02b24a$var$g.createElement($3412d7152e02b24a$var$xe, null, t) : t : o === "blank" ? null : $3412d7152e02b24a$var$g.createElement($3412d7152e02b24a$var$ge, null, $3412d7152e02b24a$var$g.createElement($3412d7152e02b24a$var$C, {
        ...s
    }), o !== "loading" && $3412d7152e02b24a$var$g.createElement($3412d7152e02b24a$var$ye, null, o === "error" ? $3412d7152e02b24a$var$g.createElement($3412d7152e02b24a$var$w, {
        ...s
    }) : $3412d7152e02b24a$var$g.createElement($3412d7152e02b24a$var$F, {
        ...s
    })));
};
var $3412d7152e02b24a$var$be = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $3412d7152e02b24a$var$Se = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $3412d7152e02b24a$var$Ae = "0%{opacity:0;} 100%{opacity:1;}", $3412d7152e02b24a$var$Pe = "0%{opacity:1;} 100%{opacity:0;}", $3412d7152e02b24a$var$Re = (0, $9qMb0.styled)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $3412d7152e02b24a$var$ve = (0, $9qMb0.styled)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $3412d7152e02b24a$var$Ee = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, r] = $3412d7152e02b24a$var$I() ? [
        $3412d7152e02b24a$var$Ae,
        $3412d7152e02b24a$var$Pe
    ] : [
        $3412d7152e02b24a$var$be(s),
        $3412d7152e02b24a$var$Se(s)
    ];
    return {
        animation: t ? `${(0, $9qMb0.keyframes)(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $9qMb0.keyframes)(r)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $3412d7152e02b24a$var$$ = $3412d7152e02b24a$var$f.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? $3412d7152e02b24a$var$Ee(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, r = $3412d7152e02b24a$var$f.createElement($3412d7152e02b24a$var$U, {
        toast: e
    }), c = $3412d7152e02b24a$var$f.createElement($3412d7152e02b24a$var$ve, {
        ...e.ariaProps
    }, $3412d7152e02b24a$var$u(e.message, e));
    return $3412d7152e02b24a$var$f.createElement($3412d7152e02b24a$var$Re, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: r,
        message: c
    }) : $3412d7152e02b24a$var$f.createElement($3412d7152e02b24a$var$f.Fragment, null, r, c));
});

var $9qMb0 = parcelRequire("9qMb0");

var $3412d7152e02b24a$var$T = $3412d7152e02b24a$var$W((parcelRequire("8NFma")));
(0, $9qMb0.setup)($3412d7152e02b24a$var$T.createElement);
var $3412d7152e02b24a$var$De = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let r = $3412d7152e02b24a$var$T.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let p = c.getBoundingClientRect().height;
                s(e, p);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $3412d7152e02b24a$var$T.createElement("div", {
        ref: r,
        className: t,
        style: o
    }, a);
}, $3412d7152e02b24a$var$Oe = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $3412d7152e02b24a$var$I() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, $3412d7152e02b24a$var$Ie = $9qMb0.css`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $3412d7152e02b24a$var$L = 16, $3412d7152e02b24a$var$Y = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, containerStyle: r, containerClassName: c })=>{
    let { toasts: i, handlers: p } = $3412d7152e02b24a$var$_(o);
    return $3412d7152e02b24a$var$T.createElement("div", {
        id: "_rht_toaster",
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $3412d7152e02b24a$var$L,
            left: $3412d7152e02b24a$var$L,
            right: $3412d7152e02b24a$var$L,
            bottom: $3412d7152e02b24a$var$L,
            pointerEvents: "none",
            ...r
        },
        className: c,
        onMouseEnter: p.startPause,
        onMouseLeave: p.endPause
    }, i.map((d)=>{
        let h = d.position || t, z = p.calculateOffset(d, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), D = $3412d7152e02b24a$var$Oe(h, z);
        return $3412d7152e02b24a$var$T.createElement($3412d7152e02b24a$var$De, {
            id: d.id,
            key: d.id,
            onHeightUpdate: p.updateHeight,
            className: d.visible ? $3412d7152e02b24a$var$Ie : "",
            style: D
        }, d.type === "custom" ? $3412d7152e02b24a$var$u(d.message, d) : a ? a(d) : $3412d7152e02b24a$var$T.createElement($3412d7152e02b24a$var$$, {
            toast: d,
            position: h
        }));
    }));
};
var $3412d7152e02b24a$var$ke = $3412d7152e02b24a$var$n;

});
parcelRegister("9qMb0", function(module, exports) {

$parcel$export(module.exports, "css", () => $6ddbe9a43451bf52$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "setup", () => $6ddbe9a43451bf52$export$de27182ff8187d6c);
$parcel$export(module.exports, "styled", () => $6ddbe9a43451bf52$export$3817b7a54a07cec7);
let $6ddbe9a43451bf52$var$e = {
    data: ""
}, $6ddbe9a43451bf52$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $6ddbe9a43451bf52$var$e, $6ddbe9a43451bf52$export$54aba348a7896325 = (e)=>{
    let r = $6ddbe9a43451bf52$var$t(e), l = r.data;
    return r.data = "", l;
}, $6ddbe9a43451bf52$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $6ddbe9a43451bf52$var$a = /\/\*[^]*?\*\/|  +/g, $6ddbe9a43451bf52$var$n = /\n+/g, $6ddbe9a43451bf52$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $6ddbe9a43451bf52$var$o(c, n) : n + "{" + $6ddbe9a43451bf52$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $6ddbe9a43451bf52$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $6ddbe9a43451bf52$var$o.p ? $6ddbe9a43451bf52$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $6ddbe9a43451bf52$var$c = {}, $6ddbe9a43451bf52$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $6ddbe9a43451bf52$var$s(e[r]);
        return t;
    }
    return e;
}, $6ddbe9a43451bf52$var$i = (e, t, r, i, p)=>{
    let u = $6ddbe9a43451bf52$var$s(e), d = $6ddbe9a43451bf52$var$c[u] || ($6ddbe9a43451bf52$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$6ddbe9a43451bf52$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $6ddbe9a43451bf52$var$l.exec(e.replace($6ddbe9a43451bf52$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($6ddbe9a43451bf52$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($6ddbe9a43451bf52$var$n, " ").trim();
            return o[0];
        })(e);
        $6ddbe9a43451bf52$var$c[d] = $6ddbe9a43451bf52$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $6ddbe9a43451bf52$var$c.g ? $6ddbe9a43451bf52$var$c.g : null;
    return r && ($6ddbe9a43451bf52$var$c.g = $6ddbe9a43451bf52$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($6ddbe9a43451bf52$var$c[d], t, i, f), d;
}, $6ddbe9a43451bf52$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $6ddbe9a43451bf52$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $6ddbe9a43451bf52$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $6ddbe9a43451bf52$var$i(l.unshift ? l.raw ? $6ddbe9a43451bf52$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $6ddbe9a43451bf52$var$t(r.target), r.g, r.o, r.k);
}
let $6ddbe9a43451bf52$var$d, $6ddbe9a43451bf52$var$f, $6ddbe9a43451bf52$var$g, $6ddbe9a43451bf52$export$442f1a04865e4790 = $6ddbe9a43451bf52$export$dbf350e5966cf602.bind({
    g: 1
}), $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e = $6ddbe9a43451bf52$export$dbf350e5966cf602.bind({
    k: 1
});
function $6ddbe9a43451bf52$export$de27182ff8187d6c(e, t, r, l) {
    $6ddbe9a43451bf52$var$o.p = t, $6ddbe9a43451bf52$var$d = e, $6ddbe9a43451bf52$var$f = r, $6ddbe9a43451bf52$var$g = l;
}
function $6ddbe9a43451bf52$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $6ddbe9a43451bf52$var$f && $6ddbe9a43451bf52$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $6ddbe9a43451bf52$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $6ddbe9a43451bf52$var$g && i[0] && $6ddbe9a43451bf52$var$g(c), $6ddbe9a43451bf52$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}

});


parcelRegister("lHJBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd0fd2c7e617dc2$export$2e2bcd8739ae039);

var $mPpni = parcelRequire("mPpni");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");

var $gQXnL = parcelRequire("gQXnL");

var $iSBXh = parcelRequire("iSBXh");

var $dMiGn = parcelRequire("dMiGn");

var $ctxbz = parcelRequire("ctxbz");
parcelRequire("9ECJO");
parcelRequire("9gsbX");
parcelRequire("iNvSV");
parcelRequire("iDCuG");
parcelRequire("fAqwD");
parcelRequire("cKEms");
parcelRequire("jhpb7");
parcelRequire("2wpc1");

parcelRequire("cJNrf");
parcelRequire("hsLub");
parcelRequire("4MDU6");
parcelRequire("2pmb0");

parcelRequire("8IaiT");
var $fcd0fd2c7e617dc2$var$StateManagedSelect = /*#__PURE__*/ (0, $8NFma.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $mPpni.u)(props);
    return /*#__PURE__*/ $8NFma.createElement((0, $gQXnL.S), (0, $jz4iA.default)({
        ref: ref
    }, baseSelectProps));
});
var $fcd0fd2c7e617dc2$export$2e2bcd8739ae039 = $fcd0fd2c7e617dc2$var$StateManagedSelect;
var $fcd0fd2c7e617dc2$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $8NFma.useMemo)(function() {
        return (0, $dMiGn.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $iSBXh.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("mPpni", function(module, exports) {

$parcel$export(module.exports, "u", () => $0449eeccc7095b32$export$3b14a55fb2447963);

var $5EBXX = parcelRequire("5EBXX");

var $57Wnr = parcelRequire("57Wnr");

var $hPtHC = parcelRequire("hPtHC");

var $8NFma = parcelRequire("8NFma");
var $0449eeccc7095b32$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $0449eeccc7095b32$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $hPtHC.default)(_ref, $0449eeccc7095b32$var$_excluded);
    var _useState = (0, $8NFma.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $57Wnr.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $8NFma.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $57Wnr.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $8NFma.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $57Wnr.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $8NFma.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $8NFma.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $8NFma.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $8NFma.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $5EBXX.default)((0, $5EBXX.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("5EBXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de237383779de8$export$2e2bcd8739ae039);

var $2qeFG = parcelRequire("2qeFG");
function $41de237383779de8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41de237383779de8$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41de237383779de8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2qeFG.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41de237383779de8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("2qeFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3963e2ec4676f7$export$2e2bcd8739ae039);

var $k2Kke = parcelRequire("k2Kke");
function $1c3963e2ec4676f7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $k2Kke.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("k2Kke", function(module, exports) {

$parcel$export(module.exports, "default", () => $e977edce0f75b0db$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $fEskS = parcelRequire("fEskS");
function $e977edce0f75b0db$export$2e2bcd8739ae039(t) {
    var i = (0, $fEskS.default)(t, "string");
    return "symbol" == (0, $jOMXy.default)(i) ? i : i + "";
}

});
parcelRegister("jOMXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d8aa307cfbe8b4$export$2e2bcd8739ae039);
function $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e6d8aa307cfbe8b4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fEskS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b650924e9996270c$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");
function $b650924e9996270c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jOMXy.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jOMXy.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("57Wnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbae3add6a4bdae$export$2e2bcd8739ae039);

var $56R8K = parcelRequire("56R8K");

var $2ZVhM = parcelRequire("2ZVhM");

var $eXIWw = parcelRequire("eXIWw");

var $cpFa1 = parcelRequire("cpFa1");
function $3bbae3add6a4bdae$export$2e2bcd8739ae039(r, e) {
    return (0, $56R8K.default)(r) || (0, $2ZVhM.default)(r, e) || (0, $eXIWw.default)(r, e) || (0, $cpFa1.default)();
}

});
parcelRegister("56R8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b86bbcb24b44a1d$export$2e2bcd8739ae039);
function $3b86bbcb24b44a1d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("2ZVhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $22edb70d56193891$export$2e2bcd8739ae039);
function $22edb70d56193891$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("eXIWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4970148ece50ad$export$2e2bcd8739ae039);

var $3MxnJ = parcelRequire("3MxnJ");
function $ae4970148ece50ad$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $3MxnJ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $3MxnJ.default)(r, a) : void 0;
    }
}

});
parcelRegister("3MxnJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0fbfb5c55051c8$export$2e2bcd8739ae039);
function $2c0fbfb5c55051c8$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("cpFa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $02550737ba08c18f$export$2e2bcd8739ae039);
function $02550737ba08c18f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hPtHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfae3d675552f8ab$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");
function $cfae3d675552f8ab$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $hQtye.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("jz4iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e49ed681292e30$export$2e2bcd8739ae039);
function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    return $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e3e49ed681292e30$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("gQXnL", function(module, exports) {

$parcel$export(module.exports, "b", () => $c44f90c6c9de4ee1$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $c44f90c6c9de4ee1$export$39b482c5e57630a8);
$parcel$export(module.exports, "S", () => $c44f90c6c9de4ee1$export$25ce5a424b770e84);

var $jz4iA = parcelRequire("jz4iA");

var $5EBXX = parcelRequire("5EBXX");

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $6q0Wy = parcelRequire("6q0Wy");

var $8NFma = parcelRequire("8NFma");

var $ctxbz = parcelRequire("ctxbz");

var $9XmJK = parcelRequire("9XmJK");

var $j3Kiq = parcelRequire("j3Kiq");

var $hPtHC = parcelRequire("hPtHC");
function $c44f90c6c9de4ee1$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $c44f90c6c9de4ee1$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $c44f90c6c9de4ee1$var$A11yText = function A11yText(props) {
    return (0, $9XmJK.jsx)("span", (0, $jz4iA.default)({
        css: $c44f90c6c9de4ee1$var$_ref
    }, props));
};
var $c44f90c6c9de4ee1$var$A11yText$1 = $c44f90c6c9de4ee1$var$A11yText;
var $c44f90c6c9de4ee1$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $c44f90c6c9de4ee1$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $8NFma.useMemo)(function() {
        return (0, $5EBXX.default)((0, $5EBXX.default)({}, $c44f90c6c9de4ee1$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $8NFma.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $5EBXX.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $8NFma.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $8NFma.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $8NFma.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $9XmJK.jsx)((0, $8NFma.Fragment), null, (0, $9XmJK.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $9XmJK.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $9XmJK.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $9XmJK.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $9XmJK.jsx)((0, $8NFma.Fragment), null, (0, $9XmJK.jsx)($c44f90c6c9de4ee1$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $9XmJK.jsx)($c44f90c6c9de4ee1$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $c44f90c6c9de4ee1$var$LiveRegion$1 = $c44f90c6c9de4ee1$var$LiveRegion;
var $c44f90c6c9de4ee1$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $c44f90c6c9de4ee1$var$anyDiacritic = new RegExp('[' + $c44f90c6c9de4ee1$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $c44f90c6c9de4ee1$var$diacriticToBase = {};
for(var $c44f90c6c9de4ee1$var$i = 0; $c44f90c6c9de4ee1$var$i < $c44f90c6c9de4ee1$var$diacritics.length; $c44f90c6c9de4ee1$var$i++){
    var $c44f90c6c9de4ee1$var$diacritic = $c44f90c6c9de4ee1$var$diacritics[$c44f90c6c9de4ee1$var$i];
    for(var $c44f90c6c9de4ee1$var$j = 0; $c44f90c6c9de4ee1$var$j < $c44f90c6c9de4ee1$var$diacritic.letters.length; $c44f90c6c9de4ee1$var$j++)$c44f90c6c9de4ee1$var$diacriticToBase[$c44f90c6c9de4ee1$var$diacritic.letters[$c44f90c6c9de4ee1$var$j]] = $c44f90c6c9de4ee1$var$diacritic.base;
}
var $c44f90c6c9de4ee1$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($c44f90c6c9de4ee1$var$anyDiacritic, function(match) {
        return $c44f90c6c9de4ee1$var$diacriticToBase[match];
    });
};
var $c44f90c6c9de4ee1$var$memoizedStripDiacriticsForInput = (0, $j3Kiq.default)($c44f90c6c9de4ee1$var$stripDiacritics);
var $c44f90c6c9de4ee1$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $c44f90c6c9de4ee1$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $c44f90c6c9de4ee1$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $5EBXX.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $c44f90c6c9de4ee1$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $c44f90c6c9de4ee1$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $c44f90c6c9de4ee1$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $c44f90c6c9de4ee1$var$memoizedStripDiacriticsForInput(input);
            candidate = $c44f90c6c9de4ee1$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $c44f90c6c9de4ee1$var$_excluded = [
    "innerRef"
];
function $c44f90c6c9de4ee1$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $hPtHC.default)(_ref, $c44f90c6c9de4ee1$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $ctxbz.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $9XmJK.jsx)("input", (0, $jz4iA.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $9XmJK.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $c44f90c6c9de4ee1$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $c44f90c6c9de4ee1$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $8NFma.useRef)(false);
    var isTop = (0, $8NFma.useRef)(false);
    var touchStart = (0, $8NFma.useRef)(0);
    var scrollTarget = (0, $8NFma.useRef)(null);
    var handleEventDelta = (0, $8NFma.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $c44f90c6c9de4ee1$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $8NFma.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $8NFma.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $8NFma.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $8NFma.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $ctxbz.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $8NFma.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $8NFma.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $c44f90c6c9de4ee1$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $c44f90c6c9de4ee1$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $c44f90c6c9de4ee1$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $c44f90c6c9de4ee1$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $c44f90c6c9de4ee1$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $c44f90c6c9de4ee1$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $c44f90c6c9de4ee1$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $c44f90c6c9de4ee1$var$activeScrollLocks = 0;
var $c44f90c6c9de4ee1$var$listenerOptions = {
    capture: false,
    passive: false
};
function $c44f90c6c9de4ee1$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $8NFma.useRef)({});
    var scrollTarget = (0, $8NFma.useRef)(null);
    var addScrollLock = (0, $8NFma.useCallback)(function(touchScrollTarget) {
        if (!$c44f90c6c9de4ee1$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $c44f90c6c9de4ee1$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $c44f90c6c9de4ee1$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($c44f90c6c9de4ee1$var$LOCK_STYLES).forEach(function(key) {
                var val = $c44f90c6c9de4ee1$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $c44f90c6c9de4ee1$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $c44f90c6c9de4ee1$var$preventTouchMove, $c44f90c6c9de4ee1$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $c44f90c6c9de4ee1$var$preventInertiaScroll, $c44f90c6c9de4ee1$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $c44f90c6c9de4ee1$var$allowTouchMove, $c44f90c6c9de4ee1$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $c44f90c6c9de4ee1$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $8NFma.useCallback)(function(touchScrollTarget) {
        if (!$c44f90c6c9de4ee1$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $c44f90c6c9de4ee1$var$activeScrollLocks = Math.max($c44f90c6c9de4ee1$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $c44f90c6c9de4ee1$var$activeScrollLocks < 1) $c44f90c6c9de4ee1$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $c44f90c6c9de4ee1$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $c44f90c6c9de4ee1$var$preventTouchMove, $c44f90c6c9de4ee1$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $c44f90c6c9de4ee1$var$preventInertiaScroll, $c44f90c6c9de4ee1$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $c44f90c6c9de4ee1$var$allowTouchMove, $c44f90c6c9de4ee1$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $8NFma.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $c44f90c6c9de4ee1$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c44f90c6c9de4ee1$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $c44f90c6c9de4ee1$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $c44f90c6c9de4ee1$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $c44f90c6c9de4ee1$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $c44f90c6c9de4ee1$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $9XmJK.jsx)((0, $8NFma.Fragment), null, lockEnabled && (0, $9XmJK.jsx)("div", {
        onClick: $c44f90c6c9de4ee1$var$blurSelectInput,
        css: $c44f90c6c9de4ee1$var$_ref2$1
    }), children(targetRef));
}
function $c44f90c6c9de4ee1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c44f90c6c9de4ee1$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $c44f90c6c9de4ee1$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $9XmJK.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $c44f90c6c9de4ee1$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $c44f90c6c9de4ee1$var$RequiredInput$1 = $c44f90c6c9de4ee1$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $c44f90c6c9de4ee1$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $c44f90c6c9de4ee1$var$isIPhone() {
    return $c44f90c6c9de4ee1$var$testPlatform(/^iPhone/i);
}
function $c44f90c6c9de4ee1$var$isMac() {
    return $c44f90c6c9de4ee1$var$testPlatform(/^Mac/i);
}
function $c44f90c6c9de4ee1$var$isIPad() {
    return $c44f90c6c9de4ee1$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c44f90c6c9de4ee1$var$isMac() && navigator.maxTouchPoints > 1;
}
function $c44f90c6c9de4ee1$var$isIOS() {
    return $c44f90c6c9de4ee1$var$isIPhone() || $c44f90c6c9de4ee1$var$isIPad();
}
function $c44f90c6c9de4ee1$var$isAppleDevice() {
    return $c44f90c6c9de4ee1$var$isMac() || $c44f90c6c9de4ee1$var$isIOS();
}
var $c44f90c6c9de4ee1$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $c44f90c6c9de4ee1$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $c44f90c6c9de4ee1$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $c44f90c6c9de4ee1$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $c44f90c6c9de4ee1$var$defaultStyles = {
    clearIndicator: (0, $ctxbz.a),
    container: (0, $ctxbz.b),
    control: (0, $ctxbz.d),
    dropdownIndicator: (0, $ctxbz.e),
    group: (0, $ctxbz.g),
    groupHeading: (0, $ctxbz.f),
    indicatorsContainer: (0, $ctxbz.i),
    indicatorSeparator: (0, $ctxbz.h),
    input: (0, $ctxbz.j),
    loadingIndicator: (0, $ctxbz.l),
    loadingMessage: (0, $ctxbz.k),
    menu: (0, $ctxbz.m),
    menuList: (0, $ctxbz.n),
    menuPortal: (0, $ctxbz.o),
    multiValue: (0, $ctxbz.p),
    multiValueLabel: (0, $ctxbz.q),
    multiValueRemove: (0, $ctxbz.t),
    noOptionsMessage: (0, $ctxbz.u),
    option: (0, $ctxbz.v),
    placeholder: (0, $ctxbz.w),
    singleValue: (0, $ctxbz.x),
    valueContainer: (0, $ctxbz.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $c44f90c6c9de4ee1$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $5EBXX.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $c44f90c6c9de4ee1$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $c44f90c6c9de4ee1$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $c44f90c6c9de4ee1$var$baseUnit = 4;
// The minimum height of the control
var $c44f90c6c9de4ee1$var$controlHeight = 38;
// The amount of space between the control and menu */
var $c44f90c6c9de4ee1$var$menuGutter = $c44f90c6c9de4ee1$var$baseUnit * 2;
var $c44f90c6c9de4ee1$var$spacing = {
    baseUnit: $c44f90c6c9de4ee1$var$baseUnit,
    controlHeight: $c44f90c6c9de4ee1$var$controlHeight,
    menuGutter: $c44f90c6c9de4ee1$var$menuGutter
};
var $c44f90c6c9de4ee1$export$4368d992c4eafac0 = {
    borderRadius: $c44f90c6c9de4ee1$var$borderRadius,
    colors: $c44f90c6c9de4ee1$var$colors,
    spacing: $c44f90c6c9de4ee1$var$spacing
};
var $c44f90c6c9de4ee1$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $ctxbz.z)(),
    captureMenuScroll: !(0, $ctxbz.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $c44f90c6c9de4ee1$export$db3b6bfb95261072(),
    formatGroupLabel: $c44f90c6c9de4ee1$var$formatGroupLabel,
    getOptionLabel: $c44f90c6c9de4ee1$export$8b22cf2602fb60ce,
    getOptionValue: $c44f90c6c9de4ee1$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $c44f90c6c9de4ee1$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $ctxbz.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $c44f90c6c9de4ee1$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $c44f90c6c9de4ee1$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $c44f90c6c9de4ee1$var$_isOptionSelected(props, option, selectValue);
    var label = $c44f90c6c9de4ee1$var$getOptionLabel(props, option);
    var value = $c44f90c6c9de4ee1$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $c44f90c6c9de4ee1$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $c44f90c6c9de4ee1$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $c44f90c6c9de4ee1$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $c44f90c6c9de4ee1$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $c44f90c6c9de4ee1$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $ctxbz.K));
}
function $c44f90c6c9de4ee1$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $6q0Wy.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $c44f90c6c9de4ee1$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $6q0Wy.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $c44f90c6c9de4ee1$var$buildFocusableOptions(props, selectValue) {
    return $c44f90c6c9de4ee1$var$buildFocusableOptionsFromCategorizedOptions($c44f90c6c9de4ee1$var$buildCategorizedOptions(props, selectValue));
}
function $c44f90c6c9de4ee1$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$c44f90c6c9de4ee1$var$shouldHideSelectedOptions(props) || !isSelected) && $c44f90c6c9de4ee1$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $c44f90c6c9de4ee1$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $c44f90c6c9de4ee1$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $c44f90c6c9de4ee1$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $c44f90c6c9de4ee1$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $c44f90c6c9de4ee1$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $c44f90c6c9de4ee1$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $c44f90c6c9de4ee1$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $c44f90c6c9de4ee1$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $c44f90c6c9de4ee1$var$getOptionValue(props, i) === candidate;
    });
}
function $c44f90c6c9de4ee1$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $c44f90c6c9de4ee1$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $c44f90c6c9de4ee1$var$instanceId = 1;
var $c44f90c6c9de4ee1$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1UPzg.default)(Select, _Component);
    var _super = (0, $7ZjFV.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $dM0Cr.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $c44f90c6c9de4ee1$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $ctxbz.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $ctxbz.B)([].concat((0, $6q0Wy.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $ctxbz.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $ctxbz.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $ctxbz.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $ctxbz.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $ctxbz.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $c44f90c6c9de4ee1$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $c44f90c6c9de4ee1$var$buildFocusableOptionsWithIds($c44f90c6c9de4ee1$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $ctxbz.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $c44f90c6c9de4ee1$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $c44f90c6c9de4ee1$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $c44f90c6c9de4ee1$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $ctxbz.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $c44f90c6c9de4ee1$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $c44f90c6c9de4ee1$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $5EBXX.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $ctxbz.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $c44f90c6c9de4ee1$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$c44f90c6c9de4ee1$var$instanceId);
        _this.state.selectValue = (0, $ctxbz.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $c44f90c6c9de4ee1$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $lRfe8.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $ctxbz.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $ctxbz.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $c44f90c6c9de4ee1$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($c44f90c6c9de4ee1$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $5EBXX.default)((0, $5EBXX.default)({}, $c44f90c6c9de4ee1$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $c44f90c6c9de4ee1$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $c44f90c6c9de4ee1$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $c44f90c6c9de4ee1$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $5EBXX.default)((0, $5EBXX.default)((0, $5EBXX.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $8NFma.createElement($c44f90c6c9de4ee1$var$DummyInput, (0, $jz4iA.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $ctxbz.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $8NFma.createElement(Input, (0, $jz4iA.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $8NFma.createElement(Placeholder, (0, $jz4iA.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $8NFma.createElement(MultiValue, (0, $jz4iA.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $8NFma.createElement(SingleValue, (0, $jz4iA.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $8NFma.createElement(ClearIndicator, (0, $jz4iA.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $8NFma.createElement(LoadingIndicator, (0, $jz4iA.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $8NFma.createElement(IndicatorSeparator, (0, $jz4iA.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $8NFma.createElement(DropdownIndicator, (0, $jz4iA.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $8NFma.createElement(Option, (0, $jz4iA.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $8NFma.createElement(Group, (0, $jz4iA.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $8NFma.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $8NFma.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $8NFma.createElement((0, $ctxbz.M), (0, $jz4iA.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $8NFma.createElement(Menu, (0, $jz4iA.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $8NFma.createElement($c44f90c6c9de4ee1$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $8NFma.createElement(MenuList, (0, $jz4iA.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $8NFma.createElement(MenuPortal, (0, $jz4iA.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $8NFma.createElement($c44f90c6c9de4ee1$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $8NFma.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $8NFma.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $8NFma.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $8NFma.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $8NFma.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $8NFma.createElement($c44f90c6c9de4ee1$var$LiveRegion$1, (0, $jz4iA.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $8NFma.createElement(SelectContainer, (0, $jz4iA.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $8NFma.createElement(Control, (0, $jz4iA.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $8NFma.createElement(ValueContainer, (0, $jz4iA.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $8NFma.createElement(IndicatorsContainer, (0, $jz4iA.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $ctxbz.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $c44f90c6c9de4ee1$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $c44f90c6c9de4ee1$var$buildFocusableOptionsWithIds($c44f90c6c9de4ee1$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $c44f90c6c9de4ee1$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $c44f90c6c9de4ee1$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $c44f90c6c9de4ee1$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $ctxbz.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $5EBXX.default)((0, $5EBXX.default)((0, $5EBXX.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $8NFma.Component));
$c44f90c6c9de4ee1$export$25ce5a424b770e84.defaultProps = $c44f90c6c9de4ee1$export$407448d2b89b1813;

});
parcelRegister("dM0Cr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0703d0085fc4fb2$export$2e2bcd8739ae039);
function $a0703d0085fc4fb2$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lRfe8", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe9a5bf59b39de5a$export$2e2bcd8739ae039);

var $k2Kke = parcelRequire("k2Kke");
function $fe9a5bf59b39de5a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $k2Kke.default)(o.key), o);
    }
}
function $fe9a5bf59b39de5a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fe9a5bf59b39de5a$var$_defineProperties(e.prototype, r), t && $fe9a5bf59b39de5a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("1UPzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $165305ab584beb18$export$2e2bcd8739ae039);

var $5zL6F = parcelRequire("5zL6F");
function $165305ab584beb18$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $5zL6F.default)(t, e);
}

});

parcelRegister("7ZjFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d0d7e04eb688530$export$2e2bcd8739ae039);

var $aKKvr = parcelRequire("aKKvr");

var $1DsOv = parcelRequire("1DsOv");

var $aEHZE = parcelRequire("aEHZE");
function $5d0d7e04eb688530$export$2e2bcd8739ae039(t) {
    var r = (0, $1DsOv.default)();
    return function() {
        var e, o = (0, $aKKvr.default)(t);
        if (r) {
            var s = (0, $aKKvr.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $aEHZE.default)(this, e);
    };
}

});
parcelRegister("aKKvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d424663944f7a08$export$2e2bcd8739ae039);
function $7d424663944f7a08$export$2e2bcd8739ae039(t) {
    return $7d424663944f7a08$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7d424663944f7a08$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1DsOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $130fc8bc944821df$export$2e2bcd8739ae039);
function $130fc8bc944821df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($130fc8bc944821df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("aEHZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1fc3fad5a369a2$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $1oVxX = parcelRequire("1oVxX");
function $7c1fc3fad5a369a2$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $jOMXy.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $1oVxX.default)(t);
}

});
parcelRegister("1oVxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1054abeafa6bc7e1$export$2e2bcd8739ae039);
function $1054abeafa6bc7e1$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("6q0Wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac5e71af87e3f54$export$2e2bcd8739ae039);

var $lmEQh = parcelRequire("lmEQh");

var $cZGos = parcelRequire("cZGos");

var $eXIWw = parcelRequire("eXIWw");

var $bqQy8 = parcelRequire("bqQy8");
function $4ac5e71af87e3f54$export$2e2bcd8739ae039(r) {
    return (0, $lmEQh.default)(r) || (0, $cZGos.default)(r) || (0, $eXIWw.default)(r) || (0, $bqQy8.default)();
}

});
parcelRegister("lmEQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8db557918a53714$export$2e2bcd8739ae039);

var $3MxnJ = parcelRequire("3MxnJ");
function $f8db557918a53714$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $3MxnJ.default)(r);
}

});

parcelRegister("cZGos", function(module, exports) {

$parcel$export(module.exports, "default", () => $975c10fa3ca03dc7$export$2e2bcd8739ae039);
function $975c10fa3ca03dc7$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("bqQy8", function(module, exports) {

$parcel$export(module.exports, "default", () => $852ae2ae0b46fbef$export$2e2bcd8739ae039);
function $852ae2ae0b46fbef$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("ctxbz", function(module, exports) {

$parcel$export(module.exports, "J", () => $9151ef6c0d5a41bc$export$b4171a6734a65d42);
$parcel$export(module.exports, "E", () => $9151ef6c0d5a41bc$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "H", () => $9151ef6c0d5a41bc$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "L", () => $9151ef6c0d5a41bc$export$61196ced6d74a310);
$parcel$export(module.exports, "G", () => $9151ef6c0d5a41bc$export$2329c99376c9d0a4);
$parcel$export(module.exports, "I", () => $9151ef6c0d5a41bc$export$9bb611d729802a56);
$parcel$export(module.exports, "z", () => $9151ef6c0d5a41bc$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $9151ef6c0d5a41bc$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $9151ef6c0d5a41bc$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "K", () => $9151ef6c0d5a41bc$export$3466f893ebf79586);
$parcel$export(module.exports, "D", () => $9151ef6c0d5a41bc$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $9151ef6c0d5a41bc$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $9151ef6c0d5a41bc$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $9151ef6c0d5a41bc$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $9151ef6c0d5a41bc$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $9151ef6c0d5a41bc$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $9151ef6c0d5a41bc$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $9151ef6c0d5a41bc$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $9151ef6c0d5a41bc$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $9151ef6c0d5a41bc$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $9151ef6c0d5a41bc$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $9151ef6c0d5a41bc$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $9151ef6c0d5a41bc$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $9151ef6c0d5a41bc$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $9151ef6c0d5a41bc$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $9151ef6c0d5a41bc$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $9151ef6c0d5a41bc$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $9151ef6c0d5a41bc$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $9151ef6c0d5a41bc$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $9151ef6c0d5a41bc$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $9151ef6c0d5a41bc$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $9151ef6c0d5a41bc$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $9151ef6c0d5a41bc$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $9151ef6c0d5a41bc$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $9151ef6c0d5a41bc$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $9151ef6c0d5a41bc$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $9151ef6c0d5a41bc$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $9151ef6c0d5a41bc$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $9151ef6c0d5a41bc$export$d66501df72047452);

var $5EBXX = parcelRequire("5EBXX");

var $jz4iA = parcelRequire("jz4iA");

var $9XmJK = parcelRequire("9XmJK");

var $57Wnr = parcelRequire("57Wnr");

var $hPtHC = parcelRequire("hPtHC");

var $jOMXy = parcelRequire("jOMXy");

var $hltwR = parcelRequire("hltwR");

var $2qeFG = parcelRequire("2qeFG");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $8i2T6 = parcelRequire("8i2T6");

var $8IaiT = parcelRequire("8IaiT");
var $9151ef6c0d5a41bc$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $9151ef6c0d5a41bc$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $9151ef6c0d5a41bc$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $9151ef6c0d5a41bc$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($9151ef6c0d5a41bc$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $9151ef6c0d5a41bc$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($9151ef6c0d5a41bc$var$isArray(value)) return value.filter(Boolean);
    if ((0, $jOMXy.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $9151ef6c0d5a41bc$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $hPtHC.default)(props, $9151ef6c0d5a41bc$var$_excluded$4);
    return (0, $5EBXX.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $9151ef6c0d5a41bc$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $9151ef6c0d5a41bc$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $9151ef6c0d5a41bc$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $9151ef6c0d5a41bc$var$normalizedHeight(el) {
    if ($9151ef6c0d5a41bc$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $9151ef6c0d5a41bc$var$getScrollTop(el) {
    if ($9151ef6c0d5a41bc$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $9151ef6c0d5a41bc$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($9151ef6c0d5a41bc$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $9151ef6c0d5a41bc$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $9151ef6c0d5a41bc$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $9151ef6c0d5a41bc$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $9151ef6c0d5a41bc$export$b4171a6734a65d42;
    var start = $9151ef6c0d5a41bc$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $9151ef6c0d5a41bc$var$easeOutCubic(currentTime, start, change, duration);
        $9151ef6c0d5a41bc$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $9151ef6c0d5a41bc$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $9151ef6c0d5a41bc$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $9151ef6c0d5a41bc$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $9151ef6c0d5a41bc$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $9151ef6c0d5a41bc$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $9151ef6c0d5a41bc$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $9151ef6c0d5a41bc$var$passiveOptionAccessed = false;
var $9151ef6c0d5a41bc$var$options = {
    get passive () {
        return $9151ef6c0d5a41bc$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $9151ef6c0d5a41bc$var$w = typeof window !== 'undefined' ? window : {};
if ($9151ef6c0d5a41bc$var$w.addEventListener && $9151ef6c0d5a41bc$var$w.removeEventListener) {
    $9151ef6c0d5a41bc$var$w.addEventListener('p', $9151ef6c0d5a41bc$export$b4171a6734a65d42, $9151ef6c0d5a41bc$var$options);
    $9151ef6c0d5a41bc$var$w.removeEventListener('p', $9151ef6c0d5a41bc$export$b4171a6734a65d42, false);
}
var $9151ef6c0d5a41bc$export$2408f22a0fab9ae5 = $9151ef6c0d5a41bc$var$passiveOptionAccessed;
function $9151ef6c0d5a41bc$export$3466f893ebf79586(item) {
    return item != null;
}
function $9151ef6c0d5a41bc$var$isArray(arg) {
    return Array.isArray(arg);
}
function $9151ef6c0d5a41bc$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $9151ef6c0d5a41bc$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $9151ef6c0d5a41bc$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $9151ef6c0d5a41bc$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $57Wnr.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $57Wnr.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $9151ef6c0d5a41bc$var$_excluded$3 = [
    "children",
    "innerProps"
], $9151ef6c0d5a41bc$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $9151ef6c0d5a41bc$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $9151ef6c0d5a41bc$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $9151ef6c0d5a41bc$var$normalizedHeight(scrollParent);
    var scrollTop = $9151ef6c0d5a41bc$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $9151ef6c0d5a41bc$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $9151ef6c0d5a41bc$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $9151ef6c0d5a41bc$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $9151ef6c0d5a41bc$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $9151ef6c0d5a41bc$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $9151ef6c0d5a41bc$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $9151ef6c0d5a41bc$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $9151ef6c0d5a41bc$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $5EBXX.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $2qeFG.default)(_objectSpread2, $9151ef6c0d5a41bc$var$alignToControl(placement), '100%'), (0, $2qeFG.default)(_objectSpread2, "position", 'absolute'), (0, $2qeFG.default)(_objectSpread2, "width", '100%'), (0, $2qeFG.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $9151ef6c0d5a41bc$var$PortalPlacementContext = /*#__PURE__*/ (0, $8NFma.createContext)(null);
// NOTE: internal only
var $9151ef6c0d5a41bc$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $8NFma.useContext)($9151ef6c0d5a41bc$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $8NFma.useRef)(null);
    var _useState = (0, $8NFma.useState)(maxMenuHeight), _useState2 = (0, $57Wnr.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $8NFma.useState)(null), _useState4 = (0, $57Wnr.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $8IaiT.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $9151ef6c0d5a41bc$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $5EBXX.default)((0, $5EBXX.default)({}, props), {}, {
            placement: placement || $9151ef6c0d5a41bc$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $9151ef6c0d5a41bc$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $9151ef6c0d5a41bc$var$Menu$1 = $9151ef6c0d5a41bc$var$Menu;
// ==============================
// Menu List
// ==============================
var $9151ef6c0d5a41bc$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $5EBXX.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $9151ef6c0d5a41bc$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $9151ef6c0d5a41bc$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $5EBXX.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $9151ef6c0d5a41bc$export$3b14a55fb2447963 = $9151ef6c0d5a41bc$var$noticeCSS;
var $9151ef6c0d5a41bc$export$342063e11d6c3cad = $9151ef6c0d5a41bc$var$noticeCSS;
var $9151ef6c0d5a41bc$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $hPtHC.default)(_ref6, $9151ef6c0d5a41bc$var$_excluded$3);
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps((0, $5EBXX.default)((0, $5EBXX.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $9151ef6c0d5a41bc$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $hPtHC.default)(_ref7, $9151ef6c0d5a41bc$var$_excluded2$1);
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps((0, $5EBXX.default)((0, $5EBXX.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $9151ef6c0d5a41bc$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $9151ef6c0d5a41bc$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $8NFma.useRef)(null);
    var cleanupRef = (0, $8NFma.useRef)(null);
    var _useState5 = (0, $8NFma.useState)($9151ef6c0d5a41bc$var$coercePlacement(menuPlacement)), _useState6 = (0, $57Wnr.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $8NFma.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $8NFma.useState)(null), _useState8 = (0, $57Wnr.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $8NFma.useCallback)(function() {
        if (!controlElement) return;
        var rect = $9151ef6c0d5a41bc$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $8IaiT.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $8NFma.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $8i2T6.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $8IaiT.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $8NFma.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({
        ref: setMenuPortalElement
    }, $9151ef6c0d5a41bc$var$getStyleProps((0, $5EBXX.default)((0, $5EBXX.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $2pmb0.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $9151ef6c0d5a41bc$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $9151ef6c0d5a41bc$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $9151ef6c0d5a41bc$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $5EBXX.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $9151ef6c0d5a41bc$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $9151ef6c0d5a41bc$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $9151ef6c0d5a41bc$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $9151ef6c0d5a41bc$var$_templateObject;
var $9151ef6c0d5a41bc$var$_excluded$2 = [
    "size"
], $9151ef6c0d5a41bc$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $9151ef6c0d5a41bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $9151ef6c0d5a41bc$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $9151ef6c0d5a41bc$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $hPtHC.default)(_ref, $9151ef6c0d5a41bc$var$_excluded$2);
    return (0, $9XmJK.jsx)("svg", (0, $jz4iA.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $9151ef6c0d5a41bc$var$_ref2
    }, props));
};
var $9151ef6c0d5a41bc$var$CrossIcon = function CrossIcon(props) {
    return (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$Svg, (0, $jz4iA.default)({
        size: 20
    }, props), (0, $9XmJK.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $9151ef6c0d5a41bc$var$DownChevron = function DownChevron(props) {
    return (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$Svg, (0, $jz4iA.default)({
        size: 20
    }, props), (0, $9XmJK.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $9151ef6c0d5a41bc$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $5EBXX.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $9151ef6c0d5a41bc$export$f1e1789686576879 = $9151ef6c0d5a41bc$var$baseCSS;
var $9151ef6c0d5a41bc$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$DownChevron, null));
};
var $9151ef6c0d5a41bc$export$407448d2b89b1813 = $9151ef6c0d5a41bc$var$baseCSS;
var $9151ef6c0d5a41bc$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $9151ef6c0d5a41bc$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $5EBXX.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $9151ef6c0d5a41bc$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("span", (0, $jz4iA.default)({}, innerProps, $9151ef6c0d5a41bc$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $9151ef6c0d5a41bc$var$loadingDotAnimations = (0, $9XmJK.keyframes)($9151ef6c0d5a41bc$var$_templateObject || ($9151ef6c0d5a41bc$var$_templateObject = (0, $hltwR.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $9151ef6c0d5a41bc$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $5EBXX.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $9151ef6c0d5a41bc$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $9XmJK.jsx)("span", {
        css: /*#__PURE__*/ (0, $9XmJK.css)({
            animation: "".concat($9151ef6c0d5a41bc$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $9151ef6c0d5a41bc$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $hPtHC.default)(_ref7, $9151ef6c0d5a41bc$var$_excluded2);
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps((0, $5EBXX.default)((0, $5EBXX.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $9151ef6c0d5a41bc$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $5EBXX.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $9151ef6c0d5a41bc$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({
        ref: innerRef
    }, $9151ef6c0d5a41bc$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $9151ef6c0d5a41bc$var$Control$1 = $9151ef6c0d5a41bc$var$Control;
var $9151ef6c0d5a41bc$var$_excluded$1 = [
    "data"
];
var $9151ef6c0d5a41bc$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $9151ef6c0d5a41bc$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $9XmJK.jsx)(Heading, (0, $jz4iA.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $9XmJK.jsx)("div", null, children));
};
var $9151ef6c0d5a41bc$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $5EBXX.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $9151ef6c0d5a41bc$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $9151ef6c0d5a41bc$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $hPtHC.default)(_cleanCommonProps, $9151ef6c0d5a41bc$var$_excluded$1);
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $9151ef6c0d5a41bc$var$Group$1 = $9151ef6c0d5a41bc$var$Group;
var $9151ef6c0d5a41bc$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $9151ef6c0d5a41bc$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5EBXX.default)((0, $5EBXX.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $9151ef6c0d5a41bc$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $9151ef6c0d5a41bc$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $9151ef6c0d5a41bc$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $5EBXX.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $9151ef6c0d5a41bc$var$spacingStyle)
};
var $9151ef6c0d5a41bc$var$inputStyle = function inputStyle(isHidden) {
    return (0, $5EBXX.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $9151ef6c0d5a41bc$var$spacingStyle);
};
var $9151ef6c0d5a41bc$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $9151ef6c0d5a41bc$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $hPtHC.default)(_cleanCommonProps, $9151ef6c0d5a41bc$var$_excluded);
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $9XmJK.jsx)("input", (0, $jz4iA.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $9151ef6c0d5a41bc$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $9151ef6c0d5a41bc$var$Input$1 = $9151ef6c0d5a41bc$var$Input;
var $9151ef6c0d5a41bc$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $5EBXX.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $9151ef6c0d5a41bc$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $5EBXX.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $9151ef6c0d5a41bc$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $5EBXX.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $9151ef6c0d5a41bc$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $9XmJK.jsx)("div", innerProps, children);
};
var $9151ef6c0d5a41bc$var$MultiValueContainer = $9151ef6c0d5a41bc$var$MultiValueGeneric;
var $9151ef6c0d5a41bc$var$MultiValueLabel = $9151ef6c0d5a41bc$var$MultiValueGeneric;
function $9151ef6c0d5a41bc$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({
        role: "button"
    }, innerProps), children || (0, $9XmJK.jsx)($9151ef6c0d5a41bc$var$CrossIcon, {
        size: 14
    }));
}
var $9151ef6c0d5a41bc$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $9XmJK.jsx)(Container, {
        data: data,
        innerProps: (0, $5EBXX.default)((0, $5EBXX.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $9XmJK.jsx)(Label, {
        data: data,
        innerProps: (0, $5EBXX.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $9XmJK.jsx)(Remove, {
        data: data,
        innerProps: (0, $5EBXX.default)((0, $5EBXX.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $9151ef6c0d5a41bc$var$MultiValue$1 = $9151ef6c0d5a41bc$var$MultiValue;
var $9151ef6c0d5a41bc$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5EBXX.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $9151ef6c0d5a41bc$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $9151ef6c0d5a41bc$var$Option$1 = $9151ef6c0d5a41bc$var$Option;
var $9151ef6c0d5a41bc$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5EBXX.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $9151ef6c0d5a41bc$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $9151ef6c0d5a41bc$var$Placeholder$1 = $9151ef6c0d5a41bc$var$Placeholder;
var $9151ef6c0d5a41bc$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $5EBXX.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $9151ef6c0d5a41bc$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $9XmJK.jsx)("div", (0, $jz4iA.default)({}, $9151ef6c0d5a41bc$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $9151ef6c0d5a41bc$var$SingleValue$1 = $9151ef6c0d5a41bc$var$SingleValue;
var $9151ef6c0d5a41bc$export$db3b6bfb95261072 = {
    ClearIndicator: $9151ef6c0d5a41bc$var$ClearIndicator,
    Control: $9151ef6c0d5a41bc$var$Control$1,
    DropdownIndicator: $9151ef6c0d5a41bc$var$DropdownIndicator,
    DownChevron: $9151ef6c0d5a41bc$var$DownChevron,
    CrossIcon: $9151ef6c0d5a41bc$var$CrossIcon,
    Group: $9151ef6c0d5a41bc$var$Group$1,
    GroupHeading: $9151ef6c0d5a41bc$var$GroupHeading,
    IndicatorsContainer: $9151ef6c0d5a41bc$var$IndicatorsContainer,
    IndicatorSeparator: $9151ef6c0d5a41bc$var$IndicatorSeparator,
    Input: $9151ef6c0d5a41bc$var$Input$1,
    LoadingIndicator: $9151ef6c0d5a41bc$var$LoadingIndicator,
    Menu: $9151ef6c0d5a41bc$var$Menu$1,
    MenuList: $9151ef6c0d5a41bc$var$MenuList,
    MenuPortal: $9151ef6c0d5a41bc$var$MenuPortal,
    LoadingMessage: $9151ef6c0d5a41bc$var$LoadingMessage,
    NoOptionsMessage: $9151ef6c0d5a41bc$var$NoOptionsMessage,
    MultiValue: $9151ef6c0d5a41bc$var$MultiValue$1,
    MultiValueContainer: $9151ef6c0d5a41bc$var$MultiValueContainer,
    MultiValueLabel: $9151ef6c0d5a41bc$var$MultiValueLabel,
    MultiValueRemove: $9151ef6c0d5a41bc$var$MultiValueRemove,
    Option: $9151ef6c0d5a41bc$var$Option$1,
    Placeholder: $9151ef6c0d5a41bc$var$Placeholder$1,
    SelectContainer: $9151ef6c0d5a41bc$var$SelectContainer,
    SingleValue: $9151ef6c0d5a41bc$var$SingleValue$1,
    ValueContainer: $9151ef6c0d5a41bc$var$ValueContainer
};
var $9151ef6c0d5a41bc$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $5EBXX.default)((0, $5EBXX.default)({}, $9151ef6c0d5a41bc$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("9XmJK", function(module, exports) {

$parcel$export(module.exports, "css", () => $01dee42c9ca53feb$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $01dee42c9ca53feb$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $01dee42c9ca53feb$export$c8a8987d4410bf2d);

var $iSBXh = parcelRequire("iSBXh");

var $8NFma = parcelRequire("8NFma");

var $i1Adn = parcelRequire("i1Adn");

var $gwJ0Y = parcelRequire("gwJ0Y");

var $gLVll = parcelRequire("gLVll");
parcelRequire("dMiGn");
parcelRequire("lBRDc");
parcelRequire("dBNhP");

parcelRequire("l3NX5");
var $01dee42c9ca53feb$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $iSBXh.h).call(props, 'css')) return $8NFma.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $iSBXh.E);
    createElementArgArray[1] = (0, $iSBXh.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8NFma.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($01dee42c9ca53feb$export$c8a8987d4410bf2d || ($01dee42c9ca53feb$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $01dee42c9ca53feb$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $iSBXh.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $gLVll.serializeStyles)([
        styles
    ], undefined, $8NFma.useContext((0, $iSBXh.T)));
    if (!(0, $iSBXh.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8NFma.useRef();
    (0, $gwJ0Y.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gwJ0Y.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $i1Adn.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $01dee42c9ca53feb$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $gLVll.serializeStyles)(args);
}
function $01dee42c9ca53feb$export$d25ddfdf17c3ad3e() {
    var insertable = $01dee42c9ca53feb$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $01dee42c9ca53feb$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $01dee42c9ca53feb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $i1Adn.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $01dee42c9ca53feb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $i1Adn.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $iSBXh.i) && res !== undefined) rules += res;
        }
        if (!(0, $iSBXh.i)) return rules;
    });
    if (!(0, $iSBXh.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $01dee42c9ca53feb$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $iSBXh.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $iSBXh.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $gLVll.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $i1Adn.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $iSBXh.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $01dee42c9ca53feb$var$merge(cache.registered, css, $01dee42c9ca53feb$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8NFma.useContext((0, $iSBXh.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($01dee42c9ca53feb$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("iSBXh", function(module, exports) {

$parcel$export(module.exports, "a", () => $dbeab63edf3287cf$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $dbeab63edf3287cf$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $dbeab63edf3287cf$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $dbeab63edf3287cf$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $dbeab63edf3287cf$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $dbeab63edf3287cf$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $dbeab63edf3287cf$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $dbeab63edf3287cf$export$a9c23c6ac3fc3eca);

var $8NFma = parcelRequire("8NFma");

var $dMiGn = parcelRequire("dMiGn");

var $jz4iA = parcelRequire("jz4iA");

var $dBNhP = parcelRequire("dBNhP");

var $69vM6 = parcelRequire("69vM6");

var $i1Adn = parcelRequire("i1Adn");

var $gLVll = parcelRequire("gLVll");

var $gwJ0Y = parcelRequire("gwJ0Y");
var $dbeab63edf3287cf$export$407448d2b89b1813 = false;
var $dbeab63edf3287cf$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $dbeab63edf3287cf$var$EmotionCacheContext = /* #__PURE__ */ $8NFma.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $dMiGn.default)({
    key: 'css'
}) : null);
var $dbeab63edf3287cf$export$e7094788287c5e9b = $dbeab63edf3287cf$var$EmotionCacheContext.Provider;
var $dbeab63edf3287cf$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
};
var $dbeab63edf3287cf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8NFma.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$dbeab63edf3287cf$export$23f2a1d2818174ef) $dbeab63edf3287cf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $dMiGn.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $dbeab63edf3287cf$export$971d5caa766a69d7 = /* #__PURE__ */ $8NFma.createContext({});
var $dbeab63edf3287cf$export$3b14a55fb2447963 = function useTheme() {
    return $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
};
var $dbeab63edf3287cf$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $jz4iA.default)({}, outerTheme, theme);
};
var $dbeab63edf3287cf$var$createCacheWithTheme = /* #__PURE__ */ (0, $dBNhP.default)(function(outerTheme) {
    return (0, $dBNhP.default)(function(theme) {
        return $dbeab63edf3287cf$var$getTheme(outerTheme, theme);
    });
});
var $dbeab63edf3287cf$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $dbeab63edf3287cf$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $dbeab63edf3287cf$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8NFma.forwardRef(function render(props, ref) {
        var theme = $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8NFma.createElement(Component, (0, $jz4iA.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $69vM6.default)(WithTheme, Component);
}
var $dbeab63edf3287cf$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $dbeab63edf3287cf$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $dbeab63edf3287cf$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($dbeab63edf3287cf$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$dbeab63edf3287cf$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $dbeab63edf3287cf$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $i1Adn.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $i1Adn.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$dbeab63edf3287cf$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $dbeab63edf3287cf$var$Emotion = /* #__PURE__ */ $dbeab63edf3287cf$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$dbeab63edf3287cf$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $i1Adn.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $gLVll.serializeStyles)(registeredStyles, undefined, $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($dbeab63edf3287cf$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $dbeab63edf3287cf$var$typePropName && !$dbeab63edf3287cf$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8NFma.createElement(WrappedComponent, newProps));
});
var $dbeab63edf3287cf$export$a9c23c6ac3fc3eca = $dbeab63edf3287cf$var$Emotion;

});
parcelRegister("dMiGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07e4002c0412599$export$2e2bcd8739ae039);

var $2Dt2A = parcelRequire("2Dt2A");

var $5ZhKJ = parcelRequire("5ZhKJ");

var $dBNhP = parcelRequire("dBNhP");

var $b9Xpj = parcelRequire("b9Xpj");
var $a07e4002c0412599$var$isBrowser = typeof document !== 'undefined';
var $a07e4002c0412599$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $5ZhKJ.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $5ZhKJ.token)(character)) break;
        (0, $5ZhKJ.next)();
    }
    return (0, $5ZhKJ.slice)(begin, (0, $5ZhKJ.position));
};
var $a07e4002c0412599$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $5ZhKJ.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $5ZhKJ.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $a07e4002c0412599$var$identifierWithPointTracking((0, $5ZhKJ.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $5ZhKJ.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $5ZhKJ.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5ZhKJ.from)(character);
    }
    while (character = (0, $5ZhKJ.next)());
    return parsed;
};
var $a07e4002c0412599$var$getRules = function getRules(value, points) {
    return (0, $5ZhKJ.dealloc)($a07e4002c0412599$var$toRules((0, $5ZhKJ.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $a07e4002c0412599$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $a07e4002c0412599$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$a07e4002c0412599$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $a07e4002c0412599$var$fixedElements.set(element, true);
    var points = [];
    var rules = $a07e4002c0412599$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $a07e4002c0412599$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $a07e4002c0412599$var$prefix(value, length) {
    switch((0, $5ZhKJ.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $5ZhKJ.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $5ZhKJ.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MOZ) + value + (0, $5ZhKJ.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + value + value;
        // order
        case 6165:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.replace)(value, /(\w+).+(:[^]+)/, (0, $5ZhKJ.WEBKIT) + 'box-$1$2' + (0, $5ZhKJ.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-item-' + (0, $5ZhKJ.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-line-pack' + (0, $5ZhKJ.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $5ZhKJ.WEBKIT) + 'box-' + (0, $5ZhKJ.replace)(value, '-grow', '') + (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $5ZhKJ.WEBKIT) + (0, $5ZhKJ.replace)(value, /([^-])(transform)/g, '$1' + (0, $5ZhKJ.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5ZhKJ.replace)((0, $5ZhKJ.replace)((0, $5ZhKJ.replace)(value, /(zoom-|grab)/, (0, $5ZhKJ.WEBKIT) + '$1'), /(image-set)/, (0, $5ZhKJ.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5ZhKJ.replace)(value, /(image-set\([^]*)/, (0, $5ZhKJ.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5ZhKJ.replace)((0, $5ZhKJ.replace)(value, /(.+:)(flex-)?(.*)/, (0, $5ZhKJ.WEBKIT) + 'box-pack:$3' + (0, $5ZhKJ.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $5ZhKJ.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5ZhKJ.replace)(value, /(.+)-inline(.+)/, (0, $5ZhKJ.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5ZhKJ.strlen)(value) - 1 - length > 6) switch((0, $5ZhKJ.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5ZhKJ.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5ZhKJ.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $5ZhKJ.WEBKIT) + '$2-$3' + '$1' + (0, $5ZhKJ.MOZ) + ((0, $5ZhKJ.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5ZhKJ.indexof)(value, 'stretch') ? $a07e4002c0412599$var$prefix((0, $5ZhKJ.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5ZhKJ.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5ZhKJ.charat)(value, (0, $5ZhKJ.strlen)(value) - 3 - (~(0, $5ZhKJ.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5ZhKJ.replace)(value, ':', ':' + (0, $5ZhKJ.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5ZhKJ.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $5ZhKJ.WEBKIT) + ((0, $5ZhKJ.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $5ZhKJ.WEBKIT) + '$2$3' + '$1' + (0, $5ZhKJ.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5ZhKJ.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + value + value;
    }
    return value;
}
var $a07e4002c0412599$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $5ZhKJ.DECLARATION:
                element["return"] = $a07e4002c0412599$var$prefix(element.value, element.length);
                break;
            case 0, $5ZhKJ.KEYFRAMES:
                return (0, $5ZhKJ.serialize)([
                    (0, $5ZhKJ.copy)(element, {
                        value: (0, $5ZhKJ.replace)(element.value, '@', '@' + (0, $5ZhKJ.WEBKIT))
                    })
                ], callback);
            case 0, $5ZhKJ.RULESET:
                if (element.length) return (0, $5ZhKJ.combine)(element.props, function(value) {
                    switch((0, $5ZhKJ.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $5ZhKJ.serialize)([
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(read-\w+)/, ':' + (0, $5ZhKJ.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $5ZhKJ.serialize)([
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, ':' + (0, $5ZhKJ.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, ':' + (0, $5ZhKJ.MOZ) + '$1')
                                    ]
                                }),
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, (0, $5ZhKJ.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $a07e4002c0412599$var$getServerStylisCache = $a07e4002c0412599$var$isBrowser ? undefined : (0, $dBNhP.default)(function() {
    return (0, $b9Xpj.default)(function() {
        return {};
    });
});
var $a07e4002c0412599$var$defaultStylisPlugins = [
    $a07e4002c0412599$var$prefixer
];
var $a07e4002c0412599$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($a07e4002c0412599$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $a07e4002c0412599$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($a07e4002c0412599$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $a07e4002c0412599$var$compat,
        $a07e4002c0412599$var$removeLabel
    ];
    if (!$a07e4002c0412599$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $5ZhKJ.stringify),
            (0, $5ZhKJ.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $5ZhKJ.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $5ZhKJ.serialize)((0, $5ZhKJ.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $5ZhKJ.stringify)
        ];
        var _serializer = (0, $5ZhKJ.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $5ZhKJ.serialize)((0, $5ZhKJ.compile)(styles), _serializer);
        };
        var serverStylisCache = $a07e4002c0412599$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $2Dt2A.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("2Dt2A", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $1eb5c02cfaf58a20$export$9d753cd7ae895cce);
var $1eb5c02cfaf58a20$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $1eb5c02cfaf58a20$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $1eb5c02cfaf58a20$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $1eb5c02cfaf58a20$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$1eb5c02cfaf58a20$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($1eb5c02cfaf58a20$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $1eb5c02cfaf58a20$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("5ZhKJ", function(module, exports) {

$parcel$export(module.exports, "MS", () => $e36f1de21b27a557$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $e36f1de21b27a557$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $e36f1de21b27a557$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $e36f1de21b27a557$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $e36f1de21b27a557$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $e36f1de21b27a557$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $e36f1de21b27a557$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $e36f1de21b27a557$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $e36f1de21b27a557$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $e36f1de21b27a557$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $e36f1de21b27a557$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $e36f1de21b27a557$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $e36f1de21b27a557$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $e36f1de21b27a557$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $e36f1de21b27a557$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $e36f1de21b27a557$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $e36f1de21b27a557$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $e36f1de21b27a557$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $e36f1de21b27a557$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $e36f1de21b27a557$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $e36f1de21b27a557$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $e36f1de21b27a557$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $e36f1de21b27a557$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $e36f1de21b27a557$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $e36f1de21b27a557$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $e36f1de21b27a557$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $e36f1de21b27a557$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $e36f1de21b27a557$export$38bcb760f1d4871c);
var $e36f1de21b27a557$export$71ad59f2e432cfe8 = "-ms-";
var $e36f1de21b27a557$export$2c0f367103c8d01c = "-moz-";
var $e36f1de21b27a557$export$39dfd62a25e0fe93 = "-webkit-";
var $e36f1de21b27a557$export$a29989082612d0d9 = "comm";
var $e36f1de21b27a557$export$aa3a2e812ca8570d = "rule";
var $e36f1de21b27a557$export$527d108ccf083c2b = "decl";
var $e36f1de21b27a557$export$d3d35020fa5b54f0 = "@page";
var $e36f1de21b27a557$export$500415a86c544f73 = "@media";
var $e36f1de21b27a557$export$a763edbf796b780a = "@import";
var $e36f1de21b27a557$export$2790aeb8b4e5c826 = "@charset";
var $e36f1de21b27a557$export$1cc683e23b84b133 = "@viewport";
var $e36f1de21b27a557$export$9447a5efea57e862 = "@supports";
var $e36f1de21b27a557$export$ef011b4e114b1fba = "@document";
var $e36f1de21b27a557$export$6aad947bda0f3f46 = "@namespace";
var $e36f1de21b27a557$export$b44a8529a35fcb60 = "@keyframes";
var $e36f1de21b27a557$export$2c16de31893252e6 = "@font-face";
var $e36f1de21b27a557$export$3d846dd52e150c6f = "@counter-style";
var $e36f1de21b27a557$export$22314bfbb57653fe = "@font-feature-values";
var $e36f1de21b27a557$export$d773506282b3cfe6 = "@layer";
var $e36f1de21b27a557$export$2335f513bbd82c6d = Math.abs;
var $e36f1de21b27a557$export$6788812c4e6611e6 = String.fromCharCode;
var $e36f1de21b27a557$export$e6e34fd1f2686227 = Object.assign;
function $e36f1de21b27a557$export$d6af199866bfb566(e, r) {
    return $e36f1de21b27a557$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 0)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 1)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 2)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 3) : 0;
}
function $e36f1de21b27a557$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e36f1de21b27a557$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e36f1de21b27a557$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e36f1de21b27a557$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $e36f1de21b27a557$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e36f1de21b27a557$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e36f1de21b27a557$export$36776f635604f274(e) {
    return e.length;
}
function $e36f1de21b27a557$export$f9084667e487ed46(e) {
    return e.length;
}
function $e36f1de21b27a557$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e36f1de21b27a557$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $e36f1de21b27a557$export$53f1d5ea8de3d7c = 1;
var $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1;
var $e36f1de21b27a557$export$f24224f1c91d8156 = 0;
var $e36f1de21b27a557$export$5880b8b5730aff45 = 0;
var $e36f1de21b27a557$export$c0306caf338ac095 = 0;
var $e36f1de21b27a557$export$30a86d91af8ff6e6 = "";
function $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e36f1de21b27a557$export$53f1d5ea8de3d7c,
        column: $e36f1de21b27a557$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $e36f1de21b27a557$export$784d13d8ee351f07(e, r) {
    return $e36f1de21b27a557$export$e6e34fd1f2686227($e36f1de21b27a557$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $e36f1de21b27a557$export$eba6f6f03b0a92e7() {
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$232faf9add678146() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 > 0 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, --$e36f1de21b27a557$export$5880b8b5730aff45) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3--, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c--;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$48cfd1e771a65c4f() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 < $e36f1de21b27a557$export$f24224f1c91d8156 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45++) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3++, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c++;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$4d3fb11e950abb9e() {
    return $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$e88cb2efb12ae807() {
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$58adb3bec8346d0f(e, r) {
    return $e36f1de21b27a557$export$2f35ab04d2335697($e36f1de21b27a557$export$30a86d91af8ff6e6, e, r);
}
function $e36f1de21b27a557$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e36f1de21b27a557$export$2de70f21292aac9e(e) {
    return $e36f1de21b27a557$export$53f1d5ea8de3d7c = $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$f24224f1c91d8156 = $e36f1de21b27a557$export$36776f635604f274($e36f1de21b27a557$export$30a86d91af8ff6e6 = e), $e36f1de21b27a557$export$5880b8b5730aff45 = 0, [];
}
function $e36f1de21b27a557$export$45918ac1574455b1(e) {
    return $e36f1de21b27a557$export$30a86d91af8ff6e6 = "", e;
}
function $e36f1de21b27a557$export$410ac95b9ec204b8(e) {
    return $e36f1de21b27a557$export$87c2784dc9fc4ab($e36f1de21b27a557$export$58adb3bec8346d0f($e36f1de21b27a557$export$5880b8b5730aff45 - 1, $e36f1de21b27a557$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e36f1de21b27a557$export$660b2ee2d4fb4eff(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$5f8c09e3ae6f64e1($e36f1de21b27a557$export$2de70f21292aac9e(e)));
}
function $e36f1de21b27a557$export$7af1228ff777d175(e) {
    while($e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$4d3fb11e950abb9e())if ($e36f1de21b27a557$export$c0306caf338ac095 < 33) $e36f1de21b27a557$export$48cfd1e771a65c4f();
    else break;
    return $e36f1de21b27a557$export$9e1725a4cfeada27(e) > 2 || $e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e36f1de21b27a557$export$5f8c09e3ae6f64e1(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095)){
        case 0:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$c0306caf338ac095), e);
            break;
        default:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$c0306caf338ac095), e);
    }
    return e;
}
function $e36f1de21b27a557$export$955ba06d119e085e(e, r) {
    while(--r && $e36f1de21b27a557$export$48cfd1e771a65c4f())if ($e36f1de21b27a557$export$c0306caf338ac095 < 48 || $e36f1de21b27a557$export$c0306caf338ac095 > 102 || $e36f1de21b27a557$export$c0306caf338ac095 > 57 && $e36f1de21b27a557$export$c0306caf338ac095 < 65 || $e36f1de21b27a557$export$c0306caf338ac095 > 70 && $e36f1de21b27a557$export$c0306caf338ac095 < 97) break;
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$e88cb2efb12ae807() + (r < 6 && $e36f1de21b27a557$export$4d3fb11e950abb9e() == 32 && $e36f1de21b27a557$export$48cfd1e771a65c4f() == 32));
}
function $e36f1de21b27a557$export$c889f2fcc19dbf12(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$c0306caf338ac095){
        case e:
            return $e36f1de21b27a557$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e36f1de21b27a557$export$c889f2fcc19dbf12($e36f1de21b27a557$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e36f1de21b27a557$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e36f1de21b27a557$export$48cfd1e771a65c4f();
            break;
    }
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$4254d4e2b3745c4c(e, r) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 57) break;
    else if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 84 && $e36f1de21b27a557$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e36f1de21b27a557$export$58adb3bec8346d0f(r, $e36f1de21b27a557$export$5880b8b5730aff45 - 1) + "*" + $e36f1de21b27a557$export$6788812c4e6611e6(e === 47 ? e : $e36f1de21b27a557$export$48cfd1e771a65c4f());
}
function $e36f1de21b27a557$export$c2ab62c7bf24634(e) {
    while(!$e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$4d3fb11e950abb9e()))$e36f1de21b27a557$export$48cfd1e771a65c4f();
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$ef7acd7185315e22(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e36f1de21b27a557$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e36f1de21b27a557$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $e36f1de21b27a557$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e36f1de21b27a557$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($e36f1de21b27a557$export$f8e21b1e77979a08(j += $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $e36f1de21b27a557$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $e36f1de21b27a557$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $e36f1de21b27a557$export$955ba06d119e085e($e36f1de21b27a557$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e36f1de21b27a557$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$4a34f930e789283c($e36f1de21b27a557$export$4254d4e2b3745c4c($e36f1de21b27a557$export$48cfd1e771a65c4f(), $e36f1de21b27a557$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e36f1de21b27a557$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $e36f1de21b27a557$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $e36f1de21b27a557$export$36776f635604f274(j) - l) $e36f1de21b27a557$export$10d8903dec122b9d(p > 32 ? $e36f1de21b27a557$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $e36f1de21b27a557$export$f8483753829ec8f3($e36f1de21b27a557$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $e36f1de21b27a557$export$10d8903dec122b9d(y = $e36f1de21b27a557$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $e36f1de21b27a557$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $e36f1de21b27a557$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e36f1de21b27a557$export$98e6a39c04603d36(e, y, y, n && $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $e36f1de21b27a557$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $e36f1de21b27a557$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $e36f1de21b27a557$export$232faf9add678146() == 125) continue;
            }
            switch(j += $e36f1de21b27a557$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e36f1de21b27a557$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e36f1de21b27a557$export$4d3fb11e950abb9e() === 45) j += $e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$48cfd1e771a65c4f());
                    v = $e36f1de21b27a557$export$4d3fb11e950abb9e(), o = l = $e36f1de21b27a557$export$36776f635604f274(g = j += $e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $e36f1de21b27a557$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $e36f1de21b27a557$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $e36f1de21b27a557$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $e36f1de21b27a557$export$2f35ab04d2335697(e, v + 1, v = $e36f1de21b27a557$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $e36f1de21b27a557$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $e36f1de21b27a557$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, s === 0 ? $e36f1de21b27a557$export$aa3a2e812ca8570d : i, f, o, l);
}
function $e36f1de21b27a557$export$4a34f930e789283c(e, r, a) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$a29989082612d0d9, $e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$eba6f6f03b0a92e7()), $e36f1de21b27a557$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $e36f1de21b27a557$export$f8483753829ec8f3(e, r, a, n) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$527d108ccf083c2b, $e36f1de21b27a557$export$2f35ab04d2335697(e, 0, n), $e36f1de21b27a557$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $e36f1de21b27a557$export$82e9f45cca5ba907(n, c, s) {
    switch($e36f1de21b27a557$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $e36f1de21b27a557$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$2c0f367103c8d01c + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-$1$2" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-item-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-line-pack" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-pack:$3" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-column-align" + $e36f1de21b27a557$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e36f1de21b27a557$export$f8e21b1e77979a08(s, "span") ? $e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) : +$e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) - +$e36f1de21b27a557$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e36f1de21b27a557$export$36776f635604f274(n) - 1 - c > 6) switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e36f1de21b27a557$export$2c0f367103c8d01c + ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n, "stretch") ? $e36f1de21b27a557$export$82e9f45cca5ba907($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 6) === 121) return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, $e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + ($e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $e36f1de21b27a557$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $e36f1de21b27a557$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e36f1de21b27a557$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e36f1de21b27a557$export$a763edbf796b780a:
        case $e36f1de21b27a557$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e36f1de21b27a557$export$a29989082612d0d9:
            return "";
        case $e36f1de21b27a557$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $e36f1de21b27a557$export$36776f635604f274(a = $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e36f1de21b27a557$export$5a7767152ae0305f(e) {
    var r = $e36f1de21b27a557$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e36f1de21b27a557$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e36f1de21b27a557$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e36f1de21b27a557$export$527d108ccf083c2b:
                n.return = $e36f1de21b27a557$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e36f1de21b27a557$export$b44a8529a35fcb60:
                return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                    $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                        value: $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e36f1de21b27a557$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e36f1de21b27a557$export$aa3a2e812ca8570d:
                if (n.length) return $e36f1de21b27a557$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($e36f1de21b27a557$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e36f1de21b27a557$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $e36f1de21b27a557$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e36f1de21b27a557$export$1be1fc439b849fdf($e36f1de21b27a557$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e36f1de21b27a557$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e36f1de21b27a557$export$2f35ab04d2335697(r, 1, $e36f1de21b27a557$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e36f1de21b27a557$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e36f1de21b27a557$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e36f1de21b27a557$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("dBNhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e84f658cb2e4b7e$export$2e2bcd8739ae039);
var $9e84f658cb2e4b7e$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("b9Xpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $81fe9e0845417c5e$export$2e2bcd8739ae039);
function $81fe9e0845417c5e$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("69vM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ac3b2531c94e30$export$2e2bcd8739ae039);

var $l3NX5 = parcelRequire("l3NX5");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $47ac3b2531c94e30$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l3NX5)))(targetComponent, sourceComponent);
};

});
parcelRegister("l3NX5", function(module, exports) {
'use strict';

var $1TAMD = parcelRequire("1TAMD");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f550a03ccbc02dc9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f550a03ccbc02dc9$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f550a03ccbc02dc9$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$TYPE_STATICS = {};
$f550a03ccbc02dc9$var$TYPE_STATICS[$1TAMD.ForwardRef] = $f550a03ccbc02dc9$var$FORWARD_REF_STATICS;
$f550a03ccbc02dc9$var$TYPE_STATICS[$1TAMD.Memo] = $f550a03ccbc02dc9$var$MEMO_STATICS;
function $f550a03ccbc02dc9$var$getStatics(component) {
    // React v16.11 and below
    if ($1TAMD.isMemo(component)) return $f550a03ccbc02dc9$var$MEMO_STATICS;
     // React v16.12 and above
    return $f550a03ccbc02dc9$var$TYPE_STATICS[component['$$typeof']] || $f550a03ccbc02dc9$var$REACT_STATICS;
}
var $f550a03ccbc02dc9$var$defineProperty = Object.defineProperty;
var $f550a03ccbc02dc9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f550a03ccbc02dc9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f550a03ccbc02dc9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f550a03ccbc02dc9$var$getPrototypeOf = Object.getPrototypeOf;
var $f550a03ccbc02dc9$var$objectPrototype = Object.prototype;
function $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($f550a03ccbc02dc9$var$objectPrototype) {
            var inheritedComponent = $f550a03ccbc02dc9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f550a03ccbc02dc9$var$objectPrototype) $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f550a03ccbc02dc9$var$getOwnPropertyNames(sourceComponent);
        if ($f550a03ccbc02dc9$var$getOwnPropertySymbols) keys = keys.concat($f550a03ccbc02dc9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f550a03ccbc02dc9$var$getStatics(targetComponent);
        var sourceStatics = $f550a03ccbc02dc9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f550a03ccbc02dc9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f550a03ccbc02dc9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f550a03ccbc02dc9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f550a03ccbc02dc9$var$hoistNonReactStatics;

});
parcelRegister("1TAMD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cdwfJ"));

});
parcelRegister("cdwfJ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $8e4fb7a6186ef4a8$export$2b8d127b894957b9, (v) => $8e4fb7a6186ef4a8$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $8e4fb7a6186ef4a8$export$cea3a54a6425200c, (v) => $8e4fb7a6186ef4a8$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae, (v) => $8e4fb7a6186ef4a8$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d, (v) => $8e4fb7a6186ef4a8$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac, (v) => $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35, (v) => $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8e4fb7a6186ef4a8$export$ffb0004e005737fa, (v) => $8e4fb7a6186ef4a8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8e4fb7a6186ef4a8$export$b624eff549462981, (v) => $8e4fb7a6186ef4a8$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8e4fb7a6186ef4a8$export$7897aa7841a5380c, (v) => $8e4fb7a6186ef4a8$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8e4fb7a6186ef4a8$export$602eac185826482c, (v) => $8e4fb7a6186ef4a8$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8e4fb7a6186ef4a8$export$e2c29f18771995cb, (v) => $8e4fb7a6186ef4a8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8e4fb7a6186ef4a8$export$5f8d39834fd61797, (v) => $8e4fb7a6186ef4a8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5, (v) => $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8e4fb7a6186ef4a8$export$92387174baf9b227, (v) => $8e4fb7a6186ef4a8$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6, (v) => $8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8e4fb7a6186ef4a8$export$b706b080d889d2c9, (v) => $8e4fb7a6186ef4a8$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc, (v) => $8e4fb7a6186ef4a8$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d, (v) => $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8e4fb7a6186ef4a8$export$455c2e768291efa6, (v) => $8e4fb7a6186ef4a8$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8e4fb7a6186ef4a8$export$9522e17588c12572, (v) => $8e4fb7a6186ef4a8$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8e4fb7a6186ef4a8$export$2110ac352bb060b9, (v) => $8e4fb7a6186ef4a8$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab, (v) => $8e4fb7a6186ef4a8$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de, (v) => $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8e4fb7a6186ef4a8$export$b82d16f27459e05a, (v) => $8e4fb7a6186ef4a8$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8, (v) => $8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6, (v) => $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8e4fb7a6186ef4a8$export$9b621391a187a31a, (v) => $8e4fb7a6186ef4a8$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f, (v) => $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e4fb7a6186ef4a8$export$2b8d127b894957b9;
var $8e4fb7a6186ef4a8$export$cea3a54a6425200c;
var $8e4fb7a6186ef4a8$export$a7c73072b1a182ae;
var $8e4fb7a6186ef4a8$export$9f27bc3417b4524d;
var $8e4fb7a6186ef4a8$export$db77ccec0bb4ccac;
var $8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35;
var $8e4fb7a6186ef4a8$export$ffb0004e005737fa;
var $8e4fb7a6186ef4a8$export$b624eff549462981;
var $8e4fb7a6186ef4a8$export$7897aa7841a5380c;
var $8e4fb7a6186ef4a8$export$602eac185826482c;
var $8e4fb7a6186ef4a8$export$e2c29f18771995cb;
var $8e4fb7a6186ef4a8$export$5f8d39834fd61797;
var $8e4fb7a6186ef4a8$export$74bf444e3cd11ea5;
var $8e4fb7a6186ef4a8$export$92387174baf9b227;
var $8e4fb7a6186ef4a8$export$ec112efeb987d9c6;
var $8e4fb7a6186ef4a8$export$b706b080d889d2c9;
var $8e4fb7a6186ef4a8$export$5be5a87408f70ddc;
var $8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d;
var $8e4fb7a6186ef4a8$export$455c2e768291efa6;
var $8e4fb7a6186ef4a8$export$9522e17588c12572;
var $8e4fb7a6186ef4a8$export$2110ac352bb060b9;
var $8e4fb7a6186ef4a8$export$56885ab8b9c456ab;
var $8e4fb7a6186ef4a8$export$d927fcb6adf8f9de;
var $8e4fb7a6186ef4a8$export$b82d16f27459e05a;
var $8e4fb7a6186ef4a8$export$522c17b4f5e123e8;
var $8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6;
var $8e4fb7a6186ef4a8$export$9b621391a187a31a;
var $8e4fb7a6186ef4a8$export$f5bbd400c2f4426f;
'use strict';
var $8e4fb7a6186ef4a8$var$b = "function" === typeof Symbol && Symbol.for, $8e4fb7a6186ef4a8$var$c = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.element") : 60103, $8e4fb7a6186ef4a8$var$d = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.portal") : 60106, $8e4fb7a6186ef4a8$var$e = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.fragment") : 60107, $8e4fb7a6186ef4a8$var$f = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.strict_mode") : 60108, $8e4fb7a6186ef4a8$var$g = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.profiler") : 60114, $8e4fb7a6186ef4a8$var$h = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.provider") : 60109, $8e4fb7a6186ef4a8$var$k = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.context") : 60110, $8e4fb7a6186ef4a8$var$l = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.async_mode") : 60111, $8e4fb7a6186ef4a8$var$m = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8e4fb7a6186ef4a8$var$n = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.forward_ref") : 60112, $8e4fb7a6186ef4a8$var$p = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.suspense") : 60113, $8e4fb7a6186ef4a8$var$q = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.suspense_list") : 60120, $8e4fb7a6186ef4a8$var$r = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.memo") : 60115, $8e4fb7a6186ef4a8$var$t = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.lazy") : 60116, $8e4fb7a6186ef4a8$var$v = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.block") : 60121, $8e4fb7a6186ef4a8$var$w = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.fundamental") : 60117, $8e4fb7a6186ef4a8$var$x = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.responder") : 60118, $8e4fb7a6186ef4a8$var$y = $8e4fb7a6186ef4a8$var$b ? Symbol.for("react.scope") : 60119;
function $8e4fb7a6186ef4a8$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8e4fb7a6186ef4a8$var$c:
                switch(a = a.type, a){
                    case $8e4fb7a6186ef4a8$var$l:
                    case $8e4fb7a6186ef4a8$var$m:
                    case $8e4fb7a6186ef4a8$var$e:
                    case $8e4fb7a6186ef4a8$var$g:
                    case $8e4fb7a6186ef4a8$var$f:
                    case $8e4fb7a6186ef4a8$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8e4fb7a6186ef4a8$var$k:
                            case $8e4fb7a6186ef4a8$var$n:
                            case $8e4fb7a6186ef4a8$var$t:
                            case $8e4fb7a6186ef4a8$var$r:
                            case $8e4fb7a6186ef4a8$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8e4fb7a6186ef4a8$var$d:
                return u;
        }
    }
}
function $8e4fb7a6186ef4a8$var$A(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$m;
}
$8e4fb7a6186ef4a8$export$2b8d127b894957b9 = $8e4fb7a6186ef4a8$var$l;
$8e4fb7a6186ef4a8$export$cea3a54a6425200c = $8e4fb7a6186ef4a8$var$m;
$8e4fb7a6186ef4a8$export$a7c73072b1a182ae = $8e4fb7a6186ef4a8$var$k;
$8e4fb7a6186ef4a8$export$9f27bc3417b4524d = $8e4fb7a6186ef4a8$var$h;
$8e4fb7a6186ef4a8$export$db77ccec0bb4ccac = $8e4fb7a6186ef4a8$var$c;
$8e4fb7a6186ef4a8$export$8392c0c9d3dcbd35 = $8e4fb7a6186ef4a8$var$n;
$8e4fb7a6186ef4a8$export$ffb0004e005737fa = $8e4fb7a6186ef4a8$var$e;
$8e4fb7a6186ef4a8$export$b624eff549462981 = $8e4fb7a6186ef4a8$var$t;
$8e4fb7a6186ef4a8$export$7897aa7841a5380c = $8e4fb7a6186ef4a8$var$r;
$8e4fb7a6186ef4a8$export$602eac185826482c = $8e4fb7a6186ef4a8$var$d;
$8e4fb7a6186ef4a8$export$e2c29f18771995cb = $8e4fb7a6186ef4a8$var$g;
$8e4fb7a6186ef4a8$export$5f8d39834fd61797 = $8e4fb7a6186ef4a8$var$f;
$8e4fb7a6186ef4a8$export$74bf444e3cd11ea5 = $8e4fb7a6186ef4a8$var$p;
$8e4fb7a6186ef4a8$export$92387174baf9b227 = function(a) {
    return $8e4fb7a6186ef4a8$var$A(a) || $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$l;
};
$8e4fb7a6186ef4a8$export$ec112efeb987d9c6 = $8e4fb7a6186ef4a8$var$A;
$8e4fb7a6186ef4a8$export$b706b080d889d2c9 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$k;
};
$8e4fb7a6186ef4a8$export$5be5a87408f70ddc = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$h;
};
$8e4fb7a6186ef4a8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8e4fb7a6186ef4a8$var$c;
};
$8e4fb7a6186ef4a8$export$455c2e768291efa6 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$n;
};
$8e4fb7a6186ef4a8$export$9522e17588c12572 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$e;
};
$8e4fb7a6186ef4a8$export$2110ac352bb060b9 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$t;
};
$8e4fb7a6186ef4a8$export$56885ab8b9c456ab = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$r;
};
$8e4fb7a6186ef4a8$export$d927fcb6adf8f9de = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$d;
};
$8e4fb7a6186ef4a8$export$b82d16f27459e05a = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$g;
};
$8e4fb7a6186ef4a8$export$522c17b4f5e123e8 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$f;
};
$8e4fb7a6186ef4a8$export$1aabd8a0274ecfd6 = function(a) {
    return $8e4fb7a6186ef4a8$var$z(a) === $8e4fb7a6186ef4a8$var$p;
};
$8e4fb7a6186ef4a8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8e4fb7a6186ef4a8$var$e || a === $8e4fb7a6186ef4a8$var$m || a === $8e4fb7a6186ef4a8$var$g || a === $8e4fb7a6186ef4a8$var$f || a === $8e4fb7a6186ef4a8$var$p || a === $8e4fb7a6186ef4a8$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8e4fb7a6186ef4a8$var$t || a.$$typeof === $8e4fb7a6186ef4a8$var$r || a.$$typeof === $8e4fb7a6186ef4a8$var$h || a.$$typeof === $8e4fb7a6186ef4a8$var$k || a.$$typeof === $8e4fb7a6186ef4a8$var$n || a.$$typeof === $8e4fb7a6186ef4a8$var$w || a.$$typeof === $8e4fb7a6186ef4a8$var$x || a.$$typeof === $8e4fb7a6186ef4a8$var$y || a.$$typeof === $8e4fb7a6186ef4a8$var$v);
};
$8e4fb7a6186ef4a8$export$f5bbd400c2f4426f = $8e4fb7a6186ef4a8$var$z;

});




parcelRegister("i1Adn", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $d1f46976782075db$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $d1f46976782075db$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $d1f46976782075db$export$6f077d94b33a01aa);
var $d1f46976782075db$var$isBrowser = typeof document !== 'undefined';
function $d1f46976782075db$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $d1f46976782075db$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d1f46976782075db$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d1f46976782075db$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d1f46976782075db$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$d1f46976782075db$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$d1f46976782075db$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("gLVll", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $c35d8451a28681ad$export$6321afa313b251b5);

var $ei1c3 = parcelRequire("ei1c3");

var $ia3Zd = parcelRequire("ia3Zd");

var $b9Xpj = parcelRequire("b9Xpj");
var $c35d8451a28681ad$var$isDevelopment = false;
var $c35d8451a28681ad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $c35d8451a28681ad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $c35d8451a28681ad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $c35d8451a28681ad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $c35d8451a28681ad$var$processStyleName = /* #__PURE__ */ (0, $b9Xpj.default)(function(styleName) {
    return $c35d8451a28681ad$var$isCustomProperty(styleName) ? styleName : styleName.replace($c35d8451a28681ad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $c35d8451a28681ad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($c35d8451a28681ad$var$animationRegex, function(match, p1, p2) {
                $c35d8451a28681ad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $c35d8451a28681ad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $ia3Zd.default)[key] !== 1 && !$c35d8451a28681ad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $c35d8451a28681ad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $c35d8451a28681ad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $c35d8451a28681ad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $c35d8451a28681ad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $c35d8451a28681ad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $c35d8451a28681ad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $c35d8451a28681ad$var$cursor;
                var result = interpolation(mergedProps);
                $c35d8451a28681ad$var$cursor = previousCursor;
                return $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $c35d8451a28681ad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($c35d8451a28681ad$var$isProcessableValue(asString)) string += $c35d8451a28681ad$var$processStyleName(key) + ":" + $c35d8451a28681ad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $c35d8451a28681ad$var$isDevelopment) throw new Error($c35d8451a28681ad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($c35d8451a28681ad$var$isProcessableValue(value[_i])) string += $c35d8451a28681ad$var$processStyleName(key) + ":" + $c35d8451a28681ad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $c35d8451a28681ad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $c35d8451a28681ad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $c35d8451a28681ad$var$cursor;
function $c35d8451a28681ad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $c35d8451a28681ad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $c35d8451a28681ad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $c35d8451a28681ad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $ei1c3.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $c35d8451a28681ad$var$cursor
    };
}

});
parcelRegister("ei1c3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a673ac1d41d20e76$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a673ac1d41d20e76$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("ia3Zd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38c40c43cea0c69$export$2e2bcd8739ae039);
var $d38c40c43cea0c69$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("gwJ0Y", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $c0828d75d37a5f18$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $c0828d75d37a5f18$export$811a713a7276cb9d);

var $8NFma = parcelRequire("8NFma");
var $c0828d75d37a5f18$var$isBrowser = typeof document !== 'undefined';
var $c0828d75d37a5f18$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c0828d75d37a5f18$var$useInsertionEffect = $8NFma.useInsertionEffect ? $8NFma.useInsertionEffect : false;
var $c0828d75d37a5f18$export$db21c7ffa21794e7 = !$c0828d75d37a5f18$var$isBrowser ? $c0828d75d37a5f18$var$syncFallback : $c0828d75d37a5f18$var$useInsertionEffect || $c0828d75d37a5f18$var$syncFallback;
var $c0828d75d37a5f18$export$811a713a7276cb9d = $c0828d75d37a5f18$var$useInsertionEffect || $8NFma.useLayoutEffect;

});


parcelRegister("lBRDc", function(module, exports) {
function $fbb6a7bc8836e7ee$var$_extends() {
    return module.exports = $fbb6a7bc8836e7ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fbb6a7bc8836e7ee$var$_extends.apply(null, arguments);
}
module.exports = $fbb6a7bc8836e7ee$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hltwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca0b4dad1407f418$export$2e2bcd8739ae039);
function $ca0b4dad1407f418$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("8i2T6", function(module, exports) {

$parcel$export(module.exports, "platform", () => $60923e9f3f841413$export$722a64dea1b767dc);
$parcel$export(module.exports, "autoUpdate", () => $60923e9f3f841413$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $60923e9f3f841413$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $60923e9f3f841413$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $60923e9f3f841413$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $60923e9f3f841413$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $60923e9f3f841413$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $60923e9f3f841413$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $60923e9f3f841413$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $60923e9f3f841413$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $60923e9f3f841413$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $60923e9f3f841413$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $60923e9f3f841413$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("1D9S2")).getOverflowAncestors);

var $E7rjD = parcelRequire("E7rjD");
var $Euxde = parcelRequire("Euxde");

var $Euxde = parcelRequire("Euxde");

var $1D9S2 = parcelRequire("1D9S2");
function $60923e9f3f841413$var$getCssDimensions(element) {
    const css = (0, $1D9S2.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1D9S2.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $Euxde.round)(width) !== offsetWidth || (0, $Euxde.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $60923e9f3f841413$var$unwrapElement(element) {
    return !(0, $1D9S2.isElement)(element) ? element.contextElement : element;
}
function $60923e9f3f841413$var$getScale(element) {
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    if (!(0, $1D9S2.isHTMLElement)(domElement)) return (0, $Euxde.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $60923e9f3f841413$var$getCssDimensions(domElement);
    let x = ($ ? (0, $Euxde.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $Euxde.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $60923e9f3f841413$var$noOffsets = /*#__PURE__*/ (0, $Euxde.createCoords)(0);
function $60923e9f3f841413$var$getVisualOffsets(element) {
    const win = (0, $1D9S2.getWindow)(element);
    if (!(0, $1D9S2.isWebKit)() || !win.visualViewport) return $60923e9f3f841413$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $60923e9f3f841413$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1D9S2.getWindow)(element)) return false;
    return isFixed;
}
function $60923e9f3f841413$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    let scale = (0, $Euxde.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1D9S2.isElement)(offsetParent)) scale = $60923e9f3f841413$var$getScale(offsetParent);
        } else scale = $60923e9f3f841413$var$getScale(element);
    }
    const visualOffsets = $60923e9f3f841413$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $60923e9f3f841413$var$getVisualOffsets(domElement) : (0, $Euxde.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1D9S2.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1D9S2.isElement)(offsetParent) ? (0, $1D9S2.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $1D9S2.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $60923e9f3f841413$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1D9S2.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1D9S2.getWindow)(currentIFrame);
            currentIFrame = (0, $1D9S2.getFrameElement)(currentWin);
        }
    }
    return (0, $Euxde.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $60923e9f3f841413$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $1D9S2.getNodeScroll)(element).scrollLeft;
    if (!rect) return $60923e9f3f841413$var$getBoundingClientRect((0, $1D9S2.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $60923e9f3f841413$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $1D9S2.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $1D9S2.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $Euxde.createCoords)(1);
    const offsets = (0, $Euxde.createCoords)(0);
    const isOffsetParentAnElement = (0, $1D9S2.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1D9S2.getNodeName)(offsetParent) !== 'body' || (0, $1D9S2.isOverflowElement)(documentElement)) scroll = (0, $1D9S2.getNodeScroll)(offsetParent);
        if ((0, $1D9S2.isHTMLElement)(offsetParent)) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent);
            scale = $60923e9f3f841413$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll, true) : (0, $Euxde.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $60923e9f3f841413$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $60923e9f3f841413$var$getDocumentRect(element) {
    const html = (0, $1D9S2.getDocumentElement)(element);
    const scroll = (0, $1D9S2.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $Euxde.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $Euxde.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $60923e9f3f841413$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1D9S2.getComputedStyle)(body).direction === 'rtl') x += (0, $Euxde.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$getViewportRect(element, strategy) {
    const win = (0, $1D9S2.getWindow)(element);
    const html = (0, $1D9S2.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1D9S2.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $60923e9f3f841413$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $60923e9f3f841413$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1D9S2.isHTMLElement)(element) ? $60923e9f3f841413$var$getScale(element) : (0, $Euxde.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $60923e9f3f841413$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $60923e9f3f841413$var$getDocumentRect((0, $1D9S2.getDocumentElement)(element));
    else if ((0, $1D9S2.isElement)(clippingAncestor)) rect = $60923e9f3f841413$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $60923e9f3f841413$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $Euxde.rectToClientRect)(rect);
}
function $60923e9f3f841413$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1D9S2.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1D9S2.isElement)(parentNode) || (0, $1D9S2.isLastTraversableNode)(parentNode)) return false;
    return (0, $1D9S2.getComputedStyle)(parentNode).position === 'fixed' || $60923e9f3f841413$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $60923e9f3f841413$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1D9S2.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1D9S2.isElement)(el) && (0, $1D9S2.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1D9S2.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $1D9S2.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1D9S2.isElement)(currentNode) && !(0, $1D9S2.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1D9S2.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1D9S2.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1D9S2.isOverflowElement)(currentNode) && !currentNodeIsContaining && $60923e9f3f841413$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1D9S2.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $60923e9f3f841413$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $1D9S2.isTopLayer)(element) ? [] : $60923e9f3f841413$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $Euxde.max)(rect.top, accRect.top);
        accRect.right = (0, $Euxde.min)(rect.right, accRect.right);
        accRect.bottom = (0, $Euxde.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $Euxde.max)(rect.left, accRect.left);
        return accRect;
    }, $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $60923e9f3f841413$var$getDimensions(element) {
    const { width: width, height: height } = $60923e9f3f841413$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $60923e9f3f841413$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1D9S2.isHTMLElement)(offsetParent);
    const documentElement = (0, $1D9S2.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $60923e9f3f841413$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $Euxde.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1D9S2.getNodeName)(offsetParent) !== 'body' || (0, $1D9S2.isOverflowElement)(documentElement)) scroll = (0, $1D9S2.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $60923e9f3f841413$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll) : (0, $Euxde.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $60923e9f3f841413$var$isStaticPositioned(element) {
    return (0, $1D9S2.getComputedStyle)(element).position === 'static';
}
function $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1D9S2.isHTMLElement)(element) || (0, $1D9S2.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $1D9S2.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $60923e9f3f841413$var$getOffsetParent(element, polyfill) {
    const win = (0, $1D9S2.getWindow)(element);
    if ((0, $1D9S2.isTopLayer)(element)) return win;
    if (!(0, $1D9S2.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $1D9S2.getParentNode)(element);
        while(svgOffsetParent && !(0, $1D9S2.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $1D9S2.isElement)(svgOffsetParent) && !$60923e9f3f841413$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1D9S2.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1D9S2.isTableElement)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent))offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1D9S2.isLastTraversableNode)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent) && !(0, $1D9S2.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $1D9S2.getContainingBlock)(element) || win;
}
const $60923e9f3f841413$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $60923e9f3f841413$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $60923e9f3f841413$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $60923e9f3f841413$var$isRTL(element) {
    return (0, $1D9S2.getComputedStyle)(element).direction === 'rtl';
}
const $60923e9f3f841413$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1D9S2.getDocumentElement,
    getClippingRect: $60923e9f3f841413$var$getClippingRect,
    getOffsetParent: $60923e9f3f841413$var$getOffsetParent,
    getElementRects: $60923e9f3f841413$var$getElementRects,
    getClientRects: $60923e9f3f841413$var$getClientRects,
    getDimensions: $60923e9f3f841413$var$getDimensions,
    getScale: $60923e9f3f841413$var$getScale,
    isElement: $1D9S2.isElement,
    isRTL: $60923e9f3f841413$var$isRTL
};
function $60923e9f3f841413$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $60923e9f3f841413$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1D9S2.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $Euxde.floor)(top);
        const insetRight = (0, $Euxde.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $Euxde.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $Euxde.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $Euxde.max)(0, (0, $Euxde.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$60923e9f3f841413$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $60923e9f3f841413$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $60923e9f3f841413$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1D9S2.getOverflowAncestors)(referenceEl) : [],
        ...(0, $1D9S2.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $60923e9f3f841413$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $60923e9f3f841413$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $60923e9f3f841413$var$getBoundingClientRect(reference);
        if (prevRefRect && !$60923e9f3f841413$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $60923e9f3f841413$export$37b6bde19b108ecc = (0, $E7rjD.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $60923e9f3f841413$export$cc800923e997bb8 = (0, $E7rjD.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $60923e9f3f841413$export$91fb6ecbd551914 = (0, $E7rjD.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $60923e9f3f841413$export$fba63a578e423eb = (0, $E7rjD.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $60923e9f3f841413$export$8a83211c878a3f1f = (0, $E7rjD.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $60923e9f3f841413$export$346677f925de839c = (0, $E7rjD.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $60923e9f3f841413$export$fe8985bb6374093c = (0, $E7rjD.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $60923e9f3f841413$export$f2120bbfa5450bd2 = (0, $E7rjD.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $60923e9f3f841413$export$18c8ad048e32c7d5 = (0, $E7rjD.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $60923e9f3f841413$export$7bf07e38f3dc4b69 = (0, $E7rjD.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $60923e9f3f841413$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $60923e9f3f841413$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $E7rjD.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("E7rjD", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $078981e2e5df035a$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $078981e2e5df035a$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $078981e2e5df035a$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $078981e2e5df035a$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $078981e2e5df035a$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $078981e2e5df035a$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $078981e2e5df035a$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $078981e2e5df035a$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $078981e2e5df035a$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $078981e2e5df035a$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $078981e2e5df035a$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("Euxde")).rectToClientRect);

var $Euxde = parcelRequire("Euxde");
function $078981e2e5df035a$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $Euxde.getSideAxis)(placement);
    const alignmentAxis = (0, $Euxde.getAlignmentAxis)(placement);
    const alignLength = (0, $Euxde.getAxisLength)(alignmentAxis);
    const side = (0, $Euxde.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $Euxde.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $078981e2e5df035a$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $078981e2e5df035a$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $Euxde.evaluate)(options, state);
    const paddingObject = (0, $Euxde.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $Euxde.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $Euxde.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $078981e2e5df035a$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $Euxde.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $Euxde.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $Euxde.getAlignmentAxis)(placement);
            const length = (0, $Euxde.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $Euxde.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $Euxde.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $Euxde.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $Euxde.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $078981e2e5df035a$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $Euxde.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $Euxde.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $Euxde.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $Euxde.getAlignment)(placement) === alignment || (autoAlignment ? (0, $Euxde.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $078981e2e5df035a$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $Euxde.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $Euxde.placements) ? $078981e2e5df035a$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $Euxde.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $Euxde.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $Euxde.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $Euxde.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $078981e2e5df035a$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $Euxde.getSide)(placement);
            const initialSideAxis = (0, $Euxde.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $Euxde.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $Euxde.getOppositePlacement)(initialPlacement)
            ] : (0, $Euxde.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $Euxde.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $Euxde.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $Euxde.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $078981e2e5df035a$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $078981e2e5df035a$var$isAnySideFullyClipped(overflow) {
    return (0, $Euxde.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $078981e2e5df035a$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $078981e2e5df035a$var$getBoundingRect(rects) {
    const minX = (0, $Euxde.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $Euxde.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $Euxde.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $Euxde.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $078981e2e5df035a$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $Euxde.rectToClientRect)($078981e2e5df035a$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $078981e2e5df035a$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $Euxde.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $078981e2e5df035a$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $Euxde.rectToClientRect)($078981e2e5df035a$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $Euxde.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $Euxde.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $Euxde.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $Euxde.getSide)(placement) === 'left';
                    const maxRight = (0, $Euxde.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $Euxde.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $078981e2e5df035a$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $Euxde.getSide)(placement);
    const alignment = (0, $Euxde.getAlignment)(placement);
    const isVertical = (0, $Euxde.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $Euxde.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $078981e2e5df035a$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $078981e2e5df035a$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $078981e2e5df035a$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $Euxde.getSideAxis)((0, $Euxde.getSide)(placement));
            const mainAxis = (0, $Euxde.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $Euxde.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $Euxde.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $078981e2e5df035a$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $Euxde.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $Euxde.getSideAxis)(placement);
            const mainAxis = (0, $Euxde.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $Euxde.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $Euxde.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $078981e2e5df035a$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $Euxde.evaluate)(options, state);
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $Euxde.getSide)(placement);
            const alignment = (0, $Euxde.getAlignment)(placement);
            const isYAxis = (0, $Euxde.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $Euxde.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $Euxde.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $Euxde.max)(overflow.left, 0);
                const xMax = (0, $Euxde.max)(overflow.right, 0);
                const yMin = (0, $Euxde.max)(overflow.top, 0);
                const yMax = (0, $Euxde.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $Euxde.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $Euxde.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("Euxde", function(module, exports) {

$parcel$export(module.exports, "sides", () => $079b6c18061715d9$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $079b6c18061715d9$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $079b6c18061715d9$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $079b6c18061715d9$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $079b6c18061715d9$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $079b6c18061715d9$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $079b6c18061715d9$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $079b6c18061715d9$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $079b6c18061715d9$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $079b6c18061715d9$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $079b6c18061715d9$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $079b6c18061715d9$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $079b6c18061715d9$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $079b6c18061715d9$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $079b6c18061715d9$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $079b6c18061715d9$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $079b6c18061715d9$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $079b6c18061715d9$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $079b6c18061715d9$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $079b6c18061715d9$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $079b6c18061715d9$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $079b6c18061715d9$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $079b6c18061715d9$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $079b6c18061715d9$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $079b6c18061715d9$export$803cd8101b6c182b = /*#__PURE__*/ $079b6c18061715d9$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[0], side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[1]), []);
const $079b6c18061715d9$export$96ec731ed4dcb222 = Math.min;
const $079b6c18061715d9$export$8960430cfd85939f = Math.max;
const $079b6c18061715d9$export$2077e0241d6afd3c = Math.round;
const $079b6c18061715d9$export$a3fe094919f356fd = Math.floor;
const $079b6c18061715d9$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $079b6c18061715d9$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $079b6c18061715d9$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $079b6c18061715d9$export$7d15b64cf5a3a4c4(start, value, end) {
    return $079b6c18061715d9$export$8960430cfd85939f(start, $079b6c18061715d9$export$96ec731ed4dcb222(value, end));
}
function $079b6c18061715d9$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $079b6c18061715d9$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $079b6c18061715d9$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $079b6c18061715d9$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $079b6c18061715d9$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $079b6c18061715d9$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($079b6c18061715d9$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $079b6c18061715d9$export$2b57e0052a6d6d4c(placement) {
    return $079b6c18061715d9$export$8a000a963141ac32($079b6c18061715d9$export$f28e8f882010718a(placement));
}
function $079b6c18061715d9$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    const alignmentAxis = $079b6c18061715d9$export$2b57e0052a6d6d4c(placement);
    const length = $079b6c18061715d9$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $079b6c18061715d9$export$496432a3699e50b1(placement) {
    const oppositePlacement = $079b6c18061715d9$export$9c5e28bad23365fa(placement);
    return [
        $079b6c18061715d9$export$2b182c584985588b(placement),
        oppositePlacement,
        $079b6c18061715d9$export$2b182c584985588b(oppositePlacement)
    ];
}
function $079b6c18061715d9$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$079b6c18061715d9$var$oppositeAlignmentMap[alignment]);
}
function $079b6c18061715d9$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $079b6c18061715d9$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    let list = $079b6c18061715d9$var$getSideList($079b6c18061715d9$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($079b6c18061715d9$export$2b182c584985588b));
    }
    return list;
}
function $079b6c18061715d9$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$079b6c18061715d9$var$oppositeSideMap[side]);
}
function $079b6c18061715d9$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $079b6c18061715d9$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $079b6c18061715d9$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $079b6c18061715d9$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("1D9S2", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $1301171352b69415$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $1301171352b69415$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $1301171352b69415$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $1301171352b69415$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $1301171352b69415$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $1301171352b69415$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $1301171352b69415$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $1301171352b69415$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $1301171352b69415$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $1301171352b69415$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $1301171352b69415$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $1301171352b69415$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $1301171352b69415$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $1301171352b69415$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $1301171352b69415$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $1301171352b69415$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $1301171352b69415$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $1301171352b69415$export$7bf1f8740e3e34af);
function $1301171352b69415$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $1301171352b69415$export$651544f548703224(node) {
    if ($1301171352b69415$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $1301171352b69415$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $1301171352b69415$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($1301171352b69415$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $1301171352b69415$export$8ee0fc9ee280b4ee(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Node;
}
function $1301171352b69415$export$45a5e7f76e0caa8d(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Element;
}
function $1301171352b69415$export$1b3bfaa9684536aa(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).HTMLElement;
}
function $1301171352b69415$export$af51f0f06c0f328a(value) {
    if (!$1301171352b69415$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $1301171352b69415$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $1301171352b69415$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $1301171352b69415$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($1301171352b69415$export$651544f548703224(element));
}
function $1301171352b69415$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $1301171352b69415$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $1301171352b69415$export$78551043582a6a98();
    const css = $1301171352b69415$export$45a5e7f76e0caa8d(elementOrCss) ? $1301171352b69415$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $1301171352b69415$export$940d8225183e1404(element) {
    let currentNode = $1301171352b69415$export$4e12058fc4d51d56(element);
    while($1301171352b69415$export$1b3bfaa9684536aa(currentNode) && !$1301171352b69415$export$d1162fb0b6d4cd51(currentNode)){
        if ($1301171352b69415$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($1301171352b69415$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $1301171352b69415$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $1301171352b69415$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $1301171352b69415$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($1301171352b69415$export$651544f548703224(node));
}
function $1301171352b69415$export$3735103072e4a80(element) {
    return $1301171352b69415$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $1301171352b69415$export$dc8fc79fa2800137(element) {
    if ($1301171352b69415$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $1301171352b69415$export$4e12058fc4d51d56(node) {
    if ($1301171352b69415$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $1301171352b69415$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $1301171352b69415$export$e495491855dc5418(node);
    return $1301171352b69415$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $1301171352b69415$export$7cd01a57c8ca906c(node) {
    const parentNode = $1301171352b69415$export$4e12058fc4d51d56(node);
    if ($1301171352b69415$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($1301171352b69415$export$1b3bfaa9684536aa(parentNode) && $1301171352b69415$export$989e911fa9af580a(parentNode)) return parentNode;
    return $1301171352b69415$export$7cd01a57c8ca906c(parentNode);
}
function $1301171352b69415$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $1301171352b69415$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $1301171352b69415$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $1301171352b69415$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $1301171352b69415$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $1301171352b69415$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $1301171352b69415$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $1301171352b69415$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("8IaiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $657a6ce5ed908256$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");
var $657a6ce5ed908256$export$2e2bcd8739ae039 = (0, $8NFma.useLayoutEffect);

});


parcelRegister("j3Kiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de02359db43fa8ed$export$2e2bcd8739ae039);
var $de02359db43fa8ed$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $de02359db43fa8ed$var$isEqual(first, second) {
    if (first === second) return true;
    if ($de02359db43fa8ed$var$safeIsNaN(first) && $de02359db43fa8ed$var$safeIsNaN(second)) return true;
    return false;
}
function $de02359db43fa8ed$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$de02359db43fa8ed$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $de02359db43fa8ed$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $de02359db43fa8ed$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("9ECJO", function(module, exports) {

var $4MDU6 = parcelRequire("4MDU6");
function $7075e60b98eebb73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7075e60b98eebb73$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7075e60b98eebb73$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4MDU6(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7075e60b98eebb73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $7075e60b98eebb73$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4MDU6", function(module, exports) {

var $68oWB = parcelRequire("68oWB");
function $37ba99320e233eab$var$_defineProperty(e, r, t) {
    return (r = $68oWB(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $37ba99320e233eab$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("68oWB", function(module, exports) {

var $cJNrf = parcelRequire("cJNrf");
var $4776d6d9c6c13a61$var$_typeof = $cJNrf.default;

var $eE63w = parcelRequire("eE63w");
function $4776d6d9c6c13a61$var$toPropertyKey(t) {
    var i = $eE63w(t, "string");
    return "symbol" == $4776d6d9c6c13a61$var$_typeof(i) ? i : i + "";
}
module.exports = $4776d6d9c6c13a61$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cJNrf", function(module, exports) {
function $9460096fea0e4bc3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9460096fea0e4bc3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9460096fea0e4bc3$var$_typeof(o);
}
module.exports = $9460096fea0e4bc3$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eE63w", function(module, exports) {

var $cJNrf = parcelRequire("cJNrf");
var $aa997fae0d2a4cc6$var$_typeof = $cJNrf.default;
function $aa997fae0d2a4cc6$var$toPrimitive(t, r) {
    if ("object" != $aa997fae0d2a4cc6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $aa997fae0d2a4cc6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $aa997fae0d2a4cc6$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("9gsbX", function(module, exports) {

var $7aIce = parcelRequire("7aIce");

var $iT2rD = parcelRequire("iT2rD");

var $5k3iG = parcelRequire("5k3iG");

var $hiBQt = parcelRequire("hiBQt");
function $6beb79f9435ab463$var$_slicedToArray(r, e) {
    return $7aIce(r) || $iT2rD(r, e) || $5k3iG(r, e) || $hiBQt();
}
module.exports = $6beb79f9435ab463$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7aIce", function(module, exports) {
function $538bc00736e27731$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $538bc00736e27731$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iT2rD", function(module, exports) {
function $dbff428584a951fa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $dbff428584a951fa$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5k3iG", function(module, exports) {

var $OpJR1 = parcelRequire("OpJR1");
function $3e01616426bc0774$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $OpJR1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $OpJR1(r, a) : void 0;
    }
}
module.exports = $3e01616426bc0774$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("OpJR1", function(module, exports) {
function $0978a2c5ded8b830$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $0978a2c5ded8b830$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hiBQt", function(module, exports) {
function $c9817962d0cbc0dc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c9817962d0cbc0dc$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iNvSV", function(module, exports) {

var $6oOAi = parcelRequire("6oOAi");
function $daf589439909d1f5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6oOAi(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $daf589439909d1f5$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6oOAi", function(module, exports) {
function $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iDCuG", function(module, exports) {
function $d919ba9c303fb5f5$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $d919ba9c303fb5f5$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fAqwD", function(module, exports) {

var $68oWB = parcelRequire("68oWB");
function $b58ecb379a8496e7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $68oWB(o.key), o);
    }
}
function $b58ecb379a8496e7$var$_createClass(e, r, t) {
    return r && $b58ecb379a8496e7$var$_defineProperties(e.prototype, r), t && $b58ecb379a8496e7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $b58ecb379a8496e7$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cKEms", function(module, exports) {

var $fVxGC = parcelRequire("fVxGC");
function $948916cc7f48639a$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $fVxGC(t, e);
}
module.exports = $948916cc7f48639a$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fVxGC", function(module, exports) {
function $b9864f4f20cda04e$var$_setPrototypeOf(t, e) {
    return module.exports = $b9864f4f20cda04e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b9864f4f20cda04e$var$_setPrototypeOf(t, e);
}
module.exports = $b9864f4f20cda04e$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jhpb7", function(module, exports) {

var $bTjdP = parcelRequire("bTjdP");

var $isUe0 = parcelRequire("isUe0");

var $jzQX6 = parcelRequire("jzQX6");
function $e09322b8f9d3c262$var$_createSuper(t) {
    var r = $isUe0();
    return function() {
        var e, o = $bTjdP(t);
        if (r) {
            var s = $bTjdP(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $jzQX6(this, e);
    };
}
module.exports = $e09322b8f9d3c262$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bTjdP", function(module, exports) {
function $8a83bddbfdc6d8c7$var$_getPrototypeOf(t) {
    return module.exports = $8a83bddbfdc6d8c7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8a83bddbfdc6d8c7$var$_getPrototypeOf(t);
}
module.exports = $8a83bddbfdc6d8c7$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("isUe0", function(module, exports) {
function $d71674a0e5945da3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $d71674a0e5945da3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $d71674a0e5945da3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jzQX6", function(module, exports) {

var $cJNrf = parcelRequire("cJNrf");
var $e40a5c72d9ff00a8$var$_typeof = $cJNrf.default;

var $iUkBc = parcelRequire("iUkBc");
function $e40a5c72d9ff00a8$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $e40a5c72d9ff00a8$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $iUkBc(t);
}
module.exports = $e40a5c72d9ff00a8$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iUkBc", function(module, exports) {
function $dc3d6f7870c2c0af$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $dc3d6f7870c2c0af$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("2wpc1", function(module, exports) {

var $fVXFf = parcelRequire("fVXFf");

var $aIYBk = parcelRequire("aIYBk");

var $5k3iG = parcelRequire("5k3iG");

var $bq6Z9 = parcelRequire("bq6Z9");
function $1d621cbb896997fc$var$_toConsumableArray(r) {
    return $fVXFf(r) || $aIYBk(r) || $5k3iG(r) || $bq6Z9();
}
module.exports = $1d621cbb896997fc$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fVXFf", function(module, exports) {

var $OpJR1 = parcelRequire("OpJR1");
function $b99a75f99dc08932$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $OpJR1(r);
}
module.exports = $b99a75f99dc08932$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aIYBk", function(module, exports) {
function $7ced058a1d590a3b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $7ced058a1d590a3b$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bq6Z9", function(module, exports) {
function $85078a88a14f50e1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $85078a88a14f50e1$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hsLub", function(module, exports) {
function $cb69e2e2639557e2$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $cb69e2e2639557e2$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gNm81", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a2633057849864$export$2e2bcd8739ae039);

var $lmhZG = parcelRequire("lmhZG");

var $8NFma = parcelRequire("8NFma");

var $iQRYA = parcelRequire("iQRYA");

var $1IdZj = parcelRequire("1IdZj");
"use client";
const $c3a2633057849864$var$Row = /*#__PURE__*/ $8NFma.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $iQRYA.useBootstrapPrefix)(bsPrefix, 'row');
    const breakpoints = (0, $iQRYA.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $iQRYA.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($lmhZG)))(className, decoratedBsPrefix, ...classes)
    });
});
$c3a2633057849864$var$Row.displayName = 'Row';
var $c3a2633057849864$export$2e2bcd8739ae039 = $c3a2633057849864$var$Row;

});

parcelRegister("78jzq", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $5318760779786e26$require$Buffer = $N0o3H.Buffer;
//  Chance.js 1.1.12
//  https://chancejs.com
//  (c) 2013 Victor Quinn
//  Chance may be freely distributed or modified under the MIT license.
(function() {
    // Constants
    var MAX_INT = 9007199254740992;
    var MIN_INT = -MAX_INT;
    var NUMBERS = '0123456789';
    var CHARS_LOWER = 'abcdefghijklmnopqrstuvwxyz';
    var CHARS_UPPER = CHARS_LOWER.toUpperCase();
    var HEX_POOL = NUMBERS + "abcdef";
    // Errors
    function UnsupportedError(message) {
        this.name = 'UnsupportedError';
        this.message = message || 'This feature is not supported on this platform';
    }
    UnsupportedError.prototype = new Error();
    UnsupportedError.prototype.constructor = UnsupportedError;
    // Cached array helpers
    var slice = Array.prototype.slice;
    // Constructor
    function Chance(seed) {
        if (!(this instanceof Chance)) {
            if (!seed) seed = null;
             // handle other non-truthy seeds, as described in issue #322
            return seed === null ? new Chance() : new Chance(seed);
        }
        // if user has provided a function, use that as the generator
        if (typeof seed === 'function') {
            this.random = seed;
            return this;
        }
        if (arguments.length) // set a starting value of zero so we can add to it
        this.seed = 0;
        // otherwise, leave this.seed blank so that MT will receive a blank
        for(var i = 0; i < arguments.length; i++){
            var seedling = 0;
            if (Object.prototype.toString.call(arguments[i]) === '[object String]') for(var j = 0; j < arguments[i].length; j++){
                // create a numeric hash for each argument, add to seedling
                var hash = 0;
                for(var k = 0; k < arguments[i].length; k++)hash = arguments[i].charCodeAt(k) + (hash << 6) + (hash << 16) - hash;
                seedling += hash;
            }
            else seedling = arguments[i];
            this.seed += (arguments.length - i) * seedling;
        }
        // If no generator function was provided, use our MT
        this.mt = this.mersenne_twister(this.seed);
        this.bimd5 = this.blueimp_md5();
        this.random = function() {
            return this.mt.random(this.seed);
        };
        return this;
    }
    Chance.prototype.VERSION = "1.1.12";
    // Random helper functions
    function initOptions(options, defaults) {
        options = options || {};
        if (defaults) {
            for(var i in defaults)if (typeof options[i] === 'undefined') options[i] = defaults[i];
        }
        return options;
    }
    function range(size) {
        return Array.apply(null, Array(size)).map(function(_, i) {
            return i;
        });
    }
    function testRange(test, errorMessage) {
        if (test) throw new RangeError(errorMessage);
    }
    /**
     * Encode the input string with Base64.
     */ var base64 = function() {
        throw new Error('No Base64 encoder available.');
    };
    // Select proper Base64 encoder.
    (function determineBase64Encoder() {
        if (typeof btoa === 'function') base64 = btoa;
        else if (typeof $5318760779786e26$require$Buffer === 'function') base64 = function(input) {
            return new $5318760779786e26$require$Buffer(input).toString('base64');
        };
    })();
    // -- Basics --
    /**
     *  Return a random bool, either true or false
     *
     *  @param {Object} [options={ likelihood: 50 }] alter the likelihood of
     *    receiving a true or false value back.
     *  @throws {RangeError} if the likelihood is out of bounds
     *  @returns {Bool} either true or false
     */ Chance.prototype.bool = function(options) {
        // likelihood of success (true)
        options = initOptions(options, {
            likelihood: 50
        });
        // Note, we could get some minor perf optimizations by checking range
        // prior to initializing defaults, but that makes code a bit messier
        // and the check more complicated as we have to check existence of
        // the object then existence of the key before checking constraints.
        // Since the options initialization should be minor computationally,
        // decision made for code cleanliness intentionally. This is mentioned
        // here as it's the first occurrence, will not be mentioned again.
        testRange(options.likelihood < 0 || options.likelihood > 100, "Chance: Likelihood accepts values from 0 to 100.");
        return this.random() * 100 < options.likelihood;
    };
    Chance.prototype.falsy = function(options) {
        // return a random falsy value
        options = initOptions(options, {
            pool: [
                false,
                null,
                0,
                NaN,
                '',
                undefined
            ]
        });
        var pool = options.pool, index = this.integer({
            min: 0,
            max: pool.length - 1
        }), value = pool[index];
        return value;
    };
    Chance.prototype.animal = function(options) {
        //returns a random animal
        options = initOptions(options);
        if (typeof options.type !== 'undefined') {
            //if user does not put in a valid animal type, user will get an error
            testRange(!this.get("animals")[options.type.toLowerCase()], "Please pick from desert, ocean, grassland, forest, zoo, pets, farm.");
            //if user does put in valid animal type, will return a random animal of that type
            return this.pick(this.get("animals")[options.type.toLowerCase()]);
        }
        //if user does not put in any animal type, will return a random animal regardless
        var animalTypeArray = [
            "desert",
            "forest",
            "ocean",
            "zoo",
            "farm",
            "pet",
            "grassland"
        ];
        return this.pick(this.get("animals")[this.pick(animalTypeArray)]);
    };
    /**
     *  Return a random character.
     *
     *  @param {Object} [options={}] can specify a character pool or alpha,
     *    numeric, symbols and casing (lower or upper)
     *  @returns {String} a single random character
     */ Chance.prototype.character = function(options) {
        options = initOptions(options);
        var symbols = "!@#$%^&*()[]", letters, pool;
        if (options.casing === 'lower') letters = CHARS_LOWER;
        else if (options.casing === 'upper') letters = CHARS_UPPER;
        else letters = CHARS_LOWER + CHARS_UPPER;
        if (options.pool) pool = options.pool;
        else {
            pool = '';
            if (options.alpha) pool += letters;
            if (options.numeric) pool += NUMBERS;
            if (options.symbols) pool += symbols;
            if (!pool) pool = letters + NUMBERS + symbols;
        }
        return pool.charAt(this.natural({
            max: pool.length - 1
        }));
    };
    // Note, wanted to use "float" or "double" but those are both JS reserved words.
    // Note, fixed means N OR LESS digits after the decimal. This because
    // It could be 14.9000 but in JavaScript, when this is cast as a number,
    // the trailing zeroes are dropped. Left to the consumer if trailing zeroes are
    // needed
    /**
     *  Return a random floating point number
     *
     *  @param {Object} [options={}] can specify a fixed precision, min, max
     *  @returns {Number} a single floating point number
     *  @throws {RangeError} Can only specify fixed or precision, not both. Also
     *    min cannot be greater than max
     */ Chance.prototype.floating = function(options) {
        options = initOptions(options, {
            fixed: 4
        });
        testRange(options.fixed && options.precision, "Chance: Cannot specify both fixed and precision.");
        var num;
        var fixed = Math.pow(10, options.fixed);
        var max = MAX_INT / fixed;
        var min = -max;
        testRange(options.min && options.fixed && options.min < min, "Chance: Min specified is out of range with fixed. Min should be, at least, " + min);
        testRange(options.max && options.fixed && options.max > max, "Chance: Max specified is out of range with fixed. Max should be, at most, " + max);
        options = initOptions(options, {
            min: min,
            max: max
        });
        // Todo - Make this work!
        // options.precision = (typeof options.precision !== "undefined") ? options.precision : false;
        num = this.integer({
            min: options.min * fixed,
            max: options.max * fixed
        });
        var num_fixed = (num / fixed).toFixed(options.fixed);
        return parseFloat(num_fixed);
    };
    /**
     *  Return a random integer
     *
     *  NOTE the max and min are INCLUDED in the range. So:
     *  chance.integer({min: 1, max: 3});
     *  would return either 1, 2, or 3.
     *
     *  @param {Object} [options={}] can specify a min and/or max
     *  @returns {Number} a single random integer number
     *  @throws {RangeError} min cannot be greater than max
     */ Chance.prototype.integer = function(options) {
        // 9007199254740992 (2^53) is the max integer number in JavaScript
        // See: http://vq.io/132sa2j
        options = initOptions(options, {
            min: MIN_INT,
            max: MAX_INT
        });
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        return Math.floor(this.random() * (options.max - options.min + 1) + options.min);
    };
    /**
     *  Return a random natural
     *
     *  NOTE the max and min are INCLUDED in the range. So:
     *  chance.natural({min: 1, max: 3});
     *  would return either 1, 2, or 3.
     *
     *  @param {Object} [options={}] can specify a min and/or max or a numerals count.
     *  @returns {Number} a single random integer number
     *  @throws {RangeError} min cannot be greater than max
     */ Chance.prototype.natural = function(options) {
        options = initOptions(options, {
            min: 0,
            max: MAX_INT
        });
        if (typeof options.numerals === 'number') {
            testRange(options.numerals < 1, "Chance: Numerals cannot be less than one.");
            options.min = Math.pow(10, options.numerals - 1);
            options.max = Math.pow(10, options.numerals) - 1;
        }
        testRange(options.min < 0, "Chance: Min cannot be less than zero.");
        if (options.exclude) {
            testRange(!Array.isArray(options.exclude), "Chance: exclude must be an array.");
            for(var exclusionIndex in options.exclude)testRange(!Number.isInteger(options.exclude[exclusionIndex]), "Chance: exclude must be numbers.");
            var random = options.min + this.natural({
                max: options.max - options.min - options.exclude.length
            });
            var sortedExclusions = options.exclude.sort();
            for(var sortedExclusionIndex in sortedExclusions){
                if (random < sortedExclusions[sortedExclusionIndex]) break;
                random++;
            }
            return random;
        }
        return this.integer(options);
    };
    /**
     *  Return a random prime number
     *
     *  NOTE the max and min are INCLUDED in the range.
     *
     *  @param {Object} [options={}] can specify a min and/or max
     *  @returns {Number} a single random prime number
     *  @throws {RangeError} min cannot be greater than max nor negative
     */ Chance.prototype.prime = function(options) {
        options = initOptions(options, {
            min: 0,
            max: 10000
        });
        testRange(options.min < 0, "Chance: Min cannot be less than zero.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        var lastPrime = data.primes[data.primes.length - 1];
        if (options.max > lastPrime) {
            for(var i = lastPrime + 2; i <= options.max; ++i)if (this.is_prime(i)) data.primes.push(i);
        }
        var targetPrimes = data.primes.filter(function(prime) {
            return prime >= options.min && prime <= options.max;
        });
        return this.pick(targetPrimes);
    };
    /**
     * Determine whether a given number is prime or not.
     */ Chance.prototype.is_prime = function(n) {
        if (n % 1 || n < 2) return false;
        if (n % 2 === 0) return n === 2;
        if (n % 3 === 0) return n === 3;
        var m = Math.sqrt(n);
        for(var i = 5; i <= m; i += 6){
            if (n % i === 0 || n % (i + 2) === 0) return false;
        }
        return true;
    };
    /**
     *  Return a random hex number as string
     *
     *  NOTE the max and min are INCLUDED in the range. So:
     *  chance.hex({min: '9', max: 'B'});
     *  would return either '9', 'A' or 'B'.
     *
     *  @param {Object} [options={}] can specify a min and/or max and/or casing
     *  @returns {String} a single random string hex number
     *  @throws {RangeError} min cannot be greater than max
     */ Chance.prototype.hex = function(options) {
        options = initOptions(options, {
            min: 0,
            max: MAX_INT,
            casing: 'lower'
        });
        testRange(options.min < 0, "Chance: Min cannot be less than zero.");
        var integer = this.natural({
            min: options.min,
            max: options.max
        });
        if (options.casing === 'upper') return integer.toString(16).toUpperCase();
        return integer.toString(16);
    };
    Chance.prototype.letter = function(options) {
        options = initOptions(options, {
            casing: 'lower'
        });
        var pool = "abcdefghijklmnopqrstuvwxyz";
        var letter = this.character({
            pool: pool
        });
        if (options.casing === 'upper') letter = letter.toUpperCase();
        return letter;
    };
    /**
     *  Return a random string
     *
     *  @param {Object} [options={}] can specify a length or min and max
     *  @returns {String} a string of random length
     *  @throws {RangeError} length cannot be less than zero
     */ Chance.prototype.string = function(options) {
        options = initOptions(options, {
            min: 5,
            max: 20
        });
        if (options.length !== 0 && !options.length) options.length = this.natural({
            min: options.min,
            max: options.max
        });
        testRange(options.length < 0, "Chance: Length cannot be less than zero.");
        var length = options.length, text = this.n(this.character, length, options);
        return text.join("");
    };
    function CopyToken(c) {
        this.c = c;
    }
    CopyToken.prototype = {
        substitute: function() {
            return this.c;
        }
    };
    function EscapeToken(c) {
        this.c = c;
    }
    EscapeToken.prototype = {
        substitute: function() {
            if (!/[{}\\]/.test(this.c)) throw new Error('Invalid escape sequence: "\\' + this.c + '".');
            return this.c;
        }
    };
    function ReplaceToken(c) {
        this.c = c;
    }
    ReplaceToken.prototype = {
        replacers: {
            '#': function(chance1) {
                return chance1.character({
                    pool: NUMBERS
                });
            },
            'A': function(chance1) {
                return chance1.character({
                    pool: CHARS_UPPER
                });
            },
            'a': function(chance1) {
                return chance1.character({
                    pool: CHARS_LOWER
                });
            }
        },
        substitute: function(chance1) {
            var replacer = this.replacers[this.c];
            if (!replacer) throw new Error('Invalid replacement character: "' + this.c + '".');
            return replacer(chance1);
        }
    };
    function parseTemplate(template) {
        var tokens = [];
        var mode = 'identity';
        for(var i = 0; i < template.length; i++){
            var c = template[i];
            switch(mode){
                case 'escape':
                    tokens.push(new EscapeToken(c));
                    mode = 'identity';
                    break;
                case 'identity':
                    if (c === '{') mode = 'replace';
                    else if (c === '\\') mode = 'escape';
                    else tokens.push(new CopyToken(c));
                    break;
                case 'replace':
                    if (c === '}') mode = 'identity';
                    else tokens.push(new ReplaceToken(c));
                    break;
            }
        }
        return tokens;
    }
    /**
     *  Return a random string matching the given template.
     *
     *  The template consists of any number of "character replacement" and
     *  "character literal" sequences. A "character replacement" sequence
     *  starts with a left brace, has any number of special replacement
     *  characters, and ends with a right brace. A character literal can be any
     *  character except a brace or a backslash. A literal brace or backslash
     *  character can be included in the output by escaping with a backslash.
     *
     *  The following replacement characters can be used in a replacement
     *  sequence:
     *
     *      "#": a random digit
     *      "a": a random lower case letter
     *      "A": a random upper case letter
     *
     *  Example: chance.template('{AA###}-{##}')
     *
     *  @param {String} template string.
     *  @returns {String} a random string matching the template.
     */ Chance.prototype.template = function(template) {
        if (!template) throw new Error('Template string is required');
        var self1 = this;
        return parseTemplate(template).map(function(token) {
            return token.substitute(self1);
        }).join('');
    };
    /**
     *  Return a random buffer
     *
     *  @param {Object} [options={}] can specify a length
     *  @returns {Buffer} a buffer of random length
     *  @throws {RangeError} length cannot be less than zero
     */ Chance.prototype.buffer = function(options) {
        if (typeof $5318760779786e26$require$Buffer === 'undefined') throw new UnsupportedError('Sorry, the buffer() function is not supported on your platform');
        options = initOptions(options, {
            length: this.natural({
                min: 5,
                max: 20
            })
        });
        testRange(options.length < 0, "Chance: Length cannot be less than zero.");
        var length = options.length;
        var content = this.n(this.character, length, options);
        return $5318760779786e26$require$Buffer.from(content);
    };
    // -- End Basics --
    // -- Helpers --
    Chance.prototype.capitalize = function(word) {
        return word.charAt(0).toUpperCase() + word.substr(1);
    };
    Chance.prototype.mixin = function(obj) {
        for(var func_name in obj)this[func_name] = obj[func_name];
        return this;
    };
    /**
     *  Given a function that generates something random and a number of items to generate,
     *    return an array of items where none repeat.
     *
     *  @param {Function} fn the function that generates something random
     *  @param {Number} num number of terms to generate
     *  @param {Object} options any options to pass on to the generator function
     *  @returns {Array} an array of length `num` with every item generated by `fn` and unique
     *
     *  There can be more parameters after these. All additional parameters are provided to the given function
     */ Chance.prototype.unique = function(fn, num, options) {
        testRange(typeof fn !== "function", "Chance: The first argument must be a function.");
        var comparator = function(arr, val) {
            return arr.indexOf(val) !== -1;
        };
        if (options) comparator = options.comparator || comparator;
        var arr = [], count = 0, result, MAX_DUPLICATES = num * 50, params = slice.call(arguments, 2);
        while(arr.length < num){
            var clonedParams = JSON.parse(JSON.stringify(params));
            result = fn.apply(this, clonedParams);
            if (!comparator(arr, result)) {
                arr.push(result);
                // reset count when unique found
                count = 0;
            }
            if (++count > MAX_DUPLICATES) throw new RangeError("Chance: num is likely too large for sample set");
        }
        return arr;
    };
    /**
     *  Gives an array of n random terms
     *
     *  @param {Function} fn the function that generates something random
     *  @param {Number} n number of terms to generate
     *  @returns {Array} an array of length `n` with items generated by `fn`
     *
     *  There can be more parameters after these. All additional parameters are provided to the given function
     */ Chance.prototype.n = function(fn, n) {
        testRange(typeof fn !== "function", "Chance: The first argument must be a function.");
        if (typeof n === 'undefined') n = 1;
        var i = n, arr = [], params = slice.call(arguments, 2);
        // Providing a negative count should result in a noop.
        i = Math.max(0, i);
        for(; i--;)arr.push(fn.apply(this, params));
        return arr;
    };
    // H/T to SO for this one: http://vq.io/OtUrZ5
    Chance.prototype.pad = function(number, width, pad) {
        // Default pad to 0 if none provided
        pad = pad || '0';
        // Convert number to a string
        number = number + '';
        return number.length >= width ? number : new Array(width - number.length + 1).join(pad) + number;
    };
    // DEPRECATED on 2015-10-01
    Chance.prototype.pick = function(arr, count) {
        if (arr.length === 0) throw new RangeError("Chance: Cannot pick() from an empty array");
        if (!count || count === 1) return arr[this.natural({
            max: arr.length - 1
        })];
        else return this.shuffle(arr).slice(0, count);
    };
    // Given an array, returns a single random element
    Chance.prototype.pickone = function(arr) {
        if (arr.length === 0) throw new RangeError("Chance: Cannot pickone() from an empty array");
        return arr[this.natural({
            max: arr.length - 1
        })];
    };
    // Given an array, returns a random set with 'count' elements
    Chance.prototype.pickset = function(arr, count) {
        if (count === 0) return [];
        if (arr.length === 0) throw new RangeError("Chance: Cannot pickset() from an empty array");
        if (count < 0) throw new RangeError("Chance: Count must be a positive number");
        if (!count || count === 1) return [
            this.pickone(arr)
        ];
        else {
            var array = arr.slice(0);
            var end = array.length;
            return this.n(function() {
                var index = this.natural({
                    max: --end
                });
                var value = array[index];
                array[index] = array[end];
                return value;
            }, Math.min(end, count));
        }
    };
    Chance.prototype.shuffle = function(arr) {
        var new_array = [], j = 0, length = Number(arr.length), source_indexes = range(length), last_source_index = length - 1, selected_source_index;
        for(var i = 0; i < length; i++){
            // Pick a random index from the array
            selected_source_index = this.natural({
                max: last_source_index
            });
            j = source_indexes[selected_source_index];
            // Add it to the new array
            new_array[i] = arr[j];
            // Mark the source index as used
            source_indexes[selected_source_index] = source_indexes[last_source_index];
            last_source_index -= 1;
        }
        return new_array;
    };
    // Returns a single item from an array with relative weighting of odds
    Chance.prototype.weighted = function(arr, weights, trim) {
        if (arr.length !== weights.length) throw new RangeError("Chance: Length of array and weights must match");
        // scan weights array and sum valid entries
        var sum = 0;
        var val;
        for(var weightIndex = 0; weightIndex < weights.length; ++weightIndex){
            val = weights[weightIndex];
            if (isNaN(val)) throw new RangeError("Chance: All weights must be numbers");
            if (val > 0) sum += val;
        }
        if (sum === 0) throw new RangeError("Chance: No valid entries in array weights");
        // select a value within range
        var selected = this.random() * sum;
        // find array entry corresponding to selected value
        var total = 0;
        var lastGoodIdx = -1;
        var chosenIdx;
        for(weightIndex = 0; weightIndex < weights.length; ++weightIndex){
            val = weights[weightIndex];
            total += val;
            if (val > 0) {
                if (selected <= total) {
                    chosenIdx = weightIndex;
                    break;
                }
                lastGoodIdx = weightIndex;
            }
            // handle any possible rounding error comparison to ensure something is picked
            if (weightIndex === weights.length - 1) chosenIdx = lastGoodIdx;
        }
        var chosen = arr[chosenIdx];
        trim = typeof trim === 'undefined' ? false : trim;
        if (trim) {
            arr.splice(chosenIdx, 1);
            weights.splice(chosenIdx, 1);
        }
        return chosen;
    };
    // -- End Helpers --
    // -- Text --
    Chance.prototype.paragraph = function(options) {
        options = initOptions(options);
        var sentences = options.sentences || this.natural({
            min: 3,
            max: 7
        }), sentence_array = this.n(this.sentence, sentences), separator = options.linebreak === true ? '\n' : ' ';
        return sentence_array.join(separator);
    };
    // Could get smarter about this than generating random words and
    // chaining them together. Such as: http://vq.io/1a5ceOh
    Chance.prototype.sentence = function(options) {
        options = initOptions(options);
        var words = options.words || this.natural({
            min: 12,
            max: 18
        }), punctuation = options.punctuation, text, word_array = this.n(this.word, words);
        text = word_array.join(' ');
        // Capitalize first letter of sentence
        text = this.capitalize(text);
        // Make sure punctuation has a usable value
        if (punctuation !== false && !/^[.?;!:]$/.test(punctuation)) punctuation = '.';
        // Add punctuation mark
        if (punctuation) text += punctuation;
        return text;
    };
    Chance.prototype.syllable = function(options) {
        options = initOptions(options);
        var length = options.length || this.natural({
            min: 2,
            max: 3
        }), consonants = 'bcdfghjklmnprstvwz', vowels = 'aeiou', all = consonants + vowels, text = '', chr;
        // I'm sure there's a more elegant way to do this, but this works
        // decently well.
        for(var i = 0; i < length; i++){
            if (i === 0) // First character can be anything
            chr = this.character({
                pool: all
            });
            else if (consonants.indexOf(chr) === -1) // Last character was a vowel, now we want a consonant
            chr = this.character({
                pool: consonants
            });
            else // Last character was a consonant, now we want a vowel
            chr = this.character({
                pool: vowels
            });
            text += chr;
        }
        if (options.capitalize) text = this.capitalize(text);
        return text;
    };
    Chance.prototype.word = function(options) {
        options = initOptions(options);
        testRange(options.syllables && options.length, "Chance: Cannot specify both syllables AND length.");
        var syllables = options.syllables || this.natural({
            min: 1,
            max: 3
        }), text = '';
        if (options.length) {
            // Either bound word by length
            do text += this.syllable();
            while (text.length < options.length);
            text = text.substring(0, options.length);
        } else // Or by number of syllables
        for(var i = 0; i < syllables; i++)text += this.syllable();
        if (options.capitalize) text = this.capitalize(text);
        return text;
    };
    Chance.prototype.emoji = function(options) {
        options = initOptions(options, {
            category: "all",
            length: 1
        });
        testRange(options.length < 1 || BigInt(options.length) > BigInt(MAX_INT), "Chance: length must be between 1 and " + String(MAX_INT));
        var emojis = this.get("emojis");
        if (options.category === "all") options.category = this.pickone(Object.keys(emojis));
        var emojisForCategory = emojis[options.category];
        testRange(emojisForCategory === undefined, "Chance: Unrecognised emoji category: [" + options.category + "].");
        return this.pickset(emojisForCategory, options.length).map(function(codePoint) {
            return String.fromCodePoint(codePoint);
        }).join("");
    };
    // -- End Text --
    // -- Person --
    Chance.prototype.age = function(options) {
        options = initOptions(options);
        var ageRange;
        switch(options.type){
            case 'child':
                ageRange = {
                    min: 0,
                    max: 12
                };
                break;
            case 'teen':
                ageRange = {
                    min: 13,
                    max: 19
                };
                break;
            case 'adult':
                ageRange = {
                    min: 18,
                    max: 65
                };
                break;
            case 'senior':
                ageRange = {
                    min: 65,
                    max: 100
                };
                break;
            case 'all':
                ageRange = {
                    min: 0,
                    max: 100
                };
                break;
            default:
                ageRange = {
                    min: 18,
                    max: 65
                };
                break;
        }
        return this.natural(ageRange);
    };
    Chance.prototype.birthday = function(options) {
        var age = this.age(options);
        var now = new Date();
        var currentYear = now.getFullYear();
        if (options && options.type) {
            var min = new Date();
            var max = new Date();
            min.setFullYear(currentYear - age - 1);
            max.setFullYear(currentYear - age);
            options = initOptions(options, {
                min: min,
                max: max
            });
        } else if (options && (options.minAge !== undefined || options.maxAge !== undefined)) {
            testRange(options.minAge < 0, "Chance: MinAge cannot be less than zero.");
            testRange(options.minAge > options.maxAge, "Chance: MinAge cannot be greater than MaxAge.");
            var minAge = options.minAge !== undefined ? options.minAge : 0;
            var maxAge = options.maxAge !== undefined ? options.maxAge : 100;
            var minDate = new Date(currentYear - maxAge - 1, now.getMonth(), now.getDate());
            var maxDate = new Date(currentYear - minAge, now.getMonth(), now.getDate());
            minDate.setDate(minDate.getDate() + 1);
            maxDate.setDate(maxDate.getDate() + 1);
            maxDate.setMilliseconds(maxDate.getMilliseconds() - 1);
            options = initOptions(options, {
                min: minDate,
                max: maxDate
            });
        } else options = initOptions(options, {
            year: currentYear - age
        });
        return this.date(options);
    };
    // CPF; ID to identify taxpayers in Brazil
    Chance.prototype.cpf = function(options) {
        options = initOptions(options, {
            formatted: true
        });
        var n = this.n(this.natural, 9, {
            max: 9
        });
        var d1 = n[8] * 2 + n[7] * 3 + n[6] * 4 + n[5] * 5 + n[4] * 6 + n[3] * 7 + n[2] * 8 + n[1] * 9 + n[0] * 10;
        d1 = 11 - d1 % 11;
        if (d1 >= 10) d1 = 0;
        var d2 = d1 * 2 + n[8] * 3 + n[7] * 4 + n[6] * 5 + n[5] * 6 + n[4] * 7 + n[3] * 8 + n[2] * 9 + n[1] * 10 + n[0] * 11;
        d2 = 11 - d2 % 11;
        if (d2 >= 10) d2 = 0;
        var cpf = '' + n[0] + n[1] + n[2] + '.' + n[3] + n[4] + n[5] + '.' + n[6] + n[7] + n[8] + '-' + d1 + d2;
        return options.formatted ? cpf : cpf.replace(/\D/g, '');
    };
    // CNPJ: ID to identify companies in Brazil
    Chance.prototype.cnpj = function(options) {
        options = initOptions(options, {
            formatted: true
        });
        var n = this.n(this.natural, 12, {
            max: 12
        });
        var d1 = n[11] * 2 + n[10] * 3 + n[9] * 4 + n[8] * 5 + n[7] * 6 + n[6] * 7 + n[5] * 8 + n[4] * 9 + n[3] * 2 + n[2] * 3 + n[1] * 4 + n[0] * 5;
        d1 = 11 - d1 % 11;
        if (d1 < 2) d1 = 0;
        var d2 = d1 * 2 + n[11] * 3 + n[10] * 4 + n[9] * 5 + n[8] * 6 + n[7] * 7 + n[6] * 8 + n[5] * 9 + n[4] * 2 + n[3] * 3 + n[2] * 4 + n[1] * 5 + n[0] * 6;
        d2 = 11 - d2 % 11;
        if (d2 < 2) d2 = 0;
        var cnpj = '' + n[0] + n[1] + '.' + n[2] + n[3] + n[4] + '.' + n[5] + n[6] + n[7] + '/' + n[8] + n[9] + n[10] + n[11] + '-' + d1 + d2;
        return options.formatted ? cnpj : cnpj.replace(/\D/g, '');
    };
    Chance.prototype.first = function(options) {
        options = initOptions(options, {
            gender: this.gender(),
            nationality: 'en'
        });
        return this.pick(this.get("firstNames")[options.gender.toLowerCase()][options.nationality.toLowerCase()]);
    };
    Chance.prototype.profession = function(options) {
        options = initOptions(options);
        if (options.rank) return this.pick([
            'Apprentice ',
            'Junior ',
            'Senior ',
            'Lead '
        ]) + this.pick(this.get("profession"));
        else return this.pick(this.get("profession"));
    };
    Chance.prototype.company = function() {
        return this.pick(this.get("company"));
    };
    Chance.prototype.gender = function(options) {
        options = initOptions(options, {
            extraGenders: []
        });
        return this.pick([
            'Male',
            'Female'
        ].concat(options.extraGenders));
    };
    Chance.prototype.last = function(options) {
        options = initOptions(options, {
            nationality: '*'
        });
        if (options.nationality === "*") {
            var allLastNames = [];
            var lastNames = this.get("lastNames");
            Object.keys(lastNames).forEach(function(key) {
                allLastNames = allLastNames.concat(lastNames[key]);
            });
            return this.pick(allLastNames);
        } else return this.pick(this.get("lastNames")[options.nationality.toLowerCase()]);
    };
    Chance.prototype.israelId = function() {
        var x = this.string({
            pool: '0123456789',
            length: 8
        });
        var y = 0;
        for(var i = 0; i < x.length; i++){
            var thisDigit = x[i] * (i / 2 === parseInt(i / 2) ? 1 : 2);
            thisDigit = this.pad(thisDigit, 2).toString();
            thisDigit = parseInt(thisDigit[0]) + parseInt(thisDigit[1]);
            y = y + thisDigit;
        }
        x = x + (10 - parseInt(y.toString().slice(-1))).toString().slice(-1);
        return x;
    };
    Chance.prototype.mrz = function(options) {
        var checkDigit = function(input) {
            var alpha = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(''), multipliers = [
                7,
                3,
                1
            ], runningTotal = 0;
            if (typeof input !== 'string') input = input.toString();
            input.split('').forEach(function(character, idx) {
                var pos = alpha.indexOf(character);
                if (pos !== -1) character = pos === 0 ? 0 : pos + 9;
                else character = parseInt(character, 10);
                character *= multipliers[idx % multipliers.length];
                runningTotal += character;
            });
            return runningTotal % 10;
        };
        var generate = function(opts) {
            var pad = function(length) {
                return new Array(length + 1).join('<');
            };
            var number = [
                'P<',
                opts.issuer,
                opts.last.toUpperCase(),
                '<<',
                opts.first.toUpperCase(),
                pad(39 - (opts.last.length + opts.first.length + 2)),
                opts.passportNumber,
                checkDigit(opts.passportNumber),
                opts.nationality,
                opts.dob,
                checkDigit(opts.dob),
                opts.gender,
                opts.expiry,
                checkDigit(opts.expiry),
                pad(14),
                checkDigit(pad(14))
            ].join('');
            return number + checkDigit(number.substr(44, 10) + number.substr(57, 7) + number.substr(65, 7));
        };
        var that = this;
        options = initOptions(options, {
            first: this.first(),
            last: this.last(),
            passportNumber: this.integer({
                min: 100000000,
                max: 999999999
            }),
            dob: function() {
                var date = that.birthday({
                    type: 'adult'
                });
                return [
                    date.getFullYear().toString().substr(2),
                    that.pad(date.getMonth() + 1, 2),
                    that.pad(date.getDate(), 2)
                ].join('');
            }(),
            expiry: function() {
                var date = new Date();
                return [
                    (date.getFullYear() + 5).toString().substr(2),
                    that.pad(date.getMonth() + 1, 2),
                    that.pad(date.getDate(), 2)
                ].join('');
            }(),
            gender: this.gender() === 'Female' ? 'F' : 'M',
            issuer: 'GBR',
            nationality: 'GBR'
        });
        return generate(options);
    };
    Chance.prototype.name = function(options) {
        options = initOptions(options);
        var first = this.first(options), last = this.last(options), name;
        if (options.middle) name = first + ' ' + this.first(options) + ' ' + last;
        else if (options.middle_initial) name = first + ' ' + this.character({
            alpha: true,
            casing: 'upper'
        }) + '. ' + last;
        else name = first + ' ' + last;
        if (options.prefix) name = this.prefix(options) + ' ' + name;
        if (options.suffix) name = name + ' ' + this.suffix(options);
        return name;
    };
    // Return the list of available name prefixes based on supplied gender.
    // @todo introduce internationalization
    Chance.prototype.name_prefixes = function(gender) {
        gender = gender || "all";
        gender = gender.toLowerCase();
        var prefixes = [
            {
                name: 'Doctor',
                abbreviation: 'Dr.'
            }
        ];
        if (gender === "male" || gender === "all") prefixes.push({
            name: 'Mister',
            abbreviation: 'Mr.'
        });
        if (gender === "female" || gender === "all") {
            prefixes.push({
                name: 'Miss',
                abbreviation: 'Miss'
            });
            prefixes.push({
                name: 'Misses',
                abbreviation: 'Mrs.'
            });
        }
        return prefixes;
    };
    // Alias for name_prefix
    Chance.prototype.prefix = function(options) {
        return this.name_prefix(options);
    };
    Chance.prototype.name_prefix = function(options) {
        options = initOptions(options, {
            gender: "all"
        });
        return options.full ? this.pick(this.name_prefixes(options.gender)).name : this.pick(this.name_prefixes(options.gender)).abbreviation;
    };
    //Hungarian ID number
    Chance.prototype.HIDN = function() {
        //Hungarian ID nuber structure: XXXXXXYY (X=number,Y=Capital Latin letter)
        var idn_pool = "0123456789";
        var idn_chrs = "ABCDEFGHIJKLMNOPQRSTUVWXYXZ";
        var idn = "";
        idn += this.string({
            pool: idn_pool,
            length: 6
        });
        idn += this.string({
            pool: idn_chrs,
            length: 2
        });
        return idn;
    };
    Chance.prototype.ssn = function(options) {
        options = initOptions(options, {
            ssnFour: false,
            dashes: true
        });
        var ssn_pool = "1234567890", ssn, dash = options.dashes ? '-' : '';
        if (!options.ssnFour) ssn = this.string({
            pool: ssn_pool,
            length: 3
        }) + dash + this.string({
            pool: ssn_pool,
            length: 2
        }) + dash + this.string({
            pool: ssn_pool,
            length: 4
        });
        else ssn = this.string({
            pool: ssn_pool,
            length: 4
        });
        return ssn;
    };
    // Aadhar is similar to ssn, used in India to uniquely identify a person
    Chance.prototype.aadhar = function(options) {
        options = initOptions(options, {
            onlyLastFour: false,
            separatedByWhiteSpace: true
        });
        var aadhar_pool = "1234567890", aadhar, whiteSpace = options.separatedByWhiteSpace ? ' ' : '';
        if (!options.onlyLastFour) aadhar = this.string({
            pool: aadhar_pool,
            length: 4
        }) + whiteSpace + this.string({
            pool: aadhar_pool,
            length: 4
        }) + whiteSpace + this.string({
            pool: aadhar_pool,
            length: 4
        });
        else aadhar = this.string({
            pool: aadhar_pool,
            length: 4
        });
        return aadhar;
    };
    // Return the list of available name suffixes
    // @todo introduce internationalization
    Chance.prototype.name_suffixes = function() {
        var suffixes = [
            {
                name: 'Doctor of Osteopathic Medicine',
                abbreviation: 'D.O.'
            },
            {
                name: 'Doctor of Philosophy',
                abbreviation: 'Ph.D.'
            },
            {
                name: 'Esquire',
                abbreviation: 'Esq.'
            },
            {
                name: 'Junior',
                abbreviation: 'Jr.'
            },
            {
                name: 'Juris Doctor',
                abbreviation: 'J.D.'
            },
            {
                name: 'Master of Arts',
                abbreviation: 'M.A.'
            },
            {
                name: 'Master of Business Administration',
                abbreviation: 'M.B.A.'
            },
            {
                name: 'Master of Science',
                abbreviation: 'M.S.'
            },
            {
                name: 'Medical Doctor',
                abbreviation: 'M.D.'
            },
            {
                name: 'Senior',
                abbreviation: 'Sr.'
            },
            {
                name: 'The Third',
                abbreviation: 'III'
            },
            {
                name: 'The Fourth',
                abbreviation: 'IV'
            },
            {
                name: 'Bachelor of Engineering',
                abbreviation: 'B.E'
            },
            {
                name: 'Bachelor of Technology',
                abbreviation: 'B.TECH'
            }
        ];
        return suffixes;
    };
    // Alias for name_suffix
    Chance.prototype.suffix = function(options) {
        return this.name_suffix(options);
    };
    Chance.prototype.name_suffix = function(options) {
        options = initOptions(options);
        return options.full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
    };
    Chance.prototype.nationalities = function() {
        return this.get("nationalities");
    };
    // Generate random nationality based on json list
    Chance.prototype.nationality = function() {
        var nationality = this.pick(this.nationalities());
        return nationality.name;
    };
    // Generate random zodiac sign
    Chance.prototype.zodiac = function() {
        const zodiacSymbols = [
            "Aries",
            "Taurus",
            "Gemini",
            "Cancer",
            "Leo",
            "Virgo",
            "Libra",
            "Scorpio",
            "Sagittarius",
            "Capricorn",
            "Aquarius",
            "Pisces"
        ];
        return this.pickone(zodiacSymbols);
    };
    // -- End Person --
    // -- Mobile --
    // Android GCM Registration ID
    Chance.prototype.android_id = function() {
        return "APA91" + this.string({
            pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_",
            length: 178
        });
    };
    // Apple Push Token
    Chance.prototype.apple_token = function() {
        return this.string({
            pool: "abcdef1234567890",
            length: 64
        });
    };
    // Windows Phone 8 ANID2
    Chance.prototype.wp8_anid2 = function() {
        return base64(this.hash({
            length: 32
        }));
    };
    // Windows Phone 7 ANID
    Chance.prototype.wp7_anid = function() {
        return 'A=' + this.guid().replace(/-/g, '').toUpperCase() + '&E=' + this.hash({
            length: 3
        }) + '&W=' + this.integer({
            min: 0,
            max: 9
        });
    };
    // BlackBerry Device PIN
    Chance.prototype.bb_pin = function() {
        return this.hash({
            length: 8
        });
    };
    // -- End Mobile --
    // -- Web --
    Chance.prototype.avatar = function(options) {
        var url = null;
        var URL_BASE = '//www.gravatar.com/avatar/';
        var PROTOCOLS = {
            http: 'http',
            https: 'https'
        };
        var FILE_TYPES = {
            bmp: 'bmp',
            gif: 'gif',
            jpg: 'jpg',
            png: 'png'
        };
        var FALLBACKS = {
            '404': '404',
            mm: 'mm',
            identicon: 'identicon',
            monsterid: 'monsterid',
            wavatar: 'wavatar',
            retro: 'retro',
            blank: 'blank' // A transparent png
        };
        var RATINGS = {
            g: 'g',
            pg: 'pg',
            r: 'r',
            x: 'x'
        };
        var opts = {
            protocol: null,
            email: null,
            fileExtension: null,
            size: null,
            fallback: null,
            rating: null
        };
        if (!options) {
            // Set to a random email
            opts.email = this.email();
            options = {};
        } else if (typeof options === 'string') {
            opts.email = options;
            options = {};
        } else if (typeof options !== 'object') return null;
        else if (options.constructor === 'Array') return null;
        opts = initOptions(options, opts);
        if (!opts.email) // Set to a random email
        opts.email = this.email();
        // Safe checking for params
        opts.protocol = PROTOCOLS[opts.protocol] ? opts.protocol + ':' : '';
        opts.size = parseInt(opts.size, 0) ? opts.size : '';
        opts.rating = RATINGS[opts.rating] ? opts.rating : '';
        opts.fallback = FALLBACKS[opts.fallback] ? opts.fallback : '';
        opts.fileExtension = FILE_TYPES[opts.fileExtension] ? opts.fileExtension : '';
        url = opts.protocol + URL_BASE + this.bimd5.md5(opts.email) + (opts.fileExtension ? '.' + opts.fileExtension : '') + (opts.size || opts.rating || opts.fallback ? '?' : '') + (opts.size ? '&s=' + opts.size.toString() : '') + (opts.rating ? '&r=' + opts.rating : '') + (opts.fallback ? '&d=' + opts.fallback : '');
        return url;
    };
    /**
     * #Description:
     * ===============================================
     * Generate random color value base on color type:
     * -> hex
     * -> rgb
     * -> rgba
     * -> 0x
     * -> named color
     *
     * #Examples:
     * ===============================================
     * * Geerate random hex color
     * chance.color() => '#79c157' / 'rgb(110,52,164)' / '0x67ae0b' / '#e2e2e2' / '#29CFA7'
     *
     * * Generate Hex based color value
     * chance.color({format: 'hex'})    => '#d67118'
     *
     * * Generate simple rgb value
     * chance.color({format: 'rgb'})    => 'rgb(110,52,164)'
     *
     * * Generate Ox based color value
     * chance.color({format: '0x'})     => '0x67ae0b'
     *
     * * Generate graiscale based value
     * chance.color({grayscale: true})  => '#e2e2e2'
     *
     * * Return valide color name
     * chance.color({format: 'name'})   => 'red'
     *
     * * Make color uppercase
     * chance.color({casing: 'upper'})  => '#29CFA7'
     *
     * * Min Max values for RGBA
     * var light_red = chance.color({format: 'hex', min_red: 200, max_red: 255, max_green: 0, max_blue: 0, min_alpha: .2, max_alpha: .3});
     *
     * @param  [object] options
     * @return [string] color value
     */ Chance.prototype.color = function(options) {
        function gray(value, delimiter) {
            return [
                value,
                value,
                value
            ].join(delimiter || '');
        }
        function rgb(hasAlpha) {
            var rgbValue = hasAlpha ? 'rgba' : 'rgb';
            var alphaChannel = hasAlpha ? ',' + this.floating({
                min: min_alpha,
                max: max_alpha
            }) : "";
            var colorValue = isGrayscale ? gray(this.natural({
                min: min_rgb,
                max: max_rgb
            }), ',') : this.natural({
                min: min_green,
                max: max_green
            }) + ',' + this.natural({
                min: min_blue,
                max: max_blue
            }) + ',' + this.natural({
                max: 255
            });
            return rgbValue + '(' + colorValue + alphaChannel + ')';
        }
        function hex(start, end, withHash) {
            var symbol = withHash ? "#" : "";
            var hexstring = "";
            if (isGrayscale) {
                hexstring = gray(this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2));
                if (options.format === "shorthex") hexstring = gray(this.hex({
                    min: 0,
                    max: 15
                }));
            } else {
                if (options.format === "shorthex") hexstring = this.pad(this.hex({
                    min: Math.floor(min_red / 16),
                    max: Math.floor(max_red / 16)
                }), 1) + this.pad(this.hex({
                    min: Math.floor(min_green / 16),
                    max: Math.floor(max_green / 16)
                }), 1) + this.pad(this.hex({
                    min: Math.floor(min_blue / 16),
                    max: Math.floor(max_blue / 16)
                }), 1);
                else if (min_red !== undefined || max_red !== undefined || min_green !== undefined || max_green !== undefined || min_blue !== undefined || max_blue !== undefined) hexstring = this.pad(this.hex({
                    min: min_red,
                    max: max_red
                }), 2) + this.pad(this.hex({
                    min: min_green,
                    max: max_green
                }), 2) + this.pad(this.hex({
                    min: min_blue,
                    max: max_blue
                }), 2);
                else hexstring = this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2) + this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2) + this.pad(this.hex({
                    min: min_rgb,
                    max: max_rgb
                }), 2);
            }
            return symbol + hexstring;
        }
        options = initOptions(options, {
            format: this.pick([
                'hex',
                'shorthex',
                'rgb',
                'rgba',
                '0x',
                'name'
            ]),
            grayscale: false,
            casing: 'lower',
            min: 0,
            max: 255,
            min_red: undefined,
            max_red: undefined,
            min_green: undefined,
            max_green: undefined,
            min_blue: undefined,
            max_blue: undefined,
            min_alpha: 0,
            max_alpha: 1
        });
        var isGrayscale = options.grayscale;
        var min_rgb = options.min;
        var max_rgb = options.max;
        var min_red = options.min_red;
        var max_red = options.max_red;
        var min_green = options.min_green;
        var max_green = options.max_green;
        var min_blue = options.min_blue;
        var max_blue = options.max_blue;
        var min_alpha = options.min_alpha;
        var max_alpha = options.max_alpha;
        if (options.min_red === undefined) min_red = min_rgb;
        if (options.max_red === undefined) max_red = max_rgb;
        if (options.min_green === undefined) min_green = min_rgb;
        if (options.max_green === undefined) max_green = max_rgb;
        if (options.min_blue === undefined) min_blue = min_rgb;
        if (options.max_blue === undefined) max_blue = max_rgb;
        if (options.min_alpha === undefined) min_alpha = 0;
        if (options.max_alpha === undefined) max_alpha = 1;
        if (isGrayscale && min_rgb === 0 && max_rgb === 255 && min_red !== undefined && max_red !== undefined) {
            min_rgb = (min_red + min_green + min_blue) / 3;
            max_rgb = (max_red + max_green + max_blue) / 3;
        }
        var colorValue;
        if (options.format === 'hex') colorValue = hex.call(this, 2, 6, true);
        else if (options.format === 'shorthex') colorValue = hex.call(this, 1, 3, true);
        else if (options.format === 'rgb') colorValue = rgb.call(this, false);
        else if (options.format === 'rgba') colorValue = rgb.call(this, true);
        else if (options.format === '0x') colorValue = '0x' + hex.call(this, 2, 6);
        else if (options.format === 'name') return this.pick(this.get("colorNames"));
        else throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
        if (options.casing === 'upper') colorValue = colorValue.toUpperCase();
        return colorValue;
    };
    Chance.prototype.domain = function(options) {
        options = initOptions(options);
        return this.word() + '.' + (options.tld || this.tld());
    };
    Chance.prototype.email = function(options) {
        options = initOptions(options);
        return this.word({
            length: options.length
        }) + '@' + (options.domain || this.domain());
    };
    /**
     * #Description:
     * ===============================================
     * Generate a random Facebook id, aka fbid.
     *
     * NOTE: At the moment (Sep 2017), Facebook ids are
     * "numeric strings" of length 16.
     * However, Facebook Graph API documentation states that
     * "it is extremely likely to change over time".
     * @see https://developers.facebook.com/docs/graph-api/overview/
     *
     * #Examples:
     * ===============================================
     * chance.fbid() => '1000035231661304'
     *
     * @return [string] facebook id
     */ Chance.prototype.fbid = function() {
        return '10000' + this.string({
            pool: "1234567890",
            length: 11
        });
    };
    Chance.prototype.google_analytics = function() {
        var account = this.pad(this.natural({
            max: 999999
        }), 6);
        var property = this.pad(this.natural({
            max: 99
        }), 2);
        return 'UA-' + account + '-' + property;
    };
    Chance.prototype.hashtag = function() {
        return '#' + this.word();
    };
    Chance.prototype.ip = function() {
        // Todo: This could return some reserved IPs. See http://vq.io/137dgYy
        // this should probably be updated to account for that rare as it may be
        return this.natural({
            min: 1,
            max: 254
        }) + '.' + this.natural({
            max: 255
        }) + '.' + this.natural({
            max: 255
        }) + '.' + this.natural({
            min: 1,
            max: 254
        });
    };
    Chance.prototype.ipv6 = function() {
        var ip_addr = this.n(this.hash, 8, {
            length: 4
        });
        return ip_addr.join(":");
    };
    Chance.prototype.klout = function() {
        return this.natural({
            min: 1,
            max: 99
        });
    };
    Chance.prototype.mac = function(options) {
        // Todo: This could also be extended to EUI-64 based MACs
        // (https://www.iana.org/assignments/ethernet-numbers/ethernet-numbers.xhtml#ethernet-numbers-4)
        // Todo: This can return some reserved MACs (similar to IP function)
        // this should probably be updated to account for that rare as it may be
        options = initOptions(options, {
            delimiter: ':'
        });
        return this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2) + options.delimiter + this.pad(this.natural({
            max: 255
        }).toString(16), 2);
    };
    Chance.prototype.semver = function(options) {
        options = initOptions(options, {
            include_prerelease: true
        });
        var range = this.pickone([
            "^",
            "~",
            "<",
            ">",
            "<=",
            ">=",
            "="
        ]);
        if (options.range) range = options.range;
        var prerelease = "";
        if (options.include_prerelease) prerelease = this.weighted([
            "",
            "-dev",
            "-beta",
            "-alpha"
        ], [
            50,
            10,
            5,
            1
        ]);
        return range + this.rpg('3d10').join('.') + prerelease;
    };
    Chance.prototype.tlds = function() {
        return [
            'com',
            'org',
            'edu',
            'gov',
            'co.uk',
            'net',
            'io',
            'ac',
            'ad',
            'ae',
            'af',
            'ag',
            'ai',
            'al',
            'am',
            'ao',
            'aq',
            'ar',
            'as',
            'at',
            'au',
            'aw',
            'ax',
            'az',
            'ba',
            'bb',
            'bd',
            'be',
            'bf',
            'bg',
            'bh',
            'bi',
            'bj',
            'bm',
            'bn',
            'bo',
            'br',
            'bs',
            'bt',
            'bv',
            'bw',
            'by',
            'bz',
            'ca',
            'cc',
            'cd',
            'cf',
            'cg',
            'ch',
            'ci',
            'ck',
            'cl',
            'cm',
            'cn',
            'co',
            'cr',
            'cu',
            'cv',
            'cw',
            'cx',
            'cy',
            'cz',
            'de',
            'dj',
            'dk',
            'dm',
            'do',
            'dz',
            'ec',
            'ee',
            'eg',
            'eh',
            'er',
            'es',
            'et',
            'eu',
            'fi',
            'fj',
            'fk',
            'fm',
            'fo',
            'fr',
            'ga',
            'gb',
            'gd',
            'ge',
            'gf',
            'gg',
            'gh',
            'gi',
            'gl',
            'gm',
            'gn',
            'gp',
            'gq',
            'gr',
            'gs',
            'gt',
            'gu',
            'gw',
            'gy',
            'hk',
            'hm',
            'hn',
            'hr',
            'ht',
            'hu',
            'id',
            'ie',
            'il',
            'im',
            'in',
            'io',
            'iq',
            'ir',
            'is',
            'it',
            'je',
            'jm',
            'jo',
            'jp',
            'ke',
            'kg',
            'kh',
            'ki',
            'km',
            'kn',
            'kp',
            'kr',
            'kw',
            'ky',
            'kz',
            'la',
            'lb',
            'lc',
            'li',
            'lk',
            'lr',
            'ls',
            'lt',
            'lu',
            'lv',
            'ly',
            'ma',
            'mc',
            'md',
            'me',
            'mg',
            'mh',
            'mk',
            'ml',
            'mm',
            'mn',
            'mo',
            'mp',
            'mq',
            'mr',
            'ms',
            'mt',
            'mu',
            'mv',
            'mw',
            'mx',
            'my',
            'mz',
            'na',
            'nc',
            'ne',
            'nf',
            'ng',
            'ni',
            'nl',
            'no',
            'np',
            'nr',
            'nu',
            'nz',
            'om',
            'pa',
            'pe',
            'pf',
            'pg',
            'ph',
            'pk',
            'pl',
            'pm',
            'pn',
            'pr',
            'ps',
            'pt',
            'pw',
            'py',
            'qa',
            're',
            'ro',
            'rs',
            'ru',
            'rw',
            'sa',
            'sb',
            'sc',
            'sd',
            'se',
            'sg',
            'sh',
            'si',
            'sj',
            'sk',
            'sl',
            'sm',
            'sn',
            'so',
            'sr',
            'ss',
            'st',
            'su',
            'sv',
            'sx',
            'sy',
            'sz',
            'tc',
            'td',
            'tf',
            'tg',
            'th',
            'tj',
            'tk',
            'tl',
            'tm',
            'tn',
            'to',
            'tr',
            'tt',
            'tv',
            'tw',
            'tz',
            'ua',
            'ug',
            'uk',
            'us',
            'uy',
            'uz',
            'va',
            'vc',
            've',
            'vg',
            'vi',
            'vn',
            'vu',
            'wf',
            'ws',
            'ye',
            'yt',
            'za',
            'zm',
            'zw'
        ];
    };
    Chance.prototype.tld = function() {
        return this.pick(this.tlds());
    };
    Chance.prototype.twitter = function() {
        return '@' + this.word();
    };
    Chance.prototype.url = function(options) {
        options = initOptions(options, {
            protocol: "http",
            domain: this.domain(options),
            domain_prefix: "",
            path: this.word(),
            extensions: []
        });
        var extension = options.extensions.length > 0 ? "." + this.pick(options.extensions) : "";
        var domain = options.domain_prefix ? options.domain_prefix + "." + options.domain : options.domain;
        return options.protocol + "://" + domain + "/" + options.path + extension;
    };
    Chance.prototype.port = function() {
        return this.integer({
            min: 0,
            max: 65535
        });
    };
    Chance.prototype.locale = function(options) {
        options = initOptions(options);
        if (options.region) return this.pick(this.get("locale_regions"));
        else return this.pick(this.get("locale_languages"));
    };
    Chance.prototype.locales = function(options) {
        options = initOptions(options);
        if (options.region) return this.get("locale_regions");
        else return this.get("locale_languages");
    };
    Chance.prototype.loremPicsum = function(options) {
        options = initOptions(options, {
            width: 500,
            height: 500,
            greyscale: false,
            blurred: false
        });
        var greyscale = options.greyscale ? 'g/' : '';
        var query = options.blurred ? '/?blur' : '/?random';
        return 'https://picsum.photos/' + greyscale + options.width + '/' + options.height + query;
    };
    // -- End Web --
    // -- Location --
    Chance.prototype.address = function(options) {
        options = initOptions(options);
        return this.natural({
            min: 5,
            max: 2000
        }) + ' ' + this.street(options);
    };
    Chance.prototype.altitude = function(options) {
        options = initOptions(options, {
            fixed: 5,
            min: 0,
            max: 8848
        });
        return this.floating({
            min: options.min,
            max: options.max,
            fixed: options.fixed
        });
    };
    Chance.prototype.areacode = function(options) {
        options = initOptions(options, {
            parens: true
        });
        // Don't want area codes to start with 1, or have a 9 as the second digit
        var areacode = options.exampleNumber ? "555" : this.natural({
            min: 2,
            max: 9
        }).toString() + this.natural({
            min: 0,
            max: 8
        }).toString() + this.natural({
            min: 0,
            max: 9
        }).toString();
        return options.parens ? '(' + areacode + ')' : areacode;
    };
    Chance.prototype.city = function() {
        return this.capitalize(this.word({
            syllables: 3
        }));
    };
    Chance.prototype.coordinates = function(options) {
        return this.latitude(options) + ', ' + this.longitude(options);
    };
    Chance.prototype.countries = function() {
        return this.get("countries");
    };
    Chance.prototype.country = function(options) {
        options = initOptions(options);
        var country = this.pick(this.countries());
        return options.raw ? country : options.full ? country.name : country.abbreviation;
    };
    Chance.prototype.depth = function(options) {
        options = initOptions(options, {
            fixed: 5,
            min: -10994,
            max: 0
        });
        return this.floating({
            min: options.min,
            max: options.max,
            fixed: options.fixed
        });
    };
    Chance.prototype.geohash = function(options) {
        options = initOptions(options, {
            length: 7
        });
        return this.string({
            length: options.length,
            pool: '0123456789bcdefghjkmnpqrstuvwxyz'
        });
    };
    Chance.prototype.geojson = function(options) {
        return this.latitude(options) + ', ' + this.longitude(options) + ', ' + this.altitude(options);
    };
    Chance.prototype.latitude = function(options) {
        // Constants - Formats
        var [DDM, DMS, DD] = [
            'ddm',
            'dms',
            'dd'
        ];
        options = initOptions(options, options && options.format && [
            DDM,
            DMS
        ].includes(options.format.toLowerCase()) ? {
            min: 0,
            max: 89,
            fixed: 4
        } : {
            fixed: 5,
            min: -90,
            max: 90,
            format: DD
        });
        var format = options.format.toLowerCase();
        if (format === DDM || format === DMS) {
            testRange(options.min < 0 || options.min > 89, "Chance: Min specified is out of range. Should be between 0 - 89");
            testRange(options.max < 0 || options.max > 89, "Chance: Max specified is out of range. Should be between 0 - 89");
            testRange(options.fixed > 4, 'Chance: Fixed specified should be below or equal to 4');
        }
        switch(format){
            case DDM:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.floating({
                    min: 0,
                    max: 59,
                    fixed: options.fixed
                });
            case DMS:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.integer({
                    min: 0,
                    max: 59
                }) + "\u2019" + this.floating({
                    min: 0,
                    max: 59,
                    fixed: options.fixed
                }) + "\u201D";
            case DD:
            default:
                return this.floating({
                    min: options.min,
                    max: options.max,
                    fixed: options.fixed
                });
        }
    };
    Chance.prototype.longitude = function(options) {
        // Constants - Formats
        var [DDM, DMS, DD] = [
            'ddm',
            'dms',
            'dd'
        ];
        options = initOptions(options, options && options.format && [
            DDM,
            DMS
        ].includes(options.format.toLowerCase()) ? {
            min: 0,
            max: 179,
            fixed: 4
        } : {
            fixed: 5,
            min: -180,
            max: 180,
            format: DD
        });
        var format = options.format.toLowerCase();
        if (format === DDM || format === DMS) {
            testRange(options.min < 0 || options.min > 179, "Chance: Min specified is out of range. Should be between 0 - 179");
            testRange(options.max < 0 || options.max > 179, "Chance: Max specified is out of range. Should be between 0 - 179");
            testRange(options.fixed > 4, 'Chance: Fixed specified should be below or equal to 4');
        }
        switch(format){
            case DDM:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.floating({
                    min: 0,
                    max: 59.9999,
                    fixed: options.fixed
                });
            case DMS:
                return this.integer({
                    min: options.min,
                    max: options.max
                }) + "\xb0" + this.integer({
                    min: 0,
                    max: 59
                }) + "\u2019" + this.floating({
                    min: 0,
                    max: 59.9999,
                    fixed: options.fixed
                }) + "\u201D";
            case DD:
            default:
                return this.floating({
                    min: options.min,
                    max: options.max,
                    fixed: options.fixed
                });
        }
    };
    Chance.prototype.phone = function(options) {
        var self1 = this, numPick, ukNum = function(parts) {
            var section = [];
            //fills the section part of the phone number with random numbers.
            parts.sections.forEach(function(n) {
                section.push(self1.string({
                    pool: '0123456789',
                    length: n
                }));
            });
            return parts.area + section.join(' ');
        };
        options = initOptions(options, {
            formatted: true,
            country: 'us',
            mobile: false,
            exampleNumber: false
        });
        if (!options.formatted) options.parens = false;
        var phone;
        switch(options.country){
            case 'fr':
                if (!options.mobile) {
                    numPick = this.pick([
                        // Valid zone and département codes.
                        '01' + this.pick([
                            '30',
                            '34',
                            '39',
                            '40',
                            '41',
                            '42',
                            '43',
                            '44',
                            '45',
                            '46',
                            '47',
                            '48',
                            '49',
                            '53',
                            '55',
                            '56',
                            '58',
                            '60',
                            '64',
                            '69',
                            '70',
                            '72',
                            '73',
                            '74',
                            '75',
                            '76',
                            '77',
                            '78',
                            '79',
                            '80',
                            '81',
                            '82',
                            '83'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '02' + this.pick([
                            '14',
                            '18',
                            '22',
                            '23',
                            '28',
                            '29',
                            '30',
                            '31',
                            '32',
                            '33',
                            '34',
                            '35',
                            '36',
                            '37',
                            '38',
                            '40',
                            '41',
                            '43',
                            '44',
                            '45',
                            '46',
                            '47',
                            '48',
                            '49',
                            '50',
                            '51',
                            '52',
                            '53',
                            '54',
                            '56',
                            '57',
                            '61',
                            '62',
                            '69',
                            '72',
                            '76',
                            '77',
                            '78',
                            '85',
                            '90',
                            '96',
                            '97',
                            '98',
                            '99'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '03' + this.pick([
                            '10',
                            '20',
                            '21',
                            '22',
                            '23',
                            '24',
                            '25',
                            '26',
                            '27',
                            '28',
                            '29',
                            '39',
                            '44',
                            '45',
                            '51',
                            '52',
                            '54',
                            '55',
                            '57',
                            '58',
                            '59',
                            '60',
                            '61',
                            '62',
                            '63',
                            '64',
                            '65',
                            '66',
                            '67',
                            '68',
                            '69',
                            '70',
                            '71',
                            '72',
                            '73',
                            '80',
                            '81',
                            '82',
                            '83',
                            '84',
                            '85',
                            '86',
                            '87',
                            '88',
                            '89',
                            '90'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '04' + this.pick([
                            '11',
                            '13',
                            '15',
                            '20',
                            '22',
                            '26',
                            '27',
                            '30',
                            '32',
                            '34',
                            '37',
                            '42',
                            '43',
                            '44',
                            '50',
                            '56',
                            '57',
                            '63',
                            '66',
                            '67',
                            '68',
                            '69',
                            '70',
                            '71',
                            '72',
                            '73',
                            '74',
                            '75',
                            '76',
                            '77',
                            '78',
                            '79',
                            '80',
                            '81',
                            '82',
                            '83',
                            '84',
                            '85',
                            '86',
                            '88',
                            '89',
                            '90',
                            '91',
                            '92',
                            '93',
                            '94',
                            '95',
                            '97',
                            '98'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '05' + this.pick([
                            '08',
                            '16',
                            '17',
                            '19',
                            '24',
                            '31',
                            '32',
                            '33',
                            '34',
                            '35',
                            '40',
                            '45',
                            '46',
                            '47',
                            '49',
                            '53',
                            '55',
                            '56',
                            '57',
                            '58',
                            '59',
                            '61',
                            '62',
                            '63',
                            '64',
                            '65',
                            '67',
                            '79',
                            '81',
                            '82',
                            '86',
                            '87',
                            '90',
                            '94'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '09' + self1.string({
                            pool: '0123456789',
                            length: 8
                        })
                    ]);
                    phone = options.formatted ? numPick.match(/../g).join(' ') : numPick;
                } else {
                    numPick = this.pick([
                        '06',
                        '07'
                    ]) + self1.string({
                        pool: '0123456789',
                        length: 8
                    });
                    phone = options.formatted ? numPick.match(/../g).join(' ') : numPick;
                }
                break;
            case 'uk':
                if (!options.mobile) {
                    numPick = this.pick([
                        //valid area codes of major cities/counties followed by random numbers in required format.
                        {
                            area: '01' + this.character({
                                pool: '234569'
                            }) + '1 ',
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '020 ' + this.character({
                                pool: '378'
                            }),
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '023 ' + this.character({
                                pool: '89'
                            }),
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '024 7',
                            sections: [
                                3,
                                4
                            ]
                        },
                        {
                            area: '028 ' + this.pick([
                                '25',
                                '28',
                                '37',
                                '71',
                                '82',
                                '90',
                                '92',
                                '95'
                            ]),
                            sections: [
                                2,
                                4
                            ]
                        },
                        {
                            area: '012' + this.pick([
                                '04',
                                '08',
                                '54',
                                '76',
                                '97',
                                '98'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '013' + this.pick([
                                '63',
                                '64',
                                '84',
                                '86'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '014' + this.pick([
                                '04',
                                '20',
                                '60',
                                '61',
                                '80',
                                '88'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '015' + this.pick([
                                '24',
                                '27',
                                '62',
                                '66'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '016' + this.pick([
                                '06',
                                '29',
                                '35',
                                '47',
                                '59',
                                '95'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '017' + this.pick([
                                '26',
                                '44',
                                '50',
                                '68'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '018' + this.pick([
                                '27',
                                '37',
                                '84',
                                '97'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        },
                        {
                            area: '019' + this.pick([
                                '00',
                                '05',
                                '35',
                                '46',
                                '49',
                                '63',
                                '95'
                            ]) + ' ',
                            sections: [
                                6
                            ]
                        }
                    ]);
                    phone = options.formatted ? ukNum(numPick) : ukNum(numPick).replace(' ', '', 'g');
                } else {
                    numPick = this.pick([
                        {
                            area: '07' + this.pick([
                                '4',
                                '5',
                                '7',
                                '8',
                                '9'
                            ]),
                            sections: [
                                2,
                                6
                            ]
                        },
                        {
                            area: '07624 ',
                            sections: [
                                6
                            ]
                        }
                    ]);
                    phone = options.formatted ? ukNum(numPick) : ukNum(numPick).replace(' ', '');
                }
                break;
            case 'za':
                if (!options.mobile) {
                    numPick = this.pick([
                        '01' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '02' + this.pick([
                            '1',
                            '2',
                            '3',
                            '4',
                            '7',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '03' + this.pick([
                            '1',
                            '2',
                            '3',
                            '5',
                            '6',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '04' + this.pick([
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '05' + this.pick([
                            '1',
                            '3',
                            '4',
                            '6',
                            '7',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        })
                    ]);
                    phone = options.formatted || numPick;
                } else {
                    numPick = this.pick([
                        '060' + this.pick([
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '061' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '8'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '06' + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '071' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 6
                        }),
                        '07' + this.pick([
                            '2',
                            '3',
                            '4',
                            '6',
                            '7',
                            '8',
                            '9'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        }),
                        '08' + this.pick([
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5'
                        ]) + self1.string({
                            pool: '0123456789',
                            length: 7
                        })
                    ]);
                    phone = options.formatted || numPick;
                }
                break;
            case 'us':
                var areacode = this.areacode(options).toString();
                var exchange = this.natural({
                    min: 2,
                    max: 9
                }).toString() + this.natural({
                    min: 0,
                    max: 9
                }).toString() + this.natural({
                    min: 0,
                    max: 9
                }).toString();
                var subscriber = this.natural({
                    min: 1000,
                    max: 9999
                }).toString(); // this could be random [0-9]{4}
                phone = options.formatted ? areacode + ' ' + exchange + '-' + subscriber : areacode + exchange + subscriber;
                break;
            case 'br':
                var areaCode = this.pick([
                    "11",
                    "12",
                    "13",
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "21",
                    "22",
                    "24",
                    "27",
                    "28",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35",
                    "37",
                    "38",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49",
                    "51",
                    "53",
                    "54",
                    "55",
                    "61",
                    "62",
                    "63",
                    "64",
                    "65",
                    "66",
                    "67",
                    "68",
                    "69",
                    "71",
                    "73",
                    "74",
                    "75",
                    "77",
                    "79",
                    "81",
                    "82",
                    "83",
                    "84",
                    "85",
                    "86",
                    "87",
                    "88",
                    "89",
                    "91",
                    "92",
                    "93",
                    "94",
                    "95",
                    "96",
                    "97",
                    "98",
                    "99"
                ]);
                var prefix;
                if (options.mobile) // Brasilian official reference (mobile): http://www.anatel.gov.br/setorregulado/plano-de-numeracao-brasileiro?id=330
                prefix = '9' + self1.string({
                    pool: '0123456789',
                    length: 4
                });
                else // Brasilian official reference: http://www.anatel.gov.br/setorregulado/plano-de-numeracao-brasileiro?id=331
                prefix = this.natural({
                    min: 2000,
                    max: 5999
                }).toString();
                var mcdu = self1.string({
                    pool: '0123456789',
                    length: 4
                });
                phone = options.formatted ? '(' + areaCode + ') ' + prefix + '-' + mcdu : areaCode + prefix + mcdu;
                break;
        }
        return phone;
    };
    Chance.prototype.postal = function() {
        // Postal District
        var pd = this.character({
            pool: "XVTSRPNKLMHJGECBA"
        });
        // Forward Sortation Area (FSA)
        var fsa = pd + this.natural({
            max: 9
        }) + this.character({
            alpha: true,
            casing: "upper"
        });
        // Local Delivery Unut (LDU)
        var ldu = this.natural({
            max: 9
        }) + this.character({
            alpha: true,
            casing: "upper"
        }) + this.natural({
            max: 9
        });
        return fsa + " " + ldu;
    };
    Chance.prototype.postcode = function() {
        // Area
        var area = this.pick(this.get("postcodeAreas")).code;
        // District
        var district = this.natural({
            max: 9
        });
        // Sub-District
        var subDistrict = this.bool() ? this.character({
            alpha: true,
            casing: "upper"
        }) : "";
        // Outward Code
        var outward = area + district + subDistrict;
        // Sector
        var sector = this.natural({
            max: 9
        });
        // Unit
        var unit = this.character({
            alpha: true,
            casing: "upper"
        }) + this.character({
            alpha: true,
            casing: "upper"
        });
        // Inward Code
        var inward = sector + unit;
        return outward + " " + inward;
    };
    Chance.prototype.counties = function(options) {
        options = initOptions(options, {
            country: 'uk'
        });
        return this.get("counties")[options.country.toLowerCase()];
    };
    Chance.prototype.county = function(options) {
        return this.pick(this.counties(options)).name;
    };
    Chance.prototype.provinces = function(options) {
        options = initOptions(options, {
            country: 'ca'
        });
        return this.get("provinces")[options.country.toLowerCase()];
    };
    Chance.prototype.province = function(options) {
        return options && options.full ? this.pick(this.provinces(options)).name : this.pick(this.provinces(options)).abbreviation;
    };
    Chance.prototype.state = function(options) {
        return options && options.full ? this.pick(this.states(options)).name : this.pick(this.states(options)).abbreviation;
    };
    Chance.prototype.states = function(options) {
        options = initOptions(options, {
            country: 'us',
            us_states_and_dc: true
        });
        var states;
        switch(options.country.toLowerCase()){
            case 'us':
                var us_states_and_dc = this.get("us_states_and_dc"), territories = this.get("territories"), armed_forces = this.get("armed_forces");
                states = [];
                if (options.us_states_and_dc) states = states.concat(us_states_and_dc);
                if (options.territories) states = states.concat(territories);
                if (options.armed_forces) states = states.concat(armed_forces);
                break;
            case 'it':
            case 'mx':
                states = this.get("country_regions")[options.country.toLowerCase()];
                break;
            case 'uk':
                states = this.get("counties")[options.country.toLowerCase()];
                break;
        }
        return states;
    };
    Chance.prototype.street = function(options) {
        options = initOptions(options, {
            country: 'us',
            syllables: 2
        });
        var street;
        switch(options.country.toLowerCase()){
            case 'us':
                street = this.word({
                    syllables: options.syllables
                });
                street = this.capitalize(street);
                street += ' ';
                street += options.short_suffix ? this.street_suffix(options).abbreviation : this.street_suffix(options).name;
                break;
            case 'it':
                street = this.word({
                    syllables: options.syllables
                });
                street = this.capitalize(street);
                street = (options.short_suffix ? this.street_suffix(options).abbreviation : this.street_suffix(options).name) + " " + street;
                break;
        }
        return street;
    };
    Chance.prototype.street_suffix = function(options) {
        options = initOptions(options, {
            country: 'us'
        });
        return this.pick(this.street_suffixes(options));
    };
    Chance.prototype.street_suffixes = function(options) {
        options = initOptions(options, {
            country: 'us'
        });
        // These are the most common suffixes.
        return this.get("street_suffixes")[options.country.toLowerCase()];
    };
    // Note: only returning US zip codes, internationalization will be a whole
    // other beast to tackle at some point.
    Chance.prototype.zip = function(options) {
        var zip = this.n(this.natural, 5, {
            max: 9
        });
        if (options && options.plusfour === true) {
            zip.push('-');
            zip = zip.concat(this.n(this.natural, 4, {
                max: 9
            }));
        }
        return zip.join("");
    };
    // -- End Location --
    // -- Time
    Chance.prototype.ampm = function() {
        return this.bool() ? 'am' : 'pm';
    };
    Chance.prototype.date = function(options) {
        var date_string, date;
        // If interval is specified we ignore preset
        if (options && (options.min || options.max)) {
            options = initOptions(options, {
                american: true,
                string: false
            });
            var min = typeof options.min !== "undefined" ? options.min.getTime() : 1;
            // 100,000,000 days measured relative to midnight at the beginning of 01 January, 1970 UTC. http://es5.github.io/#x15.9.1.1
            var max = typeof options.max !== "undefined" ? options.max.getTime() : 8640000000000000;
            date = new Date(this.integer({
                min: min,
                max: max
            }));
        } else {
            var m = this.month({
                raw: true
            });
            var daysInMonth = m.days;
            if (options && options.month) // Mod 12 to allow months outside range of 0-11 (not encouraged, but also not prevented).
            daysInMonth = this.get('months')[(options.month % 12 + 12) % 12].days;
            options = initOptions(options, {
                year: parseInt(this.year(), 10),
                // Necessary to subtract 1 because Date() 0-indexes month but not day or year
                // for some reason.
                month: m.numeric - 1,
                day: this.natural({
                    min: 1,
                    max: daysInMonth
                }),
                hour: this.hour({
                    twentyfour: true
                }),
                minute: this.minute(),
                second: this.second(),
                millisecond: this.millisecond(),
                american: true,
                string: false
            });
            date = new Date(options.year, options.month, options.day, options.hour, options.minute, options.second, options.millisecond);
        }
        if (options.american) // Adding 1 to the month is necessary because Date() 0-indexes
        // months but not day for some odd reason.
        date_string = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
        else date_string = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        return options.string ? date_string : date;
    };
    Chance.prototype.hammertime = function(options) {
        return this.date(options).getTime();
    };
    Chance.prototype.hour = function(options) {
        options = initOptions(options, {
            min: options && options.twentyfour ? 0 : 1,
            max: options && options.twentyfour ? 23 : 12
        });
        testRange(options.min < 0, "Chance: Min cannot be less than 0.");
        testRange(options.twentyfour && options.max > 23, "Chance: Max cannot be greater than 23 for twentyfour option.");
        testRange(!options.twentyfour && options.max > 12, "Chance: Max cannot be greater than 12.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        return this.natural({
            min: options.min,
            max: options.max
        });
    };
    Chance.prototype.millisecond = function() {
        return this.natural({
            max: 999
        });
    };
    Chance.prototype.minute = Chance.prototype.second = function(options) {
        options = initOptions(options, {
            min: 0,
            max: 59
        });
        testRange(options.min < 0, "Chance: Min cannot be less than 0.");
        testRange(options.max > 59, "Chance: Max cannot be greater than 59.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        return this.natural({
            min: options.min,
            max: options.max
        });
    };
    Chance.prototype.month = function(options) {
        options = initOptions(options, {
            min: 1,
            max: 12
        });
        testRange(options.min < 1, "Chance: Min cannot be less than 1.");
        testRange(options.max > 12, "Chance: Max cannot be greater than 12.");
        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
        var month = this.pick(this.months().slice(options.min - 1, options.max));
        return options.raw ? month : month.name;
    };
    Chance.prototype.months = function() {
        return this.get("months");
    };
    Chance.prototype.second = function() {
        return this.natural({
            max: 59
        });
    };
    Chance.prototype.timestamp = function() {
        return this.natural({
            min: 1,
            max: parseInt(new Date().getTime() / 1000, 10)
        });
    };
    Chance.prototype.weekday = function(options) {
        options = initOptions(options, {
            weekday_only: false
        });
        var weekdays = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
        ];
        if (!options.weekday_only) {
            weekdays.push("Saturday");
            weekdays.push("Sunday");
        }
        return this.pickone(weekdays);
    };
    Chance.prototype.year = function(options) {
        // Default to current year as min if none specified
        options = initOptions(options, {
            min: new Date().getFullYear()
        });
        // Default to one century after current year as max if none specified
        options.max = typeof options.max !== "undefined" ? options.max : options.min + 100;
        return this.natural(options).toString();
    };
    // -- End Time
    // -- Finance --
    Chance.prototype.cc = function(options) {
        options = initOptions(options);
        var type, number, to_generate;
        type = options.type ? this.cc_type({
            name: options.type,
            raw: true
        }) : this.cc_type({
            raw: true
        });
        number = type.prefix.split("");
        to_generate = type.length - type.prefix.length - 1;
        // Generates n - 1 digits
        number = number.concat(this.n(this.integer, to_generate, {
            min: 0,
            max: 9
        }));
        // Generates the last digit according to Luhn algorithm
        number.push(this.luhn_calculate(number.join("")));
        return number.join("");
    };
    Chance.prototype.cc_types = function() {
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        return this.get("cc_types");
    };
    Chance.prototype.cc_type = function(options) {
        options = initOptions(options);
        var types = this.cc_types(), type = null;
        if (options.name) {
            for(var i = 0; i < types.length; i++)// Accept either name or short_name to specify card type
            if (types[i].name === options.name || types[i].short_name === options.name) {
                type = types[i];
                break;
            }
            if (type === null) throw new RangeError("Chance: Credit card type '" + options.name + "' is not supported");
        } else type = this.pick(types);
        return options.raw ? type : type.name;
    };
    // return all world currency by ISO 4217
    Chance.prototype.currency_types = function() {
        return this.get("currency_types");
    };
    // return random world currency by ISO 4217
    Chance.prototype.currency = function() {
        return this.pick(this.currency_types());
    };
    // return all timezones available
    Chance.prototype.timezones = function() {
        return this.get("timezones");
    };
    // return random timezone
    Chance.prototype.timezone = function() {
        return this.pick(this.timezones());
    };
    //Return random correct currency exchange pair (e.g. EUR/USD) or array of currency code
    Chance.prototype.currency_pair = function(returnAsString) {
        var currencies = this.unique(this.currency, 2, {
            comparator: function(arr, val) {
                return arr.reduce(function(acc, item) {
                    // If a match has been found, short circuit check and just return
                    return acc || item.code === val.code;
                }, false);
            }
        });
        if (returnAsString) return currencies[0].code + '/' + currencies[1].code;
        else return currencies;
    };
    Chance.prototype.dollar = function(options) {
        // By default, a somewhat more sane max for dollar than all available numbers
        options = initOptions(options, {
            max: 10000,
            min: 0
        });
        var dollar = this.floating({
            min: options.min,
            max: options.max,
            fixed: 2
        }).toString(), cents = dollar.split('.')[1];
        if (cents === undefined) dollar += '.00';
        else if (cents.length < 2) dollar = dollar + '0';
        if (dollar < 0) return '-$' + dollar.replace('-', '');
        else return '$' + dollar;
    };
    Chance.prototype.euro = function(options) {
        return Number(this.dollar(options).replace("$", "")).toLocaleString() + "\u20AC";
    };
    Chance.prototype.exp = function(options) {
        options = initOptions(options);
        var exp = {};
        exp.year = this.exp_year();
        // If the year is this year, need to ensure month is greater than the
        // current month or this expiration will not be valid
        if (exp.year === new Date().getFullYear().toString()) exp.month = this.exp_month({
            future: true
        });
        else exp.month = this.exp_month();
        return options.raw ? exp : exp.month + '/' + exp.year;
    };
    Chance.prototype.exp_month = function(options) {
        options = initOptions(options);
        var month, month_int, // Date object months are 0 indexed
        curMonth = new Date().getMonth() + 1;
        if (options.future && curMonth !== 12) do {
            month = this.month({
                raw: true
            }).numeric;
            month_int = parseInt(month, 10);
        }while (month_int <= curMonth);
        else month = this.month({
            raw: true
        }).numeric;
        return month;
    };
    Chance.prototype.exp_year = function() {
        var curMonth = new Date().getMonth() + 1, curYear = new Date().getFullYear();
        return this.year({
            min: curMonth === 12 ? curYear + 1 : curYear,
            max: curYear + 10
        });
    };
    Chance.prototype.vat = function(options) {
        options = initOptions(options, {
            country: 'it'
        });
        switch(options.country.toLowerCase()){
            case 'it':
                return this.it_vat();
        }
    };
    /**
     * Generate a string matching IBAN pattern (https://en.wikipedia.org/wiki/International_Bank_Account_Number).
     * No country-specific formats support (yet)
     */ Chance.prototype.iban = function() {
        var alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var alphanum = alpha + '0123456789';
        var iban = this.string({
            length: 2,
            pool: alpha
        }) + this.pad(this.integer({
            min: 0,
            max: 99
        }), 2) + this.string({
            length: 4,
            pool: alphanum
        }) + this.pad(this.natural(), this.natural({
            min: 6,
            max: 26
        }));
        return iban;
    };
    // -- End Finance
    // -- Regional
    Chance.prototype.it_vat = function() {
        var it_vat = this.natural({
            min: 1,
            max: 1800000
        });
        it_vat = this.pad(it_vat, 7) + this.pad(this.pick(this.provinces({
            country: 'it'
        })).code, 3);
        return it_vat + this.luhn_calculate(it_vat);
    };
    /*
     * this generator is written following the official algorithm
     * all data can be passed explicitely or randomized by calling chance.cf() without options
     * the code does not check that the input data is valid (it goes beyond the scope of the generator)
     *
     * @param  [Object] options = { first: first name,
     *                              last: last name,
     *                              gender: female|male,
                                    birthday: JavaScript date object,
                                    city: string(4), 1 letter + 3 numbers
                                   }
     * @return [string] codice fiscale
     *
    */ Chance.prototype.cf = function(options) {
        options = options || {};
        var gender = !!options.gender ? options.gender : this.gender(), first = !!options.first ? options.first : this.first({
            gender: gender,
            nationality: 'it'
        }), last = !!options.last ? options.last : this.last({
            nationality: 'it'
        }), birthday = !!options.birthday ? options.birthday : this.birthday(), city = !!options.city ? options.city : this.pickone([
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'L',
            'M',
            'Z'
        ]) + this.pad(this.natural({
            max: 999
        }), 3), cf = [], name_generator = function(name, isLast) {
            var temp, return_value = [];
            if (name.length < 3) return_value = name.split("").concat("XXX".split("")).splice(0, 3);
            else {
                temp = name.toUpperCase().split('').map(function(c) {
                    return "BCDFGHJKLMNPRSTVWZ".indexOf(c) !== -1 ? c : undefined;
                }).join('');
                if (temp.length > 3) {
                    if (isLast) temp = temp.substr(0, 3);
                    else temp = temp[0] + temp.substr(2, 2);
                }
                if (temp.length < 3) {
                    return_value = temp;
                    temp = name.toUpperCase().split('').map(function(c) {
                        return "AEIOU".indexOf(c) !== -1 ? c : undefined;
                    }).join('').substr(0, 3 - return_value.length);
                }
                return_value = return_value + temp;
            }
            return return_value;
        }, date_generator = function(birthday, gender, that) {
            var lettermonths = [
                'A',
                'B',
                'C',
                'D',
                'E',
                'H',
                'L',
                'M',
                'P',
                'R',
                'S',
                'T'
            ];
            return birthday.getFullYear().toString().substr(2) + lettermonths[birthday.getMonth()] + that.pad(birthday.getDate() + (gender.toLowerCase() === "female" ? 40 : 0), 2);
        }, checkdigit_generator = function(cf) {
            var range1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", range2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", evens = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", odds = "BAKPLCQDREVOSFTGUHMINJWZYX", digit = 0;
            for(var i = 0; i < 15; i++)if (i % 2 !== 0) digit += evens.indexOf(range2[range1.indexOf(cf[i])]);
            else digit += odds.indexOf(range2[range1.indexOf(cf[i])]);
            return evens[digit % 26];
        };
        cf = cf.concat(name_generator(last, true), name_generator(first), date_generator(birthday, gender, this), city.toUpperCase().split("")).join("");
        cf += checkdigit_generator(cf.toUpperCase(), this);
        return cf.toUpperCase();
    };
    Chance.prototype.pl_pesel = function() {
        var number = this.natural({
            min: 1,
            max: 9999999999
        });
        var arr = this.pad(number, 10).split('');
        for(var i = 0; i < arr.length; i++)arr[i] = parseInt(arr[i]);
        var controlNumber = (1 * arr[0] + 3 * arr[1] + 7 * arr[2] + 9 * arr[3] + 1 * arr[4] + 3 * arr[5] + 7 * arr[6] + 9 * arr[7] + 1 * arr[8] + 3 * arr[9]) % 10;
        if (controlNumber !== 0) controlNumber = 10 - controlNumber;
        return arr.join('') + controlNumber;
    };
    Chance.prototype.pl_nip = function() {
        var number = this.natural({
            min: 1,
            max: 999999999
        });
        var arr = this.pad(number, 9).split('');
        for(var i = 0; i < arr.length; i++)arr[i] = parseInt(arr[i]);
        var controlNumber = (6 * arr[0] + 5 * arr[1] + 7 * arr[2] + 2 * arr[3] + 3 * arr[4] + 4 * arr[5] + 5 * arr[6] + 6 * arr[7] + 7 * arr[8]) % 11;
        if (controlNumber === 10) return this.pl_nip();
        return arr.join('') + controlNumber;
    };
    Chance.prototype.pl_regon = function() {
        var number = this.natural({
            min: 1,
            max: 99999999
        });
        var arr = this.pad(number, 8).split('');
        for(var i = 0; i < arr.length; i++)arr[i] = parseInt(arr[i]);
        var controlNumber = (8 * arr[0] + 9 * arr[1] + 2 * arr[2] + 3 * arr[3] + 4 * arr[4] + 5 * arr[5] + 6 * arr[6] + 7 * arr[7]) % 11;
        if (controlNumber === 10) controlNumber = 0;
        return arr.join('') + controlNumber;
    };
    // -- End Regional
    // -- Music --
    // Genre choices:
    // Rock,Pop,Hip-Hop,Jazz,Classical,Electronic,Country,R&B,Reggae,
    // Blues,Metal,Folk,Alternative,Punk,Disco,Funk,Techno,
    // Indie,Gospel,Dance,Children's,World
    Chance.prototype.music_genre = function(genre = 'general') {
        if (!(genre.toLowerCase() in data.music_genres)) throw new Error(`Unsupported genre: ${genre}`);
        const genres = data.music_genres[genre.toLowerCase()];
        const randomIndex = this.integer({
            min: 0,
            max: genres.length - 1
        });
        return genres[randomIndex];
    };
    Chance.prototype.note = function(options) {
        // choices for 'notes' option:
        // flatKey - chromatic scale with flat notes (default)
        // sharpKey - chromatic scale with sharp notes
        // flats - just flat notes
        // sharps - just sharp notes
        // naturals - just natural notes
        // all - naturals, sharps and flats
        options = initOptions(options, {
            notes: 'flatKey'
        });
        var scales = {
            naturals: [
                'C',
                'D',
                'E',
                'F',
                'G',
                'A',
                'B'
            ],
            flats: [
                "D\u266D",
                "E\u266D",
                "G\u266D",
                "A\u266D",
                "B\u266D"
            ],
            sharps: [
                "C\u266F",
                "D\u266F",
                "F\u266F",
                "G\u266F",
                "A\u266F"
            ]
        };
        scales.all = scales.naturals.concat(scales.flats.concat(scales.sharps));
        scales.flatKey = scales.naturals.concat(scales.flats);
        scales.sharpKey = scales.naturals.concat(scales.sharps);
        return this.pickone(scales[options.notes]);
    };
    Chance.prototype.midi_note = function(options) {
        var min = 0;
        var max = 127;
        options = initOptions(options, {
            min: min,
            max: max
        });
        return this.integer({
            min: options.min,
            max: options.max
        });
    };
    Chance.prototype.chord_quality = function(options) {
        options = initOptions(options, {
            jazz: true
        });
        var chord_qualities = [
            'maj',
            'min',
            'aug',
            'dim'
        ];
        if (options.jazz) chord_qualities = [
            'maj7',
            'min7',
            '7',
            'sus',
            'dim',
            "\xf8"
        ];
        return this.pickone(chord_qualities);
    };
    Chance.prototype.chord = function(options) {
        options = initOptions(options);
        return this.note(options) + this.chord_quality(options);
    };
    Chance.prototype.tempo = function(options) {
        var min = 40;
        var max = 320;
        options = initOptions(options, {
            min: min,
            max: max
        });
        return this.integer({
            min: options.min,
            max: options.max
        });
    };
    // -- End Music
    // -- Miscellaneous --
    // Coin - Flip, flip, flipadelphia
    Chance.prototype.coin = function() {
        return this.bool() ? "heads" : "tails";
    };
    // Dice - For all the board game geeks out there, myself included ;)
    function diceFn(range) {
        return function() {
            return this.natural(range);
        };
    }
    Chance.prototype.d4 = diceFn({
        min: 1,
        max: 4
    });
    Chance.prototype.d6 = diceFn({
        min: 1,
        max: 6
    });
    Chance.prototype.d8 = diceFn({
        min: 1,
        max: 8
    });
    Chance.prototype.d10 = diceFn({
        min: 1,
        max: 10
    });
    Chance.prototype.d12 = diceFn({
        min: 1,
        max: 12
    });
    Chance.prototype.d20 = diceFn({
        min: 1,
        max: 20
    });
    Chance.prototype.d30 = diceFn({
        min: 1,
        max: 30
    });
    Chance.prototype.d100 = diceFn({
        min: 1,
        max: 100
    });
    Chance.prototype.rpg = function(thrown, options) {
        options = initOptions(options);
        if (!thrown) throw new RangeError("Chance: A type of die roll must be included");
        else {
            var bits = thrown.toLowerCase().split("d"), rolls = [];
            if (bits.length !== 2 || !parseInt(bits[0], 10) || !parseInt(bits[1], 10)) throw new Error("Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");
            for(var i = bits[0]; i > 0; i--)rolls[i - 1] = this.natural({
                min: 1,
                max: bits[1]
            });
            return typeof options.sum !== 'undefined' && options.sum ? rolls.reduce(function(p, c) {
                return p + c;
            }) : rolls;
        }
    };
    // Guid
    Chance.prototype.guid = function(options) {
        options = initOptions(options, {
            version: 5
        });
        var guid_pool = "abcdef1234567890", variant_pool = "ab89", guid = this.string({
            pool: guid_pool,
            length: 8
        }) + '-' + this.string({
            pool: guid_pool,
            length: 4
        }) + '-' + // The Version
        options.version + this.string({
            pool: guid_pool,
            length: 3
        }) + '-' + // The Variant
        this.string({
            pool: variant_pool,
            length: 1
        }) + this.string({
            pool: guid_pool,
            length: 3
        }) + '-' + this.string({
            pool: guid_pool,
            length: 12
        });
        return guid;
    };
    // Hash
    Chance.prototype.hash = function(options) {
        options = initOptions(options, {
            length: 40,
            casing: 'lower'
        });
        var pool = options.casing === 'upper' ? HEX_POOL.toUpperCase() : HEX_POOL;
        return this.string({
            pool: pool,
            length: options.length
        });
    };
    Chance.prototype.luhn_check = function(num) {
        var str = num.toString();
        var checkDigit = +str.substring(str.length - 1);
        return checkDigit === this.luhn_calculate(+str.substring(0, str.length - 1));
    };
    Chance.prototype.luhn_calculate = function(num) {
        var digits = num.toString().split("").reverse();
        var sum = 0;
        var digit;
        for(var i = 0, l = digits.length; l > i; ++i){
            digit = +digits[i];
            if (i % 2 === 0) {
                digit *= 2;
                if (digit > 9) digit -= 9;
            }
            sum += digit;
        }
        return sum * 9 % 10;
    };
    // MD5 Hash
    Chance.prototype.md5 = function(options) {
        var opts = {
            str: '',
            key: null,
            raw: false
        };
        if (!options) {
            opts.str = this.string();
            options = {};
        } else if (typeof options === 'string') {
            opts.str = options;
            options = {};
        } else if (typeof options !== 'object') return null;
        else if (options.constructor === 'Array') return null;
        opts = initOptions(options, opts);
        if (!opts.str) throw new Error('A parameter is required to return an md5 hash.');
        return this.bimd5.md5(opts.str, opts.key, opts.raw);
    };
    /**
     * #Description:
     * =====================================================
     * Generate random file name with extension
     *
     * The argument provide extension type
     * -> raster
     * -> vector
     * -> 3d
     * -> document
     *
     * If nothing is provided the function return random file name with random
     * extension type of any kind
     *
     * The user can validate the file name length range
     * If nothing provided the generated file name is random
     *
     * #Extension Pool :
     * * Currently the supported extensions are
     *  -> some of the most popular raster image extensions
     *  -> some of the most popular vector image extensions
     *  -> some of the most popular 3d image extensions
     *  -> some of the most popular document extensions
     *
     * #Examples :
     * =====================================================
     *
     * Return random file name with random extension. The file extension
     * is provided by a predefined collection of extensions. More about the extension
     * pool can be found in #Extension Pool section
     *
     * chance.file()
     * => dsfsdhjf.xml
     *
     * In order to generate a file name with specific length, specify the
     * length property and integer value. The extension is going to be random
     *
     * chance.file({length : 10})
     * => asrtineqos.pdf
     *
     * In order to generate file with extension from some of the predefined groups
     * of the extension pool just specify the extension pool category in fileType property
     *
     * chance.file({fileType : 'raster'})
     * => dshgssds.psd
     *
     * You can provide specific extension for your files
     * chance.file({extension : 'html'})
     * => djfsd.html
     *
     * Or you could pass custom collection of extensions by array or by object
     * chance.file({extensions : [...]})
     * => dhgsdsd.psd
     *
     * chance.file({extensions : { key : [...], key : [...]}})
     * => djsfksdjsd.xml
     *
     * @param  [collection] options
     * @return [string]
     *
     */ Chance.prototype.file = function(options) {
        var fileOptions = options || {};
        var poolCollectionKey = "fileExtension";
        var typeRange = Object.keys(this.get("fileExtension")); //['raster', 'vector', '3d', 'document'];
        var fileName;
        var fileExtension;
        // Generate random file name
        fileName = this.word({
            length: fileOptions.length
        });
        // Generate file by specific extension provided by the user
        if (fileOptions.extension) {
            fileExtension = fileOptions.extension;
            return fileName + '.' + fileExtension;
        }
        // Generate file by specific extension collection
        if (fileOptions.extensions) {
            if (Array.isArray(fileOptions.extensions)) {
                fileExtension = this.pickone(fileOptions.extensions);
                return fileName + '.' + fileExtension;
            } else if (fileOptions.extensions.constructor === Object) {
                var extensionObjectCollection = fileOptions.extensions;
                var keys = Object.keys(extensionObjectCollection);
                fileExtension = this.pickone(extensionObjectCollection[this.pickone(keys)]);
                return fileName + '.' + fileExtension;
            }
            throw new Error("Chance: Extensions must be an Array or Object");
        }
        // Generate file extension based on specific file type
        if (fileOptions.fileType) {
            var fileType = fileOptions.fileType;
            if (typeRange.indexOf(fileType) !== -1) {
                fileExtension = this.pickone(this.get(poolCollectionKey)[fileType]);
                return fileName + '.' + fileExtension;
            }
            throw new RangeError("Chance: Expect file type value to be 'raster', 'vector', '3d' or 'document'");
        }
        // Generate random file name if no extension options are passed
        fileExtension = this.pickone(this.get(poolCollectionKey)[this.pickone(typeRange)]);
        return fileName + '.' + fileExtension;
    };
    /**
     * Generates file data of random bytes using the chance.file method for the file name
     *
     * @param {object}
     * fileName: String
     * fileExtention: String
     * fileSize: Number      <- in bytes
     * @returns {object} fileName: String, fileData: Buffer
     */ Chance.prototype.fileWithContent = function(options) {
        var fileOptions = options || {};
        var fileName = 'fileName' in fileOptions ? fileOptions.fileName : this.file().split(".")[0];
        fileName += "." + ('fileExtension' in fileOptions ? fileOptions.fileExtension : this.file().split(".")[1]);
        if (typeof fileOptions.fileSize !== "number") throw new Error('File size must be an integer');
        var file = {
            fileData: this.buffer({
                length: fileOptions.fileSize
            }),
            fileName: fileName
        };
        return file;
    };
    var data = {
        firstNames: {
            "male": {
                "en": [
                    "James",
                    "John",
                    "Robert",
                    "Michael",
                    "William",
                    "David",
                    "Richard",
                    "Joseph",
                    "Charles",
                    "Thomas",
                    "Christopher",
                    "Daniel",
                    "Matthew",
                    "George",
                    "Donald",
                    "Anthony",
                    "Paul",
                    "Mark",
                    "Edward",
                    "Steven",
                    "Kenneth",
                    "Andrew",
                    "Brian",
                    "Joshua",
                    "Kevin",
                    "Ronald",
                    "Timothy",
                    "Jason",
                    "Jeffrey",
                    "Frank",
                    "Gary",
                    "Ryan",
                    "Nicholas",
                    "Eric",
                    "Stephen",
                    "Jacob",
                    "Larry",
                    "Jonathan",
                    "Scott",
                    "Raymond",
                    "Justin",
                    "Brandon",
                    "Gregory",
                    "Samuel",
                    "Benjamin",
                    "Patrick",
                    "Jack",
                    "Henry",
                    "Walter",
                    "Dennis",
                    "Jerry",
                    "Alexander",
                    "Peter",
                    "Tyler",
                    "Douglas",
                    "Harold",
                    "Aaron",
                    "Jose",
                    "Adam",
                    "Arthur",
                    "Zachary",
                    "Carl",
                    "Nathan",
                    "Albert",
                    "Kyle",
                    "Lawrence",
                    "Joe",
                    "Willie",
                    "Gerald",
                    "Roger",
                    "Keith",
                    "Jeremy",
                    "Terry",
                    "Harry",
                    "Ralph",
                    "Sean",
                    "Jesse",
                    "Roy",
                    "Louis",
                    "Billy",
                    "Austin",
                    "Bruce",
                    "Eugene",
                    "Christian",
                    "Bryan",
                    "Wayne",
                    "Russell",
                    "Howard",
                    "Fred",
                    "Ethan",
                    "Jordan",
                    "Philip",
                    "Alan",
                    "Juan",
                    "Randy",
                    "Vincent",
                    "Bobby",
                    "Dylan",
                    "Johnny",
                    "Phillip",
                    "Victor",
                    "Clarence",
                    "Ernest",
                    "Martin",
                    "Craig",
                    "Stanley",
                    "Shawn",
                    "Travis",
                    "Bradley",
                    "Leonard",
                    "Earl",
                    "Gabriel",
                    "Jimmy",
                    "Francis",
                    "Todd",
                    "Noah",
                    "Danny",
                    "Dale",
                    "Cody",
                    "Carlos",
                    "Allen",
                    "Frederick",
                    "Logan",
                    "Curtis",
                    "Alex",
                    "Joel",
                    "Luis",
                    "Norman",
                    "Marvin",
                    "Glenn",
                    "Tony",
                    "Nathaniel",
                    "Rodney",
                    "Melvin",
                    "Alfred",
                    "Steve",
                    "Cameron",
                    "Chad",
                    "Edwin",
                    "Caleb",
                    "Evan",
                    "Antonio",
                    "Lee",
                    "Herbert",
                    "Jeffery",
                    "Isaac",
                    "Derek",
                    "Ricky",
                    "Marcus",
                    "Theodore",
                    "Elijah",
                    "Luke",
                    "Jesus",
                    "Eddie",
                    "Troy",
                    "Mike",
                    "Dustin",
                    "Ray",
                    "Adrian",
                    "Bernard",
                    "Leroy",
                    "Angel",
                    "Randall",
                    "Wesley",
                    "Ian",
                    "Jared",
                    "Mason",
                    "Hunter",
                    "Calvin",
                    "Oscar",
                    "Clifford",
                    "Jay",
                    "Shane",
                    "Ronnie",
                    "Barry",
                    "Lucas",
                    "Corey",
                    "Manuel",
                    "Leo",
                    "Tommy",
                    "Warren",
                    "Jackson",
                    "Isaiah",
                    "Connor",
                    "Don",
                    "Dean",
                    "Jon",
                    "Julian",
                    "Miguel",
                    "Bill",
                    "Lloyd",
                    "Charlie",
                    "Mitchell",
                    "Leon",
                    "Jerome",
                    "Darrell",
                    "Jeremiah",
                    "Alvin",
                    "Brett",
                    "Seth",
                    "Floyd",
                    "Jim",
                    "Blake",
                    "Micheal",
                    "Gordon",
                    "Trevor",
                    "Lewis",
                    "Erik",
                    "Edgar",
                    "Vernon",
                    "Devin",
                    "Gavin",
                    "Jayden",
                    "Chris",
                    "Clyde",
                    "Tom",
                    "Derrick",
                    "Mario",
                    "Brent",
                    "Marc",
                    "Herman",
                    "Chase",
                    "Dominic",
                    "Ricardo",
                    "Franklin",
                    "Maurice",
                    "Max",
                    "Aiden",
                    "Owen",
                    "Lester",
                    "Gilbert",
                    "Elmer",
                    "Gene",
                    "Francisco",
                    "Glen",
                    "Cory",
                    "Garrett",
                    "Clayton",
                    "Sam",
                    "Jorge",
                    "Chester",
                    "Alejandro",
                    "Jeff",
                    "Harvey",
                    "Milton",
                    "Cole",
                    "Ivan",
                    "Andre",
                    "Duane",
                    "Landon"
                ],
                // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0163
                "it": [
                    "Adolfo",
                    "Alberto",
                    "Aldo",
                    "Alessandro",
                    "Alessio",
                    "Alfredo",
                    "Alvaro",
                    "Andrea",
                    "Angelo",
                    "Angiolo",
                    "Antonino",
                    "Antonio",
                    "Attilio",
                    "Benito",
                    "Bernardo",
                    "Bruno",
                    "Carlo",
                    "Cesare",
                    "Christian",
                    "Claudio",
                    "Corrado",
                    "Cosimo",
                    "Cristian",
                    "Cristiano",
                    "Daniele",
                    "Dario",
                    "David",
                    "Davide",
                    "Diego",
                    "Dino",
                    "Domenico",
                    "Duccio",
                    "Edoardo",
                    "Elia",
                    "Elio",
                    "Emanuele",
                    "Emiliano",
                    "Emilio",
                    "Enrico",
                    "Enzo",
                    "Ettore",
                    "Fabio",
                    "Fabrizio",
                    "Federico",
                    "Ferdinando",
                    "Fernando",
                    "Filippo",
                    "Francesco",
                    "Franco",
                    "Gabriele",
                    "Giacomo",
                    "Giampaolo",
                    "Giampiero",
                    "Giancarlo",
                    "Gianfranco",
                    "Gianluca",
                    "Gianmarco",
                    "Gianni",
                    "Gino",
                    "Giorgio",
                    "Giovanni",
                    "Giuliano",
                    "Giulio",
                    "Giuseppe",
                    "Graziano",
                    "Gregorio",
                    "Guido",
                    "Iacopo",
                    "Jacopo",
                    "Lapo",
                    "Leonardo",
                    "Lorenzo",
                    "Luca",
                    "Luciano",
                    "Luigi",
                    "Manuel",
                    "Marcello",
                    "Marco",
                    "Marino",
                    "Mario",
                    "Massimiliano",
                    "Massimo",
                    "Matteo",
                    "Mattia",
                    "Maurizio",
                    "Mauro",
                    "Michele",
                    "Mirko",
                    "Mohamed",
                    "Nello",
                    "Neri",
                    "Niccol\xf2",
                    "Nicola",
                    "Osvaldo",
                    "Otello",
                    "Paolo",
                    "Pier Luigi",
                    "Piero",
                    "Pietro",
                    "Raffaele",
                    "Remo",
                    "Renato",
                    "Renzo",
                    "Riccardo",
                    "Roberto",
                    "Rolando",
                    "Romano",
                    "Salvatore",
                    "Samuele",
                    "Sandro",
                    "Sergio",
                    "Silvano",
                    "Simone",
                    "Stefano",
                    "Thomas",
                    "Tommaso",
                    "Ubaldo",
                    "Ugo",
                    "Umberto",
                    "Valerio",
                    "Valter",
                    "Vasco",
                    "Vincenzo",
                    "Vittorio"
                ],
                // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
                "nl": [
                    "Aaron",
                    "Abel",
                    "Adam",
                    "Adriaan",
                    "Albert",
                    "Alexander",
                    "Ali",
                    "Arjen",
                    "Arno",
                    "Bart",
                    "Bas",
                    "Bastiaan",
                    "Benjamin",
                    "Bob",
                    "Boris",
                    "Bram",
                    "Brent",
                    "Cas",
                    "Casper",
                    "Chris",
                    "Christiaan",
                    "Cornelis",
                    "Daan",
                    "Daley",
                    "Damian",
                    "Dani",
                    "Daniel",
                    "Dani\xebl",
                    "David",
                    "Dean",
                    "Dirk",
                    "Dylan",
                    "Egbert",
                    "Elijah",
                    "Erik",
                    "Erwin",
                    "Evert",
                    "Ezra",
                    "Fabian",
                    "Fedde",
                    "Finn",
                    "Florian",
                    "Floris",
                    "Frank",
                    "Frans",
                    "Frederik",
                    "Freek",
                    "Geert",
                    "Gerard",
                    "Gerben",
                    "Gerrit",
                    "Gijs",
                    "Guus",
                    "Hans",
                    "Hendrik",
                    "Henk",
                    "Herman",
                    "Hidde",
                    "Hugo",
                    "Jaap",
                    "Jan Jaap",
                    "Jan-Willem",
                    "Jack",
                    "Jacob",
                    "Jan",
                    "Jason",
                    "Jasper",
                    "Jayden",
                    "Jelle",
                    "Jelte",
                    "Jens",
                    "Jeroen",
                    "Jesse",
                    "Jim",
                    "Job",
                    "Joep",
                    "Johannes",
                    "John",
                    "Jonathan",
                    "Joris",
                    "Joshua",
                    "Jo\xebl",
                    "Julian",
                    "Kees",
                    "Kevin",
                    "Koen",
                    "Lars",
                    "Laurens",
                    "Leendert",
                    "Lennard",
                    "Lodewijk",
                    "Luc",
                    "Luca",
                    "Lucas",
                    "Lukas",
                    "Luuk",
                    "Maarten",
                    "Marcus",
                    "Martijn",
                    "Martin",
                    "Matthijs",
                    "Maurits",
                    "Max",
                    "Mees",
                    "Melle",
                    "Mick",
                    "Mika",
                    "Milan",
                    "Mohamed",
                    "Mohammed",
                    "Morris",
                    "Muhammed",
                    "Nathan",
                    "Nick",
                    "Nico",
                    "Niek",
                    "Niels",
                    "Noah",
                    "Noud",
                    "Olivier",
                    "Oscar",
                    "Owen",
                    "Paul",
                    "Pepijn",
                    "Peter",
                    "Pieter",
                    "Pim",
                    "Quinten",
                    "Reinier",
                    "Rens",
                    "Robin",
                    "Ruben",
                    "Sam",
                    "Samuel",
                    "Sander",
                    "Sebastiaan",
                    "Sem",
                    "Sep",
                    "Sepp",
                    "Siem",
                    "Simon",
                    "Stan",
                    "Stef",
                    "Steven",
                    "Stijn",
                    "Sven",
                    "Teun",
                    "Thijmen",
                    "Thijs",
                    "Thomas",
                    "Tijn",
                    "Tim",
                    "Timo",
                    "Tobias",
                    "Tom",
                    "Victor",
                    "Vince",
                    "Willem",
                    "Wim",
                    "Wouter",
                    "Yusuf"
                ],
                // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
                "fr": [
                    "Aaron",
                    "Abdon",
                    "Abel",
                    "Ab\xe9lard",
                    "Abelin",
                    "Abondance",
                    "Abraham",
                    "Absalon",
                    "Acace",
                    "Achaire",
                    "Achille",
                    "Adalard",
                    "Adalbald",
                    "Adalb\xe9ron",
                    "Adalbert",
                    "Adalric",
                    "Adam",
                    "Adegrin",
                    "Adel",
                    "Adelin",
                    "Andelin",
                    "Adelphe",
                    "Adam",
                    "Ad\xe9odat",
                    "Adh\xe9mar",
                    "Adjutor",
                    "Adolphe",
                    "Adonis",
                    "Adon",
                    "Adrien",
                    "Agapet",
                    "Agathange",
                    "Agathon",
                    "Agilbert",
                    "Ag\xe9nor",
                    "Agnan",
                    "Aignan",
                    "Agrippin",
                    "Aimable",
                    "Aim\xe9",
                    "Alain",
                    "Alban",
                    "Albin",
                    "Aubin",
                    "Alb\xe9ric",
                    "Albert",
                    "Albertet",
                    "Alcibiade",
                    "Alcide",
                    "Alc\xe9e",
                    "Alcime",
                    "Aldonce",
                    "Aldric",
                    "Ald\xe9ric",
                    "Aleaume",
                    "Alexandre",
                    "Alexis",
                    "Alix",
                    "Alliaume",
                    "Aleaume",
                    "Almine",
                    "Almire",
                    "Alo\xefs",
                    "Alph\xe9e",
                    "Alphonse",
                    "Alpinien",
                    "Alver\xe8de",
                    "Amalric",
                    "Amaury",
                    "Amandin",
                    "Amant",
                    "Ambroise",
                    "Am\xe9d\xe9e",
                    "Am\xe9lien",
                    "Amiel",
                    "Amour",
                    "Ana\xebl",
                    "Anastase",
                    "Anatole",
                    "Ancelin",
                    "And\xe9ol",
                    "Andoche",
                    "Andr\xe9",
                    "Andoche",
                    "Ange",
                    "Angelin",
                    "Angilbe",
                    "Anglebert",
                    "Angoustan",
                    "Anicet",
                    "Anne",
                    "Annibal",
                    "Ansbert",
                    "Anselme",
                    "Anthelme",
                    "Antheaume",
                    "Anthime",
                    "Antide",
                    "Antoine",
                    "Antonius",
                    "Antonin",
                    "Apollinaire",
                    "Apollon",
                    "Aquilin",
                    "Arcade",
                    "Archambaud",
                    "Archambeau",
                    "Archange",
                    "Archibald",
                    "Arian",
                    "Ariel",
                    "Ariste",
                    "Aristide",
                    "Armand",
                    "Armel",
                    "Armin",
                    "Arnould",
                    "Arnaud",
                    "Arolde",
                    "Ars\xe8ne",
                    "Arsino\xe9",
                    "Arthaud",
                    "Arth\xe8me",
                    "Arthur",
                    "Ascelin",
                    "Athanase",
                    "Aubry",
                    "Audebert",
                    "Audouin",
                    "Audran",
                    "Audric",
                    "Auguste",
                    "Augustin",
                    "Aur\xe8le",
                    "Aur\xe9lien",
                    "Aurian",
                    "Auxence",
                    "Axel",
                    "Aymard",
                    "Aymeric",
                    "Aymon",
                    "Aymond",
                    "Balthazar",
                    "Baptiste",
                    "Barnab\xe9",
                    "Barth\xe9lemy",
                    "Bartim\xe9e",
                    "Basile",
                    "Bastien",
                    "Baudouin",
                    "B\xe9nigne",
                    "Benjamin",
                    "Beno\xeet",
                    "B\xe9renger",
                    "B\xe9rard",
                    "Bernard",
                    "Bertrand",
                    "Blaise",
                    "Bon",
                    "Boniface",
                    "Bouchard",
                    "Brice",
                    "Brieuc",
                    "Bruno",
                    "Brunon",
                    "Calixte",
                    "Calliste",
                    "Cam\xe9lien",
                    "Camille",
                    "Camillien",
                    "Candide",
                    "Caribert",
                    "Carloman",
                    "Cassandre",
                    "Cassien",
                    "C\xe9dric",
                    "C\xe9leste",
                    "C\xe9lestin",
                    "C\xe9lien",
                    "C\xe9saire",
                    "C\xe9sar",
                    "Charles",
                    "Charlemagne",
                    "Childebert",
                    "Chilp\xe9ric",
                    "Chr\xe9tien",
                    "Christian",
                    "Christodule",
                    "Christophe",
                    "Chrysostome",
                    "Clarence",
                    "Claude",
                    "Claudien",
                    "Cl\xe9andre",
                    "Cl\xe9ment",
                    "Clotaire",
                    "C\xf4me",
                    "Constance",
                    "Constant",
                    "Constantin",
                    "Corentin",
                    "Cyprien",
                    "Cyriaque",
                    "Cyrille",
                    "Cyril",
                    "Damien",
                    "Daniel",
                    "David",
                    "Delphin",
                    "Denis",
                    "D\xe9sir\xe9",
                    "Didier",
                    "Dieudonn\xe9",
                    "Dimitri",
                    "Dominique",
                    "Dorian",
                    "Doroth\xe9e",
                    "Edgard",
                    "Edmond",
                    "\xc9douard",
                    "\xc9leuth\xe8re",
                    "\xc9lie",
                    "\xc9lis\xe9e",
                    "\xc9meric",
                    "\xc9mile",
                    "\xc9milien",
                    "Emmanuel",
                    "Enguerrand",
                    "\xc9piphane",
                    "\xc9ric",
                    "Esprit",
                    "Ernest",
                    "\xc9tienne",
                    "Eubert",
                    "Eudes",
                    "Eudoxe",
                    "Eug\xe8ne",
                    "Eus\xe8be",
                    "Eustache",
                    "\xc9variste",
                    "\xc9vrard",
                    "Fabien",
                    "Fabrice",
                    "Falba",
                    "F\xe9licit\xe9",
                    "F\xe9lix",
                    "Ferdinand",
                    "Fiacre",
                    "Fid\xe8le",
                    "Firmin",
                    "Flavien",
                    "Flodoard",
                    "Florent",
                    "Florentin",
                    "Florestan",
                    "Florian",
                    "Fortun\xe9",
                    "Foulques",
                    "Francisque",
                    "Fran\xe7ois",
                    "Fran\xe7ais",
                    "Franciscus",
                    "Francs",
                    "Fr\xe9d\xe9ric",
                    "Fulbert",
                    "Fulcran",
                    "Fulgence",
                    "Gabin",
                    "Gabriel",
                    "Ga\xebl",
                    "Garnier",
                    "Gaston",
                    "Gaspard",
                    "Gatien",
                    "Gaud",
                    "Gautier",
                    "G\xe9d\xe9on",
                    "Geoffroy",
                    "Georges",
                    "G\xe9raud",
                    "G\xe9rard",
                    "Gerbert",
                    "Germain",
                    "Gervais",
                    "Ghislain",
                    "Gilbert",
                    "Gilles",
                    "Girart",
                    "Gislebert",
                    "Gondebaud",
                    "Gonthier",
                    "Gontran",
                    "Gonzague",
                    "Gr\xe9goire",
                    "Gu\xe9rin",
                    "Gui",
                    "Guillaume",
                    "Gustave",
                    "Guy",
                    "Guyot",
                    "Hardouin",
                    "Hector",
                    "H\xe9delin",
                    "H\xe9lier",
                    "Henri",
                    "Herbert",
                    "Herluin",
                    "Herv\xe9",
                    "Hilaire",
                    "Hildebert",
                    "Hincmar",
                    "Hippolyte",
                    "Honor\xe9",
                    "Hubert",
                    "Hugues",
                    "Innocent",
                    "Isabeau",
                    "Isidore",
                    "Jacques",
                    "Japhet",
                    "Jason",
                    "Jean",
                    "Jeannel",
                    "Jeannot",
                    "J\xe9r\xe9mie",
                    "J\xe9r\xf4me",
                    "Joachim",
                    "Joanny",
                    "Job",
                    "Jocelyn",
                    "Jo\xebl",
                    "Johan",
                    "Jonas",
                    "Jonathan",
                    "Joseph",
                    "Josse",
                    "Josselin",
                    "Jourdain",
                    "Jude",
                    "Judica\xebl",
                    "Jules",
                    "Julien",
                    "Juste",
                    "Justin",
                    "Lambert",
                    "Landry",
                    "Laurent",
                    "Lazare",
                    "L\xe9andre",
                    "L\xe9on",
                    "L\xe9onard",
                    "L\xe9opold",
                    "Leu",
                    "Loup",
                    "Leufroy",
                    "Lib\xe8re",
                    "Li\xe9tald",
                    "Lionel",
                    "Lo\xefc",
                    "Longin",
                    "Lorrain",
                    "Lorraine",
                    "Lothaire",
                    "Louis",
                    "Loup",
                    "Luc",
                    "Lucas",
                    "Lucien",
                    "Ludolphe",
                    "Ludovic",
                    "Macaire",
                    "Malo",
                    "Mamert",
                    "Manass\xe9",
                    "Marc",
                    "Marceau",
                    "Marcel",
                    "Marcelin",
                    "Marius",
                    "Marseille",
                    "Martial",
                    "Martin",
                    "Mathurin",
                    "Matthias",
                    "Mathias",
                    "Matthieu",
                    "Maugis",
                    "Maurice",
                    "Mauricet",
                    "Maxence",
                    "Maxime",
                    "Maximilien",
                    "Mayeul",
                    "M\xe9d\xe9ric",
                    "Melchior",
                    "Mence",
                    "Merlin",
                    "M\xe9rov\xe9e",
                    "Micha\xebl",
                    "Michel",
                    "Mo\xefse",
                    "Morgan",
                    "Nathan",
                    "Nathana\xebl",
                    "Narcisse",
                    "N\xe9h\xe9mie",
                    "Nestor",
                    "Nestor",
                    "Nic\xe9phore",
                    "Nicolas",
                    "No\xe9",
                    "No\xebl",
                    "Norbert",
                    "Normand",
                    "Normands",
                    "Octave",
                    "Odilon",
                    "Odon",
                    "Oger",
                    "Olivier",
                    "Oury",
                    "Pac\xf4me",
                    "Pal\xe9mon",
                    "Parfait",
                    "Pascal",
                    "Paterne",
                    "Patrice",
                    "Paul",
                    "P\xe9pin",
                    "Perceval",
                    "Phil\xe9mon",
                    "Philibert",
                    "Philippe",
                    "Philoth\xe9e",
                    "Pie",
                    "Pierre",
                    "Pierrick",
                    "Prosper",
                    "Quentin",
                    "Raoul",
                    "Rapha\xebl",
                    "Raymond",
                    "R\xe9gis",
                    "R\xe9jean",
                    "R\xe9mi",
                    "Renaud",
                    "Ren\xe9",
                    "Reybaud",
                    "Richard",
                    "Robert",
                    "Roch",
                    "Rodolphe",
                    "Rodrigue",
                    "Roger",
                    "Roland",
                    "Romain",
                    "Romuald",
                    "Rom\xe9o",
                    "Rome",
                    "Ronan",
                    "Roselin",
                    "Salomon",
                    "Samuel",
                    "Savin",
                    "Savinien",
                    "Scholastique",
                    "S\xe9bastien",
                    "S\xe9raphin",
                    "Serge",
                    "S\xe9verin",
                    "Sidoine",
                    "Sigebert",
                    "Sigismond",
                    "Silv\xe8re",
                    "Simon",
                    "Sim\xe9on",
                    "Sixte",
                    "Stanislas",
                    "St\xe9phane",
                    "Stephan",
                    "Sylvain",
                    "Sylvestre",
                    "Tancr\xe8de",
                    "Tanguy",
                    "Taurin",
                    "Th\xe9odore",
                    "Th\xe9odose",
                    "Th\xe9ophile",
                    "Th\xe9ophraste",
                    "Thibault",
                    "Thibert",
                    "Thierry",
                    "Thomas",
                    "Timol\xe9on",
                    "Timoth\xe9e",
                    "Titien",
                    "Tonnin",
                    "Toussaint",
                    "Trajan",
                    "Tristan",
                    "Turold",
                    "Tim",
                    "Ulysse",
                    "Urbain",
                    "Valentin",
                    "Val\xe8re",
                    "Val\xe9ry",
                    "Venance",
                    "Venant",
                    "Venceslas",
                    "Vianney",
                    "Victor",
                    "Victorien",
                    "Victorin",
                    "Vigile",
                    "Vincent",
                    "Vital",
                    "Vitalien",
                    "Vivien",
                    "Waleran",
                    "Wandrille",
                    "Xavier",
                    "X\xe9nophon",
                    "Yves",
                    "Zacharie",
                    "Zach\xe9",
                    "Z\xe9phirin"
                ]
            },
            "female": {
                "en": [
                    "Mary",
                    "Emma",
                    "Elizabeth",
                    "Minnie",
                    "Margaret",
                    "Ida",
                    "Alice",
                    "Bertha",
                    "Sarah",
                    "Annie",
                    "Clara",
                    "Ella",
                    "Florence",
                    "Cora",
                    "Martha",
                    "Laura",
                    "Nellie",
                    "Grace",
                    "Carrie",
                    "Maude",
                    "Mabel",
                    "Bessie",
                    "Jennie",
                    "Gertrude",
                    "Julia",
                    "Hattie",
                    "Edith",
                    "Mattie",
                    "Rose",
                    "Catherine",
                    "Lillian",
                    "Ada",
                    "Lillie",
                    "Helen",
                    "Jessie",
                    "Louise",
                    "Ethel",
                    "Lula",
                    "Myrtle",
                    "Eva",
                    "Frances",
                    "Lena",
                    "Lucy",
                    "Edna",
                    "Maggie",
                    "Pearl",
                    "Daisy",
                    "Fannie",
                    "Josephine",
                    "Dora",
                    "Rosa",
                    "Katherine",
                    "Agnes",
                    "Marie",
                    "Nora",
                    "May",
                    "Mamie",
                    "Blanche",
                    "Stella",
                    "Ellen",
                    "Nancy",
                    "Effie",
                    "Sallie",
                    "Nettie",
                    "Della",
                    "Lizzie",
                    "Flora",
                    "Susie",
                    "Maud",
                    "Mae",
                    "Etta",
                    "Harriet",
                    "Sadie",
                    "Caroline",
                    "Katie",
                    "Lydia",
                    "Elsie",
                    "Kate",
                    "Susan",
                    "Mollie",
                    "Alma",
                    "Addie",
                    "Georgia",
                    "Eliza",
                    "Lulu",
                    "Nannie",
                    "Lottie",
                    "Amanda",
                    "Belle",
                    "Charlotte",
                    "Rebecca",
                    "Ruth",
                    "Viola",
                    "Olive",
                    "Amelia",
                    "Hannah",
                    "Jane",
                    "Virginia",
                    "Emily",
                    "Matilda",
                    "Irene",
                    "Kathryn",
                    "Esther",
                    "Willie",
                    "Henrietta",
                    "Ollie",
                    "Amy",
                    "Rachel",
                    "Sara",
                    "Estella",
                    "Theresa",
                    "Augusta",
                    "Ora",
                    "Pauline",
                    "Josie",
                    "Lola",
                    "Sophia",
                    "Leona",
                    "Anne",
                    "Mildred",
                    "Ann",
                    "Beulah",
                    "Callie",
                    "Lou",
                    "Delia",
                    "Eleanor",
                    "Barbara",
                    "Iva",
                    "Louisa",
                    "Maria",
                    "Mayme",
                    "Evelyn",
                    "Estelle",
                    "Nina",
                    "Betty",
                    "Marion",
                    "Bettie",
                    "Dorothy",
                    "Luella",
                    "Inez",
                    "Lela",
                    "Rosie",
                    "Allie",
                    "Millie",
                    "Janie",
                    "Cornelia",
                    "Victoria",
                    "Ruby",
                    "Winifred",
                    "Alta",
                    "Celia",
                    "Christine",
                    "Beatrice",
                    "Birdie",
                    "Harriett",
                    "Mable",
                    "Myra",
                    "Sophie",
                    "Tillie",
                    "Isabel",
                    "Sylvia",
                    "Carolyn",
                    "Isabelle",
                    "Leila",
                    "Sally",
                    "Ina",
                    "Essie",
                    "Bertie",
                    "Nell",
                    "Alberta",
                    "Katharine",
                    "Lora",
                    "Rena",
                    "Mina",
                    "Rhoda",
                    "Mathilda",
                    "Abbie",
                    "Eula",
                    "Dollie",
                    "Hettie",
                    "Eunice",
                    "Fanny",
                    "Ola",
                    "Lenora",
                    "Adelaide",
                    "Christina",
                    "Lelia",
                    "Nelle",
                    "Sue",
                    "Johanna",
                    "Lilly",
                    "Lucinda",
                    "Minerva",
                    "Lettie",
                    "Roxie",
                    "Cynthia",
                    "Helena",
                    "Hilda",
                    "Hulda",
                    "Bernice",
                    "Genevieve",
                    "Jean",
                    "Cordelia",
                    "Marian",
                    "Francis",
                    "Jeanette",
                    "Adeline",
                    "Gussie",
                    "Leah",
                    "Lois",
                    "Lura",
                    "Mittie",
                    "Hallie",
                    "Isabella",
                    "Olga",
                    "Phoebe",
                    "Teresa",
                    "Hester",
                    "Lida",
                    "Lina",
                    "Winnie",
                    "Claudia",
                    "Marguerite",
                    "Vera",
                    "Cecelia",
                    "Bess",
                    "Emilie",
                    "Rosetta",
                    "Verna",
                    "Myrtie",
                    "Cecilia",
                    "Elva",
                    "Olivia",
                    "Ophelia",
                    "Georgie",
                    "Elnora",
                    "Violet",
                    "Adele",
                    "Lily",
                    "Linnie",
                    "Loretta",
                    "Madge",
                    "Polly",
                    "Virgie",
                    "Eugenia",
                    "Lucile",
                    "Lucille",
                    "Mabelle",
                    "Rosalie"
                ],
                // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0162
                "it": [
                    "Ada",
                    "Adriana",
                    "Alessandra",
                    "Alessia",
                    "Alice",
                    "Angela",
                    "Anna",
                    "Anna Maria",
                    "Annalisa",
                    "Annita",
                    "Annunziata",
                    "Antonella",
                    "Arianna",
                    "Asia",
                    "Assunta",
                    "Aurora",
                    "Barbara",
                    "Beatrice",
                    "Benedetta",
                    "Bianca",
                    "Bruna",
                    "Camilla",
                    "Carla",
                    "Carlotta",
                    "Carmela",
                    "Carolina",
                    "Caterina",
                    "Catia",
                    "Cecilia",
                    "Chiara",
                    "Cinzia",
                    "Clara",
                    "Claudia",
                    "Costanza",
                    "Cristina",
                    "Daniela",
                    "Debora",
                    "Diletta",
                    "Dina",
                    "Donatella",
                    "Elena",
                    "Eleonora",
                    "Elisa",
                    "Elisabetta",
                    "Emanuela",
                    "Emma",
                    "Eva",
                    "Federica",
                    "Fernanda",
                    "Fiorella",
                    "Fiorenza",
                    "Flora",
                    "Franca",
                    "Francesca",
                    "Gabriella",
                    "Gaia",
                    "Gemma",
                    "Giada",
                    "Gianna",
                    "Gina",
                    "Ginevra",
                    "Giorgia",
                    "Giovanna",
                    "Giulia",
                    "Giuliana",
                    "Giuseppa",
                    "Giuseppina",
                    "Grazia",
                    "Graziella",
                    "Greta",
                    "Ida",
                    "Ilaria",
                    "Ines",
                    "Iolanda",
                    "Irene",
                    "Irma",
                    "Isabella",
                    "Jessica",
                    "Laura",
                    "Lea",
                    "Letizia",
                    "Licia",
                    "Lidia",
                    "Liliana",
                    "Lina",
                    "Linda",
                    "Lisa",
                    "Livia",
                    "Loretta",
                    "Luana",
                    "Lucia",
                    "Luciana",
                    "Lucrezia",
                    "Luisa",
                    "Manuela",
                    "Mara",
                    "Marcella",
                    "Margherita",
                    "Maria",
                    "Maria Cristina",
                    "Maria Grazia",
                    "Maria Luisa",
                    "Maria Pia",
                    "Maria Teresa",
                    "Marina",
                    "Marisa",
                    "Marta",
                    "Martina",
                    "Marzia",
                    "Matilde",
                    "Melissa",
                    "Michela",
                    "Milena",
                    "Mirella",
                    "Monica",
                    "Natalina",
                    "Nella",
                    "Nicoletta",
                    "Noemi",
                    "Olga",
                    "Paola",
                    "Patrizia",
                    "Piera",
                    "Pierina",
                    "Raffaella",
                    "Rebecca",
                    "Renata",
                    "Rina",
                    "Rita",
                    "Roberta",
                    "Rosa",
                    "Rosanna",
                    "Rossana",
                    "Rossella",
                    "Sabrina",
                    "Sandra",
                    "Sara",
                    "Serena",
                    "Silvana",
                    "Silvia",
                    "Simona",
                    "Simonetta",
                    "Sofia",
                    "Sonia",
                    "Stefania",
                    "Susanna",
                    "Teresa",
                    "Tina",
                    "Tiziana",
                    "Tosca",
                    "Valentina",
                    "Valeria",
                    "Vanda",
                    "Vanessa",
                    "Vanna",
                    "Vera",
                    "Veronica",
                    "Vilma",
                    "Viola",
                    "Virginia",
                    "Vittoria"
                ],
                // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
                "nl": [
                    "Ada",
                    "Arianne",
                    "Afke",
                    "Amanda",
                    "Amber",
                    "Amy",
                    "Aniek",
                    "Anita",
                    "Anja",
                    "Anna",
                    "Anne",
                    "Annelies",
                    "Annemarie",
                    "Annette",
                    "Anouk",
                    "Astrid",
                    "Aukje",
                    "Barbara",
                    "Bianca",
                    "Carla",
                    "Carlijn",
                    "Carolien",
                    "Chantal",
                    "Charlotte",
                    "Claudia",
                    "Dani\xeblle",
                    "Debora",
                    "Diane",
                    "Dora",
                    "Eline",
                    "Elise",
                    "Ella",
                    "Ellen",
                    "Emma",
                    "Esmee",
                    "Evelien",
                    "Esther",
                    "Erica",
                    "Eva",
                    "Femke",
                    "Fleur",
                    "Floor",
                    "Froukje",
                    "Gea",
                    "Gerda",
                    "Hanna",
                    "Hanneke",
                    "Heleen",
                    "Hilde",
                    "Ilona",
                    "Ina",
                    "Inge",
                    "Ingrid",
                    "Iris",
                    "Isabel",
                    "Isabelle",
                    "Janneke",
                    "Jasmijn",
                    "Jeanine",
                    "Jennifer",
                    "Jessica",
                    "Johanna",
                    "Joke",
                    "Julia",
                    "Julie",
                    "Karen",
                    "Karin",
                    "Katja",
                    "Kim",
                    "Lara",
                    "Laura",
                    "Lena",
                    "Lianne",
                    "Lieke",
                    "Lilian",
                    "Linda",
                    "Lisa",
                    "Lisanne",
                    "Lotte",
                    "Louise",
                    "Maaike",
                    "Manon",
                    "Marga",
                    "Maria",
                    "Marissa",
                    "Marit",
                    "Marjolein",
                    "Martine",
                    "Marleen",
                    "Melissa",
                    "Merel",
                    "Miranda",
                    "Michelle",
                    "Mirjam",
                    "Mirthe",
                    "Naomi",
                    "Natalie",
                    'Nienke',
                    "Nina",
                    "Noortje",
                    "Olivia",
                    "Patricia",
                    "Paula",
                    "Paulien",
                    "Ramona",
                    "Ria",
                    "Rianne",
                    "Roos",
                    "Rosanne",
                    "Ruth",
                    "Sabrina",
                    "Sandra",
                    "Sanne",
                    "Sara",
                    "Saskia",
                    "Silvia",
                    "Sofia",
                    "Sophie",
                    "Sonja",
                    "Suzanne",
                    "Tamara",
                    "Tess",
                    "Tessa",
                    "Tineke",
                    "Valerie",
                    "Vanessa",
                    "Veerle",
                    "Vera",
                    "Victoria",
                    "Wendy",
                    "Willeke",
                    "Yvonne",
                    "Zo\xeb"
                ],
                // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
                "fr": [
                    "Abdon",
                    "Abel",
                    "Abiga\xeblle",
                    "Abiga\xefl",
                    "Acacius",
                    "Acanthe",
                    "Adalbert",
                    "Adalsinde",
                    "Adegrine",
                    "Ad\xe9la\xefde",
                    "Ad\xe8le",
                    "Ad\xe9lie",
                    "Adeline",
                    "Adeltrude",
                    "Adolphe",
                    "Adonis",
                    "Adrast\xe9e",
                    "Adrehilde",
                    "Adrienne",
                    "Agathe",
                    "Agilbert",
                    "Agla\xe9",
                    "Aignan",
                    "Agnefl\xe8te",
                    "Agn\xe8s",
                    "Agrippine",
                    "Aim\xe9",
                    "Alaine",
                    "Ala\xefs",
                    "Albane",
                    "Alb\xe9rade",
                    "Alberte",
                    "Alcide",
                    "Alcine",
                    "Alcyone",
                    "Aldegonde",
                    "Aleth",
                    "Alexandrine",
                    "Alexine",
                    "Alice",
                    "Ali\xe9nor",
                    "Aliette",
                    "Aline",
                    "Alix",
                    "Aliz\xe9",
                    "Alo\xefse",
                    "Aloyse",
                    "Alphonsine",
                    "Alth\xe9e",
                    "Amaliane",
                    "Amalth\xe9e",
                    "Amande",
                    "Amandine",
                    "Amant",
                    "Amarande",
                    "Amaranthe",
                    "Amaryllis",
                    "Ambre",
                    "Ambroisie",
                    "Am\xe9lie",
                    "Am\xe9thyste",
                    "Aminte",
                    "Ana\xebl",
                    "Ana\xefs",
                    "Anastasie",
                    "Anatole",
                    "Ancelin",
                    "Andr\xe9e",
                    "An\xe9mone",
                    "Angadr\xeame",
                    "Ang\xe8le",
                    "Angeline",
                    "Ang\xe9lique",
                    "Angilbert",
                    "Anicet",
                    "Annabelle",
                    "Anne",
                    "Annette",
                    "Annick",
                    "Annie",
                    "Annonciade",
                    "Ansbert",
                    "Anstrudie",
                    "Anthelme",
                    "Antigone",
                    "Antoinette",
                    "Antonine",
                    "Aph\xe9lie",
                    "Apolline",
                    "Apollonie",
                    "Aquiline",
                    "Arabelle",
                    "Arcadie",
                    "Archange",
                    "Argine",
                    "Ariane",
                    "Aricie",
                    "Ariel",
                    "Arielle",
                    "Arlette",
                    "Armance",
                    "Armande",
                    "Armandine",
                    "Armelle",
                    "Armide",
                    "Armelle",
                    "Armin",
                    "Arnaud",
                    "Ars\xe8ne",
                    "Arsino\xe9",
                    "Art\xe9mis",
                    "Arthur",
                    "Ascelin",
                    "Ascension",
                    "Assomption",
                    "Astart\xe9",
                    "Ast\xe9rie",
                    "Astr\xe9e",
                    "Astrid",
                    "Athalie",
                    "Athanasie",
                    "Athina",
                    "Aube",
                    "Albert",
                    "Aude",
                    "Audrey",
                    "Augustine",
                    "Aure",
                    "Aur\xe9lie",
                    "Aur\xe9lien",
                    "Aur\xe8le",
                    "Aurore",
                    "Auxence",
                    "Aveline",
                    "Abiga\xeblle",
                    "Avoye",
                    "Axelle",
                    "Aymard",
                    "Azal\xe9e",
                    "Ad\xe8le",
                    "Adeline",
                    "Barbe",
                    "Basilisse",
                    "Bathilde",
                    "B\xe9atrice",
                    "B\xe9atrix",
                    "B\xe9n\xe9dicte",
                    "B\xe9reng\xe8re",
                    "Bernadette",
                    "Berthe",
                    "Bertille",
                    "Beuve",
                    "Blanche",
                    "Blanc",
                    "Blandine",
                    "Brigitte",
                    "Brune",
                    "Brunehilde",
                    "Callista",
                    "Camille",
                    "Capucine",
                    "Carine",
                    "Caroline",
                    "Cassandre",
                    "Catherine",
                    "C\xe9cile",
                    "C\xe9leste",
                    "C\xe9lestine",
                    "C\xe9line",
                    "Chantal",
                    "Charl\xe8ne",
                    "Charline",
                    "Charlotte",
                    "Chlo\xe9",
                    "Christelle",
                    "Christiane",
                    "Christine",
                    "Claire",
                    "Clara",
                    "Claude",
                    "Claudine",
                    "Clarisse",
                    "Cl\xe9mence",
                    "Cl\xe9mentine",
                    "Cl\xe9o",
                    "Clio",
                    "Clotilde",
                    "Coline",
                    "Conception",
                    "Constance",
                    "Coralie",
                    "Coraline",
                    "Corentine",
                    "Corinne",
                    "Cyrielle",
                    "Daniel",
                    "Daniel",
                    "Daphn\xe9",
                    "D\xe9bora",
                    "Delphine",
                    "Denise",
                    "Diane",
                    "Dieudonn\xe9",
                    "Dominique",
                    "Doriane",
                    "Doroth\xe9e",
                    "Douce",
                    "\xc9dith",
                    "Edm\xe9e",
                    "\xc9l\xe9onore",
                    "\xc9liane",
                    "\xc9lia",
                    "\xc9liette",
                    "\xc9lisabeth",
                    "\xc9lise",
                    "Ella",
                    "\xc9lodie",
                    "\xc9lo\xefse",
                    "Elsa",
                    "\xc9meline",
                    "\xc9m\xe9rance",
                    "\xc9m\xe9rentienne",
                    "\xc9m\xe9rencie",
                    "\xc9milie",
                    "Emma",
                    "Emmanuelle",
                    "Emmelie",
                    "Ernestine",
                    "Esther",
                    "Estelle",
                    "Eudoxie",
                    "Eug\xe9nie",
                    "Eulalie",
                    "Euphrasie",
                    "Eus\xe9bie",
                    "\xc9vang\xe9line",
                    "Eva",
                    "\xc8ve",
                    "\xc9velyne",
                    "Fanny",
                    "Fantine",
                    "Faustine",
                    "F\xe9licie",
                    "Fernande",
                    "Flavie",
                    "Fleur",
                    "Flore",
                    "Florence",
                    "Florie",
                    "Fortun\xe9",
                    "France",
                    "Francia",
                    "Fran\xe7oise",
                    "Francine",
                    "Gabrielle",
                    "Ga\xeblle",
                    "Garance",
                    "Genevi\xe8ve",
                    "Georgette",
                    "Gerberge",
                    "Germaine",
                    "Gertrude",
                    "Gis\xe8le",
                    "Gueni\xe8vre",
                    "Guilhemine",
                    "Guillemette",
                    "Gustave",
                    "Gwenael",
                    "H\xe9l\xe8ne",
                    "H\xe9lo\xefse",
                    "Henriette",
                    "Hermine",
                    "Hermione",
                    "Hippolyte",
                    "Honorine",
                    "Hortense",
                    "Huguette",
                    "Ines",
                    "Ir\xe8ne",
                    "Irina",
                    "Iris",
                    "Isabeau",
                    "Isabelle",
                    "Iseult",
                    "Isolde",
                    "Ism\xe9rie",
                    "Jacinthe",
                    "Jacqueline",
                    "Jade",
                    "Janine",
                    "Jeanne",
                    "Jocelyne",
                    "Jo\xeblle",
                    "Jos\xe9phine",
                    "Judith",
                    "Julia",
                    "Julie",
                    "Jules",
                    "Juliette",
                    "Justine",
                    "Katy",
                    "Kathy",
                    "Katie",
                    "Laura",
                    "Laure",
                    "Laureline",
                    "Laurence",
                    "Laurene",
                    "Lauriane",
                    "Laurianne",
                    "Laurine",
                    "L\xe9a",
                    "L\xe9na",
                    "L\xe9onie",
                    "L\xe9on",
                    "L\xe9ontine",
                    "Lorraine",
                    "Lucie",
                    "Lucienne",
                    "Lucille",
                    "Ludivine",
                    "Lydie",
                    "Lydie",
                    "Megane",
                    "Madeleine",
                    "Magali",
                    "Maguelone",
                    "Mallaury",
                    "Manon",
                    "Marceline",
                    "Margot",
                    "Marguerite",
                    "Marianne",
                    "Marie",
                    "Myriam",
                    "Marie",
                    "Marine",
                    "Marion",
                    "Marl\xe8ne",
                    "Marthe",
                    "Martine",
                    "Mathilde",
                    "Maud",
                    "Maureen",
                    "Mauricette",
                    "Maxime",
                    "M\xe9lanie",
                    "Melissa",
                    "M\xe9lissandre",
                    "M\xe9lisande",
                    "M\xe9lodie",
                    "Michel",
                    "Micheline",
                    "Mireille",
                    "Miriam",
                    "Mo\xefse",
                    "Monique",
                    "Morgane",
                    "Muriel",
                    "Myl\xe8ne",
                    "Nad\xe8ge",
                    "Nadine",
                    "Nathalie",
                    "Nicole",
                    "Nicolette",
                    "Nine",
                    "No\xebl",
                    "No\xe9mie",
                    "Oc\xe9ane",
                    "Odette",
                    "Odile",
                    "Olive",
                    "Olivia",
                    "Olympe",
                    "Ombline",
                    "Ombeline",
                    "Oph\xe9lie",
                    "Oriande",
                    "Oriane",
                    "Ozanne",
                    "Pascale",
                    "Pascaline",
                    "Paule",
                    "Paulette",
                    "Pauline",
                    "Priscille",
                    "Prisca",
                    "Prisque",
                    "P\xe9cine",
                    "P\xe9lagie",
                    "P\xe9n\xe9lope",
                    "Perrine",
                    "P\xe9tronille",
                    "Philippine",
                    "Philom\xe8ne",
                    "Philoth\xe9e",
                    "Primerose",
                    "Prudence",
                    "Pulch\xe9rie",
                    "Quentine",
                    "Qui\xe9ta",
                    "Quintia",
                    "Quintilla",
                    "Rachel",
                    "Rapha\xeblle",
                    "Raymonde",
                    "Rebecca",
                    "R\xe9gine",
                    "R\xe9jeanne",
                    "Ren\xe9",
                    "Rita",
                    "Rita",
                    "Rolande",
                    "Romane",
                    "Rosalie",
                    "Rose",
                    "Roseline",
                    "Sabine",
                    "Salom\xe9",
                    "Sandra",
                    "Sandrine",
                    "Sarah",
                    "S\xe9gol\xe8ne",
                    "S\xe9verine",
                    "Sibylle",
                    "Simone",
                    "Sixt",
                    "Solange",
                    "Soline",
                    "Sol\xe8ne",
                    "Sophie",
                    "St\xe9phanie",
                    "Suzanne",
                    "Sylvain",
                    "Sylvie",
                    "Tatiana",
                    "Tha\xefs",
                    "Th\xe9odora",
                    "Th\xe9r\xe8se",
                    "Tiphaine",
                    "Ursule",
                    "Valentine",
                    "Val\xe9rie",
                    "V\xe9ronique",
                    "Victoire",
                    "Victorine",
                    "Vinciane",
                    "Violette",
                    "Virginie",
                    "Viviane",
                    "Xavi\xe8re",
                    "Yolande",
                    "Ysaline",
                    "Yvette",
                    "Yvonne",
                    "Z\xe9lie",
                    "Zita",
                    "Zo\xe9"
                ]
            }
        },
        lastNames: {
            "en": [
                'Smith',
                'Johnson',
                'Williams',
                'Jones',
                'Brown',
                'Davis',
                'Miller',
                'Wilson',
                'Moore',
                'Taylor',
                'Anderson',
                'Thomas',
                'Jackson',
                'White',
                'Harris',
                'Martin',
                'Thompson',
                'Garcia',
                'Martinez',
                'Robinson',
                'Clark',
                'Rodriguez',
                'Lewis',
                'Lee',
                'Walker',
                'Hall',
                'Allen',
                'Young',
                'Hernandez',
                'King',
                'Wright',
                'Lopez',
                'Hill',
                'Scott',
                'Green',
                'Adams',
                'Baker',
                'Gonzalez',
                'Nelson',
                'Carter',
                'Mitchell',
                'Perez',
                'Roberts',
                'Turner',
                'Phillips',
                'Campbell',
                'Parker',
                'Evans',
                'Edwards',
                'Collins',
                'Stewart',
                'Sanchez',
                'Morris',
                'Rogers',
                'Reed',
                'Cook',
                'Morgan',
                'Bell',
                'Murphy',
                'Bailey',
                'Rivera',
                'Cooper',
                'Richardson',
                'Cox',
                'Howard',
                'Ward',
                'Torres',
                'Peterson',
                'Gray',
                'Ramirez',
                'James',
                'Watson',
                'Brooks',
                'Kelly',
                'Sanders',
                'Price',
                'Bennett',
                'Wood',
                'Barnes',
                'Ross',
                'Henderson',
                'Coleman',
                'Jenkins',
                'Perry',
                'Powell',
                'Long',
                'Patterson',
                'Hughes',
                'Flores',
                'Washington',
                'Butler',
                'Simmons',
                'Foster',
                'Gonzales',
                'Bryant',
                'Alexander',
                'Russell',
                'Griffin',
                'Diaz',
                'Hayes',
                'Myers',
                'Ford',
                'Hamilton',
                'Graham',
                'Sullivan',
                'Wallace',
                'Woods',
                'Cole',
                'West',
                'Jordan',
                'Owens',
                'Reynolds',
                'Fisher',
                'Ellis',
                'Harrison',
                'Gibson',
                'McDonald',
                'Cruz',
                'Marshall',
                'Ortiz',
                'Gomez',
                'Murray',
                'Freeman',
                'Wells',
                'Webb',
                'Simpson',
                'Stevens',
                'Tucker',
                'Porter',
                'Hunter',
                'Hicks',
                'Crawford',
                'Henry',
                'Boyd',
                'Mason',
                'Morales',
                'Kennedy',
                'Warren',
                'Dixon',
                'Ramos',
                'Reyes',
                'Burns',
                'Gordon',
                'Shaw',
                'Holmes',
                'Rice',
                'Robertson',
                'Hunt',
                'Black',
                'Daniels',
                'Palmer',
                'Mills',
                'Nichols',
                'Grant',
                'Knight',
                'Ferguson',
                'Rose',
                'Stone',
                'Hawkins',
                'Dunn',
                'Perkins',
                'Hudson',
                'Spencer',
                'Gardner',
                'Stephens',
                'Payne',
                'Pierce',
                'Berry',
                'Matthews',
                'Arnold',
                'Wagner',
                'Willis',
                'Ray',
                'Watkins',
                'Olson',
                'Carroll',
                'Duncan',
                'Snyder',
                'Hart',
                'Cunningham',
                'Bradley',
                'Lane',
                'Andrews',
                'Ruiz',
                'Harper',
                'Fox',
                'Riley',
                'Armstrong',
                'Carpenter',
                'Weaver',
                'Greene',
                'Lawrence',
                'Elliott',
                'Chavez',
                'Sims',
                'Austin',
                'Peters',
                'Kelley',
                'Franklin',
                'Lawson',
                'Fields',
                'Gutierrez',
                'Ryan',
                'Schmidt',
                'Carr',
                'Vasquez',
                'Castillo',
                'Wheeler',
                'Chapman',
                'Oliver',
                'Montgomery',
                'Richards',
                'Williamson',
                'Johnston',
                'Banks',
                'Meyer',
                'Bishop',
                'McCoy',
                'Howell',
                'Alvarez',
                'Morrison',
                'Hansen',
                'Fernandez',
                'Garza',
                'Harvey',
                'Little',
                'Burton',
                'Stanley',
                'Nguyen',
                'George',
                'Jacobs',
                'Reid',
                'Kim',
                'Fuller',
                'Lynch',
                'Dean',
                'Gilbert',
                'Garrett',
                'Romero',
                'Welch',
                'Larson',
                'Frazier',
                'Burke',
                'Hanson',
                'Day',
                'Mendoza',
                'Moreno',
                'Bowman',
                'Medina',
                'Fowler',
                'Brewer',
                'Hoffman',
                'Carlson',
                'Silva',
                'Pearson',
                'Holland',
                'Douglas',
                'Fleming',
                'Jensen',
                'Vargas',
                'Byrd',
                'Davidson',
                'Hopkins',
                'May',
                'Terry',
                'Herrera',
                'Wade',
                'Soto',
                'Walters',
                'Curtis',
                'Neal',
                'Caldwell',
                'Lowe',
                'Jennings',
                'Barnett',
                'Graves',
                'Jimenez',
                'Horton',
                'Shelton',
                'Barrett',
                'Obrien',
                'Castro',
                'Sutton',
                'Gregory',
                'McKinney',
                'Lucas',
                'Miles',
                'Craig',
                'Rodriquez',
                'Chambers',
                'Holt',
                'Lambert',
                'Fletcher',
                'Watts',
                'Bates',
                'Hale',
                'Rhodes',
                'Pena',
                'Beck',
                'Newman',
                'Haynes',
                'McDaniel',
                'Mendez',
                'Bush',
                'Vaughn',
                'Parks',
                'Dawson',
                'Santiago',
                'Norris',
                'Hardy',
                'Love',
                'Steele',
                'Curry',
                'Powers',
                'Schultz',
                'Barker',
                'Guzman',
                'Page',
                'Munoz',
                'Ball',
                'Keller',
                'Chandler',
                'Weber',
                'Leonard',
                'Walsh',
                'Lyons',
                'Ramsey',
                'Wolfe',
                'Schneider',
                'Mullins',
                'Benson',
                'Sharp',
                'Bowen',
                'Daniel',
                'Barber',
                'Cummings',
                'Hines',
                'Baldwin',
                'Griffith',
                'Valdez',
                'Hubbard',
                'Salazar',
                'Reeves',
                'Warner',
                'Stevenson',
                'Burgess',
                'Santos',
                'Tate',
                'Cross',
                'Garner',
                'Mann',
                'Mack',
                'Moss',
                'Thornton',
                'Dennis',
                'McGee',
                'Farmer',
                'Delgado',
                'Aguilar',
                'Vega',
                'Glover',
                'Manning',
                'Cohen',
                'Harmon',
                'Rodgers',
                'Robbins',
                'Newton',
                'Todd',
                'Blair',
                'Higgins',
                'Ingram',
                'Reese',
                'Cannon',
                'Strickland',
                'Townsend',
                'Potter',
                'Goodwin',
                'Walton',
                'Rowe',
                'Hampton',
                'Ortega',
                'Patton',
                'Swanson',
                'Joseph',
                'Francis',
                'Goodman',
                'Maldonado',
                'Yates',
                'Becker',
                'Erickson',
                'Hodges',
                'Rios',
                'Conner',
                'Adkins',
                'Webster',
                'Norman',
                'Malone',
                'Hammond',
                'Flowers',
                'Cobb',
                'Moody',
                'Quinn',
                'Blake',
                'Maxwell',
                'Pope',
                'Floyd',
                'Osborne',
                'Paul',
                'McCarthy',
                'Guerrero',
                'Lindsey',
                'Estrada',
                'Sandoval',
                'Gibbs',
                'Tyler',
                'Gross',
                'Fitzgerald',
                'Stokes',
                'Doyle',
                'Sherman',
                'Saunders',
                'Wise',
                'Colon',
                'Gill',
                'Alvarado',
                'Greer',
                'Padilla',
                'Simon',
                'Waters',
                'Nunez',
                'Ballard',
                'Schwartz',
                'McBride',
                'Houston',
                'Christensen',
                'Klein',
                'Pratt',
                'Briggs',
                'Parsons',
                'McLaughlin',
                'Zimmerman',
                'French',
                'Buchanan',
                'Moran',
                'Copeland',
                'Roy',
                'Pittman',
                'Brady',
                'McCormick',
                'Holloway',
                'Brock',
                'Poole',
                'Frank',
                'Logan',
                'Owen',
                'Bass',
                'Marsh',
                'Drake',
                'Wong',
                'Jefferson',
                'Park',
                'Morton',
                'Abbott',
                'Sparks',
                'Patrick',
                'Norton',
                'Huff',
                'Clayton',
                'Massey',
                'Lloyd',
                'Figueroa',
                'Carson',
                'Bowers',
                'Roberson',
                'Barton',
                'Tran',
                'Lamb',
                'Harrington',
                'Casey',
                'Boone',
                'Cortez',
                'Clarke',
                'Mathis',
                'Singleton',
                'Wilkins',
                'Cain',
                'Bryan',
                'Underwood',
                'Hogan',
                'McKenzie',
                'Collier',
                'Luna',
                'Phelps',
                'McGuire',
                'Allison',
                'Bridges',
                'Wilkerson',
                'Nash',
                'Summers',
                'Atkins'
            ],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0164 (first 1000)
            "it": [
                "Acciai",
                "Aglietti",
                "Agostini",
                "Agresti",
                "Ahmed",
                "Aiazzi",
                "Albanese",
                "Alberti",
                "Alessi",
                "Alfani",
                "Alinari",
                "Alterini",
                "Amato",
                "Ammannati",
                "Ancillotti",
                "Andrei",
                "Andreini",
                "Andreoni",
                "Angeli",
                "Anichini",
                "Antonelli",
                "Antonini",
                "Arena",
                "Ariani",
                "Arnetoli",
                "Arrighi",
                "Baccani",
                "Baccetti",
                "Bacci",
                "Bacherini",
                "Badii",
                "Baggiani",
                "Baglioni",
                "Bagni",
                "Bagnoli",
                "Baldassini",
                "Baldi",
                "Baldini",
                "Ballerini",
                "Balli",
                "Ballini",
                "Balloni",
                "Bambi",
                "Banchi",
                "Bandinelli",
                "Bandini",
                "Bani",
                "Barbetti",
                "Barbieri",
                "Barchielli",
                "Bardazzi",
                "Bardelli",
                "Bardi",
                "Barducci",
                "Bargellini",
                "Bargiacchi",
                "Barni",
                "Baroncelli",
                "Baroncini",
                "Barone",
                "Baroni",
                "Baronti",
                "Bartalesi",
                "Bartoletti",
                "Bartoli",
                "Bartolini",
                "Bartoloni",
                "Bartolozzi",
                "Basagni",
                "Basile",
                "Bassi",
                "Batacchi",
                "Battaglia",
                "Battaglini",
                "Bausi",
                "Becagli",
                "Becattini",
                "Becchi",
                "Becucci",
                "Bellandi",
                "Bellesi",
                "Belli",
                "Bellini",
                "Bellucci",
                "Bencini",
                "Benedetti",
                "Benelli",
                "Beni",
                "Benini",
                "Bensi",
                "Benucci",
                "Benvenuti",
                "Berlincioni",
                "Bernacchioni",
                "Bernardi",
                "Bernardini",
                "Berni",
                "Bernini",
                "Bertelli",
                "Berti",
                "Bertini",
                "Bessi",
                "Betti",
                "Bettini",
                "Biagi",
                "Biagini",
                "Biagioni",
                "Biagiotti",
                "Biancalani",
                "Bianchi",
                "Bianchini",
                "Bianco",
                "Biffoli",
                "Bigazzi",
                "Bigi",
                "Biliotti",
                "Billi",
                "Binazzi",
                "Bindi",
                "Bini",
                "Biondi",
                "Bizzarri",
                "Bocci",
                "Bogani",
                "Bolognesi",
                "Bonaiuti",
                "Bonanni",
                "Bonciani",
                "Boncinelli",
                "Bondi",
                "Bonechi",
                "Bongini",
                "Boni",
                "Bonini",
                "Borchi",
                "Boretti",
                "Borghi",
                "Borghini",
                "Borgioli",
                "Borri",
                "Borselli",
                "Boschi",
                "Bottai",
                "Bracci",
                "Braccini",
                "Brandi",
                "Braschi",
                "Bravi",
                "Brazzini",
                "Breschi",
                "Brilli",
                "Brizzi",
                "Brogelli",
                "Brogi",
                "Brogioni",
                "Brunelli",
                "Brunetti",
                "Bruni",
                "Bruno",
                "Brunori",
                "Bruschi",
                "Bucci",
                "Bucciarelli",
                "Buccioni",
                "Bucelli",
                "Bulli",
                "Burberi",
                "Burchi",
                "Burgassi",
                "Burroni",
                "Bussotti",
                "Buti",
                "Caciolli",
                "Caiani",
                "Calabrese",
                "Calamai",
                "Calamandrei",
                "Caldini",
                "Calo'",
                "Calonaci",
                "Calosi",
                "Calvelli",
                "Cambi",
                "Camiciottoli",
                "Cammelli",
                "Cammilli",
                "Campolmi",
                "Cantini",
                "Capanni",
                "Capecchi",
                "Caponi",
                "Cappelletti",
                "Cappelli",
                "Cappellini",
                "Cappugi",
                "Capretti",
                "Caputo",
                "Carbone",
                "Carboni",
                "Cardini",
                "Carlesi",
                "Carletti",
                "Carli",
                "Caroti",
                "Carotti",
                "Carrai",
                "Carraresi",
                "Carta",
                "Caruso",
                "Casalini",
                "Casati",
                "Caselli",
                "Casini",
                "Castagnoli",
                "Castellani",
                "Castelli",
                "Castellucci",
                "Catalano",
                "Catarzi",
                "Catelani",
                "Cavaciocchi",
                "Cavallaro",
                "Cavallini",
                "Cavicchi",
                "Cavini",
                "Ceccarelli",
                "Ceccatelli",
                "Ceccherelli",
                "Ceccherini",
                "Cecchi",
                "Cecchini",
                "Cecconi",
                "Cei",
                "Cellai",
                "Celli",
                "Cellini",
                "Cencetti",
                "Ceni",
                "Cenni",
                "Cerbai",
                "Cesari",
                "Ceseri",
                "Checcacci",
                "Checchi",
                "Checcucci",
                "Cheli",
                "Chellini",
                "Chen",
                "Cheng",
                "Cherici",
                "Cherubini",
                "Chiaramonti",
                "Chiarantini",
                "Chiarelli",
                "Chiari",
                "Chiarini",
                "Chiarugi",
                "Chiavacci",
                "Chiesi",
                "Chimenti",
                "Chini",
                "Chirici",
                "Chiti",
                "Ciabatti",
                "Ciampi",
                "Cianchi",
                "Cianfanelli",
                "Cianferoni",
                "Ciani",
                "Ciapetti",
                "Ciappi",
                "Ciardi",
                "Ciatti",
                "Cicali",
                "Ciccone",
                "Cinelli",
                "Cini",
                "Ciobanu",
                "Ciolli",
                "Cioni",
                "Cipriani",
                "Cirillo",
                "Cirri",
                "Ciucchi",
                "Ciuffi",
                "Ciulli",
                "Ciullini",
                "Clemente",
                "Cocchi",
                "Cognome",
                "Coli",
                "Collini",
                "Colombo",
                "Colzi",
                "Comparini",
                "Conforti",
                "Consigli",
                "Conte",
                "Conti",
                "Contini",
                "Coppini",
                "Coppola",
                "Corsi",
                "Corsini",
                "Corti",
                "Cortini",
                "Cosi",
                "Costa",
                "Costantini",
                "Costantino",
                "Cozzi",
                "Cresci",
                "Crescioli",
                "Cresti",
                "Crini",
                "Curradi",
                "D'Agostino",
                "D'Alessandro",
                "D'Amico",
                "D'Angelo",
                "Daddi",
                "Dainelli",
                "Dallai",
                "Danti",
                "Davitti",
                "De Angelis",
                "De Luca",
                "De Marco",
                "De Rosa",
                "De Santis",
                "De Simone",
                "De Vita",
                "Degl'Innocenti",
                "Degli Innocenti",
                "Dei",
                "Del Lungo",
                "Del Re",
                "Di Marco",
                "Di Stefano",
                "Dini",
                "Diop",
                "Dobre",
                "Dolfi",
                "Donati",
                "Dondoli",
                "Dong",
                "Donnini",
                "Ducci",
                "Dumitru",
                "Ermini",
                "Esposito",
                "Evangelisti",
                "Fabbri",
                "Fabbrini",
                "Fabbrizzi",
                "Fabbroni",
                "Fabbrucci",
                "Fabiani",
                "Facchini",
                "Faggi",
                "Fagioli",
                "Failli",
                "Faini",
                "Falciani",
                "Falcini",
                "Falcone",
                "Fallani",
                "Falorni",
                "Falsini",
                "Falugiani",
                "Fancelli",
                "Fanelli",
                "Fanetti",
                "Fanfani",
                "Fani",
                "Fantappie'",
                "Fantechi",
                "Fanti",
                "Fantini",
                "Fantoni",
                "Farina",
                "Fattori",
                "Favilli",
                "Fedi",
                "Fei",
                "Ferrante",
                "Ferrara",
                "Ferrari",
                "Ferraro",
                "Ferretti",
                "Ferri",
                "Ferrini",
                "Ferroni",
                "Fiaschi",
                "Fibbi",
                "Fiesoli",
                "Filippi",
                "Filippini",
                "Fini",
                "Fioravanti",
                "Fiore",
                "Fiorentini",
                "Fiorini",
                "Fissi",
                "Focardi",
                "Foggi",
                "Fontana",
                "Fontanelli",
                "Fontani",
                "Forconi",
                "Formigli",
                "Forte",
                "Forti",
                "Fortini",
                "Fossati",
                "Fossi",
                "Francalanci",
                "Franceschi",
                "Franceschini",
                "Franchi",
                "Franchini",
                "Franci",
                "Francini",
                "Francioni",
                "Franco",
                "Frassineti",
                "Frati",
                "Fratini",
                "Frilli",
                "Frizzi",
                "Frosali",
                "Frosini",
                "Frullini",
                "Fusco",
                "Fusi",
                "Gabbrielli",
                "Gabellini",
                "Gagliardi",
                "Galanti",
                "Galardi",
                "Galeotti",
                "Galletti",
                "Galli",
                "Gallo",
                "Gallori",
                "Gambacciani",
                "Gargani",
                "Garofalo",
                "Garuglieri",
                "Gashi",
                "Gasperini",
                "Gatti",
                "Gelli",
                "Gensini",
                "Gentile",
                "Gentili",
                "Geri",
                "Gerini",
                "Gheri",
                "Ghini",
                "Giachetti",
                "Giachi",
                "Giacomelli",
                "Gianassi",
                "Giani",
                "Giannelli",
                "Giannetti",
                "Gianni",
                "Giannini",
                "Giannoni",
                "Giannotti",
                "Giannozzi",
                "Gigli",
                "Giordano",
                "Giorgetti",
                "Giorgi",
                "Giovacchini",
                "Giovannelli",
                "Giovannetti",
                "Giovannini",
                "Giovannoni",
                "Giuliani",
                "Giunti",
                "Giuntini",
                "Giusti",
                "Gonnelli",
                "Goretti",
                "Gori",
                "Gradi",
                "Gramigni",
                "Grassi",
                "Grasso",
                "Graziani",
                "Grazzini",
                "Greco",
                "Grifoni",
                "Grillo",
                "Grimaldi",
                "Grossi",
                "Gualtieri",
                "Guarducci",
                "Guarino",
                "Guarnieri",
                "Guasti",
                "Guerra",
                "Guerri",
                "Guerrini",
                "Guidi",
                "Guidotti",
                "He",
                "Hoxha",
                "Hu",
                "Huang",
                "Iandelli",
                "Ignesti",
                "Innocenti",
                "Jin",
                "La Rosa",
                "Lai",
                "Landi",
                "Landini",
                "Lanini",
                "Lapi",
                "Lapini",
                "Lari",
                "Lascialfari",
                "Lastrucci",
                "Latini",
                "Lazzeri",
                "Lazzerini",
                "Lelli",
                "Lenzi",
                "Leonardi",
                "Leoncini",
                "Leone",
                "Leoni",
                "Lepri",
                "Li",
                "Liao",
                "Lin",
                "Linari",
                "Lippi",
                "Lisi",
                "Livi",
                "Lombardi",
                "Lombardini",
                "Lombardo",
                "Longo",
                "Lopez",
                "Lorenzi",
                "Lorenzini",
                "Lorini",
                "Lotti",
                "Lu",
                "Lucchesi",
                "Lucherini",
                "Lunghi",
                "Lupi",
                "Madiai",
                "Maestrini",
                "Maffei",
                "Maggi",
                "Maggini",
                "Magherini",
                "Magini",
                "Magnani",
                "Magnelli",
                "Magni",
                "Magnolfi",
                "Magrini",
                "Malavolti",
                "Malevolti",
                "Manca",
                "Mancini",
                "Manetti",
                "Manfredi",
                "Mangani",
                "Mannelli",
                "Manni",
                "Mannini",
                "Mannucci",
                "Manuelli",
                "Manzini",
                "Marcelli",
                "Marchese",
                "Marchetti",
                "Marchi",
                "Marchiani",
                "Marchionni",
                "Marconi",
                "Marcucci",
                "Margheri",
                "Mari",
                "Mariani",
                "Marilli",
                "Marinai",
                "Marinari",
                "Marinelli",
                "Marini",
                "Marino",
                "Mariotti",
                "Marsili",
                "Martelli",
                "Martinelli",
                "Martini",
                "Martino",
                "Marzi",
                "Masi",
                "Masini",
                "Masoni",
                "Massai",
                "Materassi",
                "Mattei",
                "Matteini",
                "Matteucci",
                "Matteuzzi",
                "Mattioli",
                "Mattolini",
                "Matucci",
                "Mauro",
                "Mazzanti",
                "Mazzei",
                "Mazzetti",
                "Mazzi",
                "Mazzini",
                "Mazzocchi",
                "Mazzoli",
                "Mazzoni",
                "Mazzuoli",
                "Meacci",
                "Mecocci",
                "Meini",
                "Melani",
                "Mele",
                "Meli",
                "Mengoni",
                "Menichetti",
                "Meoni",
                "Merlini",
                "Messeri",
                "Messina",
                "Meucci",
                "Miccinesi",
                "Miceli",
                "Micheli",
                "Michelini",
                "Michelozzi",
                "Migliori",
                "Migliorini",
                "Milani",
                "Miniati",
                "Misuri",
                "Monaco",
                "Montagnani",
                "Montagni",
                "Montanari",
                "Montelatici",
                "Monti",
                "Montigiani",
                "Montini",
                "Morandi",
                "Morandini",
                "Morelli",
                "Moretti",
                "Morganti",
                "Mori",
                "Morini",
                "Moroni",
                "Morozzi",
                "Mugnai",
                "Mugnaini",
                "Mustafa",
                "Naldi",
                "Naldini",
                "Nannelli",
                "Nanni",
                "Nannini",
                "Nannucci",
                "Nardi",
                "Nardini",
                "Nardoni",
                "Natali",
                "Ndiaye",
                "Nencetti",
                "Nencini",
                "Nencioni",
                "Neri",
                "Nesi",
                "Nesti",
                "Niccolai",
                "Niccoli",
                "Niccolini",
                "Nigi",
                "Nistri",
                "Nocentini",
                "Noferini",
                "Novelli",
                "Nucci",
                "Nuti",
                "Nutini",
                "Oliva",
                "Olivieri",
                "Olmi",
                "Orlandi",
                "Orlandini",
                "Orlando",
                "Orsini",
                "Ortolani",
                "Ottanelli",
                "Pacciani",
                "Pace",
                "Paci",
                "Pacini",
                "Pagani",
                "Pagano",
                "Paggetti",
                "Pagliai",
                "Pagni",
                "Pagnini",
                "Paladini",
                "Palagi",
                "Palchetti",
                "Palloni",
                "Palmieri",
                "Palumbo",
                "Pampaloni",
                "Pancani",
                "Pandolfi",
                "Pandolfini",
                "Panerai",
                "Panichi",
                "Paoletti",
                "Paoli",
                "Paolini",
                "Papi",
                "Papini",
                "Papucci",
                "Parenti",
                "Parigi",
                "Parisi",
                "Parri",
                "Parrini",
                "Pasquini",
                "Passeri",
                "Pecchioli",
                "Pecorini",
                "Pellegrini",
                "Pepi",
                "Perini",
                "Perrone",
                "Peruzzi",
                "Pesci",
                "Pestelli",
                "Petri",
                "Petrini",
                "Petrucci",
                "Pettini",
                "Pezzati",
                "Pezzatini",
                "Piani",
                "Piazza",
                "Piazzesi",
                "Piazzini",
                "Piccardi",
                "Picchi",
                "Piccini",
                "Piccioli",
                "Pieraccini",
                "Pieraccioni",
                "Pieralli",
                "Pierattini",
                "Pieri",
                "Pierini",
                "Pieroni",
                "Pietrini",
                "Pini",
                "Pinna",
                "Pinto",
                "Pinzani",
                "Pinzauti",
                "Piras",
                "Pisani",
                "Pistolesi",
                "Poggesi",
                "Poggi",
                "Poggiali",
                "Poggiolini",
                "Poli",
                "Pollastri",
                "Porciani",
                "Pozzi",
                "Pratellesi",
                "Pratesi",
                "Prosperi",
                "Pruneti",
                "Pucci",
                "Puccini",
                "Puccioni",
                "Pugi",
                "Pugliese",
                "Puliti",
                "Querci",
                "Quercioli",
                "Raddi",
                "Radu",
                "Raffaelli",
                "Ragazzini",
                "Ranfagni",
                "Ranieri",
                "Rastrelli",
                "Raugei",
                "Raveggi",
                "Renai",
                "Renzi",
                "Rettori",
                "Ricci",
                "Ricciardi",
                "Ridi",
                "Ridolfi",
                "Rigacci",
                "Righi",
                "Righini",
                "Rinaldi",
                "Risaliti",
                "Ristori",
                "Rizzo",
                "Rocchi",
                "Rocchini",
                "Rogai",
                "Romagnoli",
                "Romanelli",
                "Romani",
                "Romano",
                "Romei",
                "Romeo",
                "Romiti",
                "Romoli",
                "Romolini",
                "Rontini",
                "Rosati",
                "Roselli",
                "Rosi",
                "Rossetti",
                "Rossi",
                "Rossini",
                "Rovai",
                "Ruggeri",
                "Ruggiero",
                "Russo",
                "Sabatini",
                "Saccardi",
                "Sacchetti",
                "Sacchi",
                "Sacco",
                "Salerno",
                "Salimbeni",
                "Salucci",
                "Salvadori",
                "Salvestrini",
                "Salvi",
                "Salvini",
                "Sanesi",
                "Sani",
                "Sanna",
                "Santi",
                "Santini",
                "Santoni",
                "Santoro",
                "Santucci",
                "Sardi",
                "Sarri",
                "Sarti",
                "Sassi",
                "Sbolci",
                "Scali",
                "Scarpelli",
                "Scarselli",
                "Scopetani",
                "Secci",
                "Selvi",
                "Senatori",
                "Senesi",
                "Serafini",
                "Sereni",
                "Serra",
                "Sestini",
                "Sguanci",
                "Sieni",
                "Signorini",
                "Silvestri",
                "Simoncini",
                "Simonetti",
                "Simoni",
                "Singh",
                "Sodi",
                "Soldi",
                "Somigli",
                "Sorbi",
                "Sorelli",
                "Sorrentino",
                "Sottili",
                "Spina",
                "Spinelli",
                "Staccioli",
                "Staderini",
                "Stefanelli",
                "Stefani",
                "Stefanini",
                "Stella",
                "Susini",
                "Tacchi",
                "Tacconi",
                "Taddei",
                "Tagliaferri",
                "Tamburini",
                "Tanganelli",
                "Tani",
                "Tanini",
                "Tapinassi",
                "Tarchi",
                "Tarchiani",
                "Targioni",
                "Tassi",
                "Tassini",
                "Tempesti",
                "Terzani",
                "Tesi",
                "Testa",
                "Testi",
                "Tilli",
                "Tinti",
                "Tirinnanzi",
                "Toccafondi",
                "Tofanari",
                "Tofani",
                "Tognaccini",
                "Tonelli",
                "Tonini",
                "Torelli",
                "Torrini",
                "Tosi",
                "Toti",
                "Tozzi",
                "Trambusti",
                "Trapani",
                "Tucci",
                "Turchi",
                "Ugolini",
                "Ulivi",
                "Valente",
                "Valenti",
                "Valentini",
                "Vangelisti",
                "Vanni",
                "Vannini",
                "Vannoni",
                "Vannozzi",
                "Vannucchi",
                "Vannucci",
                "Ventura",
                "Venturi",
                "Venturini",
                "Vestri",
                "Vettori",
                "Vichi",
                "Viciani",
                "Vieri",
                "Vigiani",
                "Vignoli",
                "Vignolini",
                "Vignozzi",
                "Villani",
                "Vinci",
                "Visani",
                "Vitale",
                "Vitali",
                "Viti",
                "Viviani",
                "Vivoli",
                "Volpe",
                "Volpi",
                "Wang",
                "Wu",
                "Xu",
                "Yang",
                "Ye",
                "Zagli",
                "Zani",
                "Zanieri",
                "Zanobini",
                "Zecchi",
                "Zetti",
                "Zhang",
                "Zheng",
                "Zhou",
                "Zhu",
                "Zingoni",
                "Zini",
                "Zoppi"
            ],
            // http://www.voornamelijk.nl/meest-voorkomende-achternamen-in-nederland-en-amsterdam/
            "nl": [
                "Albers",
                "Alblas",
                "Appelman",
                "Baars",
                "Baas",
                "Bakker",
                "Blank",
                "Bleeker",
                "Blok",
                "Blom",
                "Boer",
                "Boers",
                "Boldewijn",
                "Boon",
                "Boot",
                "Bos",
                "Bosch",
                "Bosma",
                "Bosman",
                "Bouma",
                "Bouman",
                "Bouwman",
                "Brands",
                "Brouwer",
                "Burger",
                "Buijs",
                "Buitenhuis",
                "Ceder",
                "Cohen",
                "Dekker",
                "Dekkers",
                "Dijkman",
                "Dijkstra",
                "Driessen",
                "Drost",
                "Engel",
                "Evers",
                "Faber",
                "Franke",
                "Gerritsen",
                "Goedhart",
                "Goossens",
                "Groen",
                "Groenenberg",
                "Groot",
                "Haan",
                "Hart",
                "Heemskerk",
                "Hendriks",
                "Hermans",
                "Hoekstra",
                "Hofman",
                "Hopman",
                "Huisman",
                "Jacobs",
                "Jansen",
                "Janssen",
                "Jonker",
                "Jaspers",
                "Keijzer",
                "Klaassen",
                "Klein",
                "Koek",
                "Koenders",
                "Kok",
                "Kool",
                "Koopman",
                "Koopmans",
                "Koning",
                "Koster",
                "Kramer",
                "Kroon",
                "Kuijpers",
                "Kuiper",
                "Kuipers",
                "Kurt",
                "Koster",
                "Kwakman",
                "Los",
                "Lubbers",
                "Maas",
                "Markus",
                "Martens",
                "Meijer",
                "Mol",
                "Molenaar",
                "Mulder",
                "Nieuwenhuis",
                "Peeters",
                "Peters",
                "Pengel",
                "Pieters",
                "Pool",
                "Post",
                "Postma",
                "Prins",
                "Pronk",
                "Reijnders",
                "Rietveld",
                "Roest",
                "Roos",
                "Sanders",
                "Schaap",
                "Scheffer",
                "Schenk",
                "Schilder",
                "Schipper",
                "Schmidt",
                "Scholten",
                "Schouten",
                "Schut",
                "Schutte",
                "Schuurman",
                "Simons",
                "Smeets",
                "Smit",
                "Smits",
                "Snel",
                "Swinkels",
                "Tas",
                "Terpstra",
                "Timmermans",
                "Tol",
                "Tromp",
                "Troost",
                "Valk",
                "Veenstra",
                "Veldkamp",
                "Verbeek",
                "Verheul",
                "Verhoeven",
                "Vermeer",
                "Vermeulen",
                "Verweij",
                "Vink",
                "Visser",
                "Voorn",
                "Vos",
                "Wagenaar",
                "Wiersema",
                "Willems",
                "Willemsen",
                "Witteveen",
                "Wolff",
                "Wolters",
                "Zijlstra",
                "Zwart",
                "de Beer",
                "de Boer",
                "de Bruijn",
                "de Bruin",
                "de Graaf",
                "de Groot",
                "de Haan",
                "de Haas",
                "de Jager",
                "de Jong",
                "de Jonge",
                "de Koning",
                "de Lange",
                "de Leeuw",
                "de Ridder",
                "de Rooij",
                "de Ruiter",
                "de Vos",
                "de Vries",
                "de Waal",
                "de Wit",
                "de Zwart",
                "van Beek",
                "van Boven",
                "van Dam",
                "van Dijk",
                "van Dongen",
                "van Doorn",
                "van Egmond",
                "van Eijk",
                "van Es",
                "van Gelder",
                "van Gelderen",
                "van Houten",
                "van Hulst",
                "van Kempen",
                "van Kesteren",
                "van Leeuwen",
                "van Loon",
                "van Mill",
                "van Noord",
                "van Ommen",
                "van Ommeren",
                "van Oosten",
                "van Oostveen",
                "van Rijn",
                "van Schaik",
                "van Veen",
                "van Vliet",
                "van Wijk",
                "van Wijngaarden",
                "van den Poel",
                "van de Pol",
                "van den Ploeg",
                "van de Ven",
                "van den Berg",
                "van den Bosch",
                "van den Brink",
                "van den Broek",
                "van den Heuvel",
                "van der Heijden",
                "van der Horst",
                "van der Hulst",
                "van der Kroon",
                "van der Laan",
                "van der Linden",
                "van der Meer",
                "van der Meij",
                "van der Meulen",
                "van der Molen",
                "van der Sluis",
                "van der Spek",
                "van der Veen",
                "van der Velde",
                "van der Velden",
                "van der Vliet",
                "van der Wal"
            ],
            // https://surnames.behindthename.com/top/lists/england-wales/1991
            "uk": [
                "Smith",
                "Jones",
                "Williams",
                "Taylor",
                "Brown",
                "Davies",
                "Evans",
                "Wilson",
                "Thomas",
                "Johnson",
                "Roberts",
                "Robinson",
                "Thompson",
                "Wright",
                "Walker",
                "White",
                "Edwards",
                "Hughes",
                "Green",
                "Hall",
                "Lewis",
                "Harris",
                "Clarke",
                "Patel",
                "Jackson",
                "Wood",
                "Turner",
                "Martin",
                "Cooper",
                "Hill",
                "Ward",
                "Morris",
                "Moore",
                "Clark",
                "Lee",
                "King",
                "Baker",
                "Harrison",
                "Morgan",
                "Allen",
                "James",
                "Scott",
                "Phillips",
                "Watson",
                "Davis",
                "Parker",
                "Price",
                "Bennett",
                "Young",
                "Griffiths",
                "Mitchell",
                "Kelly",
                "Cook",
                "Carter",
                "Richardson",
                "Bailey",
                "Collins",
                "Bell",
                "Shaw",
                "Murphy",
                "Miller",
                "Cox",
                "Richards",
                "Khan",
                "Marshall",
                "Anderson",
                "Simpson",
                "Ellis",
                "Adams",
                "Singh",
                "Begum",
                "Wilkinson",
                "Foster",
                "Chapman",
                "Powell",
                "Webb",
                "Rogers",
                "Gray",
                "Mason",
                "Ali",
                "Hunt",
                "Hussain",
                "Campbell",
                "Matthews",
                "Owen",
                "Palmer",
                "Holmes",
                "Mills",
                "Barnes",
                "Knight",
                "Lloyd",
                "Butler",
                "Russell",
                "Barker",
                "Fisher",
                "Stevens",
                "Jenkins",
                "Murray",
                "Dixon",
                "Harvey",
                "Graham",
                "Pearson",
                "Ahmed",
                "Fletcher",
                "Walsh",
                "Kaur",
                "Gibson",
                "Howard",
                "Andrews",
                "Stewart",
                "Elliott",
                "Reynolds",
                "Saunders",
                "Payne",
                "Fox",
                "Ford",
                "Pearce",
                "Day",
                "Brooks",
                "West",
                "Lawrence",
                "Cole",
                "Atkinson",
                "Bradley",
                "Spencer",
                "Gill",
                "Dawson",
                "Ball",
                "Burton",
                "O'brien",
                "Watts",
                "Rose",
                "Booth",
                "Perry",
                "Ryan",
                "Grant",
                "Wells",
                "Armstrong",
                "Francis",
                "Rees",
                "Hayes",
                "Hart",
                "Hudson",
                "Newman",
                "Barrett",
                "Webster",
                "Hunter",
                "Gregory",
                "Carr",
                "Lowe",
                "Page",
                "Marsh",
                "Riley",
                "Dunn",
                "Woods",
                "Parsons",
                "Berry",
                "Stone",
                "Reid",
                "Holland",
                "Hawkins",
                "Harding",
                "Porter",
                "Robertson",
                "Newton",
                "Oliver",
                "Reed",
                "Kennedy",
                "Williamson",
                "Bird",
                "Gardner",
                "Shah",
                "Dean",
                "Lane",
                "Cooke",
                "Bates",
                "Henderson",
                "Parry",
                "Burgess",
                "Bishop",
                "Walton",
                "Burns",
                "Nicholson",
                "Shepherd",
                "Ross",
                "Cross",
                "Long",
                "Freeman",
                "Warren",
                "Nicholls",
                "Hamilton",
                "Byrne",
                "Sutton",
                "Mcdonald",
                "Yates",
                "Hodgson",
                "Robson",
                "Curtis",
                "Hopkins",
                "O'connor",
                "Harper",
                "Coleman",
                "Watkins",
                "Moss",
                "Mccarthy",
                "Chambers",
                "O'neill",
                "Griffin",
                "Sharp",
                "Hardy",
                "Wheeler",
                "Potter",
                "Osborne",
                "Johnston",
                "Gordon",
                "Doyle",
                "Wallace",
                "George",
                "Jordan",
                "Hutchinson",
                "Rowe",
                "Burke",
                "May",
                "Pritchard",
                "Gilbert",
                "Willis",
                "Higgins",
                "Read",
                "Miles",
                "Stevenson",
                "Stephenson",
                "Hammond",
                "Arnold",
                "Buckley",
                "Walters",
                "Hewitt",
                "Barber",
                "Nelson",
                "Slater",
                "Austin",
                "Sullivan",
                "Whitehead",
                "Mann",
                "Frost",
                "Lambert",
                "Stephens",
                "Blake",
                "Akhtar",
                "Lynch",
                "Goodwin",
                "Barton",
                "Woodward",
                "Thomson",
                "Cunningham",
                "Quinn",
                "Barnett",
                "Baxter",
                "Bibi",
                "Clayton",
                "Nash",
                "Greenwood",
                "Jennings",
                "Holt",
                "Kemp",
                "Poole",
                "Gallagher",
                "Bond",
                "Stokes",
                "Tucker",
                "Davidson",
                "Fowler",
                "Heath",
                "Norman",
                "Middleton",
                "Lawson",
                "Banks",
                "French",
                "Stanley",
                "Jarvis",
                "Gibbs",
                "Ferguson",
                "Hayward",
                "Carroll",
                "Douglas",
                "Dickinson",
                "Todd",
                "Barlow",
                "Peters",
                "Lucas",
                "Knowles",
                "Hartley",
                "Miah",
                "Simmons",
                "Morton",
                "Alexander",
                "Field",
                "Morrison",
                "Norris",
                "Townsend",
                "Preston",
                "Hancock",
                "Thornton",
                "Baldwin",
                "Burrows",
                "Briggs",
                "Parkinson",
                "Reeves",
                "Macdonald",
                "Lamb",
                "Black",
                "Abbott",
                "Sanders",
                "Thorpe",
                "Holden",
                "Tomlinson",
                "Perkins",
                "Ashton",
                "Rhodes",
                "Fuller",
                "Howe",
                "Bryant",
                "Vaughan",
                "Dale",
                "Davey",
                "Weston",
                "Bartlett",
                "Whittaker",
                "Davison",
                "Kent",
                "Skinner",
                "Birch",
                "Morley",
                "Daniels",
                "Glover",
                "Howell",
                "Cartwright",
                "Pugh",
                "Humphreys",
                "Goddard",
                "Brennan",
                "Wall",
                "Kirby",
                "Bowen",
                "Savage",
                "Bull",
                "Wong",
                "Dobson",
                "Smart",
                "Wilkins",
                "Kirk",
                "Fraser",
                "Duffy",
                "Hicks",
                "Patterson",
                "Bradshaw",
                "Little",
                "Archer",
                "Warner",
                "Waters",
                "O'sullivan",
                "Farrell",
                "Brookes",
                "Atkins",
                "Kay",
                "Dodd",
                "Bentley",
                "Flynn",
                "John",
                "Schofield",
                "Short",
                "Haynes",
                "Wade",
                "Butcher",
                "Henry",
                "Sanderson",
                "Crawford",
                "Sheppard",
                "Bolton",
                "Coates",
                "Giles",
                "Gould",
                "Houghton",
                "Gibbons",
                "Pratt",
                "Manning",
                "Law",
                "Hooper",
                "Noble",
                "Dyer",
                "Rahman",
                "Clements",
                "Moran",
                "Sykes",
                "Chan",
                "Doherty",
                "Connolly",
                "Joyce",
                "Franklin",
                "Hobbs",
                "Coles",
                "Herbert",
                "Steele",
                "Kerr",
                "Leach",
                "Winter",
                "Owens",
                "Duncan",
                "Naylor",
                "Fleming",
                "Horton",
                "Finch",
                "Fitzgerald",
                "Randall",
                "Carpenter",
                "Marsden",
                "Browne",
                "Garner",
                "Pickering",
                "Hale",
                "Dennis",
                "Vincent",
                "Chadwick",
                "Chandler",
                "Sharpe",
                "Nolan",
                "Lyons",
                "Hurst",
                "Collier",
                "Peacock",
                "Howarth",
                "Faulkner",
                "Rice",
                "Pollard",
                "Welch",
                "Norton",
                "Gough",
                "Sinclair",
                "Blackburn",
                "Bryan",
                "Conway",
                "Power",
                "Cameron",
                "Daly",
                "Allan",
                "Hanson",
                "Gardiner",
                "Boyle",
                "Myers",
                "Turnbull",
                "Wallis",
                "Mahmood",
                "Sims",
                "Swift",
                "Iqbal",
                "Pope",
                "Brady",
                "Chamberlain",
                "Rowley",
                "Tyler",
                "Farmer",
                "Metcalfe",
                "Hilton",
                "Godfrey",
                "Holloway",
                "Parkin",
                "Bray",
                "Talbot",
                "Donnelly",
                "Nixon",
                "Charlton",
                "Benson",
                "Whitehouse",
                "Barry",
                "Hope",
                "Lord",
                "North",
                "Storey",
                "Connor",
                "Potts",
                "Bevan",
                "Hargreaves",
                "Mclean",
                "Mistry",
                "Bruce",
                "Howells",
                "Hyde",
                "Parkes",
                "Wyatt",
                "Fry",
                "Lees",
                "O'donnell",
                "Craig",
                "Forster",
                "Mckenzie",
                "Humphries",
                "Mellor",
                "Carey",
                "Ingram",
                "Summers",
                "Leonard"
            ],
            // https://surnames.behindthename.com/top/lists/germany/2017
            "de": [
                "M\xfcller",
                "Schmidt",
                "Schneider",
                "Fischer",
                "Weber",
                "Meyer",
                "Wagner",
                "Becker",
                "Schulz",
                "Hoffmann",
                "Sch\xe4fer",
                "Koch",
                "Bauer",
                "Richter",
                "Klein",
                "Wolf",
                "Schr\xf6der",
                "Neumann",
                "Schwarz",
                "Zimmermann",
                "Braun",
                "Kr\xfcger",
                "Hofmann",
                "Hartmann",
                "Lange",
                "Schmitt",
                "Werner",
                "Schmitz",
                "Krause",
                "Meier",
                "Lehmann",
                "Schmid",
                "Schulze",
                "Maier",
                "K\xf6hler",
                "Herrmann",
                "K\xf6nig",
                "Walter",
                "Mayer",
                "Huber",
                "Kaiser",
                "Fuchs",
                "Peters",
                "Lang",
                "Scholz",
                "M\xf6ller",
                "Wei\xdf",
                "Jung",
                "Hahn",
                "Schubert",
                "Vogel",
                "Friedrich",
                "Keller",
                "G\xfcnther",
                "Frank",
                "Berger",
                "Winkler",
                "Roth",
                "Beck",
                "Lorenz",
                "Baumann",
                "Franke",
                "Albrecht",
                "Schuster",
                "Simon",
                "Ludwig",
                "B\xf6hm",
                "Winter",
                "Kraus",
                "Martin",
                "Schumacher",
                "Kr\xe4mer",
                "Vogt",
                "Stein",
                "J\xe4ger",
                "Otto",
                "Sommer",
                "Gro\xdf",
                "Seidel",
                "Heinrich",
                "Brandt",
                "Haas",
                "Schreiber",
                "Graf",
                "Schulte",
                "Dietrich",
                "Ziegler",
                "Kuhn",
                "K\xfchn",
                "Pohl",
                "Engel",
                "Horn",
                "Busch",
                "Bergmann",
                "Thomas",
                "Voigt",
                "Sauer",
                "Arnold",
                "Wolff",
                "Pfeiffer"
            ],
            // http://www.japantimes.co.jp/life/2009/10/11/lifestyle/japans-top-100-most-common-family-names/
            "jp": [
                "Sato",
                "Suzuki",
                "Takahashi",
                "Tanaka",
                "Watanabe",
                "Ito",
                "Yamamoto",
                "Nakamura",
                "Kobayashi",
                "Kato",
                "Yoshida",
                "Yamada",
                "Sasaki",
                "Yamaguchi",
                "Saito",
                "Matsumoto",
                "Inoue",
                "Kimura",
                "Hayashi",
                "Shimizu",
                "Yamazaki",
                "Mori",
                "Abe",
                "Ikeda",
                "Hashimoto",
                "Yamashita",
                "Ishikawa",
                "Nakajima",
                "Maeda",
                "Fujita",
                "Ogawa",
                "Goto",
                "Okada",
                "Hasegawa",
                "Murakami",
                "Kondo",
                "Ishii",
                "Saito",
                "Sakamoto",
                "Endo",
                "Aoki",
                "Fujii",
                "Nishimura",
                "Fukuda",
                "Ota",
                "Miura",
                "Fujiwara",
                "Okamoto",
                "Matsuda",
                "Nakagawa",
                "Nakano",
                "Harada",
                "Ono",
                "Tamura",
                "Takeuchi",
                "Kaneko",
                "Wada",
                "Nakayama",
                "Ishida",
                "Ueda",
                "Morita",
                "Hara",
                "Shibata",
                "Sakai",
                "Kudo",
                "Yokoyama",
                "Miyazaki",
                "Miyamoto",
                "Uchida",
                "Takagi",
                "Ando",
                "Taniguchi",
                "Ohno",
                "Maruyama",
                "Imai",
                "Takada",
                "Fujimoto",
                "Takeda",
                "Murata",
                "Ueno",
                "Sugiyama",
                "Masuda",
                "Sugawara",
                "Hirano",
                "Kojima",
                "Otsuka",
                "Chiba",
                "Kubo",
                "Matsui",
                "Iwasaki",
                "Sakurai",
                "Kinoshita",
                "Noguchi",
                "Matsuo",
                "Nomura",
                "Kikuchi",
                "Sano",
                "Onishi",
                "Sugimoto",
                "Arai"
            ],
            // http://www.lowchensaustralia.com/names/popular-spanish-names.htm
            "es": [
                "Garcia",
                "Fernandez",
                "Lopez",
                "Martinez",
                "Gonzalez",
                "Rodriguez",
                "Sanchez",
                "Perez",
                "Martin",
                "Gomez",
                "Ruiz",
                "Diaz",
                "Hernandez",
                "Alvarez",
                "Jimenez",
                "Moreno",
                "Munoz",
                "Alonso",
                "Romero",
                "Navarro",
                "Gutierrez",
                "Torres",
                "Dominguez",
                "Gil",
                "Vazquez",
                "Blanco",
                "Serrano",
                "Ramos",
                "Castro",
                "Suarez",
                "Sanz",
                "Rubio",
                "Ortega",
                "Molina",
                "Delgado",
                "Ortiz",
                "Morales",
                "Ramirez",
                "Marin",
                "Iglesias",
                "Santos",
                "Castillo",
                "Garrido",
                "Calvo",
                "Pena",
                "Cruz",
                "Cano",
                "Nunez",
                "Prieto",
                "Diez",
                "Lozano",
                "Vidal",
                "Pascual",
                "Ferrer",
                "Medina",
                "Vega",
                "Leon",
                "Herrero",
                "Vicente",
                "Mendez",
                "Guerrero",
                "Fuentes",
                "Campos",
                "Nieto",
                "Cortes",
                "Caballero",
                "Ibanez",
                "Lorenzo",
                "Pastor",
                "Gimenez",
                "Saez",
                "Soler",
                "Marquez",
                "Carrasco",
                "Herrera",
                "Montero",
                "Arias",
                "Crespo",
                "Flores",
                "Andres",
                "Aguilar",
                "Hidalgo",
                "Cabrera",
                "Mora",
                "Duran",
                "Velasco",
                "Rey",
                "Pardo",
                "Roman",
                "Vila",
                "Bravo",
                "Merino",
                "Moya",
                "Soto",
                "Izquierdo",
                "Reyes",
                "Redondo",
                "Marcos",
                "Carmona",
                "Menendez"
            ],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_des_noms_de_famille_les_plus_courants_en_France
            "fr": [
                "Martin",
                "Bernard",
                "Thomas",
                "Petit",
                "Robert",
                "Richard",
                "Durand",
                "Dubois",
                "Moreau",
                "Laurent",
                "Simon",
                "Michel",
                "Lef\xe8vre",
                "Leroy",
                "Roux",
                "David",
                "Bertrand",
                "Morel",
                "Fournier",
                "Girard",
                "Bonnet",
                "Dupont",
                "Lambert",
                "Fontaine",
                "Rousseau",
                "Vincent",
                "M\xfcller",
                "Lef\xe8vre",
                "Faure",
                "Andr\xe9",
                "Mercier",
                "Blanc",
                "Gu\xe9rin",
                "Boyer",
                "Garnier",
                "Chevalier",
                "Fran\xe7ois",
                "Legrand",
                "Gauthier",
                "Garcia",
                "Perrin",
                "Robin",
                "Cl\xe9ment",
                "Morin",
                "Nicolas",
                "Henry",
                "Roussel",
                "Matthieu",
                "Gautier",
                "Masson",
                "Marchand",
                "Duval",
                "Denis",
                "Dumont",
                "Marie",
                "Lemaire",
                "No\xebl",
                "Meyer",
                "Dufour",
                "Meunier",
                "Brun",
                "Blanchard",
                "Giraud",
                "Joly",
                "Rivi\xe8re",
                "Lucas",
                "Brunet",
                "Gaillard",
                "Barbier",
                "Arnaud",
                "Mart\xednez",
                "G\xe9rard",
                "Roche",
                "Renard",
                "Schmitt",
                "Roy",
                "Leroux",
                "Colin",
                "Vidal",
                "Caron",
                "Picard",
                "Roger",
                "Fabre",
                "Aubert",
                "Lemoine",
                "Renaud",
                "Dumas",
                "Lacroix",
                "Olivier",
                "Philippe",
                "Bourgeois",
                "Pierre",
                "Beno\xeet",
                "Rey",
                "Leclerc",
                "Payet",
                "Rolland",
                "Leclercq",
                "Guillaume",
                "Lecomte",
                "L\xf3pez",
                "Jean",
                "Dupuy",
                "Guillot",
                "Hubert",
                "Berger",
                "Carpentier",
                "S\xe1nchez",
                "Dupuis",
                "Moulin",
                "Louis",
                "Deschamps",
                "Huet",
                "Vasseur",
                "Perez",
                "Boucher",
                "Fleury",
                "Royer",
                "Klein",
                "Jacquet",
                "Adam",
                "Paris",
                "Poirier",
                "Marty",
                "Aubry",
                "Guyot",
                "Carr\xe9",
                "Charles",
                "Renault",
                "Charpentier",
                "M\xe9nard",
                "Maillard",
                "Baron",
                "Bertin",
                "Bailly",
                "Herv\xe9",
                "Schneider",
                "Fern\xe1ndez",
                "Le GallGall",
                "Collet",
                "L\xe9ger",
                "Bouvier",
                "Julien",
                "Pr\xe9vost",
                "Millet",
                "Perrot",
                "Daniel",
                "Le RouxRoux",
                "Cousin",
                "Germain",
                "Breton",
                "Besson",
                "Langlois",
                "R\xe9mi",
                "Le GoffGoff",
                "Pelletier",
                "L\xe9v\xeaque",
                "Perrier",
                "Leblanc",
                "Barr\xe9",
                "Lebrun",
                "Marchal",
                "Weber",
                "Mallet",
                "Hamon",
                "Boulanger",
                "Jacob",
                "Monnier",
                "Michaud",
                "Rodr\xedguez",
                "Guichard",
                "Gillet",
                "\xc9tienne",
                "Grondin",
                "Poulain",
                "Tessier",
                "Chevallier",
                "Collin",
                "Chauvin",
                "Da SilvaSilva",
                "Bouchet",
                "Gay",
                "Lema\xeetre",
                "B\xe9nard",
                "Mar\xe9chal",
                "Humbert",
                "Reynaud",
                "Antoine",
                "Hoarau",
                "Perret",
                "Barth\xe9lemy",
                "Cordier",
                "Pichon",
                "Lejeune",
                "Gilbert",
                "Lamy",
                "Delaunay",
                "Pasquier",
                "Carlier",
                "LaporteLaporte"
            ]
        },
        // Data taken from http://geoportal.statistics.gov.uk/datasets/ons-postcode-directory-latest-centroids
        postcodeAreas: [
            {
                code: 'AB'
            },
            {
                code: 'AL'
            },
            {
                code: 'B'
            },
            {
                code: 'BA'
            },
            {
                code: 'BB'
            },
            {
                code: 'BD'
            },
            {
                code: 'BH'
            },
            {
                code: 'BL'
            },
            {
                code: 'BN'
            },
            {
                code: 'BR'
            },
            {
                code: 'BS'
            },
            {
                code: 'BT'
            },
            {
                code: 'CA'
            },
            {
                code: 'CB'
            },
            {
                code: 'CF'
            },
            {
                code: 'CH'
            },
            {
                code: 'CM'
            },
            {
                code: 'CO'
            },
            {
                code: 'CR'
            },
            {
                code: 'CT'
            },
            {
                code: 'CV'
            },
            {
                code: 'CW'
            },
            {
                code: 'DA'
            },
            {
                code: 'DD'
            },
            {
                code: 'DE'
            },
            {
                code: 'DG'
            },
            {
                code: 'DH'
            },
            {
                code: 'DL'
            },
            {
                code: 'DN'
            },
            {
                code: 'DT'
            },
            {
                code: 'DY'
            },
            {
                code: 'E'
            },
            {
                code: 'EC'
            },
            {
                code: 'EH'
            },
            {
                code: 'EN'
            },
            {
                code: 'EX'
            },
            {
                code: 'FK'
            },
            {
                code: 'FY'
            },
            {
                code: 'G'
            },
            {
                code: 'GL'
            },
            {
                code: 'GU'
            },
            {
                code: 'GY'
            },
            {
                code: 'HA'
            },
            {
                code: 'HD'
            },
            {
                code: 'HG'
            },
            {
                code: 'HP'
            },
            {
                code: 'HR'
            },
            {
                code: 'HS'
            },
            {
                code: 'HU'
            },
            {
                code: 'HX'
            },
            {
                code: 'IG'
            },
            {
                code: 'IM'
            },
            {
                code: 'IP'
            },
            {
                code: 'IV'
            },
            {
                code: 'JE'
            },
            {
                code: 'KA'
            },
            {
                code: 'KT'
            },
            {
                code: 'KW'
            },
            {
                code: 'KY'
            },
            {
                code: 'L'
            },
            {
                code: 'LA'
            },
            {
                code: 'LD'
            },
            {
                code: 'LE'
            },
            {
                code: 'LL'
            },
            {
                code: 'LN'
            },
            {
                code: 'LS'
            },
            {
                code: 'LU'
            },
            {
                code: 'M'
            },
            {
                code: 'ME'
            },
            {
                code: 'MK'
            },
            {
                code: 'ML'
            },
            {
                code: 'N'
            },
            {
                code: 'NE'
            },
            {
                code: 'NG'
            },
            {
                code: 'NN'
            },
            {
                code: 'NP'
            },
            {
                code: 'NR'
            },
            {
                code: 'NW'
            },
            {
                code: 'OL'
            },
            {
                code: 'OX'
            },
            {
                code: 'PA'
            },
            {
                code: 'PE'
            },
            {
                code: 'PH'
            },
            {
                code: 'PL'
            },
            {
                code: 'PO'
            },
            {
                code: 'PR'
            },
            {
                code: 'RG'
            },
            {
                code: 'RH'
            },
            {
                code: 'RM'
            },
            {
                code: 'S'
            },
            {
                code: 'SA'
            },
            {
                code: 'SE'
            },
            {
                code: 'SG'
            },
            {
                code: 'SK'
            },
            {
                code: 'SL'
            },
            {
                code: 'SM'
            },
            {
                code: 'SN'
            },
            {
                code: 'SO'
            },
            {
                code: 'SP'
            },
            {
                code: 'SR'
            },
            {
                code: 'SS'
            },
            {
                code: 'ST'
            },
            {
                code: 'SW'
            },
            {
                code: 'SY'
            },
            {
                code: 'TA'
            },
            {
                code: 'TD'
            },
            {
                code: 'TF'
            },
            {
                code: 'TN'
            },
            {
                code: 'TQ'
            },
            {
                code: 'TR'
            },
            {
                code: 'TS'
            },
            {
                code: 'TW'
            },
            {
                code: 'UB'
            },
            {
                code: 'W'
            },
            {
                code: 'WA'
            },
            {
                code: 'WC'
            },
            {
                code: 'WD'
            },
            {
                code: 'WF'
            },
            {
                code: 'WN'
            },
            {
                code: 'WR'
            },
            {
                code: 'WS'
            },
            {
                code: 'WV'
            },
            {
                code: 'YO'
            },
            {
                code: 'ZE'
            }
        ],
        // Data taken from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        countries: [
            {
                "name": "Afghanistan",
                "abbreviation": "AF"
            },
            {
                "name": "\xc5land Islands",
                "abbreviation": "AX"
            },
            {
                "name": "Albania",
                "abbreviation": "AL"
            },
            {
                "name": "Algeria",
                "abbreviation": "DZ"
            },
            {
                "name": "American Samoa",
                "abbreviation": "AS"
            },
            {
                "name": "Andorra",
                "abbreviation": "AD"
            },
            {
                "name": "Angola",
                "abbreviation": "AO"
            },
            {
                "name": "Anguilla",
                "abbreviation": "AI"
            },
            {
                "name": "Antarctica",
                "abbreviation": "AQ"
            },
            {
                "name": "Antigua and Barbuda",
                "abbreviation": "AG"
            },
            {
                "name": "Argentina",
                "abbreviation": "AR"
            },
            {
                "name": "Armenia",
                "abbreviation": "AM"
            },
            {
                "name": "Aruba",
                "abbreviation": "AW"
            },
            {
                "name": "Australia",
                "abbreviation": "AU"
            },
            {
                "name": "Austria",
                "abbreviation": "AT"
            },
            {
                "name": "Azerbaijan",
                "abbreviation": "AZ"
            },
            {
                "name": "Bahamas",
                "abbreviation": "BS"
            },
            {
                "name": "Bahrain",
                "abbreviation": "BH"
            },
            {
                "name": "Bangladesh",
                "abbreviation": "BD"
            },
            {
                "name": "Barbados",
                "abbreviation": "BB"
            },
            {
                "name": "Belarus",
                "abbreviation": "BY"
            },
            {
                "name": "Belgium",
                "abbreviation": "BE"
            },
            {
                "name": "Belize",
                "abbreviation": "BZ"
            },
            {
                "name": "Benin",
                "abbreviation": "BJ"
            },
            {
                "name": "Bermuda",
                "abbreviation": "BM"
            },
            {
                "name": "Bhutan",
                "abbreviation": "BT"
            },
            {
                "name": "Plurinational State of Bolivia",
                "abbreviation": "BO"
            },
            {
                "name": "Bonaire, Sint Eustatius and Saba",
                "abbreviation": "BQ"
            },
            {
                "name": "Bosnia and Herzegovina",
                "abbreviation": "BA"
            },
            {
                "name": "Botswana",
                "abbreviation": "BW"
            },
            {
                "name": "Bouvet Island",
                "abbreviation": "BV"
            },
            {
                "name": "Brazil",
                "abbreviation": "BR"
            },
            {
                "name": "British Indian Ocean Territory",
                "abbreviation": "IO"
            },
            {
                "name": "Brunei Darussalam",
                "abbreviation": "BN"
            },
            {
                "name": "Bulgaria",
                "abbreviation": "BG"
            },
            {
                "name": "Burkina Faso",
                "abbreviation": "BF"
            },
            {
                "name": "Burundi",
                "abbreviation": "BI"
            },
            {
                "name": "Cabo Verde",
                "abbreviation": "CV"
            },
            {
                "name": "Cambodia",
                "abbreviation": "KH"
            },
            {
                "name": "Cameroon",
                "abbreviation": "CM"
            },
            {
                "name": "Canada",
                "abbreviation": "CA"
            },
            {
                "name": "Cayman Islands",
                "abbreviation": "KY"
            },
            {
                "name": "Central African Republic",
                "abbreviation": "CF"
            },
            {
                "name": "Chad",
                "abbreviation": "TD"
            },
            {
                "name": "Chile",
                "abbreviation": "CL"
            },
            {
                "name": "China",
                "abbreviation": "CN"
            },
            {
                "name": "Christmas Island",
                "abbreviation": "CX"
            },
            {
                "name": "Cocos (Keeling) Islands",
                "abbreviation": "CC"
            },
            {
                "name": "Colombia",
                "abbreviation": "CO"
            },
            {
                "name": "Comoros",
                "abbreviation": "KM"
            },
            {
                "name": "Congo",
                "abbreviation": "CG"
            },
            {
                "name": "Democratic Republic of the Congo",
                "abbreviation": "CD"
            },
            {
                "name": "Cook Islands",
                "abbreviation": "CK"
            },
            {
                "name": "Costa Rica",
                "abbreviation": "CR"
            },
            {
                "name": "C\xf4te d'Ivoire",
                "abbreviation": "CI"
            },
            {
                "name": "Croatia",
                "abbreviation": "HR"
            },
            {
                "name": "Cuba",
                "abbreviation": "CU"
            },
            {
                "name": "Cura\xe7ao",
                "abbreviation": "CW"
            },
            {
                "name": "Cyprus",
                "abbreviation": "CY"
            },
            {
                "name": "Czechia",
                "abbreviation": "CZ"
            },
            {
                "name": "Denmark",
                "abbreviation": "DK"
            },
            {
                "name": "Djibouti",
                "abbreviation": "DJ"
            },
            {
                "name": "Dominica",
                "abbreviation": "DM"
            },
            {
                "name": "Dominican Republic",
                "abbreviation": "DO"
            },
            {
                "name": "Ecuador",
                "abbreviation": "EC"
            },
            {
                "name": "Egypt",
                "abbreviation": "EG"
            },
            {
                "name": "El Salvador",
                "abbreviation": "SV"
            },
            {
                "name": "Equatorial Guinea",
                "abbreviation": "GQ"
            },
            {
                "name": "Eritrea",
                "abbreviation": "ER"
            },
            {
                "name": "Estonia",
                "abbreviation": "EE"
            },
            {
                "name": "Eswatini",
                "abbreviation": "SZ"
            },
            {
                "name": "Ethiopia",
                "abbreviation": "ET"
            },
            {
                "name": "Falkland Islands (Malvinas)",
                "abbreviation": "FK"
            },
            {
                "name": "Faroe Islands",
                "abbreviation": "FO"
            },
            {
                "name": "Fiji",
                "abbreviation": "FJ"
            },
            {
                "name": "Finland",
                "abbreviation": "FI"
            },
            {
                "name": "France",
                "abbreviation": "FR"
            },
            {
                "name": "French Guiana",
                "abbreviation": "GF"
            },
            {
                "name": "French Polynesia",
                "abbreviation": "PF"
            },
            {
                "name": "French Southern Territories",
                "abbreviation": "TF"
            },
            {
                "name": "Gabon",
                "abbreviation": "GA"
            },
            {
                "name": "Gambia",
                "abbreviation": "GM"
            },
            {
                "name": "Georgia",
                "abbreviation": "GE"
            },
            {
                "name": "Germany",
                "abbreviation": "DE"
            },
            {
                "name": "Ghana",
                "abbreviation": "GH"
            },
            {
                "name": "Gibraltar",
                "abbreviation": "GI"
            },
            {
                "name": "Greece",
                "abbreviation": "GR"
            },
            {
                "name": "Greenland",
                "abbreviation": "GL"
            },
            {
                "name": "Grenada",
                "abbreviation": "GD"
            },
            {
                "name": "Guadeloupe",
                "abbreviation": "GP"
            },
            {
                "name": "Guam",
                "abbreviation": "GU"
            },
            {
                "name": "Guatemala",
                "abbreviation": "GT"
            },
            {
                "name": "Guernsey",
                "abbreviation": "GG"
            },
            {
                "name": "Guinea",
                "abbreviation": "GN"
            },
            {
                "name": "Guinea-Bissau",
                "abbreviation": "GW"
            },
            {
                "name": "Guyana",
                "abbreviation": "GY"
            },
            {
                "name": "Haiti",
                "abbreviation": "HT"
            },
            {
                "name": "Heard Island and McDonald Islands",
                "abbreviation": "HM"
            },
            {
                "name": "Holy See",
                "abbreviation": "VA"
            },
            {
                "name": "Honduras",
                "abbreviation": "HN"
            },
            {
                "name": "Hong Kong",
                "abbreviation": "HK"
            },
            {
                "name": "Hungary",
                "abbreviation": "HU"
            },
            {
                "name": "Iceland",
                "abbreviation": "IS"
            },
            {
                "name": "India",
                "abbreviation": "IN"
            },
            {
                "name": "Indonesia",
                "abbreviation": "ID"
            },
            {
                "name": "Islamic Republic of Iran",
                "abbreviation": "IR"
            },
            {
                "name": "Iraq",
                "abbreviation": "IQ"
            },
            {
                "name": "Ireland",
                "abbreviation": "IE"
            },
            {
                "name": "Isle of Man",
                "abbreviation": "IM"
            },
            {
                "name": "Israel",
                "abbreviation": "IL"
            },
            {
                "name": "Italy",
                "abbreviation": "IT"
            },
            {
                "name": "Jamaica",
                "abbreviation": "JM"
            },
            {
                "name": "Japan",
                "abbreviation": "JP"
            },
            {
                "name": "Jersey",
                "abbreviation": "JE"
            },
            {
                "name": "Jordan",
                "abbreviation": "JO"
            },
            {
                "name": "Kazakhstan",
                "abbreviation": "KZ"
            },
            {
                "name": "Kenya",
                "abbreviation": "KE"
            },
            {
                "name": "Kiribati",
                "abbreviation": "KI"
            },
            {
                "name": "Democratic People's Republic of Korea",
                "abbreviation": "KP"
            },
            {
                "name": "Republic of Korea",
                "abbreviation": "KR"
            },
            {
                "name": "Kuwait",
                "abbreviation": "KW"
            },
            {
                "name": "Kyrgyzstan",
                "abbreviation": "KG"
            },
            {
                "name": "Lao People's Democratic Republic",
                "abbreviation": "LA"
            },
            {
                "name": "Latvia",
                "abbreviation": "LV"
            },
            {
                "name": "Lebanon",
                "abbreviation": "LB"
            },
            {
                "name": "Lesotho",
                "abbreviation": "LS"
            },
            {
                "name": "Liberia",
                "abbreviation": "LR"
            },
            {
                "name": "Libya",
                "abbreviation": "LY"
            },
            {
                "name": "Liechtenstein",
                "abbreviation": "LI"
            },
            {
                "name": "Lithuania",
                "abbreviation": "LT"
            },
            {
                "name": "Luxembourg",
                "abbreviation": "LU"
            },
            {
                "name": "Macao",
                "abbreviation": "MO"
            },
            {
                "name": "Madagascar",
                "abbreviation": "MG"
            },
            {
                "name": "Malawi",
                "abbreviation": "MW"
            },
            {
                "name": "Malaysia",
                "abbreviation": "MY"
            },
            {
                "name": "Maldives",
                "abbreviation": "MV"
            },
            {
                "name": "Mali",
                "abbreviation": "ML"
            },
            {
                "name": "Malta",
                "abbreviation": "MT"
            },
            {
                "name": "Marshall Islands",
                "abbreviation": "MH"
            },
            {
                "name": "Martinique",
                "abbreviation": "MQ"
            },
            {
                "name": "Mauritania",
                "abbreviation": "MR"
            },
            {
                "name": "Mauritius",
                "abbreviation": "MU"
            },
            {
                "name": "Mayotte",
                "abbreviation": "YT"
            },
            {
                "name": "Mexico",
                "abbreviation": "MX"
            },
            {
                "name": "Federated States of Micronesia",
                "abbreviation": "FM"
            },
            {
                "name": "Republic of Moldova",
                "abbreviation": "MD"
            },
            {
                "name": "Monaco",
                "abbreviation": "MC"
            },
            {
                "name": "Mongolia",
                "abbreviation": "MN"
            },
            {
                "name": "Montenegro",
                "abbreviation": "ME"
            },
            {
                "name": "Montserrat",
                "abbreviation": "MS"
            },
            {
                "name": "Morocco",
                "abbreviation": "MA"
            },
            {
                "name": "Mozambique",
                "abbreviation": "MZ"
            },
            {
                "name": "Myanmar",
                "abbreviation": "MM"
            },
            {
                "name": "Namibia",
                "abbreviation": "NA"
            },
            {
                "name": "Nauru",
                "abbreviation": "NR"
            },
            {
                "name": "Nepal",
                "abbreviation": "NP"
            },
            {
                "name": "Kingdom of the Netherlands",
                "abbreviation": "NL"
            },
            {
                "name": "New Caledonia",
                "abbreviation": "NC"
            },
            {
                "name": "New Zealand",
                "abbreviation": "NZ"
            },
            {
                "name": "Nicaragua",
                "abbreviation": "NI"
            },
            {
                "name": "Niger",
                "abbreviation": "NE"
            },
            {
                "name": "Nigeria",
                "abbreviation": "NG"
            },
            {
                "name": "Niue",
                "abbreviation": "NU"
            },
            {
                "name": "Norfolk Island",
                "abbreviation": "NF"
            },
            {
                "name": "North Macedonia",
                "abbreviation": "MK"
            },
            {
                "name": "Northern Mariana Islands",
                "abbreviation": "MP"
            },
            {
                "name": "Norway",
                "abbreviation": "NO"
            },
            {
                "name": "Oman",
                "abbreviation": "OM"
            },
            {
                "name": "Pakistan",
                "abbreviation": "PK"
            },
            {
                "name": "Palau",
                "abbreviation": "PW"
            },
            {
                "name": "State of Palestine",
                "abbreviation": "PS"
            },
            {
                "name": "Panama",
                "abbreviation": "PA"
            },
            {
                "name": "Papua New Guinea",
                "abbreviation": "PG"
            },
            {
                "name": "Paraguay",
                "abbreviation": "PY"
            },
            {
                "name": "Peru",
                "abbreviation": "PE"
            },
            {
                "name": "Philippines",
                "abbreviation": "PH"
            },
            {
                "name": "Pitcairn",
                "abbreviation": "PN"
            },
            {
                "name": "Poland",
                "abbreviation": "PL"
            },
            {
                "name": "Portugal",
                "abbreviation": "PT"
            },
            {
                "name": "Puerto Rico",
                "abbreviation": "PR"
            },
            {
                "name": "Qatar",
                "abbreviation": "QA"
            },
            {
                "name": "R\xe9union",
                "abbreviation": "RE"
            },
            {
                "name": "Romania",
                "abbreviation": "RO"
            },
            {
                "name": "Russian Federation",
                "abbreviation": "RU"
            },
            {
                "name": "Rwanda",
                "abbreviation": "RW"
            },
            {
                "name": "Saint Barth\xe9lemy",
                "abbreviation": "BL"
            },
            {
                "name": "Saint Helena, Ascension and Tristan da Cunha",
                "abbreviation": "SH"
            },
            {
                "name": "Saint Kitts and Nevis",
                "abbreviation": "KN"
            },
            {
                "name": "Saint Lucia",
                "abbreviation": "LC"
            },
            {
                "name": "Saint Martin (French part)",
                "abbreviation": "MF"
            },
            {
                "name": "Saint Pierre and Miquelon",
                "abbreviation": "PM"
            },
            {
                "name": "Saint Vincent and the Grenadines",
                "abbreviation": "VC"
            },
            {
                "name": "Samoa",
                "abbreviation": "WS"
            },
            {
                "name": "San Marino",
                "abbreviation": "SM"
            },
            {
                "name": "Sao Tome and Principe",
                "abbreviation": "ST"
            },
            {
                "name": "Saudi Arabia",
                "abbreviation": "SA"
            },
            {
                "name": "Senegal",
                "abbreviation": "SN"
            },
            {
                "name": "Serbia",
                "abbreviation": "RS"
            },
            {
                "name": "Seychelles",
                "abbreviation": "SC"
            },
            {
                "name": "Sierra Leone",
                "abbreviation": "SL"
            },
            {
                "name": "Singapore",
                "abbreviation": "SG"
            },
            {
                "name": "Sint Maarten (Dutch part)",
                "abbreviation": "SX"
            },
            {
                "name": "Slovakia",
                "abbreviation": "SK"
            },
            {
                "name": "Slovenia",
                "abbreviation": "SI"
            },
            {
                "name": "Solomon Islands",
                "abbreviation": "SB"
            },
            {
                "name": "Somalia",
                "abbreviation": "SO"
            },
            {
                "name": "South Africa",
                "abbreviation": "ZA"
            },
            {
                "name": "South Georgia and the South Sandwich Islands",
                "abbreviation": "GS"
            },
            {
                "name": "South Sudan",
                "abbreviation": "SS"
            },
            {
                "name": "Spain",
                "abbreviation": "ES"
            },
            {
                "name": "Sri Lanka",
                "abbreviation": "LK"
            },
            {
                "name": "Sudan",
                "abbreviation": "SD"
            },
            {
                "name": "Suriname",
                "abbreviation": "SR"
            },
            {
                "name": "Svalbard and Jan Mayen",
                "abbreviation": "SJ"
            },
            {
                "name": "Sweden",
                "abbreviation": "SE"
            },
            {
                "name": "Switzerland",
                "abbreviation": "CH"
            },
            {
                "name": "Syrian Arab Republic",
                "abbreviation": "SY"
            },
            {
                "name": "Taiwan, Province of China",
                "abbreviation": "TW"
            },
            {
                "name": "Tajikistan",
                "abbreviation": "TJ"
            },
            {
                "name": "United Republic of Tanzania",
                "abbreviation": "TZ"
            },
            {
                "name": "Thailand",
                "abbreviation": "TH"
            },
            {
                "name": "Timor-Leste",
                "abbreviation": "TL"
            },
            {
                "name": "Togo",
                "abbreviation": "TG"
            },
            {
                "name": "Tokelau",
                "abbreviation": "TK"
            },
            {
                "name": "Tonga",
                "abbreviation": "TO"
            },
            {
                "name": "Trinidad and Tobago",
                "abbreviation": "TT"
            },
            {
                "name": "Tunisia",
                "abbreviation": "TN"
            },
            {
                "name": "T\xfcrkiye",
                "abbreviation": "TR"
            },
            {
                "name": "Turkmenistan",
                "abbreviation": "TM"
            },
            {
                "name": "Turks and Caicos Islands",
                "abbreviation": "TC"
            },
            {
                "name": "Tuvalu",
                "abbreviation": "TV"
            },
            {
                "name": "Uganda",
                "abbreviation": "UG"
            },
            {
                "name": "Ukraine",
                "abbreviation": "UA"
            },
            {
                "name": "United Arab Emirates",
                "abbreviation": "AE"
            },
            {
                "name": "United Kingdom of Great Britain and Northern Ireland",
                "abbreviation": "GB"
            },
            {
                "name": "United States Minor Outlying Islands",
                "abbreviation": "UM"
            },
            {
                "name": "United States of America",
                "abbreviation": "US"
            },
            {
                "name": "Uruguay",
                "abbreviation": "UY"
            },
            {
                "name": "Uzbekistan",
                "abbreviation": "UZ"
            },
            {
                "name": "Vanuatu",
                "abbreviation": "VU"
            },
            {
                "name": "Bolivarian Republic of Venezuela",
                "abbreviation": "VE"
            },
            {
                "name": "Viet Nam",
                "abbreviation": "VN"
            },
            {
                "name": "Virgin Islands (British)",
                "abbreviation": "VG"
            },
            {
                "name": "Virgin Islands (U.S.)",
                "abbreviation": "VI"
            },
            {
                "name": "Wallis and Futuna",
                "abbreviation": "WF"
            },
            {
                "name": "Western Sahara",
                "abbreviation": "EH"
            },
            {
                "name": "Yemen",
                "abbreviation": "YE"
            },
            {
                "name": "Zambia",
                "abbreviation": "ZM"
            },
            {
                "name": "Zimbabwe",
                "abbreviation": "ZW"
            }
        ],
        counties: {
            // Data taken from http://www.downloadexcelfiles.com/gb_en/download-excel-file-list-counties-uk
            "uk": [
                {
                    name: 'Bath and North East Somerset'
                },
                {
                    name: 'Aberdeenshire'
                },
                {
                    name: 'Anglesey'
                },
                {
                    name: 'Angus'
                },
                {
                    name: 'Bedford'
                },
                {
                    name: 'Blackburn with Darwen'
                },
                {
                    name: 'Blackpool'
                },
                {
                    name: 'Bournemouth'
                },
                {
                    name: 'Bracknell Forest'
                },
                {
                    name: 'Brighton & Hove'
                },
                {
                    name: 'Bristol'
                },
                {
                    name: 'Buckinghamshire'
                },
                {
                    name: 'Cambridgeshire'
                },
                {
                    name: 'Carmarthenshire'
                },
                {
                    name: 'Central Bedfordshire'
                },
                {
                    name: 'Ceredigion'
                },
                {
                    name: 'Cheshire East'
                },
                {
                    name: 'Cheshire West and Chester'
                },
                {
                    name: 'Clackmannanshire'
                },
                {
                    name: 'Conwy'
                },
                {
                    name: 'Cornwall'
                },
                {
                    name: 'County Antrim'
                },
                {
                    name: 'County Armagh'
                },
                {
                    name: 'County Down'
                },
                {
                    name: 'County Durham'
                },
                {
                    name: 'County Fermanagh'
                },
                {
                    name: 'County Londonderry'
                },
                {
                    name: 'County Tyrone'
                },
                {
                    name: 'Cumbria'
                },
                {
                    name: 'Darlington'
                },
                {
                    name: 'Denbighshire'
                },
                {
                    name: 'Derby'
                },
                {
                    name: 'Derbyshire'
                },
                {
                    name: 'Devon'
                },
                {
                    name: 'Dorset'
                },
                {
                    name: 'Dumfries and Galloway'
                },
                {
                    name: 'Dundee'
                },
                {
                    name: 'East Lothian'
                },
                {
                    name: 'East Riding of Yorkshire'
                },
                {
                    name: 'East Sussex'
                },
                {
                    name: 'Edinburgh?'
                },
                {
                    name: 'Essex'
                },
                {
                    name: 'Falkirk'
                },
                {
                    name: 'Fife'
                },
                {
                    name: 'Flintshire'
                },
                {
                    name: 'Gloucestershire'
                },
                {
                    name: 'Greater London'
                },
                {
                    name: 'Greater Manchester'
                },
                {
                    name: 'Gwent'
                },
                {
                    name: 'Gwynedd'
                },
                {
                    name: 'Halton'
                },
                {
                    name: 'Hampshire'
                },
                {
                    name: 'Hartlepool'
                },
                {
                    name: 'Herefordshire'
                },
                {
                    name: 'Hertfordshire'
                },
                {
                    name: 'Highlands'
                },
                {
                    name: 'Hull'
                },
                {
                    name: 'Isle of Wight'
                },
                {
                    name: 'Isles of Scilly'
                },
                {
                    name: 'Kent'
                },
                {
                    name: 'Lancashire'
                },
                {
                    name: 'Leicester'
                },
                {
                    name: 'Leicestershire'
                },
                {
                    name: 'Lincolnshire'
                },
                {
                    name: 'Lothian'
                },
                {
                    name: 'Luton'
                },
                {
                    name: 'Medway'
                },
                {
                    name: 'Merseyside'
                },
                {
                    name: 'Mid Glamorgan'
                },
                {
                    name: 'Middlesbrough'
                },
                {
                    name: 'Milton Keynes'
                },
                {
                    name: 'Monmouthshire'
                },
                {
                    name: 'Moray'
                },
                {
                    name: 'Norfolk'
                },
                {
                    name: 'North East Lincolnshire'
                },
                {
                    name: 'North Lincolnshire'
                },
                {
                    name: 'North Somerset'
                },
                {
                    name: 'North Yorkshire'
                },
                {
                    name: 'Northamptonshire'
                },
                {
                    name: 'Northumberland'
                },
                {
                    name: 'Nottingham'
                },
                {
                    name: 'Nottinghamshire'
                },
                {
                    name: 'Oxfordshire'
                },
                {
                    name: 'Pembrokeshire'
                },
                {
                    name: 'Perth and Kinross'
                },
                {
                    name: 'Peterborough'
                },
                {
                    name: 'Plymouth'
                },
                {
                    name: 'Poole'
                },
                {
                    name: 'Portsmouth'
                },
                {
                    name: 'Powys'
                },
                {
                    name: 'Reading'
                },
                {
                    name: 'Redcar and Cleveland'
                },
                {
                    name: 'Rutland'
                },
                {
                    name: 'Scottish Borders'
                },
                {
                    name: 'Shropshire'
                },
                {
                    name: 'Slough'
                },
                {
                    name: 'Somerset'
                },
                {
                    name: 'South Glamorgan'
                },
                {
                    name: 'South Gloucestershire'
                },
                {
                    name: 'South Yorkshire'
                },
                {
                    name: 'Southampton'
                },
                {
                    name: 'Southend-on-Sea'
                },
                {
                    name: 'Staffordshire'
                },
                {
                    name: 'Stirlingshire'
                },
                {
                    name: 'Stockton-on-Tees'
                },
                {
                    name: 'Stoke-on-Trent'
                },
                {
                    name: 'Strathclyde'
                },
                {
                    name: 'Suffolk'
                },
                {
                    name: 'Surrey'
                },
                {
                    name: 'Swindon'
                },
                {
                    name: 'Telford and Wrekin'
                },
                {
                    name: 'Thurrock'
                },
                {
                    name: 'Torbay'
                },
                {
                    name: 'Tyne and Wear'
                },
                {
                    name: 'Warrington'
                },
                {
                    name: 'Warwickshire'
                },
                {
                    name: 'West Berkshire'
                },
                {
                    name: 'West Glamorgan'
                },
                {
                    name: 'West Lothian'
                },
                {
                    name: 'West Midlands'
                },
                {
                    name: 'West Sussex'
                },
                {
                    name: 'West Yorkshire'
                },
                {
                    name: 'Western Isles'
                },
                {
                    name: 'Wiltshire'
                },
                {
                    name: 'Windsor and Maidenhead'
                },
                {
                    name: 'Wokingham'
                },
                {
                    name: 'Worcestershire'
                },
                {
                    name: 'Wrexham'
                },
                {
                    name: 'York'
                }
            ]
        },
        provinces: {
            "ca": [
                {
                    name: 'Alberta',
                    abbreviation: 'AB'
                },
                {
                    name: 'British Columbia',
                    abbreviation: 'BC'
                },
                {
                    name: 'Manitoba',
                    abbreviation: 'MB'
                },
                {
                    name: 'New Brunswick',
                    abbreviation: 'NB'
                },
                {
                    name: 'Newfoundland and Labrador',
                    abbreviation: 'NL'
                },
                {
                    name: 'Nova Scotia',
                    abbreviation: 'NS'
                },
                {
                    name: 'Ontario',
                    abbreviation: 'ON'
                },
                {
                    name: 'Prince Edward Island',
                    abbreviation: 'PE'
                },
                {
                    name: 'Quebec',
                    abbreviation: 'QC'
                },
                {
                    name: 'Saskatchewan',
                    abbreviation: 'SK'
                },
                // The case could be made that the following are not actually provinces
                // since they are technically considered "territories" however they all
                // look the same on an envelope!
                {
                    name: 'Northwest Territories',
                    abbreviation: 'NT'
                },
                {
                    name: 'Nunavut',
                    abbreviation: 'NU'
                },
                {
                    name: 'Yukon',
                    abbreviation: 'YT'
                }
            ],
            "it": [
                {
                    name: "Agrigento",
                    abbreviation: "AG",
                    code: 84
                },
                {
                    name: "Alessandria",
                    abbreviation: "AL",
                    code: 6
                },
                {
                    name: "Ancona",
                    abbreviation: "AN",
                    code: 42
                },
                {
                    name: "Aosta",
                    abbreviation: "AO",
                    code: 7
                },
                {
                    name: "L'Aquila",
                    abbreviation: "AQ",
                    code: 66
                },
                {
                    name: "Arezzo",
                    abbreviation: "AR",
                    code: 51
                },
                {
                    name: "Ascoli-Piceno",
                    abbreviation: "AP",
                    code: 44
                },
                {
                    name: "Asti",
                    abbreviation: "AT",
                    code: 5
                },
                {
                    name: "Avellino",
                    abbreviation: "AV",
                    code: 64
                },
                {
                    name: "Bari",
                    abbreviation: "BA",
                    code: 72
                },
                {
                    name: "Barletta-Andria-Trani",
                    abbreviation: "BT",
                    code: 72
                },
                {
                    name: "Belluno",
                    abbreviation: "BL",
                    code: 25
                },
                {
                    name: "Benevento",
                    abbreviation: "BN",
                    code: 62
                },
                {
                    name: "Bergamo",
                    abbreviation: "BG",
                    code: 16
                },
                {
                    name: "Biella",
                    abbreviation: "BI",
                    code: 96
                },
                {
                    name: "Bologna",
                    abbreviation: "BO",
                    code: 37
                },
                {
                    name: "Bolzano",
                    abbreviation: "BZ",
                    code: 21
                },
                {
                    name: "Brescia",
                    abbreviation: "BS",
                    code: 17
                },
                {
                    name: "Brindisi",
                    abbreviation: "BR",
                    code: 74
                },
                {
                    name: "Cagliari",
                    abbreviation: "CA",
                    code: 92
                },
                {
                    name: "Caltanissetta",
                    abbreviation: "CL",
                    code: 85
                },
                {
                    name: "Campobasso",
                    abbreviation: "CB",
                    code: 70
                },
                {
                    name: "Carbonia Iglesias",
                    abbreviation: "CI",
                    code: 70
                },
                {
                    name: "Caserta",
                    abbreviation: "CE",
                    code: 61
                },
                {
                    name: "Catania",
                    abbreviation: "CT",
                    code: 87
                },
                {
                    name: "Catanzaro",
                    abbreviation: "CZ",
                    code: 79
                },
                {
                    name: "Chieti",
                    abbreviation: "CH",
                    code: 69
                },
                {
                    name: "Como",
                    abbreviation: "CO",
                    code: 13
                },
                {
                    name: "Cosenza",
                    abbreviation: "CS",
                    code: 78
                },
                {
                    name: "Cremona",
                    abbreviation: "CR",
                    code: 19
                },
                {
                    name: "Crotone",
                    abbreviation: "KR",
                    code: 101
                },
                {
                    name: "Cuneo",
                    abbreviation: "CN",
                    code: 4
                },
                {
                    name: "Enna",
                    abbreviation: "EN",
                    code: 86
                },
                {
                    name: "Fermo",
                    abbreviation: "FM",
                    code: 86
                },
                {
                    name: "Ferrara",
                    abbreviation: "FE",
                    code: 38
                },
                {
                    name: "Firenze",
                    abbreviation: "FI",
                    code: 48
                },
                {
                    name: "Foggia",
                    abbreviation: "FG",
                    code: 71
                },
                {
                    name: "Forli-Cesena",
                    abbreviation: "FC",
                    code: 71
                },
                {
                    name: "Frosinone",
                    abbreviation: "FR",
                    code: 60
                },
                {
                    name: "Genova",
                    abbreviation: "GE",
                    code: 10
                },
                {
                    name: "Gorizia",
                    abbreviation: "GO",
                    code: 31
                },
                {
                    name: "Grosseto",
                    abbreviation: "GR",
                    code: 53
                },
                {
                    name: "Imperia",
                    abbreviation: "IM",
                    code: 8
                },
                {
                    name: "Isernia",
                    abbreviation: "IS",
                    code: 94
                },
                {
                    name: "La-Spezia",
                    abbreviation: "SP",
                    code: 66
                },
                {
                    name: "Latina",
                    abbreviation: "LT",
                    code: 59
                },
                {
                    name: "Lecce",
                    abbreviation: "LE",
                    code: 75
                },
                {
                    name: "Lecco",
                    abbreviation: "LC",
                    code: 97
                },
                {
                    name: "Livorno",
                    abbreviation: "LI",
                    code: 49
                },
                {
                    name: "Lodi",
                    abbreviation: "LO",
                    code: 98
                },
                {
                    name: "Lucca",
                    abbreviation: "LU",
                    code: 46
                },
                {
                    name: "Macerata",
                    abbreviation: "MC",
                    code: 43
                },
                {
                    name: "Mantova",
                    abbreviation: "MN",
                    code: 20
                },
                {
                    name: "Massa-Carrara",
                    abbreviation: "MS",
                    code: 45
                },
                {
                    name: "Matera",
                    abbreviation: "MT",
                    code: 77
                },
                {
                    name: "Medio Campidano",
                    abbreviation: "VS",
                    code: 77
                },
                {
                    name: "Messina",
                    abbreviation: "ME",
                    code: 83
                },
                {
                    name: "Milano",
                    abbreviation: "MI",
                    code: 15
                },
                {
                    name: "Modena",
                    abbreviation: "MO",
                    code: 36
                },
                {
                    name: "Monza-Brianza",
                    abbreviation: "MB",
                    code: 36
                },
                {
                    name: "Napoli",
                    abbreviation: "NA",
                    code: 63
                },
                {
                    name: "Novara",
                    abbreviation: "NO",
                    code: 3
                },
                {
                    name: "Nuoro",
                    abbreviation: "NU",
                    code: 91
                },
                {
                    name: "Ogliastra",
                    abbreviation: "OG",
                    code: 91
                },
                {
                    name: "Olbia Tempio",
                    abbreviation: "OT",
                    code: 91
                },
                {
                    name: "Oristano",
                    abbreviation: "OR",
                    code: 95
                },
                {
                    name: "Padova",
                    abbreviation: "PD",
                    code: 28
                },
                {
                    name: "Palermo",
                    abbreviation: "PA",
                    code: 82
                },
                {
                    name: "Parma",
                    abbreviation: "PR",
                    code: 34
                },
                {
                    name: "Pavia",
                    abbreviation: "PV",
                    code: 18
                },
                {
                    name: "Perugia",
                    abbreviation: "PG",
                    code: 54
                },
                {
                    name: "Pesaro-Urbino",
                    abbreviation: "PU",
                    code: 41
                },
                {
                    name: "Pescara",
                    abbreviation: "PE",
                    code: 68
                },
                {
                    name: "Piacenza",
                    abbreviation: "PC",
                    code: 33
                },
                {
                    name: "Pisa",
                    abbreviation: "PI",
                    code: 50
                },
                {
                    name: "Pistoia",
                    abbreviation: "PT",
                    code: 47
                },
                {
                    name: "Pordenone",
                    abbreviation: "PN",
                    code: 93
                },
                {
                    name: "Potenza",
                    abbreviation: "PZ",
                    code: 76
                },
                {
                    name: "Prato",
                    abbreviation: "PO",
                    code: 100
                },
                {
                    name: "Ragusa",
                    abbreviation: "RG",
                    code: 88
                },
                {
                    name: "Ravenna",
                    abbreviation: "RA",
                    code: 39
                },
                {
                    name: "Reggio-Calabria",
                    abbreviation: "RC",
                    code: 35
                },
                {
                    name: "Reggio-Emilia",
                    abbreviation: "RE",
                    code: 35
                },
                {
                    name: "Rieti",
                    abbreviation: "RI",
                    code: 57
                },
                {
                    name: "Rimini",
                    abbreviation: "RN",
                    code: 99
                },
                {
                    name: "Roma",
                    abbreviation: "Roma",
                    code: 58
                },
                {
                    name: "Rovigo",
                    abbreviation: "RO",
                    code: 29
                },
                {
                    name: "Salerno",
                    abbreviation: "SA",
                    code: 65
                },
                {
                    name: "Sassari",
                    abbreviation: "SS",
                    code: 90
                },
                {
                    name: "Savona",
                    abbreviation: "SV",
                    code: 9
                },
                {
                    name: "Siena",
                    abbreviation: "SI",
                    code: 52
                },
                {
                    name: "Siracusa",
                    abbreviation: "SR",
                    code: 89
                },
                {
                    name: "Sondrio",
                    abbreviation: "SO",
                    code: 14
                },
                {
                    name: "Taranto",
                    abbreviation: "TA",
                    code: 73
                },
                {
                    name: "Teramo",
                    abbreviation: "TE",
                    code: 67
                },
                {
                    name: "Terni",
                    abbreviation: "TR",
                    code: 55
                },
                {
                    name: "Torino",
                    abbreviation: "TO",
                    code: 1
                },
                {
                    name: "Trapani",
                    abbreviation: "TP",
                    code: 81
                },
                {
                    name: "Trento",
                    abbreviation: "TN",
                    code: 22
                },
                {
                    name: "Treviso",
                    abbreviation: "TV",
                    code: 26
                },
                {
                    name: "Trieste",
                    abbreviation: "TS",
                    code: 32
                },
                {
                    name: "Udine",
                    abbreviation: "UD",
                    code: 30
                },
                {
                    name: "Varese",
                    abbreviation: "VA",
                    code: 12
                },
                {
                    name: "Venezia",
                    abbreviation: "VE",
                    code: 27
                },
                {
                    name: "Verbania",
                    abbreviation: "VB",
                    code: 27
                },
                {
                    name: "Vercelli",
                    abbreviation: "VC",
                    code: 2
                },
                {
                    name: "Verona",
                    abbreviation: "VR",
                    code: 23
                },
                {
                    name: "Vibo-Valentia",
                    abbreviation: "VV",
                    code: 102
                },
                {
                    name: "Vicenza",
                    abbreviation: "VI",
                    code: 24
                },
                {
                    name: "Viterbo",
                    abbreviation: "VT",
                    code: 56
                }
            ]
        },
        // from: https://github.com/samsargent/Useful-Autocomplete-Data/blob/master/data/nationalities.json
        nationalities: [
            {
                name: 'Afghan'
            },
            {
                name: 'Albanian'
            },
            {
                name: 'Algerian'
            },
            {
                name: 'American'
            },
            {
                name: 'Andorran'
            },
            {
                name: 'Angolan'
            },
            {
                name: 'Antiguans'
            },
            {
                name: 'Argentinean'
            },
            {
                name: 'Armenian'
            },
            {
                name: 'Australian'
            },
            {
                name: 'Austrian'
            },
            {
                name: 'Azerbaijani'
            },
            {
                name: 'Bahami'
            },
            {
                name: 'Bahraini'
            },
            {
                name: 'Bangladeshi'
            },
            {
                name: 'Barbadian'
            },
            {
                name: 'Barbudans'
            },
            {
                name: 'Batswana'
            },
            {
                name: 'Belarusian'
            },
            {
                name: 'Belgian'
            },
            {
                name: 'Belizean'
            },
            {
                name: 'Beninese'
            },
            {
                name: 'Bhutanese'
            },
            {
                name: 'Bolivian'
            },
            {
                name: 'Bosnian'
            },
            {
                name: 'Brazilian'
            },
            {
                name: 'British'
            },
            {
                name: 'Bruneian'
            },
            {
                name: 'Bulgarian'
            },
            {
                name: 'Burkinabe'
            },
            {
                name: 'Burmese'
            },
            {
                name: 'Burundian'
            },
            {
                name: 'Cambodian'
            },
            {
                name: 'Cameroonian'
            },
            {
                name: 'Canadian'
            },
            {
                name: 'Cape Verdean'
            },
            {
                name: 'Central African'
            },
            {
                name: 'Chadian'
            },
            {
                name: 'Chilean'
            },
            {
                name: 'Chinese'
            },
            {
                name: 'Colombian'
            },
            {
                name: 'Comoran'
            },
            {
                name: 'Congolese'
            },
            {
                name: 'Costa Rican'
            },
            {
                name: 'Croatian'
            },
            {
                name: 'Cuban'
            },
            {
                name: 'Cypriot'
            },
            {
                name: 'Czech'
            },
            {
                name: 'Danish'
            },
            {
                name: 'Djibouti'
            },
            {
                name: 'Dominican'
            },
            {
                name: 'Dutch'
            },
            {
                name: 'East Timorese'
            },
            {
                name: 'Ecuadorean'
            },
            {
                name: 'Egyptian'
            },
            {
                name: 'Emirian'
            },
            {
                name: 'Equatorial Guinean'
            },
            {
                name: 'Eritrean'
            },
            {
                name: 'Estonian'
            },
            {
                name: 'Ethiopian'
            },
            {
                name: 'Fijian'
            },
            {
                name: 'Filipino'
            },
            {
                name: 'Finnish'
            },
            {
                name: 'French'
            },
            {
                name: 'Gabonese'
            },
            {
                name: 'Gambian'
            },
            {
                name: 'Georgian'
            },
            {
                name: 'German'
            },
            {
                name: 'Ghanaian'
            },
            {
                name: 'Greek'
            },
            {
                name: 'Grenadian'
            },
            {
                name: 'Guatemalan'
            },
            {
                name: 'Guinea-Bissauan'
            },
            {
                name: 'Guinean'
            },
            {
                name: 'Guyanese'
            },
            {
                name: 'Haitian'
            },
            {
                name: 'Herzegovinian'
            },
            {
                name: 'Honduran'
            },
            {
                name: 'Hungarian'
            },
            {
                name: 'I-Kiribati'
            },
            {
                name: 'Icelander'
            },
            {
                name: 'Indian'
            },
            {
                name: 'Indonesian'
            },
            {
                name: 'Iranian'
            },
            {
                name: 'Iraqi'
            },
            {
                name: 'Irish'
            },
            {
                name: 'Israeli'
            },
            {
                name: 'Italian'
            },
            {
                name: 'Ivorian'
            },
            {
                name: 'Jamaican'
            },
            {
                name: 'Japanese'
            },
            {
                name: 'Jordanian'
            },
            {
                name: 'Kazakhstani'
            },
            {
                name: 'Kenyan'
            },
            {
                name: 'Kittian and Nevisian'
            },
            {
                name: 'Kuwaiti'
            },
            {
                name: 'Kyrgyz'
            },
            {
                name: 'Laotian'
            },
            {
                name: 'Latvian'
            },
            {
                name: 'Lebanese'
            },
            {
                name: 'Liberian'
            },
            {
                name: 'Libyan'
            },
            {
                name: 'Liechtensteiner'
            },
            {
                name: 'Lithuanian'
            },
            {
                name: 'Luxembourger'
            },
            {
                name: 'Macedonian'
            },
            {
                name: 'Malagasy'
            },
            {
                name: 'Malawian'
            },
            {
                name: 'Malaysian'
            },
            {
                name: 'Maldivan'
            },
            {
                name: 'Malian'
            },
            {
                name: 'Maltese'
            },
            {
                name: 'Marshallese'
            },
            {
                name: 'Mauritanian'
            },
            {
                name: 'Mauritian'
            },
            {
                name: 'Mexican'
            },
            {
                name: 'Micronesian'
            },
            {
                name: 'Moldovan'
            },
            {
                name: 'Monacan'
            },
            {
                name: 'Mongolian'
            },
            {
                name: 'Moroccan'
            },
            {
                name: 'Mosotho'
            },
            {
                name: 'Motswana'
            },
            {
                name: 'Mozambican'
            },
            {
                name: 'Namibian'
            },
            {
                name: 'Nauruan'
            },
            {
                name: 'Nepalese'
            },
            {
                name: 'New Zealander'
            },
            {
                name: 'Nicaraguan'
            },
            {
                name: 'Nigerian'
            },
            {
                name: 'Nigerien'
            },
            {
                name: 'North Korean'
            },
            {
                name: 'Northern Irish'
            },
            {
                name: 'Norwegian'
            },
            {
                name: 'Omani'
            },
            {
                name: 'Pakistani'
            },
            {
                name: 'Palauan'
            },
            {
                name: 'Panamanian'
            },
            {
                name: 'Papua New Guinean'
            },
            {
                name: 'Paraguayan'
            },
            {
                name: 'Peruvian'
            },
            {
                name: 'Polish'
            },
            {
                name: 'Portuguese'
            },
            {
                name: 'Qatari'
            },
            {
                name: 'Romani'
            },
            {
                name: 'Russian'
            },
            {
                name: 'Rwandan'
            },
            {
                name: 'Saint Lucian'
            },
            {
                name: 'Salvadoran'
            },
            {
                name: 'Samoan'
            },
            {
                name: 'San Marinese'
            },
            {
                name: 'Sao Tomean'
            },
            {
                name: 'Saudi'
            },
            {
                name: 'Scottish'
            },
            {
                name: 'Senegalese'
            },
            {
                name: 'Serbian'
            },
            {
                name: 'Seychellois'
            },
            {
                name: 'Sierra Leonean'
            },
            {
                name: 'Singaporean'
            },
            {
                name: 'Slovakian'
            },
            {
                name: 'Slovenian'
            },
            {
                name: 'Solomon Islander'
            },
            {
                name: 'Somali'
            },
            {
                name: 'South African'
            },
            {
                name: 'South Korean'
            },
            {
                name: 'Spanish'
            },
            {
                name: 'Sri Lankan'
            },
            {
                name: 'Sudanese'
            },
            {
                name: 'Surinamer'
            },
            {
                name: 'Swazi'
            },
            {
                name: 'Swedish'
            },
            {
                name: 'Swiss'
            },
            {
                name: 'Syrian'
            },
            {
                name: 'Taiwanese'
            },
            {
                name: 'Tajik'
            },
            {
                name: 'Tanzanian'
            },
            {
                name: 'Thai'
            },
            {
                name: 'Togolese'
            },
            {
                name: 'Tongan'
            },
            {
                name: 'Trinidadian or Tobagonian'
            },
            {
                name: 'Tunisian'
            },
            {
                name: 'Turkish'
            },
            {
                name: 'Tuvaluan'
            },
            {
                name: 'Ugandan'
            },
            {
                name: 'Ukrainian'
            },
            {
                name: 'Uruguaya'
            },
            {
                name: 'Uzbekistani'
            },
            {
                name: 'Venezuela'
            },
            {
                name: 'Vietnamese'
            },
            {
                name: 'Wels'
            },
            {
                name: 'Yemenit'
            },
            {
                name: 'Zambia'
            },
            {
                name: 'Zimbabwe'
            }
        ],
        // http://www.loc.gov/standards/iso639-2/php/code_list.php (ISO-639-1 codes)
        locale_languages: [
            "aa",
            "ab",
            "ae",
            "af",
            "ak",
            "am",
            "an",
            "ar",
            "as",
            "av",
            "ay",
            "az",
            "ba",
            "be",
            "bg",
            "bh",
            "bi",
            "bm",
            "bn",
            "bo",
            "br",
            "bs",
            "ca",
            "ce",
            "ch",
            "co",
            "cr",
            "cs",
            "cu",
            "cv",
            "cy",
            "da",
            "de",
            "dv",
            "dz",
            "ee",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fa",
            "ff",
            "fi",
            "fj",
            "fo",
            "fr",
            "fy",
            "ga",
            "gd",
            "gl",
            "gn",
            "gu",
            "gv",
            "ha",
            "he",
            "hi",
            "ho",
            "hr",
            "ht",
            "hu",
            "hy",
            "hz",
            "ia",
            "id",
            "ie",
            "ig",
            "ii",
            "ik",
            "io",
            "is",
            "it",
            "iu",
            "ja",
            "jv",
            "ka",
            "kg",
            "ki",
            "kj",
            "kk",
            "kl",
            "km",
            "kn",
            "ko",
            "kr",
            "ks",
            "ku",
            "kv",
            "kw",
            "ky",
            "la",
            "lb",
            "lg",
            "li",
            "ln",
            "lo",
            "lt",
            "lu",
            "lv",
            "mg",
            "mh",
            "mi",
            "mk",
            "ml",
            "mn",
            "mr",
            "ms",
            "mt",
            "my",
            "na",
            "nb",
            "nd",
            "ne",
            "ng",
            "nl",
            "nn",
            "no",
            "nr",
            "nv",
            "ny",
            "oc",
            "oj",
            "om",
            "or",
            "os",
            "pa",
            "pi",
            "pl",
            "ps",
            "pt",
            "qu",
            "rm",
            "rn",
            "ro",
            "ru",
            "rw",
            "sa",
            "sc",
            "sd",
            "se",
            "sg",
            "si",
            "sk",
            "sl",
            "sm",
            "sn",
            "so",
            "sq",
            "sr",
            "ss",
            "st",
            "su",
            "sv",
            "sw",
            "ta",
            "te",
            "tg",
            "th",
            "ti",
            "tk",
            "tl",
            "tn",
            "to",
            "tr",
            "ts",
            "tt",
            "tw",
            "ty",
            "ug",
            "uk",
            "ur",
            "uz",
            "ve",
            "vi",
            "vo",
            "wa",
            "wo",
            "xh",
            "yi",
            "yo",
            "za",
            "zh",
            "zu"
        ],
        // From http://data.okfn.org/data/core/language-codes#resource-language-codes-full (IETF language tags)
        locale_regions: [
            "agq-CM",
            "asa-TZ",
            "ast-ES",
            "bas-CM",
            "bem-ZM",
            "bez-TZ",
            "brx-IN",
            "cgg-UG",
            "chr-US",
            "dav-KE",
            "dje-NE",
            "dsb-DE",
            "dua-CM",
            "dyo-SN",
            "ebu-KE",
            "ewo-CM",
            "fil-PH",
            "fur-IT",
            "gsw-CH",
            "gsw-FR",
            "gsw-LI",
            "guz-KE",
            "haw-US",
            "hsb-DE",
            "jgo-CM",
            "jmc-TZ",
            "kab-DZ",
            "kam-KE",
            "kde-TZ",
            "kea-CV",
            "khq-ML",
            "kkj-CM",
            "kln-KE",
            "kok-IN",
            "ksb-TZ",
            "ksf-CM",
            "ksh-DE",
            "lag-TZ",
            "lkt-US",
            "luo-KE",
            "luy-KE",
            "mas-KE",
            "mas-TZ",
            "mer-KE",
            "mfe-MU",
            "mgh-MZ",
            "mgo-CM",
            "mua-CM",
            "naq-NA",
            "nmg-CM",
            "nnh-CM",
            "nus-SD",
            "nyn-UG",
            "rof-TZ",
            "rwk-TZ",
            "sah-RU",
            "saq-KE",
            "sbp-TZ",
            "seh-MZ",
            "ses-ML",
            "shi-Latn",
            "shi-Latn-MA",
            "shi-Tfng",
            "shi-Tfng-MA",
            "smn-FI",
            "teo-KE",
            "teo-UG",
            "twq-NE",
            "tzm-Latn",
            "tzm-Latn-MA",
            "vai-Latn",
            "vai-Latn-LR",
            "vai-Vaii",
            "vai-Vaii-LR",
            "vun-TZ",
            "wae-CH",
            "xog-UG",
            "yav-CM",
            "zgh-MA",
            "af-NA",
            "af-ZA",
            "ak-GH",
            "am-ET",
            "ar-001",
            "ar-AE",
            "ar-BH",
            "ar-DJ",
            "ar-DZ",
            "ar-EG",
            "ar-EH",
            "ar-ER",
            "ar-IL",
            "ar-IQ",
            "ar-JO",
            "ar-KM",
            "ar-KW",
            "ar-LB",
            "ar-LY",
            "ar-MA",
            "ar-MR",
            "ar-OM",
            "ar-PS",
            "ar-QA",
            "ar-SA",
            "ar-SD",
            "ar-SO",
            "ar-SS",
            "ar-SY",
            "ar-TD",
            "ar-TN",
            "ar-YE",
            "as-IN",
            "az-Cyrl",
            "az-Cyrl-AZ",
            "az-Latn",
            "az-Latn-AZ",
            "be-BY",
            "bg-BG",
            "bm-Latn",
            "bm-Latn-ML",
            "bn-BD",
            "bn-IN",
            "bo-CN",
            "bo-IN",
            "br-FR",
            "bs-Cyrl",
            "bs-Cyrl-BA",
            "bs-Latn",
            "bs-Latn-BA",
            "ca-AD",
            "ca-ES",
            "ca-ES-VALENCIA",
            "ca-FR",
            "ca-IT",
            "cs-CZ",
            "cy-GB",
            "da-DK",
            "da-GL",
            "de-AT",
            "de-BE",
            "de-CH",
            "de-DE",
            "de-LI",
            "de-LU",
            "dz-BT",
            "ee-GH",
            "ee-TG",
            "el-CY",
            "el-GR",
            "en-001",
            "en-150",
            "en-AG",
            "en-AI",
            "en-AS",
            "en-AU",
            "en-BB",
            "en-BE",
            "en-BM",
            "en-BS",
            "en-BW",
            "en-BZ",
            "en-CA",
            "en-CC",
            "en-CK",
            "en-CM",
            "en-CX",
            "en-DG",
            "en-DM",
            "en-ER",
            "en-FJ",
            "en-FK",
            "en-FM",
            "en-GB",
            "en-GD",
            "en-GG",
            "en-GH",
            "en-GI",
            "en-GM",
            "en-GU",
            "en-GY",
            "en-HK",
            "en-IE",
            "en-IM",
            "en-IN",
            "en-IO",
            "en-JE",
            "en-JM",
            "en-KE",
            "en-KI",
            "en-KN",
            "en-KY",
            "en-LC",
            "en-LR",
            "en-LS",
            "en-MG",
            "en-MH",
            "en-MO",
            "en-MP",
            "en-MS",
            "en-MT",
            "en-MU",
            "en-MW",
            "en-MY",
            "en-NA",
            "en-NF",
            "en-NG",
            "en-NR",
            "en-NU",
            "en-NZ",
            "en-PG",
            "en-PH",
            "en-PK",
            "en-PN",
            "en-PR",
            "en-PW",
            "en-RW",
            "en-SB",
            "en-SC",
            "en-SD",
            "en-SG",
            "en-SH",
            "en-SL",
            "en-SS",
            "en-SX",
            "en-SZ",
            "en-TC",
            "en-TK",
            "en-TO",
            "en-TT",
            "en-TV",
            "en-TZ",
            "en-UG",
            "en-UM",
            "en-US",
            "en-US-POSIX",
            "en-VC",
            "en-VG",
            "en-VI",
            "en-VU",
            "en-WS",
            "en-ZA",
            "en-ZM",
            "en-ZW",
            "eo-001",
            "es-419",
            "es-AR",
            "es-BO",
            "es-CL",
            "es-CO",
            "es-CR",
            "es-CU",
            "es-DO",
            "es-EA",
            "es-EC",
            "es-ES",
            "es-GQ",
            "es-GT",
            "es-HN",
            "es-IC",
            "es-MX",
            "es-NI",
            "es-PA",
            "es-PE",
            "es-PH",
            "es-PR",
            "es-PY",
            "es-SV",
            "es-US",
            "es-UY",
            "es-VE",
            "et-EE",
            "eu-ES",
            "fa-AF",
            "fa-IR",
            "ff-CM",
            "ff-GN",
            "ff-MR",
            "ff-SN",
            "fi-FI",
            "fo-FO",
            "fr-BE",
            "fr-BF",
            "fr-BI",
            "fr-BJ",
            "fr-BL",
            "fr-CA",
            "fr-CD",
            "fr-CF",
            "fr-CG",
            "fr-CH",
            "fr-CI",
            "fr-CM",
            "fr-DJ",
            "fr-DZ",
            "fr-FR",
            "fr-GA",
            "fr-GF",
            "fr-GN",
            "fr-GP",
            "fr-GQ",
            "fr-HT",
            "fr-KM",
            "fr-LU",
            "fr-MA",
            "fr-MC",
            "fr-MF",
            "fr-MG",
            "fr-ML",
            "fr-MQ",
            "fr-MR",
            "fr-MU",
            "fr-NC",
            "fr-NE",
            "fr-PF",
            "fr-PM",
            "fr-RE",
            "fr-RW",
            "fr-SC",
            "fr-SN",
            "fr-SY",
            "fr-TD",
            "fr-TG",
            "fr-TN",
            "fr-VU",
            "fr-WF",
            "fr-YT",
            "fy-NL",
            "ga-IE",
            "gd-GB",
            "gl-ES",
            "gu-IN",
            "gv-IM",
            "ha-Latn",
            "ha-Latn-GH",
            "ha-Latn-NE",
            "ha-Latn-NG",
            "he-IL",
            "hi-IN",
            "hr-BA",
            "hr-HR",
            "hu-HU",
            "hy-AM",
            "id-ID",
            "ig-NG",
            "ii-CN",
            "is-IS",
            "it-CH",
            "it-IT",
            "it-SM",
            "ja-JP",
            "ka-GE",
            "ki-KE",
            "kk-Cyrl",
            "kk-Cyrl-KZ",
            "kl-GL",
            "km-KH",
            "kn-IN",
            "ko-KP",
            "ko-KR",
            "ks-Arab",
            "ks-Arab-IN",
            "kw-GB",
            "ky-Cyrl",
            "ky-Cyrl-KG",
            "lb-LU",
            "lg-UG",
            "ln-AO",
            "ln-CD",
            "ln-CF",
            "ln-CG",
            "lo-LA",
            "lt-LT",
            "lu-CD",
            "lv-LV",
            "mg-MG",
            "mk-MK",
            "ml-IN",
            "mn-Cyrl",
            "mn-Cyrl-MN",
            "mr-IN",
            "ms-Latn",
            "ms-Latn-BN",
            "ms-Latn-MY",
            "ms-Latn-SG",
            "mt-MT",
            "my-MM",
            "nb-NO",
            "nb-SJ",
            "nd-ZW",
            "ne-IN",
            "ne-NP",
            "nl-AW",
            "nl-BE",
            "nl-BQ",
            "nl-CW",
            "nl-NL",
            "nl-SR",
            "nl-SX",
            "nn-NO",
            "om-ET",
            "om-KE",
            "or-IN",
            "os-GE",
            "os-RU",
            "pa-Arab",
            "pa-Arab-PK",
            "pa-Guru",
            "pa-Guru-IN",
            "pl-PL",
            "ps-AF",
            "pt-AO",
            "pt-BR",
            "pt-CV",
            "pt-GW",
            "pt-MO",
            "pt-MZ",
            "pt-PT",
            "pt-ST",
            "pt-TL",
            "qu-BO",
            "qu-EC",
            "qu-PE",
            "rm-CH",
            "rn-BI",
            "ro-MD",
            "ro-RO",
            "ru-BY",
            "ru-KG",
            "ru-KZ",
            "ru-MD",
            "ru-RU",
            "ru-UA",
            "rw-RW",
            "se-FI",
            "se-NO",
            "se-SE",
            "sg-CF",
            "si-LK",
            "sk-SK",
            "sl-SI",
            "sn-ZW",
            "so-DJ",
            "so-ET",
            "so-KE",
            "so-SO",
            "sq-AL",
            "sq-MK",
            "sq-XK",
            "sr-Cyrl",
            "sr-Cyrl-BA",
            "sr-Cyrl-ME",
            "sr-Cyrl-RS",
            "sr-Cyrl-XK",
            "sr-Latn",
            "sr-Latn-BA",
            "sr-Latn-ME",
            "sr-Latn-RS",
            "sr-Latn-XK",
            "sv-AX",
            "sv-FI",
            "sv-SE",
            "sw-CD",
            "sw-KE",
            "sw-TZ",
            "sw-UG",
            "ta-IN",
            "ta-LK",
            "ta-MY",
            "ta-SG",
            "te-IN",
            "th-TH",
            "ti-ER",
            "ti-ET",
            "to-TO",
            "tr-CY",
            "tr-TR",
            "ug-Arab",
            "ug-Arab-CN",
            "uk-UA",
            "ur-IN",
            "ur-PK",
            "uz-Arab",
            "uz-Arab-AF",
            "uz-Cyrl",
            "uz-Cyrl-UZ",
            "uz-Latn",
            "uz-Latn-UZ",
            "vi-VN",
            "yi-001",
            "yo-BJ",
            "yo-NG",
            "zh-Hans",
            "zh-Hans-CN",
            "zh-Hans-HK",
            "zh-Hans-MO",
            "zh-Hans-SG",
            "zh-Hant",
            "zh-Hant-HK",
            "zh-Hant-MO",
            "zh-Hant-TW",
            "zu-ZA"
        ],
        us_states_and_dc: [
            {
                name: 'Alabama',
                abbreviation: 'AL'
            },
            {
                name: 'Alaska',
                abbreviation: 'AK'
            },
            {
                name: 'Arizona',
                abbreviation: 'AZ'
            },
            {
                name: 'Arkansas',
                abbreviation: 'AR'
            },
            {
                name: 'California',
                abbreviation: 'CA'
            },
            {
                name: 'Colorado',
                abbreviation: 'CO'
            },
            {
                name: 'Connecticut',
                abbreviation: 'CT'
            },
            {
                name: 'Delaware',
                abbreviation: 'DE'
            },
            {
                name: 'District of Columbia',
                abbreviation: 'DC'
            },
            {
                name: 'Florida',
                abbreviation: 'FL'
            },
            {
                name: 'Georgia',
                abbreviation: 'GA'
            },
            {
                name: 'Hawaii',
                abbreviation: 'HI'
            },
            {
                name: 'Idaho',
                abbreviation: 'ID'
            },
            {
                name: 'Illinois',
                abbreviation: 'IL'
            },
            {
                name: 'Indiana',
                abbreviation: 'IN'
            },
            {
                name: 'Iowa',
                abbreviation: 'IA'
            },
            {
                name: 'Kansas',
                abbreviation: 'KS'
            },
            {
                name: 'Kentucky',
                abbreviation: 'KY'
            },
            {
                name: 'Louisiana',
                abbreviation: 'LA'
            },
            {
                name: 'Maine',
                abbreviation: 'ME'
            },
            {
                name: 'Maryland',
                abbreviation: 'MD'
            },
            {
                name: 'Massachusetts',
                abbreviation: 'MA'
            },
            {
                name: 'Michigan',
                abbreviation: 'MI'
            },
            {
                name: 'Minnesota',
                abbreviation: 'MN'
            },
            {
                name: 'Mississippi',
                abbreviation: 'MS'
            },
            {
                name: 'Missouri',
                abbreviation: 'MO'
            },
            {
                name: 'Montana',
                abbreviation: 'MT'
            },
            {
                name: 'Nebraska',
                abbreviation: 'NE'
            },
            {
                name: 'Nevada',
                abbreviation: 'NV'
            },
            {
                name: 'New Hampshire',
                abbreviation: 'NH'
            },
            {
                name: 'New Jersey',
                abbreviation: 'NJ'
            },
            {
                name: 'New Mexico',
                abbreviation: 'NM'
            },
            {
                name: 'New York',
                abbreviation: 'NY'
            },
            {
                name: 'North Carolina',
                abbreviation: 'NC'
            },
            {
                name: 'North Dakota',
                abbreviation: 'ND'
            },
            {
                name: 'Ohio',
                abbreviation: 'OH'
            },
            {
                name: 'Oklahoma',
                abbreviation: 'OK'
            },
            {
                name: 'Oregon',
                abbreviation: 'OR'
            },
            {
                name: 'Pennsylvania',
                abbreviation: 'PA'
            },
            {
                name: 'Rhode Island',
                abbreviation: 'RI'
            },
            {
                name: 'South Carolina',
                abbreviation: 'SC'
            },
            {
                name: 'South Dakota',
                abbreviation: 'SD'
            },
            {
                name: 'Tennessee',
                abbreviation: 'TN'
            },
            {
                name: 'Texas',
                abbreviation: 'TX'
            },
            {
                name: 'Utah',
                abbreviation: 'UT'
            },
            {
                name: 'Vermont',
                abbreviation: 'VT'
            },
            {
                name: 'Virginia',
                abbreviation: 'VA'
            },
            {
                name: 'Washington',
                abbreviation: 'WA'
            },
            {
                name: 'West Virginia',
                abbreviation: 'WV'
            },
            {
                name: 'Wisconsin',
                abbreviation: 'WI'
            },
            {
                name: 'Wyoming',
                abbreviation: 'WY'
            }
        ],
        territories: [
            {
                name: 'American Samoa',
                abbreviation: 'AS'
            },
            {
                name: 'Federated States of Micronesia',
                abbreviation: 'FM'
            },
            {
                name: 'Guam',
                abbreviation: 'GU'
            },
            {
                name: 'Marshall Islands',
                abbreviation: 'MH'
            },
            {
                name: 'Northern Mariana Islands',
                abbreviation: 'MP'
            },
            {
                name: 'Puerto Rico',
                abbreviation: 'PR'
            },
            {
                name: 'Virgin Islands, U.S.',
                abbreviation: 'VI'
            }
        ],
        armed_forces: [
            {
                name: 'Armed Forces Europe',
                abbreviation: 'AE'
            },
            {
                name: 'Armed Forces Pacific',
                abbreviation: 'AP'
            },
            {
                name: 'Armed Forces the Americas',
                abbreviation: 'AA'
            }
        ],
        country_regions: {
            it: [
                {
                    name: "Valle d'Aosta",
                    abbreviation: "VDA"
                },
                {
                    name: "Piemonte",
                    abbreviation: "PIE"
                },
                {
                    name: "Lombardia",
                    abbreviation: "LOM"
                },
                {
                    name: "Veneto",
                    abbreviation: "VEN"
                },
                {
                    name: "Trentino Alto Adige",
                    abbreviation: "TAA"
                },
                {
                    name: "Friuli Venezia Giulia",
                    abbreviation: "FVG"
                },
                {
                    name: "Liguria",
                    abbreviation: "LIG"
                },
                {
                    name: "Emilia Romagna",
                    abbreviation: "EMR"
                },
                {
                    name: "Toscana",
                    abbreviation: "TOS"
                },
                {
                    name: "Umbria",
                    abbreviation: "UMB"
                },
                {
                    name: "Marche",
                    abbreviation: "MAR"
                },
                {
                    name: "Abruzzo",
                    abbreviation: "ABR"
                },
                {
                    name: "Lazio",
                    abbreviation: "LAZ"
                },
                {
                    name: "Campania",
                    abbreviation: "CAM"
                },
                {
                    name: "Puglia",
                    abbreviation: "PUG"
                },
                {
                    name: "Basilicata",
                    abbreviation: "BAS"
                },
                {
                    name: "Molise",
                    abbreviation: "MOL"
                },
                {
                    name: "Calabria",
                    abbreviation: "CAL"
                },
                {
                    name: "Sicilia",
                    abbreviation: "SIC"
                },
                {
                    name: "Sardegna",
                    abbreviation: "SAR"
                }
            ],
            mx: [
                {
                    name: 'Aguascalientes',
                    abbreviation: 'AGU'
                },
                {
                    name: 'Baja California',
                    abbreviation: 'BCN'
                },
                {
                    name: 'Baja California Sur',
                    abbreviation: 'BCS'
                },
                {
                    name: 'Campeche',
                    abbreviation: 'CAM'
                },
                {
                    name: 'Chiapas',
                    abbreviation: 'CHP'
                },
                {
                    name: 'Chihuahua',
                    abbreviation: 'CHH'
                },
                {
                    name: "Ciudad de M\xe9xico",
                    abbreviation: 'DIF'
                },
                {
                    name: 'Coahuila',
                    abbreviation: 'COA'
                },
                {
                    name: 'Colima',
                    abbreviation: 'COL'
                },
                {
                    name: 'Durango',
                    abbreviation: 'DUR'
                },
                {
                    name: 'Guanajuato',
                    abbreviation: 'GUA'
                },
                {
                    name: 'Guerrero',
                    abbreviation: 'GRO'
                },
                {
                    name: 'Hidalgo',
                    abbreviation: 'HID'
                },
                {
                    name: 'Jalisco',
                    abbreviation: 'JAL'
                },
                {
                    name: "M\xe9xico",
                    abbreviation: 'MEX'
                },
                {
                    name: "Michoac\xe1n",
                    abbreviation: 'MIC'
                },
                {
                    name: 'Morelos',
                    abbreviation: 'MOR'
                },
                {
                    name: 'Nayarit',
                    abbreviation: 'NAY'
                },
                {
                    name: "Nuevo Le\xf3n",
                    abbreviation: 'NLE'
                },
                {
                    name: 'Oaxaca',
                    abbreviation: 'OAX'
                },
                {
                    name: 'Puebla',
                    abbreviation: 'PUE'
                },
                {
                    name: "Quer\xe9taro",
                    abbreviation: 'QUE'
                },
                {
                    name: 'Quintana Roo',
                    abbreviation: 'ROO'
                },
                {
                    name: "San Luis Potos\xed",
                    abbreviation: 'SLP'
                },
                {
                    name: 'Sinaloa',
                    abbreviation: 'SIN'
                },
                {
                    name: 'Sonora',
                    abbreviation: 'SON'
                },
                {
                    name: 'Tabasco',
                    abbreviation: 'TAB'
                },
                {
                    name: 'Tamaulipas',
                    abbreviation: 'TAM'
                },
                {
                    name: 'Tlaxcala',
                    abbreviation: 'TLA'
                },
                {
                    name: 'Veracruz',
                    abbreviation: 'VER'
                },
                {
                    name: "Yucat\xe1n",
                    abbreviation: 'YUC'
                },
                {
                    name: 'Zacatecas',
                    abbreviation: 'ZAC'
                }
            ]
        },
        street_suffixes: {
            'us': [
                {
                    name: 'Avenue',
                    abbreviation: 'Ave'
                },
                {
                    name: 'Boulevard',
                    abbreviation: 'Blvd'
                },
                {
                    name: 'Center',
                    abbreviation: 'Ctr'
                },
                {
                    name: 'Circle',
                    abbreviation: 'Cir'
                },
                {
                    name: 'Court',
                    abbreviation: 'Ct'
                },
                {
                    name: 'Drive',
                    abbreviation: 'Dr'
                },
                {
                    name: 'Extension',
                    abbreviation: 'Ext'
                },
                {
                    name: 'Glen',
                    abbreviation: 'Gln'
                },
                {
                    name: 'Grove',
                    abbreviation: 'Grv'
                },
                {
                    name: 'Heights',
                    abbreviation: 'Hts'
                },
                {
                    name: 'Highway',
                    abbreviation: 'Hwy'
                },
                {
                    name: 'Junction',
                    abbreviation: 'Jct'
                },
                {
                    name: 'Key',
                    abbreviation: 'Key'
                },
                {
                    name: 'Lane',
                    abbreviation: 'Ln'
                },
                {
                    name: 'Loop',
                    abbreviation: 'Loop'
                },
                {
                    name: 'Manor',
                    abbreviation: 'Mnr'
                },
                {
                    name: 'Mill',
                    abbreviation: 'Mill'
                },
                {
                    name: 'Park',
                    abbreviation: 'Park'
                },
                {
                    name: 'Parkway',
                    abbreviation: 'Pkwy'
                },
                {
                    name: 'Pass',
                    abbreviation: 'Pass'
                },
                {
                    name: 'Path',
                    abbreviation: 'Path'
                },
                {
                    name: 'Pike',
                    abbreviation: 'Pike'
                },
                {
                    name: 'Place',
                    abbreviation: 'Pl'
                },
                {
                    name: 'Plaza',
                    abbreviation: 'Plz'
                },
                {
                    name: 'Point',
                    abbreviation: 'Pt'
                },
                {
                    name: 'Ridge',
                    abbreviation: 'Rdg'
                },
                {
                    name: 'River',
                    abbreviation: 'Riv'
                },
                {
                    name: 'Road',
                    abbreviation: 'Rd'
                },
                {
                    name: 'Square',
                    abbreviation: 'Sq'
                },
                {
                    name: 'Street',
                    abbreviation: 'St'
                },
                {
                    name: 'Terrace',
                    abbreviation: 'Ter'
                },
                {
                    name: 'Trail',
                    abbreviation: 'Trl'
                },
                {
                    name: 'Turnpike',
                    abbreviation: 'Tpke'
                },
                {
                    name: 'View',
                    abbreviation: 'Vw'
                },
                {
                    name: 'Way',
                    abbreviation: 'Way'
                }
            ],
            'it': [
                {
                    name: 'Accesso',
                    abbreviation: 'Acc.'
                },
                {
                    name: 'Alzaia',
                    abbreviation: 'Alz.'
                },
                {
                    name: 'Arco',
                    abbreviation: 'Arco'
                },
                {
                    name: 'Archivolto',
                    abbreviation: 'Acv.'
                },
                {
                    name: 'Arena',
                    abbreviation: 'Arena'
                },
                {
                    name: 'Argine',
                    abbreviation: 'Argine'
                },
                {
                    name: 'Bacino',
                    abbreviation: 'Bacino'
                },
                {
                    name: 'Banchi',
                    abbreviation: 'Banchi'
                },
                {
                    name: 'Banchina',
                    abbreviation: 'Ban.'
                },
                {
                    name: 'Bastioni',
                    abbreviation: 'Bas.'
                },
                {
                    name: 'Belvedere',
                    abbreviation: 'Belv.'
                },
                {
                    name: 'Borgata',
                    abbreviation: 'B.ta'
                },
                {
                    name: 'Borgo',
                    abbreviation: 'B.go'
                },
                {
                    name: 'Calata',
                    abbreviation: 'Cal.'
                },
                {
                    name: 'Calle',
                    abbreviation: 'Calle'
                },
                {
                    name: 'Campiello',
                    abbreviation: 'Cam.'
                },
                {
                    name: 'Campo',
                    abbreviation: 'Cam.'
                },
                {
                    name: 'Canale',
                    abbreviation: 'Can.'
                },
                {
                    name: 'Carraia',
                    abbreviation: 'Carr.'
                },
                {
                    name: 'Cascina',
                    abbreviation: 'Cascina'
                },
                {
                    name: 'Case sparse',
                    abbreviation: 'c.s.'
                },
                {
                    name: 'Cavalcavia',
                    abbreviation: 'Cv.'
                },
                {
                    name: 'Circonvallazione',
                    abbreviation: 'Cv.'
                },
                {
                    name: 'Complanare',
                    abbreviation: 'C.re'
                },
                {
                    name: 'Contrada',
                    abbreviation: 'C.da'
                },
                {
                    name: 'Corso',
                    abbreviation: 'C.so'
                },
                {
                    name: 'Corte',
                    abbreviation: 'C.te'
                },
                {
                    name: 'Cortile',
                    abbreviation: 'C.le'
                },
                {
                    name: 'Diramazione',
                    abbreviation: 'Dir.'
                },
                {
                    name: 'Fondaco',
                    abbreviation: 'F.co'
                },
                {
                    name: 'Fondamenta',
                    abbreviation: 'F.ta'
                },
                {
                    name: 'Fondo',
                    abbreviation: 'F.do'
                },
                {
                    name: 'Frazione',
                    abbreviation: 'Fr.'
                },
                {
                    name: 'Isola',
                    abbreviation: 'Is.'
                },
                {
                    name: 'Largo',
                    abbreviation: 'L.go'
                },
                {
                    name: 'Litoranea',
                    abbreviation: 'Lit.'
                },
                {
                    name: 'Lungolago',
                    abbreviation: 'L.go lago'
                },
                {
                    name: 'Lungo Po',
                    abbreviation: 'l.go Po'
                },
                {
                    name: 'Molo',
                    abbreviation: 'Molo'
                },
                {
                    name: 'Mura',
                    abbreviation: 'Mura'
                },
                {
                    name: 'Passaggio privato',
                    abbreviation: 'pass. priv.'
                },
                {
                    name: 'Passeggiata',
                    abbreviation: 'Pass.'
                },
                {
                    name: 'Piazza',
                    abbreviation: 'P.zza'
                },
                {
                    name: 'Piazzale',
                    abbreviation: 'P.le'
                },
                {
                    name: 'Ponte',
                    abbreviation: 'P.te'
                },
                {
                    name: 'Portico',
                    abbreviation: 'P.co'
                },
                {
                    name: 'Rampa',
                    abbreviation: 'Rampa'
                },
                {
                    name: 'Regione',
                    abbreviation: 'Reg.'
                },
                {
                    name: 'Rione',
                    abbreviation: 'R.ne'
                },
                {
                    name: 'Rio',
                    abbreviation: 'Rio'
                },
                {
                    name: 'Ripa',
                    abbreviation: 'Ripa'
                },
                {
                    name: 'Riva',
                    abbreviation: 'Riva'
                },
                {
                    name: "Rond\xf2",
                    abbreviation: "Rond\xf2"
                },
                {
                    name: 'Rotonda',
                    abbreviation: 'Rot.'
                },
                {
                    name: 'Sagrato',
                    abbreviation: 'Sagr.'
                },
                {
                    name: 'Salita',
                    abbreviation: 'Sal.'
                },
                {
                    name: 'Scalinata',
                    abbreviation: 'Scal.'
                },
                {
                    name: 'Scalone',
                    abbreviation: 'Scal.'
                },
                {
                    name: 'Slargo',
                    abbreviation: 'Sl.'
                },
                {
                    name: 'Sottoportico',
                    abbreviation: 'Sott.'
                },
                {
                    name: 'Strada',
                    abbreviation: 'Str.'
                },
                {
                    name: 'Stradale',
                    abbreviation: 'Str.le'
                },
                {
                    name: 'Strettoia',
                    abbreviation: 'Strett.'
                },
                {
                    name: 'Traversa',
                    abbreviation: 'Trav.'
                },
                {
                    name: 'Via',
                    abbreviation: 'V.'
                },
                {
                    name: 'Viale',
                    abbreviation: 'V.le'
                },
                {
                    name: 'Vicinale',
                    abbreviation: 'Vic.le'
                },
                {
                    name: 'Vicolo',
                    abbreviation: 'Vic.'
                }
            ],
            'uk': [
                {
                    name: 'Avenue',
                    abbreviation: 'Ave'
                },
                {
                    name: 'Close',
                    abbreviation: 'Cl'
                },
                {
                    name: 'Court',
                    abbreviation: 'Ct'
                },
                {
                    name: 'Crescent',
                    abbreviation: 'Cr'
                },
                {
                    name: 'Drive',
                    abbreviation: 'Dr'
                },
                {
                    name: 'Garden',
                    abbreviation: 'Gdn'
                },
                {
                    name: 'Gardens',
                    abbreviation: 'Gdns'
                },
                {
                    name: 'Green',
                    abbreviation: 'Gn'
                },
                {
                    name: 'Grove',
                    abbreviation: 'Gr'
                },
                {
                    name: 'Lane',
                    abbreviation: 'Ln'
                },
                {
                    name: 'Mount',
                    abbreviation: 'Mt'
                },
                {
                    name: 'Place',
                    abbreviation: 'Pl'
                },
                {
                    name: 'Park',
                    abbreviation: 'Pk'
                },
                {
                    name: 'Ridge',
                    abbreviation: 'Rdg'
                },
                {
                    name: 'Road',
                    abbreviation: 'Rd'
                },
                {
                    name: 'Square',
                    abbreviation: 'Sq'
                },
                {
                    name: 'Street',
                    abbreviation: 'St'
                },
                {
                    name: 'Terrace',
                    abbreviation: 'Ter'
                },
                {
                    name: 'Valley',
                    abbreviation: 'Val'
                }
            ]
        },
        months: [
            {
                name: 'January',
                short_name: 'Jan',
                numeric: '01',
                days: 31
            },
            // Not messing with leap years...
            {
                name: 'February',
                short_name: 'Feb',
                numeric: '02',
                days: 28
            },
            {
                name: 'March',
                short_name: 'Mar',
                numeric: '03',
                days: 31
            },
            {
                name: 'April',
                short_name: 'Apr',
                numeric: '04',
                days: 30
            },
            {
                name: 'May',
                short_name: 'May',
                numeric: '05',
                days: 31
            },
            {
                name: 'June',
                short_name: 'Jun',
                numeric: '06',
                days: 30
            },
            {
                name: 'July',
                short_name: 'Jul',
                numeric: '07',
                days: 31
            },
            {
                name: 'August',
                short_name: 'Aug',
                numeric: '08',
                days: 31
            },
            {
                name: 'September',
                short_name: 'Sep',
                numeric: '09',
                days: 30
            },
            {
                name: 'October',
                short_name: 'Oct',
                numeric: '10',
                days: 31
            },
            {
                name: 'November',
                short_name: 'Nov',
                numeric: '11',
                days: 30
            },
            {
                name: 'December',
                short_name: 'Dec',
                numeric: '12',
                days: 31
            }
        ],
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        cc_types: [
            {
                name: "American Express",
                short_name: 'amex',
                prefix: '34',
                length: 15
            },
            {
                name: "Bankcard",
                short_name: 'bankcard',
                prefix: '5610',
                length: 16
            },
            {
                name: "China UnionPay",
                short_name: 'chinaunion',
                prefix: '62',
                length: 16
            },
            {
                name: "Diners Club Carte Blanche",
                short_name: 'dccarte',
                prefix: '300',
                length: 14
            },
            {
                name: "Diners Club enRoute",
                short_name: 'dcenroute',
                prefix: '2014',
                length: 15
            },
            {
                name: "Diners Club International",
                short_name: 'dcintl',
                prefix: '36',
                length: 14
            },
            {
                name: "Diners Club United States & Canada",
                short_name: 'dcusc',
                prefix: '54',
                length: 16
            },
            {
                name: "Discover Card",
                short_name: 'discover',
                prefix: '6011',
                length: 16
            },
            {
                name: "InstaPayment",
                short_name: 'instapay',
                prefix: '637',
                length: 16
            },
            {
                name: "JCB",
                short_name: 'jcb',
                prefix: '3528',
                length: 16
            },
            {
                name: "Laser",
                short_name: 'laser',
                prefix: '6304',
                length: 16
            },
            {
                name: "Maestro",
                short_name: 'maestro',
                prefix: '5018',
                length: 16
            },
            {
                name: "Mastercard",
                short_name: 'mc',
                prefix: '51',
                length: 16
            },
            {
                name: "Solo",
                short_name: 'solo',
                prefix: '6334',
                length: 16
            },
            {
                name: "Switch",
                short_name: 'switch',
                prefix: '4903',
                length: 16
            },
            {
                name: "Visa",
                short_name: 'visa',
                prefix: '4',
                length: 16
            },
            {
                name: "Visa Electron",
                short_name: 'electron',
                prefix: '4026',
                length: 16
            }
        ],
        //return all world currency by ISO 4217
        currency_types: [
            {
                'code': 'AED',
                'name': 'United Arab Emirates Dirham'
            },
            {
                'code': 'AFN',
                'name': 'Afghanistan Afghani'
            },
            {
                'code': 'ALL',
                'name': 'Albania Lek'
            },
            {
                'code': 'AMD',
                'name': 'Armenia Dram'
            },
            {
                'code': 'ANG',
                'name': 'Netherlands Antilles Guilder'
            },
            {
                'code': 'AOA',
                'name': 'Angola Kwanza'
            },
            {
                'code': 'ARS',
                'name': 'Argentina Peso'
            },
            {
                'code': 'AUD',
                'name': 'Australia Dollar'
            },
            {
                'code': 'AWG',
                'name': 'Aruba Guilder'
            },
            {
                'code': 'AZN',
                'name': 'Azerbaijan New Manat'
            },
            {
                'code': 'BAM',
                'name': 'Bosnia and Herzegovina Convertible Marka'
            },
            {
                'code': 'BBD',
                'name': 'Barbados Dollar'
            },
            {
                'code': 'BDT',
                'name': 'Bangladesh Taka'
            },
            {
                'code': 'BGN',
                'name': 'Bulgaria Lev'
            },
            {
                'code': 'BHD',
                'name': 'Bahrain Dinar'
            },
            {
                'code': 'BIF',
                'name': 'Burundi Franc'
            },
            {
                'code': 'BMD',
                'name': 'Bermuda Dollar'
            },
            {
                'code': 'BND',
                'name': 'Brunei Darussalam Dollar'
            },
            {
                'code': 'BOB',
                'name': 'Bolivia Boliviano'
            },
            {
                'code': 'BRL',
                'name': 'Brazil Real'
            },
            {
                'code': 'BSD',
                'name': 'Bahamas Dollar'
            },
            {
                'code': 'BTN',
                'name': 'Bhutan Ngultrum'
            },
            {
                'code': 'BWP',
                'name': 'Botswana Pula'
            },
            {
                'code': 'BYR',
                'name': 'Belarus Ruble'
            },
            {
                'code': 'BZD',
                'name': 'Belize Dollar'
            },
            {
                'code': 'CAD',
                'name': 'Canada Dollar'
            },
            {
                'code': 'CDF',
                'name': 'Congo/Kinshasa Franc'
            },
            {
                'code': 'CHF',
                'name': 'Switzerland Franc'
            },
            {
                'code': 'CLP',
                'name': 'Chile Peso'
            },
            {
                'code': 'CNY',
                'name': 'China Yuan Renminbi'
            },
            {
                'code': 'COP',
                'name': 'Colombia Peso'
            },
            {
                'code': 'CRC',
                'name': 'Costa Rica Colon'
            },
            {
                'code': 'CUC',
                'name': 'Cuba Convertible Peso'
            },
            {
                'code': 'CUP',
                'name': 'Cuba Peso'
            },
            {
                'code': 'CVE',
                'name': 'Cape Verde Escudo'
            },
            {
                'code': 'CZK',
                'name': 'Czech Republic Koruna'
            },
            {
                'code': 'DJF',
                'name': 'Djibouti Franc'
            },
            {
                'code': 'DKK',
                'name': 'Denmark Krone'
            },
            {
                'code': 'DOP',
                'name': 'Dominican Republic Peso'
            },
            {
                'code': 'DZD',
                'name': 'Algeria Dinar'
            },
            {
                'code': 'EGP',
                'name': 'Egypt Pound'
            },
            {
                'code': 'ERN',
                'name': 'Eritrea Nakfa'
            },
            {
                'code': 'ETB',
                'name': 'Ethiopia Birr'
            },
            {
                'code': 'EUR',
                'name': 'Euro Member Countries'
            },
            {
                'code': 'FJD',
                'name': 'Fiji Dollar'
            },
            {
                'code': 'FKP',
                'name': 'Falkland Islands (Malvinas) Pound'
            },
            {
                'code': 'GBP',
                'name': 'United Kingdom Pound'
            },
            {
                'code': 'GEL',
                'name': 'Georgia Lari'
            },
            {
                'code': 'GGP',
                'name': 'Guernsey Pound'
            },
            {
                'code': 'GHS',
                'name': 'Ghana Cedi'
            },
            {
                'code': 'GIP',
                'name': 'Gibraltar Pound'
            },
            {
                'code': 'GMD',
                'name': 'Gambia Dalasi'
            },
            {
                'code': 'GNF',
                'name': 'Guinea Franc'
            },
            {
                'code': 'GTQ',
                'name': 'Guatemala Quetzal'
            },
            {
                'code': 'GYD',
                'name': 'Guyana Dollar'
            },
            {
                'code': 'HKD',
                'name': 'Hong Kong Dollar'
            },
            {
                'code': 'HNL',
                'name': 'Honduras Lempira'
            },
            {
                'code': 'HRK',
                'name': 'Croatia Kuna'
            },
            {
                'code': 'HTG',
                'name': 'Haiti Gourde'
            },
            {
                'code': 'HUF',
                'name': 'Hungary Forint'
            },
            {
                'code': 'IDR',
                'name': 'Indonesia Rupiah'
            },
            {
                'code': 'ILS',
                'name': 'Israel Shekel'
            },
            {
                'code': 'IMP',
                'name': 'Isle of Man Pound'
            },
            {
                'code': 'INR',
                'name': 'India Rupee'
            },
            {
                'code': 'IQD',
                'name': 'Iraq Dinar'
            },
            {
                'code': 'IRR',
                'name': 'Iran Rial'
            },
            {
                'code': 'ISK',
                'name': 'Iceland Krona'
            },
            {
                'code': 'JEP',
                'name': 'Jersey Pound'
            },
            {
                'code': 'JMD',
                'name': 'Jamaica Dollar'
            },
            {
                'code': 'JOD',
                'name': 'Jordan Dinar'
            },
            {
                'code': 'JPY',
                'name': 'Japan Yen'
            },
            {
                'code': 'KES',
                'name': 'Kenya Shilling'
            },
            {
                'code': 'KGS',
                'name': 'Kyrgyzstan Som'
            },
            {
                'code': 'KHR',
                'name': 'Cambodia Riel'
            },
            {
                'code': 'KMF',
                'name': 'Comoros Franc'
            },
            {
                'code': 'KPW',
                'name': 'Korea (North) Won'
            },
            {
                'code': 'KRW',
                'name': 'Korea (South) Won'
            },
            {
                'code': 'KWD',
                'name': 'Kuwait Dinar'
            },
            {
                'code': 'KYD',
                'name': 'Cayman Islands Dollar'
            },
            {
                'code': 'KZT',
                'name': 'Kazakhstan Tenge'
            },
            {
                'code': 'LAK',
                'name': 'Laos Kip'
            },
            {
                'code': 'LBP',
                'name': 'Lebanon Pound'
            },
            {
                'code': 'LKR',
                'name': 'Sri Lanka Rupee'
            },
            {
                'code': 'LRD',
                'name': 'Liberia Dollar'
            },
            {
                'code': 'LSL',
                'name': 'Lesotho Loti'
            },
            {
                'code': 'LTL',
                'name': 'Lithuania Litas'
            },
            {
                'code': 'LYD',
                'name': 'Libya Dinar'
            },
            {
                'code': 'MAD',
                'name': 'Morocco Dirham'
            },
            {
                'code': 'MDL',
                'name': 'Moldova Leu'
            },
            {
                'code': 'MGA',
                'name': 'Madagascar Ariary'
            },
            {
                'code': 'MKD',
                'name': 'Macedonia Denar'
            },
            {
                'code': 'MMK',
                'name': 'Myanmar (Burma) Kyat'
            },
            {
                'code': 'MNT',
                'name': 'Mongolia Tughrik'
            },
            {
                'code': 'MOP',
                'name': 'Macau Pataca'
            },
            {
                'code': 'MRO',
                'name': 'Mauritania Ouguiya'
            },
            {
                'code': 'MUR',
                'name': 'Mauritius Rupee'
            },
            {
                'code': 'MVR',
                'name': 'Maldives (Maldive Islands) Rufiyaa'
            },
            {
                'code': 'MWK',
                'name': 'Malawi Kwacha'
            },
            {
                'code': 'MXN',
                'name': 'Mexico Peso'
            },
            {
                'code': 'MYR',
                'name': 'Malaysia Ringgit'
            },
            {
                'code': 'MZN',
                'name': 'Mozambique Metical'
            },
            {
                'code': 'NAD',
                'name': 'Namibia Dollar'
            },
            {
                'code': 'NGN',
                'name': 'Nigeria Naira'
            },
            {
                'code': 'NIO',
                'name': 'Nicaragua Cordoba'
            },
            {
                'code': 'NOK',
                'name': 'Norway Krone'
            },
            {
                'code': 'NPR',
                'name': 'Nepal Rupee'
            },
            {
                'code': 'NZD',
                'name': 'New Zealand Dollar'
            },
            {
                'code': 'OMR',
                'name': 'Oman Rial'
            },
            {
                'code': 'PAB',
                'name': 'Panama Balboa'
            },
            {
                'code': 'PEN',
                'name': 'Peru Nuevo Sol'
            },
            {
                'code': 'PGK',
                'name': 'Papua New Guinea Kina'
            },
            {
                'code': 'PHP',
                'name': 'Philippines Peso'
            },
            {
                'code': 'PKR',
                'name': 'Pakistan Rupee'
            },
            {
                'code': 'PLN',
                'name': 'Poland Zloty'
            },
            {
                'code': 'PYG',
                'name': 'Paraguay Guarani'
            },
            {
                'code': 'QAR',
                'name': 'Qatar Riyal'
            },
            {
                'code': 'RON',
                'name': 'Romania New Leu'
            },
            {
                'code': 'RSD',
                'name': 'Serbia Dinar'
            },
            {
                'code': 'RUB',
                'name': 'Russia Ruble'
            },
            {
                'code': 'RWF',
                'name': 'Rwanda Franc'
            },
            {
                'code': 'SAR',
                'name': 'Saudi Arabia Riyal'
            },
            {
                'code': 'SBD',
                'name': 'Solomon Islands Dollar'
            },
            {
                'code': 'SCR',
                'name': 'Seychelles Rupee'
            },
            {
                'code': 'SDG',
                'name': 'Sudan Pound'
            },
            {
                'code': 'SEK',
                'name': 'Sweden Krona'
            },
            {
                'code': 'SGD',
                'name': 'Singapore Dollar'
            },
            {
                'code': 'SHP',
                'name': 'Saint Helena Pound'
            },
            {
                'code': 'SLL',
                'name': 'Sierra Leone Leone'
            },
            {
                'code': 'SOS',
                'name': 'Somalia Shilling'
            },
            {
                'code': 'SPL',
                'name': 'Seborga Luigino'
            },
            {
                'code': 'SRD',
                'name': 'Suriname Dollar'
            },
            {
                'code': 'STD',
                'name': "S\xe3o Tom\xe9 and Pr\xedncipe Dobra"
            },
            {
                'code': 'SVC',
                'name': 'El Salvador Colon'
            },
            {
                'code': 'SYP',
                'name': 'Syria Pound'
            },
            {
                'code': 'SZL',
                'name': 'Swaziland Lilangeni'
            },
            {
                'code': 'THB',
                'name': 'Thailand Baht'
            },
            {
                'code': 'TJS',
                'name': 'Tajikistan Somoni'
            },
            {
                'code': 'TMT',
                'name': 'Turkmenistan Manat'
            },
            {
                'code': 'TND',
                'name': 'Tunisia Dinar'
            },
            {
                'code': 'TOP',
                'name': 'Tonga Pa\'anga'
            },
            {
                'code': 'TRY',
                'name': 'Turkey Lira'
            },
            {
                'code': 'TTD',
                'name': 'Trinidad and Tobago Dollar'
            },
            {
                'code': 'TVD',
                'name': 'Tuvalu Dollar'
            },
            {
                'code': 'TWD',
                'name': 'Taiwan New Dollar'
            },
            {
                'code': 'TZS',
                'name': 'Tanzania Shilling'
            },
            {
                'code': 'UAH',
                'name': 'Ukraine Hryvnia'
            },
            {
                'code': 'UGX',
                'name': 'Uganda Shilling'
            },
            {
                'code': 'USD',
                'name': 'United States Dollar'
            },
            {
                'code': 'UYU',
                'name': 'Uruguay Peso'
            },
            {
                'code': 'UZS',
                'name': 'Uzbekistan Som'
            },
            {
                'code': 'VEF',
                'name': 'Venezuela Bolivar'
            },
            {
                'code': 'VND',
                'name': 'Viet Nam Dong'
            },
            {
                'code': 'VUV',
                'name': 'Vanuatu Vatu'
            },
            {
                'code': 'WST',
                'name': 'Samoa Tala'
            },
            {
                'code': 'XAF',
                'name': "Communaut\xe9 Financi\xe8re Africaine (BEAC) CFA Franc BEAC"
            },
            {
                'code': 'XCD',
                'name': 'East Caribbean Dollar'
            },
            {
                'code': 'XDR',
                'name': 'International Monetary Fund (IMF) Special Drawing Rights'
            },
            {
                'code': 'XOF',
                'name': "Communaut\xe9 Financi\xe8re Africaine (BCEAO) Franc"
            },
            {
                'code': 'XPF',
                'name': "Comptoirs Fran\xe7ais du Pacifique (CFP) Franc"
            },
            {
                'code': 'YER',
                'name': 'Yemen Rial'
            },
            {
                'code': 'ZAR',
                'name': 'South Africa Rand'
            },
            {
                'code': 'ZMW',
                'name': 'Zambia Kwacha'
            },
            {
                'code': 'ZWD',
                'name': 'Zimbabwe Dollar'
            }
        ],
        // return the names of all valide colors
        colorNames: [
            "AliceBlue",
            "Black",
            "Navy",
            "DarkBlue",
            "MediumBlue",
            "Blue",
            "DarkGreen",
            "Green",
            "Teal",
            "DarkCyan",
            "DeepSkyBlue",
            "DarkTurquoise",
            "MediumSpringGreen",
            "Lime",
            "SpringGreen",
            "Aqua",
            "Cyan",
            "MidnightBlue",
            "DodgerBlue",
            "LightSeaGreen",
            "ForestGreen",
            "SeaGreen",
            "DarkSlateGray",
            "LimeGreen",
            "MediumSeaGreen",
            "Turquoise",
            "RoyalBlue",
            "SteelBlue",
            "DarkSlateBlue",
            "MediumTurquoise",
            "Indigo",
            "DarkOliveGreen",
            "CadetBlue",
            "CornflowerBlue",
            "RebeccaPurple",
            "MediumAquaMarine",
            "DimGray",
            "SlateBlue",
            "OliveDrab",
            "SlateGray",
            "LightSlateGray",
            "MediumSlateBlue",
            "LawnGreen",
            "Chartreuse",
            "Aquamarine",
            "Maroon",
            "Purple",
            "Olive",
            "Gray",
            "SkyBlue",
            "LightSkyBlue",
            "BlueViolet",
            "DarkRed",
            "DarkMagenta",
            "SaddleBrown",
            "Ivory",
            "White",
            "DarkSeaGreen",
            "LightGreen",
            "MediumPurple",
            "DarkViolet",
            "PaleGreen",
            "DarkOrchid",
            "YellowGreen",
            "Sienna",
            "Brown",
            "DarkGray",
            "LightBlue",
            "GreenYellow",
            "PaleTurquoise",
            "LightSteelBlue",
            "PowderBlue",
            "FireBrick",
            "DarkGoldenRod",
            "MediumOrchid",
            "RosyBrown",
            "DarkKhaki",
            "Silver",
            "MediumVioletRed",
            "IndianRed",
            "Peru",
            "Chocolate",
            "Tan",
            "LightGray",
            "Thistle",
            "Orchid",
            "GoldenRod",
            "PaleVioletRed",
            "Crimson",
            "Gainsboro",
            "Plum",
            "BurlyWood",
            "LightCyan",
            "Lavender",
            "DarkSalmon",
            "Violet",
            "PaleGoldenRod",
            "LightCoral",
            "Khaki",
            "AliceBlue",
            "HoneyDew",
            "Azure",
            "SandyBrown",
            "Wheat",
            "Beige",
            "WhiteSmoke",
            "MintCream",
            "GhostWhite",
            "Salmon",
            "AntiqueWhite",
            "Linen",
            "LightGoldenRodYellow",
            "OldLace",
            "Red",
            "Fuchsia",
            "Magenta",
            "DeepPink",
            "OrangeRed",
            "Tomato",
            "HotPink",
            "Coral",
            "DarkOrange",
            "LightSalmon",
            "Orange",
            "LightPink",
            "Pink",
            "Gold",
            "PeachPuff",
            "NavajoWhite",
            "Moccasin",
            "Bisque",
            "MistyRose",
            "BlanchedAlmond",
            "PapayaWhip",
            "LavenderBlush",
            "SeaShell",
            "Cornsilk",
            "LemonChiffon",
            "FloralWhite",
            "Snow",
            "Yellow",
            "LightYellow"
        ],
        // Data taken from https://www.sec.gov/rules/other/4-460list.htm
        company: [
            "3Com Corp",
            "3M Company",
            "A.G. Edwards Inc.",
            "Abbott Laboratories",
            "Abercrombie & Fitch Co.",
            "ABM Industries Incorporated",
            "Ace Hardware Corporation",
            "ACT Manufacturing Inc.",
            "Acterna Corp.",
            "Adams Resources & Energy, Inc.",
            "ADC Telecommunications, Inc.",
            "Adelphia Communications Corporation",
            "Administaff, Inc.",
            "Adobe Systems Incorporated",
            "Adolph Coors Company",
            "Advance Auto Parts, Inc.",
            "Advanced Micro Devices, Inc.",
            "AdvancePCS, Inc.",
            "Advantica Restaurant Group, Inc.",
            "The AES Corporation",
            "Aetna Inc.",
            "Affiliated Computer Services, Inc.",
            "AFLAC Incorporated",
            "AGCO Corporation",
            "Agilent Technologies, Inc.",
            "Agway Inc.",
            "Apartment Investment and Management Company",
            "Air Products and Chemicals, Inc.",
            "Airborne, Inc.",
            "Airgas, Inc.",
            "AK Steel Holding Corporation",
            "Alaska Air Group, Inc.",
            "Alberto-Culver Company",
            "Albertson's, Inc.",
            "Alcoa Inc.",
            "Alleghany Corporation",
            "Allegheny Energy, Inc.",
            "Allegheny Technologies Incorporated",
            "Allergan, Inc.",
            "ALLETE, Inc.",
            "Alliant Energy Corporation",
            "Allied Waste Industries, Inc.",
            "Allmerica Financial Corporation",
            "The Allstate Corporation",
            "ALLTEL Corporation",
            "The Alpine Group, Inc.",
            "Amazon.com, Inc.",
            "AMC Entertainment Inc.",
            "American Power Conversion Corporation",
            "Amerada Hess Corporation",
            "AMERCO",
            "Ameren Corporation",
            "America West Holdings Corporation",
            "American Axle & Manufacturing Holdings, Inc.",
            "American Eagle Outfitters, Inc.",
            "American Electric Power Company, Inc.",
            "American Express Company",
            "American Financial Group, Inc.",
            "American Greetings Corporation",
            "American International Group, Inc.",
            "American Standard Companies Inc.",
            "American Water Works Company, Inc.",
            "AmerisourceBergen Corporation",
            "Ames Department Stores, Inc.",
            "Amgen Inc.",
            "Amkor Technology, Inc.",
            "AMR Corporation",
            "AmSouth Bancorp.",
            "Amtran, Inc.",
            "Anadarko Petroleum Corporation",
            "Analog Devices, Inc.",
            "Anheuser-Busch Companies, Inc.",
            "Anixter International Inc.",
            "AnnTaylor Inc.",
            "Anthem, Inc.",
            "AOL Time Warner Inc.",
            "Aon Corporation",
            "Apache Corporation",
            "Apple Computer, Inc.",
            "Applera Corporation",
            "Applied Industrial Technologies, Inc.",
            "Applied Materials, Inc.",
            "Aquila, Inc.",
            "ARAMARK Corporation",
            "Arch Coal, Inc.",
            "Archer Daniels Midland Company",
            "Arkansas Best Corporation",
            "Armstrong Holdings, Inc.",
            "Arrow Electronics, Inc.",
            "ArvinMeritor, Inc.",
            "Ashland Inc.",
            "Astoria Financial Corporation",
            "AT&T Corp.",
            "Atmel Corporation",
            "Atmos Energy Corporation",
            "Audiovox Corporation",
            "Autoliv, Inc.",
            "Automatic Data Processing, Inc.",
            "AutoNation, Inc.",
            "AutoZone, Inc.",
            "Avaya Inc.",
            "Avery Dennison Corporation",
            "Avista Corporation",
            "Avnet, Inc.",
            "Avon Products, Inc.",
            "Baker Hughes Incorporated",
            "Ball Corporation",
            "Bank of America Corporation",
            "The Bank of New York Company, Inc.",
            "Bank One Corporation",
            "Banknorth Group, Inc.",
            "Banta Corporation",
            "Barnes & Noble, Inc.",
            "Bausch & Lomb Incorporated",
            "Baxter International Inc.",
            "BB&T Corporation",
            "The Bear Stearns Companies Inc.",
            "Beazer Homes USA, Inc.",
            "Beckman Coulter, Inc.",
            "Becton, Dickinson and Company",
            "Bed Bath & Beyond Inc.",
            "Belk, Inc.",
            "Bell Microproducts Inc.",
            "BellSouth Corporation",
            "Belo Corp.",
            "Bemis Company, Inc.",
            "Benchmark Electronics, Inc.",
            "Berkshire Hathaway Inc.",
            "Best Buy Co., Inc.",
            "Bethlehem Steel Corporation",
            "Beverly Enterprises, Inc.",
            "Big Lots, Inc.",
            "BJ Services Company",
            "BJ's Wholesale Club, Inc.",
            "The Black & Decker Corporation",
            "Black Hills Corporation",
            "BMC Software, Inc.",
            "The Boeing Company",
            "Boise Cascade Corporation",
            "Borders Group, Inc.",
            "BorgWarner Inc.",
            "Boston Scientific Corporation",
            "Bowater Incorporated",
            "Briggs & Stratton Corporation",
            "Brightpoint, Inc.",
            "Brinker International, Inc.",
            "Bristol-Myers Squibb Company",
            "Broadwing, Inc.",
            "Brown Shoe Company, Inc.",
            "Brown-Forman Corporation",
            "Brunswick Corporation",
            "Budget Group, Inc.",
            "Burlington Coat Factory Warehouse Corporation",
            "Burlington Industries, Inc.",
            "Burlington Northern Santa Fe Corporation",
            "Burlington Resources Inc.",
            "C. H. Robinson Worldwide Inc.",
            "Cablevision Systems Corp",
            "Cabot Corp",
            "Cadence Design Systems, Inc.",
            "Calpine Corp.",
            "Campbell Soup Co.",
            "Capital One Financial Corp.",
            "Cardinal Health Inc.",
            "Caremark Rx Inc.",
            "Carlisle Cos. Inc.",
            "Carpenter Technology Corp.",
            "Casey's General Stores Inc.",
            "Caterpillar Inc.",
            "CBRL Group Inc.",
            "CDI Corp.",
            "CDW Computer Centers Inc.",
            "CellStar Corp.",
            "Cendant Corp",
            "Cenex Harvest States Cooperatives",
            "Centex Corp.",
            "CenturyTel Inc.",
            "Ceridian Corp.",
            "CH2M Hill Cos. Ltd.",
            "Champion Enterprises Inc.",
            "Charles Schwab Corp.",
            "Charming Shoppes Inc.",
            "Charter Communications Inc.",
            "Charter One Financial Inc.",
            "ChevronTexaco Corp.",
            "Chiquita Brands International Inc.",
            "Chubb Corp",
            "Ciena Corp.",
            "Cigna Corp",
            "Cincinnati Financial Corp.",
            "Cinergy Corp.",
            "Cintas Corp.",
            "Circuit City Stores Inc.",
            "Cisco Systems Inc.",
            "Citigroup, Inc",
            "Citizens Communications Co.",
            "CKE Restaurants Inc.",
            "Clear Channel Communications Inc.",
            "The Clorox Co.",
            "CMGI Inc.",
            "CMS Energy Corp.",
            "CNF Inc.",
            "Coca-Cola Co.",
            "Coca-Cola Enterprises Inc.",
            "Colgate-Palmolive Co.",
            "Collins & Aikman Corp.",
            "Comcast Corp.",
            "Comdisco Inc.",
            "Comerica Inc.",
            "Comfort Systems USA Inc.",
            "Commercial Metals Co.",
            "Community Health Systems Inc.",
            "Compass Bancshares Inc",
            "Computer Associates International Inc.",
            "Computer Sciences Corp.",
            "Compuware Corp.",
            "Comverse Technology Inc.",
            "ConAgra Foods Inc.",
            "Concord EFS Inc.",
            "Conectiv, Inc",
            "Conoco Inc",
            "Conseco Inc.",
            "Consolidated Freightways Corp.",
            "Consolidated Edison Inc.",
            "Constellation Brands Inc.",
            "Constellation Emergy Group Inc.",
            "Continental Airlines Inc.",
            "Convergys Corp.",
            "Cooper Cameron Corp.",
            "Cooper Industries Ltd.",
            "Cooper Tire & Rubber Co.",
            "Corn Products International Inc.",
            "Corning Inc.",
            "Costco Wholesale Corp.",
            "Countrywide Credit Industries Inc.",
            "Coventry Health Care Inc.",
            "Cox Communications Inc.",
            "Crane Co.",
            "Crompton Corp.",
            "Crown Cork & Seal Co. Inc.",
            "CSK Auto Corp.",
            "CSX Corp.",
            "Cummins Inc.",
            "CVS Corp.",
            "Cytec Industries Inc.",
            "D&K Healthcare Resources, Inc.",
            "D.R. Horton Inc.",
            "Dana Corporation",
            "Danaher Corporation",
            "Darden Restaurants Inc.",
            "DaVita Inc.",
            "Dean Foods Company",
            "Deere & Company",
            "Del Monte Foods Co",
            "Dell Computer Corporation",
            "Delphi Corp.",
            "Delta Air Lines Inc.",
            "Deluxe Corporation",
            "Devon Energy Corporation",
            "Di Giorgio Corporation",
            "Dial Corporation",
            "Diebold Incorporated",
            "Dillard's Inc.",
            "DIMON Incorporated",
            "Dole Food Company, Inc.",
            "Dollar General Corporation",
            "Dollar Tree Stores, Inc.",
            "Dominion Resources, Inc.",
            "Domino's Pizza LLC",
            "Dover Corporation, Inc.",
            "Dow Chemical Company",
            "Dow Jones & Company, Inc.",
            "DPL Inc.",
            "DQE Inc.",
            "Dreyer's Grand Ice Cream, Inc.",
            "DST Systems, Inc.",
            "DTE Energy Co.",
            "E.I. Du Pont de Nemours and Company",
            "Duke Energy Corp",
            "Dun & Bradstreet Inc.",
            "DURA Automotive Systems Inc.",
            "DynCorp",
            "Dynegy Inc.",
            "E*Trade Group, Inc.",
            "E.W. Scripps Company",
            "Earthlink, Inc.",
            "Eastman Chemical Company",
            "Eastman Kodak Company",
            "Eaton Corporation",
            "Echostar Communications Corporation",
            "Ecolab Inc.",
            "Edison International",
            "EGL Inc.",
            "El Paso Corporation",
            "Electronic Arts Inc.",
            "Electronic Data Systems Corp.",
            "Eli Lilly and Company",
            "EMC Corporation",
            "Emcor Group Inc.",
            "Emerson Electric Co.",
            "Encompass Services Corporation",
            "Energizer Holdings Inc.",
            "Energy East Corporation",
            "Engelhard Corporation",
            "Enron Corp.",
            "Entergy Corporation",
            "Enterprise Products Partners L.P.",
            "EOG Resources, Inc.",
            "Equifax Inc.",
            "Equitable Resources Inc.",
            "Equity Office Properties Trust",
            "Equity Residential Properties Trust",
            "Estee Lauder Companies Inc.",
            "Exelon Corporation",
            "Exide Technologies",
            "Expeditors International of Washington Inc.",
            "Express Scripts Inc.",
            "ExxonMobil Corporation",
            "Fairchild Semiconductor International Inc.",
            "Family Dollar Stores Inc.",
            "Farmland Industries Inc.",
            "Federal Mogul Corp.",
            "Federated Department Stores Inc.",
            "Federal Express Corp.",
            "Felcor Lodging Trust Inc.",
            "Ferro Corp.",
            "Fidelity National Financial Inc.",
            "Fifth Third Bancorp",
            "First American Financial Corp.",
            "First Data Corp.",
            "First National of Nebraska Inc.",
            "First Tennessee National Corp.",
            "FirstEnergy Corp.",
            "Fiserv Inc.",
            "Fisher Scientific International Inc.",
            "FleetBoston Financial Co.",
            "Fleetwood Enterprises Inc.",
            "Fleming Companies Inc.",
            "Flowers Foods Inc.",
            "Flowserv Corp",
            "Fluor Corp",
            "FMC Corp",
            "Foamex International Inc",
            "Foot Locker Inc",
            "Footstar Inc.",
            "Ford Motor Co",
            "Forest Laboratories Inc.",
            "Fortune Brands Inc.",
            "Foster Wheeler Ltd.",
            "FPL Group Inc.",
            "Franklin Resources Inc.",
            "Freeport McMoran Copper & Gold Inc.",
            "Frontier Oil Corp",
            "Furniture Brands International Inc.",
            "Gannett Co., Inc.",
            "Gap Inc.",
            "Gateway Inc.",
            "GATX Corporation",
            "Gemstar-TV Guide International Inc.",
            "GenCorp Inc.",
            "General Cable Corporation",
            "General Dynamics Corporation",
            "General Electric Company",
            "General Mills Inc",
            "General Motors Corporation",
            "Genesis Health Ventures Inc.",
            "Gentek Inc.",
            "Gentiva Health Services Inc.",
            "Genuine Parts Company",
            "Genuity Inc.",
            "Genzyme Corporation",
            "Georgia Gulf Corporation",
            "Georgia-Pacific Corporation",
            "Gillette Company",
            "Gold Kist Inc.",
            "Golden State Bancorp Inc.",
            "Golden West Financial Corporation",
            "Goldman Sachs Group Inc.",
            "Goodrich Corporation",
            "The Goodyear Tire & Rubber Company",
            "Granite Construction Incorporated",
            "Graybar Electric Company Inc.",
            "Great Lakes Chemical Corporation",
            "Great Plains Energy Inc.",
            "GreenPoint Financial Corp.",
            "Greif Bros. Corporation",
            "Grey Global Group Inc.",
            "Group 1 Automotive Inc.",
            "Guidant Corporation",
            "H&R Block Inc.",
            "H.B. Fuller Company",
            "H.J. Heinz Company",
            "Halliburton Co.",
            "Harley-Davidson Inc.",
            "Harman International Industries Inc.",
            "Harrah's Entertainment Inc.",
            "Harris Corp.",
            "Harsco Corp.",
            "Hartford Financial Services Group Inc.",
            "Hasbro Inc.",
            "Hawaiian Electric Industries Inc.",
            "HCA Inc.",
            "Health Management Associates Inc.",
            "Health Net Inc.",
            "Healthsouth Corp",
            "Henry Schein Inc.",
            "Hercules Inc.",
            "Herman Miller Inc.",
            "Hershey Foods Corp.",
            "Hewlett-Packard Company",
            "Hibernia Corp.",
            "Hillenbrand Industries Inc.",
            "Hilton Hotels Corp.",
            "Hollywood Entertainment Corp.",
            "Home Depot Inc.",
            "Hon Industries Inc.",
            "Honeywell International Inc.",
            "Hormel Foods Corp.",
            "Host Marriott Corp.",
            "Household International Corp.",
            "Hovnanian Enterprises Inc.",
            "Hub Group Inc.",
            "Hubbell Inc.",
            "Hughes Supply Inc.",
            "Humana Inc.",
            "Huntington Bancshares Inc.",
            "Idacorp Inc.",
            "IDT Corporation",
            "IKON Office Solutions Inc.",
            "Illinois Tool Works Inc.",
            "IMC Global Inc.",
            "Imperial Sugar Company",
            "IMS Health Inc.",
            "Ingles Market Inc",
            "Ingram Micro Inc.",
            "Insight Enterprises Inc.",
            "Integrated Electrical Services Inc.",
            "Intel Corporation",
            "International Paper Co.",
            "Interpublic Group of Companies Inc.",
            "Interstate Bakeries Corporation",
            "International Business Machines Corp.",
            "International Flavors & Fragrances Inc.",
            "International Multifoods Corporation",
            "Intuit Inc.",
            "IT Group Inc.",
            "ITT Industries Inc.",
            "Ivax Corp.",
            "J.B. Hunt Transport Services Inc.",
            "J.C. Penny Co.",
            "J.P. Morgan Chase & Co.",
            "Jabil Circuit Inc.",
            "Jack In The Box Inc.",
            "Jacobs Engineering Group Inc.",
            "JDS Uniphase Corp.",
            "Jefferson-Pilot Co.",
            "John Hancock Financial Services Inc.",
            "Johnson & Johnson",
            "Johnson Controls Inc.",
            "Jones Apparel Group Inc.",
            "KB Home",
            "Kellogg Company",
            "Kellwood Company",
            "Kelly Services Inc.",
            "Kemet Corp.",
            "Kennametal Inc.",
            "Kerr-McGee Corporation",
            "KeyCorp",
            "KeySpan Corp.",
            "Kimball International Inc.",
            "Kimberly-Clark Corporation",
            "Kindred Healthcare Inc.",
            "KLA-Tencor Corporation",
            "K-Mart Corp.",
            "Knight-Ridder Inc.",
            "Kohl's Corp.",
            "KPMG Consulting Inc.",
            "Kroger Co.",
            "L-3 Communications Holdings Inc.",
            "Laboratory Corporation of America Holdings",
            "Lam Research Corporation",
            "LandAmerica Financial Group Inc.",
            "Lands' End Inc.",
            "Landstar System Inc.",
            "La-Z-Boy Inc.",
            "Lear Corporation",
            "Legg Mason Inc.",
            "Leggett & Platt Inc.",
            "Lehman Brothers Holdings Inc.",
            "Lennar Corporation",
            "Lennox International Inc.",
            "Level 3 Communications Inc.",
            "Levi Strauss & Co.",
            "Lexmark International Inc.",
            "Limited Inc.",
            "Lincoln National Corporation",
            "Linens 'n Things Inc.",
            "Lithia Motors Inc.",
            "Liz Claiborne Inc.",
            "Lockheed Martin Corporation",
            "Loews Corporation",
            "Longs Drug Stores Corporation",
            "Louisiana-Pacific Corporation",
            "Lowe's Companies Inc.",
            "LSI Logic Corporation",
            "The LTV Corporation",
            "The Lubrizol Corporation",
            "Lucent Technologies Inc.",
            "Lyondell Chemical Company",
            "M & T Bank Corporation",
            "Magellan Health Services Inc.",
            "Mail-Well Inc.",
            "Mandalay Resort Group",
            "Manor Care Inc.",
            "Manpower Inc.",
            "Marathon Oil Corporation",
            "Mariner Health Care Inc.",
            "Markel Corporation",
            "Marriott International Inc.",
            "Marsh & McLennan Companies Inc.",
            "Marsh Supermarkets Inc.",
            "Marshall & Ilsley Corporation",
            "Martin Marietta Materials Inc.",
            "Masco Corporation",
            "Massey Energy Company",
            "MasTec Inc.",
            "Mattel Inc.",
            "Maxim Integrated Products Inc.",
            "Maxtor Corporation",
            "Maxxam Inc.",
            "The May Department Stores Company",
            "Maytag Corporation",
            "MBNA Corporation",
            "McCormick & Company Incorporated",
            "McDonald's Corporation",
            "The McGraw-Hill Companies Inc.",
            "McKesson Corporation",
            "McLeodUSA Incorporated",
            "M.D.C. Holdings Inc.",
            "MDU Resources Group Inc.",
            "MeadWestvaco Corporation",
            "Medtronic Inc.",
            "Mellon Financial Corporation",
            "The Men's Wearhouse Inc.",
            "Merck & Co., Inc.",
            "Mercury General Corporation",
            "Merrill Lynch & Co. Inc.",
            "Metaldyne Corporation",
            "Metals USA Inc.",
            "MetLife Inc.",
            "Metris Companies Inc",
            "MGIC Investment Corporation",
            "MGM Mirage",
            "Michaels Stores Inc.",
            "Micron Technology Inc.",
            "Microsoft Corporation",
            "Milacron Inc.",
            "Millennium Chemicals Inc.",
            "Mirant Corporation",
            "Mohawk Industries Inc.",
            "Molex Incorporated",
            "The MONY Group Inc.",
            "Morgan Stanley Dean Witter & Co.",
            "Motorola Inc.",
            "MPS Group Inc.",
            "Murphy Oil Corporation",
            "Nabors Industries Inc",
            "Nacco Industries Inc",
            "Nash Finch Company",
            "National City Corp.",
            "National Commerce Financial Corporation",
            "National Fuel Gas Company",
            "National Oilwell Inc",
            "National Rural Utilities Cooperative Finance Corporation",
            "National Semiconductor Corporation",
            "National Service Industries Inc",
            "Navistar International Corporation",
            "NCR Corporation",
            "The Neiman Marcus Group Inc.",
            "New Jersey Resources Corporation",
            "New York Times Company",
            "Newell Rubbermaid Inc",
            "Newmont Mining Corporation",
            "Nextel Communications Inc",
            "Nicor Inc",
            "Nike Inc",
            "NiSource Inc",
            "Noble Energy Inc",
            "Nordstrom Inc",
            "Norfolk Southern Corporation",
            "Nortek Inc",
            "North Fork Bancorporation Inc",
            "Northeast Utilities System",
            "Northern Trust Corporation",
            "Northrop Grumman Corporation",
            "NorthWestern Corporation",
            "Novellus Systems Inc",
            "NSTAR",
            "NTL Incorporated",
            "Nucor Corp",
            "Nvidia Corp",
            "NVR Inc",
            "Northwest Airlines Corp",
            "Occidental Petroleum Corp",
            "Ocean Energy Inc",
            "Office Depot Inc.",
            "OfficeMax Inc",
            "OGE Energy Corp",
            "Oglethorpe Power Corp.",
            "Ohio Casualty Corp.",
            "Old Republic International Corp.",
            "Olin Corp.",
            "OM Group Inc",
            "Omnicare Inc",
            "Omnicom Group",
            "On Semiconductor Corp",
            "ONEOK Inc",
            "Oracle Corp",
            "Oshkosh Truck Corp",
            "Outback Steakhouse Inc.",
            "Owens & Minor Inc.",
            "Owens Corning",
            "Owens-Illinois Inc",
            "Oxford Health Plans Inc",
            "Paccar Inc",
            "PacifiCare Health Systems Inc",
            "Packaging Corp. of America",
            "Pactiv Corp",
            "Pall Corp",
            "Pantry Inc",
            "Park Place Entertainment Corp",
            "Parker Hannifin Corp.",
            "Pathmark Stores Inc.",
            "Paychex Inc",
            "Payless Shoesource Inc",
            "Penn Traffic Co.",
            "Pennzoil-Quaker State Company",
            "Pentair Inc",
            "Peoples Energy Corp.",
            "PeopleSoft Inc",
            "Pep Boys Manny, Moe & Jack",
            "Potomac Electric Power Co.",
            "Pepsi Bottling Group Inc.",
            "PepsiAmericas Inc.",
            "PepsiCo Inc.",
            "Performance Food Group Co.",
            "Perini Corp",
            "PerkinElmer Inc",
            "Perot Systems Corp",
            "Petco Animal Supplies Inc.",
            "Peter Kiewit Sons', Inc.",
            "PETsMART Inc",
            "Pfizer Inc",
            "Pacific Gas & Electric Corp.",
            "Pharmacia Corp",
            "Phar Mor Inc.",
            "Phelps Dodge Corp.",
            "Philip Morris Companies Inc.",
            "Phillips Petroleum Co",
            "Phillips Van Heusen Corp.",
            "Phoenix Companies Inc",
            "Pier 1 Imports Inc.",
            "Pilgrim's Pride Corporation",
            "Pinnacle West Capital Corp",
            "Pioneer-Standard Electronics Inc.",
            "Pitney Bowes Inc.",
            "Pittston Brinks Group",
            "Plains All American Pipeline LP",
            "PNC Financial Services Group Inc.",
            "PNM Resources Inc",
            "Polaris Industries Inc.",
            "Polo Ralph Lauren Corp",
            "PolyOne Corp",
            "Popular Inc",
            "Potlatch Corp",
            "PPG Industries Inc",
            "PPL Corp",
            "Praxair Inc",
            "Precision Castparts Corp",
            "Premcor Inc.",
            "Pride International Inc",
            "Primedia Inc",
            "Principal Financial Group Inc.",
            "Procter & Gamble Co.",
            "Pro-Fac Cooperative Inc.",
            "Progress Energy Inc",
            "Progressive Corporation",
            "Protective Life Corp",
            "Provident Financial Group",
            "Providian Financial Corp.",
            "Prudential Financial Inc.",
            "PSS World Medical Inc",
            "Public Service Enterprise Group Inc.",
            "Publix Super Markets Inc.",
            "Puget Energy Inc.",
            "Pulte Homes Inc",
            "Qualcomm Inc",
            "Quanta Services Inc.",
            "Quantum Corp",
            "Quest Diagnostics Inc.",
            "Questar Corp",
            "Quintiles Transnational",
            "Qwest Communications Intl Inc",
            "R.J. Reynolds Tobacco Company",
            "R.R. Donnelley & Sons Company",
            "Radio Shack Corporation",
            "Raymond James Financial Inc.",
            "Raytheon Company",
            "Reader's Digest Association Inc.",
            "Reebok International Ltd.",
            "Regions Financial Corp.",
            "Regis Corporation",
            "Reliance Steel & Aluminum Co.",
            "Reliant Energy Inc.",
            "Rent A Center Inc",
            "Republic Services Inc",
            "Revlon Inc",
            "RGS Energy Group Inc",
            "Rite Aid Corp",
            "Riverwood Holding Inc.",
            "RoadwayCorp",
            "Robert Half International Inc.",
            "Rock-Tenn Co",
            "Rockwell Automation Inc",
            "Rockwell Collins Inc",
            "Rohm & Haas Co.",
            "Ross Stores Inc",
            "RPM Inc.",
            "Ruddick Corp",
            "Ryder System Inc",
            "Ryerson Tull Inc",
            "Ryland Group Inc.",
            "Sabre Holdings Corp",
            "Safeco Corp",
            "Safeguard Scientifics Inc.",
            "Safeway Inc",
            "Saks Inc",
            "Sanmina-SCI Inc",
            "Sara Lee Corp",
            "SBC Communications Inc",
            "Scana Corp.",
            "Schering-Plough Corp",
            "Scholastic Corp",
            "SCI Systems Onc.",
            "Science Applications Intl. Inc.",
            "Scientific-Atlanta Inc",
            "Scotts Company",
            "Seaboard Corp",
            "Sealed Air Corp",
            "Sears Roebuck & Co",
            "Sempra Energy",
            "Sequa Corp",
            "Service Corp. International",
            "ServiceMaster Co",
            "Shaw Group Inc",
            "Sherwin-Williams Company",
            "Shopko Stores Inc",
            "Siebel Systems Inc",
            "Sierra Health Services Inc",
            "Sierra Pacific Resources",
            "Silgan Holdings Inc.",
            "Silicon Graphics Inc",
            "Simon Property Group Inc",
            "SLM Corporation",
            "Smith International Inc",
            "Smithfield Foods Inc",
            "Smurfit-Stone Container Corp",
            "Snap-On Inc",
            "Solectron Corp",
            "Solutia Inc",
            "Sonic Automotive Inc.",
            "Sonoco Products Co.",
            "Southern Company",
            "Southern Union Company",
            "SouthTrust Corp.",
            "Southwest Airlines Co",
            "Southwest Gas Corp",
            "Sovereign Bancorp Inc.",
            "Spartan Stores Inc",
            "Spherion Corp",
            "Sports Authority Inc",
            "Sprint Corp.",
            "SPX Corp",
            "St. Jude Medical Inc",
            "St. Paul Cos.",
            "Staff Leasing Inc.",
            "StanCorp Financial Group Inc",
            "Standard Pacific Corp.",
            "Stanley Works",
            "Staples Inc",
            "Starbucks Corp",
            "Starwood Hotels & Resorts Worldwide Inc",
            "State Street Corp.",
            "Stater Bros. Holdings Inc.",
            "Steelcase Inc",
            "Stein Mart Inc",
            "Stewart & Stevenson Services Inc",
            "Stewart Information Services Corp",
            "Stilwell Financial Inc",
            "Storage Technology Corporation",
            "Stryker Corp",
            "Sun Healthcare Group Inc.",
            "Sun Microsystems Inc.",
            "SunGard Data Systems Inc.",
            "Sunoco Inc.",
            "SunTrust Banks Inc",
            "Supervalu Inc",
            "Swift Transportation, Co., Inc",
            "Symbol Technologies Inc",
            "Synovus Financial Corp.",
            "Sysco Corp",
            "Systemax Inc.",
            "Target Corp.",
            "Tech Data Corporation",
            "TECO Energy Inc",
            "Tecumseh Products Company",
            "Tektronix Inc",
            "Teleflex Incorporated",
            "Telephone & Data Systems Inc",
            "Tellabs Inc.",
            "Temple-Inland Inc",
            "Tenet Healthcare Corporation",
            "Tenneco Automotive Inc.",
            "Teradyne Inc",
            "Terex Corp",
            "Tesoro Petroleum Corp.",
            "Texas Industries Inc.",
            "Texas Instruments Incorporated",
            "Textron Inc",
            "Thermo Electron Corporation",
            "Thomas & Betts Corporation",
            "Tiffany & Co",
            "Timken Company",
            "TJX Companies Inc",
            "TMP Worldwide Inc",
            "Toll Brothers Inc",
            "Torchmark Corporation",
            "Toro Company",
            "Tower Automotive Inc.",
            "Toys 'R' Us Inc",
            "Trans World Entertainment Corp.",
            "TransMontaigne Inc",
            "Transocean Inc",
            "TravelCenters of America Inc.",
            "Triad Hospitals Inc",
            "Tribune Company",
            "Trigon Healthcare Inc.",
            "Trinity Industries Inc",
            "Trump Hotels & Casino Resorts Inc.",
            "TruServ Corporation",
            "TRW Inc",
            "TXU Corp",
            "Tyson Foods Inc",
            "U.S. Bancorp",
            "U.S. Industries Inc.",
            "UAL Corporation",
            "UGI Corporation",
            "Unified Western Grocers Inc",
            "Union Pacific Corporation",
            "Union Planters Corp",
            "Unisource Energy Corp",
            "Unisys Corporation",
            "United Auto Group Inc",
            "United Defense Industries Inc.",
            "United Parcel Service Inc",
            "United Rentals Inc",
            "United Stationers Inc",
            "United Technologies Corporation",
            "UnitedHealth Group Incorporated",
            "Unitrin Inc",
            "Universal Corporation",
            "Universal Forest Products Inc",
            "Universal Health Services Inc",
            "Unocal Corporation",
            "Unova Inc",
            "UnumProvident Corporation",
            "URS Corporation",
            "US Airways Group Inc",
            "US Oncology Inc",
            "USA Interactive",
            "USFreighways Corporation",
            "USG Corporation",
            "UST Inc",
            "Valero Energy Corporation",
            "Valspar Corporation",
            "Value City Department Stores Inc",
            "Varco International Inc",
            "Vectren Corporation",
            "Veritas Software Corporation",
            "Verizon Communications Inc",
            "VF Corporation",
            "Viacom Inc",
            "Viad Corp",
            "Viasystems Group Inc",
            "Vishay Intertechnology Inc",
            "Visteon Corporation",
            "Volt Information Sciences Inc",
            "Vulcan Materials Company",
            "W.R. Berkley Corporation",
            "W.R. Grace & Co",
            "W.W. Grainger Inc",
            "Wachovia Corporation",
            "Wakenhut Corporation",
            "Walgreen Co",
            "Wallace Computer Services Inc",
            "Wal-Mart Stores Inc",
            "Walt Disney Co",
            "Walter Industries Inc",
            "Washington Mutual Inc",
            "Washington Post Co.",
            "Waste Management Inc",
            "Watsco Inc",
            "Weatherford International Inc",
            "Weis Markets Inc.",
            "Wellpoint Health Networks Inc",
            "Wells Fargo & Company",
            "Wendy's International Inc",
            "Werner Enterprises Inc",
            "WESCO International Inc",
            "Western Digital Inc",
            "Western Gas Resources Inc",
            "WestPoint Stevens Inc",
            "Weyerhauser Company",
            "WGL Holdings Inc",
            "Whirlpool Corporation",
            "Whole Foods Market Inc",
            "Willamette Industries Inc.",
            "Williams Companies Inc",
            "Williams Sonoma Inc",
            "Winn Dixie Stores Inc",
            "Wisconsin Energy Corporation",
            "Wm Wrigley Jr Company",
            "World Fuel Services Corporation",
            "WorldCom Inc",
            "Worthington Industries Inc",
            "WPS Resources Corporation",
            "Wyeth",
            "Wyndham International Inc",
            "Xcel Energy Inc",
            "Xerox Corp",
            "Xilinx Inc",
            "XO Communications Inc",
            "Yellow Corporation",
            "York International Corp",
            "Yum Brands Inc.",
            "Zale Corporation",
            "Zions Bancorporation"
        ],
        fileExtension: {
            "raster": [
                "bmp",
                "gif",
                "gpl",
                "ico",
                "jpeg",
                "psd",
                "png",
                "psp",
                "raw",
                "tiff"
            ],
            "vector": [
                "3dv",
                "amf",
                "awg",
                "ai",
                "cgm",
                "cdr",
                "cmx",
                "dxf",
                "e2d",
                "egt",
                "eps",
                "fs",
                "odg",
                "svg",
                "xar"
            ],
            "3d": [
                "3dmf",
                "3dm",
                "3mf",
                "3ds",
                "an8",
                "aoi",
                "blend",
                "cal3d",
                "cob",
                "ctm",
                "iob",
                "jas",
                "max",
                "mb",
                "mdx",
                "obj",
                "x",
                "x3d"
            ],
            "document": [
                "doc",
                "docx",
                "dot",
                "html",
                "xml",
                "odt",
                "odm",
                "ott",
                "csv",
                "rtf",
                "tex",
                "xhtml",
                "xps"
            ]
        },
        // Data taken from https://github.com/dmfilipenko/timezones.json/blob/master/timezones.json
        timezones: [
            {
                "name": "Dateline Standard Time",
                "abbr": "DST",
                "offset": -12,
                "isdst": false,
                "text": "(UTC-12:00) International Date Line West",
                "utc": [
                    "Etc/GMT+12"
                ]
            },
            {
                "name": "UTC-11",
                "abbr": "U",
                "offset": -11,
                "isdst": false,
                "text": "(UTC-11:00) Coordinated Universal Time-11",
                "utc": [
                    "Etc/GMT+11",
                    "Pacific/Midway",
                    "Pacific/Niue",
                    "Pacific/Pago_Pago"
                ]
            },
            {
                "name": "Hawaiian Standard Time",
                "abbr": "HST",
                "offset": -10,
                "isdst": false,
                "text": "(UTC-10:00) Hawaii",
                "utc": [
                    "Etc/GMT+10",
                    "Pacific/Honolulu",
                    "Pacific/Johnston",
                    "Pacific/Rarotonga",
                    "Pacific/Tahiti"
                ]
            },
            {
                "name": "Alaskan Standard Time",
                "abbr": "AKDT",
                "offset": -8,
                "isdst": true,
                "text": "(UTC-09:00) Alaska",
                "utc": [
                    "America/Anchorage",
                    "America/Juneau",
                    "America/Nome",
                    "America/Sitka",
                    "America/Yakutat"
                ]
            },
            {
                "name": "Pacific Standard Time (Mexico)",
                "abbr": "PDT",
                "offset": -7,
                "isdst": true,
                "text": "(UTC-08:00) Baja California",
                "utc": [
                    "America/Santa_Isabel"
                ]
            },
            {
                "name": "Pacific Daylight Time",
                "abbr": "PDT",
                "offset": -7,
                "isdst": true,
                "text": "(UTC-07:00) Pacific Time (US & Canada)",
                "utc": [
                    "America/Dawson",
                    "America/Los_Angeles",
                    "America/Tijuana",
                    "America/Vancouver",
                    "America/Whitehorse"
                ]
            },
            {
                "name": "Pacific Standard Time",
                "abbr": "PST",
                "offset": -8,
                "isdst": false,
                "text": "(UTC-08:00) Pacific Time (US & Canada)",
                "utc": [
                    "America/Dawson",
                    "America/Los_Angeles",
                    "America/Tijuana",
                    "America/Vancouver",
                    "America/Whitehorse",
                    "PST8PDT"
                ]
            },
            {
                "name": "US Mountain Standard Time",
                "abbr": "UMST",
                "offset": -7,
                "isdst": false,
                "text": "(UTC-07:00) Arizona",
                "utc": [
                    "America/Creston",
                    "America/Dawson_Creek",
                    "America/Hermosillo",
                    "America/Phoenix",
                    "Etc/GMT+7"
                ]
            },
            {
                "name": "Mountain Standard Time (Mexico)",
                "abbr": "MDT",
                "offset": -6,
                "isdst": true,
                "text": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
                "utc": [
                    "America/Chihuahua",
                    "America/Mazatlan"
                ]
            },
            {
                "name": "Mountain Standard Time",
                "abbr": "MDT",
                "offset": -6,
                "isdst": true,
                "text": "(UTC-07:00) Mountain Time (US & Canada)",
                "utc": [
                    "America/Boise",
                    "America/Cambridge_Bay",
                    "America/Denver",
                    "America/Edmonton",
                    "America/Inuvik",
                    "America/Ojinaga",
                    "America/Yellowknife",
                    "MST7MDT"
                ]
            },
            {
                "name": "Central America Standard Time",
                "abbr": "CAST",
                "offset": -6,
                "isdst": false,
                "text": "(UTC-06:00) Central America",
                "utc": [
                    "America/Belize",
                    "America/Costa_Rica",
                    "America/El_Salvador",
                    "America/Guatemala",
                    "America/Managua",
                    "America/Tegucigalpa",
                    "Etc/GMT+6",
                    "Pacific/Galapagos"
                ]
            },
            {
                "name": "Central Standard Time",
                "abbr": "CDT",
                "offset": -5,
                "isdst": true,
                "text": "(UTC-06:00) Central Time (US & Canada)",
                "utc": [
                    "America/Chicago",
                    "America/Indiana/Knox",
                    "America/Indiana/Tell_City",
                    "America/Matamoros",
                    "America/Menominee",
                    "America/North_Dakota/Beulah",
                    "America/North_Dakota/Center",
                    "America/North_Dakota/New_Salem",
                    "America/Rainy_River",
                    "America/Rankin_Inlet",
                    "America/Resolute",
                    "America/Winnipeg",
                    "CST6CDT"
                ]
            },
            {
                "name": "Central Standard Time (Mexico)",
                "abbr": "CDT",
                "offset": -5,
                "isdst": true,
                "text": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
                "utc": [
                    "America/Bahia_Banderas",
                    "America/Cancun",
                    "America/Merida",
                    "America/Mexico_City",
                    "America/Monterrey"
                ]
            },
            {
                "name": "Canada Central Standard Time",
                "abbr": "CCST",
                "offset": -6,
                "isdst": false,
                "text": "(UTC-06:00) Saskatchewan",
                "utc": [
                    "America/Regina",
                    "America/Swift_Current"
                ]
            },
            {
                "name": "SA Pacific Standard Time",
                "abbr": "SPST",
                "offset": -5,
                "isdst": false,
                "text": "(UTC-05:00) Bogota, Lima, Quito",
                "utc": [
                    "America/Bogota",
                    "America/Cayman",
                    "America/Coral_Harbour",
                    "America/Eirunepe",
                    "America/Guayaquil",
                    "America/Jamaica",
                    "America/Lima",
                    "America/Panama",
                    "America/Rio_Branco",
                    "Etc/GMT+5"
                ]
            },
            {
                "name": "Eastern Standard Time",
                "abbr": "EDT",
                "offset": -4,
                "isdst": true,
                "text": "(UTC-05:00) Eastern Time (US & Canada)",
                "utc": [
                    "America/Detroit",
                    "America/Havana",
                    "America/Indiana/Petersburg",
                    "America/Indiana/Vincennes",
                    "America/Indiana/Winamac",
                    "America/Iqaluit",
                    "America/Kentucky/Monticello",
                    "America/Louisville",
                    "America/Montreal",
                    "America/Nassau",
                    "America/New_York",
                    "America/Nipigon",
                    "America/Pangnirtung",
                    "America/Port-au-Prince",
                    "America/Thunder_Bay",
                    "America/Toronto",
                    "EST5EDT"
                ]
            },
            {
                "name": "US Eastern Standard Time",
                "abbr": "UEDT",
                "offset": -4,
                "isdst": true,
                "text": "(UTC-05:00) Indiana (East)",
                "utc": [
                    "America/Indiana/Marengo",
                    "America/Indiana/Vevay",
                    "America/Indianapolis"
                ]
            },
            {
                "name": "Venezuela Standard Time",
                "abbr": "VST",
                "offset": -4.5,
                "isdst": false,
                "text": "(UTC-04:30) Caracas",
                "utc": [
                    "America/Caracas"
                ]
            },
            {
                "name": "Paraguay Standard Time",
                "abbr": "PYT",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Asuncion",
                "utc": [
                    "America/Asuncion"
                ]
            },
            {
                "name": "Atlantic Standard Time",
                "abbr": "ADT",
                "offset": -3,
                "isdst": true,
                "text": "(UTC-04:00) Atlantic Time (Canada)",
                "utc": [
                    "America/Glace_Bay",
                    "America/Goose_Bay",
                    "America/Halifax",
                    "America/Moncton",
                    "America/Thule",
                    "Atlantic/Bermuda"
                ]
            },
            {
                "name": "Central Brazilian Standard Time",
                "abbr": "CBST",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Cuiaba",
                "utc": [
                    "America/Campo_Grande",
                    "America/Cuiaba"
                ]
            },
            {
                "name": "SA Western Standard Time",
                "abbr": "SWST",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
                "utc": [
                    "America/Anguilla",
                    "America/Antigua",
                    "America/Aruba",
                    "America/Barbados",
                    "America/Blanc-Sablon",
                    "America/Boa_Vista",
                    "America/Curacao",
                    "America/Dominica",
                    "America/Grand_Turk",
                    "America/Grenada",
                    "America/Guadeloupe",
                    "America/Guyana",
                    "America/Kralendijk",
                    "America/La_Paz",
                    "America/Lower_Princes",
                    "America/Manaus",
                    "America/Marigot",
                    "America/Martinique",
                    "America/Montserrat",
                    "America/Port_of_Spain",
                    "America/Porto_Velho",
                    "America/Puerto_Rico",
                    "America/Santo_Domingo",
                    "America/St_Barthelemy",
                    "America/St_Kitts",
                    "America/St_Lucia",
                    "America/St_Thomas",
                    "America/St_Vincent",
                    "America/Tortola",
                    "Etc/GMT+4"
                ]
            },
            {
                "name": "Pacific SA Standard Time",
                "abbr": "PSST",
                "offset": -4,
                "isdst": false,
                "text": "(UTC-04:00) Santiago",
                "utc": [
                    "America/Santiago",
                    "Antarctica/Palmer"
                ]
            },
            {
                "name": "Newfoundland Standard Time",
                "abbr": "NDT",
                "offset": -2.5,
                "isdst": true,
                "text": "(UTC-03:30) Newfoundland",
                "utc": [
                    "America/St_Johns"
                ]
            },
            {
                "name": "E. South America Standard Time",
                "abbr": "ESAST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Brasilia",
                "utc": [
                    "America/Sao_Paulo"
                ]
            },
            {
                "name": "Argentina Standard Time",
                "abbr": "AST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Buenos Aires",
                "utc": [
                    "America/Argentina/La_Rioja",
                    "America/Argentina/Rio_Gallegos",
                    "America/Argentina/Salta",
                    "America/Argentina/San_Juan",
                    "America/Argentina/San_Luis",
                    "America/Argentina/Tucuman",
                    "America/Argentina/Ushuaia",
                    "America/Buenos_Aires",
                    "America/Catamarca",
                    "America/Cordoba",
                    "America/Jujuy",
                    "America/Mendoza"
                ]
            },
            {
                "name": "SA Eastern Standard Time",
                "abbr": "SEST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Cayenne, Fortaleza",
                "utc": [
                    "America/Araguaina",
                    "America/Belem",
                    "America/Cayenne",
                    "America/Fortaleza",
                    "America/Maceio",
                    "America/Paramaribo",
                    "America/Recife",
                    "America/Santarem",
                    "Antarctica/Rothera",
                    "Atlantic/Stanley",
                    "Etc/GMT+3"
                ]
            },
            {
                "name": "Greenland Standard Time",
                "abbr": "GDT",
                "offset": -3,
                "isdst": true,
                "text": "(UTC-03:00) Greenland",
                "utc": [
                    "America/Godthab"
                ]
            },
            {
                "name": "Montevideo Standard Time",
                "abbr": "MST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Montevideo",
                "utc": [
                    "America/Montevideo"
                ]
            },
            {
                "name": "Bahia Standard Time",
                "abbr": "BST",
                "offset": -3,
                "isdst": false,
                "text": "(UTC-03:00) Salvador",
                "utc": [
                    "America/Bahia"
                ]
            },
            {
                "name": "UTC-02",
                "abbr": "U",
                "offset": -2,
                "isdst": false,
                "text": "(UTC-02:00) Coordinated Universal Time-02",
                "utc": [
                    "America/Noronha",
                    "Atlantic/South_Georgia",
                    "Etc/GMT+2"
                ]
            },
            {
                "name": "Mid-Atlantic Standard Time",
                "abbr": "MDT",
                "offset": -1,
                "isdst": true,
                "text": "(UTC-02:00) Mid-Atlantic - Old",
                "utc": []
            },
            {
                "name": "Azores Standard Time",
                "abbr": "ADT",
                "offset": 0,
                "isdst": true,
                "text": "(UTC-01:00) Azores",
                "utc": [
                    "America/Scoresbysund",
                    "Atlantic/Azores"
                ]
            },
            {
                "name": "Cape Verde Standard Time",
                "abbr": "CVST",
                "offset": -1,
                "isdst": false,
                "text": "(UTC-01:00) Cape Verde Is.",
                "utc": [
                    "Atlantic/Cape_Verde",
                    "Etc/GMT+1"
                ]
            },
            {
                "name": "Morocco Standard Time",
                "abbr": "MDT",
                "offset": 1,
                "isdst": true,
                "text": "(UTC) Casablanca",
                "utc": [
                    "Africa/Casablanca",
                    "Africa/El_Aaiun"
                ]
            },
            {
                "name": "UTC",
                "abbr": "UTC",
                "offset": 0,
                "isdst": false,
                "text": "(UTC) Coordinated Universal Time",
                "utc": [
                    "America/Danmarkshavn",
                    "Etc/GMT"
                ]
            },
            {
                "name": "GMT Standard Time",
                "abbr": "GMT",
                "offset": 0,
                "isdst": false,
                "text": "(UTC) Edinburgh, London",
                "utc": [
                    "Europe/Isle_of_Man",
                    "Europe/Guernsey",
                    "Europe/Jersey",
                    "Europe/London"
                ]
            },
            {
                "name": "British Summer Time",
                "abbr": "BST",
                "offset": 1,
                "isdst": true,
                "text": "(UTC+01:00) Edinburgh, London",
                "utc": [
                    "Europe/Isle_of_Man",
                    "Europe/Guernsey",
                    "Europe/Jersey",
                    "Europe/London"
                ]
            },
            {
                "name": "GMT Standard Time",
                "abbr": "GDT",
                "offset": 1,
                "isdst": true,
                "text": "(UTC) Dublin, Lisbon",
                "utc": [
                    "Atlantic/Canary",
                    "Atlantic/Faeroe",
                    "Atlantic/Madeira",
                    "Europe/Dublin",
                    "Europe/Lisbon"
                ]
            },
            {
                "name": "Greenwich Standard Time",
                "abbr": "GST",
                "offset": 0,
                "isdst": false,
                "text": "(UTC) Monrovia, Reykjavik",
                "utc": [
                    "Africa/Abidjan",
                    "Africa/Accra",
                    "Africa/Bamako",
                    "Africa/Banjul",
                    "Africa/Bissau",
                    "Africa/Conakry",
                    "Africa/Dakar",
                    "Africa/Freetown",
                    "Africa/Lome",
                    "Africa/Monrovia",
                    "Africa/Nouakchott",
                    "Africa/Ouagadougou",
                    "Africa/Sao_Tome",
                    "Atlantic/Reykjavik",
                    "Atlantic/St_Helena"
                ]
            },
            {
                "name": "W. Europe Standard Time",
                "abbr": "WEDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
                "utc": [
                    "Arctic/Longyearbyen",
                    "Europe/Amsterdam",
                    "Europe/Andorra",
                    "Europe/Berlin",
                    "Europe/Busingen",
                    "Europe/Gibraltar",
                    "Europe/Luxembourg",
                    "Europe/Malta",
                    "Europe/Monaco",
                    "Europe/Oslo",
                    "Europe/Rome",
                    "Europe/San_Marino",
                    "Europe/Stockholm",
                    "Europe/Vaduz",
                    "Europe/Vatican",
                    "Europe/Vienna",
                    "Europe/Zurich"
                ]
            },
            {
                "name": "Central Europe Standard Time",
                "abbr": "CEDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
                "utc": [
                    "Europe/Belgrade",
                    "Europe/Bratislava",
                    "Europe/Budapest",
                    "Europe/Ljubljana",
                    "Europe/Podgorica",
                    "Europe/Prague",
                    "Europe/Tirane"
                ]
            },
            {
                "name": "Romance Standard Time",
                "abbr": "RDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
                "utc": [
                    "Africa/Ceuta",
                    "Europe/Brussels",
                    "Europe/Copenhagen",
                    "Europe/Madrid",
                    "Europe/Paris"
                ]
            },
            {
                "name": "Central European Standard Time",
                "abbr": "CEDT",
                "offset": 2,
                "isdst": true,
                "text": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
                "utc": [
                    "Europe/Sarajevo",
                    "Europe/Skopje",
                    "Europe/Warsaw",
                    "Europe/Zagreb"
                ]
            },
            {
                "name": "W. Central Africa Standard Time",
                "abbr": "WCAST",
                "offset": 1,
                "isdst": false,
                "text": "(UTC+01:00) West Central Africa",
                "utc": [
                    "Africa/Algiers",
                    "Africa/Bangui",
                    "Africa/Brazzaville",
                    "Africa/Douala",
                    "Africa/Kinshasa",
                    "Africa/Lagos",
                    "Africa/Libreville",
                    "Africa/Luanda",
                    "Africa/Malabo",
                    "Africa/Ndjamena",
                    "Africa/Niamey",
                    "Africa/Porto-Novo",
                    "Africa/Tunis",
                    "Etc/GMT-1"
                ]
            },
            {
                "name": "Namibia Standard Time",
                "abbr": "NST",
                "offset": 1,
                "isdst": false,
                "text": "(UTC+01:00) Windhoek",
                "utc": [
                    "Africa/Windhoek"
                ]
            },
            {
                "name": "GTB Standard Time",
                "abbr": "GDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Athens, Bucharest",
                "utc": [
                    "Asia/Nicosia",
                    "Europe/Athens",
                    "Europe/Bucharest",
                    "Europe/Chisinau"
                ]
            },
            {
                "name": "Middle East Standard Time",
                "abbr": "MEDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Beirut",
                "utc": [
                    "Asia/Beirut"
                ]
            },
            {
                "name": "Egypt Standard Time",
                "abbr": "EST",
                "offset": 2,
                "isdst": false,
                "text": "(UTC+02:00) Cairo",
                "utc": [
                    "Africa/Cairo"
                ]
            },
            {
                "name": "Syria Standard Time",
                "abbr": "SDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Damascus",
                "utc": [
                    "Asia/Damascus"
                ]
            },
            {
                "name": "E. Europe Standard Time",
                "abbr": "EEDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) E. Europe",
                "utc": [
                    "Asia/Nicosia",
                    "Europe/Athens",
                    "Europe/Bucharest",
                    "Europe/Chisinau",
                    "Europe/Helsinki",
                    "Europe/Kiev",
                    "Europe/Mariehamn",
                    "Europe/Nicosia",
                    "Europe/Riga",
                    "Europe/Sofia",
                    "Europe/Tallinn",
                    "Europe/Uzhgorod",
                    "Europe/Vilnius",
                    "Europe/Zaporozhye"
                ]
            },
            {
                "name": "South Africa Standard Time",
                "abbr": "SAST",
                "offset": 2,
                "isdst": false,
                "text": "(UTC+02:00) Harare, Pretoria",
                "utc": [
                    "Africa/Blantyre",
                    "Africa/Bujumbura",
                    "Africa/Gaborone",
                    "Africa/Harare",
                    "Africa/Johannesburg",
                    "Africa/Kigali",
                    "Africa/Lubumbashi",
                    "Africa/Lusaka",
                    "Africa/Maputo",
                    "Africa/Maseru",
                    "Africa/Mbabane",
                    "Etc/GMT-2"
                ]
            },
            {
                "name": "FLE Standard Time",
                "abbr": "FDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
                "utc": [
                    "Europe/Helsinki",
                    "Europe/Kiev",
                    "Europe/Mariehamn",
                    "Europe/Riga",
                    "Europe/Sofia",
                    "Europe/Tallinn",
                    "Europe/Uzhgorod",
                    "Europe/Vilnius",
                    "Europe/Zaporozhye"
                ]
            },
            {
                "name": "Turkey Standard Time",
                "abbr": "TDT",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Istanbul",
                "utc": [
                    "Europe/Istanbul"
                ]
            },
            {
                "name": "Israel Standard Time",
                "abbr": "JDT",
                "offset": 3,
                "isdst": true,
                "text": "(UTC+02:00) Jerusalem",
                "utc": [
                    "Asia/Jerusalem"
                ]
            },
            {
                "name": "Libya Standard Time",
                "abbr": "LST",
                "offset": 2,
                "isdst": false,
                "text": "(UTC+02:00) Tripoli",
                "utc": [
                    "Africa/Tripoli"
                ]
            },
            {
                "name": "Jordan Standard Time",
                "abbr": "JST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Amman",
                "utc": [
                    "Asia/Amman"
                ]
            },
            {
                "name": "Arabic Standard Time",
                "abbr": "AST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Baghdad",
                "utc": [
                    "Asia/Baghdad"
                ]
            },
            {
                "name": "Kaliningrad Standard Time",
                "abbr": "KST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+02:00) Kaliningrad",
                "utc": [
                    "Europe/Kaliningrad"
                ]
            },
            {
                "name": "Arab Standard Time",
                "abbr": "AST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Kuwait, Riyadh",
                "utc": [
                    "Asia/Aden",
                    "Asia/Bahrain",
                    "Asia/Kuwait",
                    "Asia/Qatar",
                    "Asia/Riyadh"
                ]
            },
            {
                "name": "E. Africa Standard Time",
                "abbr": "EAST",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Nairobi",
                "utc": [
                    "Africa/Addis_Ababa",
                    "Africa/Asmera",
                    "Africa/Dar_es_Salaam",
                    "Africa/Djibouti",
                    "Africa/Juba",
                    "Africa/Kampala",
                    "Africa/Khartoum",
                    "Africa/Mogadishu",
                    "Africa/Nairobi",
                    "Antarctica/Syowa",
                    "Etc/GMT-3",
                    "Indian/Antananarivo",
                    "Indian/Comoro",
                    "Indian/Mayotte"
                ]
            },
            {
                "name": "Moscow Standard Time",
                "abbr": "MSK",
                "offset": 3,
                "isdst": false,
                "text": "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
                "utc": [
                    "Europe/Kirov",
                    "Europe/Moscow",
                    "Europe/Simferopol",
                    "Europe/Volgograd",
                    "Europe/Minsk"
                ]
            },
            {
                "name": "Samara Time",
                "abbr": "SAMT",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Samara, Ulyanovsk, Saratov",
                "utc": [
                    "Europe/Astrakhan",
                    "Europe/Samara",
                    "Europe/Ulyanovsk"
                ]
            },
            {
                "name": "Iran Standard Time",
                "abbr": "IDT",
                "offset": 4.5,
                "isdst": true,
                "text": "(UTC+03:30) Tehran",
                "utc": [
                    "Asia/Tehran"
                ]
            },
            {
                "name": "Arabian Standard Time",
                "abbr": "AST",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Abu Dhabi, Muscat",
                "utc": [
                    "Asia/Dubai",
                    "Asia/Muscat",
                    "Etc/GMT-4"
                ]
            },
            {
                "name": "Azerbaijan Standard Time",
                "abbr": "ADT",
                "offset": 5,
                "isdst": true,
                "text": "(UTC+04:00) Baku",
                "utc": [
                    "Asia/Baku"
                ]
            },
            {
                "name": "Mauritius Standard Time",
                "abbr": "MST",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Port Louis",
                "utc": [
                    "Indian/Mahe",
                    "Indian/Mauritius",
                    "Indian/Reunion"
                ]
            },
            {
                "name": "Georgian Standard Time",
                "abbr": "GET",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Tbilisi",
                "utc": [
                    "Asia/Tbilisi"
                ]
            },
            {
                "name": "Caucasus Standard Time",
                "abbr": "CST",
                "offset": 4,
                "isdst": false,
                "text": "(UTC+04:00) Yerevan",
                "utc": [
                    "Asia/Yerevan"
                ]
            },
            {
                "name": "Afghanistan Standard Time",
                "abbr": "AST",
                "offset": 4.5,
                "isdst": false,
                "text": "(UTC+04:30) Kabul",
                "utc": [
                    "Asia/Kabul"
                ]
            },
            {
                "name": "West Asia Standard Time",
                "abbr": "WAST",
                "offset": 5,
                "isdst": false,
                "text": "(UTC+05:00) Ashgabat, Tashkent",
                "utc": [
                    "Antarctica/Mawson",
                    "Asia/Aqtau",
                    "Asia/Aqtobe",
                    "Asia/Ashgabat",
                    "Asia/Dushanbe",
                    "Asia/Oral",
                    "Asia/Samarkand",
                    "Asia/Tashkent",
                    "Etc/GMT-5",
                    "Indian/Kerguelen",
                    "Indian/Maldives"
                ]
            },
            {
                "name": "Yekaterinburg Time",
                "abbr": "YEKT",
                "offset": 5,
                "isdst": false,
                "text": "(UTC+05:00) Yekaterinburg",
                "utc": [
                    "Asia/Yekaterinburg"
                ]
            },
            {
                "name": "Pakistan Standard Time",
                "abbr": "PKT",
                "offset": 5,
                "isdst": false,
                "text": "(UTC+05:00) Islamabad, Karachi",
                "utc": [
                    "Asia/Karachi"
                ]
            },
            {
                "name": "India Standard Time",
                "abbr": "IST",
                "offset": 5.5,
                "isdst": false,
                "text": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
                "utc": [
                    "Asia/Kolkata"
                ]
            },
            {
                "name": "Sri Lanka Standard Time",
                "abbr": "SLST",
                "offset": 5.5,
                "isdst": false,
                "text": "(UTC+05:30) Sri Jayawardenepura",
                "utc": [
                    "Asia/Colombo"
                ]
            },
            {
                "name": "Nepal Standard Time",
                "abbr": "NST",
                "offset": 5.75,
                "isdst": false,
                "text": "(UTC+05:45) Kathmandu",
                "utc": [
                    "Asia/Kathmandu"
                ]
            },
            {
                "name": "Central Asia Standard Time",
                "abbr": "CAST",
                "offset": 6,
                "isdst": false,
                "text": "(UTC+06:00) Nur-Sultan (Astana)",
                "utc": [
                    "Antarctica/Vostok",
                    "Asia/Almaty",
                    "Asia/Bishkek",
                    "Asia/Qyzylorda",
                    "Asia/Urumqi",
                    "Etc/GMT-6",
                    "Indian/Chagos"
                ]
            },
            {
                "name": "Bangladesh Standard Time",
                "abbr": "BST",
                "offset": 6,
                "isdst": false,
                "text": "(UTC+06:00) Dhaka",
                "utc": [
                    "Asia/Dhaka",
                    "Asia/Thimphu"
                ]
            },
            {
                "name": "Myanmar Standard Time",
                "abbr": "MST",
                "offset": 6.5,
                "isdst": false,
                "text": "(UTC+06:30) Yangon (Rangoon)",
                "utc": [
                    "Asia/Rangoon",
                    "Indian/Cocos"
                ]
            },
            {
                "name": "SE Asia Standard Time",
                "abbr": "SAST",
                "offset": 7,
                "isdst": false,
                "text": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
                "utc": [
                    "Antarctica/Davis",
                    "Asia/Bangkok",
                    "Asia/Hovd",
                    "Asia/Jakarta",
                    "Asia/Phnom_Penh",
                    "Asia/Pontianak",
                    "Asia/Saigon",
                    "Asia/Vientiane",
                    "Etc/GMT-7",
                    "Indian/Christmas"
                ]
            },
            {
                "name": "N. Central Asia Standard Time",
                "abbr": "NCAST",
                "offset": 7,
                "isdst": false,
                "text": "(UTC+07:00) Novosibirsk",
                "utc": [
                    "Asia/Novokuznetsk",
                    "Asia/Novosibirsk",
                    "Asia/Omsk"
                ]
            },
            {
                "name": "China Standard Time",
                "abbr": "CST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
                "utc": [
                    "Asia/Hong_Kong",
                    "Asia/Macau",
                    "Asia/Shanghai"
                ]
            },
            {
                "name": "North Asia Standard Time",
                "abbr": "NAST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Krasnoyarsk",
                "utc": [
                    "Asia/Krasnoyarsk"
                ]
            },
            {
                "name": "Singapore Standard Time",
                "abbr": "MPST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Kuala Lumpur, Singapore",
                "utc": [
                    "Asia/Brunei",
                    "Asia/Kuala_Lumpur",
                    "Asia/Kuching",
                    "Asia/Makassar",
                    "Asia/Manila",
                    "Asia/Singapore",
                    "Etc/GMT-8"
                ]
            },
            {
                "name": "W. Australia Standard Time",
                "abbr": "WAST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Perth",
                "utc": [
                    "Antarctica/Casey",
                    "Australia/Perth"
                ]
            },
            {
                "name": "Taipei Standard Time",
                "abbr": "TST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Taipei",
                "utc": [
                    "Asia/Taipei"
                ]
            },
            {
                "name": "Ulaanbaatar Standard Time",
                "abbr": "UST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Ulaanbaatar",
                "utc": [
                    "Asia/Choibalsan",
                    "Asia/Ulaanbaatar"
                ]
            },
            {
                "name": "North Asia East Standard Time",
                "abbr": "NAEST",
                "offset": 8,
                "isdst": false,
                "text": "(UTC+08:00) Irkutsk",
                "utc": [
                    "Asia/Irkutsk"
                ]
            },
            {
                "name": "Japan Standard Time",
                "abbr": "JST",
                "offset": 9,
                "isdst": false,
                "text": "(UTC+09:00) Osaka, Sapporo, Tokyo",
                "utc": [
                    "Asia/Dili",
                    "Asia/Jayapura",
                    "Asia/Tokyo",
                    "Etc/GMT-9",
                    "Pacific/Palau"
                ]
            },
            {
                "name": "Korea Standard Time",
                "abbr": "KST",
                "offset": 9,
                "isdst": false,
                "text": "(UTC+09:00) Seoul",
                "utc": [
                    "Asia/Pyongyang",
                    "Asia/Seoul"
                ]
            },
            {
                "name": "Cen. Australia Standard Time",
                "abbr": "CAST",
                "offset": 9.5,
                "isdst": false,
                "text": "(UTC+09:30) Adelaide",
                "utc": [
                    "Australia/Adelaide",
                    "Australia/Broken_Hill"
                ]
            },
            {
                "name": "AUS Central Standard Time",
                "abbr": "ACST",
                "offset": 9.5,
                "isdst": false,
                "text": "(UTC+09:30) Darwin",
                "utc": [
                    "Australia/Darwin"
                ]
            },
            {
                "name": "E. Australia Standard Time",
                "abbr": "EAST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Brisbane",
                "utc": [
                    "Australia/Brisbane",
                    "Australia/Lindeman"
                ]
            },
            {
                "name": "AUS Eastern Standard Time",
                "abbr": "AEST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Canberra, Melbourne, Sydney",
                "utc": [
                    "Australia/Melbourne",
                    "Australia/Sydney"
                ]
            },
            {
                "name": "West Pacific Standard Time",
                "abbr": "WPST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Guam, Port Moresby",
                "utc": [
                    "Antarctica/DumontDUrville",
                    "Etc/GMT-10",
                    "Pacific/Guam",
                    "Pacific/Port_Moresby",
                    "Pacific/Saipan",
                    "Pacific/Truk"
                ]
            },
            {
                "name": "Tasmania Standard Time",
                "abbr": "TST",
                "offset": 10,
                "isdst": false,
                "text": "(UTC+10:00) Hobart",
                "utc": [
                    "Australia/Currie",
                    "Australia/Hobart"
                ]
            },
            {
                "name": "Yakutsk Standard Time",
                "abbr": "YST",
                "offset": 9,
                "isdst": false,
                "text": "(UTC+09:00) Yakutsk",
                "utc": [
                    "Asia/Chita",
                    "Asia/Khandyga",
                    "Asia/Yakutsk"
                ]
            },
            {
                "name": "Central Pacific Standard Time",
                "abbr": "CPST",
                "offset": 11,
                "isdst": false,
                "text": "(UTC+11:00) Solomon Is., New Caledonia",
                "utc": [
                    "Antarctica/Macquarie",
                    "Etc/GMT-11",
                    "Pacific/Efate",
                    "Pacific/Guadalcanal",
                    "Pacific/Kosrae",
                    "Pacific/Noumea",
                    "Pacific/Ponape"
                ]
            },
            {
                "name": "Vladivostok Standard Time",
                "abbr": "VST",
                "offset": 11,
                "isdst": false,
                "text": "(UTC+11:00) Vladivostok",
                "utc": [
                    "Asia/Sakhalin",
                    "Asia/Ust-Nera",
                    "Asia/Vladivostok"
                ]
            },
            {
                "name": "New Zealand Standard Time",
                "abbr": "NZST",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Auckland, Wellington",
                "utc": [
                    "Antarctica/McMurdo",
                    "Pacific/Auckland"
                ]
            },
            {
                "name": "UTC+12",
                "abbr": "U",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Coordinated Universal Time+12",
                "utc": [
                    "Etc/GMT-12",
                    "Pacific/Funafuti",
                    "Pacific/Kwajalein",
                    "Pacific/Majuro",
                    "Pacific/Nauru",
                    "Pacific/Tarawa",
                    "Pacific/Wake",
                    "Pacific/Wallis"
                ]
            },
            {
                "name": "Fiji Standard Time",
                "abbr": "FST",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Fiji",
                "utc": [
                    "Pacific/Fiji"
                ]
            },
            {
                "name": "Magadan Standard Time",
                "abbr": "MST",
                "offset": 12,
                "isdst": false,
                "text": "(UTC+12:00) Magadan",
                "utc": [
                    "Asia/Anadyr",
                    "Asia/Kamchatka",
                    "Asia/Magadan",
                    "Asia/Srednekolymsk"
                ]
            },
            {
                "name": "Kamchatka Standard Time",
                "abbr": "KDT",
                "offset": 13,
                "isdst": true,
                "text": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
                "utc": [
                    "Asia/Kamchatka"
                ]
            },
            {
                "name": "Tonga Standard Time",
                "abbr": "TST",
                "offset": 13,
                "isdst": false,
                "text": "(UTC+13:00) Nuku'alofa",
                "utc": [
                    "Etc/GMT-13",
                    "Pacific/Enderbury",
                    "Pacific/Fakaofo",
                    "Pacific/Tongatapu"
                ]
            },
            {
                "name": "Samoa Standard Time",
                "abbr": "SST",
                "offset": 13,
                "isdst": false,
                "text": "(UTC+13:00) Samoa",
                "utc": [
                    "Pacific/Apia"
                ]
            }
        ],
        //List source: http://answers.google.com/answers/threadview/id/589312.html
        profession: [
            "Airline Pilot",
            "Academic Team",
            "Accountant",
            "Account Executive",
            "Actor",
            "Actuary",
            "Acquisition Analyst",
            "Administrative Asst.",
            "Administrative Analyst",
            "Administrator",
            "Advertising Director",
            "Aerospace Engineer",
            "Agent",
            "Agricultural Inspector",
            "Agricultural Scientist",
            "Air Traffic Controller",
            "Animal Trainer",
            "Anthropologist",
            "Appraiser",
            "Architect",
            "Art Director",
            "Artist",
            "Astronomer",
            "Athletic Coach",
            "Auditor",
            "Author",
            "Baker",
            "Banker",
            "Bankruptcy Attorney",
            "Benefits Manager",
            "Biologist",
            "Bio-feedback Specialist",
            "Biomedical Engineer",
            "Biotechnical Researcher",
            "Broadcaster",
            "Broker",
            "Building Manager",
            "Building Contractor",
            "Building Inspector",
            "Business Analyst",
            "Business Planner",
            "Business Manager",
            "Buyer",
            "Call Center Manager",
            "Career Counselor",
            "Cash Manager",
            "Ceramic Engineer",
            "Chief Executive Officer",
            "Chief Operation Officer",
            "Chef",
            "Chemical Engineer",
            "Chemist",
            "Child Care Manager",
            "Chief Medical Officer",
            "Chiropractor",
            "Cinematographer",
            "City Housing Manager",
            "City Manager",
            "Civil Engineer",
            "Claims Manager",
            "Clinical Research Assistant",
            "Collections Manager",
            "Compliance Manager",
            "Comptroller",
            "Computer Manager",
            "Commercial Artist",
            "Communications Affairs Director",
            "Communications Director",
            "Communications Engineer",
            "Compensation Analyst",
            "Computer Programmer",
            "Computer Ops. Manager",
            "Computer Engineer",
            "Computer Operator",
            "Computer Graphics Specialist",
            "Construction Engineer",
            "Construction Manager",
            "Consultant",
            "Consumer Relations Manager",
            "Contract Administrator",
            "Copyright Attorney",
            "Copywriter",
            "Corporate Planner",
            "Corrections Officer",
            "Cosmetologist",
            "Credit Analyst",
            "Cruise Director",
            "Chief Information Officer",
            "Chief Technology Officer",
            "Customer Service Manager",
            "Cryptologist",
            "Dancer",
            "Data Security Manager",
            "Database Manager",
            "Day Care Instructor",
            "Dentist",
            "Designer",
            "Design Engineer",
            "Desktop Publisher",
            "Developer",
            "Development Officer",
            "Diamond Merchant",
            "Dietitian",
            "Direct Marketer",
            "Director",
            "Distribution Manager",
            "Diversity Manager",
            "Economist",
            "EEO Compliance Manager",
            "Editor",
            "Education Adminator",
            "Electrical Engineer",
            "Electro Optical Engineer",
            "Electronics Engineer",
            "Embassy Management",
            "Employment Agent",
            "Engineer Technician",
            "Entrepreneur",
            "Environmental Analyst",
            "Environmental Attorney",
            "Environmental Engineer",
            "Environmental Specialist",
            "Escrow Officer",
            "Estimator",
            "Executive Assistant",
            "Executive Director",
            "Executive Recruiter",
            "Facilities Manager",
            "Family Counselor",
            "Fashion Events Manager",
            "Fashion Merchandiser",
            "Fast Food Manager",
            "Film Producer",
            "Film Production Assistant",
            "Financial Analyst",
            "Financial Planner",
            "Financier",
            "Fine Artist",
            "Wildlife Specialist",
            "Fitness Consultant",
            "Flight Attendant",
            "Flight Engineer",
            "Floral Designer",
            "Food & Beverage Director",
            "Food Service Manager",
            "Forestry Technician",
            "Franchise Management",
            "Franchise Sales",
            "Fraud Investigator",
            "Freelance Writer",
            "Fund Raiser",
            "General Manager",
            "Geologist",
            "General Counsel",
            "Geriatric Specialist",
            "Gerontologist",
            "Glamour Photographer",
            "Golf Club Manager",
            "Gourmet Chef",
            "Graphic Designer",
            "Grounds Keeper",
            "Hazardous Waste Manager",
            "Health Care Manager",
            "Health Therapist",
            "Health Service Administrator",
            "Hearing Officer",
            "Home Economist",
            "Horticulturist",
            "Hospital Administrator",
            "Hotel Manager",
            "Human Resources Manager",
            "Importer",
            "Industrial Designer",
            "Industrial Engineer",
            "Information Director",
            "Inside Sales",
            "Insurance Adjuster",
            "Interior Decorator",
            "Internal Controls Director",
            "International Acct.",
            "International Courier",
            "International Lawyer",
            "Interpreter",
            "Investigator",
            "Investment Banker",
            "Investment Manager",
            "IT Architect",
            "IT Project Manager",
            "IT Systems Analyst",
            "Jeweler",
            "Joint Venture Manager",
            "Journalist",
            "Labor Negotiator",
            "Labor Organizer",
            "Labor Relations Manager",
            "Lab Services Director",
            "Lab Technician",
            "Land Developer",
            "Landscape Architect",
            "Law Enforcement Officer",
            "Lawyer",
            "Lead Software Engineer",
            "Lead Software Test Engineer",
            "Leasing Manager",
            "Legal Secretary",
            "Library Manager",
            "Litigation Attorney",
            "Loan Officer",
            "Lobbyist",
            "Logistics Manager",
            "Maintenance Manager",
            "Management Consultant",
            "Managed Care Director",
            "Managing Partner",
            "Manufacturing Director",
            "Manpower Planner",
            "Marine Biologist",
            "Market Res. Analyst",
            "Marketing Director",
            "Materials Manager",
            "Mathematician",
            "Membership Chairman",
            "Mechanic",
            "Mechanical Engineer",
            "Media Buyer",
            "Medical Investor",
            "Medical Secretary",
            "Medical Technician",
            "Mental Health Counselor",
            "Merchandiser",
            "Metallurgical Engineering",
            "Meteorologist",
            "Microbiologist",
            "MIS Manager",
            "Motion Picture Director",
            "Multimedia Director",
            "Musician",
            "Network Administrator",
            "Network Specialist",
            "Network Operator",
            "New Product Manager",
            "Novelist",
            "Nuclear Engineer",
            "Nuclear Specialist",
            "Nutritionist",
            "Nursing Administrator",
            "Occupational Therapist",
            "Oceanographer",
            "Office Manager",
            "Operations Manager",
            "Operations Research Director",
            "Optical Technician",
            "Optometrist",
            "Organizational Development Manager",
            "Outplacement Specialist",
            "Paralegal",
            "Park Ranger",
            "Patent Attorney",
            "Payroll Specialist",
            "Personnel Specialist",
            "Petroleum Engineer",
            "Pharmacist",
            "Photographer",
            "Physical Therapist",
            "Physician",
            "Physician Assistant",
            "Physicist",
            "Planning Director",
            "Podiatrist",
            "Political Analyst",
            "Political Scientist",
            "Politician",
            "Portfolio Manager",
            "Preschool Management",
            "Preschool Teacher",
            "Principal",
            "Private Banker",
            "Private Investigator",
            "Probation Officer",
            "Process Engineer",
            "Producer",
            "Product Manager",
            "Product Engineer",
            "Production Engineer",
            "Production Planner",
            "Professional Athlete",
            "Professional Coach",
            "Professor",
            "Project Engineer",
            "Project Manager",
            "Program Manager",
            "Property Manager",
            "Public Administrator",
            "Public Safety Director",
            "PR Specialist",
            "Publisher",
            "Purchasing Agent",
            "Publishing Director",
            "Quality Assurance Specialist",
            "Quality Control Engineer",
            "Quality Control Inspector",
            "Radiology Manager",
            "Railroad Engineer",
            "Real Estate Broker",
            "Recreational Director",
            "Recruiter",
            "Redevelopment Specialist",
            "Regulatory Affairs Manager",
            "Registered Nurse",
            "Rehabilitation Counselor",
            "Relocation Manager",
            "Reporter",
            "Research Specialist",
            "Restaurant Manager",
            "Retail Store Manager",
            "Risk Analyst",
            "Safety Engineer",
            "Sales Engineer",
            "Sales Trainer",
            "Sales Promotion Manager",
            "Sales Representative",
            "Sales Manager",
            "Service Manager",
            "Sanitation Engineer",
            "Scientific Programmer",
            "Scientific Writer",
            "Securities Analyst",
            "Security Consultant",
            "Security Director",
            "Seminar Presenter",
            "Ship's Officer",
            "Singer",
            "Social Director",
            "Social Program Planner",
            "Social Research",
            "Social Scientist",
            "Social Worker",
            "Sociologist",
            "Software Developer",
            "Software Engineer",
            "Software Test Engineer",
            "Soil Scientist",
            "Special Events Manager",
            "Special Education Teacher",
            "Special Projects Director",
            "Speech Pathologist",
            "Speech Writer",
            "Sports Event Manager",
            "Statistician",
            "Store Manager",
            "Strategic Alliance Director",
            "Strategic Planning Director",
            "Stress Reduction Specialist",
            "Stockbroker",
            "Surveyor",
            "Structural Engineer",
            "Superintendent",
            "Supply Chain Director",
            "System Engineer",
            "Systems Analyst",
            "Systems Programmer",
            "System Administrator",
            "Tax Specialist",
            "Teacher",
            "Technical Support Specialist",
            "Technical Illustrator",
            "Technical Writer",
            "Technology Director",
            "Telecom Analyst",
            "Telemarketer",
            "Theatrical Director",
            "Title Examiner",
            "Tour Escort",
            "Tour Guide Director",
            "Traffic Manager",
            "Trainer Translator",
            "Transportation Manager",
            "Travel Agent",
            "Treasurer",
            "TV Programmer",
            "Underwriter",
            "Union Representative",
            "University Administrator",
            "University Dean",
            "Urban Planner",
            "Veterinarian",
            "Vendor Relations Director",
            "Viticulturist",
            "Warehouse Manager"
        ],
        animals: {
            //list of ocean animals comes from https://owlcation.com/stem/list-of-ocean-animals
            "ocean": [
                "Acantharea",
                "Anemone",
                "Angelfish King",
                "Ahi Tuna",
                "Albacore",
                "American Oyster",
                "Anchovy",
                "Armored Snail",
                "Arctic Char",
                "Atlantic Bluefin Tuna",
                "Atlantic Cod",
                "Atlantic Goliath Grouper",
                "Atlantic Trumpetfish",
                "Atlantic Wolffish",
                "Baleen Whale",
                "Banded Butterflyfish",
                "Banded Coral Shrimp",
                "Banded Sea Krait",
                "Barnacle",
                "Barndoor Skate",
                "Barracuda",
                "Basking Shark",
                "Bass",
                "Beluga Whale",
                "Bluebanded Goby",
                "Bluehead Wrasse",
                "Bluefish",
                "Bluestreak Cleaner-Wrasse",
                "Blue Marlin",
                "Blue Shark",
                "Blue Spiny Lobster",
                "Blue Tang",
                "Blue Whale",
                "Broadclub Cuttlefish",
                "Bull Shark",
                "Chambered Nautilus",
                "Chilean Basket Star",
                "Chilean Jack Mackerel",
                "Chinook Salmon",
                "Christmas Tree Worm",
                "Clam",
                "Clown Anemonefish",
                "Clown Triggerfish",
                "Cod",
                "Coelacanth",
                "Cockscomb Cup Coral",
                "Common Fangtooth",
                "Conch",
                "Cookiecutter Shark",
                "Copepod",
                "Coral",
                "Corydoras",
                "Cownose Ray",
                "Crab",
                "Crown-of-Thorns Starfish",
                "Cushion Star",
                "Cuttlefish",
                "California Sea Otters",
                "Dolphin",
                "Dolphinfish",
                "Dory",
                "Devil Fish",
                "Dugong",
                "Dumbo Octopus",
                "Dungeness Crab",
                "Eccentric Sand Dollar",
                "Edible Sea Cucumber",
                "Eel",
                "Elephant Seal",
                "Elkhorn Coral",
                "Emperor Shrimp",
                "Estuarine Crocodile",
                "Fathead Sculpin",
                "Fiddler Crab",
                "Fin Whale",
                "Flameback",
                "Flamingo Tongue Snail",
                "Flashlight Fish",
                "Flatback Turtle",
                "Flatfish",
                "Flying Fish",
                "Flounder",
                "Fluke",
                "French Angelfish",
                "Frilled Shark",
                "Fugu (also called Pufferfish)",
                "Gar",
                "Geoduck",
                "Giant Barrel Sponge",
                "Giant Caribbean Sea Anemone",
                "Giant Clam",
                "Giant Isopod",
                "Giant Kingfish",
                "Giant Oarfish",
                "Giant Pacific Octopus",
                "Giant Pyrosome",
                "Giant Sea Star",
                "Giant Squid",
                "Glowing Sucker Octopus",
                "Giant Tube Worm",
                "Goblin Shark",
                "Goosefish",
                "Great White Shark",
                "Greenland Shark",
                "Grey Atlantic Seal",
                "Grouper",
                "Grunion",
                "Guineafowl Puffer",
                "Haddock",
                "Hake",
                "Halibut",
                "Hammerhead Shark",
                "Hapuka",
                "Harbor Porpoise",
                "Harbor Seal",
                "Hatchetfish",
                "Hawaiian Monk Seal",
                "Hawksbill Turtle",
                "Hector's Dolphin",
                "Hermit Crab",
                "Herring",
                "Hoki",
                "Horn Shark",
                "Horseshoe Crab",
                "Humpback Anglerfish",
                "Humpback Whale",
                "Icefish",
                "Imperator Angelfish",
                "Irukandji Jellyfish",
                "Isopod",
                "Ivory Bush Coral",
                "Japanese Spider Crab",
                "Jellyfish",
                "John Dory",
                "Juan Fernandez Fur Seal",
                "Killer Whale",
                "Kiwa Hirsuta",
                "Krill",
                "Lagoon Triggerfish",
                "Lamprey",
                "Leafy Seadragon",
                "Leopard Seal",
                "Limpet",
                "Ling",
                "Lionfish",
                "Lions Mane Jellyfish",
                "Lobe Coral",
                "Lobster",
                "Loggerhead Turtle",
                "Longnose Sawshark",
                "Longsnout Seahorse",
                "Lophelia Coral",
                "Marrus Orthocanna",
                "Manatee",
                "Manta Ray",
                "Marlin",
                "Megamouth Shark",
                "Mexican Lookdown",
                "Mimic Octopus",
                "Moon Jelly",
                "Mollusk",
                "Monkfish",
                "Moray Eel",
                "Mullet",
                "Mussel",
                "Megaladon",
                "Napoleon Wrasse",
                "Nassau Grouper",
                "Narwhal",
                "Nautilus",
                "Needlefish",
                "Northern Seahorse",
                "North Atlantic Right Whale",
                "Northern Red Snapper",
                "Norway Lobster",
                "Nudibranch",
                "Nurse Shark",
                "Oarfish",
                "Ocean Sunfish",
                "Oceanic Whitetip Shark",
                "Octopus",
                "Olive Sea Snake",
                "Orange Roughy",
                "Ostracod",
                "Otter",
                "Oyster",
                "Pacific Angelshark",
                "Pacific Blackdragon",
                "Pacific Halibut",
                "Pacific Sardine",
                "Pacific Sea Nettle Jellyfish",
                "Pacific White Sided Dolphin",
                "Pantropical Spotted Dolphin",
                "Patagonian Toothfish",
                "Peacock Mantis Shrimp",
                "Pelagic Thresher Shark",
                "Penguin",
                "Peruvian Anchoveta",
                "Pilchard",
                "Pink Salmon",
                "Pinniped",
                "Plankton",
                "Porpoise",
                "Polar Bear",
                "Portuguese Man o' War",
                "Pycnogonid Sea Spider",
                "Quahog",
                "Queen Angelfish",
                "Queen Conch",
                "Queen Parrotfish",
                "Queensland Grouper",
                "Ragfish",
                "Ratfish",
                "Rattail Fish",
                "Ray",
                "Red Drum",
                "Red King Crab",
                "Ringed Seal",
                "Risso's Dolphin",
                "Ross Seals",
                "Sablefish",
                "Salmon",
                "Sand Dollar",
                "Sandbar Shark",
                "Sawfish",
                "Sarcastic Fringehead",
                "Scalloped Hammerhead Shark",
                "Seahorse",
                "Sea Cucumber",
                "Sea Lion",
                "Sea Urchin",
                "Seal",
                "Shark",
                "Shortfin Mako Shark",
                "Shovelnose Guitarfish",
                "Shrimp",
                "Silverside Fish",
                "Skipjack Tuna",
                "Slender Snipe Eel",
                "Smalltooth Sawfish",
                "Smelts",
                "Sockeye Salmon",
                "Southern Stingray",
                "Sponge",
                "Spotted Porcupinefish",
                "Spotted Dolphin",
                "Spotted Eagle Ray",
                "Spotted Moray",
                "Squid",
                "Squidworm",
                "Starfish",
                "Stickleback",
                "Stonefish",
                "Stoplight Loosejaw",
                "Sturgeon",
                "Swordfish",
                "Tan Bristlemouth",
                "Tasseled Wobbegong",
                "Terrible Claw Lobster",
                "Threespot Damselfish",
                "Tiger Prawn",
                "Tiger Shark",
                "Tilefish",
                "Toadfish",
                "Tropical Two-Wing Flyfish",
                "Tuna",
                "Umbrella Squid",
                "Velvet Crab",
                "Venus Flytrap Sea Anemone",
                "Vigtorniella Worm",
                "Viperfish",
                "Vampire Squid",
                "Vaquita",
                "Wahoo",
                "Walrus",
                "West Indian Manatee",
                "Whale",
                "Whale Shark",
                "Whiptail Gulper",
                "White-Beaked Dolphin",
                "White-Ring Garden Eel",
                "White Shrimp",
                "Wobbegong",
                "Wrasse",
                "Wreckfish",
                "Xiphosura",
                "Yellowtail Damselfish",
                "Yelloweye Rockfish",
                "Yellow Cup Black Coral",
                "Yellow Tube Sponge",
                "Yellowfin Tuna",
                "Zebrashark",
                "Zooplankton"
            ],
            //list of desert, grassland, and forest animals comes from http://www.skyenimals.com/
            "desert": [
                "Aardwolf",
                "Addax",
                "African Wild Ass",
                "Ant",
                "Antelope",
                "Armadillo",
                "Baboon",
                "Badger",
                "Bat",
                "Bearded Dragon",
                "Beetle",
                "Bird",
                "Black-footed Cat",
                "Boa",
                "Brown Bear",
                "Bustard",
                "Butterfly",
                "Camel",
                "Caracal",
                "Caracara",
                "Caterpillar",
                "Centipede",
                "Cheetah",
                "Chipmunk",
                "Chuckwalla",
                "Climbing Mouse",
                "Coati",
                "Cobra",
                "Cotton Rat",
                "Cougar",
                "Courser",
                "Crane Fly",
                "Crow",
                "Dassie Rat",
                "Dove",
                "Dunnart",
                "Eagle",
                "Echidna",
                "Elephant",
                "Emu",
                "Falcon",
                "Fly",
                "Fox",
                "Frogmouth",
                "Gecko",
                "Geoffroy's Cat",
                "Gerbil",
                "Grasshopper",
                "Guanaco",
                "Gundi",
                "Hamster",
                "Hawk",
                "Hedgehog",
                "Hyena",
                "Hyrax",
                "Jackal",
                "Kangaroo",
                "Kangaroo Rat",
                "Kestrel",
                "Kowari",
                "Kultarr",
                "Leopard",
                "Lion",
                "Macaw",
                "Meerkat",
                "Mouse",
                "Oryx",
                "Ostrich",
                "Owl",
                "Pronghorn",
                "Python",
                "Rabbit",
                "Raccoon",
                "Rattlesnake",
                "Rhinoceros",
                "Sand Cat",
                "Spectacled Bear",
                "Spiny Mouse",
                "Starling",
                "Stick Bug",
                "Tarantula",
                "Tit",
                "Toad",
                "Tortoise",
                "Tyrant Flycatcher",
                "Viper",
                "Vulture",
                "Waxwing",
                "Xerus",
                "Zebra"
            ],
            "grassland": [
                "Aardvark",
                "Aardwolf",
                "Accentor",
                "African Buffalo",
                "African Wild Dog",
                "Alpaca",
                "Anaconda",
                "Ant",
                "Anteater",
                "Antelope",
                "Armadillo",
                "Baboon",
                "Badger",
                "Bandicoot",
                "Barbet",
                "Bat",
                "Bee",
                "Bee-eater",
                "Beetle",
                "Bird",
                "Bison",
                "Black-footed Cat",
                "Black-footed Ferret",
                "Bluebird",
                "Boa",
                "Bowerbird",
                "Brown Bear",
                "Bush Dog",
                "Bushshrike",
                "Bustard",
                "Butterfly",
                "Buzzard",
                "Caracal",
                "Caracara",
                "Cardinal",
                "Caterpillar",
                "Cheetah",
                "Chipmunk",
                "Civet",
                "Climbing Mouse",
                "Clouded Leopard",
                "Coati",
                "Cobra",
                "Cockatoo",
                "Cockroach",
                "Common Genet",
                "Cotton Rat",
                "Cougar",
                "Courser",
                "Coyote",
                "Crane",
                "Crane Fly",
                "Cricket",
                "Crow",
                "Culpeo",
                "Death Adder",
                "Deer",
                "Deer Mouse",
                "Dingo",
                "Dinosaur",
                "Dove",
                "Drongo",
                "Duck",
                "Duiker",
                "Dunnart",
                "Eagle",
                "Echidna",
                "Elephant",
                "Elk",
                "Emu",
                "Falcon",
                "Finch",
                "Flea",
                "Fly",
                "Flying Frog",
                "Fox",
                "Frog",
                "Frogmouth",
                "Garter Snake",
                "Gazelle",
                "Gecko",
                "Geoffroy's Cat",
                "Gerbil",
                "Giant Tortoise",
                "Giraffe",
                "Grasshopper",
                "Grison",
                "Groundhog",
                "Grouse",
                "Guanaco",
                "Guinea Pig",
                "Hamster",
                "Harrier",
                "Hartebeest",
                "Hawk",
                "Hedgehog",
                "Helmetshrike",
                "Hippopotamus",
                "Hornbill",
                "Hyena",
                "Hyrax",
                "Impala",
                "Jackal",
                "Jaguar",
                "Jaguarundi",
                "Kangaroo",
                "Kangaroo Rat",
                "Kestrel",
                "Kultarr",
                "Ladybug",
                "Leopard",
                "Lion",
                "Macaw",
                "Meerkat",
                "Mouse",
                "Newt",
                "Oryx",
                "Ostrich",
                "Owl",
                "Pangolin",
                "Pheasant",
                "Prairie Dog",
                "Pronghorn",
                "Przewalski's Horse",
                "Python",
                "Quoll",
                "Rabbit",
                "Raven",
                "Rhinoceros",
                "Shelduck",
                "Sloth Bear",
                "Spectacled Bear",
                "Squirrel",
                "Starling",
                "Stick Bug",
                "Tamandua",
                "Tasmanian Devil",
                "Thornbill",
                "Thrush",
                "Toad",
                "Tortoise"
            ],
            "forest": [
                "Agouti",
                "Anaconda",
                "Anoa",
                "Ant",
                "Anteater",
                "Antelope",
                "Armadillo",
                "Asian Black Bear",
                "Aye-aye",
                "Babirusa",
                "Baboon",
                "Badger",
                "Bandicoot",
                "Banteng",
                "Barbet",
                "Basilisk",
                "Bat",
                "Bearded Dragon",
                "Bee",
                "Bee-eater",
                "Beetle",
                "Bettong",
                "Binturong",
                "Bird-of-paradise",
                "Bongo",
                "Bowerbird",
                "Bulbul",
                "Bush Dog",
                "Bushbaby",
                "Bushshrike",
                "Butterfly",
                "Buzzard",
                "Caecilian",
                "Cardinal",
                "Cassowary",
                "Caterpillar",
                "Centipede",
                "Chameleon",
                "Chimpanzee",
                "Cicada",
                "Civet",
                "Clouded Leopard",
                "Coati",
                "Cobra",
                "Cockatoo",
                "Cockroach",
                "Colugo",
                "Cotinga",
                "Cotton Rat",
                "Cougar",
                "Crane Fly",
                "Cricket",
                "Crocodile",
                "Crow",
                "Cuckoo",
                "Cuscus",
                "Death Adder",
                "Deer",
                "Dhole",
                "Dingo",
                "Dinosaur",
                "Drongo",
                "Duck",
                "Duiker",
                "Eagle",
                "Echidna",
                "Elephant",
                "Finch",
                "Flat-headed Cat",
                "Flea",
                "Flowerpecker",
                "Fly",
                "Flying Frog",
                "Fossa",
                "Frog",
                "Frogmouth",
                "Gaur",
                "Gecko",
                "Gorilla",
                "Grison",
                "Hawaiian Honeycreeper",
                "Hawk",
                "Hedgehog",
                "Helmetshrike",
                "Hornbill",
                "Hyrax",
                "Iguana",
                "Jackal",
                "Jaguar",
                "Jaguarundi",
                "Kestrel",
                "Ladybug",
                "Lemur",
                "Leopard",
                "Lion",
                "Macaw",
                "Mandrill",
                "Margay",
                "Monkey",
                "Mouse",
                "Mouse Deer",
                "Newt",
                "Okapi",
                "Old World Flycatcher",
                "Orangutan",
                "Owl",
                "Pangolin",
                "Peafowl",
                "Pheasant",
                "Possum",
                "Python",
                "Quokka",
                "Rabbit",
                "Raccoon",
                "Red Panda",
                "Red River Hog",
                "Rhinoceros",
                "Sloth Bear",
                "Spectacled Bear",
                "Squirrel",
                "Starling",
                "Stick Bug",
                "Sun Bear",
                "Tamandua",
                "Tamarin",
                "Tapir",
                "Tarantula",
                "Thrush",
                "Tiger",
                "Tit",
                "Toad",
                "Tortoise",
                "Toucan",
                "Trogon",
                "Trumpeter",
                "Turaco",
                "Turtle",
                "Tyrant Flycatcher",
                "Viper",
                "Vulture",
                "Wallaby",
                "Warbler",
                "Wasp",
                "Waxwing",
                "Weaver",
                "Weaver-finch",
                "Whistler",
                "White-eye",
                "Whydah",
                "Woodswallow",
                "Worm",
                "Wren",
                "Xenops",
                "Yellowjacket",
                "Accentor",
                "African Buffalo",
                "American Black Bear",
                "Anole",
                "Bird",
                "Bison",
                "Boa",
                "Brown Bear",
                "Chipmunk",
                "Common Genet",
                "Copperhead",
                "Coyote",
                "Deer Mouse",
                "Dormouse",
                "Elk",
                "Emu",
                "Fisher",
                "Fox",
                "Garter Snake",
                "Giant Panda",
                "Giant Tortoise",
                "Groundhog",
                "Grouse",
                "Guanaco",
                "Himalayan Tahr",
                "Kangaroo",
                "Koala",
                "Numbat",
                "Quoll",
                "Raccoon dog",
                "Tasmanian Devil",
                "Thornbill",
                "Turkey",
                "Vole",
                "Weasel",
                "Wildcat",
                "Wolf",
                "Wombat",
                "Woodchuck",
                "Woodpecker"
            ],
            //list of farm animals comes from https://www.buzzle.com/articles/farm-animals-list.html
            "farm": [
                "Alpaca",
                "Buffalo",
                "Banteng",
                "Cow",
                "Cat",
                "Chicken",
                "Carp",
                "Camel",
                "Donkey",
                "Dog",
                "Duck",
                "Emu",
                "Goat",
                "Gayal",
                "Guinea",
                "Goose",
                "Horse",
                "Honey",
                "Llama",
                "Pig",
                "Pigeon",
                "Rhea",
                "Rabbit",
                "Sheep",
                "Silkworm",
                "Turkey",
                "Yak",
                "Zebu"
            ],
            //list of pet animals comes from https://www.dogbreedinfo.com/pets/pet.htm
            "pet": [
                "Bearded Dragon",
                "Birds",
                "Burro",
                "Cats",
                "Chameleons",
                "Chickens",
                "Chinchillas",
                "Chinese Water Dragon",
                "Cows",
                "Dogs",
                "Donkey",
                "Ducks",
                "Ferrets",
                "Fish",
                "Geckos",
                "Geese",
                "Gerbils",
                "Goats",
                "Guinea Fowl",
                "Guinea Pigs",
                "Hamsters",
                "Hedgehogs",
                "Horses",
                "Iguanas",
                "Llamas",
                "Lizards",
                "Mice",
                "Mule",
                "Peafowl",
                "Pigs and Hogs",
                "Pigeons",
                "Ponies",
                "Pot Bellied Pig",
                "Rabbits",
                "Rats",
                "Sheep",
                "Skinks",
                "Snakes",
                "Stick Insects",
                "Sugar Gliders",
                "Tarantula",
                "Turkeys",
                "Turtles"
            ],
            //list of zoo animals comes from https://bronxzoo.com/animals
            "zoo": [
                "Aardvark",
                "African Wild Dog",
                "Aldabra Tortoise",
                "American Alligator",
                "American Bison",
                "Amur Tiger",
                "Anaconda",
                "Andean Condor",
                "Asian Elephant",
                "Baby Doll Sheep",
                "Bald Eagle",
                "Barred Owl",
                "Blue Iguana",
                "Boer Goat",
                "California Sea Lion",
                "Caribbean Flamingo",
                "Chinchilla",
                "Collared Lemur",
                "Coquerel's Sifaka",
                "Cuban Amazon Parrot",
                "Ebony Langur",
                "Fennec Fox",
                "Fossa",
                "Gelada",
                "Giant Anteater",
                "Giraffe",
                "Gorilla",
                "Grizzly Bear",
                "Henkel's Leaf-tailed Gecko",
                "Indian Gharial",
                "Indian Rhinoceros",
                "King Cobra",
                "King Vulture",
                "Komodo Dragon",
                "Linne's Two-toed Sloth",
                "Lion",
                "Little Penguin",
                "Madagascar Tree Boa",
                "Magellanic Penguin",
                "Malayan Tapir",
                "Malayan Tiger",
                "Matschies Tree Kangaroo",
                "Mini Donkey",
                "Monarch Butterfly",
                "Nile crocodile",
                "North American Porcupine",
                "Nubian Ibex",
                "Okapi",
                "Poison Dart Frog",
                "Polar Bear",
                "Pygmy Marmoset",
                "Radiated Tortoise",
                "Red Panda",
                "Red Ruffed Lemur",
                "Ring-tailed Lemur",
                "Ring-tailed Mongoose",
                "Rock Hyrax",
                "Small Clawed Asian Otter",
                "Snow Leopard",
                "Snowy Owl",
                "Southern White-faced Owl",
                "Southern White Rhinocerous",
                "Squirrel Monkey",
                "Tufted Puffin",
                "White Cheeked Gibbon",
                "White-throated Bee Eater",
                "Zebra"
            ]
        },
        primes: [
            // 1230 first primes, i.e. all primes up to the first one greater than 10000, inclusive.
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37,
            41,
            43,
            47,
            53,
            59,
            61,
            67,
            71,
            73,
            79,
            83,
            89,
            97,
            101,
            103,
            107,
            109,
            113,
            127,
            131,
            137,
            139,
            149,
            151,
            157,
            163,
            167,
            173,
            179,
            181,
            191,
            193,
            197,
            199,
            211,
            223,
            227,
            229,
            233,
            239,
            241,
            251,
            257,
            263,
            269,
            271,
            277,
            281,
            283,
            293,
            307,
            311,
            313,
            317,
            331,
            337,
            347,
            349,
            353,
            359,
            367,
            373,
            379,
            383,
            389,
            397,
            401,
            409,
            419,
            421,
            431,
            433,
            439,
            443,
            449,
            457,
            461,
            463,
            467,
            479,
            487,
            491,
            499,
            503,
            509,
            521,
            523,
            541,
            547,
            557,
            563,
            569,
            571,
            577,
            587,
            593,
            599,
            601,
            607,
            613,
            617,
            619,
            631,
            641,
            643,
            647,
            653,
            659,
            661,
            673,
            677,
            683,
            691,
            701,
            709,
            719,
            727,
            733,
            739,
            743,
            751,
            757,
            761,
            769,
            773,
            787,
            797,
            809,
            811,
            821,
            823,
            827,
            829,
            839,
            853,
            857,
            859,
            863,
            877,
            881,
            883,
            887,
            907,
            911,
            919,
            929,
            937,
            941,
            947,
            953,
            967,
            971,
            977,
            983,
            991,
            997,
            1009,
            1013,
            1019,
            1021,
            1031,
            1033,
            1039,
            1049,
            1051,
            1061,
            1063,
            1069,
            1087,
            1091,
            1093,
            1097,
            1103,
            1109,
            1117,
            1123,
            1129,
            1151,
            1153,
            1163,
            1171,
            1181,
            1187,
            1193,
            1201,
            1213,
            1217,
            1223,
            1229,
            1231,
            1237,
            1249,
            1259,
            1277,
            1279,
            1283,
            1289,
            1291,
            1297,
            1301,
            1303,
            1307,
            1319,
            1321,
            1327,
            1361,
            1367,
            1373,
            1381,
            1399,
            1409,
            1423,
            1427,
            1429,
            1433,
            1439,
            1447,
            1451,
            1453,
            1459,
            1471,
            1481,
            1483,
            1487,
            1489,
            1493,
            1499,
            1511,
            1523,
            1531,
            1543,
            1549,
            1553,
            1559,
            1567,
            1571,
            1579,
            1583,
            1597,
            1601,
            1607,
            1609,
            1613,
            1619,
            1621,
            1627,
            1637,
            1657,
            1663,
            1667,
            1669,
            1693,
            1697,
            1699,
            1709,
            1721,
            1723,
            1733,
            1741,
            1747,
            1753,
            1759,
            1777,
            1783,
            1787,
            1789,
            1801,
            1811,
            1823,
            1831,
            1847,
            1861,
            1867,
            1871,
            1873,
            1877,
            1879,
            1889,
            1901,
            1907,
            1913,
            1931,
            1933,
            1949,
            1951,
            1973,
            1979,
            1987,
            1993,
            1997,
            1999,
            2003,
            2011,
            2017,
            2027,
            2029,
            2039,
            2053,
            2063,
            2069,
            2081,
            2083,
            2087,
            2089,
            2099,
            2111,
            2113,
            2129,
            2131,
            2137,
            2141,
            2143,
            2153,
            2161,
            2179,
            2203,
            2207,
            2213,
            2221,
            2237,
            2239,
            2243,
            2251,
            2267,
            2269,
            2273,
            2281,
            2287,
            2293,
            2297,
            2309,
            2311,
            2333,
            2339,
            2341,
            2347,
            2351,
            2357,
            2371,
            2377,
            2381,
            2383,
            2389,
            2393,
            2399,
            2411,
            2417,
            2423,
            2437,
            2441,
            2447,
            2459,
            2467,
            2473,
            2477,
            2503,
            2521,
            2531,
            2539,
            2543,
            2549,
            2551,
            2557,
            2579,
            2591,
            2593,
            2609,
            2617,
            2621,
            2633,
            2647,
            2657,
            2659,
            2663,
            2671,
            2677,
            2683,
            2687,
            2689,
            2693,
            2699,
            2707,
            2711,
            2713,
            2719,
            2729,
            2731,
            2741,
            2749,
            2753,
            2767,
            2777,
            2789,
            2791,
            2797,
            2801,
            2803,
            2819,
            2833,
            2837,
            2843,
            2851,
            2857,
            2861,
            2879,
            2887,
            2897,
            2903,
            2909,
            2917,
            2927,
            2939,
            2953,
            2957,
            2963,
            2969,
            2971,
            2999,
            3001,
            3011,
            3019,
            3023,
            3037,
            3041,
            3049,
            3061,
            3067,
            3079,
            3083,
            3089,
            3109,
            3119,
            3121,
            3137,
            3163,
            3167,
            3169,
            3181,
            3187,
            3191,
            3203,
            3209,
            3217,
            3221,
            3229,
            3251,
            3253,
            3257,
            3259,
            3271,
            3299,
            3301,
            3307,
            3313,
            3319,
            3323,
            3329,
            3331,
            3343,
            3347,
            3359,
            3361,
            3371,
            3373,
            3389,
            3391,
            3407,
            3413,
            3433,
            3449,
            3457,
            3461,
            3463,
            3467,
            3469,
            3491,
            3499,
            3511,
            3517,
            3527,
            3529,
            3533,
            3539,
            3541,
            3547,
            3557,
            3559,
            3571,
            3581,
            3583,
            3593,
            3607,
            3613,
            3617,
            3623,
            3631,
            3637,
            3643,
            3659,
            3671,
            3673,
            3677,
            3691,
            3697,
            3701,
            3709,
            3719,
            3727,
            3733,
            3739,
            3761,
            3767,
            3769,
            3779,
            3793,
            3797,
            3803,
            3821,
            3823,
            3833,
            3847,
            3851,
            3853,
            3863,
            3877,
            3881,
            3889,
            3907,
            3911,
            3917,
            3919,
            3923,
            3929,
            3931,
            3943,
            3947,
            3967,
            3989,
            4001,
            4003,
            4007,
            4013,
            4019,
            4021,
            4027,
            4049,
            4051,
            4057,
            4073,
            4079,
            4091,
            4093,
            4099,
            4111,
            4127,
            4129,
            4133,
            4139,
            4153,
            4157,
            4159,
            4177,
            4201,
            4211,
            4217,
            4219,
            4229,
            4231,
            4241,
            4243,
            4253,
            4259,
            4261,
            4271,
            4273,
            4283,
            4289,
            4297,
            4327,
            4337,
            4339,
            4349,
            4357,
            4363,
            4373,
            4391,
            4397,
            4409,
            4421,
            4423,
            4441,
            4447,
            4451,
            4457,
            4463,
            4481,
            4483,
            4493,
            4507,
            4513,
            4517,
            4519,
            4523,
            4547,
            4549,
            4561,
            4567,
            4583,
            4591,
            4597,
            4603,
            4621,
            4637,
            4639,
            4643,
            4649,
            4651,
            4657,
            4663,
            4673,
            4679,
            4691,
            4703,
            4721,
            4723,
            4729,
            4733,
            4751,
            4759,
            4783,
            4787,
            4789,
            4793,
            4799,
            4801,
            4813,
            4817,
            4831,
            4861,
            4871,
            4877,
            4889,
            4903,
            4909,
            4919,
            4931,
            4933,
            4937,
            4943,
            4951,
            4957,
            4967,
            4969,
            4973,
            4987,
            4993,
            4999,
            5003,
            5009,
            5011,
            5021,
            5023,
            5039,
            5051,
            5059,
            5077,
            5081,
            5087,
            5099,
            5101,
            5107,
            5113,
            5119,
            5147,
            5153,
            5167,
            5171,
            5179,
            5189,
            5197,
            5209,
            5227,
            5231,
            5233,
            5237,
            5261,
            5273,
            5279,
            5281,
            5297,
            5303,
            5309,
            5323,
            5333,
            5347,
            5351,
            5381,
            5387,
            5393,
            5399,
            5407,
            5413,
            5417,
            5419,
            5431,
            5437,
            5441,
            5443,
            5449,
            5471,
            5477,
            5479,
            5483,
            5501,
            5503,
            5507,
            5519,
            5521,
            5527,
            5531,
            5557,
            5563,
            5569,
            5573,
            5581,
            5591,
            5623,
            5639,
            5641,
            5647,
            5651,
            5653,
            5657,
            5659,
            5669,
            5683,
            5689,
            5693,
            5701,
            5711,
            5717,
            5737,
            5741,
            5743,
            5749,
            5779,
            5783,
            5791,
            5801,
            5807,
            5813,
            5821,
            5827,
            5839,
            5843,
            5849,
            5851,
            5857,
            5861,
            5867,
            5869,
            5879,
            5881,
            5897,
            5903,
            5923,
            5927,
            5939,
            5953,
            5981,
            5987,
            6007,
            6011,
            6029,
            6037,
            6043,
            6047,
            6053,
            6067,
            6073,
            6079,
            6089,
            6091,
            6101,
            6113,
            6121,
            6131,
            6133,
            6143,
            6151,
            6163,
            6173,
            6197,
            6199,
            6203,
            6211,
            6217,
            6221,
            6229,
            6247,
            6257,
            6263,
            6269,
            6271,
            6277,
            6287,
            6299,
            6301,
            6311,
            6317,
            6323,
            6329,
            6337,
            6343,
            6353,
            6359,
            6361,
            6367,
            6373,
            6379,
            6389,
            6397,
            6421,
            6427,
            6449,
            6451,
            6469,
            6473,
            6481,
            6491,
            6521,
            6529,
            6547,
            6551,
            6553,
            6563,
            6569,
            6571,
            6577,
            6581,
            6599,
            6607,
            6619,
            6637,
            6653,
            6659,
            6661,
            6673,
            6679,
            6689,
            6691,
            6701,
            6703,
            6709,
            6719,
            6733,
            6737,
            6761,
            6763,
            6779,
            6781,
            6791,
            6793,
            6803,
            6823,
            6827,
            6829,
            6833,
            6841,
            6857,
            6863,
            6869,
            6871,
            6883,
            6899,
            6907,
            6911,
            6917,
            6947,
            6949,
            6959,
            6961,
            6967,
            6971,
            6977,
            6983,
            6991,
            6997,
            7001,
            7013,
            7019,
            7027,
            7039,
            7043,
            7057,
            7069,
            7079,
            7103,
            7109,
            7121,
            7127,
            7129,
            7151,
            7159,
            7177,
            7187,
            7193,
            7207,
            7211,
            7213,
            7219,
            7229,
            7237,
            7243,
            7247,
            7253,
            7283,
            7297,
            7307,
            7309,
            7321,
            7331,
            7333,
            7349,
            7351,
            7369,
            7393,
            7411,
            7417,
            7433,
            7451,
            7457,
            7459,
            7477,
            7481,
            7487,
            7489,
            7499,
            7507,
            7517,
            7523,
            7529,
            7537,
            7541,
            7547,
            7549,
            7559,
            7561,
            7573,
            7577,
            7583,
            7589,
            7591,
            7603,
            7607,
            7621,
            7639,
            7643,
            7649,
            7669,
            7673,
            7681,
            7687,
            7691,
            7699,
            7703,
            7717,
            7723,
            7727,
            7741,
            7753,
            7757,
            7759,
            7789,
            7793,
            7817,
            7823,
            7829,
            7841,
            7853,
            7867,
            7873,
            7877,
            7879,
            7883,
            7901,
            7907,
            7919,
            7927,
            7933,
            7937,
            7949,
            7951,
            7963,
            7993,
            8009,
            8011,
            8017,
            8039,
            8053,
            8059,
            8069,
            8081,
            8087,
            8089,
            8093,
            8101,
            8111,
            8117,
            8123,
            8147,
            8161,
            8167,
            8171,
            8179,
            8191,
            8209,
            8219,
            8221,
            8231,
            8233,
            8237,
            8243,
            8263,
            8269,
            8273,
            8287,
            8291,
            8293,
            8297,
            8311,
            8317,
            8329,
            8353,
            8363,
            8369,
            8377,
            8387,
            8389,
            8419,
            8423,
            8429,
            8431,
            8443,
            8447,
            8461,
            8467,
            8501,
            8513,
            8521,
            8527,
            8537,
            8539,
            8543,
            8563,
            8573,
            8581,
            8597,
            8599,
            8609,
            8623,
            8627,
            8629,
            8641,
            8647,
            8663,
            8669,
            8677,
            8681,
            8689,
            8693,
            8699,
            8707,
            8713,
            8719,
            8731,
            8737,
            8741,
            8747,
            8753,
            8761,
            8779,
            8783,
            8803,
            8807,
            8819,
            8821,
            8831,
            8837,
            8839,
            8849,
            8861,
            8863,
            8867,
            8887,
            8893,
            8923,
            8929,
            8933,
            8941,
            8951,
            8963,
            8969,
            8971,
            8999,
            9001,
            9007,
            9011,
            9013,
            9029,
            9041,
            9043,
            9049,
            9059,
            9067,
            9091,
            9103,
            9109,
            9127,
            9133,
            9137,
            9151,
            9157,
            9161,
            9173,
            9181,
            9187,
            9199,
            9203,
            9209,
            9221,
            9227,
            9239,
            9241,
            9257,
            9277,
            9281,
            9283,
            9293,
            9311,
            9319,
            9323,
            9337,
            9341,
            9343,
            9349,
            9371,
            9377,
            9391,
            9397,
            9403,
            9413,
            9419,
            9421,
            9431,
            9433,
            9437,
            9439,
            9461,
            9463,
            9467,
            9473,
            9479,
            9491,
            9497,
            9511,
            9521,
            9533,
            9539,
            9547,
            9551,
            9587,
            9601,
            9613,
            9619,
            9623,
            9629,
            9631,
            9643,
            9649,
            9661,
            9677,
            9679,
            9689,
            9697,
            9719,
            9721,
            9733,
            9739,
            9743,
            9749,
            9767,
            9769,
            9781,
            9787,
            9791,
            9803,
            9811,
            9817,
            9829,
            9833,
            9839,
            9851,
            9857,
            9859,
            9871,
            9883,
            9887,
            9901,
            9907,
            9923,
            9929,
            9931,
            9941,
            9949,
            9967,
            9973,
            10007
        ],
        emotions: [
            "love",
            "joy",
            "surprise",
            "anger",
            "sadness",
            "fear"
        ],
        music_genres: {
            'general': [
                'Rock',
                'Pop',
                'Hip-Hop',
                'Jazz',
                'Classical',
                'Electronic',
                'Country',
                'R&B',
                'Reggae',
                'Blues',
                'Metal',
                'Folk',
                'Alternative',
                'Punk',
                'Disco',
                'Funk',
                'Techno',
                'Indie',
                'Gospel',
                'Dance',
                'Children\'s',
                'World'
            ],
            'alternative': [
                'Art Punk',
                'Alternative Rock',
                'Britpunk',
                'College Rock',
                'Crossover Thrash',
                'Crust Punk',
                'Emo / Emocore',
                'Experimental Rock',
                'Folk Punk',
                'Goth / Gothic Rock',
                'Grunge',
                'Hardcore Punk',
                'Hard Rock',
                'Indie Rock',
                'Lo-fi',
                "Musique Concr\xe8te",
                'New Wave',
                'Progressive Rock',
                'Punk',
                'Shoegaze',
                'Steampunk'
            ],
            'blues': [
                'Acoustic Blues',
                'African Blues',
                'Blues Rock',
                'Blues Shouter',
                'British Blues',
                'Canadian Blues',
                'Chicago Blues',
                'Classic Blues',
                'Classic Female Blues',
                'Contemporary Blues',
                'Country Blues',
                'Dark Blues',
                'Delta Blues',
                'Detroit Blues',
                'Doom Blues',
                'Electric Blues',
                'Folk Blues',
                'Gospel Blues',
                'Harmonica Blues',
                'Hill Country Blues',
                'Hokum Blues',
                'Jazz Blues',
                'Jump Blues',
                'Kansas City Blues',
                'Louisiana Blues',
                'Memphis Blues',
                'Modern Blues',
                'New Orlean Blues',
                'NY Blues',
                'Piano Blues',
                'Piedmont Blues',
                'Punk Blues',
                'Ragtime Blues',
                'Rhythm Blues',
                'Soul Blues',
                'St.Louis Blues',
                'Soul Blues',
                'Swamp Blues',
                'Texas Blues',
                'Urban Blues',
                'Vandeville',
                'West Coast Blues'
            ],
            'children\'s': [
                'Lullabies',
                'Sing - Along',
                'Stories'
            ],
            'classical': [
                'Avant-Garde',
                'Ballet',
                'Baroque',
                'Cantata',
                'Chamber Music',
                'String Quartet',
                'Chant',
                'Choral',
                'Classical Crossover',
                'Concerto',
                'Concerto Grosso',
                'Contemporary Classical',
                'Early Music',
                'Expressionist',
                'High Classical',
                'Impressionist',
                'Mass Requiem',
                'Medieval',
                'Minimalism',
                'Modern Composition',
                'Modern Classical',
                'Opera',
                'Oratorio',
                'Orchestral',
                'Organum',
                'Renaissance',
                'Romantic (early period)',
                'Romantic (later period)',
                'Sonata',
                'Symphonic',
                'Symphony',
                'Twelve-tone',
                'Wedding Music'
            ],
            'country': [
                'Alternative Country',
                'Americana',
                'Australian Country',
                'Bakersfield Sound',
                'Bluegrass',
                'Blues Country',
                'Cajun Fiddle Tunes',
                'Christian Country',
                'Classic Country',
                'Close Harmony',
                'Contemporary Bluegrass',
                'Contemporary Country',
                'Country Gospel',
                'Country Pop',
                'Country Rap',
                'Country Rock',
                'Country Soul',
                'Cowboy / Western',
                'Cowpunk',
                'Dansband',
                'Honky Tonk',
                'Franco-Country',
                'Gulf and Western',
                'Hellbilly Music',
                'Honky Tonk',
                'Instrumental Country',
                'Lubbock Sound',
                'Nashville Sound',
                'Neotraditional Country',
                'Outlaw Country',
                'Progressive',
                'Psychobilly / Punkabilly',
                'Red Dirt',
                'Sertanejo',
                'Texas County',
                'Traditional Bluegrass',
                'Traditional Country',
                'Truck-Driving Country',
                'Urban Cowboy',
                'Western Swing'
            ],
            'dance': [
                'Club / Club Dance',
                'Breakcore',
                'Breakbeat / Breakstep',
                'Chillstep',
                'Deep House',
                'Dubstep',
                'Dancehall',
                'Electro House',
                'Electroswing',
                'Exercise',
                'Future Garage',
                'Garage',
                'Glitch Hop',
                'Glitch Pop',
                'Grime',
                'Hardcore',
                'Hard Dance',
                'Hi-NRG / Eurodance',
                'Horrorcore',
                'House',
                'Jackin House',
                'Jungle / Drum n bass',
                'Liquid Dub',
                'Regstep',
                'Speedcore',
                'Techno',
                'Trance',
                'Trap'
            ],
            electronic: [
                '2-Step',
                '8bit',
                'Ambient',
                'Asian Underground',
                'Bassline',
                'Chillwave',
                'Chiptune',
                'Crunk',
                'Downtempo',
                'Drum & Bass',
                'Hard Step',
                'Electro',
                'Electro-swing',
                'Electroacoustic',
                'Electronica',
                'Electronic Rock',
                'Eurodance',
                'Hardstyle',
                'Hi-Nrg',
                'IDM/Experimental',
                'Industrial',
                'Trip Hop',
                'Vaporwave',
                'UK Garage',
                'House',
                'Dubstep',
                'Deep House',
                'EDM',
                'Future Bass',
                'Psychedelic trance'
            ],
            'jazz': [
                'Acid Jazz',
                'Afro-Cuban Jazz',
                'Avant-Garde Jazz',
                'Bebop',
                'Big Band',
                'Blue Note',
                'British Dance Band (Jazz)',
                'Cape Jazz',
                'Chamber Jazz',
                'Contemporary Jazz',
                'Continental Jazz',
                'Cool Jazz',
                'Crossover Jazz',
                'Dark Jazz',
                'Dixieland',
                'Early Jazz',
                'Electro Swing (Jazz)',
                'Ethio-jazz',
                'Ethno-Jazz',
                'European Free Jazz',
                'Free Funk (Avant-Garde / Funk Jazz)',
                'Free Jazz',
                'Fusion',
                'Gypsy Jazz',
                'Hard Bop',
                'Indo Jazz',
                'Jazz Blues',
                'Jazz-Funk (see Free Funk)',
                'Jazz-Fusion',
                'Jazz Rap',
                'Jazz Rock',
                'Kansas City Jazz',
                'Latin Jazz',
                'M-Base Jazz',
                'Mainstream Jazz',
                'Modal Jazz',
                'Neo-Bop',
                'Neo-Swing',
                'Nu Jazz',
                'Orchestral Jazz',
                'Post-Bop',
                'Punk Jazz',
                'Ragtime',
                'Ska Jazz',
                'Skiffle (also Folk)',
                'Smooth Jazz',
                'Soul Jazz',
                'Swing Jazz',
                'Straight-Ahead Jazz',
                'Trad Jazz',
                'Third Stream',
                'Jazz-Funk',
                'Free Jazz',
                'West Coast Jazz'
            ],
            'metal': [
                'Heavy Metal',
                'Speed Metal',
                'Thrash Metal',
                'Power Metal',
                'Death Metal',
                'Black Metal',
                'Pagan Metal',
                'Viking Metal',
                'Folk Metal',
                'Symphonic Metal',
                'Gothic Metal',
                'Glam Metal',
                'Hair Metal',
                'Doom Metal',
                'Groove Metal',
                'Industrial Metal',
                'Modern Metal',
                'Neoclassical Metal',
                'New Wave Of British Heavy Metal',
                'Post Metal',
                'Progressive Metal',
                'Avantgarde Metal',
                'Sludge',
                'Djent',
                'Drone',
                'Kawaii Metal',
                'Pirate Metal',
                'Nu Metal',
                "Neue Deutsche H\xe4rte",
                'Math Metal',
                'Crossover',
                'Grindcore',
                'Hardcore',
                'Metalcore',
                'Deathcore',
                'Post Hardcore',
                'Mathcore'
            ],
            'folk': [
                'American Folk Revival',
                'Anti - Folk',
                'British Folk Revival',
                'Contemporary Folk',
                'Filk Music',
                'Freak Folk',
                'Indie Folk',
                'Industrial Folk',
                'Neofolk',
                'Progressive Folk',
                'Psychedelic Folk',
                'Sung Poetry',
                'Techno - Folk',
                'Folk Rock',
                'Old-time Music',
                'Bluegrass',
                'Appalachian',
                'Roots Revival',
                'Celtic',
                'Indie Folk'
            ],
            'pop': [
                'Adult Contemporary',
                'Arab Pop',
                'Baroque',
                'Britpop',
                'Bubblegum Pop',
                'Chamber Pop',
                'Chanson',
                'Christian Pop',
                'Classical Crossover',
                'Europop',
                'Austropop',
                'Balkan Pop',
                'French Pop',
                'Korean Pop',
                'Japanese Pop',
                'Chinese Pop',
                'Latin Pop',
                "La\xefk\xf3",
                'Nederpop',
                'Russian Pop',
                'Dance Pop',
                'Dream Pop',
                'Electro Pop',
                'Iranian Pop',
                'Jangle Pop',
                'Latin Ballad',
                'Levenslied',
                'Louisiana Swamp Pop',
                'Mexican Pop',
                'Motorpop',
                'New Romanticism',
                'Orchestral Pop',
                'Pop Rap',
                'Popera',
                'Pop / Rock',
                'Pop Punk',
                'Power Pop',
                'Psychedelic Pop',
                'Russian Pop',
                'Schlager',
                'Soft Rock',
                'Sophisti - Pop',
                'Space Age Pop',
                'Sunshine Pop',
                'Surf Pop',
                'Synthpop',
                'Teen Pop',
                'Traditional Pop Music',
                'Turkish Pop',
                'Vispop',
                'Wonky Pop'
            ],
            'r&b': [
                '(Carolina) Beach Music',
                'Contemporary R & B',
                'Disco',
                'Doo Wop',
                'Funk',
                'Modern Soul',
                'Motown',
                'Neo - Soul',
                'Northern Soul',
                'Psychedelic Soul',
                'Quiet Storm',
                'Soul',
                'Soul Blues',
                'Southern Soul'
            ],
            'reggae': [
                '2 - Tone',
                'Dub',
                'Roots Reggae',
                'Reggae Fusion',
                "Reggae en Espa\xf1ol",
                'Spanish Reggae',
                'Reggae 110',
                "Reggae Bultr\xf3n",
                'Romantic Flow',
                'Lovers Rock',
                'Raggamuffin',
                'Ragga',
                'Dancehall',
                'Ska'
            ],
            'rock': [
                'Acid Rock',
                'Adult - Oriented Rock',
                'Afro Punk',
                'Adult Alternative',
                'Alternative Rock',
                'American Traditional Rock',
                'Anatolian Rock',
                'Arena Rock',
                'Art Rock',
                'Blues - Rock',
                'British Invasion',
                'Cock Rock',
                'Death Metal / Black Metal',
                'Doom Metal',
                'Glam Rock',
                'Gothic Metal',
                'Grind Core',
                'Hair Metal',
                'Hard Rock',
                'Math Metal',
                'Math Rock',
                'Metal',
                'Metal Core',
                'Noise Rock',
                'Jam Bands',
                'Post Punk',
                'Post Rock',
                'Prog - Rock / Art Rock',
                'Progressive Metal',
                'Psychedelic',
                'Rock & Roll',
                'Rockabilly',
                'Roots Rock',
                'Singer / Songwriter',
                'Southern Rock',
                'Spazzcore',
                'Stoner Metal',
                'Surf',
                'Technical Death Metal',
                'Tex - Mex',
                'Thrash Metal',
                'Time Lord Rock(Trock)',
                'Trip - hop',
                'Yacht Rock',
                'School House Rock'
            ],
            'hip-hop': [
                'Alternative Rap',
                'Avant - Garde',
                'Bounce',
                'Chap Hop',
                'Christian Hip Hop',
                'Conscious Hip Hop',
                'Country - Rap',
                'Grunk',
                'Crunkcore',
                'Cumbia Rap',
                'Dirty South',
                'East Coast',
                'Brick City Club',
                'Hardcore Hip Hop',
                'Mafioso Rap',
                'New Jersey Hip Hop',
                'Freestyle Rap',
                'G - Funk',
                'Gangsta Rap',
                'Golden Age',
                'Grime',
                'Hardcore Rap',
                'Hip - Hop',
                'Hip Pop',
                'Horrorcore',
                'Hyphy',
                'Industrial Hip Hop',
                'Instrumental Hip Hop',
                'Jazz Rap',
                'Latin Rap',
                'Low Bap',
                'Lyrical Hip Hop',
                'Merenrap',
                'Midwest Hip Hop',
                'Chicago Hip Hop',
                'Detroit Hip Hop',
                'Horrorcore',
                'St.Louis Hip Hop',
                'Twin Cities Hip Hop',
                'Motswako',
                'Nerdcore',
                'New Jack Swing',
                'New School Hip Hop',
                'Old School Rap',
                'Rap',
                'Trap',
                'Turntablism',
                'Underground Rap',
                'West Coast Rap',
                'East Coast Rap',
                'Trap',
                'UK Grime',
                'Hyphy',
                'Emo-rap',
                'Cloud rap',
                'G-funk',
                'Boom Bap',
                'Mumble',
                'Drill',
                'UK Drill',
                'Soundcloud Rap',
                'Lo-fi'
            ],
            'punk': [
                'Afro-punk',
                'Anarcho punk',
                'Art punk',
                'Christian punk',
                'Crust punk',
                'Deathrock',
                'Egg punk',
                'Garage punk',
                'Glam punk',
                'Hardcore punk',
                'Horror punk',
                'Incelcore/e-punk',
                'Oi!',
                'Peace punk',
                'Punk pathetique',
                'Queercore',
                'Riot Grrrl',
                'Skate punk',
                'Street punk',
                'Taqwacore',
                'Trallpunk'
            ],
            'disco': [
                'Nu-disco',
                'Disco-funk',
                'Hi-NRG',
                'Italo Disco',
                'Eurodisco',
                'Boogie',
                'Space Disco',
                'Post-disco',
                'Electro Disco',
                'Disco House',
                'Disco Pop',
                'Soulful House'
            ],
            'funk': [
                'Funk Rock',
                'P-Funk (Parliament-Funkadelic)',
                'Psychedelic Funk',
                'Funk Metal',
                'Electro-Funk',
                'Go-go',
                'Boogie-Funk',
                'Jazz-Funk',
                'Soul-Funk',
                'Funky Disco',
                'Nu-Funk',
                'Afrobeat',
                'Latin Funk',
                'G-Funk',
                'Acid Jazz',
                'Funktronica',
                'Folk-Funk',
                'Space Funk',
                'Ambient Funk',
                'Hard Funk',
                'Fusion Funk'
            ],
            'techno': [
                'Acid Techno',
                'Ambient Techno',
                'Detroit Techno',
                'Dub Techno',
                'Minimal Techno',
                'Industrial Techno',
                'Hard Techno',
                'Trance',
                'Progressive Techno',
                'Tech House',
                'Electronica',
                'Breakbeat Techno',
                'Electro Techno',
                'Melodic Techno',
                'Experimental Techno',
                'Dark Techno',
                'Ebm',
                'Hypnotic Techno',
                'Psychedelic Techno',
                'Rave Techno',
                'Techno-Pop'
            ],
            'indie': [
                'Indie Rock',
                'Indie Pop',
                'Indie Folk',
                'Indie Electronic',
                'Indie Punk',
                'Indie Hip-Hop',
                'Dream Pop',
                'Shoegaze',
                'Lo-fi',
                'Chillwave',
                'Freak Folk',
                'Noise Pop',
                'Math Rock',
                'Post-Punk',
                'Garage Rock',
                'Experimental Indie',
                'Surf Rock',
                'Alternative Country',
                'Indie Soul',
                'Art Rock',
                'Indie R&B',
                'Indietronica',
                'Emo',
                'Post-Rock',
                'Indie Pop-Rock',
                'Indie Synthpop',
                'Noise Rock',
                'Psych Folk',
                'Indie Blues'
            ],
            'gospel': [
                'Traditional Gospel',
                'Contemporary Gospel',
                'Southern Gospel',
                'Black Gospel',
                'Urban Contemporary Gospel',
                'Gospel Blues',
                'Bluegrass Gospel',
                'Country Gospel',
                'Praise and Worship',
                'Christian Hip-Hop',
                'Gospel Jazz',
                'Reggae Gospel',
                'African Gospel',
                'Latin Gospel',
                'R&B Gospel',
                'Gospel Choir',
                'Acappella Gospel',
                'Instrumental Gospel',
                'Gospel Rap'
            ],
            'world': [
                'African',
                'Arabic',
                'Asian',
                'Caribbean',
                'Celtic',
                'European',
                'Latin American',
                'Middle Eastern',
                'Native American',
                'Polynesian',
                'Reggae',
                'Ska',
                'Salsa',
                'Flamenco',
                'Bossa Nova',
                'Tango',
                'Fado',
                'Klezmer',
                'Balkan',
                'Afrobeat',
                'Mongolian Throat Singing',
                'Indian Classical',
                'Gamelan',
                'Sufi Music',
                'Zydeco',
                'Kora Music',
                'Andean Music',
                'Irish Traditional',
                'Gypsy Jazz',
                'Bollywood',
                'Bhangra',
                'Jawaiian',
                'Hawaiian Slack Key Guitar',
                'Calypso',
                'Cuban Son',
                'Taiko Drumming',
                'African Highlife',
                'Merengue',
                'Tuvan Throat Singing'
            ]
        },
        // Data sourced from https://unicode.org/emoji/charts/full-emoji-list.html
        emojis: {
            "smileys_and_emotion": [
                "0x1f600",
                "0x1f603",
                "0x1f604",
                "0x1f601",
                "0x1f606",
                "0x1f605",
                "0x1f923",
                "0x1f602",
                "0x1f642",
                "0x1f643",
                "0x1fae0",
                "0x1f609",
                "0x1f60a",
                "0x1f607",
                "0x1f970",
                "0x1f60d",
                "0x1f929",
                "0x1f618",
                "0x1f617",
                "0x263a",
                "0x1f61a",
                "0x1f619",
                "0x1f972",
                "0x1f60b",
                "0x1f61b",
                "0x1f61c",
                "0x1f92a",
                "0x1f61d",
                "0x1f911",
                "0x1f917",
                "0x1f92d",
                "0x1fae2",
                "0x1fae3",
                "0x1f92b",
                "0x1f914",
                "0x1fae1",
                "0x1f910",
                "0x1f928",
                "0x1f610",
                "0x1f611",
                "0x1f636",
                "0x1fae5",
                "0x1f636",
                "0x200d",
                "0x1f32b",
                "0xfe0f",
                "0x1f60f",
                "0x1f612",
                "0x1f644",
                "0x1f62c",
                "0x1f62e",
                "0x200d",
                "0x1f4a8",
                "0x1f925",
                "0x1fae8",
                "0x1f642",
                "0x200d",
                "0x2194",
                "0xfe0f",
                "0x1f642",
                "0x200d",
                "0x2195",
                "0xfe0f",
                "0x1f60c",
                "0x1f614",
                "0x1f62a",
                "0x1f924",
                "0x1f634",
                "0x1f637",
                "0x1f912",
                "0x1f915",
                "0x1f922",
                "0x1f92e",
                "0x1f927",
                "0x1f975",
                "0x1f976",
                "0x1f974",
                "0x1f635",
                "0x1f635",
                "0x200d",
                "0x1f4ab",
                "0x1f92f",
                "0x1f920",
                "0x1f973",
                "0x1f978",
                "0x1f60e",
                "0x1f913",
                "0x1f9d0",
                "0x1f615",
                "0x1fae4",
                "0x1f61f",
                "0x1f641",
                "0x2639",
                "0x1f62e",
                "0x1f62f",
                "0x1f632",
                "0x1f633",
                "0x1f97a",
                "0x1f979",
                "0x1f626",
                "0x1f627",
                "0x1f628",
                "0x1f630",
                "0x1f625",
                "0x1f622",
                "0x1f62d",
                "0x1f631",
                "0x1f616",
                "0x1f623",
                "0x1f61e",
                "0x1f613",
                "0x1f629",
                "0x1f62b",
                "0x1f971",
                "0x1f624",
                "0x1f621",
                "0x1f620",
                "0x1f92c",
                "0x1f608",
                "0x1f47f",
                "0x1f480",
                "0x2620",
                "0x1f4a9",
                "0x1f921",
                "0x1f479",
                "0x1f47a",
                "0x1f47b",
                "0x1f47d",
                "0x1f47e",
                "0x1f916",
                "0x1f63a",
                "0x1f638",
                "0x1f639",
                "0x1f63b",
                "0x1f63c",
                "0x1f63d",
                "0x1f640",
                "0x1f63f",
                "0x1f63e",
                "0x1f648",
                "0x1f649",
                "0x1f64a",
                "0x1f48c",
                "0x1f498",
                "0x1f49d",
                "0x1f496",
                "0x1f497",
                "0x1f493",
                "0x1f49e",
                "0x1f495",
                "0x1f49f",
                "0x2763",
                "0x1f494",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f525",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1fa79",
                "0x2764",
                "0x1fa77",
                "0x1f9e1",
                "0x1f49b",
                "0x1f49a",
                "0x1f499",
                "0x1fa75",
                "0x1f49c",
                "0x1f90e",
                "0x1f5a4",
                "0x1fa76",
                "0x1f90d",
                "0x1f48b",
                "0x1f4af",
                "0x1f4a2",
                "0x1f4a5",
                "0x1f4ab",
                "0x1f4a6",
                "0x1f4a8",
                "0x1f573",
                "0x1f4ac",
                "0x1f441",
                "0xfe0f",
                "0x200d",
                "0x1f5e8",
                "0xfe0f",
                "0x1f5e8",
                "0x1f5ef",
                "0x1f4ad",
                "0x1f4a4"
            ],
            "people_and_body": [
                "0x1f44b",
                "0x1f91a",
                "0x1f590",
                "0x270b",
                "0x1f596",
                "0x1faf1",
                "0x1faf2",
                "0x1faf3",
                "0x1faf4",
                "0x1faf7",
                "0x1faf8",
                "0x1f44c",
                "0x1f90c",
                "0x1f90f",
                "0x270c",
                "0x1f91e",
                "0x1faf0",
                "0x1f91f",
                "0x1f918",
                "0x1f919",
                "0x1f448",
                "0x1f449",
                "0x1f446",
                "0x1f595",
                "0x1f447",
                "0x261d",
                "0x1faf5",
                "0x1f44d",
                "0x1f44e",
                "0x270a",
                "0x1f44a",
                "0x1f91b",
                "0x1f91c",
                "0x1f44f",
                "0x1f64c",
                "0x1faf6",
                "0x1f450",
                "0x1f932",
                "0x1f91d",
                "0x1f64f",
                "0x270d",
                "0x1f485",
                "0x1f933",
                "0x1f4aa",
                "0x1f9be",
                "0x1f9bf",
                "0x1f9b5",
                "0x1f9b6",
                "0x1f442",
                "0x1f9bb",
                "0x1f443",
                "0x1f9e0",
                "0x1fac0",
                "0x1fac1",
                "0x1f9b7",
                "0x1f9b4",
                "0x1f440",
                "0x1f441",
                "0x1f445",
                "0x1f444",
                "0x1fae6",
                "0x1f476",
                "0x1f9d2",
                "0x1f466",
                "0x1f467",
                "0x1f9d1",
                "0x1f471",
                "0x1f468",
                "0x1f9d4",
                "0x1f9d4",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d4",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9b0",
                "0x1f468",
                "0x200d",
                "0x1f9b1",
                "0x1f468",
                "0x200d",
                "0x1f9b3",
                "0x1f468",
                "0x200d",
                "0x1f9b2",
                "0x1f469",
                "0x1f469",
                "0x200d",
                "0x1f9b0",
                "0x1f9d1",
                "0x200d",
                "0x1f9b0",
                "0x1f469",
                "0x200d",
                "0x1f9b1",
                "0x1f9d1",
                "0x200d",
                "0x1f9b1",
                "0x1f469",
                "0x200d",
                "0x1f9b3",
                "0x1f9d1",
                "0x200d",
                "0x1f9b3",
                "0x1f469",
                "0x200d",
                "0x1f9b2",
                "0x1f9d1",
                "0x200d",
                "0x1f9b2",
                "0x1f471",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f471",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d3",
                "0x1f474",
                "0x1f475",
                "0x1f64d",
                "0x1f64d",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f64d",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f64e",
                "0x1f64e",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f64e",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f645",
                "0x1f645",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f645",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f646",
                "0x1f646",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f646",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f481",
                "0x1f481",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f481",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f64b",
                "0x1f64b",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f64b",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9cf",
                "0x1f9cf",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9cf",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f647",
                "0x1f647",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f647",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f926",
                "0x1f926",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f926",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f937",
                "0x1f937",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f937",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x2695",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x2695",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x2695",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f393",
                "0x1f468",
                "0x200d",
                "0x1f393",
                "0x1f469",
                "0x200d",
                "0x1f393",
                "0x1f9d1",
                "0x200d",
                "0x1f3eb",
                "0x1f468",
                "0x200d",
                "0x1f3eb",
                "0x1f469",
                "0x200d",
                "0x1f3eb",
                "0x1f9d1",
                "0x200d",
                "0x2696",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x2696",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x2696",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f33e",
                "0x1f468",
                "0x200d",
                "0x1f33e",
                "0x1f469",
                "0x200d",
                "0x1f33e",
                "0x1f9d1",
                "0x200d",
                "0x1f373",
                "0x1f468",
                "0x200d",
                "0x1f373",
                "0x1f469",
                "0x200d",
                "0x1f373",
                "0x1f9d1",
                "0x200d",
                "0x1f527",
                "0x1f468",
                "0x200d",
                "0x1f527",
                "0x1f469",
                "0x200d",
                "0x1f527",
                "0x1f9d1",
                "0x200d",
                "0x1f3ed",
                "0x1f468",
                "0x200d",
                "0x1f3ed",
                "0x1f469",
                "0x200d",
                "0x1f3ed",
                "0x1f9d1",
                "0x200d",
                "0x1f4bc",
                "0x1f468",
                "0x200d",
                "0x1f4bc",
                "0x1f469",
                "0x200d",
                "0x1f4bc",
                "0x1f9d1",
                "0x200d",
                "0x1f52c",
                "0x1f468",
                "0x200d",
                "0x1f52c",
                "0x1f469",
                "0x200d",
                "0x1f52c",
                "0x1f9d1",
                "0x200d",
                "0x1f4bb",
                "0x1f468",
                "0x200d",
                "0x1f4bb",
                "0x1f469",
                "0x200d",
                "0x1f4bb",
                "0x1f9d1",
                "0x200d",
                "0x1f3a4",
                "0x1f468",
                "0x200d",
                "0x1f3a4",
                "0x1f469",
                "0x200d",
                "0x1f3a4",
                "0x1f9d1",
                "0x200d",
                "0x1f3a8",
                "0x1f468",
                "0x200d",
                "0x1f3a8",
                "0x1f469",
                "0x200d",
                "0x1f3a8",
                "0x1f9d1",
                "0x200d",
                "0x2708",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x2708",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x2708",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f680",
                "0x1f468",
                "0x200d",
                "0x1f680",
                "0x1f469",
                "0x200d",
                "0x1f680",
                "0x1f9d1",
                "0x200d",
                "0x1f692",
                "0x1f468",
                "0x200d",
                "0x1f692",
                "0x1f469",
                "0x200d",
                "0x1f692",
                "0x1f46e",
                "0x1f46e",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f46e",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f575",
                "0x1f575",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f575",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f482",
                "0x1f482",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f482",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f977",
                "0x1f477",
                "0x1f477",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f477",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1fac5",
                "0x1f934",
                "0x1f478",
                "0x1f473",
                "0x1f473",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f473",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f472",
                "0x1f9d5",
                "0x1f935",
                "0x1f935",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f935",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f470",
                "0x1f470",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f470",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f930",
                "0x1fac3",
                "0x1fac4",
                "0x1f931",
                "0x1f469",
                "0x200d",
                "0x1f37c",
                "0x1f468",
                "0x200d",
                "0x1f37c",
                "0x1f9d1",
                "0x200d",
                "0x1f37c",
                "0x1f47c",
                "0x1f385",
                "0x1f936",
                "0x1f9d1",
                "0x200d",
                "0x1f384",
                "0x1f9b8",
                "0x1f9b8",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9b8",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9b9",
                "0x1f9b9",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9b9",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d9",
                "0x1f9d9",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d9",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9da",
                "0x1f9da",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9da",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9db",
                "0x1f9db",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9db",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9dc",
                "0x1f9dc",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9dc",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9dd",
                "0x1f9dd",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9dd",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9de",
                "0x1f9de",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9de",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9df",
                "0x1f9df",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9df",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9cc",
                "0x1f486",
                "0x1f486",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f486",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f487",
                "0x1f487",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f487",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b6",
                "0x1f6b6",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f6b6",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9cd",
                "0x1f9cd",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9cd",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9ce",
                "0x1f9ce",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9ce",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f9af",
                "0x1f9d1",
                "0x200d",
                "0x1f9af",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9af",
                "0x1f468",
                "0x200d",
                "0x1f9af",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x1f9af",
                "0x1f469",
                "0x200d",
                "0x1f9af",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f9bc",
                "0x1f9d1",
                "0x200d",
                "0x1f9bc",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9bc",
                "0x1f468",
                "0x200d",
                "0x1f9bc",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x1f9bc",
                "0x1f469",
                "0x200d",
                "0x1f9bc",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f9d1",
                "0x200d",
                "0x1f9bd",
                "0x1f9d1",
                "0x200d",
                "0x1f9bd",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f468",
                "0x200d",
                "0x1f9bd",
                "0x1f468",
                "0x200d",
                "0x1f9bd",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f469",
                "0x200d",
                "0x1f9bd",
                "0x1f469",
                "0x200d",
                "0x1f9bd",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f3c3",
                "0x1f3c3",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f3c3",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x200d",
                "0x27a1",
                "0xfe0f",
                "0x1f483",
                "0x1f57a",
                "0x1f574",
                "0x1f46f",
                "0x1f46f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f46f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d6",
                "0x1f9d6",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d6",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d7",
                "0x1f9d7",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d7",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93a",
                "0x1f3c7",
                "0x26f7",
                "0x1f3c2",
                "0x1f3cc",
                "0x1f3cc",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3cc",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3c4",
                "0x1f3c4",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3c4",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6a3",
                "0x1f6a3",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6a3",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3ca",
                "0x1f3ca",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3ca",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x26f9",
                "0x26f9",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x26f9",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f3cb",
                "0x1f3cb",
                "0xfe0f",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f3cb",
                "0xfe0f",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b4",
                "0x1f6b4",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6b4",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6b5",
                "0x1f6b5",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f6b5",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f938",
                "0x1f938",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f938",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93c",
                "0x1f93c",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f93c",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93d",
                "0x1f93d",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f93d",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f93e",
                "0x1f93e",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f93e",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f939",
                "0x1f939",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f939",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f9d8",
                "0x1f9d8",
                "0x200d",
                "0x2642",
                "0xfe0f",
                "0x1f9d8",
                "0x200d",
                "0x2640",
                "0xfe0f",
                "0x1f6c0",
                "0x1f6cc",
                "0x1f9d1",
                "0x200d",
                "0x1f91d",
                "0x200d",
                "0x1f9d1",
                "0x1f46d",
                "0x1f46b",
                "0x1f46c",
                "0x1f48f",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f48b",
                "0x200d",
                "0x1f468",
                "0x1f468",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f48b",
                "0x200d",
                "0x1f468",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f48b",
                "0x200d",
                "0x1f469",
                "0x1f491",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f468",
                "0x1f468",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f468",
                "0x1f469",
                "0x200d",
                "0x2764",
                "0xfe0f",
                "0x200d",
                "0x1f469",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f468",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f466",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f466",
                "0x1f469",
                "0x200d",
                "0x1f467",
                "0x200d",
                "0x1f467",
                "0x1f5e3",
                "0x1f464",
                "0x1f465",
                "0x1fac2",
                "0x1f46a",
                "0x1f9d1",
                "0x200d",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x1f9d1",
                "0x200d",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x200d",
                "0x1f9d2",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x1f9d1",
                "0x200d",
                "0x1f9d2",
                "0x200d",
                "0x1f9d2",
                "0x1f463"
            ],
            "animals_and_nature": [
                "0x1f435",
                "0x1f412",
                "0x1f98d",
                "0x1f9a7",
                "0x1f436",
                "0x1f415",
                "0x1f9ae",
                "0x1f415",
                "0x200d",
                "0x1f9ba",
                "0x1f429",
                "0x1f43a",
                "0x1f98a",
                "0x1f99d",
                "0x1f431",
                "0x1f408",
                "0x1f408",
                "0x200d",
                "0x2b1b",
                "0x1f981",
                "0x1f42f",
                "0x1f405",
                "0x1f406",
                "0x1f434",
                "0x1face",
                "0x1facf",
                "0x1f40e",
                "0x1f984",
                "0x1f993",
                "0x1f98c",
                "0x1f9ac",
                "0x1f42e",
                "0x1f402",
                "0x1f403",
                "0x1f404",
                "0x1f437",
                "0x1f416",
                "0x1f417",
                "0x1f43d",
                "0x1f40f",
                "0x1f411",
                "0x1f410",
                "0x1f42a",
                "0x1f42b",
                "0x1f999",
                "0x1f992",
                "0x1f418",
                "0x1f9a3",
                "0x1f98f",
                "0x1f99b",
                "0x1f42d",
                "0x1f401",
                "0x1f400",
                "0x1f439",
                "0x1f430",
                "0x1f407",
                "0x1f43f",
                "0x1f9ab",
                "0x1f994",
                "0x1f987",
                "0x1f43b",
                "0x1f43b",
                "0x200d",
                "0x2744",
                "0xfe0f",
                "0x1f428",
                "0x1f43c",
                "0x1f9a5",
                "0x1f9a6",
                "0x1f9a8",
                "0x1f998",
                "0x1f9a1",
                "0x1f43e",
                "0x1f983",
                "0x1f414",
                "0x1f413",
                "0x1f423",
                "0x1f424",
                "0x1f425",
                "0x1f426",
                "0x1f427",
                "0x1f54a",
                "0x1f985",
                "0x1f986",
                "0x1f9a2",
                "0x1f989",
                "0x1f9a4",
                "0x1fab6",
                "0x1f9a9",
                "0x1f99a",
                "0x1f99c",
                "0x1fabd",
                "0x1f426",
                "0x200d",
                "0x2b1b",
                "0x1fabf",
                "0x1f426",
                "0x200d",
                "0x1f525",
                "0x1f438",
                "0x1f40a",
                "0x1f422",
                "0x1f98e",
                "0x1f40d",
                "0x1f432",
                "0x1f409",
                "0x1f995",
                "0x1f996",
                "0x1f433",
                "0x1f40b",
                "0x1f42c",
                "0x1f9ad",
                "0x1f41f",
                "0x1f420",
                "0x1f421",
                "0x1f988",
                "0x1f419",
                "0x1f41a",
                "0x1fab8",
                "0x1fabc",
                "0x1f40c",
                "0x1f98b",
                "0x1f41b",
                "0x1f41c",
                "0x1f41d",
                "0x1fab2",
                "0x1f41e",
                "0x1f997",
                "0x1fab3",
                "0x1f577",
                "0x1f578",
                "0x1f982",
                "0x1f99f",
                "0x1fab0",
                "0x1fab1",
                "0x1f9a0",
                "0x1f490",
                "0x1f338",
                "0x1f4ae",
                "0x1fab7",
                "0x1f3f5",
                "0x1f339",
                "0x1f940",
                "0x1f33a",
                "0x1f33b",
                "0x1f33c",
                "0x1f337",
                "0x1fabb",
                "0x1f331",
                "0x1fab4",
                "0x1f332",
                "0x1f333",
                "0x1f334",
                "0x1f335",
                "0x1f33e",
                "0x1f33f",
                "0x2618",
                "0x1f340",
                "0x1f341",
                "0x1f342",
                "0x1f343",
                "0x1fab9",
                "0x1faba",
                "0x1f344"
            ],
            "food_and_drink": [
                "0x1f347",
                "0x1f348",
                "0x1f349",
                "0x1f34a",
                "0x1f34b",
                "0x1f34b",
                "0x200d",
                "0x1f7e9",
                "0x1f34c",
                "0x1f34d",
                "0x1f96d",
                "0x1f34e",
                "0x1f34f",
                "0x1f350",
                "0x1f351",
                "0x1f352",
                "0x1f353",
                "0x1fad0",
                "0x1f95d",
                "0x1f345",
                "0x1fad2",
                "0x1f965",
                "0x1f951",
                "0x1f346",
                "0x1f954",
                "0x1f955",
                "0x1f33d",
                "0x1f336",
                "0x1fad1",
                "0x1f952",
                "0x1f96c",
                "0x1f966",
                "0x1f9c4",
                "0x1f9c5",
                "0x1f95c",
                "0x1fad8",
                "0x1f330",
                "0x1fada",
                "0x1fadb",
                "0x1f344",
                "0x200d",
                "0x1f7eb",
                "0x1f35e",
                "0x1f950",
                "0x1f956",
                "0x1fad3",
                "0x1f968",
                "0x1f96f",
                "0x1f95e",
                "0x1f9c7",
                "0x1f9c0",
                "0x1f356",
                "0x1f357",
                "0x1f969",
                "0x1f953",
                "0x1f354",
                "0x1f35f",
                "0x1f355",
                "0x1f32d",
                "0x1f96a",
                "0x1f32e",
                "0x1f32f",
                "0x1fad4",
                "0x1f959",
                "0x1f9c6",
                "0x1f95a",
                "0x1f373",
                "0x1f958",
                "0x1f372",
                "0x1fad5",
                "0x1f963",
                "0x1f957",
                "0x1f37f",
                "0x1f9c8",
                "0x1f9c2",
                "0x1f96b",
                "0x1f371",
                "0x1f358",
                "0x1f359",
                "0x1f35a",
                "0x1f35b",
                "0x1f35c",
                "0x1f35d",
                "0x1f360",
                "0x1f362",
                "0x1f363",
                "0x1f364",
                "0x1f365",
                "0x1f96e",
                "0x1f361",
                "0x1f95f",
                "0x1f960",
                "0x1f961",
                "0x1f980",
                "0x1f99e",
                "0x1f990",
                "0x1f991",
                "0x1f9aa",
                "0x1f366",
                "0x1f367",
                "0x1f368",
                "0x1f369",
                "0x1f36a",
                "0x1f382",
                "0x1f370",
                "0x1f9c1",
                "0x1f967",
                "0x1f36b",
                "0x1f36c",
                "0x1f36d",
                "0x1f36e",
                "0x1f36f",
                "0x1f37c",
                "0x1f95b",
                "0x2615",
                "0x1fad6",
                "0x1f375",
                "0x1f376",
                "0x1f37e",
                "0x1f377",
                "0x1f378",
                "0x1f379",
                "0x1f37a",
                "0x1f37b",
                "0x1f942",
                "0x1f943",
                "0x1fad7",
                "0x1f964",
                "0x1f9cb",
                "0x1f9c3",
                "0x1f9c9",
                "0x1f9ca",
                "0x1f962",
                "0x1f37d",
                "0x1f374",
                "0x1f944",
                "0x1f52a",
                "0x1fad9",
                "0x1f3fa"
            ],
            "travel_and_places": [
                "0x1f30d",
                "0x1f30e",
                "0x1f30f",
                "0x1f310",
                "0x1f5fa",
                "0x1f5fe",
                "0x1f9ed",
                "0x1f3d4",
                "0x26f0",
                "0x1f30b",
                "0x1f5fb",
                "0x1f3d5",
                "0x1f3d6",
                "0x1f3dc",
                "0x1f3dd",
                "0x1f3de",
                "0x1f3df",
                "0x1f3db",
                "0x1f3d7",
                "0x1f9f1",
                "0x1faa8",
                "0x1fab5",
                "0x1f6d6",
                "0x1f3d8",
                "0x1f3da",
                "0x1f3e0",
                "0x1f3e1",
                "0x1f3e2",
                "0x1f3e3",
                "0x1f3e4",
                "0x1f3e5",
                "0x1f3e6",
                "0x1f3e8",
                "0x1f3e9",
                "0x1f3ea",
                "0x1f3eb",
                "0x1f3ec",
                "0x1f3ed",
                "0x1f3ef",
                "0x1f3f0",
                "0x1f492",
                "0x1f5fc",
                "0x1f5fd",
                "0x26ea",
                "0x1f54c",
                "0x1f6d5",
                "0x1f54d",
                "0x26e9",
                "0x1f54b",
                "0x26f2",
                "0x26fa",
                "0x1f301",
                "0x1f303",
                "0x1f3d9",
                "0x1f304",
                "0x1f305",
                "0x1f306",
                "0x1f307",
                "0x1f309",
                "0x2668",
                "0x1f3a0",
                "0x1f6dd",
                "0x1f3a1",
                "0x1f3a2",
                "0x1f488",
                "0x1f3aa",
                "0x1f682",
                "0x1f683",
                "0x1f684",
                "0x1f685",
                "0x1f686",
                "0x1f687",
                "0x1f688",
                "0x1f689",
                "0x1f68a",
                "0x1f69d",
                "0x1f69e",
                "0x1f68b",
                "0x1f68c",
                "0x1f68d",
                "0x1f68e",
                "0x1f690",
                "0x1f691",
                "0x1f692",
                "0x1f693",
                "0x1f694",
                "0x1f695",
                "0x1f696",
                "0x1f697",
                "0x1f698",
                "0x1f699",
                "0x1f6fb",
                "0x1f69a",
                "0x1f69b",
                "0x1f69c",
                "0x1f3ce",
                "0x1f3cd",
                "0x1f6f5",
                "0x1f9bd",
                "0x1f9bc",
                "0x1f6fa",
                "0x1f6b2",
                "0x1f6f4",
                "0x1f6f9",
                "0x1f6fc",
                "0x1f68f",
                "0x1f6e3",
                "0x1f6e4",
                "0x1f6e2",
                "0x26fd",
                "0x1f6de",
                "0x1f6a8",
                "0x1f6a5",
                "0x1f6a6",
                "0x1f6d1",
                "0x1f6a7",
                "0x2693",
                "0x1f6df",
                "0x26f5",
                "0x1f6f6",
                "0x1f6a4",
                "0x1f6f3",
                "0x26f4",
                "0x1f6e5",
                "0x1f6a2",
                "0x2708",
                "0x1f6e9",
                "0x1f6eb",
                "0x1f6ec",
                "0x1fa82",
                "0x1f4ba",
                "0x1f681",
                "0x1f69f",
                "0x1f6a0",
                "0x1f6a1",
                "0x1f6f0",
                "0x1f680",
                "0x1f6f8",
                "0x1f6ce",
                "0x1f9f3",
                "0x231b",
                "0x23f3",
                "0x231a",
                "0x23f0",
                "0x23f1",
                "0x23f2",
                "0x1f570",
                "0x1f55b",
                "0x1f567",
                "0x1f550",
                "0x1f55c",
                "0x1f551",
                "0x1f55d",
                "0x1f552",
                "0x1f55e",
                "0x1f553",
                "0x1f55f",
                "0x1f554",
                "0x1f560",
                "0x1f555",
                "0x1f561",
                "0x1f556",
                "0x1f562",
                "0x1f557",
                "0x1f563",
                "0x1f558",
                "0x1f564",
                "0x1f559",
                "0x1f565",
                "0x1f55a",
                "0x1f566",
                "0x1f311",
                "0x1f312",
                "0x1f313",
                "0x1f314",
                "0x1f315",
                "0x1f316",
                "0x1f317",
                "0x1f318",
                "0x1f319",
                "0x1f31a",
                "0x1f31b",
                "0x1f31c",
                "0x1f321",
                "0x2600",
                "0x1f31d",
                "0x1f31e",
                "0x1fa90",
                "0x2b50",
                "0x1f31f",
                "0x1f320",
                "0x1f30c",
                "0x2601",
                "0x26c5",
                "0x26c8",
                "0x1f324",
                "0x1f325",
                "0x1f326",
                "0x1f327",
                "0x1f328",
                "0x1f329",
                "0x1f32a",
                "0x1f32b",
                "0x1f32c",
                "0x1f300",
                "0x1f308",
                "0x1f302",
                "0x2602",
                "0x2614",
                "0x26f1",
                "0x26a1",
                "0x2744",
                "0x2603",
                "0x26c4",
                "0x2604",
                "0x1f525",
                "0x1f4a7",
                "0x1f30a"
            ],
            "activities": [
                "0x1f383",
                "0x1f384",
                "0x1f386",
                "0x1f387",
                "0x1f9e8",
                "0x2728",
                "0x1f388",
                "0x1f389",
                "0x1f38a",
                "0x1f38b",
                "0x1f38d",
                "0x1f38e",
                "0x1f38f",
                "0x1f390",
                "0x1f391",
                "0x1f9e7",
                "0x1f380",
                "0x1f381",
                "0x1f397",
                "0x1f39f",
                "0x1f3ab",
                "0x1f396",
                "0x1f3c6",
                "0x1f3c5",
                "0x1f947",
                "0x1f948",
                "0x1f949",
                "0x26bd",
                "0x26be",
                "0x1f94e",
                "0x1f3c0",
                "0x1f3d0",
                "0x1f3c8",
                "0x1f3c9",
                "0x1f3be",
                "0x1f94f",
                "0x1f3b3",
                "0x1f3cf",
                "0x1f3d1",
                "0x1f3d2",
                "0x1f94d",
                "0x1f3d3",
                "0x1f3f8",
                "0x1f94a",
                "0x1f94b",
                "0x1f945",
                "0x26f3",
                "0x26f8",
                "0x1f3a3",
                "0x1f93f",
                "0x1f3bd",
                "0x1f3bf",
                "0x1f6f7",
                "0x1f94c",
                "0x1f3af",
                "0x1fa80",
                "0x1fa81",
                "0x1f52b",
                "0x1f3b1",
                "0x1f52e",
                "0x1fa84",
                "0x1f3ae",
                "0x1f579",
                "0x1f3b0",
                "0x1f3b2",
                "0x1f9e9",
                "0x1f9f8",
                "0x1fa85",
                "0x1faa9",
                "0x1fa86",
                "0x2660",
                "0x2665",
                "0x2666",
                "0x2663",
                "0x265f",
                "0x1f0cf",
                "0x1f004",
                "0x1f3b4",
                "0x1f3ad",
                "0x1f5bc",
                "0x1f3a8",
                "0x1f9f5",
                "0x1faa1",
                "0x1f9f6",
                "0x1faa2"
            ],
            "objects": [
                "0x1f453",
                "0x1f576",
                "0x1f97d",
                "0x1f97c",
                "0x1f9ba",
                "0x1f454",
                "0x1f455",
                "0x1f456",
                "0x1f9e3",
                "0x1f9e4",
                "0x1f9e5",
                "0x1f9e6",
                "0x1f457",
                "0x1f458",
                "0x1f97b",
                "0x1fa71",
                "0x1fa72",
                "0x1fa73",
                "0x1f459",
                "0x1f45a",
                "0x1faad",
                "0x1f45b",
                "0x1f45c",
                "0x1f45d",
                "0x1f6cd",
                "0x1f392",
                "0x1fa74",
                "0x1f45e",
                "0x1f45f",
                "0x1f97e",
                "0x1f97f",
                "0x1f460",
                "0x1f461",
                "0x1fa70",
                "0x1f462",
                "0x1faae",
                "0x1f451",
                "0x1f452",
                "0x1f3a9",
                "0x1f393",
                "0x1f9e2",
                "0x1fa96",
                "0x26d1",
                "0x1f4ff",
                "0x1f484",
                "0x1f48d",
                "0x1f48e",
                "0x1f507",
                "0x1f508",
                "0x1f509",
                "0x1f50a",
                "0x1f4e2",
                "0x1f4e3",
                "0x1f4ef",
                "0x1f514",
                "0x1f515",
                "0x1f3bc",
                "0x1f3b5",
                "0x1f3b6",
                "0x1f399",
                "0x1f39a",
                "0x1f39b",
                "0x1f3a4",
                "0x1f3a7",
                "0x1f4fb",
                "0x1f3b7",
                "0x1fa97",
                "0x1f3b8",
                "0x1f3b9",
                "0x1f3ba",
                "0x1f3bb",
                "0x1fa95",
                "0x1f941",
                "0x1fa98",
                "0x1fa87",
                "0x1fa88",
                "0x1f4f1",
                "0x1f4f2",
                "0x260e",
                "0x1f4de",
                "0x1f4df",
                "0x1f4e0",
                "0x1f50b",
                "0x1faab",
                "0x1f50c",
                "0x1f4bb",
                "0x1f5a5",
                "0x1f5a8",
                "0x2328",
                "0x1f5b1",
                "0x1f5b2",
                "0x1f4bd",
                "0x1f4be",
                "0x1f4bf",
                "0x1f4c0",
                "0x1f9ee",
                "0x1f3a5",
                "0x1f39e",
                "0x1f4fd",
                "0x1f3ac",
                "0x1f4fa",
                "0x1f4f7",
                "0x1f4f8",
                "0x1f4f9",
                "0x1f4fc",
                "0x1f50d",
                "0x1f50e",
                "0x1f56f",
                "0x1f4a1",
                "0x1f526",
                "0x1f3ee",
                "0x1fa94",
                "0x1f4d4",
                "0x1f4d5",
                "0x1f4d6",
                "0x1f4d7",
                "0x1f4d8",
                "0x1f4d9",
                "0x1f4da",
                "0x1f4d3",
                "0x1f4d2",
                "0x1f4c3",
                "0x1f4dc",
                "0x1f4c4",
                "0x1f4f0",
                "0x1f5de",
                "0x1f4d1",
                "0x1f516",
                "0x1f3f7",
                "0x1f4b0",
                "0x1fa99",
                "0x1f4b4",
                "0x1f4b5",
                "0x1f4b6",
                "0x1f4b7",
                "0x1f4b8",
                "0x1f4b3",
                "0x1f9fe",
                "0x1f4b9",
                "0x2709",
                "0x1f4e7",
                "0x1f4e8",
                "0x1f4e9",
                "0x1f4e4",
                "0x1f4e5",
                "0x1f4e6",
                "0x1f4eb",
                "0x1f4ea",
                "0x1f4ec",
                "0x1f4ed",
                "0x1f4ee",
                "0x1f5f3",
                "0x270f",
                "0x2712",
                "0x1f58b",
                "0x1f58a",
                "0x1f58c",
                "0x1f58d",
                "0x1f4dd",
                "0x1f4bc",
                "0x1f4c1",
                "0x1f4c2",
                "0x1f5c2",
                "0x1f4c5",
                "0x1f4c6",
                "0x1f5d2",
                "0x1f5d3",
                "0x1f4c7",
                "0x1f4c8",
                "0x1f4c9",
                "0x1f4ca",
                "0x1f4cb",
                "0x1f4cc",
                "0x1f4cd",
                "0x1f4ce",
                "0x1f587",
                "0x1f4cf",
                "0x1f4d0",
                "0x2702",
                "0x1f5c3",
                "0x1f5c4",
                "0x1f5d1",
                "0x1f512",
                "0x1f513",
                "0x1f50f",
                "0x1f510",
                "0x1f511",
                "0x1f5dd",
                "0x1f528",
                "0x1fa93",
                "0x26cf",
                "0x2692",
                "0x1f6e0",
                "0x1f5e1",
                "0x2694",
                "0x1f4a3",
                "0x1fa83",
                "0x1f3f9",
                "0x1f6e1",
                "0x1fa9a",
                "0x1f527",
                "0x1fa9b",
                "0x1f529",
                "0x2699",
                "0x1f5dc",
                "0x2696",
                "0x1f9af",
                "0x1f517",
                "0x26d3",
                "0xfe0f",
                "0x200d",
                "0x1f4a5",
                "0x26d3",
                "0x1fa9d",
                "0x1f9f0",
                "0x1f9f2",
                "0x1fa9c",
                "0x2697",
                "0x1f9ea",
                "0x1f9eb",
                "0x1f9ec",
                "0x1f52c",
                "0x1f52d",
                "0x1f4e1",
                "0x1f489",
                "0x1fa78",
                "0x1f48a",
                "0x1fa79",
                "0x1fa7c",
                "0x1fa7a",
                "0x1fa7b",
                "0x1f6aa",
                "0x1f6d7",
                "0x1fa9e",
                "0x1fa9f",
                "0x1f6cf",
                "0x1f6cb",
                "0x1fa91",
                "0x1f6bd",
                "0x1faa0",
                "0x1f6bf",
                "0x1f6c1",
                "0x1faa4",
                "0x1fa92",
                "0x1f9f4",
                "0x1f9f7",
                "0x1f9f9",
                "0x1f9fa",
                "0x1f9fb",
                "0x1faa3",
                "0x1f9fc",
                "0x1fae7",
                "0x1faa5",
                "0x1f9fd",
                "0x1f9ef",
                "0x1f6d2",
                "0x1f6ac",
                "0x26b0",
                "0x1faa6",
                "0x26b1",
                "0x1f9ff",
                "0x1faac",
                "0x1f5ff",
                "0x1faa7",
                "0x1faaa"
            ],
            "symbols": [
                "0x1f3e7",
                "0x1f6ae",
                "0x1f6b0",
                "0x267f",
                "0x1f6b9",
                "0x1f6ba",
                "0x1f6bb",
                "0x1f6bc",
                "0x1f6be",
                "0x1f6c2",
                "0x1f6c3",
                "0x1f6c4",
                "0x1f6c5",
                "0x26a0",
                "0x1f6b8",
                "0x26d4",
                "0x1f6ab",
                "0x1f6b3",
                "0x1f6ad",
                "0x1f6af",
                "0x1f6b1",
                "0x1f6b7",
                "0x1f4f5",
                "0x1f51e",
                "0x2622",
                "0x2623",
                "0x2b06",
                "0x2197",
                "0x27a1",
                "0x2198",
                "0x2b07",
                "0x2199",
                "0x2b05",
                "0x2196",
                "0x2195",
                "0x2194",
                "0x21a9",
                "0x21aa",
                "0x2934",
                "0x2935",
                "0x1f503",
                "0x1f504",
                "0x1f519",
                "0x1f51a",
                "0x1f51b",
                "0x1f51c",
                "0x1f51d",
                "0x1f6d0",
                "0x269b",
                "0x1f549",
                "0x2721",
                "0x2638",
                "0x262f",
                "0x271d",
                "0x2626",
                "0x262a",
                "0x262e",
                "0x1f54e",
                "0x1f52f",
                "0x1faaf",
                "0x2648",
                "0x2649",
                "0x264a",
                "0x264b",
                "0x264c",
                "0x264d",
                "0x264e",
                "0x264f",
                "0x2650",
                "0x2651",
                "0x2652",
                "0x2653",
                "0x26ce",
                "0x1f500",
                "0x1f501",
                "0x1f502",
                "0x25b6",
                "0x23e9",
                "0x23ed",
                "0x23ef",
                "0x25c0",
                "0x23ea",
                "0x23ee",
                "0x1f53c",
                "0x23eb",
                "0x1f53d",
                "0x23ec",
                "0x23f8",
                "0x23f9",
                "0x23fa",
                "0x23cf",
                "0x1f3a6",
                "0x1f505",
                "0x1f506",
                "0x1f4f6",
                "0x1f6dc",
                "0x1f4f3",
                "0x1f4f4",
                "0x2640",
                "0x2642",
                "0x26a7",
                "0x2716",
                "0x2795",
                "0x2796",
                "0x2797",
                "0x1f7f0",
                "0x267e",
                "0x203c",
                "0x2049",
                "0x2753",
                "0x2754",
                "0x2755",
                "0x2757",
                "0x3030",
                "0x1f4b1",
                "0x1f4b2",
                "0x2695",
                "0x267b",
                "0x269c",
                "0x1f531",
                "0x1f4db",
                "0x1f530",
                "0x2b55",
                "0x2705",
                "0x2611",
                "0x2714",
                "0x274c",
                "0x274e",
                "0x27b0",
                "0x27bf",
                "0x303d",
                "0x2733",
                "0x2734",
                "0x2747",
                "0x00a9",
                "0x00ae",
                "0x2122",
                "0x0023",
                "0xfe0f",
                "0x20e3",
                "0x002a",
                "0xfe0f",
                "0x20e3",
                "0x0030",
                "0xfe0f",
                "0x20e3",
                "0x0031",
                "0xfe0f",
                "0x20e3",
                "0x0032",
                "0xfe0f",
                "0x20e3",
                "0x0033",
                "0xfe0f",
                "0x20e3",
                "0x0034",
                "0xfe0f",
                "0x20e3",
                "0x0035",
                "0xfe0f",
                "0x20e3",
                "0x0036",
                "0xfe0f",
                "0x20e3",
                "0x0037",
                "0xfe0f",
                "0x20e3",
                "0x0038",
                "0xfe0f",
                "0x20e3",
                "0x0039",
                "0xfe0f",
                "0x20e3",
                "0x1f51f",
                "0x1f520",
                "0x1f521",
                "0x1f522",
                "0x1f523",
                "0x1f524",
                "0x1f170",
                "0x1f18e",
                "0x1f171",
                "0x1f191",
                "0x1f192",
                "0x1f193",
                "0x2139",
                "0x1f194",
                "0x24c2",
                "0x1f195",
                "0x1f196",
                "0x1f17e",
                "0x1f197",
                "0x1f17f",
                "0x1f198",
                "0x1f199",
                "0x1f19a",
                "0x1f201",
                "0x1f202",
                "0x1f237",
                "0x1f236",
                "0x1f22f",
                "0x1f250",
                "0x1f239",
                "0x1f21a",
                "0x1f232",
                "0x1f251",
                "0x1f238",
                "0x1f234",
                "0x1f233",
                "0x3297",
                "0x3299",
                "0x1f23a",
                "0x1f235",
                "0x1f534",
                "0x1f7e0",
                "0x1f7e1",
                "0x1f7e2",
                "0x1f535",
                "0x1f7e3",
                "0x1f7e4",
                "0x26ab",
                "0x26aa",
                "0x1f7e5",
                "0x1f7e7",
                "0x1f7e8",
                "0x1f7e9",
                "0x1f7e6",
                "0x1f7ea",
                "0x1f7eb",
                "0x2b1b",
                "0x2b1c",
                "0x25fc",
                "0x25fb",
                "0x25fe",
                "0x25fd",
                "0x25aa",
                "0x25ab",
                "0x1f536",
                "0x1f537",
                "0x1f538",
                "0x1f539",
                "0x1f53a",
                "0x1f53b",
                "0x1f4a0",
                "0x1f518",
                "0x1f533",
                "0x1f532"
            ],
            "flags": [
                "0x1f3c1",
                "0x1f6a9",
                "0x1f38c",
                "0x1f3f4",
                "0x1f3f3",
                "0x1f3f3",
                "0xfe0f",
                "0x200d",
                "0x1f308",
                "0x1f3f3",
                "0xfe0f",
                "0x200d",
                "0x26a7",
                "0xfe0f",
                "0x1f3f4",
                "0x200d",
                "0x2620",
                "0xfe0f",
                "0x1f1e6",
                "0x1f1e8",
                "0x1f1e6",
                "0x1f1e9",
                "0x1f1e6",
                "0x1f1ea",
                "0x1f1e6",
                "0x1f1eb",
                "0x1f1e6",
                "0x1f1ec",
                "0x1f1e6",
                "0x1f1ee",
                "0x1f1e6",
                "0x1f1f1",
                "0x1f1e6",
                "0x1f1f2",
                "0x1f1e6",
                "0x1f1f4",
                "0x1f1e6",
                "0x1f1f6",
                "0x1f1e6",
                "0x1f1f7",
                "0x1f1e6",
                "0x1f1f8",
                "0x1f1e6",
                "0x1f1f9",
                "0x1f1e6",
                "0x1f1fa",
                "0x1f1e6",
                "0x1f1fc",
                "0x1f1e6",
                "0x1f1fd",
                "0x1f1e6",
                "0x1f1ff",
                "0x1f1e7",
                "0x1f1e6",
                "0x1f1e7",
                "0x1f1e7",
                "0x1f1e7",
                "0x1f1e9",
                "0x1f1e7",
                "0x1f1ea",
                "0x1f1e7",
                "0x1f1eb",
                "0x1f1e7",
                "0x1f1ec",
                "0x1f1e7",
                "0x1f1ed",
                "0x1f1e7",
                "0x1f1ee",
                "0x1f1e7",
                "0x1f1ef",
                "0x1f1e7",
                "0x1f1f1",
                "0x1f1e7",
                "0x1f1f2",
                "0x1f1e7",
                "0x1f1f3",
                "0x1f1e7",
                "0x1f1f4",
                "0x1f1e7",
                "0x1f1f6",
                "0x1f1e7",
                "0x1f1f7",
                "0x1f1e7",
                "0x1f1f8",
                "0x1f1e7",
                "0x1f1f9",
                "0x1f1e7",
                "0x1f1fb",
                "0x1f1e7",
                "0x1f1fc",
                "0x1f1e7",
                "0x1f1fe",
                "0x1f1e7",
                "0x1f1ff",
                "0x1f1e8",
                "0x1f1e6",
                "0x1f1e8",
                "0x1f1e8",
                "0x1f1e8",
                "0x1f1e9",
                "0x1f1e8",
                "0x1f1eb",
                "0x1f1e8",
                "0x1f1ec",
                "0x1f1e8",
                "0x1f1ed",
                "0x1f1e8",
                "0x1f1ee",
                "0x1f1e8",
                "0x1f1f0",
                "0x1f1e8",
                "0x1f1f1",
                "0x1f1e8",
                "0x1f1f2",
                "0x1f1e8",
                "0x1f1f3",
                "0x1f1e8",
                "0x1f1f4",
                "0x1f1e8",
                "0x1f1f5",
                "0x1f1e8",
                "0x1f1f7",
                "0x1f1e8",
                "0x1f1fa",
                "0x1f1e8",
                "0x1f1fb",
                "0x1f1e8",
                "0x1f1fc",
                "0x1f1e8",
                "0x1f1fd",
                "0x1f1e8",
                "0x1f1fe",
                "0x1f1e8",
                "0x1f1ff",
                "0x1f1e9",
                "0x1f1ea",
                "0x1f1e9",
                "0x1f1ec",
                "0x1f1e9",
                "0x1f1ef",
                "0x1f1e9",
                "0x1f1f0",
                "0x1f1e9",
                "0x1f1f2",
                "0x1f1e9",
                "0x1f1f4",
                "0x1f1e9",
                "0x1f1ff",
                "0x1f1ea",
                "0x1f1e6",
                "0x1f1ea",
                "0x1f1e8",
                "0x1f1ea",
                "0x1f1ea",
                "0x1f1ea",
                "0x1f1ec",
                "0x1f1ea",
                "0x1f1ed",
                "0x1f1ea",
                "0x1f1f7",
                "0x1f1ea",
                "0x1f1f8",
                "0x1f1ea",
                "0x1f1f9",
                "0x1f1ea",
                "0x1f1fa",
                "0x1f1eb",
                "0x1f1ee",
                "0x1f1eb",
                "0x1f1ef",
                "0x1f1eb",
                "0x1f1f0",
                "0x1f1eb",
                "0x1f1f2",
                "0x1f1eb",
                "0x1f1f4",
                "0x1f1eb",
                "0x1f1f7",
                "0x1f1ec",
                "0x1f1e6",
                "0x1f1ec",
                "0x1f1e7",
                "0x1f1ec",
                "0x1f1e9",
                "0x1f1ec",
                "0x1f1ea",
                "0x1f1ec",
                "0x1f1eb",
                "0x1f1ec",
                "0x1f1ec",
                "0x1f1ec",
                "0x1f1ed",
                "0x1f1ec",
                "0x1f1ee",
                "0x1f1ec",
                "0x1f1f1",
                "0x1f1ec",
                "0x1f1f2",
                "0x1f1ec",
                "0x1f1f3",
                "0x1f1ec",
                "0x1f1f5",
                "0x1f1ec",
                "0x1f1f6",
                "0x1f1ec",
                "0x1f1f7",
                "0x1f1ec",
                "0x1f1f8",
                "0x1f1ec",
                "0x1f1f9",
                "0x1f1ec",
                "0x1f1fa",
                "0x1f1ec",
                "0x1f1fc",
                "0x1f1ec",
                "0x1f1fe",
                "0x1f1ed",
                "0x1f1f0",
                "0x1f1ed",
                "0x1f1f2",
                "0x1f1ed",
                "0x1f1f3",
                "0x1f1ed",
                "0x1f1f7",
                "0x1f1ed",
                "0x1f1f9",
                "0x1f1ed",
                "0x1f1fa",
                "0x1f1ee",
                "0x1f1e8",
                "0x1f1ee",
                "0x1f1e9",
                "0x1f1ee",
                "0x1f1ea",
                "0x1f1ee",
                "0x1f1f1",
                "0x1f1ee",
                "0x1f1f2",
                "0x1f1ee",
                "0x1f1f3",
                "0x1f1ee",
                "0x1f1f4",
                "0x1f1ee",
                "0x1f1f6",
                "0x1f1ee",
                "0x1f1f7",
                "0x1f1ee",
                "0x1f1f8",
                "0x1f1ee",
                "0x1f1f9",
                "0x1f1ef",
                "0x1f1ea",
                "0x1f1ef",
                "0x1f1f2",
                "0x1f1ef",
                "0x1f1f4",
                "0x1f1ef",
                "0x1f1f5",
                "0x1f1f0",
                "0x1f1ea",
                "0x1f1f0",
                "0x1f1ec",
                "0x1f1f0",
                "0x1f1ed",
                "0x1f1f0",
                "0x1f1ee",
                "0x1f1f0",
                "0x1f1f2",
                "0x1f1f0",
                "0x1f1f3",
                "0x1f1f0",
                "0x1f1f5",
                "0x1f1f0",
                "0x1f1f7",
                "0x1f1f0",
                "0x1f1fc",
                "0x1f1f0",
                "0x1f1fe",
                "0x1f1f0",
                "0x1f1ff",
                "0x1f1f1",
                "0x1f1e6",
                "0x1f1f1",
                "0x1f1e7",
                "0x1f1f1",
                "0x1f1e8",
                "0x1f1f1",
                "0x1f1ee",
                "0x1f1f1",
                "0x1f1f0",
                "0x1f1f1",
                "0x1f1f7",
                "0x1f1f1",
                "0x1f1f8",
                "0x1f1f1",
                "0x1f1f9",
                "0x1f1f1",
                "0x1f1fa",
                "0x1f1f1",
                "0x1f1fb",
                "0x1f1f1",
                "0x1f1fe",
                "0x1f1f2",
                "0x1f1e6",
                "0x1f1f2",
                "0x1f1e8",
                "0x1f1f2",
                "0x1f1e9",
                "0x1f1f2",
                "0x1f1ea",
                "0x1f1f2",
                "0x1f1eb",
                "0x1f1f2",
                "0x1f1ec",
                "0x1f1f2",
                "0x1f1ed",
                "0x1f1f2",
                "0x1f1f0",
                "0x1f1f2",
                "0x1f1f1",
                "0x1f1f2",
                "0x1f1f2",
                "0x1f1f2",
                "0x1f1f3",
                "0x1f1f2",
                "0x1f1f4",
                "0x1f1f2",
                "0x1f1f5",
                "0x1f1f2",
                "0x1f1f6",
                "0x1f1f2",
                "0x1f1f7",
                "0x1f1f2",
                "0x1f1f8",
                "0x1f1f2",
                "0x1f1f9",
                "0x1f1f2",
                "0x1f1fa",
                "0x1f1f2",
                "0x1f1fb",
                "0x1f1f2",
                "0x1f1fc",
                "0x1f1f2",
                "0x1f1fd",
                "0x1f1f2",
                "0x1f1fe",
                "0x1f1f2",
                "0x1f1ff",
                "0x1f1f3",
                "0x1f1e6",
                "0x1f1f3",
                "0x1f1e8",
                "0x1f1f3",
                "0x1f1ea",
                "0x1f1f3",
                "0x1f1eb",
                "0x1f1f3",
                "0x1f1ec",
                "0x1f1f3",
                "0x1f1ee",
                "0x1f1f3",
                "0x1f1f1",
                "0x1f1f3",
                "0x1f1f4",
                "0x1f1f3",
                "0x1f1f5",
                "0x1f1f3",
                "0x1f1f7",
                "0x1f1f3",
                "0x1f1fa",
                "0x1f1f3",
                "0x1f1ff",
                "0x1f1f4",
                "0x1f1f2",
                "0x1f1f5",
                "0x1f1e6",
                "0x1f1f5",
                "0x1f1ea",
                "0x1f1f5",
                "0x1f1eb",
                "0x1f1f5",
                "0x1f1ec",
                "0x1f1f5",
                "0x1f1ed",
                "0x1f1f5",
                "0x1f1f0",
                "0x1f1f5",
                "0x1f1f1",
                "0x1f1f5",
                "0x1f1f2",
                "0x1f1f5",
                "0x1f1f3",
                "0x1f1f5",
                "0x1f1f7",
                "0x1f1f5",
                "0x1f1f8",
                "0x1f1f5",
                "0x1f1f9",
                "0x1f1f5",
                "0x1f1fc",
                "0x1f1f5",
                "0x1f1fe",
                "0x1f1f6",
                "0x1f1e6",
                "0x1f1f7",
                "0x1f1ea",
                "0x1f1f7",
                "0x1f1f4",
                "0x1f1f7",
                "0x1f1f8",
                "0x1f1f7",
                "0x1f1fa",
                "0x1f1f7",
                "0x1f1fc",
                "0x1f1f8",
                "0x1f1e6",
                "0x1f1f8",
                "0x1f1e7",
                "0x1f1f8",
                "0x1f1e8",
                "0x1f1f8",
                "0x1f1e9",
                "0x1f1f8",
                "0x1f1ea",
                "0x1f1f8",
                "0x1f1ec",
                "0x1f1f8",
                "0x1f1ed",
                "0x1f1f8",
                "0x1f1ee",
                "0x1f1f8",
                "0x1f1ef",
                "0x1f1f8",
                "0x1f1f0",
                "0x1f1f8",
                "0x1f1f1",
                "0x1f1f8",
                "0x1f1f2",
                "0x1f1f8",
                "0x1f1f3",
                "0x1f1f8",
                "0x1f1f4",
                "0x1f1f8",
                "0x1f1f7",
                "0x1f1f8",
                "0x1f1f8",
                "0x1f1f8",
                "0x1f1f9",
                "0x1f1f8",
                "0x1f1fb",
                "0x1f1f8",
                "0x1f1fd",
                "0x1f1f8",
                "0x1f1fe",
                "0x1f1f8",
                "0x1f1ff",
                "0x1f1f9",
                "0x1f1e6",
                "0x1f1f9",
                "0x1f1e8",
                "0x1f1f9",
                "0x1f1e9",
                "0x1f1f9",
                "0x1f1eb",
                "0x1f1f9",
                "0x1f1ec",
                "0x1f1f9",
                "0x1f1ed",
                "0x1f1f9",
                "0x1f1ef",
                "0x1f1f9",
                "0x1f1f0",
                "0x1f1f9",
                "0x1f1f1",
                "0x1f1f9",
                "0x1f1f2",
                "0x1f1f9",
                "0x1f1f3",
                "0x1f1f9",
                "0x1f1f4",
                "0x1f1f9",
                "0x1f1f7",
                "0x1f1f9",
                "0x1f1f9",
                "0x1f1f9",
                "0x1f1fb",
                "0x1f1f9",
                "0x1f1fc",
                "0x1f1f9",
                "0x1f1ff",
                "0x1f1fa",
                "0x1f1e6",
                "0x1f1fa",
                "0x1f1ec",
                "0x1f1fa",
                "0x1f1f2",
                "0x1f1fa",
                "0x1f1f3",
                "0x1f1fa",
                "0x1f1f8",
                "0x1f1fa",
                "0x1f1fe",
                "0x1f1fa",
                "0x1f1ff",
                "0x1f1fb",
                "0x1f1e6",
                "0x1f1fb",
                "0x1f1e8",
                "0x1f1fb",
                "0x1f1ea",
                "0x1f1fb",
                "0x1f1ec",
                "0x1f1fb",
                "0x1f1ee",
                "0x1f1fb",
                "0x1f1f3",
                "0x1f1fb",
                "0x1f1fa",
                "0x1f1fc",
                "0x1f1eb",
                "0x1f1fc",
                "0x1f1f8",
                "0x1f1fd",
                "0x1f1f0",
                "0x1f1fe",
                "0x1f1ea",
                "0x1f1fe",
                "0x1f1f9",
                "0x1f1ff",
                "0x1f1e6",
                "0x1f1ff",
                "0x1f1f2",
                "0x1f1ff",
                "0x1f1fc",
                "0x1f3f4",
                "0xe0067",
                "0xe0062",
                "0xe0065",
                "0xe006e",
                "0xe0067",
                "0xe007f",
                "0x1f3f4",
                "0xe0067",
                "0xe0062",
                "0xe0073",
                "0xe0063",
                "0xe0074",
                "0xe007f",
                "0x1f3f4",
                "0xe0067",
                "0xe0062",
                "0xe0077",
                "0xe006c",
                "0xe0073",
                "0xe007f"
            ]
        }
    };
    var o_hasOwnProperty = Object.prototype.hasOwnProperty;
    var o_keys = Object.keys || function(obj) {
        var result = [];
        for(var key in obj)if (o_hasOwnProperty.call(obj, key)) result.push(key);
        return result;
    };
    function _copyObject(source, target) {
        var keys = o_keys(source);
        var key;
        for(var i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            target[key] = source[key] || target[key];
        }
    }
    function _copyArray(source, target) {
        for(var i = 0, l = source.length; i < l; i++)target[i] = source[i];
    }
    function copyObject(source, _target) {
        var isArray = Array.isArray(source);
        var target = _target || (isArray ? new Array(source.length) : {});
        if (isArray) _copyArray(source, target);
        else _copyObject(source, target);
        return target;
    }
    /** Get the data based on key**/ Chance.prototype.get = function(name) {
        return copyObject(data[name]);
    };
    // Mac Address
    Chance.prototype.mac_address = function(options) {
        // typically mac addresses are separated by ":"
        // however they can also be separated by "-"
        // the network variant uses a dot every fourth byte
        options = initOptions(options);
        if (!options.separator) options.separator = options.networkVersion ? "." : ":";
        var mac_pool = "ABCDEF1234567890", mac = "";
        if (!options.networkVersion) mac = this.n(this.string, 6, {
            pool: mac_pool,
            length: 2
        }).join(options.separator);
        else mac = this.n(this.string, 3, {
            pool: mac_pool,
            length: 4
        }).join(options.separator);
        return mac;
    };
    Chance.prototype.normal = function(options) {
        options = initOptions(options, {
            mean: 0,
            dev: 1,
            pool: []
        });
        testRange(options.pool.constructor !== Array, "Chance: The pool option must be a valid array.");
        testRange(typeof options.mean !== 'number', "Chance: Mean (mean) must be a number");
        testRange(typeof options.dev !== 'number', "Chance: Standard deviation (dev) must be a number");
        // If a pool has been passed, then we are returning an item from that pool,
        // using the normal distribution settings that were passed in
        if (options.pool.length > 0) return this.normal_pool(options);
        // The Marsaglia Polar method
        var s, u, v, norm, mean = options.mean, dev = options.dev;
        do {
            // U and V are from the uniform distribution on (-1, 1)
            u = this.random() * 2 - 1;
            v = this.random() * 2 - 1;
            s = u * u + v * v;
        }while (s >= 1);
        // Compute the standard normal variate
        norm = u * Math.sqrt(-2 * Math.log(s) / s);
        // Shape and scale
        return dev * norm + mean;
    };
    Chance.prototype.normal_pool = function(options) {
        var performanceCounter = 0;
        do {
            var idx = Math.round(this.normal({
                mean: options.mean,
                dev: options.dev
            }));
            if (idx < options.pool.length && idx >= 0) return options.pool[idx];
            else performanceCounter++;
        }while (performanceCounter < 100);
        throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
    };
    Chance.prototype.radio = function(options) {
        // Initial Letter (Typically Designated by Side of Mississippi River)
        options = initOptions(options, {
            side: "?"
        });
        var fl = "";
        switch(options.side.toLowerCase()){
            case "east":
            case "e":
                fl = "W";
                break;
            case "west":
            case "w":
                fl = "K";
                break;
            default:
                fl = this.character({
                    pool: "KW"
                });
                break;
        }
        return fl + this.character({
            alpha: true,
            casing: "upper"
        }) + this.character({
            alpha: true,
            casing: "upper"
        }) + this.character({
            alpha: true,
            casing: "upper"
        });
    };
    // Set the data as key and data or the data map
    Chance.prototype.set = function(name, values) {
        if (typeof name === "string") data[name] = values;
        else data = copyObject(name, data);
    };
    Chance.prototype.tv = function(options) {
        return this.radio(options);
    };
    // ID number for Brazil companies
    Chance.prototype.cnpj = function() {
        var n = this.n(this.natural, 8, {
            max: 9
        });
        var d1 = 2 + n[7] * 6 + n[6] * 7 + n[5] * 8 + n[4] * 9 + n[3] * 2 + n[2] * 3 + n[1] * 4 + n[0] * 5;
        d1 = 11 - d1 % 11;
        if (d1 >= 10) d1 = 0;
        var d2 = d1 * 2 + 3 + n[7] * 7 + n[6] * 8 + n[5] * 9 + n[4] * 2 + n[3] * 3 + n[2] * 4 + n[1] * 5 + n[0] * 6;
        d2 = 11 - d2 % 11;
        if (d2 >= 10) d2 = 0;
        return '' + n[0] + n[1] + '.' + n[2] + n[3] + n[4] + '.' + n[5] + n[6] + n[7] + '/0001-' + d1 + d2;
    };
    Chance.prototype.emotion = function() {
        return this.pick(this.get("emotions"));
    };
    // -- End Miscellaneous --
    Chance.prototype.mersenne_twister = function(seed) {
        return new MersenneTwister(seed);
    };
    Chance.prototype.blueimp_md5 = function() {
        return new BlueImpMD5();
    };
    // Mersenne Twister from https://gist.github.com/banksean/300494
    /*
       A C-program for MT19937, with initialization improved 2002/1/26.
       Coded by Takuji Nishimura and Makoto Matsumoto.

       Before using, initialize the state by using init_genrand(seed)
       or init_by_array(init_key, key_length).

       Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
       All rights reserved.

       Redistribution and use in source and binary forms, with or without
       modification, are permitted provided that the following conditions
       are met:

       1. Redistributions of source code must retain the above copyright
       notice, this list of conditions and the following disclaimer.

       2. Redistributions in binary form must reproduce the above copyright
       notice, this list of conditions and the following disclaimer in the
       documentation and/or other materials provided with the distribution.

       3. The names of its contributors may not be used to endorse or promote
       products derived from this software without specific prior written
       permission.

       THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
       "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
       LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
       A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
       CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
       EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
       PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
       PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
       LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
       NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
       SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


       Any feedback is very welcome.
       http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
       email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
     */ var MersenneTwister = function(seed) {
        if (seed === undefined) // kept random number same size as time used previously to ensure no unexpected results downstream
        seed = Math.floor(Math.random() * Math.pow(10, 13));
        /* Period parameters */ this.N = 624;
        this.M = 397;
        this.MATRIX_A = 0x9908b0df; /* constant vector a */ 
        this.UPPER_MASK = 0x80000000; /* most significant w-r bits */ 
        this.LOWER_MASK = 0x7fffffff; /* least significant r bits */ 
        this.mt = new Array(this.N); /* the array for the state vector */ 
        this.mti = this.N + 1; /* mti==N + 1 means mt[N] is not initialized */ 
        this.init_genrand(seed);
    };
    /* initializes mt[N] with a seed */ MersenneTwister.prototype.init_genrand = function(s) {
        this.mt[0] = s >>> 0;
        for(this.mti = 1; this.mti < this.N; this.mti++){
            s = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
            this.mt[this.mti] = (((s & 0xffff0000) >>> 16) * 1812433253 << 16) + (s & 0x0000ffff) * 1812433253 + this.mti;
            /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */ /* In the previous versions, MSBs of the seed affect   */ /* only MSBs of the array mt[].                        */ /* 2002/01/09 modified by Makoto Matsumoto             */ this.mt[this.mti] >>>= 0;
        /* for >32 bit machines */ }
    };
    /* initialize by an array with array-length */ /* init_key is the array for initializing keys */ /* key_length is its length */ /* slight change for C++, 2004/2/26 */ MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
        var i = 1, j = 0, k, s;
        this.init_genrand(19650218);
        k = this.N > key_length ? this.N : key_length;
        for(; k; k--){
            s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
            this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1664525 << 16) + (s & 0x0000ffff) * 1664525) + init_key[j] + j; /* non linear */ 
            this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
            i++;
            j++;
            if (i >= this.N) {
                this.mt[0] = this.mt[this.N - 1];
                i = 1;
            }
            if (j >= key_length) j = 0;
        }
        for(k = this.N - 1; k; k--){
            s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
            this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1566083941 << 16) + (s & 0x0000ffff) * 1566083941) - i; /* non linear */ 
            this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
            i++;
            if (i >= this.N) {
                this.mt[0] = this.mt[this.N - 1];
                i = 1;
            }
        }
        this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
    };
    /* generates a random number on [0,0xffffffff]-interval */ MersenneTwister.prototype.genrand_int32 = function() {
        var y;
        var mag01 = new Array(0x0, this.MATRIX_A);
        /* mag01[x] = x * MATRIX_A  for x=0,1 */ if (this.mti >= this.N) {
            var kk;
            if (this.mti === this.N + 1) this.init_genrand(5489); /* a default initial seed is used */ 
            for(kk = 0; kk < this.N - this.M; kk++){
                y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
                this.mt[kk] = this.mt[kk + this.M] ^ y >>> 1 ^ mag01[y & 0x1];
            }
            for(; kk < this.N - 1; kk++){
                y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
                this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ y >>> 1 ^ mag01[y & 0x1];
            }
            y = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK;
            this.mt[this.N - 1] = this.mt[this.M - 1] ^ y >>> 1 ^ mag01[y & 0x1];
            this.mti = 0;
        }
        y = this.mt[this.mti++];
        /* Tempering */ y ^= y >>> 11;
        y ^= y << 7 & 0x9d2c5680;
        y ^= y << 15 & 0xefc60000;
        y ^= y >>> 18;
        return y >>> 0;
    };
    /* generates a random number on [0,0x7fffffff]-interval */ MersenneTwister.prototype.genrand_int31 = function() {
        return this.genrand_int32() >>> 1;
    };
    /* generates a random number on [0,1]-real-interval */ MersenneTwister.prototype.genrand_real1 = function() {
        return this.genrand_int32() * (1.0 / 4294967295.0);
    /* divided by 2^32-1 */ };
    /* generates a random number on [0,1)-real-interval */ MersenneTwister.prototype.random = function() {
        return this.genrand_int32() * (1.0 / 4294967296.0);
    /* divided by 2^32 */ };
    /* generates a random number on (0,1)-real-interval */ MersenneTwister.prototype.genrand_real3 = function() {
        return (this.genrand_int32() + 0.5) * (1.0 / 4294967296.0);
    /* divided by 2^32 */ };
    /* generates a random number on [0,1) with 53-bit resolution*/ MersenneTwister.prototype.genrand_res53 = function() {
        var a = this.genrand_int32() >>> 5, b = this.genrand_int32() >>> 6;
        return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
    };
    // BlueImp MD5 hashing algorithm from https://github.com/blueimp/JavaScript-MD5
    var BlueImpMD5 = function() {};
    BlueImpMD5.prototype.VERSION = '1.0.1';
    /*
    * Add integers, wrapping at 2^32. This uses 16-bit operations internally
    * to work around bugs in some JS interpreters.
    */ BlueImpMD5.prototype.safe_add = function safe_add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    /*
    * Bitwise rotate a 32-bit number to the left.
    */ BlueImpMD5.prototype.bit_roll = function(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    };
    /*
    * These functions implement the five basic operations the algorithm uses.
    */ BlueImpMD5.prototype.md5_cmn = function(q, a, b, x, s, t) {
        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(a, q), this.safe_add(x, t)), s), b);
    };
    BlueImpMD5.prototype.md5_ff = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(b & c | ~b & d, a, b, x, s, t);
    };
    BlueImpMD5.prototype.md5_gg = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(b & d | c & ~d, a, b, x, s, t);
    };
    BlueImpMD5.prototype.md5_hh = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(b ^ c ^ d, a, b, x, s, t);
    };
    BlueImpMD5.prototype.md5_ii = function(a, b, c, d, x, s, t) {
        return this.md5_cmn(c ^ (b | ~d), a, b, x, s, t);
    };
    /*
    * Calculate the MD5 of an array of little-endian words, and a bit length.
    */ BlueImpMD5.prototype.binl_md5 = function(x, len) {
        /* append padding */ x[len >> 5] |= 0x80 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;
        var i, olda, oldb, oldc, oldd, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        for(i = 0; i < x.length; i += 16){
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;
            a = this.md5_ff(a, b, c, d, x[i], 7, -680876936);
            d = this.md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = this.md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = this.md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = this.md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = this.md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = this.md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = this.md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = this.md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = this.md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = this.md5_ff(c, d, a, b, x[i + 10], 17, -42063);
            b = this.md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = this.md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = this.md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = this.md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = this.md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
            a = this.md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = this.md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = this.md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = this.md5_gg(b, c, d, a, x[i], 20, -373897302);
            a = this.md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = this.md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = this.md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = this.md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = this.md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = this.md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = this.md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = this.md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = this.md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = this.md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = this.md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = this.md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
            a = this.md5_hh(a, b, c, d, x[i + 5], 4, -378558);
            d = this.md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = this.md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = this.md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = this.md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = this.md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = this.md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = this.md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = this.md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = this.md5_hh(d, a, b, c, x[i], 11, -358537222);
            c = this.md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = this.md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = this.md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = this.md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = this.md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = this.md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
            a = this.md5_ii(a, b, c, d, x[i], 6, -198630844);
            d = this.md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = this.md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = this.md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = this.md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = this.md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = this.md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = this.md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = this.md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = this.md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = this.md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = this.md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = this.md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = this.md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = this.md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = this.md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
            a = this.safe_add(a, olda);
            b = this.safe_add(b, oldb);
            c = this.safe_add(c, oldc);
            d = this.safe_add(d, oldd);
        }
        return [
            a,
            b,
            c,
            d
        ];
    };
    /*
    * Convert an array of little-endian words to a string
    */ BlueImpMD5.prototype.binl2rstr = function(input) {
        var i, output = '';
        for(i = 0; i < input.length * 32; i += 8)output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
        return output;
    };
    /*
    * Convert a raw string to an array of little-endian words
    * Characters >255 have their high-byte silently ignored.
    */ BlueImpMD5.prototype.rstr2binl = function(input) {
        var i, output = [];
        output[(input.length >> 2) - 1] = undefined;
        for(i = 0; i < output.length; i += 1)output[i] = 0;
        for(i = 0; i < input.length * 8; i += 8)output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
        return output;
    };
    /*
    * Calculate the MD5 of a raw string
    */ BlueImpMD5.prototype.rstr_md5 = function(s) {
        return this.binl2rstr(this.binl_md5(this.rstr2binl(s), s.length * 8));
    };
    /*
    * Calculate the HMAC-MD5, of a key and some data (raw strings)
    */ BlueImpMD5.prototype.rstr_hmac_md5 = function(key, data) {
        var i, bkey = this.rstr2binl(key), ipad = [], opad = [], hash;
        ipad[15] = opad[15] = undefined;
        if (bkey.length > 16) bkey = this.binl_md5(bkey, key.length * 8);
        for(i = 0; i < 16; i += 1){
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5C5C5C5C;
        }
        hash = this.binl_md5(ipad.concat(this.rstr2binl(data)), 512 + data.length * 8);
        return this.binl2rstr(this.binl_md5(opad.concat(hash), 640));
    };
    /*
    * Convert a raw string to a hex string
    */ BlueImpMD5.prototype.rstr2hex = function(input) {
        var hex_tab = '0123456789abcdef', output = '', x, i;
        for(i = 0; i < input.length; i += 1){
            x = input.charCodeAt(i);
            output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
        }
        return output;
    };
    /*
    * Encode a string as utf-8
    */ BlueImpMD5.prototype.str2rstr_utf8 = function(input) {
        return unescape(encodeURIComponent(input));
    };
    /*
    * Take string arguments and return either raw or hex encoded strings
    */ BlueImpMD5.prototype.raw_md5 = function(s) {
        return this.rstr_md5(this.str2rstr_utf8(s));
    };
    BlueImpMD5.prototype.hex_md5 = function(s) {
        return this.rstr2hex(this.raw_md5(s));
    };
    BlueImpMD5.prototype.raw_hmac_md5 = function(k, d) {
        return this.rstr_hmac_md5(this.str2rstr_utf8(k), this.str2rstr_utf8(d));
    };
    BlueImpMD5.prototype.hex_hmac_md5 = function(k, d) {
        return this.rstr2hex(this.raw_hmac_md5(k, d));
    };
    BlueImpMD5.prototype.md5 = function(string, key, raw) {
        if (!key) {
            if (!raw) return this.hex_md5(string);
            return this.raw_md5(string);
        }
        if (!raw) return this.hex_hmac_md5(key, string);
        return this.raw_hmac_md5(key, string);
    };
    if (0, module.exports) exports = module.exports = Chance;
    exports.Chance = Chance;
    // Register as an anonymous AMD module
    if (typeof define === 'function' && define.amd) define([], function() {
        return Chance;
    });
    // if there is a importsScrips object define chance for worker
    // allows worker to use full Chance functionality with seed
    if (typeof importScripts !== 'undefined') {
        chance = new Chance();
        self.Chance = Chance;
    }
    // If there is a window object, that at least has a document property,
    // instantiate and define chance on the window
    if (typeof window === "object" && typeof window.document === "object") {
        window.Chance = Chance;
        window.chance = new Chance();
    }
})();

});

parcelRegister("52kL4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3aad3dc8a82b847c$export$2e2bcd8739ae039);

var $8trTd = parcelRequire("8trTd");

var $7HMEJ = parcelRequire("7HMEJ");

var $iOAFx = parcelRequire("iOAFx");

var $6mIwy = parcelRequire("6mIwy");

var $dRQ0a = parcelRequire("dRQ0a");

var $h0m4m = parcelRequire("h0m4m");

var $e7rBS = parcelRequire("e7rBS");

var $ctM6U = parcelRequire("ctM6U");

var $jILpd = parcelRequire("jILpd");

var $7SYLh = parcelRequire("7SYLh");

var $lUljM = parcelRequire("lUljM");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3aad3dc8a82b847c$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3aad3dc8a82b847c$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3aad3dc8a82b847c$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3aad3dc8a82b847c$var$doubleQuoteRegExp = /''/g;
var $3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3aad3dc8a82b847c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $jILpd.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $lUljM.default);
    var firstWeekContainsDate = (0, $ctM6U.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $ctM6U.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $iOAFx.default)(dirtyDate);
    if (!(0, $8trTd.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $h0m4m.default)(originalDate);
    var utcDate = (0, $7HMEJ.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($3aad3dc8a82b847c$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $dRQ0a.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($3aad3dc8a82b847c$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $3aad3dc8a82b847c$var$cleanEscapedString(substring);
        var formatter = (0, $6mIwy.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $e7rBS.isProtectedWeekYearToken)(substring)) (0, $e7rBS.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $e7rBS.isProtectedDayOfYearToken)(substring)) (0, $e7rBS.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $3aad3dc8a82b847c$var$cleanEscapedString(input) {
    var matched = input.match($3aad3dc8a82b847c$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($3aad3dc8a82b847c$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("8trTd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $62b6aa7362d709e7$export$2e2bcd8739ae039);

var $4nFE3 = parcelRequire("4nFE3");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $62b6aa7362d709e7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    if (!(0, $4nFE3.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $iOAFx.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("4nFE3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $33099d3a0ee000b6$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $jILpd = parcelRequire("jILpd");
function $33099d3a0ee000b6$export$2e2bcd8739ae039(value) {
    (0, $jILpd.default)(1, arguments);
    return value instanceof Date || (0, $jOMXy.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});
parcelRegister("jILpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5b6e627005992fb$export$2e2bcd8739ae039);
function $e5b6e627005992fb$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("iOAFx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $db295730c81e792c$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $jILpd = parcelRequire("jILpd");
function $db295730c81e792c$export$2e2bcd8739ae039(argument) {
    (0, $jILpd.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $jOMXy.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("7HMEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c24a9e74e1c5c0$export$2e2bcd8739ae039);

var $9vFg7 = parcelRequire("9vFg7");

var $jILpd = parcelRequire("jILpd");

var $ctM6U = parcelRequire("ctM6U");
function $59c24a9e74e1c5c0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $9vFg7.default)(dirtyDate, -amount);
}

});
parcelRegister("9vFg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec7037ed5e3d5c3$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $6ec7037ed5e3d5c3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var timestamp = (0, $iOAFx.default)(dirtyDate).getTime();
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("ctM6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $915d833559b42c3f$export$2e2bcd8739ae039);
function $915d833559b42c3f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("6mIwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2755b1807fc917$export$2e2bcd8739ae039);

var $l5mXb = parcelRequire("l5mXb");

var $i5TSl = parcelRequire("i5TSl");

var $hgFbY = parcelRequire("hgFbY");

var $h56WH = parcelRequire("h56WH");

var $di10y = parcelRequire("di10y");

var $eqMal = parcelRequire("eqMal");

var $7aFVr = parcelRequire("7aFVr");
var $4a2755b1807fc917$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4a2755b1807fc917$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $7aFVr.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $di10y.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $eqMal.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $eqMal.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $hgFbY.default)(date);
        // Padding
        return (0, $eqMal.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $eqMal.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $eqMal.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $eqMal.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $7aFVr.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $eqMal.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $h56WH.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $eqMal.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $i5TSl.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $eqMal.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $7aFVr.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $l5mXb.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $eqMal.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $eqMal.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $eqMal.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $eqMal.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $7aFVr.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $7aFVr.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $eqMal.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $eqMal.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $7aFVr.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $7aFVr.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $7aFVr.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $eqMal.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $eqMal.default)(timestamp, token.length);
    }
};
function $4a2755b1807fc917$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $eqMal.default)(minutes, 2);
}
function $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $eqMal.default)(Math.abs(offset) / 60, 2);
    }
    return $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter);
}
function $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $eqMal.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $eqMal.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4a2755b1807fc917$export$2e2bcd8739ae039 = $4a2755b1807fc917$var$formatters;

});
parcelRegister("l5mXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59bdeb98608936d$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
var $f59bdeb98608936d$var$MILLISECONDS_IN_DAY = 86400000;
function $f59bdeb98608936d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $f59bdeb98608936d$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("i5TSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c40956b8ab3953$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $6ft3d = parcelRequire("6ft3d");

var $iFhME = parcelRequire("iFhME");

var $jILpd = parcelRequire("jILpd");
var $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK = 604800000;
function $d2c40956b8ab3953$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var diff = (0, $6ft3d.default)(date).getTime() - (0, $iFhME.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("6ft3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $48caadaecccd9d4f$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $48caadaecccd9d4f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $iOAFx.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("iFhME", function(module, exports) {

$parcel$export(module.exports, "default", () => $d969d9c83bc56a0e$export$2e2bcd8739ae039);

var $hgFbY = parcelRequire("hgFbY");

var $6ft3d = parcelRequire("6ft3d");

var $jILpd = parcelRequire("jILpd");
function $d969d9c83bc56a0e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var year = (0, $hgFbY.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $6ft3d.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("hgFbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c923e234d864ebd7$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");

var $6ft3d = parcelRequire("6ft3d");
function $c923e234d864ebd7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $6ft3d.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $6ft3d.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("h56WH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f84a8f2fb5610c$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $e8tpO = parcelRequire("e8tpO");

var $lb5vp = parcelRequire("lb5vp");

var $jILpd = parcelRequire("jILpd");
var $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK = 604800000;
function $c6f84a8f2fb5610c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var diff = (0, $e8tpO.default)(date, options).getTime() - (0, $lb5vp.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("e8tpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a8a151e5e43f6b$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");

var $ctM6U = parcelRequire("ctM6U");

var $7SYLh = parcelRequire("7SYLh");
function $a4a8a151e5e43f6b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $jILpd.default)(1, arguments);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var weekStartsOn = (0, $ctM6U.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $iOAFx.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("7SYLh", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $5bdcb58bd181ac10$export$430a3269e24b912e);
var $5bdcb58bd181ac10$var$defaultOptions = {};
function $5bdcb58bd181ac10$export$430a3269e24b912e() {
    return $5bdcb58bd181ac10$var$defaultOptions;
}
function $5bdcb58bd181ac10$export$95365be1b0704abc(newOptions) {
    $5bdcb58bd181ac10$var$defaultOptions = newOptions;
}

});


parcelRegister("lb5vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6aee5547809ce40$export$2e2bcd8739ae039);

var $di10y = parcelRequire("di10y");

var $jILpd = parcelRequire("jILpd");

var $e8tpO = parcelRequire("e8tpO");

var $ctM6U = parcelRequire("ctM6U");

var $7SYLh = parcelRequire("7SYLh");
function $f6aee5547809ce40$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $jILpd.default)(1, arguments);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var firstWeekContainsDate = (0, $ctM6U.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $di10y.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $e8tpO.default)(firstWeek, options);
    return date;
}

});
parcelRegister("di10y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9acdbcf7776722e9$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");

var $e8tpO = parcelRequire("e8tpO");

var $ctM6U = parcelRequire("ctM6U");

var $7SYLh = parcelRequire("7SYLh");
function $9acdbcf7776722e9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var firstWeekContainsDate = (0, $ctM6U.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e8tpO.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e8tpO.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("eqMal", function(module, exports) {

$parcel$export(module.exports, "default", () => $a818db1c2d04a150$export$2e2bcd8739ae039);
function $a818db1c2d04a150$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("7aFVr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5389fd1b998732ff$export$2e2bcd8739ae039);

var $eqMal = parcelRequire("eqMal");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $5389fd1b998732ff$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $eqMal.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $eqMal.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $eqMal.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $eqMal.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $eqMal.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $eqMal.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $eqMal.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $eqMal.default)(fractionalSeconds, token.length);
    }
};
var $5389fd1b998732ff$export$2e2bcd8739ae039 = $5389fd1b998732ff$var$formatters;

});


parcelRegister("dRQ0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $a188900c436ed76e$export$2e2bcd8739ae039);
var $a188900c436ed76e$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $a188900c436ed76e$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $a188900c436ed76e$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $a188900c436ed76e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $a188900c436ed76e$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $a188900c436ed76e$var$timeLongFormatter(timePattern, formatLong));
};
var $a188900c436ed76e$var$longFormatters = {
    p: $a188900c436ed76e$var$timeLongFormatter,
    P: $a188900c436ed76e$var$dateTimeLongFormatter
};
var $a188900c436ed76e$export$2e2bcd8739ae039 = $a188900c436ed76e$var$longFormatters;

});

parcelRegister("h0m4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6138e3e9e222cc3$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $c6138e3e9e222cc3$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("e7rBS", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $a47722dda2cd757f$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $a47722dda2cd757f$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $a47722dda2cd757f$export$8073c1ae88f0e727);
var $a47722dda2cd757f$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a47722dda2cd757f$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a47722dda2cd757f$export$c6cc36aa33304772(token) {
    return $a47722dda2cd757f$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$c6b49d6dceb604a1(token) {
    return $a47722dda2cd757f$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("lUljM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2f5d41cd8b653b$export$2e2bcd8739ae039);

var $2IzrS = parcelRequire("2IzrS");
var $ff2f5d41cd8b653b$export$2e2bcd8739ae039 = (0, $2IzrS.default);

});
parcelRegister("2IzrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fab302b13b08d66$export$2e2bcd8739ae039);

var $dOW3f = parcelRequire("dOW3f");

var $kKu2h = parcelRequire("kKu2h");

var $3TJul = parcelRequire("3TJul");

var $gUnTV = parcelRequire("gUnTV");

var $4ncxM = parcelRequire("4ncxM");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $1fab302b13b08d66$var$locale = {
    code: 'en-US',
    formatDistance: (0, $dOW3f.default),
    formatLong: (0, $kKu2h.default),
    formatRelative: (0, $3TJul.default),
    localize: (0, $gUnTV.default),
    match: (0, $4ncxM.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $1fab302b13b08d66$export$2e2bcd8739ae039 = $1fab302b13b08d66$var$locale;

});
parcelRegister("dOW3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0fcf9a783a9c8cf$export$2e2bcd8739ae039);
var $a0fcf9a783a9c8cf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $a0fcf9a783a9c8cf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a0fcf9a783a9c8cf$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $a0fcf9a783a9c8cf$export$2e2bcd8739ae039 = $a0fcf9a783a9c8cf$var$formatDistance;

});

parcelRegister("kKu2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1af66fefd840e85$export$2e2bcd8739ae039);

var $65kDf = parcelRequire("65kDf");
var $f1af66fefd840e85$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $f1af66fefd840e85$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f1af66fefd840e85$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f1af66fefd840e85$var$formatLong = {
    date: (0, $65kDf.default)({
        formats: $f1af66fefd840e85$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $65kDf.default)({
        formats: $f1af66fefd840e85$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $65kDf.default)({
        formats: $f1af66fefd840e85$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f1af66fefd840e85$export$2e2bcd8739ae039 = $f1af66fefd840e85$var$formatLong;

});
parcelRegister("65kDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e336c804985263$export$2e2bcd8739ae039);
function $46e336c804985263$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("3TJul", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d69cb397acad490$export$2e2bcd8739ae039);
var $2d69cb397acad490$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $2d69cb397acad490$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2d69cb397acad490$var$formatRelativeLocale[token];
};
var $2d69cb397acad490$export$2e2bcd8739ae039 = $2d69cb397acad490$var$formatRelative;

});

parcelRegister("gUnTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4f46a8d544f3daa$export$2e2bcd8739ae039);

var $jAY2m = parcelRequire("jAY2m");
var $c4f46a8d544f3daa$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $c4f46a8d544f3daa$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c4f46a8d544f3daa$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $c4f46a8d544f3daa$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $c4f46a8d544f3daa$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $c4f46a8d544f3daa$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $c4f46a8d544f3daa$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $c4f46a8d544f3daa$var$localize = {
    ordinalNumber: $c4f46a8d544f3daa$var$ordinalNumber,
    era: (0, $jAY2m.default)({
        values: $c4f46a8d544f3daa$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $jAY2m.default)({
        values: $c4f46a8d544f3daa$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $jAY2m.default)({
        values: $c4f46a8d544f3daa$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $jAY2m.default)({
        values: $c4f46a8d544f3daa$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $jAY2m.default)({
        values: $c4f46a8d544f3daa$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c4f46a8d544f3daa$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c4f46a8d544f3daa$export$2e2bcd8739ae039 = $c4f46a8d544f3daa$var$localize;

});
parcelRegister("jAY2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e43ff33ed7f225ec$export$2e2bcd8739ae039);
function $e43ff33ed7f225ec$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("4ncxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f30a5965252391$export$2e2bcd8739ae039);

var $kVkYX = parcelRequire("kVkYX");

var $1HUvr = parcelRequire("1HUvr");
var $32f30a5965252391$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $32f30a5965252391$var$parseOrdinalNumberPattern = /\d+/i;
var $32f30a5965252391$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $32f30a5965252391$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $32f30a5965252391$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $32f30a5965252391$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $32f30a5965252391$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $32f30a5965252391$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $32f30a5965252391$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $32f30a5965252391$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $32f30a5965252391$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $32f30a5965252391$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $32f30a5965252391$var$match = {
    ordinalNumber: (0, $1HUvr.default)({
        matchPattern: $32f30a5965252391$var$matchOrdinalNumberPattern,
        parsePattern: $32f30a5965252391$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $kVkYX.default)({
        matchPatterns: $32f30a5965252391$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $kVkYX.default)({
        matchPatterns: $32f30a5965252391$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $kVkYX.default)({
        matchPatterns: $32f30a5965252391$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $kVkYX.default)({
        matchPatterns: $32f30a5965252391$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $kVkYX.default)({
        matchPatterns: $32f30a5965252391$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $32f30a5965252391$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $32f30a5965252391$export$2e2bcd8739ae039 = $32f30a5965252391$var$match;

});
parcelRegister("kVkYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b96828de7939a6$export$2e2bcd8739ae039);
function $f3b96828de7939a6$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f3b96828de7939a6$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f3b96828de7939a6$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f3b96828de7939a6$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f3b96828de7939a6$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("1HUvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e5a388dae711de$export$2e2bcd8739ae039);
function $13e5a388dae711de$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("ePGyo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $acc6d665ebe23d7e$export$2e2bcd8739ae039);

var $7VSLk = parcelRequire("7VSLk");

var $jILpd = parcelRequire("jILpd");

var $ctM6U = parcelRequire("ctM6U");
function $acc6d665ebe23d7e$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $jILpd.default)(1, arguments);
    var additionalDigits = (0, $ctM6U.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $acc6d665ebe23d7e$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $acc6d665ebe23d7e$var$parseYear(dateStrings.date, additionalDigits);
        date = $acc6d665ebe23d7e$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $acc6d665ebe23d7e$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $acc6d665ebe23d7e$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $acc6d665ebe23d7e$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $acc6d665ebe23d7e$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $acc6d665ebe23d7e$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $acc6d665ebe23d7e$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $acc6d665ebe23d7e$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($acc6d665ebe23d7e$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($acc6d665ebe23d7e$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($acc6d665ebe23d7e$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $acc6d665ebe23d7e$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $acc6d665ebe23d7e$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $acc6d665ebe23d7e$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($acc6d665ebe23d7e$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $acc6d665ebe23d7e$var$parseDateUnit(captures[1]);
    var month = $acc6d665ebe23d7e$var$parseDateUnit(captures[2]) - 1;
    var day = $acc6d665ebe23d7e$var$parseDateUnit(captures[3]);
    var week = $acc6d665ebe23d7e$var$parseDateUnit(captures[4]);
    var dayOfWeek = $acc6d665ebe23d7e$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$acc6d665ebe23d7e$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $acc6d665ebe23d7e$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$acc6d665ebe23d7e$var$validateDate(year, month, day) || !$acc6d665ebe23d7e$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $acc6d665ebe23d7e$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $acc6d665ebe23d7e$var$parseTime(timeString) {
    var captures = timeString.match($acc6d665ebe23d7e$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $acc6d665ebe23d7e$var$parseTimeUnit(captures[1]);
    var minutes = $acc6d665ebe23d7e$var$parseTimeUnit(captures[2]);
    var seconds = $acc6d665ebe23d7e$var$parseTimeUnit(captures[3]);
    if (!$acc6d665ebe23d7e$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $7VSLk.millisecondsInHour) + minutes * (0, $7VSLk.millisecondsInMinute) + seconds * 1000;
}
function $acc6d665ebe23d7e$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $acc6d665ebe23d7e$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($acc6d665ebe23d7e$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$acc6d665ebe23d7e$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $7VSLk.millisecondsInHour) + minutes * (0, $7VSLk.millisecondsInMinute));
}
function $acc6d665ebe23d7e$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $acc6d665ebe23d7e$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $acc6d665ebe23d7e$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $acc6d665ebe23d7e$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($acc6d665ebe23d7e$var$daysInMonths[month] || ($acc6d665ebe23d7e$var$isLeapYearIndex(year) ? 29 : 28));
}
function $acc6d665ebe23d7e$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($acc6d665ebe23d7e$var$isLeapYearIndex(year) ? 366 : 365);
}
function $acc6d665ebe23d7e$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $acc6d665ebe23d7e$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $acc6d665ebe23d7e$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});
parcelRegister("7VSLk", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", () => $5c6855f17eac7feb$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $5c6855f17eac7feb$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $5c6855f17eac7feb$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $5c6855f17eac7feb$export$dfd9b671c89acc8e = 7;
var $5c6855f17eac7feb$export$3913210603d8e9ae = 365.2425;
var $5c6855f17eac7feb$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $5c6855f17eac7feb$export$91246f0b9bd9beff = 60000;
var $5c6855f17eac7feb$export$7f72910d6dfd237a = 3600000;
var $5c6855f17eac7feb$export$397c2d5776aa9055 = 1000;
var $5c6855f17eac7feb$export$4dec998e48f9c246 = -$5c6855f17eac7feb$export$81caae6e1cc7a622;
var $5c6855f17eac7feb$export$f2f5ae5a8e2d8f9f = 60;
var $5c6855f17eac7feb$export$3c58128db900d44e = 3;
var $5c6855f17eac7feb$export$80d7e435f744f319 = 12;
var $5c6855f17eac7feb$export$4db7641526e3241f = 4;
var $5c6855f17eac7feb$export$698aec755e92c695 = 3600;
var $5c6855f17eac7feb$export$a77c1a7ebebe2a5a = 60;
var $5c6855f17eac7feb$export$815a9362476d2fe3 = $5c6855f17eac7feb$export$698aec755e92c695 * 24;
var $5c6855f17eac7feb$export$34804a017b31e2fe = $5c6855f17eac7feb$export$815a9362476d2fe3 * 7;
var $5c6855f17eac7feb$export$7271e9e3478110d1 = $5c6855f17eac7feb$export$815a9362476d2fe3 * $5c6855f17eac7feb$export$3913210603d8e9ae;
var $5c6855f17eac7feb$export$8e6600bbdee7dabb = $5c6855f17eac7feb$export$7271e9e3478110d1 / 12;
var $5c6855f17eac7feb$export$be1dccf2de902d31 = $5c6855f17eac7feb$export$8e6600bbdee7dabb * 3;

});


parcelRegister("hX1NX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d11958ba29431b83$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $40c8c = parcelRequire("40c8c");
const $d11958ba29431b83$var$DelayDeleteButton = ({ onDelete: onDelete, delayTimeMs: delayTimeMs, className: className, displayText: displayText, disabled: disabled })=>{
    const deleteText = displayText != null ? displayText : 'Delete';
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $40c8c.default), {
        onAction: onDelete,
        delayTimeMs: delayTimeMs,
        className: className,
        displayText: deleteText,
        confirmDisplayText: "Confirm deletion",
        disabled: disabled
    });
};
var $d11958ba29431b83$export$2e2bcd8739ae039 = $d11958ba29431b83$var$DelayDeleteButton;

});
parcelRegister("40c8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea092892271c1ca$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $kKP1P = parcelRequire("kKP1P");
const $2ea092892271c1ca$var$DelayActionButton = ({ onAction: onAction, delayTimeMs: delayTimeMs, displayText: displayText, confirmDisplayText: confirmDisplayText, disabled: disabled, ...buttonProps })=>{
    const [confirmAction, setConfirmAction] = (0, $8NFma.useState)(false);
    const [actionDisabled, setActionDisabled] = (0, $8NFma.useState)(false);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $kKP1P.default), {
        disabled: actionDisabled || disabled,
        onClick: (_e)=>{
            if (confirmAction) {
                onAction();
                setConfirmAction(false);
                setActionDisabled(false);
            } else {
                setActionDisabled(true);
                setConfirmAction(true);
                // Re-enable button after a delay
                setTimeout(()=>{
                    setActionDisabled(false);
                }, delayTimeMs);
            }
        },
        ...buttonProps,
        children: [
            actionDisabled && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                className: "spinner-border spinner-border-sm me-1",
                role: "status",
                "aria-hidden": "true"
            }),
            confirmAction ? confirmDisplayText : displayText
        ]
    });
};
var $2ea092892271c1ca$export$2e2bcd8739ae039 = $2ea092892271c1ca$var$DelayActionButton;

});


parcelRegister("2szKO", function(module, exports) {

$parcel$export(module.exports, "tzAwareNow", () => $1ca9ee49cf9b9035$export$167464913fd9e429);
$parcel$export(module.exports, "TzAwareDatetimePicker", () => $1ca9ee49cf9b9035$export$8b644ab256e551bb);

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $dRBOz = parcelRequire("dRBOz");
var $52kL4 = parcelRequire("52kL4");
var $hKOo7 = parcelRequire("hKOo7");
var $jGHQx = parcelRequire("jGHQx");
var $ePGyo = parcelRequire("ePGyo");
var $l1Bqy = parcelRequire("l1Bqy");
var $fYV7N = parcelRequire("fYV7N");
var $6veFJ = parcelRequire("6veFJ");

var $37Nrk = parcelRequire("37Nrk");

const $1ca9ee49cf9b9035$export$167464913fd9e429 = ()=>(0, $jGHQx.default)(Date.now());
const $1ca9ee49cf9b9035$var$useIsMobile = ()=>{
    const [isMobile, setIsMobile] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        const checkMobile = ()=>setIsMobile(window.matchMedia('(max-width: 767px)').matches);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return ()=>window.removeEventListener('resize', checkMobile);
    }, []);
    return isMobile;
};
const $1ca9ee49cf9b9035$export$8b644ab256e551bb = ({ id: id, label: label, val: val, setVal: setVal, className: className, innerStyle: innerStyle, hideDistance: hideDistance, disabled: disabled = false, restrictTo15: restrictTo15 = false })=>{
    const isMobile = $1ca9ee49cf9b9035$var$useIsMobile();
    const localDt = (0, $ePGyo.default)(val);
    const effectiveDt = restrictTo15 ? (0, $l1Bqy.default)(localDt, {
        nearestTo: 15
    }) : localDt;
    const handleChange = (date)=>{
        if (date) {
            const effectiveDate = restrictTo15 ? (0, $l1Bqy.default)(date, {
                nearestTo: 15
            }) : date;
            setVal((0, $jGHQx.default)((0, $ePGyo.default)((0, $jGHQx.default)(effectiveDate)))) // roundtrip to add timezone info
            ;
        } else setVal('');
    };
    const memoizedDatePicker = (0, $8NFma.useMemo)(()=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($37Nrk))), {
            id: id,
            name: id,
            selected: effectiveDt,
            onChange: handleChange,
            showTimeInput: !restrictTo15,
            showTimeSelect: restrictTo15,
            timeFormat: "HH:mm",
            dateFormat: "MM/dd/yyyy HH:mm",
            timeCaption: "Time",
            ...restrictTo15 && {
                timeIntervals: 15,
                minTime: (0, $fYV7N.default)((0, $6veFJ.default)(new Date(), 0), 0),
                maxTime: (0, $fYV7N.default)((0, $6veFJ.default)(new Date(), 45), 23)
            },
            className: "form-control",
            style: innerStyle,
            disabled: disabled,
            "aria-label": label
        }), [
        effectiveDt,
        restrictTo15,
        disabled,
        label
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                className: "form-label",
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                children: [
                    isMobile ? /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                        type: "datetime-local",
                        id: id,
                        name: id,
                        value: (0, $52kL4.default)(effectiveDt, "yyyy-MM-dd'T'HH:mm"),
                        onChange: (e)=>{
                            // Roundtrip to add timezone info
                            handleChange((0, $ePGyo.default)(e.target.value));
                        },
                        className: "form-control",
                        style: innerStyle,
                        disabled: disabled,
                        step: restrictTo15 ? 900 : 60,
                        "aria-label": label
                    }) : memoizedDatePicker,
                    !hideDistance && val && /*#__PURE__*/ (0, $1IdZj.jsxs)("small", {
                        className: "text-muted ms-3",
                        children: [
                            (0, $hKOo7.default)(effectiveDt),
                            (0, $dRBOz.default)(effectiveDt, new Date()) === -1 ? ' ago' : ' in the future'
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("dRBOz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a17d8ed27c1eb490$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $a17d8ed27c1eb490$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var dateLeft = (0, $iOAFx.default)(dirtyDateLeft);
    var dateRight = (0, $iOAFx.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("hKOo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecdd18eece7954d$export$2e2bcd8739ae039);

var $e2e6v = parcelRequire("e2e6v");

var $jILpd = parcelRequire("jILpd");
function $cecdd18eece7954d$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $jILpd.default)(1, arguments);
    return (0, $e2e6v.default)(dirtyDate, Date.now(), options);
}

});
parcelRegister("e2e6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a37c315095dfae11$export$2e2bcd8739ae039);

var $7SYLh = parcelRequire("7SYLh");

var $h0m4m = parcelRequire("h0m4m");

var $dRBOz = parcelRequire("dRBOz");

var $iOAFx = parcelRequire("iOAFx");

var $401a7 = parcelRequire("401a7");

var $6NTqf = parcelRequire("6NTqf");

var $lUljM = parcelRequire("lUljM");

var $jILpd = parcelRequire("jILpd");
var $a37c315095dfae11$var$MILLISECONDS_IN_MINUTE = 60000;
var $a37c315095dfae11$var$MINUTES_IN_DAY = 1440;
var $a37c315095dfae11$var$MINUTES_IN_MONTH = $a37c315095dfae11$var$MINUTES_IN_DAY * 30;
var $a37c315095dfae11$var$MINUTES_IN_YEAR = $a37c315095dfae11$var$MINUTES_IN_DAY * 365;
function $a37c315095dfae11$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _options$roundingMeth;
    (0, $jILpd.default)(2, arguments);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $lUljM.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain localize.formatDistance property');
    var comparison = (0, $dRBOz.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $6NTqf.default)((0, $401a7.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $iOAFx.default)(dirtyBaseDate);
        dateRight = (0, $iOAFx.default)(dirtyDate);
    } else {
        dateLeft = (0, $iOAFx.default)(dirtyDate);
        dateRight = (0, $iOAFx.default)(dirtyBaseDate);
    }
    var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
    var roundingMethodFn;
    if (roundingMethod === 'floor') roundingMethodFn = Math.floor;
    else if (roundingMethod === 'ceil') roundingMethodFn = Math.ceil;
    else if (roundingMethod === 'round') roundingMethodFn = Math.round;
    else throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / $a37c315095dfae11$var$MILLISECONDS_IN_MINUTE;
    var timezoneOffset = (0, $h0m4m.default)(dateRight) - (0, $h0m4m.default)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / $a37c315095dfae11$var$MILLISECONDS_IN_MINUTE;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = 'second';
        else if (minutes < 60) unit = 'minute';
        else if (minutes < $a37c315095dfae11$var$MINUTES_IN_DAY) unit = 'hour';
        else if (dstNormalizedMinutes < $a37c315095dfae11$var$MINUTES_IN_MONTH) unit = 'day';
        else if (dstNormalizedMinutes < $a37c315095dfae11$var$MINUTES_IN_YEAR) unit = 'month';
        else unit = 'year';
    } else unit = String(defaultUnit);
    // 0 up to 60 seconds
    if (unit === 'second') {
        var seconds = roundingMethodFn(milliseconds / 1000);
        return locale.formatDistance('xSeconds', seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === 'minute') {
        var roundedMinutes = roundingMethodFn(minutes);
        return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === 'hour') {
        var hours = roundingMethodFn(minutes / 60);
        return locale.formatDistance('xHours', hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === 'day') {
        var days = roundingMethodFn(dstNormalizedMinutes / $a37c315095dfae11$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === 'month') {
        var months = roundingMethodFn(dstNormalizedMinutes / $a37c315095dfae11$var$MINUTES_IN_MONTH);
        return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);
    // 1 year up to max Date
    } else if (unit === 'year') {
        var years = roundingMethodFn(dstNormalizedMinutes / $a37c315095dfae11$var$MINUTES_IN_YEAR);
        return locale.formatDistance('xYears', years, localizeOptions);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

});
parcelRegister("401a7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e98104d428ae556$export$2e2bcd8739ae039);

var $6NTqf = parcelRequire("6NTqf");
function $2e98104d428ae556$export$2e2bcd8739ae039(object) {
    return (0, $6NTqf.default)({}, object);
}

});
parcelRegister("6NTqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f424f68e2b4ec05$export$2e2bcd8739ae039);
function $4f424f68e2b4ec05$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});




parcelRegister("jGHQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e553f38c4d94aa8c$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $eqMal = parcelRequire("eqMal");

var $jILpd = parcelRequire("jILpd");
function $e553f38c4d94aa8c$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $jILpd.default)(1, arguments);
    var originalDate = (0, $iOAFx.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $eqMal.default)(originalDate.getDate(), 2);
        var month = (0, $eqMal.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $eqMal.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $eqMal.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $eqMal.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $eqMal.default)(originalDate.getHours(), 2);
        var minute = (0, $eqMal.default)(originalDate.getMinutes(), 2);
        var second = (0, $eqMal.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("l1Bqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e6b943eb6c8250$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $kaptM = parcelRequire("kaptM");

var $ctM6U = parcelRequire("ctM6U");
function $f4e6b943eb6c8250$export$2e2bcd8739ae039(dirtyDate, options) {
    var _options$nearestTo;
    if (arguments.length < 1) throw new TypeError('1 argument required, but only none provided present');
    var nearestTo = (0, $ctM6U.default)((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);
    if (nearestTo < 1 || nearestTo > 30) throw new RangeError('`options.nearestTo` must be between 1 and 30');
    var date = (0, $iOAFx.default)(dirtyDate);
    var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
    var minutes = date.getMinutes() + seconds / 60;
    var roundingMethod = (0, $kaptM.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod);
    var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    var remainderMinutes = minutes % nearestTo;
    var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
}

});
parcelRegister("kaptM", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $eae8817a119fdba4$export$b6474a47258c1211);
var $eae8817a119fdba4$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $eae8817a119fdba4$var$defaultRoundingMethod = 'trunc';
function $eae8817a119fdba4$export$b6474a47258c1211(method) {
    return method ? $eae8817a119fdba4$var$roundingMap[method] : $eae8817a119fdba4$var$roundingMap[$eae8817a119fdba4$var$defaultRoundingMethod];
}

});


parcelRegister("fYV7N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ba28c564c3a8f76a$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $ba28c564c3a8f76a$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var hours = (0, $ctM6U.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("6veFJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4bc104e35a9a1fdd$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $4bc104e35a9a1fdd$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var minutes = (0, $ctM6U.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("37Nrk", function(module, exports) {































































!function(e, t) {
    t(module.exports, (parcelRequire("8NFma")), (parcelRequire("fb0st")), (parcelRequire("lmhZG")), (parcelRequire("4nFE3")), (parcelRequire("8trTd")), (parcelRequire("52kL4")), (parcelRequire("fQNmZ")), (parcelRequire("3IlnT")), (parcelRequire("9CqRE")), (parcelRequire("6JwRy")), (parcelRequire("iwlPq")), (parcelRequire("5GJlZ")), (parcelRequire("7LB45")), (parcelRequire("2cJoy")), (parcelRequire("9Taqu")), (parcelRequire("kESWk")), (parcelRequire("3JQm2")), (parcelRequire("bmB1p")), (parcelRequire("1YaUy")), (parcelRequire("5vrGt")), (parcelRequire("ijnOS")), (parcelRequire("l73O9")), (parcelRequire("eQ5Ry")), (parcelRequire("6KsCe")), (parcelRequire("5PRIk")), (parcelRequire("3aRVX")), (parcelRequire("AEY6w")), (parcelRequire("bw9ox")), (parcelRequire("6LjsM")), (parcelRequire("6veFJ")), (parcelRequire("fYV7N")), (parcelRequire("fg6w7")), (parcelRequire("jdg3H")), (parcelRequire("gKDRj")), (parcelRequire("aYaZQ")), (parcelRequire("7zJ1U")), (parcelRequire("f4mhr")), (parcelRequire("5Zxq7")), (parcelRequire("4pJFe")), (parcelRequire("iMjUR")), (parcelRequire("8m0Ts")), (parcelRequire("jHVWJ")), (parcelRequire("dO07z")), (parcelRequire("93m7o")), (parcelRequire("6XRaq")), (parcelRequire("bUgTw")), (parcelRequire("lAUd9")), (parcelRequire("1dB3B")), (parcelRequire("e13sw")), (parcelRequire("5DBlA")), (parcelRequire("eU9EB")), (parcelRequire("48xcu")), (parcelRequire("94N4R")), (parcelRequire("iiN1r")), (parcelRequire("5azbE")), (parcelRequire("jEBBM")), (parcelRequire("iOAFx")), (parcelRequire("1KHEU")), (parcelRequire("ePGyo")), (parcelRequire("iy6bE")), (parcelRequire("2pmb0")), (parcelRequire("dXIky")), (parcelRequire("aWNCV")));
}(module.exports, function(e, t, r, a, n, o, s, i, p, l, c, d, u, f, h, m, y, v, D, g, k, w, b, S, C, _, M, E, P, N, Y, x, O, T, I, R, L, F, A, W, K, q, B, Q, H, j, V, U, z, $, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe, le) {
    "use strict";
    function ce(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = ce(t), ue = ce(a), fe = ce(n), he = ce(o), me = ce(s), ye = ce(i), ve = ce(p), De = ce(l), ge = ce(c), ke = ce(d), we = ce(u), be = ce(f), Se = ce(h), Ce = ce(m), _e = ce(y), Me = ce(v), Ee = ce(D), Pe = ce(g), Ne = ce(k), Ye = ce(w), xe = ce(b), Oe = ce(S), Te = ce(C), Ie = ce(_), Re = ce(M), Le = ce(E), Fe = ce(P), Ae = ce(N), We = ce(Y), Ke = ce(x), qe = ce(O), Be = ce(T), Qe = ce(I), He = ce(R), je = ce(L), Ve = ce(F), Ue = ce(A), ze = ce(W), $e = ce(K), Ge = ce(q), Je = ce(B), Xe = ce(Q), Ze = ce(H), et = ce(j), tt = ce(V), rt = ce(U), at = ce(z), nt = ce($), ot = ce(G), st = ce(J), it = ce(X), pt = ce(Z), lt = ce(ee), ct = ce(te), dt = ce(re), ut = ce(ae), ft = ce(ne), ht = ce(oe), mt = ce(se), yt = ce(ie), vt = ce(le);
    function Dt(e, t, r) {
        return t = Yt(t), function(e, t) {
            if (t && ("object" == typeof t || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return Ot(e);
        }(e, gt() ? Reflect.construct(t, r || [], Yt(e).constructor) : t.apply(e, r));
    }
    function gt() {
        try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (e) {}
        return (gt = function() {
            return !!e;
        })();
    }
    function kt(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wt(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? kt(Object(r), !0).forEach(function(t) {
                Et(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kt(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function bt(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
                var a = r.call(e, t || "default");
                if ("object" != typeof a) return a;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    function St(e) {
        return St = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, St(e);
    }
    function Ct(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _t(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, bt(a.key), a);
        }
    }
    function Mt(e, t, r) {
        return t && _t(e.prototype, t), r && _t(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Et(e, t, r) {
        return (t = bt(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function Pt() {
        return Pt = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }, Pt.apply(this, arguments);
    }
    function Nt(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && xt(e, t);
    }
    function Yt(e) {
        return Yt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, Yt(e);
    }
    function xt(e, t) {
        return xt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        }, xt(e, t);
    }
    function Ot(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function Tt(e) {
        return function(e) {
            if (Array.isArray(e)) return It(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return It(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return It(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function It(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    var Rt = function(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            default:
                return t.date({
                    width: "full"
                });
        }
    }, Lt = function(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            default:
                return t.time({
                    width: "full"
                });
        }
    }, Ft = {
        p: Lt,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return Rt(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", Rt(n, t)).replace("{{time}}", Lt(o, t));
        }
    }, At = 12, Wt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Kt(e) {
        var t = e ? "string" == typeof e || e instanceof String ? ht.default(e) : ut.default(e) : new Date;
        return qt(t) ? t : null;
    }
    function qt(e, t) {
        return t = t || new Date("1/1/1000"), he.default(e) && !ct.default(e, t);
    }
    function Bt(e, t, r) {
        if ("en" === r) return me.default(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var a = ar(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && rr() && ar(rr()) && (a = ar(rr())), me.default(e, t, {
            locale: a || null,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Qt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && Bt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Ht(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return Ke.default(We.default(Ae.default(e, i), o), a);
    }
    function jt(e, t, r) {
        var a = ar(t || rr());
        return Ge.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Vt(e) {
        return Je.default(e);
    }
    function Ut(e) {
        return Ze.default(e);
    }
    function zt(e) {
        return Xe.default(e);
    }
    function $t() {
        return $e.default(Kt());
    }
    function Gt(e, t) {
        return e && t ? it.default(e, t) : !e && !t;
    }
    function Jt(e, t) {
        return e && t ? st.default(e, t) : !e && !t;
    }
    function Xt(e, t) {
        return e && t ? pt.default(e, t) : !e && !t;
    }
    function Zt(e, t) {
        return e && t ? ot.default(e, t) : !e && !t;
    }
    function er(e, t) {
        return e && t ? nt.default(e, t) : !e && !t;
    }
    function tr(e, t, r) {
        var a, n = $e.default(t), o = et.default(r);
        try {
            a = dt.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function rr() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function ar(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function nr(e, t) {
        return Bt(qe.default(Kt(), e), "LLLL", t);
    }
    function or(e, t) {
        return Bt(qe.default(Kt(), e), "LLL", t);
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return hr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Zt(e, t.date ? t.date : t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return dt.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return Zt(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return dt.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(Kt(e)) || !1;
    }
    function ir(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return dt.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return Zt(e, t.date ? t.date : t);
        }) || !1;
    }
    function pr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return hr(e, {
            minDate: Je.default(r),
            maxDate: rt.default(a)
        }) || n && n.some(function(t) {
            return Jt(e, t);
        }) || o && !o.some(function(t) {
            return Jt(e, t);
        }) || s && !s(Kt(e)) || !1;
    }
    function lr(e, t, r, a) {
        var n = Le.default(e), o = Ie.default(e), s = Le.default(t), i = Ie.default(t), p = Le.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return hr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Xt(e, t);
        }) || o && !o.some(function(t) {
            return Xt(e, t);
        }) || s && !s(Kt(e)) || !1;
    }
    function dr(e, t, r) {
        if (!he.default(t) || !he.default(r)) return !1;
        var a = Le.default(t), n = Le.default(r);
        return a <= e && n >= e;
    }
    function ur(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate, i = new Date(e, 0, 1);
        return hr(i, {
            minDate: Ze.default(r),
            maxDate: at.default(a)
        }) || n && n.some(function(e) {
            return Gt(i, e);
        }) || o && !o.some(function(e) {
            return Gt(i, e);
        }) || s && !s(Kt(i)) || !1;
    }
    function fr(e, t, r, a) {
        var n = Le.default(e), o = Re.default(e), s = Le.default(t), i = Re.default(t), p = Le.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && Ve.default(e, r) < 0 || a && Ve.default(e, a) > 0;
    }
    function mr(e, t) {
        return t.some(function(t) {
            return Ye.default(t) === Ye.default(e) && Ne.default(t) === Ne.default(e);
        });
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && mr(e, r) || a && !mr(e, a) || n && !n(e) || !1;
    }
    function vr(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = Kt(), s = Ke.default(We.default(o, Ne.default(e)), Ye.default(e)), i = Ke.default(We.default(o, Ne.default(r)), Ye.default(r)), p = Ke.default(We.default(o, Ne.default(a)), Ye.default(a));
        try {
            n = !dt.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function Dr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = _e.default(e, 1);
        return r && Ue.default(r, n) > 0 || a && a.every(function(e) {
            return Ue.default(e, n) > 0;
        }) || !1;
    }
    function gr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ke.default(e, 1);
        return r && Ue.default(n, r) > 0 || a && a.every(function(e) {
            return Ue.default(n, e) > 0;
        }) || !1;
    }
    function kr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ee.default(e, 1);
        return r && ze.default(r, n) > 0 || a && a.every(function(e) {
            return ze.default(e, n) > 0;
        }) || !1;
    }
    function wr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = be.default(e, 1);
        return r && ze.default(n, r) > 0 || a && a.every(function(e) {
            return ze.default(n, e) > 0;
        }) || !1;
    }
    function br(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return Ve.default(e, t) >= 0;
            });
            return He.default(a);
        }
        return r ? He.default(r) : t;
    }
    function Sr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return Ve.default(e, t) <= 0;
            });
            return je.default(a);
        }
        return r ? je.default(r) : t;
    }
    function Cr() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (fe.default(o)) {
                var s = Bt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === St(o)) {
                var p = Object.keys(o), l = p[0], c = o[p[0]];
                if ("string" == typeof l && c.constructor === Array) for(var d = 0, u = c.length; d < u; d++){
                    var f = Bt(c[d], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function _r() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--holidays", r = new Map;
        return e.forEach(function(e) {
            var a = e.date, n = e.holidayName;
            if (fe.default(a)) {
                var o = Bt(a, "MM.dd.yyyy"), s = r.get(o) || {};
                if (!("className" in s) || s.className !== t || (i = s.holidayNames, p = [
                    n
                ], i.length !== p.length || !i.every(function(e, t) {
                    return e === p[t];
                }))) {
                    var i, p;
                    s.className = t;
                    var l = s.holidayNames;
                    s.holidayNames = l ? [].concat(Tt(l), [
                        n
                    ]) : [
                        n
                    ], r.set(o, s);
                }
            }
        }), r;
    }
    function Mr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = ye.default(ve.default(e, Ye.default(n[i])), Ne.default(n[i])), l = ye.default(e, (r + 1) * a);
            lt.default(p, t) && ct.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function Er(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function Pr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : At, r = Math.ceil(Le.default(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function Nr(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return ut.default(e.getTime() - 1e3 * t - r);
    }
    function Yr(e) {
        if (!fe.default(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function xr(e, t) {
        if (!fe.default(e) || !fe.default(t)) throw new Error("Invalid date received");
        var r = Yr(e), a = Yr(t);
        return ct.default(r, a);
    }
    function Or(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Le.default(r) <= s), a && i && (i = Le.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Tr = function(e) {
        function r(e) {
            var a;
            Ct(this, r), Et(Ot(a = Dt(this, r, [
                e
            ])), "renderOptions", function() {
                var e = a.props.year, t = a.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: a.onChange.bind(Ot(a), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = a.props.minDate ? Le.default(a.props.minDate) : null, n = a.props.maxDate ? Le.default(a.props.maxDate) : null;
                return n && a.state.yearsList.find(function(e) {
                    return e === n;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: a.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && a.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: a.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Et(Ot(a), "onChange", function(e) {
                a.props.onChange(e);
            }), Et(Ot(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), Et(Ot(a), "shiftYears", function(e) {
                var t = a.state.yearsList.map(function(t) {
                    return t + e;
                });
                a.setState({
                    yearsList: t
                });
            }), Et(Ot(a), "incrementYears", function() {
                return a.shiftYears(1);
            }), Et(Ot(a), "decrementYears", function() {
                return a.shiftYears(-1);
            });
            var n = e.yearDropdownItemNumber, o = e.scrollableYearDropdown, s = n || (o ? 10 : 5);
            return a.state = {
                yearsList: Or(a.props.year, s, a.props.minDate, a.props.maxDate)
            }, a.dropdownRef = t.createRef(), a;
        }
        return Nt(r, e), Mt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    if (e) {
                        var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                            return e.ariaSelected;
                        }) : null;
                        e.scrollTop = r ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ue.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Ir = mt.default(Tr), Rr = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "state", {
                dropdownVisible: !1
            }), Et(Ot(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Le.default(e.props.minDate) : 1900, r = e.props.maxDate ? Le.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), Et(Ot(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Et(Ot(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Et(Ot(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Et(Ot(e), "renderDropdown", function() {
                return de.default.createElement(Ir, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Et(Ot(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Et(Ot(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Et(Ot(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Et(Ot(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Et(Ot(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Et(Ot(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), t;
    }(de.default.Component), Lr = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Et(Ot(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(Ot(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Et(Ot(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), Et(Ot(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), t;
    }(de.default.Component), Fr = mt.default(Lr), Ar = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "state", {
                dropdownVisible: !1
            }), Et(Ot(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Et(Ot(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Et(Ot(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Et(Ot(e), "renderDropdown", function(t) {
                return de.default.createElement(Fr, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Et(Ot(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), Et(Ot(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Et(Ot(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return or(e, t.props.locale);
                    } : function(e) {
                        return nr(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), t;
    }(de.default.Component);
    function Wr(e, t) {
        for(var r = [], a = Vt(e), n = Vt(t); !lt.default(a, n);)r.push(Kt(a)), a = ke.default(a, 1);
        return r;
    }
    var Kr = function(e) {
        function t(e) {
            var r;
            return Ct(this, t), Et(Ot(r = Dt(this, t, [
                e
            ])), "renderOptions", function() {
                return r.state.monthYearsList.map(function(e) {
                    var t = Fe.default(e), a = Gt(r.props.date, e) && Jt(r.props.date, e);
                    return de.default.createElement("div", {
                        className: a ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: r.onChange.bind(Ot(r), t),
                        "aria-selected": a ? "true" : void 0
                    }, a ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Bt(e, r.props.dateFormat, r.props.locale));
                });
            }), Et(Ot(r), "onChange", function(e) {
                return r.props.onChange(e);
            }), Et(Ot(r), "handleClickOutside", function() {
                r.props.onCancel();
            }), r.state = {
                monthYearsList: Wr(r.props.minDate, r.props.maxDate)
            }, r;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    var e = ue.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), t;
    }(de.default.Component), qr = mt.default(Kr), Br = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "state", {
                dropdownVisible: !1
            }), Et(Ot(e), "renderSelectOptions", function() {
                for(var t = Vt(e.props.minDate), r = Vt(e.props.maxDate), a = []; !lt.default(t, r);){
                    var n = Fe.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, Bt(t, e.props.dateFormat, e.props.locale))), t = ke.default(t, 1);
                }
                return a;
            }), Et(Ot(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Et(Ot(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Fe.default(Vt(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Et(Ot(e), "renderReadView", function(t) {
                var r = Bt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Et(Ot(e), "renderDropdown", function() {
                return de.default.createElement(qr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Et(Ot(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Et(Ot(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = Kt(parseInt(t));
                Gt(e.props.date, r) && Jt(e.props.date, r) || e.props.onChange(r);
            }), Et(Ot(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), t;
    }(de.default.Component), Qr = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "dayEl", de.default.createRef()), Et(Ot(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Et(Ot(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Et(Ot(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Et(Ot(e), "isSameDay", function(t) {
                return Zt(e.props.day, t);
            }), Et(Ot(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !(e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected)) && (e.isSameDay(e.props.preSelection) || e.isSameWeek(e.props.preSelection));
            }), Et(Ot(e), "isDisabled", function() {
                return sr(e.props.day, e.props);
            }), Et(Ot(e), "isExcluded", function() {
                return ir(e.props.day, e.props);
            }), Et(Ot(e), "isStartOfWeek", function() {
                return Zt(e.props.day, jt(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Et(Ot(e), "isSameWeek", function(t) {
                return e.props.showWeekPicker && Zt(t, jt(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), Et(Ot(e), "getHighLightedClass", function() {
                var t = e.props, r = t.day, a = t.highlightDates;
                if (!a) return !1;
                var n = Bt(r, "MM.dd.yyyy");
                return a.get(n);
            }), Et(Ot(e), "getHolidaysClass", function() {
                var t = e.props, r = t.day, a = t.holidays;
                if (!a) return !1;
                var n = Bt(r, "MM.dd.yyyy");
                return a.has(n) ? [
                    a.get(n).className
                ] : void 0;
            }), Et(Ot(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && tr(r, a, n);
            }), Et(Ot(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, c = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !c || !i && e.isDisabled()) && (n && l && (ct.default(c, l) || er(c, l)) ? tr(a, c, l) : (o && p && (lt.default(c, p) || er(c, p)) || !(!s || !p || l || !lt.default(c, p) && !er(c, p))) && tr(a, p, c));
            }), Et(Ot(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Zt(a, o ? s : n);
            }), Et(Ot(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Zt(a, o || s ? i : n);
            }), Et(Ot(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Zt(a, r);
            }), Et(Ot(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Zt(n, r);
            }), Et(Ot(e), "isWeekend", function() {
                var t = xe.default(e.props.day);
                return 0 === t || 6 === t;
            }), Et(Ot(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === Ie.default(e.props.day);
            }), Et(Ot(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (Ie.default(e.props.day) + 1) % 12 === e.props.month;
            }), Et(Ot(e), "isCurrentDay", function() {
                return e.isSameDay(Kt());
            }), Et(Ot(e), "isSelected", function() {
                return e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected);
            }), Et(Ot(e), "getClassNames", function(t) {
                var r, a = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ue.default("react-datepicker__day", a, "react-datepicker__day--" + Bt(e.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"), e.getHolidaysClass());
            }), Et(Ot(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(Bt(r, "PPPP", e.props.locale));
            }), Et(Ot(e), "getTitle", function() {
                var t = e.props, r = t.day, a = t.holidays, n = void 0 === a ? new Map : a, o = t.excludeDates, s = Bt(r, "MM.dd.yyyy"), i = [];
                return n.has(s) && i.push.apply(i, Tt(n.get(s).holidayNames)), e.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return Zt(e.date ? e.date : e, r);
                }).map(function(e) {
                    return e.message;
                })), i.join(", ");
            }), Et(Ot(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return (!e.props.showWeekPicker || !e.props.showWeekNumber && e.isStartOfWeek()) && (e.isKeyboardSelected() || e.isSameDay(a) && Zt(n, a)) ? 0 : -1;
            }), Et(Ot(e), "handleFocusDay", function() {
                var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = !1;
                0 === e.getTabIndex() && !r.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (a = !0), e.props.inline && !e.props.shouldFocusDayInline && (a = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (a = !0), e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() && (a = !1), e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() && (a = !1)), a && (null === (t = e.dayEl.current) || void 0 === t || t.focus({
                    preventScroll: !0
                }));
            }), Et(Ot(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Oe.default(e.props.day), e.props.day) : Oe.default(e.props.day);
            }), Et(Ot(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    title: e.getTitle(),
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected() || e.isInRange()
                }, e.renderDayContents(), "" !== e.getTitle() && de.default.createElement("span", {
                    className: "overlay"
                }, e.getTitle()));
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), t;
    }(de.default.Component), Hr = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "weekNumberEl", de.default.createRef()), Et(Ot(e), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), Et(Ot(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Et(Ot(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Zt(e.props.date, e.props.selected) && Zt(e.props.date, e.props.preSelection);
            }), Et(Ot(e), "getTabIndex", function() {
                return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || Zt(e.props.date, e.props.selected) && Zt(e.props.preSelection, e.props.selected)) ? 0 : -1;
            }), Et(Ot(e), "handleFocusWeekNumber", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && Zt(e.props.date, e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && e.weekNumberEl.current && e.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusWeekNumber();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusWeekNumber(e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick,
                        "react-datepicker__week-number--selected": Zt(this.props.date, this.props.selected),
                        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        ref: this.weekNumberEl,
                        className: ue.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick,
                        onKeyDown: this.handleOnKeyDown,
                        tabIndex: this.getTabIndex()
                    }, t);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        ariaLabelPrefix: "week "
                    };
                }
            }
        ]), t;
    }(de.default.Component), jr = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Et(Ot(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Et(Ot(e), "handleWeekClick", function(t, r, a) {
                if ("function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.showWeekPicker) {
                    var n = jt(t, e.props.locale, e.props.calendarStartDay);
                    e.handleDayClick(n, a);
                }
                e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Et(Ot(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : function(e, t) {
                    var r = t && ar(t) || rr() && ar(rr());
                    return Te.default(e, r ? {
                        locale: r
                    } : null);
                }(t);
            }), Et(Ot(e), "renderDays", function() {
                var t = jt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(Ot(e), t, a) : void 0;
                    r.push(de.default.createElement(Hr, {
                        key: "W",
                        weekNumber: a,
                        date: t,
                        onClick: n,
                        selected: e.props.selected,
                        preSelection: e.props.preSelection,
                        ariaLabelPrefix: e.props.ariaLabelPrefix,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Qr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(Ot(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(Ot(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        holidays: e.props.holidays,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), Et(Ot(e), "startOfWeek", function() {
                return jt(e.props.day, e.props.locale, e.props.calendarStartDay);
            }), Et(Ot(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Zt(e.startOfWeek(), e.props.selected) && Zt(e.startOfWeek(), e.props.preSelection);
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    var e = {
                        "react-datepicker__week": !0,
                        "react-datepicker__week--selected": Zt(this.startOfWeek(), this.props.selected),
                        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        className: ue.default(e)
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), t;
    }(de.default.Component), Vr = "two_columns", Ur = "three_columns", zr = "four_columns", $r = Et(Et(Et({}, Vr, {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }), Ur, {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }), zr, {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    });
    function Gr(e, t) {
        return e ? zr : t ? Vr : Ur;
    }
    var Jr = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "MONTH_REFS", Tt(Array(12)).map(function() {
                return de.default.createRef();
            })), Et(Ot(e), "QUARTER_REFS", Tt(Array(4)).map(function() {
                return de.default.createRef();
            })), Et(Ot(e), "isDisabled", function(t) {
                return sr(t, e.props);
            }), Et(Ot(e), "isExcluded", function(t) {
                return ir(t, e.props);
            }), Et(Ot(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Et(Ot(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Et(Ot(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Et(Ot(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Jt(qe.default(a, t), n);
            }), Et(Ot(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Xt(Be.default(a, t), n);
            }), Et(Ot(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Jt(qe.default(a, t), o);
            }), Et(Ot(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Xt(Be.default(a, t), o);
            }), Et(Ot(e), "isInSelectingRangeMonth", function(t) {
                var r, a = e.props, n = a.day, o = a.selectsStart, s = a.selectsEnd, i = a.selectsRange, p = a.startDate, l = a.endDate, c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !c) && (o && l ? lr(c, l, t, n) : (s && p || !(!i || !p || l)) && lr(p, c, t, n));
            }), Et(Ot(e), "isSelectingMonthRangeStart", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var a = e.props, n = a.day, o = a.startDate, s = a.selectsStart, i = qe.default(n, t), p = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return Jt(i, s ? p : o);
            }), Et(Ot(e), "isSelectingMonthRangeEnd", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var a = e.props, n = a.day, o = a.endDate, s = a.selectsEnd, i = a.selectsRange, p = qe.default(n, t), l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return Jt(p, s || i ? l : o);
            }), Et(Ot(e), "isInSelectingRangeQuarter", function(t) {
                var r, a = e.props, n = a.day, o = a.selectsStart, s = a.selectsEnd, i = a.selectsRange, p = a.startDate, l = a.endDate, c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !c) && (o && l ? fr(c, l, t, n) : (s && p || !(!i || !p || l)) && fr(p, c, t, n));
            }), Et(Ot(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return Jt(t, r) || Jt(a, r);
            }), Et(Ot(e), "isCurrentMonth", function(e, t) {
                return Le.default(e) === Le.default(Kt()) && t === Ie.default(Kt());
            }), Et(Ot(e), "isCurrentQuarter", function(e, t) {
                return Le.default(e) === Le.default(Kt()) && t === Re.default(Kt());
            }), Et(Ot(e), "isSelectedMonth", function(e, t, r) {
                return Ie.default(r) === t && Le.default(e) === Le.default(r);
            }), Et(Ot(e), "isSelectedQuarter", function(e, t, r) {
                return Re.default(e) === t && Le.default(e) === Le.default(r);
            }), Et(Ot(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = jt(Vt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(jr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Ie.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    holidays: e.props.holidays,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    showWeekPicker: e.props.showWeekPicker,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ge.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), Et(Ot(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Vt(qe.default(e.props.day, r)), t);
            }), Et(Ot(e), "onMonthMouseEnter", function(t) {
                e.handleDayMouseEnter(Vt(qe.default(e.props.day, t)));
            }), Et(Ot(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Et(Ot(e), "onMonthKeyDown", function(t, r) {
                var a = e.props, n = a.selected, o = a.preSelection, s = a.disabledKeyboardNavigation, i = a.showTwoColumnMonthYearPicker, p = a.showFourColumnMonthYearPicker, l = a.setPreSelection, c = t.key;
                if ("Tab" !== c && t.preventDefault(), !s) {
                    var d = Gr(p, i), u = $r[d].verticalNavigationOffset, f = $r[d].grid;
                    switch(c){
                        case "Enter":
                            e.onMonthClick(t, r), l(n);
                            break;
                        case "ArrowRight":
                            e.handleMonthNavigation(11 === r ? 0 : r + 1, ke.default(o, 1));
                            break;
                        case "ArrowLeft":
                            e.handleMonthNavigation(0 === r ? 11 : r - 1, _e.default(o, 1));
                            break;
                        case "ArrowUp":
                            e.handleMonthNavigation(f[0].includes(r) ? r + 12 - u : r - u, _e.default(o, u));
                            break;
                        case "ArrowDown":
                            e.handleMonthNavigation(f[f.length - 1].includes(r) ? r - 12 + u : r + u, ke.default(o, u));
                    }
                }
            }), Et(Ot(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(zt(Be.default(e.props.day, r)), t);
            }), Et(Ot(e), "onQuarterMouseEnter", function(t) {
                e.handleDayMouseEnter(zt(Be.default(e.props.day, t)));
            }), Et(Ot(e), "handleQuarterNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.QUARTER_REFS[t - 1].current && e.QUARTER_REFS[t - 1].current.focus());
            }), Et(Ot(e), "onQuarterKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onQuarterClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleQuarterNavigation(4 === r ? 1 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleQuarterNavigation(1 === r ? 4 : r - 1, Me.default(e.props.preSelection, 1));
                }
            }), Et(Ot(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, c = r.monthClassName, d = r.excludeDates, u = r.includeDates, f = c ? c(qe.default(a, t)) : void 0, h = qe.default(a, t);
                return ue.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), f, {
                    "react-datepicker__month-text--disabled": (i || p || d || u) && pr(h, e.props),
                    "react-datepicker__month-text--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && Ie.default(l) === t,
                    "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(t),
                    "react-datepicker__month-text--in-range": lr(n, o, t, a),
                    "react-datepicker__month-text--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month-text--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(t),
                    "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Et(Ot(e), "getTabIndex", function(t) {
                var r = Ie.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Et(Ot(e), "getQuarterTabIndex", function(t) {
                var r = Re.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Et(Ot(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.chooseDayAriaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = qe.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(Bt(p, "MMMM yyyy"));
            }), Et(Ot(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, c = r.disabledKeyboardNavigation;
                return ue.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter-text--disabled": (i || p) && cr(Be.default(a, t), e.props),
                    "react-datepicker__quarter-text--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter-text--keyboard-selected": !c && Re.default(l) === t,
                    "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(t),
                    "react-datepicker__quarter-text--in-range": fr(n, o, t, a),
                    "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(t)
                });
            }), Et(Ot(e), "getMonthContent", function(t) {
                var r = e.props, a = r.showFullMonthYearPicker, n = r.renderMonthContent, o = r.locale, s = r.day, i = or(t, o), p = nr(t, o);
                return n ? n(t, i, p, s) : a ? p : i;
            }), Et(Ot(e), "getQuarterContent", function(t) {
                var r = e.props, a = r.renderQuarterContent, n = function(e, t) {
                    return Bt(Be.default(Kt(), e), "QQQ", t);
                }(t, r.locale);
                return a ? a(t, n) : n;
            }), Et(Ot(e), "renderMonths", function() {
                var t = e.props, r = t.showTwoColumnMonthYearPicker, a = t.showFourColumnMonthYearPicker, n = t.day, o = t.selected;
                return $r[Gr(a, r)].grid.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, t.map(function(t, r) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: r,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            onMouseEnter: function() {
                                return e.onMonthMouseEnter(t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(n, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(n, t, o)
                        }, e.getMonthContent(t));
                    }));
                });
            }), Et(Ot(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        ref: e.QUARTER_REFS[n],
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        onKeyDown: function(r) {
                            e.onQuarterKeyDown(r, t);
                        },
                        onMouseEnter: function() {
                            return e.onQuarterMouseEnter(t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a),
                        tabIndex: e.getQuarterTabIndex(t),
                        "aria-current": e.isCurrentQuarter(r, t) ? "date" : void 0
                    }, e.getQuarterContent(t));
                }));
            }), Et(Ot(e), "getClassNames", function() {
                var t = e.props, r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker, i = t.showWeekPicker;
                return ue.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                }, {
                    "react-datepicker__weekPicker": i
                });
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(Bt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), t;
    }(de.default.Component), Xr = function(e) {
        function t() {
            var e;
            Ct(this, t);
            for(var r = arguments.length, a = new Array(r), n = 0; n < r; n++)a[n] = arguments[n];
            return Et(Ot(e = Dt(this, t, [].concat(a))), "state", {
                height: null
            }), Et(Ot(e), "scrollToTheSelectedTime", function() {
                requestAnimationFrame(function() {
                    e.list && (e.list.scrollTop = e.centerLi && t.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - e.header.clientHeight : e.list.clientHeight, e.centerLi));
                });
            }), Et(Ot(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && vr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && yr(t, e.props) || e.props.onChange(t);
            }), Et(Ot(e), "isSelectedTime", function(t) {
                var r, a;
                return e.props.selected && (r = e.props.selected, a = t, Nr(r).getTime() === Nr(a).getTime());
            }), Et(Ot(e), "isDisabledTime", function(t) {
                return (e.props.minTime || e.props.maxTime) && vr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && yr(t, e.props);
            }), Et(Ot(e), "liClasses", function(t) {
                var r = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t) : void 0
                ];
                return e.isSelectedTime(t) && r.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(t) && r.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Ye.default(t) + Ne.default(t)) % e.props.intervals != 0 && r.push("react-datepicker__time-list-item--injected"), r.join(" ");
            }), Et(Ot(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "ArrowUp" !== t.key && "ArrowLeft" !== t.key || !t.target.previousSibling || (t.preventDefault(), t.target.previousSibling.focus()), "ArrowDown" !== t.key && "ArrowRight" !== t.key || !t.target.nextSibling || (t.preventDefault(), t.target.nextSibling.focus()), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Et(Ot(e), "renderTimes", function() {
                for(var t, r = [], a = e.props.format ? e.props.format : "p", n = e.props.intervals, o = e.props.selected || e.props.openToDate || Kt(), s = (t = o, $e.default(t)), i = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), p = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(o), l = p / n, c = 0; c < l; c++){
                    var d = ye.default(s, c * n);
                    if (r.push(d), i) {
                        var u = Mr(s, d, c, n, i);
                        r = r.concat(u);
                    }
                }
                var f = r.reduce(function(e, t) {
                    return t.getTime() <= o.getTime() ? t : e;
                }, r[0]);
                return r.map(function(t, r) {
                    return de.default.createElement("li", {
                        key: r,
                        onClick: e.handleClick.bind(Ot(e), t),
                        className: e.liClasses(t),
                        ref: function(r) {
                            t === f && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: t === f ? 0 : -1,
                        role: "option",
                        "aria-selected": e.isSelectedTime(t) ? "true" : void 0,
                        "aria-disabled": e.isDisabledTime(t) ? "true" : void 0
                    }, Bt(t, a, e.props.locale));
                });
            }), e;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        role: "listbox",
                        "aria-label": this.props.timeCaption
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), t;
    }(de.default.Component);
    Et(Xr, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var Zr = function(e) {
        function t(e) {
            var r;
            return Ct(this, t), Et(Ot(r = Dt(this, t, [
                e
            ])), "YEAR_REFS", Tt(Array(r.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), Et(Ot(r), "isDisabled", function(e) {
                return sr(e, r.props);
            }), Et(Ot(r), "isExcluded", function(e) {
                return ir(e, r.props);
            }), Et(Ot(r), "selectingDate", function() {
                var e;
                return null !== (e = r.props.selectingDate) && void 0 !== e ? e : r.props.preSelection;
            }), Et(Ot(r), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(Ot(r));
                window.requestAnimationFrame(t);
            }), Et(Ot(r), "handleYearClick", function(e, t) {
                r.props.onDayClick && r.props.onDayClick(e, t);
            }), Et(Ot(r), "handleYearNavigation", function(e, t) {
                var a = r.props, n = a.date, o = a.yearItemNumber, s = Pr(n, o).startPeriod;
                r.isDisabled(t) || r.isExcluded(t) || (r.props.setPreSelection(t), e - s == -1 ? r.updateFocusOnPaginate(o - 1) : e - s === o ? r.updateFocusOnPaginate(0) : r.YEAR_REFS[e - s].current.focus());
            }), Et(Ot(r), "isSameDay", function(e, t) {
                return Zt(e, t);
            }), Et(Ot(r), "isCurrentYear", function(e) {
                return e === Le.default(Kt());
            }), Et(Ot(r), "isRangeStart", function(e) {
                return r.props.startDate && r.props.endDate && Gt(Qe.default(Kt(), e), r.props.startDate);
            }), Et(Ot(r), "isRangeEnd", function(e) {
                return r.props.startDate && r.props.endDate && Gt(Qe.default(Kt(), e), r.props.endDate);
            }), Et(Ot(r), "isInRange", function(e) {
                return dr(e, r.props.startDate, r.props.endDate);
            }), Et(Ot(r), "isInSelectingRange", function(e) {
                var t = r.props, a = t.selectsStart, n = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(a || n || o) || !r.selectingDate()) && (a && i ? dr(e, r.selectingDate(), i) : (n && s || !(!o || !s || i)) && dr(e, s, r.selectingDate()));
            }), Et(Ot(r), "isSelectingRangeStart", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, a = t.startDate, n = t.selectsStart, o = Qe.default(Kt(), e);
                return Gt(o, n ? r.selectingDate() : a);
            }), Et(Ot(r), "isSelectingRangeEnd", function(e) {
                if (!r.isInSelectingRange(e)) return !1;
                var t = r.props, a = t.endDate, n = t.selectsEnd, o = t.selectsRange, s = Qe.default(Kt(), e);
                return Gt(s, n || o ? r.selectingDate() : a);
            }), Et(Ot(r), "isKeyboardSelected", function(e) {
                var t = Ut(Qe.default(r.props.date, e));
                return !r.props.disabledKeyboardNavigation && !r.props.inline && !Zt(t, Ut(r.props.selected)) && Zt(t, Ut(r.props.preSelection));
            }), Et(Ot(r), "onYearClick", function(e, t) {
                var a = r.props.date;
                r.handleYearClick(Ut(Qe.default(a, t)), e);
            }), Et(Ot(r), "onYearKeyDown", function(e, t) {
                var a = e.key;
                if (!r.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        r.onYearClick(e, t), r.props.setPreSelection(r.props.selected);
                        break;
                    case "ArrowRight":
                        r.handleYearNavigation(t + 1, be.default(r.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        r.handleYearNavigation(t - 1, Ee.default(r.props.preSelection, 1));
                }
            }), Et(Ot(r), "getYearClassNames", function(e) {
                var t = r.props, a = t.minDate, n = t.maxDate, o = t.selected, s = t.excludeDates, i = t.includeDates, p = t.filterDate;
                return ue.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Le.default(o),
                    "react-datepicker__year-text--disabled": (a || n || s || i || p) && ur(e, r.props),
                    "react-datepicker__year-text--keyboard-selected": r.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": r.isRangeStart(e),
                    "react-datepicker__year-text--range-end": r.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": r.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": r.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": r.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": r.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": r.isCurrentYear(e)
                });
            }), Et(Ot(r), "getYearTabIndex", function(e) {
                return r.props.disabledKeyboardNavigation ? "-1" : e === Le.default(r.props.preSelection) ? "0" : "-1";
            }), Et(Ot(r), "getYearContainerClassNames", function() {
                var e = r.props, t = e.selectingDate, a = e.selectsStart, n = e.selectsEnd, o = e.selectsRange;
                return ue.default("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": t && (a || n || o)
                });
            }), Et(Ot(r), "getYearContent", function(e) {
                return r.props.renderYearContent ? r.props.renderYearContent(e) : e;
            }), r;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = r.date, n = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave, i = Pr(a, n), p = i.startPeriod, l = i.endPeriod, c = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - p],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            onMouseEnter: function(e) {
                                return o(e, r);
                            },
                            onMouseLeave: function(e) {
                                return s(e, r);
                            },
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, e.getYearContent(r)));
                    }, d = p; d <= l; d++)c(d);
                    return de.default.createElement("div", {
                        className: this.getYearContainerClassNames()
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper",
                        onMouseLeave: this.props.clearSelectingDate
                    }, t));
                }
            }
        ]), t;
    }(de.default.Component), ea = function(e) {
        function t(e) {
            var r;
            return Ct(this, t), Et(Ot(r = Dt(this, t, [
                e
            ])), "onTimeChange", function(e) {
                r.setState({
                    time: e
                });
                var t = r.props.date, a = t instanceof Date && !isNaN(t) ? t : new Date;
                a.setHours(e.split(":")[0]), a.setMinutes(e.split(":")[1]), r.props.onChange(a);
            }), Et(Ot(r), "renderTimeInput", function() {
                var e = r.state.time, t = r.props, a = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: a,
                    value: e,
                    onChange: r.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        r.onTimeChange(e.target.value || n);
                    }
                });
            }), r.state = {
                time: r.props.timeString
            }, r;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), t;
    }(de.default.Component);
    function ta(e) {
        var t = e.className, r = e.children;
        return de.default.createElement("div", {
            className: t
        }, r);
    }
    var ra = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], aa = function(e) {
        function t(e) {
            var r;
            return Ct(this, t), Et(Ot(r = Dt(this, t, [
                e
            ])), "handleClickOutside", function(e) {
                r.props.onClickOutside(e);
            }), Et(Ot(r), "setClickOutsideRef", function() {
                return r.containerRef.current;
            }), Et(Ot(r), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return ra.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && r.props.onDropdownFocus();
            }), Et(Ot(r), "getDateInView", function() {
                var e = r.props, t = e.preSelection, a = e.selected, n = e.openToDate, o = br(r.props), s = Sr(r.props), i = Kt(), p = n || a || t;
                return p || (o && ct.default(i, o) ? o : s && lt.default(i, s) ? s : i);
            }), Et(Ot(r), "increaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ke.default(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Et(Ot(r), "decreaseMonth", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: _e.default(t, 1)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Et(Ot(r), "handleDayClick", function(e, t, a) {
                r.props.onSelect(e, t, a), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Et(Ot(r), "handleDayMouseEnter", function(e) {
                r.setState({
                    selectingDate: e
                }), r.props.onDayMouseEnter && r.props.onDayMouseEnter(e);
            }), Et(Ot(r), "handleMonthMouseLeave", function() {
                r.setState({
                    selectingDate: null
                }), r.props.onMonthMouseLeave && r.props.onMonthMouseLeave();
            }), Et(Ot(r), "handleYearMouseEnter", function(e, t) {
                r.setState({
                    selectingDate: Qe.default(Kt(), t)
                }), r.props.onYearMouseEnter && r.props.onYearMouseEnter(e, t);
            }), Et(Ot(r), "handleYearMouseLeave", function(e, t) {
                r.props.onYearMouseLeave && r.props.onYearMouseLeave(e, t);
            }), Et(Ot(r), "handleYearChange", function(e) {
                r.props.onYearChange && (r.props.onYearChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Et(Ot(r), "handleMonthChange", function(e) {
                r.handleCustomMonthChange(e), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(e), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(e);
            }), Et(Ot(r), "handleCustomMonthChange", function(e) {
                r.props.onMonthChange && (r.props.onMonthChange(e), r.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }), Et(Ot(r), "handleMonthYearChange", function(e) {
                r.handleYearChange(e), r.handleMonthChange(e);
            }), Et(Ot(r), "changeYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Qe.default(r, e)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Et(Ot(r), "changeMonth", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: qe.default(r, e)
                    };
                }, function() {
                    return r.handleMonthChange(r.state.date);
                });
            }), Et(Ot(r), "changeMonthYear", function(e) {
                r.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Qe.default(qe.default(r, Ie.default(e)), Le.default(e))
                    };
                }, function() {
                    return r.handleMonthYearChange(r.state.date);
                });
            }), Et(Ot(r), "header", function() {
                var e = jt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, r.props.locale, r.props.calendarStartDay), t = [];
                return r.props.showWeekNumbers && t.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, r.props.weekLabel || "#")), t.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(t) {
                    var a = De.default(e, t), n = r.formatWeekday(a, r.props.locale), o = r.props.weekDayClassName ? r.props.weekDayClassName(a) : void 0;
                    return de.default.createElement("div", {
                        key: t,
                        className: ue.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), Et(Ot(r), "formatWeekday", function(e, t) {
                return r.props.formatWeekDay ? function(e, t, r) {
                    return t(Bt(e, "EEEE", r));
                }(e, r.props.formatWeekDay, t) : r.props.useWeekdaysShort ? function(e, t) {
                    return Bt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Bt(e, "EEEEEE", t);
                }(e, t);
            }), Et(Ot(r), "decreaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Ee.default(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Et(Ot(r), "clearSelectingDate", function() {
                r.setState({
                    selectingDate: null
                });
            }), Et(Ot(r), "renderPreviousButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = kr(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? At : a, o = Pr(Ut(Ee.default(e, n)), n).endPeriod, s = r && Le.default(r);
                                return s && s > o || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = Dr(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], a = r.decreaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (a = r.decreaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), a = null);
                        var n = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = r.props, l = p.previousMonthAriaLabel, c = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, d = p.previousYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Previous Year" : d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: a,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": n ? u : c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? r.props.previousYearButtonLabel : r.props.previousMonthButtonLabel));
                    }
                }
            }), Et(Ot(r), "increaseYear", function() {
                r.setState(function(e) {
                    var t = e.date;
                    return {
                        date: be.default(t, r.props.showYearPicker ? r.props.yearItemNumber : 1)
                    };
                }, function() {
                    return r.handleYearChange(r.state.date);
                });
            }), Et(Ot(r), "renderNextButton", function() {
                if (!r.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case r.props.showMonthYearPicker:
                            e = wr(r.state.date, r.props);
                            break;
                        case r.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? At : a, o = Pr(be.default(e, n), n).startPeriod, s = r && Le.default(r);
                                return s && s < o || !1;
                            }(r.state.date, r.props);
                            break;
                        default:
                            e = gr(r.state.date, r.props);
                    }
                    if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !e) && !r.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        r.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), r.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var a = r.increaseMonth;
                        (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (a = r.increaseYear), e && r.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), a = null);
                        var n = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, o = r.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = r.props, l = p.nextMonthAriaLabel, c = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, d = p.nextYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Next Year" : d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: a,
                            onKeyDown: r.props.handleOnKeyDown,
                            "aria-label": n ? u : c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? r.props.nextYearButtonLabel : r.props.nextMonthButtonLabel));
                    }
                }
            }), Et(Ot(r), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return r.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), r.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), r.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, Bt(e, r.props.dateFormat, r.props.locale));
            }), Et(Ot(r), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showYearDropdown && !e) return de.default.createElement(Rr, {
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    date: r.state.date,
                    onSelect: r.props.onSelect,
                    setOpen: r.props.setOpen,
                    dropdownMode: r.props.dropdownMode,
                    onChange: r.changeYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    year: Le.default(r.state.date),
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber
                });
            }), Et(Ot(r), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthDropdown && !e) return de.default.createElement(Ar, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    onChange: r.changeMonth,
                    month: Ie.default(r.state.date),
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown
                });
            }), Et(Ot(r), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (r.props.showMonthYearDropdown && !e) return de.default.createElement(Br, {
                    dropdownMode: r.props.dropdownMode,
                    locale: r.props.locale,
                    dateFormat: r.props.dateFormat,
                    onChange: r.changeMonthYear,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    date: r.state.date,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown
                });
            }), Et(Ot(r), "handleTodayButtonClick", function(e) {
                r.props.onSelect($t(), e), r.props.setPreSelection && r.props.setPreSelection($t());
            }), Et(Ot(r), "renderTodayButton", function() {
                if (r.props.todayButton && !r.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return r.handleTodayButtonClick(e);
                    }
                }, r.props.todayButton);
            }), Et(Ot(r), "renderDefaultHeader", function(e) {
                var t = e.monthDate, a = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(r.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, r.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),
                    onFocus: r.handleDropdownFocus
                }, r.renderMonthDropdown(0 !== a), r.renderMonthYearDropdown(0 !== a), r.renderYearDropdown(0 !== a)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Et(Ot(r), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, a = e.i;
                if (r.props.showTimeSelect && !r.state.monthContainer || r.props.showTimeSelectOnly) return null;
                var n = Dr(r.state.date, r.props), o = gr(r.state.date, r.props), s = kr(r.state.date, r.props), i = wr(r.state.date, r.props), p = !r.props.showMonthYearPicker && !r.props.showQuarterYearPicker && !r.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: r.props.onDropdownFocus
                }, r.props.renderCustomHeader(wt(wt({}, r.state), {}, {
                    customHeaderCount: a,
                    monthDate: t,
                    changeMonth: r.changeMonth,
                    changeYear: r.changeYear,
                    decreaseMonth: r.decreaseMonth,
                    increaseMonth: r.increaseMonth,
                    decreaseYear: r.decreaseYear,
                    increaseYear: r.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, r.header(t)));
            }), Et(Ot(r), "renderYearHeader", function() {
                var e = r.state.date, t = r.props, a = t.showYearPicker, n = Pr(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, a ? "".concat(o, " - ").concat(s) : Le.default(e));
            }), Et(Ot(r), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== r.props.renderCustomHeader:
                        return r.renderCustomHeader(e);
                    case r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker:
                        return r.renderYearHeader(e);
                    default:
                        return r.renderDefaultHeader(e);
                }
            }), Et(Ot(r), "renderMonths", function() {
                var e;
                if (!r.props.showTimeSelectOnly && !r.props.showYearPicker) {
                    for(var t = [], a = r.props.showPreviousMonths ? r.props.monthsShown - 1 : 0, n = _e.default(r.state.date, a), o = null !== (e = r.props.monthSelectedIn) && void 0 !== e ? e : a, s = 0; s < r.props.monthsShown; ++s){
                        var i = s - o + a, p = ke.default(n, i), l = "month-".concat(s), c = s < r.props.monthsShown - 1, d = s > 0;
                        t.push(de.default.createElement("div", {
                            key: l,
                            ref: function(e) {
                                r.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, r.renderHeader({
                            monthDate: p,
                            i: s
                        }), de.default.createElement(Jr, {
                            chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: r.props.monthAriaLabelPrefix,
                            onChange: r.changeMonthYear,
                            day: p,
                            dayClassName: r.props.dayClassName,
                            calendarStartDay: r.props.calendarStartDay,
                            monthClassName: r.props.monthClassName,
                            onDayClick: r.handleDayClick,
                            handleOnKeyDown: r.props.handleOnDayKeyDown,
                            onDayMouseEnter: r.handleDayMouseEnter,
                            onMouseLeave: r.handleMonthMouseLeave,
                            onWeekSelect: r.props.onWeekSelect,
                            orderInDisplay: s,
                            formatWeekNumber: r.props.formatWeekNumber,
                            locale: r.props.locale,
                            minDate: r.props.minDate,
                            maxDate: r.props.maxDate,
                            excludeDates: r.props.excludeDates,
                            excludeDateIntervals: r.props.excludeDateIntervals,
                            highlightDates: r.props.highlightDates,
                            holidays: r.props.holidays,
                            selectingDate: r.state.selectingDate,
                            includeDates: r.props.includeDates,
                            includeDateIntervals: r.props.includeDateIntervals,
                            inline: r.props.inline,
                            shouldFocusDayInline: r.props.shouldFocusDayInline,
                            fixedHeight: r.props.fixedHeight,
                            filterDate: r.props.filterDate,
                            preSelection: r.props.preSelection,
                            setPreSelection: r.props.setPreSelection,
                            selected: r.props.selected,
                            selectsStart: r.props.selectsStart,
                            selectsEnd: r.props.selectsEnd,
                            selectsRange: r.props.selectsRange,
                            selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                            showWeekNumbers: r.props.showWeekNumbers,
                            startDate: r.props.startDate,
                            endDate: r.props.endDate,
                            peekNextMonth: r.props.peekNextMonth,
                            setOpen: r.props.setOpen,
                            shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                            renderDayContents: r.props.renderDayContents,
                            renderMonthContent: r.props.renderMonthContent,
                            renderQuarterContent: r.props.renderQuarterContent,
                            renderYearContent: r.props.renderYearContent,
                            disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                            showMonthYearPicker: r.props.showMonthYearPicker,
                            showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                            showYearPicker: r.props.showYearPicker,
                            showQuarterYearPicker: r.props.showQuarterYearPicker,
                            showWeekPicker: r.props.showWeekPicker,
                            isInputFocused: r.props.isInputFocused,
                            containerRef: r.containerRef,
                            monthShowsDuplicateDaysEnd: c,
                            monthShowsDuplicateDaysStart: d
                        })));
                    }
                    return t;
                }
            }), Et(Ot(r), "renderYears", function() {
                if (!r.props.showTimeSelectOnly) return r.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, r.renderHeader(), de.default.createElement(Zr, Pt({
                    onDayClick: r.handleDayClick,
                    selectingDate: r.state.selectingDate,
                    clearSelectingDate: r.clearSelectingDate,
                    date: r.state.date
                }, r.props, {
                    onYearMouseEnter: r.handleYearMouseEnter,
                    onYearMouseLeave: r.handleYearMouseLeave
                }))) : void 0;
            }), Et(Ot(r), "renderTimeSection", function() {
                if (r.props.showTimeSelect && (r.state.monthContainer || r.props.showTimeSelectOnly)) return de.default.createElement(Xr, {
                    selected: r.props.selected,
                    openToDate: r.props.openToDate,
                    onChange: r.props.onTimeChange,
                    timeClassName: r.props.timeClassName,
                    format: r.props.timeFormat,
                    includeTimes: r.props.includeTimes,
                    intervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    todayButton: r.props.todayButton,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    monthRef: r.state.monthContainer,
                    injectTimes: r.props.injectTimes,
                    locale: r.props.locale,
                    handleOnKeyDown: r.props.handleOnKeyDown,
                    showTimeSelectOnly: r.props.showTimeSelectOnly
                });
            }), Et(Ot(r), "renderInputTimeSection", function() {
                var e = new Date(r.props.selected), t = qt(e) && Boolean(r.props.selected) ? "".concat(Er(e.getHours()), ":").concat(Er(e.getMinutes())) : "";
                if (r.props.showTimeInput) return de.default.createElement(ea, {
                    date: e,
                    timeString: t,
                    timeInputLabel: r.props.timeInputLabel,
                    onChange: r.props.onTimeChange,
                    customTimeInput: r.props.customTimeInput
                });
            }), Et(Ot(r), "renderAriaLiveRegion", function() {
                var e, t = Pr(r.state.date, r.props.yearItemNumber), a = t.startPeriod, n = t.endPeriod;
                return e = r.props.showYearPicker ? "".concat(a, " - ").concat(n) : r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? Le.default(r.state.date) : "".concat(nr(Ie.default(r.state.date), r.props.locale), " ").concat(Le.default(r.state.date)), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, r.state.isRenderAriaLiveMessage && e);
            }), Et(Ot(r), "renderChildren", function() {
                if (r.props.children) return de.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, r.props.children);
            }), r.containerRef = de.default.createRef(), r.state = {
                date: r.getDateInView(),
                selectingDate: null,
                monthContainer: null,
                isRenderAriaLiveMessage: !1
            }, r;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    var t = this;
                    if (!this.props.preSelection || Zt(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Zt(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                    else {
                        var r = !Jt(this.state.date, this.props.preSelection);
                        this.setState({
                            date: this.props.preSelection
                        }, function() {
                            return r && t.handleCustomMonthChange(t.state.date);
                        });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || ta;
                    return de.default.createElement("div", {
                        style: {
                            display: "contents"
                        },
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ue.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        })
                    }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: At
                    };
                }
            }
        ]), t;
    }(de.default.Component), na = function(e) {
        var t = e.icon, r = e.className, a = void 0 === r ? "" : r, n = e.onClick, o = "react-datepicker__calendar-icon";
        return de.default.isValidElement(t) ? de.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(a),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof n && n(e);
            }
        }) : "string" == typeof t ? de.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(a),
            "aria-hidden": "true",
            onClick: n
        }) : de.default.createElement("svg", {
            className: "".concat(o, " ").concat(a),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: n
        }, de.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, oa = function(e) {
        function t(e) {
            var r;
            return Ct(this, t), (r = Dt(this, t, [
                e
            ])).el = document.createElement("div"), r;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return yt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), t;
    }(de.default.Component), sa = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, ia = function(e) {
        function t(e) {
            var r;
            return Ct(this, t), Et(Ot(r = Dt(this, t, [
                e
            ])), "getTabChildren", function() {
                return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(sa);
            }), Et(Ot(r), "handleFocusStart", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }), Et(Ot(r), "handleFocusEnd", function() {
                var e = r.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }), r.tabLoopRef = de.default.createRef(), r;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), t;
    }(de.default.Component);
    var pa, la, ca = function(e) {
        function t() {
            return Ct(this, t), Dt(this, t, arguments);
        }
        return Nt(t, e), Mt(t, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.targetComponent, i = t.enableTabLoop, p = t.popperOnKeyDown, l = t.portalId, c = t.portalHost, d = t.popperProps, u = t.showArrow;
                    if (!n) {
                        var f = ue.default("react-datepicker-popper", r);
                        e = de.default.createElement(ia, {
                            enableTabLoop: i
                        }, de.default.createElement("div", {
                            ref: d.refs.setFloating,
                            style: d.floatingStyles,
                            className: f,
                            "data-placement": d.placement,
                            onKeyDown: p
                        }, o, u && de.default.createElement(pe.FloatingArrow, {
                            ref: d.arrowRef,
                            context: d.context,
                            fill: "currentColor",
                            strokeWidth: 1,
                            height: 8,
                            width: 16,
                            style: {
                                transform: "translateY(-1px)"
                            },
                            className: "react-datepicker__triangle"
                        })));
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), l && !n && (e = de.default.createElement(oa, {
                        portalId: l,
                        portalHost: c
                    }, e));
                    var h = ue.default("react-datepicker-wrapper", a);
                    return de.default.createElement(de.default.Fragment, null, de.default.createElement("div", {
                        ref: d.refs.setReference,
                        className: h
                    }, s), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0
                    };
                }
            }
        ]), t;
    }(de.default.Component), da = (pa = ca, (la = function(e) {
        var t = de.default.useRef(), r = pe.useFloating(wt({
            open: !e.hidePopper,
            whileElementsMounted: pe.autoUpdate,
            placement: e.popperPlacement,
            middleware: [
                pe.flip({
                    padding: 15
                }),
                pe.offset(10),
                pe.arrow({
                    element: t
                })
            ].concat(Tt(e.popperModifiers))
        }, e.popperProps));
        return de.default.createElement(pa, Pt({}, e, {
            popperProps: wt(wt({}, r), {}, {
                arrowRef: t
            })
        }));
    }).defaultProps = {
        popperModifiers: [],
        popperProps: {},
        hidePopper: !0
    }, la), ua = "react-datepicker-ignore-onclickoutside", fa = mt.default(aa);
    var ha = "Date input not valid.", ma = function(e) {
        function t(e) {
            var r;
            return Ct(this, t), Et(Ot(r = Dt(this, t, [
                e
            ])), "getPreSelection", function() {
                return r.props.openToDate ? r.props.openToDate : r.props.selectsEnd && r.props.startDate ? r.props.startDate : r.props.selectsStart && r.props.endDate ? r.props.endDate : Kt();
            }), Et(Ot(r), "modifyHolidays", function() {
                var e;
                return null === (e = r.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return he.default(r) ? [].concat(Tt(e), [
                        wt(wt({}, t), {}, {
                            date: r
                        })
                    ]) : e;
                }, []);
            }), Et(Ot(r), "calcInitialState", function() {
                var e, t = r.getPreSelection(), a = br(r.props), n = Sr(r.props), o = a && ct.default(t, $e.default(a)) ? a : n && lt.default(t, et.default(n)) ? n : t;
                return {
                    open: r.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = r.props.selectsRange ? r.props.startDate : r.props.selected) && void 0 !== e ? e : o,
                    highlightDates: Cr(r.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1
                };
            }), Et(Ot(r), "clearPreventFocusTimeout", function() {
                r.preventFocusTimeout && clearTimeout(r.preventFocusTimeout);
            }), Et(Ot(r), "setFocus", function() {
                r.input && r.input.focus && r.input.focus({
                    preventScroll: !0
                });
            }), Et(Ot(r), "setBlur", function() {
                r.input && r.input.blur && r.input.blur(), r.cancelFocusInput();
            }), Et(Ot(r), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                r.setState({
                    open: e,
                    preSelection: e && r.state.open ? r.state.preSelection : r.calcInitialState().preSelection,
                    lastPreSelectChange: va
                }, function() {
                    e || r.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && r.setBlur(), r.setState({
                            inputValue: null
                        });
                    });
                });
            }), Et(Ot(r), "inputOk", function() {
                return fe.default(r.state.preSelection);
            }), Et(Ot(r), "isCalendarOpen", function() {
                return void 0 === r.props.open ? r.state.open && !r.props.disabled && !r.props.readOnly : r.props.open;
            }), Et(Ot(r), "handleFocus", function(e) {
                r.state.preventFocus || (r.props.onFocus(e), r.props.preventOpenOnFocus || r.props.readOnly || r.setOpen(!0)), r.setState({
                    focused: !0
                });
            }), Et(Ot(r), "sendFocusBackToInput", function() {
                r.preventFocusTimeout && r.clearPreventFocusTimeout(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.preventFocusTimeout = setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                });
            }), Et(Ot(r), "cancelFocusInput", function() {
                clearTimeout(r.inputFocusTimeout), r.inputFocusTimeout = null;
            }), Et(Ot(r), "deferFocusInput", function() {
                r.cancelFocusInput(), r.inputFocusTimeout = setTimeout(function() {
                    return r.setFocus();
                }, 1);
            }), Et(Ot(r), "handleDropdownFocus", function() {
                r.cancelFocusInput();
            }), Et(Ot(r), "handleBlur", function(e) {
                (!r.state.open || r.props.withPortal || r.props.showTimeInput) && r.props.onBlur(e), r.setState({
                    focused: !1
                });
            }), Et(Ot(r), "handleCalendarClickOutside", function(e) {
                r.props.inline || r.setOpen(!1), r.props.onClickOutside(e), r.props.withPortal && e.preventDefault();
            }), Et(Ot(r), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), a = 0; a < e; a++)t[a] = arguments[a];
                var n = t[0];
                if (!r.props.onChangeRaw || (r.props.onChangeRaw.apply(Ot(r), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    r.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: ya
                    });
                    var o, s, i, p, l, c, d, u, f = (o = n.target.value, s = r.props.dateFormat, i = r.props.locale, p = r.props.strictParsing, l = r.props.minDate, c = null, d = ar(i) || ar(rr()), u = !0, Array.isArray(s) ? (s.forEach(function(e) {
                        var t = ft.default(o, e, new Date, {
                            locale: d,
                            useAdditionalWeekYearTokens: !0,
                            useAdditionalDayOfYearTokens: !0
                        });
                        p && (u = qt(t, l) && o === Bt(t, e, i)), qt(t, l) && u && (c = t);
                    }), c) : (c = ft.default(o, s, new Date, {
                        locale: d,
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    }), p ? u = qt(c) && o === Bt(c, s, i) : qt(c) || (s = s.match(Wt).map(function(e) {
                        var t = e[0];
                        return "p" === t || "P" === t ? d ? (0, Ft[t])(e, d.formatLong) : t : e;
                    }).join(""), o.length > 0 && (c = ft.default(o, s.slice(0, o.length), new Date, {
                        useAdditionalWeekYearTokens: !0,
                        useAdditionalDayOfYearTokens: !0
                    })), qt(c) || (c = new Date(o))), qt(c) && u ? c : null));
                    r.props.showTimeSelectOnly && r.props.selected && f && !Zt(f, r.props.selected) && (f = vt.default(r.props.selected, {
                        hours: Ye.default(f),
                        minutes: Ne.default(f),
                        seconds: Pe.default(f)
                    })), !f && n.target.value || (r.props.showWeekPicker && (f = jt(f, r.props.locale, r.props.calendarStartDay)), r.setSelected(f, n, !0));
                }
            }), Et(Ot(r), "handleSelect", function(e, t, a) {
                if (r.props.shouldCloseOnSelect && !r.props.showTimeSelect && r.sendFocusBackToInput(), r.props.onChangeRaw && r.props.onChangeRaw(t), r.props.showWeekPicker && (e = jt(e, r.props.locale, r.props.calendarStartDay)), r.setSelected(e, t, !1, a), r.props.showDateSelect && r.setState({
                    isRenderAriaLiveMessage: !0
                }), !r.props.shouldCloseOnSelect || r.props.showTimeSelect) r.setPreSelection(e);
                else if (!r.props.inline) {
                    r.props.selectsRange || r.setOpen(!1);
                    var n = r.props, o = n.startDate, s = n.endDate;
                    !o || s || xr(e, o) || r.setOpen(!1);
                }
            }), Et(Ot(r), "setSelected", function(e, t, a, n) {
                var o = e;
                if (r.props.showYearPicker) {
                    if (null !== o && ur(Le.default(o), r.props)) return;
                } else if (r.props.showMonthYearPicker) {
                    if (null !== o && pr(o, r.props)) return;
                } else if (null !== o && sr(o, r.props)) return;
                var s = r.props, i = s.onChange, p = s.selectsRange, l = s.startDate, c = s.endDate;
                if (!er(r.props.selected, o) || r.props.allowSameDay || p) {
                    if (null !== o && (!r.props.selected || a && (r.props.showTimeSelect || r.props.showTimeSelectOnly || r.props.showTimeInput) || (o = Ht(o, {
                        hour: Ye.default(r.props.selected),
                        minute: Ne.default(r.props.selected),
                        second: Pe.default(r.props.selected)
                    })), r.props.inline || r.setState({
                        preSelection: o
                    }), r.props.focusSelectedMonth || r.setState({
                        monthSelectedIn: n
                    })), p) {
                        var d = l && !c, u = l && c;
                        !l && !c ? i([
                            o,
                            null
                        ], t) : d && (xr(o, l) ? i([
                            o,
                            null
                        ], t) : i([
                            l,
                            o
                        ], t)), u && i([
                            o,
                            null
                        ], t);
                    } else i(o, t);
                }
                a || (r.props.onSelect(o, t), r.setState({
                    inputValue: null
                }));
            }), Et(Ot(r), "setPreSelection", function(e) {
                var t = void 0 !== r.props.minDate, a = void 0 !== r.props.maxDate, n = !0;
                if (e) {
                    r.props.showWeekPicker && (e = jt(e, r.props.locale, r.props.calendarStartDay));
                    var o = $e.default(e);
                    if (t && a) n = tr(e, r.props.minDate, r.props.maxDate);
                    else if (t) {
                        var s = $e.default(r.props.minDate);
                        n = lt.default(e, s) || er(o, s);
                    } else if (a) {
                        var i = et.default(r.props.maxDate);
                        n = ct.default(e, i) || er(o, i);
                    }
                }
                n && r.setState({
                    preSelection: e
                });
            }), Et(Ot(r), "toggleCalendar", function() {
                r.setOpen(!r.state.open);
            }), Et(Ot(r), "handleTimeChange", function(e) {
                var t = r.props.selected ? r.props.selected : r.getPreSelection(), a = r.props.selected ? e : Ht(t, {
                    hour: Ye.default(e),
                    minute: Ne.default(e)
                });
                r.setState({
                    preSelection: a
                }), r.props.onChange(a), r.props.shouldCloseOnSelect && (r.sendFocusBackToInput(), r.setOpen(!1)), r.props.showTimeInput && r.setOpen(!0), (r.props.showTimeSelectOnly || r.props.showTimeSelect) && r.setState({
                    isRenderAriaLiveMessage: !0
                }), r.setState({
                    inputValue: null
                });
            }), Et(Ot(r), "onInputClick", function() {
                r.props.disabled || r.props.readOnly || r.setOpen(!0), r.props.onInputClick();
            }), Et(Ot(r), "onInputKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t = e.key;
                if (r.state.open || r.props.inline || r.props.preventOpenOnFocus) {
                    if (r.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var a = r.props.showWeekPicker && r.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', n = r.calendar.componentNode && r.calendar.componentNode.querySelector(a);
                            return void (n && n.focus({
                                preventScroll: !0
                            }));
                        }
                        var o = Kt(r.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), r.inputOk() && r.state.lastPreSelectChange === va ? (r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o)) : r.setOpen(!1)) : "Escape" === t ? (e.preventDefault(), r.sendFocusBackToInput(), r.setOpen(!1)) : "Tab" === t && r.setOpen(!1), r.inputOk() || r.props.onInputError({
                            code: 1,
                            msg: ha
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || r.onInputClick();
            }), Et(Ot(r), "onPortalKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.setState({
                    preventFocus: !0
                }, function() {
                    r.setOpen(!1), setTimeout(function() {
                        r.setFocus(), r.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Et(Ot(r), "onDayKeyDown", function(e) {
                r.props.onKeyDown(e);
                var t, a = e.key, n = e.shiftKey, o = Kt(r.state.preSelection);
                if ("Enter" === a) e.preventDefault(), r.handleSelect(o, e), !r.props.shouldCloseOnSelect && r.setPreSelection(o);
                else if ("Escape" === a) e.preventDefault(), r.setOpen(!1), r.inputOk() || r.props.onInputError({
                    code: 1,
                    msg: ha
                });
                else if (!r.props.disabledKeyboardNavigation) {
                    var s;
                    switch(a){
                        case "ArrowLeft":
                            s = r.props.showWeekPicker ? Ce.default(o, 1) : Se.default(o, 1);
                            break;
                        case "ArrowRight":
                            s = r.props.showWeekPicker ? ge.default(o, 1) : De.default(o, 1);
                            break;
                        case "ArrowUp":
                            s = Ce.default(o, 1);
                            break;
                        case "ArrowDown":
                            s = ge.default(o, 1);
                            break;
                        case "PageUp":
                            s = n ? Ee.default(o, 1) : _e.default(o, 1);
                            break;
                        case "PageDown":
                            s = n ? be.default(o, 1) : ke.default(o, 1);
                            break;
                        case "Home":
                            s = jt(o, r.props.locale, r.props.calendarStartDay);
                            break;
                        case "End":
                            t = o, s = tt.default(t);
                            break;
                        default:
                            s = null;
                    }
                    if (!s) return void (r.props.onInputError && r.props.onInputError({
                        code: 1,
                        msg: ha
                    }));
                    if (e.preventDefault(), r.setState({
                        lastPreSelectChange: va
                    }), r.props.adjustDateOnChange && r.setSelected(s), r.setPreSelection(s), r.props.inline) {
                        var i = Ie.default(o), p = Ie.default(s), l = Le.default(o), c = Le.default(s);
                        i !== p || l !== c ? r.setState({
                            shouldFocusDayInline: !0
                        }) : r.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Et(Ot(r), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), r.sendFocusBackToInput());
            }), Et(Ot(r), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), r.sendFocusBackToInput(), r.props.selectsRange ? r.props.onChange([
                    null,
                    null
                ], e) : r.props.onChange(null, e), r.setState({
                    inputValue: null
                });
            }), Et(Ot(r), "clear", function() {
                r.onClearClick();
            }), Et(Ot(r), "onScroll", function(e) {
                "boolean" == typeof r.props.closeOnScroll && r.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || r.setOpen(!1) : "function" == typeof r.props.closeOnScroll && r.props.closeOnScroll(e) && r.setOpen(!1);
            }), Et(Ot(r), "renderCalendar", function() {
                return r.props.inline || r.isCalendarOpen() ? de.default.createElement(fa, {
                    ref: function(e) {
                        r.calendar = e;
                    },
                    locale: r.props.locale,
                    calendarStartDay: r.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: r.props.monthAriaLabelPrefix,
                    adjustDateOnChange: r.props.adjustDateOnChange,
                    setOpen: r.setOpen,
                    shouldCloseOnSelect: r.props.shouldCloseOnSelect,
                    dateFormat: r.props.dateFormatCalendar,
                    useWeekdaysShort: r.props.useWeekdaysShort,
                    formatWeekDay: r.props.formatWeekDay,
                    dropdownMode: r.props.dropdownMode,
                    selected: r.props.selected,
                    preSelection: r.state.preSelection,
                    onSelect: r.handleSelect,
                    onWeekSelect: r.props.onWeekSelect,
                    openToDate: r.props.openToDate,
                    minDate: r.props.minDate,
                    maxDate: r.props.maxDate,
                    selectsStart: r.props.selectsStart,
                    selectsEnd: r.props.selectsEnd,
                    selectsRange: r.props.selectsRange,
                    startDate: r.props.startDate,
                    endDate: r.props.endDate,
                    excludeDates: r.props.excludeDates,
                    excludeDateIntervals: r.props.excludeDateIntervals,
                    filterDate: r.props.filterDate,
                    onClickOutside: r.handleCalendarClickOutside,
                    formatWeekNumber: r.props.formatWeekNumber,
                    highlightDates: r.state.highlightDates,
                    holidays: _r(r.modifyHolidays()),
                    includeDates: r.props.includeDates,
                    includeDateIntervals: r.props.includeDateIntervals,
                    includeTimes: r.props.includeTimes,
                    injectTimes: r.props.injectTimes,
                    inline: r.props.inline,
                    shouldFocusDayInline: r.state.shouldFocusDayInline,
                    peekNextMonth: r.props.peekNextMonth,
                    showMonthDropdown: r.props.showMonthDropdown,
                    showPreviousMonths: r.props.showPreviousMonths,
                    useShortMonthInDropdown: r.props.useShortMonthInDropdown,
                    showMonthYearDropdown: r.props.showMonthYearDropdown,
                    showWeekNumbers: r.props.showWeekNumbers,
                    showYearDropdown: r.props.showYearDropdown,
                    withPortal: r.props.withPortal,
                    forceShowMonthNavigation: r.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: r.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: r.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown,
                    todayButton: r.props.todayButton,
                    weekLabel: r.props.weekLabel,
                    outsideClickIgnoreClass: ua,
                    fixedHeight: r.props.fixedHeight,
                    monthsShown: r.props.monthsShown,
                    monthSelectedIn: r.state.monthSelectedIn,
                    onDropdownFocus: r.handleDropdownFocus,
                    onMonthChange: r.props.onMonthChange,
                    onYearChange: r.props.onYearChange,
                    dayClassName: r.props.dayClassName,
                    weekDayClassName: r.props.weekDayClassName,
                    monthClassName: r.props.monthClassName,
                    timeClassName: r.props.timeClassName,
                    showDateSelect: r.props.showDateSelect,
                    showTimeSelect: r.props.showTimeSelect,
                    showTimeSelectOnly: r.props.showTimeSelectOnly,
                    onTimeChange: r.handleTimeChange,
                    timeFormat: r.props.timeFormat,
                    timeIntervals: r.props.timeIntervals,
                    minTime: r.props.minTime,
                    maxTime: r.props.maxTime,
                    excludeTimes: r.props.excludeTimes,
                    filterTime: r.props.filterTime,
                    timeCaption: r.props.timeCaption,
                    className: r.props.calendarClassName,
                    container: r.props.calendarContainer,
                    yearItemNumber: r.props.yearItemNumber,
                    yearDropdownItemNumber: r.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: r.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: r.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: r.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: r.props.nextMonthButtonLabel,
                    previousYearAriaLabel: r.props.previousYearAriaLabel,
                    previousYearButtonLabel: r.props.previousYearButtonLabel,
                    nextYearAriaLabel: r.props.nextYearAriaLabel,
                    nextYearButtonLabel: r.props.nextYearButtonLabel,
                    timeInputLabel: r.props.timeInputLabel,
                    disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
                    renderCustomHeader: r.props.renderCustomHeader,
                    popperProps: r.props.popperProps,
                    renderDayContents: r.props.renderDayContents,
                    renderMonthContent: r.props.renderMonthContent,
                    renderQuarterContent: r.props.renderQuarterContent,
                    renderYearContent: r.props.renderYearContent,
                    onDayMouseEnter: r.props.onDayMouseEnter,
                    onMonthMouseLeave: r.props.onMonthMouseLeave,
                    onYearMouseEnter: r.props.onYearMouseEnter,
                    onYearMouseLeave: r.props.onYearMouseLeave,
                    selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
                    showTimeInput: r.props.showTimeInput,
                    showMonthYearPicker: r.props.showMonthYearPicker,
                    showFullMonthYearPicker: r.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
                    showYearPicker: r.props.showYearPicker,
                    showQuarterYearPicker: r.props.showQuarterYearPicker,
                    showWeekPicker: r.props.showWeekPicker,
                    excludeScrollbar: r.props.excludeScrollbar,
                    handleOnKeyDown: r.props.onKeyDown,
                    handleOnDayKeyDown: r.onDayKeyDown,
                    isInputFocused: r.state.focused,
                    customTimeInput: r.props.customTimeInput,
                    setPreSelection: r.setPreSelection
                }, r.props.children) : null;
            }), Et(Ot(r), "renderAriaLiveRegion", function() {
                var e, t = r.props, a = t.dateFormat, n = t.locale, o = r.props.showTimeInput || r.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = r.props.selectsRange ? "Selected start date: ".concat(Qt(r.props.startDate, {
                    dateFormat: o,
                    locale: n
                }), ". ").concat(r.props.endDate ? "End date: " + Qt(r.props.endDate, {
                    dateFormat: o,
                    locale: n
                }) : "") : r.props.showTimeSelectOnly ? "Selected time: ".concat(Qt(r.props.selected, {
                    dateFormat: a,
                    locale: n
                })) : r.props.showYearPicker ? "Selected year: ".concat(Qt(r.props.selected, {
                    dateFormat: "yyyy",
                    locale: n
                })) : r.props.showMonthYearPicker ? "Selected month: ".concat(Qt(r.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: n
                })) : r.props.showQuarterYearPicker ? "Selected quarter: ".concat(Qt(r.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: n
                })) : "Selected date: ".concat(Qt(r.props.selected, {
                    dateFormat: o,
                    locale: n
                })), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }), Et(Ot(r), "renderDateInput", function() {
                var e, t = ue.default(r.props.className, Et({}, ua, r.state.open)), a = r.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = r.props.customInputRef || "ref", o = "string" == typeof r.props.value ? r.props.value : "string" == typeof r.state.inputValue ? r.state.inputValue : r.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Qt(e, r), n = t ? Qt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(r.props.startDate, r.props.endDate, r.props) : Qt(r.props.selected, r.props);
                return de.default.cloneElement(a, (Et(Et(Et(Et(Et(Et(Et(Et(Et(Et(e = {}, n, function(e) {
                    r.input = e;
                }), "value", o), "onBlur", r.handleBlur), "onChange", r.handleChange), "onClick", r.onInputClick), "onFocus", r.handleFocus), "onKeyDown", r.onInputKeyDown), "id", r.props.id), "name", r.props.name), "form", r.props.form), Et(Et(Et(Et(Et(Et(Et(Et(Et(Et(e, "autoFocus", r.props.autoFocus), "placeholder", r.props.placeholderText), "disabled", r.props.disabled), "autoComplete", r.props.autoComplete), "className", ue.default(a.props.className, t)), "title", r.props.title), "readOnly", r.props.readOnly), "required", r.props.required), "tabIndex", r.props.tabIndex), "aria-describedby", r.props.ariaDescribedBy), Et(Et(Et(e, "aria-invalid", r.props.ariaInvalid), "aria-labelledby", r.props.ariaLabelledBy), "aria-required", r.props.ariaRequired)));
            }), Et(Ot(r), "renderClearButton", function() {
                var e = r.props, t = e.isClearable, a = e.disabled, n = e.selected, o = e.startDate, s = e.endDate, i = e.clearButtonTitle, p = e.clearButtonClassName, l = void 0 === p ? "" : p, c = e.ariaLabelClose, d = void 0 === c ? "Close" : c;
                return !t || null == n && null == o && null == s ? null : de.default.createElement("button", {
                    type: "button",
                    className: ue.default("react-datepicker__close-icon", l, {
                        "react-datepicker__close-icon--disabled": a
                    }),
                    disabled: a,
                    "aria-label": d,
                    onClick: r.onClearClick,
                    title: i,
                    tabIndex: -1
                });
            }), r.state = r.calcInitialState(), r.preventFocusTimeout = null, r;
        }
        return Nt(t, e), Mt(t, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Ie.default(r) !== Ie.default(a) || Le.default(r) !== Le.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: Cr(this.props.highlightDates)
                    }), t.focused || er(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    var e = this.props, t = e.showIcon, r = e.icon, a = e.calendarIconClassname, n = e.toggleCalendarOnIconClick, o = this.state.open;
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "")
                    }, t && de.default.createElement(na, Pt({
                        icon: r,
                        className: "".concat(a, " ").concat(o && "react-datepicker-ignore-onclickoutside")
                    }, n ? {
                        onClick: this.toggleCalendar
                    } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement(ia, {
                            enableTabLoop: this.props.enableTabLoop
                        }, de.default.createElement("div", {
                            className: "react-datepicker__portal",
                            tabIndex: -1,
                            onKeyDown: this.onPortalKeyDown
                        }, e)) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(oa, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(da, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop,
                        showArrow: this.props.showPopperArrow
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        showWeekPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: At,
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0,
                        toggleCalendarOnIconClick: !1
                    };
                }
            }
        ]), t;
    }(de.default.Component), ya = "input", va = "navigate";
    e.CalendarContainer = ta, e.default = ma, e.getDefaultLocale = rr, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});
parcelRegister("fQNmZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b8a20226bf872da3$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $9vFg7 = parcelRequire("9vFg7");

var $jILpd = parcelRequire("jILpd");
var $b8a20226bf872da3$var$MILLISECONDS_IN_MINUTE = 60000;
function $b8a20226bf872da3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $9vFg7.default)(dirtyDate, amount * $b8a20226bf872da3$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("3IlnT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2b4611a2abc925d2$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $9vFg7 = parcelRequire("9vFg7");

var $jILpd = parcelRequire("jILpd");
var $2b4611a2abc925d2$var$MILLISECONDS_IN_HOUR = 3600000;
function $2b4611a2abc925d2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $9vFg7.default)(dirtyDate, amount * $2b4611a2abc925d2$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("9CqRE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $700c805b81e44b88$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $700c805b81e44b88$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("6JwRy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4e706fe89c5634aa$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $9CqRE = parcelRequire("9CqRE");

var $jILpd = parcelRequire("jILpd");
function $4e706fe89c5634aa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $9CqRE.default)(dirtyDate, days);
}

});

parcelRegister("iwlPq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d7bc25d526160177$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $d7bc25d526160177$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("5GJlZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $42440e4b3a381d38$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iwlPq = parcelRequire("iwlPq");

var $jILpd = parcelRequire("jILpd");
function $42440e4b3a381d38$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    var months = amount * 3;
    return (0, $iwlPq.default)(dirtyDate, months);
}

});

parcelRegister("7LB45", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5a79ac7c364bcf84$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iwlPq = parcelRequire("iwlPq");

var $jILpd = parcelRequire("jILpd");
function $5a79ac7c364bcf84$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $iwlPq.default)(dirtyDate, amount * 12);
}

});

parcelRegister("2cJoy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $19afea461f164173$export$2e2bcd8739ae039);

var $9CqRE = parcelRequire("9CqRE");

var $jILpd = parcelRequire("jILpd");

var $ctM6U = parcelRequire("ctM6U");
function $19afea461f164173$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $9CqRE.default)(dirtyDate, -amount);
}

});

parcelRegister("9Taqu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7331568e90071bde$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $6JwRy = parcelRequire("6JwRy");

var $jILpd = parcelRequire("jILpd");
function $7331568e90071bde$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $6JwRy.default)(dirtyDate, -amount);
}

});

parcelRegister("kESWk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f0a228f358ee1664$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iwlPq = parcelRequire("iwlPq");

var $jILpd = parcelRequire("jILpd");
function $f0a228f358ee1664$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $iwlPq.default)(dirtyDate, -amount);
}

});

parcelRegister("3JQm2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2b8e2f971e68c422$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $5GJlZ = parcelRequire("5GJlZ");

var $jILpd = parcelRequire("jILpd");
function $2b8e2f971e68c422$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $5GJlZ.default)(dirtyDate, -amount);
}

});

parcelRegister("bmB1p", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $845e77898b59b0ef$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $7LB45 = parcelRequire("7LB45");

var $jILpd = parcelRequire("jILpd");
function $845e77898b59b0ef$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $jILpd.default)(2, arguments);
    var amount = (0, $ctM6U.default)(dirtyAmount);
    return (0, $7LB45.default)(dirtyDate, -amount);
}

});

parcelRegister("1YaUy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $16f3dbca0ed7f2cd$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $16f3dbca0ed7f2cd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("5vrGt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $40255277a706b862$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $40255277a706b862$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("ijnOS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d54c7a6fee4ed2f3$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $d54c7a6fee4ed2f3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("l73O9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f5ed348ffeb182d9$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $f5ed348ffeb182d9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("eQ5Ry", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $acda783d84f2f6d6$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $acda783d84f2f6d6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("6KsCe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4e9d3c67264da66a$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $dweuA = parcelRequire("dweuA");

var $5CDJW = parcelRequire("5CDJW");

var $jILpd = parcelRequire("jILpd");
var $4e9d3c67264da66a$var$MILLISECONDS_IN_WEEK = 604800000;
function $4e9d3c67264da66a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var diff = (0, $dweuA.default)(date).getTime() - (0, $5CDJW.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4e9d3c67264da66a$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("dweuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d7981675b536cdf$export$2e2bcd8739ae039);

var $8m0Ts = parcelRequire("8m0Ts");

var $jILpd = parcelRequire("jILpd");
function $9d7981675b536cdf$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    return (0, $8m0Ts.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("8m0Ts", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $61511235f8b6b207$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $ctM6U = parcelRequire("ctM6U");

var $jILpd = parcelRequire("jILpd");

var $7SYLh = parcelRequire("7SYLh");
function $61511235f8b6b207$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $jILpd.default)(1, arguments);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var weekStartsOn = (0, $ctM6U.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $iOAFx.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("5CDJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $417f53e791ed0ba3$export$2e2bcd8739ae039);

var $hkLYJ = parcelRequire("hkLYJ");

var $dweuA = parcelRequire("dweuA");

var $jILpd = parcelRequire("jILpd");
function $417f53e791ed0ba3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var year = (0, $hkLYJ.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $dweuA.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("hkLYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e9857698a44f40$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $dweuA = parcelRequire("dweuA");

var $jILpd = parcelRequire("jILpd");
function $c9e9857698a44f40$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $dweuA.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $dweuA.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("5PRIk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $43fb61a983cbfda2$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $43fb61a983cbfda2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("3aRVX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $24fc24615025b5b5$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $24fc24615025b5b5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("AEY6w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $06e324621d089d41$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $06e324621d089d41$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    return (0, $iOAFx.default)(dirtyDate).getFullYear();
}

});

parcelRegister("bw9ox", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8629f8776c9ab667$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $8629f8776c9ab667$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});

parcelRegister("6LjsM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4ec63adc5680a680$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $4ec63adc5680a680$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var seconds = (0, $ctM6U.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("fg6w7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b1bd67ced3e603ef$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $6cpZk = parcelRequire("6cpZk");

var $jILpd = parcelRequire("jILpd");
function $b1bd67ced3e603ef$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var month = (0, $ctM6U.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $6cpZk.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("6cpZk", function(module, exports) {

$parcel$export(module.exports, "default", () => $483805c3c3e48701$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $483805c3c3e48701$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("jdg3H", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dfcbb01e667017b7$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $fg6w7 = parcelRequire("fg6w7");

var $jILpd = parcelRequire("jILpd");
function $dfcbb01e667017b7$export$2e2bcd8739ae039(dirtyDate, dirtyQuarter) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var quarter = (0, $ctM6U.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $fg6w7.default)(date, date.getMonth() + diff * 3);
}

});

parcelRegister("gKDRj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c31fdc5ee4c5a1ca$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $c31fdc5ee4c5a1ca$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var year = (0, $ctM6U.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("aYaZQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7fc809a90a42d5fb$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $7fc809a90a42d5fb$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $jILpd.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, $jOMXy.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $iOAFx.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("7zJ1U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $583ebb407923cd6c$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $583ebb407923cd6c$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $jILpd.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, $jOMXy.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $iOAFx.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("f4mhr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $af8883233baae810$export$2e2bcd8739ae039);

var $h0m4m = parcelRequire("h0m4m");

var $iMjUR = parcelRequire("iMjUR");

var $jILpd = parcelRequire("jILpd");
var $af8883233baae810$var$MILLISECONDS_IN_DAY = 86400000;
function $af8883233baae810$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var startOfDayLeft = (0, $iMjUR.default)(dirtyDateLeft);
    var startOfDayRight = (0, $iMjUR.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $h0m4m.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $h0m4m.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $af8883233baae810$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("iMjUR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dabc289cdb54673c$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $dabc289cdb54673c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("5Zxq7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $45cc92cfa09828ec$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $45cc92cfa09828ec$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var dateLeft = (0, $iOAFx.default)(dirtyDateLeft);
    var dateRight = (0, $iOAFx.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("4pJFe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $336ceb2508875bc1$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $336ceb2508875bc1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var dateLeft = (0, $iOAFx.default)(dirtyDateLeft);
    var dateRight = (0, $iOAFx.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("jHVWJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e58efb6b22051c43$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $e58efb6b22051c43$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("dO07z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a0d009e8cb2c0c36$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $a0d009e8cb2c0c36$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("93m7o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $69758d13ba572d2e$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $69758d13ba572d2e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var cleanDate = (0, $iOAFx.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6XRaq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $51217ea95500cea3$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $51217ea95500cea3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("bUgTw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8ab2078f910d15d6$export$2e2bcd8739ae039);

var $7SYLh = parcelRequire("7SYLh");

var $iOAFx = parcelRequire("iOAFx");

var $ctM6U = parcelRequire("ctM6U");

var $jILpd = parcelRequire("jILpd");
function $8ab2078f910d15d6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $jILpd.default)(1, arguments);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var weekStartsOn = (0, $ctM6U.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $iOAFx.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("lAUd9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fb889019b26cae02$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $fb889019b26cae02$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("1dB3B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0e33c01ba071d026$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $0e33c01ba071d026$export$2e2bcd8739ae039(dirtyDate) {
    (0, $jILpd.default)(1, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("e13sw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a343d7918381b192$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $a343d7918381b192$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $jILpd.default)(2, arguments);
    var dateLeft = (0, $iOAFx.default)(dirtyLeftDate);
    var dateRight = (0, $iOAFx.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("5DBlA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $41ad90a4269e2189$export$2e2bcd8739ae039);

var $iMjUR = parcelRequire("iMjUR");

var $jILpd = parcelRequire("jILpd");
function $41ad90a4269e2189$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var dateLeftStartOfDay = (0, $iMjUR.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $iMjUR.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("eU9EB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ad9dc8b42e30a7d9$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $ad9dc8b42e30a7d9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var dateLeft = (0, $iOAFx.default)(dirtyDateLeft);
    var dateRight = (0, $iOAFx.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("48xcu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3031a9b6458cf067$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $3031a9b6458cf067$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var dateLeft = (0, $iOAFx.default)(dirtyDateLeft);
    var dateRight = (0, $iOAFx.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("94N4R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $69ba8e840e90f3a2$export$2e2bcd8739ae039);

var $dO07z = parcelRequire("dO07z");

var $jILpd = parcelRequire("jILpd");
function $69ba8e840e90f3a2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $jILpd.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, $dO07z.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, $dO07z.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

});

parcelRegister("iiN1r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d52fef39392aea4d$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $d52fef39392aea4d$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var dateToCompare = (0, $iOAFx.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("5azbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3c392e53221b178b$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $3c392e53221b178b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var dateToCompare = (0, $iOAFx.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("jEBBM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4eeecfed5d23308$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");
function $e4eeecfed5d23308$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $jILpd.default)(2, arguments);
    var time = (0, $iOAFx.default)(dirtyDate).getTime();
    var startTime = (0, $iOAFx.default)(interval.start).getTime();
    var endTime = (0, $iOAFx.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("1KHEU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $146bf40915c6bbcd$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $j2yjP = parcelRequire("j2yjP");

var $lUljM = parcelRequire("lUljM");

var $7HMEJ = parcelRequire("7HMEJ");

var $iOAFx = parcelRequire("iOAFx");

var $6NTqf = parcelRequire("6NTqf");

var $dRQ0a = parcelRequire("dRQ0a");

var $h0m4m = parcelRequire("h0m4m");

var $e7rBS = parcelRequire("e7rBS");

var $ctM6U = parcelRequire("ctM6U");

var $jILpd = parcelRequire("jILpd");

var $1VcjS = parcelRequire("1VcjS");

var $7ex1G = parcelRequire("7ex1G");

var $7SYLh = parcelRequire("7SYLh");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $146bf40915c6bbcd$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $146bf40915c6bbcd$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $146bf40915c6bbcd$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $146bf40915c6bbcd$var$doubleQuoteRegExp = /''/g;
var $146bf40915c6bbcd$var$notWhitespaceRegExp = /\S/;
var $146bf40915c6bbcd$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $146bf40915c6bbcd$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $jILpd.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $lUljM.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $ctM6U.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $ctM6U.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $iOAFx.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $1VcjS.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($146bf40915c6bbcd$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $dRQ0a.default)) {
            var longFormatter = (0, $dRQ0a.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($146bf40915c6bbcd$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $j2yjP.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $e7rBS.isProtectedWeekYearToken)(token)) (0, $e7rBS.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $e7rBS.isProtectedDayOfYearToken)(token)) (0, $e7rBS.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $7ex1G.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($146bf40915c6bbcd$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $146bf40915c6bbcd$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $jOMXy.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $146bf40915c6bbcd$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $iOAFx.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $7HMEJ.default)(date, (0, $h0m4m.default)(date));
    var flags = {};
    var _iterator2 = (0, $j2yjP.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6NTqf.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $146bf40915c6bbcd$var$cleanEscapedString(input) {
    return input.match($146bf40915c6bbcd$var$escapedStringRegExp)[1].replace($146bf40915c6bbcd$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("j2yjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc8d336fa8c80e8$export$2e2bcd8739ae039);

var $eXIWw = parcelRequire("eXIWw");
function $ddc8d336fa8c80e8$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $eXIWw.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});

parcelRegister("1VcjS", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $1664abb685e9a39a$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $1664abb685e9a39a$export$5aaf7ff7f09ea4ee);

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $2qeFG = parcelRequire("2qeFG");
var $1664abb685e9a39a$var$TIMEZONE_UNIT_PRIORITY = 10;
var $1664abb685e9a39a$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $dM0Cr.default)(this, Setter);
        (0, $2qeFG.default)(this, "priority", void 0);
        (0, $2qeFG.default)(this, "subPriority", 0);
    }
    (0, $lRfe8.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $1664abb685e9a39a$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $1UPzg.default)(ValueSetter, _Setter);
    var _super = (0, $7ZjFV.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $dM0Cr.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $lRfe8.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($1664abb685e9a39a$export$81d53e3678089a6);
var $1664abb685e9a39a$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $1UPzg.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $7ZjFV.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $dM0Cr.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this2), "priority", $1664abb685e9a39a$var$TIMEZONE_UNIT_PRIORITY);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $lRfe8.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($1664abb685e9a39a$export$81d53e3678089a6);

});

parcelRegister("7ex1G", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $5443758a11c90466$export$19131010e7fd8373);

var $d7sjZ = parcelRequire("d7sjZ");

var $dAr3R = parcelRequire("dAr3R");

var $fILAd = parcelRequire("fILAd");

var $h6e5H = parcelRequire("h6e5H");

var $ctjx1 = parcelRequire("ctjx1");

var $2gX5H = parcelRequire("2gX5H");

var $fKnpY = parcelRequire("fKnpY");

var $k28s8 = parcelRequire("k28s8");

var $5RyP4 = parcelRequire("5RyP4");

var $a2FWX = parcelRequire("a2FWX");

var $7wI0e = parcelRequire("7wI0e");

var $bigls = parcelRequire("bigls");

var $crkgt = parcelRequire("crkgt");

var $fkQzG = parcelRequire("fkQzG");

var $bPSzt = parcelRequire("bPSzt");

var $jdJF2 = parcelRequire("jdJF2");

var $hEbIW = parcelRequire("hEbIW");

var $jrNCt = parcelRequire("jrNCt");

var $kA5vm = parcelRequire("kA5vm");

var $5091f = parcelRequire("5091f");

var $238QM = parcelRequire("238QM");

var $aCjuk = parcelRequire("aCjuk");

var $ek1Ou = parcelRequire("ek1Ou");

var $gF884 = parcelRequire("gF884");

var $1klXw = parcelRequire("1klXw");

var $3xbDu = parcelRequire("3xbDu");

var $8tXgh = parcelRequire("8tXgh");

var $jzBwx = parcelRequire("jzBwx");

var $8j5qv = parcelRequire("8j5qv");

var $h6AQN = parcelRequire("h6AQN");

var $1TfXT = parcelRequire("1TfXT");
var $5443758a11c90466$export$19131010e7fd8373 = {
    G: new (0, $d7sjZ.EraParser)(),
    y: new (0, $dAr3R.YearParser)(),
    Y: new (0, $fILAd.LocalWeekYearParser)(),
    R: new (0, $h6e5H.ISOWeekYearParser)(),
    u: new (0, $ctjx1.ExtendedYearParser)(),
    Q: new (0, $2gX5H.QuarterParser)(),
    q: new (0, $fKnpY.StandAloneQuarterParser)(),
    M: new (0, $k28s8.MonthParser)(),
    L: new (0, $5RyP4.StandAloneMonthParser)(),
    w: new (0, $a2FWX.LocalWeekParser)(),
    I: new (0, $7wI0e.ISOWeekParser)(),
    d: new (0, $bigls.DateParser)(),
    D: new (0, $crkgt.DayOfYearParser)(),
    E: new (0, $fkQzG.DayParser)(),
    e: new (0, $bPSzt.LocalDayParser)(),
    c: new (0, $jdJF2.StandAloneLocalDayParser)(),
    i: new (0, $hEbIW.ISODayParser)(),
    a: new (0, $jrNCt.AMPMParser)(),
    b: new (0, $kA5vm.AMPMMidnightParser)(),
    B: new (0, $5091f.DayPeriodParser)(),
    h: new (0, $238QM.Hour1to12Parser)(),
    H: new (0, $aCjuk.Hour0to23Parser)(),
    K: new (0, $ek1Ou.Hour0To11Parser)(),
    k: new (0, $gF884.Hour1To24Parser)(),
    m: new (0, $1klXw.MinuteParser)(),
    s: new (0, $3xbDu.SecondParser)(),
    S: new (0, $8tXgh.FractionOfSecondParser)(),
    X: new (0, $jzBwx.ISOTimezoneWithZParser)(),
    x: new (0, $8j5qv.ISOTimezoneParser)(),
    t: new (0, $h6AQN.TimestampSecondsParser)(),
    T: new (0, $1TfXT.TimestampMillisecondsParser)()
};

});
parcelRegister("d7sjZ", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $98d1e5d451d1423a$export$8e5a1d3f85a9688);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");
var $98d1e5d451d1423a$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(EraParser, _Parser);
    var _super = (0, $7ZjFV.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $dM0Cr.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 140);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $lkKeG.Parser));

});
parcelRegister("lkKeG", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $f87f54af87444e31$export$7acfa6ed01010e37);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $2qeFG = parcelRequire("2qeFG");

var $1VcjS = parcelRequire("1VcjS");
var $f87f54af87444e31$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $dM0Cr.default)(this, Parser);
        (0, $2qeFG.default)(this, "incompatibleTokens", void 0);
        (0, $2qeFG.default)(this, "priority", void 0);
        (0, $2qeFG.default)(this, "subPriority", void 0);
    }
    (0, $lRfe8.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $1VcjS.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("dAr3R", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $9e43a0f02ded3254$export$48d352de7cd4a988);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $9e43a0f02ded3254$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(YearParser, _Parser);
    var _super = (0, $7ZjFV.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $dM0Cr.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 130);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $aAzEJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $aAzEJ.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $lkKeG.Parser));

});
parcelRegister("aAzEJ", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $7b58ecbb6dc100a9$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $7b58ecbb6dc100a9$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $7b58ecbb6dc100a9$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $7b58ecbb6dc100a9$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $7b58ecbb6dc100a9$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $7b58ecbb6dc100a9$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $7b58ecbb6dc100a9$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $7b58ecbb6dc100a9$export$3d50627710b84d75);

var $7VSLk = parcelRequire("7VSLk");

var $byRrW = parcelRequire("byRrW");
function $7b58ecbb6dc100a9$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7b58ecbb6dc100a9$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $7VSLk.millisecondsInHour) + minutes * (0, $7VSLk.millisecondsInMinute) + seconds * (0, $7VSLk.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7b58ecbb6dc100a9$export$d931c43c4608a164(dateString) {
    return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).anyDigitsSigned, dateString);
}
function $7b58ecbb6dc100a9$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).singleDigit, dateString);
        case 2:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).twoDigits, dateString);
        case 3:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).threeDigits, dateString);
        case 4:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).fourDigits, dateString);
        default:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $7b58ecbb6dc100a9$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388((0, $byRrW.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $7b58ecbb6dc100a9$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $7b58ecbb6dc100a9$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $7b58ecbb6dc100a9$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7b58ecbb6dc100a9$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("byRrW", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $86ac54b07cf10a97$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $86ac54b07cf10a97$export$a7ee192b982af9c1);
var $86ac54b07cf10a97$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $86ac54b07cf10a97$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("fILAd", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $b71fe01ad66ac7bc$export$b8ef38dfcf05d5db);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");

var $di10y = parcelRequire("di10y");

var $e8tpO = parcelRequire("e8tpO");
var $b71fe01ad66ac7bc$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $7ZjFV.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $dM0Cr.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 130);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $aAzEJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $di10y.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $aAzEJ.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $e8tpO.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $e8tpO.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $lkKeG.Parser));

});

parcelRegister("h6e5H", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $c72ded63941b1437$export$951d1df011fde06f);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");

var $6ft3d = parcelRequire("6ft3d");
var $c72ded63941b1437$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $7ZjFV.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $dM0Cr.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 130);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $aAzEJ.parseNDigitsSigned)(4, dateString);
                return (0, $aAzEJ.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $6ft3d.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $lkKeG.Parser));

});

parcelRegister("ctjx1", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $9147580fab1a7d72$export$bad9d2ea38e8f1a);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $9147580fab1a7d72$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(ExtendedYearParser, _Parser);
    var _super = (0, $7ZjFV.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $dM0Cr.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 130);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $aAzEJ.parseNDigitsSigned)(4, dateString);
                return (0, $aAzEJ.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $lkKeG.Parser));

});

parcelRegister("2gX5H", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $1a7ae9a353d67c01$export$5cb0f701186dde1d);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $1a7ae9a353d67c01$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(QuarterParser, _Parser);
    var _super = (0, $7ZjFV.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $dM0Cr.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 120);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $lkKeG.Parser));

});

parcelRegister("fKnpY", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $b76d512ffa8b559b$export$300c0c2990e20e6d);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $b76d512ffa8b559b$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $7ZjFV.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $dM0Cr.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 120);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $lkKeG.Parser));

});

parcelRegister("k28s8", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $e95a8d1b6ebb0ac4$export$400dd8b40ef138a3);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $aAzEJ = parcelRequire("aAzEJ");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");
var $e95a8d1b6ebb0ac4$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(MonthParser, _Parser);
    var _super = (0, $7ZjFV.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $dM0Cr.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 110);
        return _this;
    }
    (0, $lRfe8.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $aAzEJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $lkKeG.Parser));

});

parcelRegister("5RyP4", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $444cea125143a0b8$export$1d7eaa53eaa5deba);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $444cea125143a0b8$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $7ZjFV.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $dM0Cr.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 110);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $aAzEJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $lkKeG.Parser));

});

parcelRegister("a2FWX", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $01e3029b8f1648ce$export$c4005ffc174e07c0);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");

var $j3tBO = parcelRequire("j3tBO");

var $e8tpO = parcelRequire("e8tpO");
var $01e3029b8f1648ce$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(LocalWeekParser, _Parser);
    var _super = (0, $7ZjFV.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $dM0Cr.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 100);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $e8tpO.default)((0, $j3tBO.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $lkKeG.Parser));

});
parcelRegister("j3tBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddf543d1e9d72544$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $h56WH = parcelRequire("h56WH");

var $jILpd = parcelRequire("jILpd");
function $ddf543d1e9d72544$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var week = (0, $ctM6U.default)(dirtyWeek);
    var diff = (0, $h56WH.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("7wI0e", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $57ada79c6aecd0a2$export$6fc8dbedd560a6af);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");

var $8RIYa = parcelRequire("8RIYa");

var $6ft3d = parcelRequire("6ft3d");
var $57ada79c6aecd0a2$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(ISOWeekParser, _Parser);
    var _super = (0, $7ZjFV.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $dM0Cr.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 100);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $6ft3d.default)((0, $8RIYa.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $lkKeG.Parser));

});
parcelRegister("8RIYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $674627f0dac813e4$export$2e2bcd8739ae039);

var $ctM6U = parcelRequire("ctM6U");

var $iOAFx = parcelRequire("iOAFx");

var $i5TSl = parcelRequire("i5TSl");

var $jILpd = parcelRequire("jILpd");
function $674627f0dac813e4$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $jILpd.default)(2, arguments);
    var date = (0, $iOAFx.default)(dirtyDate);
    var isoWeek = (0, $ctM6U.default)(dirtyISOWeek);
    var diff = (0, $i5TSl.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("bigls", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $838e0dedb7868869$export$e8d4b28a20981dd2);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $aAzEJ = parcelRequire("aAzEJ");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");
var $838e0dedb7868869$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $838e0dedb7868869$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $838e0dedb7868869$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(DateParser, _Parser);
    var _super = (0, $7ZjFV.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $dM0Cr.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 90);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "subPriority", 1);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $aAzEJ.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $838e0dedb7868869$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $838e0dedb7868869$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $lkKeG.Parser));

});

parcelRegister("crkgt", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $90e7b9d2c1081444$export$6cfe0d613455f615);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $90e7b9d2c1081444$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(DayOfYearParser, _Parser);
    var _super = (0, $7ZjFV.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $dM0Cr.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 90);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "subpriority", 1);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $aAzEJ.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $lkKeG.Parser));

});

parcelRegister("fkQzG", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $02e1929ac7d04b60$export$1b03c8b76262f7bd);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $gMf6e = parcelRequire("gMf6e");
var $02e1929ac7d04b60$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(DayParser, _Parser);
    var _super = (0, $7ZjFV.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $dM0Cr.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 90);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gMf6e.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $lkKeG.Parser));

});
parcelRegister("gMf6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36cd77ce8efd48b$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");

var $ctM6U = parcelRequire("ctM6U");

var $7SYLh = parcelRequire("7SYLh");
function $c36cd77ce8efd48b$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $jILpd.default)(2, arguments);
    var defaultOptions = (0, $7SYLh.getDefaultOptions)();
    var weekStartsOn = (0, $ctM6U.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $iOAFx.default)(dirtyDate);
    var day = (0, $ctM6U.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("bPSzt", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $89dec9d14555060a$export$44d1c127ab42c480);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");

var $gMf6e = parcelRequire("gMf6e");
var $89dec9d14555060a$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(LocalDayParser, _Parser);
    var _super = (0, $7ZjFV.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $dM0Cr.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 90);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $aAzEJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gMf6e.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $lkKeG.Parser));

});

parcelRegister("jdJF2", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $dfe2a68745027fcb$export$e447a647caaaec1d);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");

var $gMf6e = parcelRequire("gMf6e");
var $dfe2a68745027fcb$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $7ZjFV.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $dM0Cr.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 90);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $aAzEJ.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gMf6e.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $lkKeG.Parser));

});

parcelRegister("hEbIW", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $cd8f442f15999384$export$693fb1e525095b2a);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");

var $8kYri = parcelRequire("8kYri");
var $cd8f442f15999384$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(ISODayParser, _Parser);
    var _super = (0, $7ZjFV.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $dM0Cr.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 90);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $aAzEJ.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $aAzEJ.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $aAzEJ.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $aAzEJ.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $8kYri.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $lkKeG.Parser));

});
parcelRegister("8kYri", function(module, exports) {

$parcel$export(module.exports, "default", () => $611f12fd7a4a2bb4$export$2e2bcd8739ae039);

var $iOAFx = parcelRequire("iOAFx");

var $jILpd = parcelRequire("jILpd");

var $ctM6U = parcelRequire("ctM6U");
function $611f12fd7a4a2bb4$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $jILpd.default)(2, arguments);
    var day = (0, $ctM6U.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $iOAFx.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("jrNCt", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $e287075569cfd789$export$8d1e08492351df91);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $e287075569cfd789$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(AMPMParser, _Parser);
    var _super = (0, $7ZjFV.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $dM0Cr.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 80);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aAzEJ.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $lkKeG.Parser));

});

parcelRegister("kA5vm", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $efbb708f6871da50$export$73ca2bd0a17d273);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $efbb708f6871da50$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $7ZjFV.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $dM0Cr.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 80);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aAzEJ.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $lkKeG.Parser));

});

parcelRegister("5091f", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $3a43f2d97fce9ac2$export$bb9212adf05373db);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $3a43f2d97fce9ac2$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(DayPeriodParser, _Parser);
    var _super = (0, $7ZjFV.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $dM0Cr.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 80);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aAzEJ.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $lkKeG.Parser));

});

parcelRegister("238QM", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $17e2ba0adee621b9$export$8a04050a727a1756);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $17e2ba0adee621b9$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(Hour1to12Parser, _Parser);
    var _super = (0, $7ZjFV.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $dM0Cr.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 70);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $lkKeG.Parser));

});

parcelRegister("aCjuk", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $7bac91f07ad8dd0d$export$e56f4dea2c3e56dd);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $7bac91f07ad8dd0d$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(Hour0to23Parser, _Parser);
    var _super = (0, $7ZjFV.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $dM0Cr.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 70);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $lkKeG.Parser));

});

parcelRegister("ek1Ou", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $a6d4570809ce7545$export$cbbe855312f87d77);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $a6d4570809ce7545$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(Hour0To11Parser, _Parser);
    var _super = (0, $7ZjFV.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $dM0Cr.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 70);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $lkKeG.Parser));

});

parcelRegister("gF884", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $c216c7f0473cd7be$export$6008046d2b34b6a5);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $c216c7f0473cd7be$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(Hour1To24Parser, _Parser);
    var _super = (0, $7ZjFV.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $dM0Cr.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 70);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $lkKeG.Parser));

});

parcelRegister("1klXw", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $0f78b14995736fbc$export$2b52670d9e2be53);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $0f78b14995736fbc$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(MinuteParser, _Parser);
    var _super = (0, $7ZjFV.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $dM0Cr.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 60);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $lkKeG.Parser));

});

parcelRegister("3xbDu", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $292d7ad59ca963db$export$94d46d540cf1366a);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $292d7ad59ca963db$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(SecondParser, _Parser);
    var _super = (0, $7ZjFV.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $dM0Cr.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 50);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $aAzEJ.parseNumericPattern)((0, $byRrW.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $aAzEJ.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $lkKeG.Parser));

});

parcelRegister("8tXgh", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $62cf0044dcce33dc$export$b8e6f8b2d70893b1);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $62cf0044dcce33dc$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $7ZjFV.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $dM0Cr.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 30);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $aAzEJ.mapValue)((0, $aAzEJ.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $lkKeG.Parser));

});

parcelRegister("jzBwx", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $e3fe64a320f21a39$export$104d901d49fea29b);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $e3fe64a320f21a39$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $7ZjFV.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $dM0Cr.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 10);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $lkKeG.Parser));

});

parcelRegister("8j5qv", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $60c44eb139dad878$export$12910e5204b52b9);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $byRrW = parcelRequire("byRrW");

var $aAzEJ = parcelRequire("aAzEJ");
var $60c44eb139dad878$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $7ZjFV.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $dM0Cr.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 10);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $lRfe8.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $aAzEJ.parseTimezonePattern)((0, $byRrW.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $lkKeG.Parser));

});

parcelRegister("h6AQN", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $c73f94ef57d05f84$export$2cd8bf877a05e96);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $c73f94ef57d05f84$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $7ZjFV.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $dM0Cr.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 40);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $lRfe8.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $aAzEJ.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $lkKeG.Parser));

});

parcelRegister("1TfXT", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $16074fcf53ee870a$export$6d8f69c6906d6368);

var $dM0Cr = parcelRequire("dM0Cr");

var $lRfe8 = parcelRequire("lRfe8");

var $1oVxX = parcelRequire("1oVxX");

var $1UPzg = parcelRequire("1UPzg");

var $7ZjFV = parcelRequire("7ZjFV");

var $2qeFG = parcelRequire("2qeFG");

var $lkKeG = parcelRequire("lkKeG");

var $aAzEJ = parcelRequire("aAzEJ");
var $16074fcf53ee870a$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $1UPzg.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $7ZjFV.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $dM0Cr.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "priority", 20);
        (0, $2qeFG.default)((0, $1oVxX.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $lRfe8.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $aAzEJ.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $lkKeG.Parser));

});



parcelRegister("iy6bE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", () => $d810338c48d01b0a$export$e2911fc69bd3195e);
$parcel$export(module.exports, "default", () => $d810338c48d01b0a$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $d810338c48d01b0a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d810338c48d01b0a$var$_setPrototypeOf(subClass, superClass);
}
function $d810338c48d01b0a$var$_setPrototypeOf(o, p) {
    $d810338c48d01b0a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d810338c48d01b0a$var$_setPrototypeOf(o, p);
}
function $d810338c48d01b0a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d810338c48d01b0a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $d810338c48d01b0a$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $d810338c48d01b0a$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $d810338c48d01b0a$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $d810338c48d01b0a$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $d810338c48d01b0a$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $d810338c48d01b0a$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $d810338c48d01b0a$var$uid = $d810338c48d01b0a$var$autoInc();
var $d810338c48d01b0a$var$passiveEventSupport;
var $d810338c48d01b0a$var$handlersMap = {};
var $d810338c48d01b0a$var$enabledInstances = {};
var $d810338c48d01b0a$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $d810338c48d01b0a$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $d810338c48d01b0a$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = $d810338c48d01b0a$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $d810338c48d01b0a$var$passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $d810338c48d01b0a$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $d810338c48d01b0a$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $2pmb0.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $d810338c48d01b0a$var$enabledInstances[_this._uid]) return;
                if (typeof $d810338c48d01b0a$var$passiveEventSupport === 'undefined') $d810338c48d01b0a$var$passiveEventSupport = $d810338c48d01b0a$var$testPassiveEventSupport();
                $d810338c48d01b0a$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $d810338c48d01b0a$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $d810338c48d01b0a$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($d810338c48d01b0a$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $d810338c48d01b0a$var$handlersMap[_this._uid], $d810338c48d01b0a$var$getEventHandlerOptions($d810338c48d01b0a$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $d810338c48d01b0a$var$enabledInstances[_this._uid];
                var fn = $d810338c48d01b0a$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $d810338c48d01b0a$var$getEventHandlerOptions($d810338c48d01b0a$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $d810338c48d01b0a$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $d810338c48d01b0a$var$uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $d810338c48d01b0a$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $8NFma.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $8NFma.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $d810338c48d01b0a$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $d810338c48d01b0a$export$2e2bcd8739ae039 = $d810338c48d01b0a$var$onClickOutsideHOC;

});

parcelRegister("dXIky", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $a2a32c30b64f04ab$export$74665b213cb5c4cf);
$parcel$export(module.exports, "FloatingList", () => $a2a32c30b64f04ab$export$ffe15b0e64951704);
$parcel$export(module.exports, "useListItem", () => $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a);
$parcel$export(module.exports, "Composite", () => $a2a32c30b64f04ab$export$43586241d9db0c6d);
$parcel$export(module.exports, "CompositeItem", () => $a2a32c30b64f04ab$export$ef1ef7a3a43ace8e);
$parcel$export(module.exports, "useId", () => $a2a32c30b64f04ab$export$f680877a34711e37);
$parcel$export(module.exports, "FloatingArrow", () => $a2a32c30b64f04ab$export$33511391554732bc);
$parcel$export(module.exports, "useFloatingParentNodeId", () => $a2a32c30b64f04ab$export$165209eae06d3488);
$parcel$export(module.exports, "useFloatingTree", () => $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69);
$parcel$export(module.exports, "useFloatingNodeId", () => $a2a32c30b64f04ab$export$9b136e0e758a42f4);
$parcel$export(module.exports, "FloatingNode", () => $a2a32c30b64f04ab$export$ca00a83b5b253862);
$parcel$export(module.exports, "FloatingTree", () => $a2a32c30b64f04ab$export$587b60129641c4c8);
$parcel$export(module.exports, "useHover", () => $a2a32c30b64f04ab$export$ae780daf29e6d456);
$parcel$export(module.exports, "useDelayGroupContext", () => $a2a32c30b64f04ab$export$e2411914b150383d);
$parcel$export(module.exports, "FloatingDelayGroup", () => $a2a32c30b64f04ab$export$718279509ff1e241);
$parcel$export(module.exports, "useDelayGroup", () => $a2a32c30b64f04ab$export$560fc8be89c8b4a8);
$parcel$export(module.exports, "useFloatingPortalNode", () => $a2a32c30b64f04ab$export$ac107512f3c5cca6);
$parcel$export(module.exports, "FloatingPortal", () => $a2a32c30b64f04ab$export$31fa5d718fa2ac09);
$parcel$export(module.exports, "FloatingFocusManager", () => $a2a32c30b64f04ab$export$8aeee49171ded61a);
$parcel$export(module.exports, "FloatingOverlay", () => $a2a32c30b64f04ab$export$a35954495955337b);
$parcel$export(module.exports, "useClick", () => $a2a32c30b64f04ab$export$98524f11226063fc);
$parcel$export(module.exports, "useClientPoint", () => $a2a32c30b64f04ab$export$7fe170a73a621816);
$parcel$export(module.exports, "useDismiss", () => $a2a32c30b64f04ab$export$fcdf1ba5fafc089b);
$parcel$export(module.exports, "useFloatingRootContext", () => $a2a32c30b64f04ab$export$1df81146f8ad8e4c);
$parcel$export(module.exports, "useFloating", () => $a2a32c30b64f04ab$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useFocus", () => $a2a32c30b64f04ab$export$f8168d8dd8fd66e6);
$parcel$export(module.exports, "useInteractions", () => $a2a32c30b64f04ab$export$a519f7794e446ddd);
$parcel$export(module.exports, "useListNavigation", () => $a2a32c30b64f04ab$export$b5d22cac4ad33f40);
$parcel$export(module.exports, "useRole", () => $a2a32c30b64f04ab$export$f66572793fa256a1);
$parcel$export(module.exports, "useTransitionStatus", () => $a2a32c30b64f04ab$export$b2ef21706733f7e5);
$parcel$export(module.exports, "useTransitionStyles", () => $a2a32c30b64f04ab$export$769fba13884bc2f4);
$parcel$export(module.exports, "useTypeahead", () => $a2a32c30b64f04ab$export$d8d674d50b73ba93);
$parcel$export(module.exports, "inner", () => $a2a32c30b64f04ab$export$4ae363f1d88fb658);
$parcel$export(module.exports, "useInnerOffset", () => $a2a32c30b64f04ab$export$3d74b0dda7cc82ff);
$parcel$export(module.exports, "safePolygon", () => $a2a32c30b64f04ab$export$7484214ab62358d2);
$parcel$export(module.exports, "arrow", () => (parcelRequire("eqxtD")).arrow);
$parcel$export(module.exports, "autoPlacement", () => (parcelRequire("eqxtD")).autoPlacement);
$parcel$export(module.exports, "autoUpdate", () => (parcelRequire("8i2T6")).autoUpdate);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("8i2T6")).computePosition);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("8i2T6")).detectOverflow);
$parcel$export(module.exports, "flip", () => (parcelRequire("eqxtD")).flip);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("1D9S2")).getOverflowAncestors);
$parcel$export(module.exports, "hide", () => (parcelRequire("eqxtD")).hide);
$parcel$export(module.exports, "inline", () => (parcelRequire("eqxtD")).inline);
$parcel$export(module.exports, "limitShift", () => (parcelRequire("eqxtD")).limitShift);
$parcel$export(module.exports, "offset", () => (parcelRequire("eqxtD")).offset);
$parcel$export(module.exports, "platform", () => (parcelRequire("8i2T6")).platform);
$parcel$export(module.exports, "shift", () => (parcelRequire("eqxtD")).shift);
$parcel$export(module.exports, "size", () => (parcelRequire("eqxtD")).size);

var $8NFma = parcelRequire("8NFma");

var $hn8gG = parcelRequire("hn8gG");

var $Euxde = parcelRequire("Euxde");

var $1D9S2 = parcelRequire("1D9S2");

var $6X8j6 = parcelRequire("6X8j6");

var $2pmb0 = parcelRequire("2pmb0");

var $eqxtD = parcelRequire("eqxtD");
var $8i2T6 = parcelRequire("8i2T6");
var $8i2T6 = parcelRequire("8i2T6");
var $1D9S2 = parcelRequire("1D9S2");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $a2a32c30b64f04ab$export$74665b213cb5c4cf(refs) {
    return $8NFma.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $a2a32c30b64f04ab$var$SafeReact = {
    ...$8NFma
};
const $a2a32c30b64f04ab$var$useInsertionEffect = $a2a32c30b64f04ab$var$SafeReact.useInsertionEffect;
const $a2a32c30b64f04ab$var$useSafeInsertionEffect = $a2a32c30b64f04ab$var$useInsertionEffect || ((fn)=>fn());
function $a2a32c30b64f04ab$var$useEffectEvent(callback) {
    const ref = $8NFma.useRef(()=>{});
    $a2a32c30b64f04ab$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $8NFma.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $a2a32c30b64f04ab$var$ARROW_UP = 'ArrowUp';
const $a2a32c30b64f04ab$var$ARROW_DOWN = 'ArrowDown';
const $a2a32c30b64f04ab$var$ARROW_LEFT = 'ArrowLeft';
const $a2a32c30b64f04ab$var$ARROW_RIGHT = 'ArrowRight';
function $a2a32c30b64f04ab$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $a2a32c30b64f04ab$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndices) {
    return $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $a2a32c30b64f04ab$var$getMaxIndex(listRef, disabledIndices) {
    return $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $a2a32c30b64f04ab$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $a2a32c30b64f04ab$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $a2a32c30b64f04ab$var$ARROW_UP) {
        stop && (0, $hn8gG.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $a2a32c30b64f04ab$var$ARROW_DOWN) {
        stop && (0, $hn8gG.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $Euxde.floor)(prevIndex / cols);
        if (event.key === (rtl ? $a2a32c30b64f04ab$var$ARROW_LEFT : $a2a32c30b64f04ab$var$ARROW_RIGHT)) {
            stop && (0, $hn8gG.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $a2a32c30b64f04ab$var$ARROW_RIGHT : $a2a32c30b64f04ab$var$ARROW_LEFT)) {
            stop && (0, $hn8gG.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($a2a32c30b64f04ab$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $Euxde.floor)(maxIndex / cols) === prevRow;
        if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $a2a32c30b64f04ab$var$ARROW_RIGHT : $a2a32c30b64f04ab$var$ARROW_LEFT) ? maxIndex : $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $a2a32c30b64f04ab$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $a2a32c30b64f04ab$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $a2a32c30b64f04ab$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $a2a32c30b64f04ab$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var $a2a32c30b64f04ab$var$index = typeof document !== 'undefined' ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);
function $a2a32c30b64f04ab$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $a2a32c30b64f04ab$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $a2a32c30b64f04ab$var$FloatingListContext = /*#__PURE__*/ $8NFma.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $a2a32c30b64f04ab$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $8NFma.useState(()=>new Map());
    const register = $8NFma.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $8NFma.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $a2a32c30b64f04ab$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($a2a32c30b64f04ab$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$a2a32c30b64f04ab$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingListContext.Provider, {
        value: $8NFma.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $8NFma.useContext($a2a32c30b64f04ab$var$FloatingListContext);
    const [index$1, setIndex] = $8NFma.useState(null);
    const componentRef = $8NFma.useRef(null);
    const ref = $8NFma.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $8NFma.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $a2a32c30b64f04ab$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $8NFma.cloneElement(render, computedProps);
    return /*#__PURE__*/ $8NFma.createElement("div", computedProps);
}
const $a2a32c30b64f04ab$var$CompositeContext = /*#__PURE__*/ $8NFma.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $a2a32c30b64f04ab$var$horizontalKeys = [
    $a2a32c30b64f04ab$var$ARROW_LEFT,
    $a2a32c30b64f04ab$var$ARROW_RIGHT
];
const $a2a32c30b64f04ab$var$verticalKeys = [
    $a2a32c30b64f04ab$var$ARROW_UP,
    $a2a32c30b64f04ab$var$ARROW_DOWN
];
const $a2a32c30b64f04ab$var$allKeys = [
    ...$a2a32c30b64f04ab$var$horizontalKeys,
    ...$a2a32c30b64f04ab$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $a2a32c30b64f04ab$export$43586241d9db0c6d = /*#__PURE__*/ $8NFma.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $8NFma.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $a2a32c30b64f04ab$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $8NFma.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $8NFma.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$a2a32c30b64f04ab$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $a2a32c30b64f04ab$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $a2a32c30b64f04ab$var$getMaxIndex(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $a2a32c30b64f04ab$var$ARROW_LEFT : $a2a32c30b64f04ab$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $a2a32c30b64f04ab$var$ARROW_RIGHT : $a2a32c30b64f04ab$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $a2a32c30b64f04ab$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$a2a32c30b64f04ab$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $a2a32c30b64f04ab$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$a2a32c30b64f04ab$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $a2a32c30b64f04ab$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $a2a32c30b64f04ab$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $a2a32c30b64f04ab$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $a2a32c30b64f04ab$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $a2a32c30b64f04ab$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $a2a32c30b64f04ab$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $a2a32c30b64f04ab$var$allKeys : ({
            horizontal: $a2a32c30b64f04ab$var$horizontalKeys,
            vertical: $a2a32c30b64f04ab$var$verticalKeys,
            both: $a2a32c30b64f04ab$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $a2a32c30b64f04ab$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$a2a32c30b64f04ab$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $a2a32c30b64f04ab$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $a2a32c30b64f04ab$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $8NFma.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $8NFma.useContext($a2a32c30b64f04ab$var$CompositeContext);
    const { ref: ref, index: index } = $a2a32c30b64f04ab$export$dcdc7ff5149f7d1a();
    const mergedRef = $a2a32c30b64f04ab$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $a2a32c30b64f04ab$var$renderJsx(render, computedProps);
});
function $a2a32c30b64f04ab$var$_extends() {
    $a2a32c30b64f04ab$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a2a32c30b64f04ab$var$_extends.apply(this, arguments);
}
let $a2a32c30b64f04ab$var$serverHandoffComplete = false;
let $a2a32c30b64f04ab$var$count = 0;
const $a2a32c30b64f04ab$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $a2a32c30b64f04ab$var$count++;
function $a2a32c30b64f04ab$var$useFloatingId() {
    const [id, setId] = $8NFma.useState(()=>$a2a32c30b64f04ab$var$serverHandoffComplete ? $a2a32c30b64f04ab$var$genId() : undefined);
    $a2a32c30b64f04ab$var$index(()=>{
        if (id == null) setId($a2a32c30b64f04ab$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $8NFma.useEffect(()=>{
        $a2a32c30b64f04ab$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $a2a32c30b64f04ab$var$useReactId = $a2a32c30b64f04ab$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $a2a32c30b64f04ab$export$f680877a34711e37 = $a2a32c30b64f04ab$var$useReactId || $a2a32c30b64f04ab$var$useFloatingId;
let $a2a32c30b64f04ab$var$devMessageSet;
function $a2a32c30b64f04ab$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $a2a32c30b64f04ab$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $a2a32c30b64f04ab$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $a2a32c30b64f04ab$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $a2a32c30b64f04ab$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $a2a32c30b64f04ab$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $a2a32c30b64f04ab$export$33511391554732bc = /*#__PURE__*/ $8NFma.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $8NFma.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $a2a32c30b64f04ab$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $1D9S2.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $8NFma.createElement("svg", $a2a32c30b64f04ab$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $8NFma.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $8NFma.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $8NFma.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $8NFma.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $a2a32c30b64f04ab$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $a2a32c30b64f04ab$var$FloatingNodeContext = /*#__PURE__*/ $8NFma.createContext(null);
const $a2a32c30b64f04ab$var$FloatingTreeContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $a2a32c30b64f04ab$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $8NFma.useContext($a2a32c30b64f04ab$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69 = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$9b136e0e758a42f4(customParentId) {
    const id = $a2a32c30b64f04ab$export$f680877a34711e37();
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const reactParentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $a2a32c30b64f04ab$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingNodeContext.Provider, {
        value: $8NFma.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $a2a32c30b64f04ab$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $8NFma.useRef([]);
    const addNode = $8NFma.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $8NFma.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $8NFma.useState(()=>$a2a32c30b64f04ab$var$createPubSub())[0];
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingTreeContext.Provider, {
        value: $8NFma.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $a2a32c30b64f04ab$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $a2a32c30b64f04ab$var$useLatestRef(value) {
    const ref = (0, $8NFma.useRef)(value);
    $a2a32c30b64f04ab$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $a2a32c30b64f04ab$var$safePolygonIdentifier = /*#__PURE__*/ $a2a32c30b64f04ab$var$createAttribute('safe-polygon');
function $a2a32c30b64f04ab$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $hn8gG.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $a2a32c30b64f04ab$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const handleCloseRef = $a2a32c30b64f04ab$var$useLatestRef(handleClose);
    const delayRef = $a2a32c30b64f04ab$var$useLatestRef(delay);
    const openRef = $a2a32c30b64f04ab$var$useLatestRef(open);
    const pointerTypeRef = $8NFma.useRef();
    const timeoutRef = $8NFma.useRef(-1);
    const handlerRef = $8NFma.useRef();
    const restTimeoutRef = $8NFma.useRef(-1);
    const blockMouseMoveRef = $8NFma.useRef(true);
    const performedPointerEventsMutationRef = $8NFma.useRef(false);
    const unbindMouseMoveRef = $8NFma.useRef(()=>{});
    const restTimeoutPendingRef = $8NFma.useRef(false);
    const isHoverOpen = $8NFma.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $hn8gG.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $8NFma.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $a2a32c30b64f04ab$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $a2a32c30b64f04ab$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $a2a32c30b64f04ab$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $hn8gG.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($a2a32c30b64f04ab$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = $a2a32c30b64f04ab$var$useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $hn8gG.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$a2a32c30b64f04ab$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $a2a32c30b64f04ab$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $hn8gG.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $hn8gG.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $1D9S2.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $a2a32c30b64f04ab$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $1D9S2.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $hn8gG.getDocument)(elements.floating).body;
                body.setAttribute($a2a32c30b64f04ab$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $8NFma.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $8NFma.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $hn8gG.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $8NFma.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $a2a32c30b64f04ab$var$NOOP = ()=>{};
const $a2a32c30b64f04ab$var$FloatingDelayGroupContext = /*#__PURE__*/ $8NFma.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $a2a32c30b64f04ab$var$NOOP,
    setState: $a2a32c30b64f04ab$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $a2a32c30b64f04ab$export$e2411914b150383d = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $8NFma.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $8NFma.useRef(null);
    const setCurrentId = $8NFma.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $a2a32c30b64f04ab$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FloatingDelayGroupContext.Provider, {
        value: $8NFma.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $a2a32c30b64f04ab$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $a2a32c30b64f04ab$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $a2a32c30b64f04ab$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $a2a32c30b64f04ab$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
let $a2a32c30b64f04ab$var$rafId = 0;
function $a2a32c30b64f04ab$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($a2a32c30b64f04ab$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $a2a32c30b64f04ab$var$rafId = requestAnimationFrame(exec);
}
function $a2a32c30b64f04ab$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $a2a32c30b64f04ab$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $a2a32c30b64f04ab$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $a2a32c30b64f04ab$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $a2a32c30b64f04ab$var$counterMap = /*#__PURE__*/ new WeakMap();
let $a2a32c30b64f04ab$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $a2a32c30b64f04ab$var$markerMap = {};
let $a2a32c30b64f04ab$var$lockCount$1 = 0;
const $a2a32c30b64f04ab$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $a2a32c30b64f04ab$var$unwrapHost = (node)=>node && (node.host || $a2a32c30b64f04ab$var$unwrapHost(node.parentNode));
const $a2a32c30b64f04ab$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $a2a32c30b64f04ab$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $a2a32c30b64f04ab$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $a2a32c30b64f04ab$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$a2a32c30b64f04ab$var$markerMap[markerName]) $a2a32c30b64f04ab$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $a2a32c30b64f04ab$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $1D9S2.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($a2a32c30b64f04ab$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $a2a32c30b64f04ab$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $a2a32c30b64f04ab$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $a2a32c30b64f04ab$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($a2a32c30b64f04ab$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $a2a32c30b64f04ab$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$a2a32c30b64f04ab$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $a2a32c30b64f04ab$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $a2a32c30b64f04ab$var$lockCount$1--;
        if (!$a2a32c30b64f04ab$var$lockCount$1) {
            $a2a32c30b64f04ab$var$counterMap = new WeakMap();
            $a2a32c30b64f04ab$var$counterMap = new WeakMap();
            $a2a32c30b64f04ab$var$uncontrolledElementsSet = new WeakSet();
            $a2a32c30b64f04ab$var$markerMap = {};
        }
    };
}
function $a2a32c30b64f04ab$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $hn8gG.getDocument)(avoidElements[0]).body;
    return $a2a32c30b64f04ab$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $a2a32c30b64f04ab$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $a2a32c30b64f04ab$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $6X8j6.tabbable)(container, $a2a32c30b64f04ab$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $a2a32c30b64f04ab$var$getNextTabbable() {
    return $a2a32c30b64f04ab$var$getTabbableIn(document.body, 'next');
}
function $a2a32c30b64f04ab$var$getPreviousTabbable() {
    return $a2a32c30b64f04ab$var$getTabbableIn(document.body, 'prev');
}
function $a2a32c30b64f04ab$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $hn8gG.contains)(containerElement, relatedTarget);
}
function $a2a32c30b64f04ab$var$disableFocusInside(container) {
    const tabbableElements = (0, $6X8j6.tabbable)(container, $a2a32c30b64f04ab$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $a2a32c30b64f04ab$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $a2a32c30b64f04ab$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $a2a32c30b64f04ab$var$timeoutId;
function $a2a32c30b64f04ab$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($a2a32c30b64f04ab$var$timeoutId);
    }
}
const $a2a32c30b64f04ab$var$FocusGuard = /*#__PURE__*/ $8NFma.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $8NFma.useState();
    $a2a32c30b64f04ab$var$index(()=>{
        if ((0, $hn8gG.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $a2a32c30b64f04ab$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $a2a32c30b64f04ab$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$a2a32c30b64f04ab$var$createAttribute('focus-guard')]: '',
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $8NFma.createElement("span", $a2a32c30b64f04ab$var$_extends({}, props, restProps));
});
const $a2a32c30b64f04ab$var$PortalContext = /*#__PURE__*/ $8NFma.createContext(null);
const $a2a32c30b64f04ab$var$attr = /*#__PURE__*/ $a2a32c30b64f04ab$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $a2a32c30b64f04ab$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const portalContext = $a2a32c30b64f04ab$var$usePortalContext();
    const [portalNode, setPortalNode] = $8NFma.useState(null);
    const portalNodeRef = $8NFma.useRef(null);
    $a2a32c30b64f04ab$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($a2a32c30b64f04ab$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $1D9S2.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($a2a32c30b64f04ab$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $a2a32c30b64f04ab$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $a2a32c30b64f04ab$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $8NFma.useState(null);
    const beforeOutsideRef = $8NFma.useRef(null);
    const afterOutsideRef = $8NFma.useRef(null);
    const beforeInsideRef = $8NFma.useRef(null);
    const afterInsideRef = $8NFma.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $8NFma.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $a2a32c30b64f04ab$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $a2a32c30b64f04ab$var$enableFocusInside : $a2a32c30b64f04ab$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $8NFma.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $a2a32c30b64f04ab$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$PortalContext.Provider, {
        value: $8NFma.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $a2a32c30b64f04ab$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $8NFma.createElement("span", {
        "aria-owns": portalNode.id,
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $2pmb0.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $a2a32c30b64f04ab$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $a2a32c30b64f04ab$var$usePortalContext = ()=>$8NFma.useContext($a2a32c30b64f04ab$var$PortalContext);
const $a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $a2a32c30b64f04ab$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $a2a32c30b64f04ab$var$LIST_LIMIT = 20;
let $a2a32c30b64f04ab$var$previouslyFocusedElements = [];
function $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(element) {
    $a2a32c30b64f04ab$var$previouslyFocusedElements = $a2a32c30b64f04ab$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $1D9S2.getNodeName)(tabbableEl) === 'body') return;
    if (!(0, $6X8j6.isTabbable)(tabbableEl, $a2a32c30b64f04ab$var$getTabbableOptions())) {
        const tabbableChild = (0, $6X8j6.tabbable)(tabbableEl, $a2a32c30b64f04ab$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $a2a32c30b64f04ab$var$previouslyFocusedElements.push(tabbableEl);
    if ($a2a32c30b64f04ab$var$previouslyFocusedElements.length > $a2a32c30b64f04ab$var$LIST_LIMIT) $a2a32c30b64f04ab$var$previouslyFocusedElements = $a2a32c30b64f04ab$var$previouslyFocusedElements.slice(-$a2a32c30b64f04ab$var$LIST_LIMIT);
}
function $a2a32c30b64f04ab$var$getPreviouslyFocusedElement() {
    return $a2a32c30b64f04ab$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $a2a32c30b64f04ab$var$VisuallyHiddenDismiss = /*#__PURE__*/ $8NFma.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $8NFma.createElement("button", $a2a32c30b64f04ab$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $a2a32c30b64f04ab$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $a2a32c30b64f04ab$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $hn8gG.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $a2a32c30b64f04ab$var$supportsInert() ? _guards : true;
    const orderRef = $a2a32c30b64f04ab$var$useLatestRef(order);
    const initialFocusRef = $a2a32c30b64f04ab$var$useLatestRef(initialFocus);
    const returnFocusRef = $a2a32c30b64f04ab$var$useLatestRef(returnFocus);
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const portalContext = $a2a32c30b64f04ab$var$usePortalContext();
    const startDismissButtonRef = $8NFma.useRef(null);
    const endDismissButtonRef = $8NFma.useRef(null);
    const preventReturnFocusRef = $8NFma.useRef(false);
    const isPointerDownRef = $8NFma.useRef(false);
    const tabbableIndexRef = $8NFma.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $a2a32c30b64f04ab$var$getFloatingFocusElement(floating);
    const getTabbableContent = $a2a32c30b64f04ab$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $6X8j6.tabbable)(container, $a2a32c30b64f04ab$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $a2a32c30b64f04ab$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $hn8gG.contains)(floatingFocusElement, (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $hn8gG.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $hn8gG.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $hn8gG.stopEvent)(event);
                    if (event.shiftKey) $a2a32c30b64f04ab$var$enqueueFocus(els[els.length - 1]);
                    else $a2a32c30b64f04ab$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $hn8gG.stopEvent)(event);
                    $a2a32c30b64f04ab$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $hn8gG.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $8NFma.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $hn8gG.contains)(domReference, relatedTarget) || (0, $hn8gG.contains)(floating, relatedTarget) || (0, $hn8gG.contains)(relatedTarget, floating) || (0, $hn8gG.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($a2a32c30b64f04ab$var$createAttribute('focus-guard')) || tree && ($a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $hn8gG.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $hn8gG.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $a2a32c30b64f04ab$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floatingFocusElement)) === (0, $hn8gG.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $1D9S2.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $1D9S2.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $a2a32c30b64f04ab$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $1D9S2.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $8NFma.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $a2a32c30b64f04ab$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $a2a32c30b64f04ab$var$markOthers(insideElements, guards, !guards) : $a2a32c30b64f04ab$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled || !(0, $1D9S2.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $hn8gG.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $hn8gG.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $a2a32c30b64f04ab$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $hn8gG.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $hn8gG.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $hn8gG.isVirtualClick)(event) || (0, $hn8gG.isVirtualPointerEvent)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $a2a32c30b64f04ab$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') return $a2a32c30b64f04ab$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $hn8gG.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $hn8gG.contains)(floating, activeEl) || tree && $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $hn8gG.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $a2a32c30b64f04ab$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $1D9S2.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    $8NFma.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $a2a32c30b64f04ab$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $a2a32c30b64f04ab$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $8NFma.createElement($a2a32c30b64f04ab$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $a2a32c30b64f04ab$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($a2a32c30b64f04ab$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $a2a32c30b64f04ab$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $a2a32c30b64f04ab$var$lockCount = 0;
function $a2a32c30b64f04ab$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $hn8gG.getPlatform)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $a2a32c30b64f04ab$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $a2a32c30b64f04ab$export$a35954495955337b = /*#__PURE__*/ $8NFma.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $a2a32c30b64f04ab$var$index(()=>{
        if (!lockScroll) return;
        $a2a32c30b64f04ab$var$lockCount++;
        if ($a2a32c30b64f04ab$var$lockCount === 1) $a2a32c30b64f04ab$var$cleanup = $a2a32c30b64f04ab$var$enableScrollLock();
        return ()=>{
            $a2a32c30b64f04ab$var$lockCount--;
            if ($a2a32c30b64f04ab$var$lockCount === 0) $a2a32c30b64f04ab$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $8NFma.createElement("div", $a2a32c30b64f04ab$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $a2a32c30b64f04ab$var$isButtonTarget(event) {
    return (0, $1D9S2.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function $a2a32c30b64f04ab$var$isSpaceIgnored(element) {
    return (0, $hn8gG.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $a2a32c30b64f04ab$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $8NFma.useRef();
    const didKeyDownRef = $8NFma.useRef(false);
    const reference = $8NFma.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $hn8gG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $hn8gG.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $a2a32c30b64f04ab$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$a2a32c30b64f04ab$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $a2a32c30b64f04ab$var$isButtonTarget(event) || $a2a32c30b64f04ab$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $a2a32c30b64f04ab$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $a2a32c30b64f04ab$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $a2a32c30b64f04ab$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $8NFma.useRef(false);
    const cleanupListenerRef = $8NFma.useRef(null);
    const [pointerType, setPointerType] = $8NFma.useState();
    const [reactive, setReactive] = $8NFma.useState([]);
    const setReference = $a2a32c30b64f04ab$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$a2a32c30b64f04ab$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($a2a32c30b64f04ab$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $hn8gG.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $8NFma.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $1D9S2.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $hn8gG.getTarget)(event);
            if (!(0, $hn8gG.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $a2a32c30b64f04ab$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $8NFma.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $8NFma.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $8NFma.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $a2a32c30b64f04ab$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $a2a32c30b64f04ab$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $a2a32c30b64f04ab$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $a2a32c30b64f04ab$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $a2a32c30b64f04ab$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $8NFma.useRef(false);
    const endedOrStartedInsideRef = $8NFma.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $a2a32c30b64f04ab$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $a2a32c30b64f04ab$var$normalizeProp(capture);
    const isComposingRef = $8NFma.useRef(false);
    const closeOnEscapeKeyDown = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $hn8gG.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $hn8gG.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $hn8gG.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $hn8gG.getTarget)(event);
        const inertSelector = "[" + $a2a32c30b64f04ab$var$createAttribute('inert') + "]";
        const markers = (0, $hn8gG.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $1D9S2.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $1D9S2.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $1D9S2.getParentNode)(targetRootAncestor);
            if ((0, $1D9S2.isLastTraversableNode)(nextParent) || !(0, $1D9S2.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $1D9S2.isElement)(target) && !(0, $hn8gG.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $hn8gG.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $hn8gG.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $1D9S2.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $1D9S2.getComputedStyle)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $hn8gG.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $hn8gG.isEventTargetWithin)(event, elements.floating) || (0, $hn8gG.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $hn8gG.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $hn8gG.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $8NFma.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $1D9S2.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $hn8gG.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $1D9S2.isElement)(elements.domReference)) ancestors = (0, $1D9S2.getOverflowAncestors)(elements.domReference);
            if ((0, $1D9S2.isElement)(elements.floating)) ancestors = ancestors.concat((0, $1D9S2.getOverflowAncestors)(elements.floating));
            if (!(0, $1D9S2.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $1D9S2.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $8NFma.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $8NFma.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$a2a32c30b64f04ab$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $8NFma.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$a2a32c30b64f04ab$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $a2a32c30b64f04ab$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const dataRef = $8NFma.useRef({});
    const [events] = $8NFma.useState(()=>$a2a32c30b64f04ab$var$createPubSub());
    const nested = $a2a32c30b64f04ab$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $8NFma.useState(elementsProp.reference);
    const onOpenChange = $a2a32c30b64f04ab$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $8NFma.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $8NFma.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $8NFma.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $a2a32c30b64f04ab$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $a2a32c30b64f04ab$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $8NFma.useState(null);
    const [positionReference, _setPositionReference] = $8NFma.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $8NFma.useRef(null);
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    $a2a32c30b64f04ab$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $eqxtD.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $8NFma.useCallback((node)=>{
        const computedPositionReference = (0, $1D9S2.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $8NFma.useCallback((node)=>{
        if ((0, $1D9S2.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $1D9S2.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $1D9S2.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $8NFma.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $8NFma.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $8NFma.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $8NFma.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $a2a32c30b64f04ab$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $8NFma.useRef(false);
    const timeoutRef = $8NFma.useRef();
    const keyboardModalityRef = $8NFma.useRef(true);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $1D9S2.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $1D9S2.isHTMLElement)(elements.domReference) && elements.domReference === (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $8NFma.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $8NFma.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $hn8gG.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $hn8gG.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $1D9S2.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $hn8gG.isSafari)() && (0, $hn8gG.isMac)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $hn8gG.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $1D9S2.isElement)(relatedTarget) && relatedTarget.hasAttribute($a2a32c30b64f04ab$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $hn8gG.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $hn8gG.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $hn8gG.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $a2a32c30b64f04ab$var$ACTIVE_KEY = 'active';
const $a2a32c30b64f04ab$var$SELECTED_KEY = 'selected';
function $a2a32c30b64f04ab$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$a2a32c30b64f04ab$var$ACTIVE_KEY]: _, [$a2a32c30b64f04ab$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$a2a32c30b64f04ab$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $a2a32c30b64f04ab$var$ACTIVE_KEY,
                    $a2a32c30b64f04ab$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $a2a32c30b64f04ab$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $8NFma.useCallback((userProps)=>$a2a32c30b64f04ab$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $8NFma.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $a2a32c30b64f04ab$var$isPreventScrollSupported = false;
function $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $a2a32c30b64f04ab$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $a2a32c30b64f04ab$var$ARROW_UP || key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_LEFT || key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
function $a2a32c30b64f04ab$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    const horizontal = rtl ? key === $a2a32c30b64f04ab$var$ARROW_LEFT : key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $a2a32c30b64f04ab$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $a2a32c30b64f04ab$var$ARROW_LEFT : key === $a2a32c30b64f04ab$var$ARROW_RIGHT;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_DOWN;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
function $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $a2a32c30b64f04ab$var$ARROW_RIGHT : key === $a2a32c30b64f04ab$var$ARROW_LEFT;
    const horizontal = key === $a2a32c30b64f04ab$var$ARROW_UP;
    return $a2a32c30b64f04ab$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $a2a32c30b64f04ab$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $a2a32c30b64f04ab$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $a2a32c30b64f04ab$var$useLatestRef(floatingFocusElement);
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const tree = $a2a32c30b64f04ab$export$db0c2a7c7a2a4f69();
    const onNavigate = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $hn8gG.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $8NFma.useRef(focusItemOnOpen);
    const indexRef = $8NFma.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $8NFma.useRef(null);
    const isPointerModalityRef = $8NFma.useRef(true);
    const previousOnNavigateRef = $8NFma.useRef(onNavigate);
    const previousMountedRef = $8NFma.useRef(!!elements.floating);
    const previousOpenRef = $8NFma.useRef(open);
    const forceSyncFocus = $8NFma.useRef(false);
    const forceScrollIntoViewRef = $8NFma.useRef(false);
    const disabledIndicesRef = $a2a32c30b64f04ab$var$useLatestRef(disabledIndices);
    const latestOpenRef = $a2a32c30b64f04ab$var$useLatestRef(open);
    const scrollItemIntoViewRef = $a2a32c30b64f04ab$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $a2a32c30b64f04ab$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $8NFma.useState();
    const [virtualId, setVirtualId] = $8NFma.useState();
    const focusItem = $a2a32c30b64f04ab$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $a2a32c30b64f04ab$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $hn8gG.isMac)() && (0, $hn8gG.isSafari)() ? $a2a32c30b64f04ab$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $a2a32c30b64f04ab$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $a2a32c30b64f04ab$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $a2a32c30b64f04ab$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndicesRef.current) : $a2a32c30b64f04ab$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$a2a32c30b64f04ab$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $a2a32c30b64f04ab$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $hn8gG.activeElement)((0, $hn8gG.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $hn8gG.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $a2a32c30b64f04ab$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $8NFma.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $a2a32c30b64f04ab$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $hn8gG.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $1D9S2.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $a2a32c30b64f04ab$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $hn8gG.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $hn8gG.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $a2a32c30b64f04ab$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$a2a32c30b64f04ab$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$a2a32c30b64f04ab$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $a2a32c30b64f04ab$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$a2a32c30b64f04ab$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $a2a32c30b64f04ab$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $a2a32c30b64f04ab$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $a2a32c30b64f04ab$var$ARROW_LEFT : $a2a32c30b64f04ab$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($a2a32c30b64f04ab$var$isMainOrientationKey(event.key, orientation)) {
            (0, $hn8gG.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $hn8gG.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $a2a32c30b64f04ab$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($a2a32c30b64f04ab$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $a2a32c30b64f04ab$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($a2a32c30b64f04ab$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $8NFma.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $8NFma.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $hn8gG.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $8NFma.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $hn8gG.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $hn8gG.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $a2a32c30b64f04ab$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $a2a32c30b64f04ab$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $a2a32c30b64f04ab$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $a2a32c30b64f04ab$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $hn8gG.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $hn8gG.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $hn8gG.stopEvent)(event);
                        if (open) {
                            indexRef.current = $a2a32c30b64f04ab$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $hn8gG.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $a2a32c30b64f04ab$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $a2a32c30b64f04ab$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $a2a32c30b64f04ab$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $a2a32c30b64f04ab$export$f680877a34711e37();
    const parentId = $a2a32c30b64f04ab$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $8NFma.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $8NFma.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $8NFma.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $a2a32c30b64f04ab$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $a2a32c30b64f04ab$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $a2a32c30b64f04ab$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $8NFma.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $8NFma.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $a2a32c30b64f04ab$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $8NFma.useState('unmounted');
    const isMounted = $a2a32c30b64f04ab$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $a2a32c30b64f04ab$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $a2a32c30b64f04ab$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $8NFma.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $8NFma.useState(()=>({
            ...$a2a32c30b64f04ab$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$a2a32c30b64f04ab$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $a2a32c30b64f04ab$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_initial);
    const openRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_open);
    const closeRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_close);
    const commonRef = $a2a32c30b64f04ab$var$useLatestRef(unstable_common);
    $a2a32c30b64f04ab$var$index(()=>{
        const initialStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $a2a32c30b64f04ab$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($a2a32c30b64f04ab$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($a2a32c30b64f04ab$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $a2a32c30b64f04ab$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $8NFma.useRef();
    const stringRef = $8NFma.useRef('');
    const prevIndexRef = $8NFma.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $8NFma.useRef(null);
    const onMatch = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $a2a32c30b64f04ab$var$useLatestRef(findMatch);
    const ignoreKeysRef = $a2a32c30b64f04ab$var$useLatestRef(ignoreKeys);
    $a2a32c30b64f04ab$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $a2a32c30b64f04ab$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $a2a32c30b64f04ab$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $a2a32c30b64f04ab$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $hn8gG.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $hn8gG.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $8NFma.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $8NFma.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $a2a32c30b64f04ab$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $Euxde.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $eqxtD.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $8i2T6.detectOverflow)($a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $8i2T6.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $Euxde.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $Euxde.round);
            const maxHeight = rounder((0, $Euxde.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $Euxde.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $Euxde.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $2pmb0.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $8i2T6.detectOverflow)($a2a32c30b64f04ab$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $a2a32c30b64f04ab$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $a2a32c30b64f04ab$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $8NFma.useRef(false);
    const prevScrollTopRef = $8NFma.useRef(null);
    const initialOverflowRef = $8NFma.useRef(null);
    $8NFma.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $2pmb0.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $hn8gG.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $8NFma.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $2pmb0.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $8NFma.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $a2a32c30b64f04ab$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $a2a32c30b64f04ab$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $a2a32c30b64f04ab$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $hn8gG.getTarget)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $hn8gG.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $hn8gG.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $a2a32c30b64f04ab$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $1D9S2.isElement)(event.relatedTarget) && (0, $hn8gG.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $a2a32c30b64f04ab$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($a2a32c30b64f04ab$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$a2a32c30b64f04ab$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("hn8gG", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $ca5aff85a2f3333d$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $ca5aff85a2f3333d$export$2344b14b097df817);
$parcel$export(module.exports, "getPlatform", () => $ca5aff85a2f3333d$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $ca5aff85a2f3333d$export$7935961ef7719cb0);
$parcel$export(module.exports, "isVirtualClick", () => $ca5aff85a2f3333d$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $ca5aff85a2f3333d$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isSafari", () => $ca5aff85a2f3333d$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $ca5aff85a2f3333d$export$9ac100e40613ea10);
$parcel$export(module.exports, "isMouseLikePointerType", () => $ca5aff85a2f3333d$export$81cf264172d31e51);
$parcel$export(module.exports, "isReactEvent", () => $ca5aff85a2f3333d$export$94781ce41a161222);
$parcel$export(module.exports, "isRootElement", () => $ca5aff85a2f3333d$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $ca5aff85a2f3333d$export$f65ca476c09acec0);
$parcel$export(module.exports, "isEventTargetWithin", () => $ca5aff85a2f3333d$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "getTarget", () => $ca5aff85a2f3333d$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isTypeableElement", () => $ca5aff85a2f3333d$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "stopEvent", () => $ca5aff85a2f3333d$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isTypeableCombobox", () => $ca5aff85a2f3333d$export$259ba5ae38188551);

var $1D9S2 = parcelRequire("1D9S2");
function $ca5aff85a2f3333d$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $ca5aff85a2f3333d$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $1D9S2.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $ca5aff85a2f3333d$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $ca5aff85a2f3333d$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $ca5aff85a2f3333d$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($ca5aff85a2f3333d$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $ca5aff85a2f3333d$export$29bf1b5f2c56cf63(event) {
    if ($ca5aff85a2f3333d$export$c8f880a2d81914c4()) return false;
    return !$ca5aff85a2f3333d$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $ca5aff85a2f3333d$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $ca5aff85a2f3333d$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $ca5aff85a2f3333d$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($ca5aff85a2f3333d$export$867a782338812cb4()) || re.test($ca5aff85a2f3333d$export$7935961ef7719cb0());
}
function $ca5aff85a2f3333d$export$9ac100e40613ea10() {
    return $ca5aff85a2f3333d$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $ca5aff85a2f3333d$export$c8f880a2d81914c4() {
    return $ca5aff85a2f3333d$export$7935961ef7719cb0().includes('jsdom/');
}
function $ca5aff85a2f3333d$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $ca5aff85a2f3333d$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $ca5aff85a2f3333d$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $ca5aff85a2f3333d$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $ca5aff85a2f3333d$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $ca5aff85a2f3333d$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $ca5aff85a2f3333d$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $ca5aff85a2f3333d$export$42ad131c32f0fb8d(element) {
    return (0, $1D9S2.isHTMLElement)(element) && element.matches($ca5aff85a2f3333d$export$78b3d091ff376bc);
}
function $ca5aff85a2f3333d$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $ca5aff85a2f3333d$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $ca5aff85a2f3333d$export$42ad131c32f0fb8d(element);
}

});

parcelRegister("6X8j6", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $50feb264d5622a99$export$17100aea90429aa7);
$parcel$export(module.exports, "isTabbable", () => $50feb264d5622a99$export$bebd5a1431fec25d);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $50feb264d5622a99$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $50feb264d5622a99$var$candidateSelector = /* #__PURE__ */ $50feb264d5622a99$var$candidateSelectors.join(',');
var $50feb264d5622a99$var$NoElement = typeof Element === 'undefined';
var $50feb264d5622a99$var$matches = $50feb264d5622a99$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $50feb264d5622a99$var$getRootNode = !$50feb264d5622a99$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $50feb264d5622a99$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $50feb264d5622a99$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $50feb264d5622a99$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($50feb264d5622a99$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($50feb264d5622a99$var$candidateSelector));
    if (includeContainer && $50feb264d5622a99$var$matches.call(el, $50feb264d5622a99$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $50feb264d5622a99$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($50feb264d5622a99$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $50feb264d5622a99$var$matches.call(element, $50feb264d5622a99$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$50feb264d5622a99$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $50feb264d5622a99$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $50feb264d5622a99$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $50feb264d5622a99$var$isContentEditable(node)) && !$50feb264d5622a99$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $50feb264d5622a99$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $50feb264d5622a99$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$50feb264d5622a99$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $50feb264d5622a99$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $50feb264d5622a99$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $50feb264d5622a99$var$isHiddenInput = function isHiddenInput(node) {
    return $50feb264d5622a99$var$isInput(node) && node.type === 'hidden';
};
var $50feb264d5622a99$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $50feb264d5622a99$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $50feb264d5622a99$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $50feb264d5622a99$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $50feb264d5622a99$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $50feb264d5622a99$var$isRadio = function isRadio(node) {
    return $50feb264d5622a99$var$isInput(node) && node.type === 'radio';
};
var $50feb264d5622a99$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $50feb264d5622a99$var$isRadio(node) && !$50feb264d5622a99$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $50feb264d5622a99$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $50feb264d5622a99$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $50feb264d5622a99$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $50feb264d5622a99$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $50feb264d5622a99$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $50feb264d5622a99$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($50feb264d5622a99$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $50feb264d5622a99$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $50feb264d5622a99$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($50feb264d5622a99$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $50feb264d5622a99$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $50feb264d5622a99$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $50feb264d5622a99$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $50feb264d5622a99$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $50feb264d5622a99$var$isInert(node) || $50feb264d5622a99$var$isHiddenInput(node) || $50feb264d5622a99$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $50feb264d5622a99$var$isDetailsWithSummary(node) || $50feb264d5622a99$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $50feb264d5622a99$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($50feb264d5622a99$var$isNonTabbableRadio(node) || $50feb264d5622a99$export$a4672efddb4181b8(node) < 0 || !$50feb264d5622a99$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $50feb264d5622a99$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $50feb264d5622a99$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $50feb264d5622a99$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($50feb264d5622a99$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $50feb264d5622a99$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $50feb264d5622a99$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $50feb264d5622a99$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $50feb264d5622a99$var$isValidShadowRootTabbable
    });
    else candidates = $50feb264d5622a99$var$getCandidates(container, options.includeContainer, $50feb264d5622a99$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $50feb264d5622a99$var$sortByOrder(candidates);
};
var $50feb264d5622a99$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $50feb264d5622a99$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $50feb264d5622a99$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $50feb264d5622a99$var$getCandidates(container, options.includeContainer, $50feb264d5622a99$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $50feb264d5622a99$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($50feb264d5622a99$var$matches.call(node, $50feb264d5622a99$var$candidateSelector) === false) return false;
    return $50feb264d5622a99$var$isNodeMatchingSelectorTabbable(options, node);
};
var $50feb264d5622a99$var$focusableCandidateSelector = /* #__PURE__ */ $50feb264d5622a99$var$candidateSelectors.concat('iframe').join(',');
var $50feb264d5622a99$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($50feb264d5622a99$var$matches.call(node, $50feb264d5622a99$var$focusableCandidateSelector) === false) return false;
    return $50feb264d5622a99$var$isNodeMatchingSelectorFocusable(options, node);
};

});

parcelRegister("eqxtD", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $a80d76388d068913$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => $a80d76388d068913$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $a80d76388d068913$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $a80d76388d068913$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "flip", () => $a80d76388d068913$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $a80d76388d068913$export$346677f925de839c);
$parcel$export(module.exports, "autoPlacement", () => $a80d76388d068913$export$91fb6ecbd551914);
$parcel$export(module.exports, "hide", () => $a80d76388d068913$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $a80d76388d068913$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "arrow", () => $a80d76388d068913$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("8i2T6")).computePosition);

var $8i2T6 = parcelRequire("8i2T6");
var $1D9S2 = parcelRequire("1D9S2");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
var $a80d76388d068913$var$index = typeof document !== 'undefined' ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $a80d76388d068913$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$a80d76388d068913$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$a80d76388d068913$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $a80d76388d068913$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $a80d76388d068913$var$roundByDPR(element, value) {
    const dpr = $a80d76388d068913$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $a80d76388d068913$var$useLatestRef(value) {
    const ref = $8NFma.useRef(value);
    $a80d76388d068913$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $a80d76388d068913$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $8NFma.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $8NFma.useState(middleware);
    if (!$a80d76388d068913$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $8NFma.useState(null);
    const [_floating, _setFloating] = $8NFma.useState(null);
    const setReference = $8NFma.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $8NFma.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $8NFma.useRef(null);
    const floatingRef = $8NFma.useRef(null);
    const dataRef = $8NFma.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $a80d76388d068913$var$useLatestRef(whileElementsMounted);
    const platformRef = $a80d76388d068913$var$useLatestRef(platform);
    const openRef = $a80d76388d068913$var$useLatestRef(open);
    const update = $8NFma.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $8i2T6.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$a80d76388d068913$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $2pmb0.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $a80d76388d068913$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $8NFma.useRef(false);
    $a80d76388d068913$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $a80d76388d068913$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $8NFma.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $8NFma.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $8NFma.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $a80d76388d068913$var$roundByDPR(elements.floating, data.x);
        const y = $a80d76388d068913$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$a80d76388d068913$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $8NFma.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a80d76388d068913$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $8i2T6.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $8i2T6.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $a80d76388d068913$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $8i2T6.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $a80d76388d068913$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $8i2T6.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $a80d76388d068913$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $8i2T6.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $a80d76388d068913$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $8i2T6.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $a80d76388d068913$export$346677f925de839c = (options, deps)=>({
        ...(0, $8i2T6.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $a80d76388d068913$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $8i2T6.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $a80d76388d068913$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $8i2T6.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $a80d76388d068913$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $8i2T6.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a80d76388d068913$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$a80d76388d068913$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});


parcelRegister("aWNCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7f85d103d7ac2329$export$2e2bcd8739ae039);

var $jOMXy = parcelRequire("jOMXy");

var $iOAFx = parcelRequire("iOAFx");

var $fg6w7 = parcelRequire("fg6w7");

var $ctM6U = parcelRequire("ctM6U");

var $jILpd = parcelRequire("jILpd");
function $7f85d103d7ac2329$export$2e2bcd8739ae039(dirtyDate, values) {
    (0, $jILpd.default)(2, arguments);
    if ((0, $jOMXy.default)(values) !== 'object' || values === null) throw new RangeError('values parameter must be an object');
    var date = (0, $iOAFx.default)(dirtyDate);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    if (values.year != null) date.setFullYear(values.year);
    if (values.month != null) date = (0, $fg6w7.default)(date, values.month);
    if (values.date != null) date.setDate((0, $ctM6U.default)(values.date));
    if (values.hours != null) date.setHours((0, $ctM6U.default)(values.hours));
    if (values.minutes != null) date.setMinutes((0, $ctM6U.default)(values.minutes));
    if (values.seconds != null) date.setSeconds((0, $ctM6U.default)(values.seconds));
    if (values.milliseconds != null) date.setMilliseconds((0, $ctM6U.default)(values.milliseconds));
    return date;
}

});




var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $4N26z = parcelRequire("4N26z");

var $kKP1P = parcelRequire("kKP1P");

var $eWs7Q = parcelRequire("eWs7Q");

var $h9Lvm = parcelRequire("h9Lvm");

var $8B2uX = parcelRequire("8B2uX");
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");

var $O6tRJ = parcelRequire("O6tRJ");

var $6T1J1 = parcelRequire("6T1J1");

var $4tbyZ = parcelRequire("4tbyZ");

var $lHJBw = parcelRequire("lHJBw");

var $gNm81 = parcelRequire("gNm81");
/**
 * https://docs.dndkit.com/presets/sortable#drag-overlay
 * */ 
var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");

var $8NFma = parcelRequire("8NFma");
function $bc7d58aa683e9af1$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $8NFma.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $bc7d58aa683e9af1$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $bc7d58aa683e9af1$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $bc7d58aa683e9af1$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $bc7d58aa683e9af1$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($bc7d58aa683e9af1$export$5a096129d439f843(target)) return target;
    if (!$bc7d58aa683e9af1$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $bc7d58aa683e9af1$export$62858bae88b53fd0(node) {
    const { Document: Document } = $bc7d58aa683e9af1$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $bc7d58aa683e9af1$export$1b3bfaa9684536aa(node) {
    if ($bc7d58aa683e9af1$export$5a096129d439f843(node)) return false;
    return node instanceof $bc7d58aa683e9af1$export$38b2d434cce3ea22(node).HTMLElement;
}
function $bc7d58aa683e9af1$export$17eda790a720ec57(node) {
    return node instanceof $bc7d58aa683e9af1$export$38b2d434cce3ea22(node).SVGElement;
}
function $bc7d58aa683e9af1$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($bc7d58aa683e9af1$export$5a096129d439f843(target)) return target.document;
    if (!$bc7d58aa683e9af1$export$8ee0fc9ee280b4ee(target)) return document;
    if ($bc7d58aa683e9af1$export$62858bae88b53fd0(target)) return target;
    if ($bc7d58aa683e9af1$export$1b3bfaa9684536aa(target) || $bc7d58aa683e9af1$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $bc7d58aa683e9af1$export$700979bc83e7db82 = $bc7d58aa683e9af1$export$71594e8a50f746f4 ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);
function $bc7d58aa683e9af1$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $8NFma.useRef)(handler);
    $bc7d58aa683e9af1$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $8NFma.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $bc7d58aa683e9af1$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $8NFma.useRef)(null);
    const set = (0, $8NFma.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $8NFma.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $bc7d58aa683e9af1$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $8NFma.useRef)(value);
    $bc7d58aa683e9af1$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $bc7d58aa683e9af1$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $8NFma.useRef)();
    return (0, $8NFma.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $bc7d58aa683e9af1$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $bc7d58aa683e9af1$export$90fc3a17d93f704c(onChange);
    const node = (0, $8NFma.useRef)(null);
    const setNodeRef = (0, $8NFma.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $bc7d58aa683e9af1$export$5cae361ad82dce8b(value) {
    const ref = (0, $8NFma.useRef)();
    (0, $8NFma.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $bc7d58aa683e9af1$var$ids = {};
function $bc7d58aa683e9af1$export$c485849f2e393253(prefix, value) {
    return (0, $8NFma.useMemo)(()=>{
        if (value) return value;
        const id = $bc7d58aa683e9af1$var$ids[prefix] == null ? 0 : $bc7d58aa683e9af1$var$ids[prefix] + 1;
        $bc7d58aa683e9af1$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $bc7d58aa683e9af1$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $bc7d58aa683e9af1$export$e16d8520af44a096 = /*#__PURE__*/ $bc7d58aa683e9af1$var$createAdjustmentFn(1);
const $bc7d58aa683e9af1$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $bc7d58aa683e9af1$var$createAdjustmentFn(-1);
function $bc7d58aa683e9af1$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $bc7d58aa683e9af1$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $bc7d58aa683e9af1$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $bc7d58aa683e9af1$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $bc7d58aa683e9af1$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $bc7d58aa683e9af1$export$36195c8aa1517e04(event) {
    if ($bc7d58aa683e9af1$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($bc7d58aa683e9af1$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $bc7d58aa683e9af1$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $bc7d58aa683e9af1$export$c4ffa16951855e28.Translate.toString(transform),
                $bc7d58aa683e9af1$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $bc7d58aa683e9af1$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $bc7d58aa683e9af1$export$44f71d798fd0a62b(element) {
    if (element.matches($bc7d58aa683e9af1$var$SELECTOR)) return element;
    return element.querySelector($bc7d58aa683e9af1$var$SELECTOR);
}



var $8NFma = parcelRequire("8NFma");
const $ceca1165e7d66b57$var$hiddenStyles = {
    display: 'none'
};
function $ceca1165e7d66b57$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        id: id,
        style: $ceca1165e7d66b57$var$hiddenStyles
    }, value);
}
function $ceca1165e7d66b57$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $ceca1165e7d66b57$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $8NFma.useState)('');
    const announce = (0, $8NFma.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $6f3a0c2935d691fb$var$DndMonitorContext = /*#__PURE__*/ (0, $8NFma.createContext)(null);
function $6f3a0c2935d691fb$export$1182af90218a7b81(listener) {
    const registerListener = (0, $8NFma.useContext)($6f3a0c2935d691fb$var$DndMonitorContext);
    (0, $8NFma.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $6f3a0c2935d691fb$var$useDndMonitorProvider() {
    const [listeners] = (0, $8NFma.useState)(()=>new Set());
    const registerListener = (0, $8NFma.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $8NFma.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $6f3a0c2935d691fb$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $6f3a0c2935d691fb$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $6f3a0c2935d691fb$var$Accessibility(_ref) {
    let { announcements: announcements = $6f3a0c2935d691fb$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $6f3a0c2935d691fb$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $ceca1165e7d66b57$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $bc7d58aa683e9af1$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        setMounted(true);
    }, []);
    $6f3a0c2935d691fb$export$1182af90218a7b81((0, $8NFma.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $ceca1165e7d66b57$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $ceca1165e7d66b57$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $2pmb0.createPortal)(markup, container) : markup;
}
var $6f3a0c2935d691fb$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($6f3a0c2935d691fb$var$Action || ($6f3a0c2935d691fb$var$Action = {}));
function $6f3a0c2935d691fb$var$noop() {}
function $6f3a0c2935d691fb$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $8NFma.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $6f3a0c2935d691fb$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $8NFma.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $6f3a0c2935d691fb$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $6f3a0c2935d691fb$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $6f3a0c2935d691fb$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $bc7d58aa683e9af1$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $6f3a0c2935d691fb$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $6f3a0c2935d691fb$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $6f3a0c2935d691fb$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $6f3a0c2935d691fb$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $6f3a0c2935d691fb$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $6f3a0c2935d691fb$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $6f3a0c2935d691fb$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $6f3a0c2935d691fb$var$distanceBetween($6f3a0c2935d691fb$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($6f3a0c2935d691fb$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $6f3a0c2935d691fb$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $6f3a0c2935d691fb$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $6f3a0c2935d691fb$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $6f3a0c2935d691fb$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($6f3a0c2935d691fb$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $6f3a0c2935d691fb$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $6f3a0c2935d691fb$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $6f3a0c2935d691fb$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($6f3a0c2935d691fb$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $6f3a0c2935d691fb$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $6f3a0c2935d691fb$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $6f3a0c2935d691fb$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $6f3a0c2935d691fb$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $6f3a0c2935d691fb$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($6f3a0c2935d691fb$var$sortCollisionsAsc);
};
function $6f3a0c2935d691fb$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $6f3a0c2935d691fb$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $6f3a0c2935d691fb$export$597cbd7bbd10deb4;
}
function $6f3a0c2935d691fb$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $6f3a0c2935d691fb$var$getAdjustedRect = /*#__PURE__*/ $6f3a0c2935d691fb$var$createRectAdjustmentFn(1);
function $6f3a0c2935d691fb$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $6f3a0c2935d691fb$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $6f3a0c2935d691fb$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $6f3a0c2935d691fb$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $6f3a0c2935d691fb$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $6f3a0c2935d691fb$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $6f3a0c2935d691fb$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $6f3a0c2935d691fb$var$getTransformAgnosticClientRect(element) {
    return $6f3a0c2935d691fb$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $6f3a0c2935d691fb$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $6f3a0c2935d691fb$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $6f3a0c2935d691fb$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $6f3a0c2935d691fb$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $bc7d58aa683e9af1$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $bc7d58aa683e9af1$export$1b3bfaa9684536aa)(node) || (0, $bc7d58aa683e9af1$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($6f3a0c2935d691fb$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($6f3a0c2935d691fb$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $6f3a0c2935d691fb$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $6f3a0c2935d691fb$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $6f3a0c2935d691fb$var$getScrollableElement(element) {
    if (!(0, $bc7d58aa683e9af1$export$71594e8a50f746f4) || !element) return null;
    if ((0, $bc7d58aa683e9af1$export$5a096129d439f843)(element)) return element;
    if (!(0, $bc7d58aa683e9af1$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $bc7d58aa683e9af1$export$62858bae88b53fd0)(element) || element === (0, $bc7d58aa683e9af1$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $bc7d58aa683e9af1$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $6f3a0c2935d691fb$var$getScrollXCoordinate(element) {
    if ((0, $bc7d58aa683e9af1$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $6f3a0c2935d691fb$var$getScrollYCoordinate(element) {
    if ((0, $bc7d58aa683e9af1$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $6f3a0c2935d691fb$var$getScrollCoordinates(element) {
    return {
        x: $6f3a0c2935d691fb$var$getScrollXCoordinate(element),
        y: $6f3a0c2935d691fb$var$getScrollYCoordinate(element)
    };
}
var $6f3a0c2935d691fb$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($6f3a0c2935d691fb$var$Direction || ($6f3a0c2935d691fb$var$Direction = {}));
function $6f3a0c2935d691fb$var$isDocumentScrollingElement(element) {
    if (!(0, $bc7d58aa683e9af1$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $6f3a0c2935d691fb$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $6f3a0c2935d691fb$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $6f3a0c2935d691fb$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $6f3a0c2935d691fb$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $6f3a0c2935d691fb$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $6f3a0c2935d691fb$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $6f3a0c2935d691fb$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $6f3a0c2935d691fb$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $6f3a0c2935d691fb$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $6f3a0c2935d691fb$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $6f3a0c2935d691fb$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $6f3a0c2935d691fb$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $bc7d58aa683e9af1$export$e16d8520af44a096)(acc, $6f3a0c2935d691fb$var$getScrollCoordinates(node));
    }, $6f3a0c2935d691fb$export$597cbd7bbd10deb4);
}
function $6f3a0c2935d691fb$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $6f3a0c2935d691fb$var$getScrollXCoordinate(node);
    }, 0);
}
function $6f3a0c2935d691fb$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $6f3a0c2935d691fb$var$getScrollYCoordinate(node);
    }, 0);
}
function $6f3a0c2935d691fb$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $6f3a0c2935d691fb$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $6f3a0c2935d691fb$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $6f3a0c2935d691fb$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $6f3a0c2935d691fb$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $6f3a0c2935d691fb$var$getScrollYOffset
    ]
];
class $6f3a0c2935d691fb$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $6f3a0c2935d691fb$export$e4864aa91b5ed091(element);
        const scrollOffsets = $6f3a0c2935d691fb$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $6f3a0c2935d691fb$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $6f3a0c2935d691fb$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $6f3a0c2935d691fb$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $bc7d58aa683e9af1$export$b204af158042fbac)(target);
}
function $6f3a0c2935d691fb$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $6f3a0c2935d691fb$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($6f3a0c2935d691fb$var$EventName || ($6f3a0c2935d691fb$var$EventName = {}));
function $6f3a0c2935d691fb$var$preventDefault(event) {
    event.preventDefault();
}
function $6f3a0c2935d691fb$var$stopPropagation(event) {
    event.stopPropagation();
}
var $6f3a0c2935d691fb$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($6f3a0c2935d691fb$export$a8b1916dba3ae88b || ($6f3a0c2935d691fb$export$a8b1916dba3ae88b = {}));
const $6f3a0c2935d691fb$var$defaultKeyboardCodes = {
    start: [
        $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Space,
        $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Space,
        $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Enter,
        $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Tab
    ]
};
const $6f3a0c2935d691fb$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $6f3a0c2935d691fb$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $6f3a0c2935d691fb$var$Listeners((0, $bc7d58aa683e9af1$export$b204af158042fbac)(target));
        this.windowListeners = new $6f3a0c2935d691fb$var$Listeners((0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($6f3a0c2935d691fb$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($6f3a0c2935d691fb$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($6f3a0c2935d691fb$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $6f3a0c2935d691fb$var$scrollIntoViewIfNeeded(node);
        onStart($6f3a0c2935d691fb$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $bc7d58aa683e9af1$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $6f3a0c2935d691fb$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $6f3a0c2935d691fb$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $6f3a0c2935d691fb$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $bc7d58aa683e9af1$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $6f3a0c2935d691fb$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $6f3a0c2935d691fb$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Right && !isRight || direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Down && !isBottom || direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $bc7d58aa683e9af1$export$e16d8520af44a096)((0, $bc7d58aa683e9af1$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$6f3a0c2935d691fb$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $6f3a0c2935d691fb$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $6f3a0c2935d691fb$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $6f3a0c2935d691fb$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $6f3a0c2935d691fb$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $6f3a0c2935d691fb$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $bc7d58aa683e9af1$export$b204af158042fbac)(target);
        this.documentListeners = new $6f3a0c2935d691fb$var$Listeners(this.document);
        this.listeners = new $6f3a0c2935d691fb$var$Listeners(listenerTarget);
        this.windowListeners = new $6f3a0c2935d691fb$var$Listeners((0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $bc7d58aa683e9af1$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $6f3a0c2935d691fb$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($6f3a0c2935d691fb$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($6f3a0c2935d691fb$var$EventName.DragStart, $6f3a0c2935d691fb$var$preventDefault);
        this.windowListeners.add($6f3a0c2935d691fb$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($6f3a0c2935d691fb$var$EventName.ContextMenu, $6f3a0c2935d691fb$var$preventDefault);
        this.documentListeners.add($6f3a0c2935d691fb$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($6f3a0c2935d691fb$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($6f3a0c2935d691fb$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($6f3a0c2935d691fb$var$EventName.Click, $6f3a0c2935d691fb$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($6f3a0c2935d691fb$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $bc7d58aa683e9af1$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $6f3a0c2935d691fb$export$597cbd7bbd10deb4;
        const delta = (0, $bc7d58aa683e9af1$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($6f3a0c2935d691fb$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $6f3a0c2935d691fb$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($6f3a0c2935d691fb$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($6f3a0c2935d691fb$var$isDelayConstraint(activationConstraint)) {
                if ($6f3a0c2935d691fb$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $6f3a0c2935d691fb$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $6f3a0c2935d691fb$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $6f3a0c2935d691fb$export$b26af955418d6638 extends $6f3a0c2935d691fb$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $bc7d58aa683e9af1$export$b204af158042fbac)(event.target);
        super(props, $6f3a0c2935d691fb$var$events, listenerTarget);
    }
}
$6f3a0c2935d691fb$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $6f3a0c2935d691fb$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $6f3a0c2935d691fb$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($6f3a0c2935d691fb$var$MouseButton || ($6f3a0c2935d691fb$var$MouseButton = {}));
class $6f3a0c2935d691fb$export$b28554b50bf7f273 extends $6f3a0c2935d691fb$var$AbstractPointerSensor {
    constructor(props){
        super(props, $6f3a0c2935d691fb$var$events$1, (0, $bc7d58aa683e9af1$export$b204af158042fbac)(props.event.target));
    }
}
$6f3a0c2935d691fb$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $6f3a0c2935d691fb$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $6f3a0c2935d691fb$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $6f3a0c2935d691fb$export$19b41baf2e1bcdc0 extends $6f3a0c2935d691fb$var$AbstractPointerSensor {
    constructor(props){
        super(props, $6f3a0c2935d691fb$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($6f3a0c2935d691fb$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($6f3a0c2935d691fb$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$6f3a0c2935d691fb$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $6f3a0c2935d691fb$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($6f3a0c2935d691fb$export$eefe60e26f04c318 || ($6f3a0c2935d691fb$export$eefe60e26f04c318 = {}));
var $6f3a0c2935d691fb$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($6f3a0c2935d691fb$export$f93aa492a37e1b0e || ($6f3a0c2935d691fb$export$f93aa492a37e1b0e = {}));
function $6f3a0c2935d691fb$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $6f3a0c2935d691fb$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $6f3a0c2935d691fb$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $6f3a0c2935d691fb$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $bc7d58aa683e9af1$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $8NFma.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $8NFma.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $8NFma.useMemo)(()=>{
        switch(activator){
            case $6f3a0c2935d691fb$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $6f3a0c2935d691fb$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $8NFma.useRef)(null);
    const autoScroll = (0, $8NFma.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $8NFma.useMemo)(()=>order === $6f3a0c2935d691fb$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $6f3a0c2935d691fb$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $6f3a0c2935d691fb$var$defaultScrollIntent = {
    x: {
        [$6f3a0c2935d691fb$var$Direction.Backward]: false,
        [$6f3a0c2935d691fb$var$Direction.Forward]: false
    },
    y: {
        [$6f3a0c2935d691fb$var$Direction.Backward]: false,
        [$6f3a0c2935d691fb$var$Direction.Forward]: false
    }
};
function $6f3a0c2935d691fb$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $bc7d58aa683e9af1$export$5cae361ad82dce8b)(delta);
    return (0, $bc7d58aa683e9af1$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $6f3a0c2935d691fb$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$6f3a0c2935d691fb$var$Direction.Backward]: previousIntent.x[$6f3a0c2935d691fb$var$Direction.Backward] || direction.x === -1,
                [$6f3a0c2935d691fb$var$Direction.Forward]: previousIntent.x[$6f3a0c2935d691fb$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$6f3a0c2935d691fb$var$Direction.Backward]: previousIntent.y[$6f3a0c2935d691fb$var$Direction.Backward] || direction.y === -1,
                [$6f3a0c2935d691fb$var$Direction.Forward]: previousIntent.y[$6f3a0c2935d691fb$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $6f3a0c2935d691fb$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $bc7d58aa683e9af1$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $6f3a0c2935d691fb$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $8NFma.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $6f3a0c2935d691fb$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($6f3a0c2935d691fb$export$571c10ffffe014ab || ($6f3a0c2935d691fb$export$571c10ffffe014ab = {}));
var $6f3a0c2935d691fb$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($6f3a0c2935d691fb$export$8e062c3160beefd5 || ($6f3a0c2935d691fb$export$8e062c3160beefd5 = {}));
const $6f3a0c2935d691fb$var$defaultValue = /*#__PURE__*/ new Map();
function $6f3a0c2935d691fb$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $8NFma.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $8NFma.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $bc7d58aa683e9af1$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $8NFma.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $8NFma.useRef)(null);
    const droppableRects = (0, $bc7d58aa683e9af1$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $6f3a0c2935d691fb$var$defaultValue;
        if (!previousValue || previousValue === $6f3a0c2935d691fb$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $6f3a0c2935d691fb$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $8NFma.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $6f3a0c2935d691fb$export$571c10ffffe014ab.Always:
                return false;
            case $6f3a0c2935d691fb$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $6f3a0c2935d691fb$var$useInitialValue(value, computeFn) {
    return (0, $bc7d58aa683e9af1$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $6f3a0c2935d691fb$var$useInitialRect(node, measure) {
    return $6f3a0c2935d691fb$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $6f3a0c2935d691fb$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $bc7d58aa683e9af1$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $8NFma.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $8NFma.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $6f3a0c2935d691fb$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $bc7d58aa683e9af1$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $8NFma.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $8NFma.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $6f3a0c2935d691fb$var$defaultMeasure(element) {
    return new $6f3a0c2935d691fb$var$Rect($6f3a0c2935d691fb$export$b6aa1f30c53d7454(element), element);
}
function $6f3a0c2935d691fb$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $6f3a0c2935d691fb$var$defaultMeasure;
    const [rect, setRect] = (0, $8NFma.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $6f3a0c2935d691fb$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $6f3a0c2935d691fb$var$useResizeObserver({
        callback: measureRect
    });
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $6f3a0c2935d691fb$var$useRectDelta(rect) {
    const initialRect = $6f3a0c2935d691fb$var$useInitialValue(rect);
    return $6f3a0c2935d691fb$var$getRectDelta(rect, initialRect);
}
const $6f3a0c2935d691fb$var$defaultValue$1 = [];
function $6f3a0c2935d691fb$var$useScrollableAncestors(node) {
    const previousNode = (0, $8NFma.useRef)(node);
    const ancestors = (0, $bc7d58aa683e9af1$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $6f3a0c2935d691fb$var$defaultValue$1;
        if (previousValue && previousValue !== $6f3a0c2935d691fb$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $6f3a0c2935d691fb$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $8NFma.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $6f3a0c2935d691fb$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $8NFma.useState)(null);
    const prevElements = (0, $8NFma.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $8NFma.useCallback)((event)=>{
        const scrollingElement = $6f3a0c2935d691fb$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $6f3a0c2935d691fb$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $8NFma.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $6f3a0c2935d691fb$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $6f3a0c2935d691fb$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $6f3a0c2935d691fb$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $8NFma.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $bc7d58aa683e9af1$export$e16d8520af44a096)(acc, coordinates), $6f3a0c2935d691fb$export$597cbd7bbd10deb4) : $6f3a0c2935d691fb$var$getScrollOffsets(elements);
        return $6f3a0c2935d691fb$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $6f3a0c2935d691fb$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $8NFma.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $6f3a0c2935d691fb$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $bc7d58aa683e9af1$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $6f3a0c2935d691fb$export$597cbd7bbd10deb4;
}
function $6f3a0c2935d691fb$var$useSensorSetup(sensors) {
    (0, $8NFma.useEffect)(()=>{
        if (!(0, $bc7d58aa683e9af1$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $6f3a0c2935d691fb$var$useSyntheticListeners(listeners, id) {
    return (0, $8NFma.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $6f3a0c2935d691fb$var$useWindowRect(element) {
    return (0, $8NFma.useMemo)(()=>element ? $6f3a0c2935d691fb$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $6f3a0c2935d691fb$var$defaultValue$2 = [];
function $6f3a0c2935d691fb$var$useRects(elements, measure) {
    if (measure === void 0) measure = $6f3a0c2935d691fb$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $6f3a0c2935d691fb$var$useWindowRect(firstElement ? (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $8NFma.useState)($6f3a0c2935d691fb$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $6f3a0c2935d691fb$var$defaultValue$2;
            return elements.map((element)=>$6f3a0c2935d691fb$var$isDocumentScrollingElement(element) ? windowRect : new $6f3a0c2935d691fb$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $6f3a0c2935d691fb$var$useResizeObserver({
        callback: measureRects
    });
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $6f3a0c2935d691fb$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $bc7d58aa683e9af1$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $6f3a0c2935d691fb$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $8NFma.useState)(null);
    const handleResize = (0, $8NFma.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $bc7d58aa683e9af1$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $6f3a0c2935d691fb$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $8NFma.useCallback)((element)=>{
        const node = $6f3a0c2935d691fb$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $bc7d58aa683e9af1$export$bc23c270f170c912)(handleNodeChange);
    return (0, $8NFma.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $6f3a0c2935d691fb$var$defaultSensors = [
    {
        sensor: $6f3a0c2935d691fb$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $6f3a0c2935d691fb$export$44d67f2a438aeba9,
        options: {}
    }
];
const $6f3a0c2935d691fb$var$defaultData = {
    current: {}
};
const $6f3a0c2935d691fb$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $6f3a0c2935d691fb$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $6f3a0c2935d691fb$var$getTransformAgnosticClientRect,
        strategy: $6f3a0c2935d691fb$export$571c10ffffe014ab.WhileDragging,
        frequency: $6f3a0c2935d691fb$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $6f3a0c2935d691fb$export$b6aa1f30c53d7454
    }
};
class $6f3a0c2935d691fb$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $6f3a0c2935d691fb$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $6f3a0c2935d691fb$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $6f3a0c2935d691fb$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $6f3a0c2935d691fb$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $6f3a0c2935d691fb$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $6f3a0c2935d691fb$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $6f3a0c2935d691fb$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $6f3a0c2935d691fb$var$noop
};
const $6f3a0c2935d691fb$var$InternalContext = /*#__PURE__*/ (0, $8NFma.createContext)($6f3a0c2935d691fb$var$defaultInternalContext);
const $6f3a0c2935d691fb$var$PublicContext = /*#__PURE__*/ (0, $8NFma.createContext)($6f3a0c2935d691fb$var$defaultPublicContext);
function $6f3a0c2935d691fb$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $6f3a0c2935d691fb$var$DroppableContainersMap()
        }
    };
}
function $6f3a0c2935d691fb$var$reducer(state, action) {
    switch(action.type){
        case $6f3a0c2935d691fb$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $6f3a0c2935d691fb$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $6f3a0c2935d691fb$var$Action.DragEnd:
        case $6f3a0c2935d691fb$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $6f3a0c2935d691fb$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $6f3a0c2935d691fb$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $6f3a0c2935d691fb$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $6f3a0c2935d691fb$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $6f3a0c2935d691fb$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $6f3a0c2935d691fb$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $6f3a0c2935d691fb$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $8NFma.useContext)($6f3a0c2935d691fb$var$InternalContext);
    const previousActivatorEvent = (0, $bc7d58aa683e9af1$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $bc7d58aa683e9af1$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $8NFma.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $bc7d58aa683e9af1$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $bc7d58aa683e9af1$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $6f3a0c2935d691fb$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $6f3a0c2935d691fb$var$useMeasuringConfiguration(config) {
    return (0, $8NFma.useMemo)(()=>({
            draggable: {
                ...$6f3a0c2935d691fb$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$6f3a0c2935d691fb$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$6f3a0c2935d691fb$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $6f3a0c2935d691fb$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $8NFma.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $6f3a0c2935d691fb$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $6f3a0c2935d691fb$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $6f3a0c2935d691fb$var$ActiveDraggableContext = /*#__PURE__*/ (0, $8NFma.createContext)({
    ...$6f3a0c2935d691fb$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $6f3a0c2935d691fb$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($6f3a0c2935d691fb$var$Status || ($6f3a0c2935d691fb$var$Status = {}));
const $6f3a0c2935d691fb$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $8NFma.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $6f3a0c2935d691fb$var$defaultSensors, collisionDetection: collisionDetection = $6f3a0c2935d691fb$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $8NFma.useReducer)($6f3a0c2935d691fb$var$reducer, undefined, $6f3a0c2935d691fb$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $6f3a0c2935d691fb$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $8NFma.useState)($6f3a0c2935d691fb$var$Status.Uninitialized);
    const isInitialized = status === $6f3a0c2935d691fb$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $8NFma.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $8NFma.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $6f3a0c2935d691fb$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $8NFma.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $8NFma.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $8NFma.useState)(null);
    const latestProps = (0, $bc7d58aa683e9af1$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $bc7d58aa683e9af1$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $8NFma.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $6f3a0c2935d691fb$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $6f3a0c2935d691fb$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $6f3a0c2935d691fb$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $8NFma.useMemo)(()=>activatorEvent ? (0, $bc7d58aa683e9af1$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $6f3a0c2935d691fb$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $6f3a0c2935d691fb$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $6f3a0c2935d691fb$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $6f3a0c2935d691fb$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $8NFma.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $6f3a0c2935d691fb$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $6f3a0c2935d691fb$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $6f3a0c2935d691fb$var$useWindowRect(draggingNode ? (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $6f3a0c2935d691fb$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $6f3a0c2935d691fb$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $6f3a0c2935d691fb$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $bc7d58aa683e9af1$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $6f3a0c2935d691fb$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $6f3a0c2935d691fb$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $6f3a0c2935d691fb$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $bc7d58aa683e9af1$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $6f3a0c2935d691fb$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $6f3a0c2935d691fb$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $8NFma.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $bc7d58aa683e9af1$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $6f3a0c2935d691fb$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $8NFma.useRef)(null);
    const instantiateSensor = (0, $8NFma.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $2pmb0.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($6f3a0c2935d691fb$var$Status.Initializing);
                    dispatch({
                        type: $6f3a0c2935d691fb$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $6f3a0c2935d691fb$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($6f3a0c2935d691fb$var$Action.DragEnd),
            onCancel: createHandler($6f3a0c2935d691fb$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $6f3a0c2935d691fb$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $6f3a0c2935d691fb$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $2pmb0.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($6f3a0c2935d691fb$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $6f3a0c2935d691fb$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $8NFma.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $6f3a0c2935d691fb$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $6f3a0c2935d691fb$var$useSensorSetup(sensors);
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $6f3a0c2935d691fb$var$Status.Initializing) setStatus($6f3a0c2935d691fb$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $8NFma.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $2pmb0.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $8NFma.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $2pmb0.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $6f3a0c2935d691fb$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $8NFma.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $8NFma.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $6f3a0c2935d691fb$var$NullContext = /*#__PURE__*/ (0, $8NFma.createContext)(null);
const $6f3a0c2935d691fb$var$defaultRole = 'button';
const $6f3a0c2935d691fb$var$ID_PREFIX = 'Draggable';
function $6f3a0c2935d691fb$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $bc7d58aa683e9af1$export$c485849f2e393253)($6f3a0c2935d691fb$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $8NFma.useContext)($6f3a0c2935d691fb$var$InternalContext);
    const { role: role = $6f3a0c2935d691fb$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $8NFma.useContext)(isDragging ? $6f3a0c2935d691fb$var$ActiveDraggableContext : $6f3a0c2935d691fb$var$NullContext);
    const [node, setNodeRef] = (0, $bc7d58aa683e9af1$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $bc7d58aa683e9af1$export$bc23c270f170c912)();
    const listeners = $6f3a0c2935d691fb$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $bc7d58aa683e9af1$export$86c4283a11f23f95)(data);
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $8NFma.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $6f3a0c2935d691fb$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $6f3a0c2935d691fb$export$4930f6bf413be70e() {
    return (0, $8NFma.useContext)($6f3a0c2935d691fb$var$PublicContext);
}
const $6f3a0c2935d691fb$var$ID_PREFIX$1 = 'Droppable';
const $6f3a0c2935d691fb$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $6f3a0c2935d691fb$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $bc7d58aa683e9af1$export$c485849f2e393253)($6f3a0c2935d691fb$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $8NFma.useContext)($6f3a0c2935d691fb$var$InternalContext);
    const previous = (0, $8NFma.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $8NFma.useRef)(false);
    const rect = (0, $8NFma.useRef)(null);
    const callbackId = (0, $8NFma.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$6f3a0c2935d691fb$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $bc7d58aa683e9af1$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $8NFma.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $6f3a0c2935d691fb$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $8NFma.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $bc7d58aa683e9af1$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $bc7d58aa683e9af1$export$86c4283a11f23f95)(data);
    (0, $8NFma.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $8NFma.useEffect)(()=>{
        dispatch({
            type: $6f3a0c2935d691fb$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $6f3a0c2935d691fb$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $6f3a0c2935d691fb$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $6f3a0c2935d691fb$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $8NFma.useState)(null);
    const [element, setElement] = (0, $8NFma.useState)(null);
    const previousChildren = (0, $bc7d58aa683e9af1$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, null, children, clonedChildren ? (0, $8NFma.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $6f3a0c2935d691fb$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $6f3a0c2935d691fb$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$InternalContext.Provider, {
        value: $6f3a0c2935d691fb$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$ActiveDraggableContext.Provider, {
        value: $6f3a0c2935d691fb$var$defaultTransform
    }, children));
}
const $6f3a0c2935d691fb$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $6f3a0c2935d691fb$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $bc7d58aa683e9af1$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $6f3a0c2935d691fb$var$PositionedOverlay = /*#__PURE__*/ (0, $8NFma.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $6f3a0c2935d691fb$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$6f3a0c2935d691fb$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $bc7d58aa683e9af1$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $6f3a0c2935d691fb$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $6f3a0c2935d691fb$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $6f3a0c2935d691fb$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $bc7d58aa683e9af1$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $bc7d58aa683e9af1$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $6f3a0c2935d691fb$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $6f3a0c2935d691fb$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $6f3a0c2935d691fb$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $6f3a0c2935d691fb$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $bc7d58aa683e9af1$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $6f3a0c2935d691fb$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $bc7d58aa683e9af1$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $6f3a0c2935d691fb$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $6f3a0c2935d691fb$var$createDefaultDropAnimation(config);
        $6f3a0c2935d691fb$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $6f3a0c2935d691fb$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$6f3a0c2935d691fb$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $6f3a0c2935d691fb$var$key = 0;
function $6f3a0c2935d691fb$var$useKey(id) {
    return (0, $8NFma.useMemo)(()=>{
        if (id == null) return;
        $6f3a0c2935d691fb$var$key++;
        return $6f3a0c2935d691fb$var$key;
    }, [
        id
    ]);
}
const $6f3a0c2935d691fb$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $6f3a0c2935d691fb$export$4930f6bf413be70e();
    const transform = (0, $8NFma.useContext)($6f3a0c2935d691fb$var$ActiveDraggableContext);
    const key = $6f3a0c2935d691fb$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $6f3a0c2935d691fb$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $6f3a0c2935d691fb$var$useInitialValue(activeNodeRect);
    const dropAnimation = $6f3a0c2935d691fb$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($6f3a0c2935d691fb$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $8NFma = parcelRequire("8NFma");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $5216a8e68f2fc577$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $5216a8e68f2fc577$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $5216a8e68f2fc577$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $5216a8e68f2fc577$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $5216a8e68f2fc577$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $5216a8e68f2fc577$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $5216a8e68f2fc577$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $5216a8e68f2fc577$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $5216a8e68f2fc577$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$5216a8e68f2fc577$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$5216a8e68f2fc577$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$5216a8e68f2fc577$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$5216a8e68f2fc577$var$defaultScale
    };
};
function $5216a8e68f2fc577$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $5216a8e68f2fc577$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $5216a8e68f2fc577$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $5216a8e68f2fc577$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $5216a8e68f2fc577$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $5216a8e68f2fc577$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$5216a8e68f2fc577$var$defaultScale$1
        };
    }
    const itemGap = $5216a8e68f2fc577$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$5216a8e68f2fc577$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$5216a8e68f2fc577$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$5216a8e68f2fc577$var$defaultScale$1
    };
};
function $5216a8e68f2fc577$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $5216a8e68f2fc577$var$ID_PREFIX = 'Sortable';
const $5216a8e68f2fc577$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext({
    activeIndex: -1,
    containerId: $5216a8e68f2fc577$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $5216a8e68f2fc577$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $5216a8e68f2fc577$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $5216a8e68f2fc577$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $6f3a0c2935d691fb$export$4930f6bf413be70e)();
    const containerId = (0, $bc7d58aa683e9af1$export$c485849f2e393253)($5216a8e68f2fc577$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $8NFma.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $8NFma.useRef)(items);
    const itemsHaveChanged = !$5216a8e68f2fc577$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $5216a8e68f2fc577$var$normalizeDisabled(disabledProp);
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $8NFma.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $8NFma.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $5216a8e68f2fc577$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($5216a8e68f2fc577$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $5216a8e68f2fc577$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $5216a8e68f2fc577$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $5216a8e68f2fc577$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $5216a8e68f2fc577$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $5216a8e68f2fc577$var$transitionProperty = 'transform';
const $5216a8e68f2fc577$var$disabledTransition = /*#__PURE__*/ (0, $bc7d58aa683e9af1$export$c4ffa16951855e28).Transition.toString({
    property: $5216a8e68f2fc577$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $5216a8e68f2fc577$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $5216a8e68f2fc577$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $8NFma.useState)(null);
    const previousIndex = (0, $8NFma.useRef)(index);
    (0, $bc7d58aa683e9af1$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $6f3a0c2935d691fb$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $5216a8e68f2fc577$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $5216a8e68f2fc577$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $5216a8e68f2fc577$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $5216a8e68f2fc577$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $8NFma.useContext)($5216a8e68f2fc577$var$Context);
    const disabled = $5216a8e68f2fc577$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $8NFma.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $8NFma.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $6f3a0c2935d691fb$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $6f3a0c2935d691fb$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$5216a8e68f2fc577$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $bc7d58aa683e9af1$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $5216a8e68f2fc577$var$isValidIndex(activeIndex) && $5216a8e68f2fc577$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $5216a8e68f2fc577$var$isValidIndex(activeIndex) && $5216a8e68f2fc577$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $8NFma.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $5216a8e68f2fc577$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $8NFma.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId && !previous.current.activeId) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $5216a8e68f2fc577$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $bc7d58aa683e9af1$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $bc7d58aa683e9af1$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $5216a8e68f2fc577$var$transitionProperty
        });
        return undefined;
    }
}
function $5216a8e68f2fc577$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $5216a8e68f2fc577$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $5216a8e68f2fc577$var$directions = [
    (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Down,
    (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Right,
    (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Up,
    (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Left
];
const $5216a8e68f2fc577$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($5216a8e68f2fc577$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $6f3a0c2935d691fb$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $6f3a0c2935d691fb$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $6f3a0c2935d691fb$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $6f3a0c2935d691fb$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $5216a8e68f2fc577$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $5216a8e68f2fc577$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $bc7d58aa683e9af1$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $5216a8e68f2fc577$var$isSameContainer(a, b) {
    if (!$5216a8e68f2fc577$export$6424ec8a0d450b09(a) || !$5216a8e68f2fc577$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $5216a8e68f2fc577$var$isAfter(a, b) {
    if (!$5216a8e68f2fc577$export$6424ec8a0d450b09(a) || !$5216a8e68f2fc577$export$6424ec8a0d450b09(b)) return false;
    if (!$5216a8e68f2fc577$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}




var $4tbyZ = parcelRequire("4tbyZ");

var $kKP1P = parcelRequire("kKP1P");

var $78jzq = parcelRequire("78jzq");
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");

var $4N26z = parcelRequire("4N26z");
const $fecaacaaae2aa15e$var$endpoint = "/api/1";
const $fecaacaaae2aa15e$var$candidate_img_style = {
    width: "20em",
    margin: "auto",
    padding: "1em"
};
const $fecaacaaae2aa15e$var$default_candidate_img_url = "/static/images/mit_beaver.png";
function $fecaacaaae2aa15e$var$Item({ name: name, img_url: img_url, open_application_callback: open_application_callback }) {
    const div_style = {
        display: "flex",
        background: "whitesmoke",
        outline: "gray solid",
        "flex-direction": "column",
        "text-align": "center",
        "margin-left": "auto",
        "margin-right": "auto",
        "margin-top": "1em",
        "margin-bottom": "1em"
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        style: div_style,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                src: img_url,
                style: $fecaacaaae2aa15e$var$candidate_img_style
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("b", {
                    children: name
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                onClick: ()=>open_application_callback(),
                children: "Open application"
            })
        ]
    });
}
function $fecaacaaae2aa15e$var$SortableItem(props) {
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $5216a8e68f2fc577$export$4ebcb6201122185a)({
        id: props.id
    });
    const style = {
        transform: (0, $bc7d58aa683e9af1$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    const div_style = {
        width: "20em",
        display: "flex",
        "flex-direction": "column",
        "text-align": "center",
        "margin-left": "auto",
        "margin-right": "auto",
        "margin-top": "1em",
        "margin-bottom": "1em",
        opacity: isDragging ? 0.2 : 1.0
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        style: div_style,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            ref: setNodeRef,
            ...attributes,
            ...listeners,
            style: style,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)($fecaacaaae2aa15e$var$Item, {
                name: props.name,
                img_url: props.img_url,
                open_application_callback: props.open_application_callback
            })
        })
    });
}
const $fecaacaaae2aa15e$var$ApplicationModal = ({ show: show, item: item, handleClose: handleClose })=>{
    const item_name = item === null ? "" : item.name;
    const candidate = item === null ? {} : item.raw_candidate;
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $4N26z.default), {
        className: "modal-lg",
        show: show,
        onHide: handleClose,
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4N26z.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4N26z.default).Title, {
                    children: item_name
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4N26z.default).Body, {
                children: item !== null && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "d-flex",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                                src: item.img_url,
                                style: $fecaacaaae2aa15e$var$candidate_img_style
                            })
                        }),
                        candidate.hall_specific_message !== null && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                                    children: "Message specific to your hall"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                    children: candidate.hall_specific_message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Reasons for applying"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: candidate.reasons
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Plans as a Hall Councilor"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: candidate.plans
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Experience"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: candidate.experience
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Involvement"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: candidate.involvement
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Summer plans"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: candidate.summer_plans
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4N26z.default).Footer, {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                    variant: "secondary",
                    onClick: handleClose,
                    children: "Close"
                })
            })
        ]
    });
};
/**
 * Component that holds two ordered lists. The first list contains a list of
 * options. The second list is initially empty. Users are meant to
 * drag elements from the first list to the second to convey their preferred
 * ordering of the available options.
 */ function $fecaacaaae2aa15e$var$DragAndDropForm({ candidates: candidates, min_candidates: min_candidates, rng_seed: rng_seed, election_id: election_id, pass_code: pass_code, initial_ranked_kerberoses: initial_ranked_kerberoses, on_vote_submit: on_vote_submit }) {
    // List of all candidates. Filled when instantiated with stable shuffle
    // of candidates
    const [all_items, setAllItems] = (0, $8NFma.useState)([]);
    // Candidates in left column
    const [itemsAIds, setItemsAIds] = (0, $8NFma.useState)([]);
    // Candidates in right column (ranked vote)
    const [itemsBIds, setItemsBIds] = (0, $8NFma.useState)([]);
    const [showApplicationModal, setShowApplicationModal] = (0, $8NFma.useState)(false);
    const [applicationModalItem, setApplicationModalItem] = (0, $8NFma.useState)(null);
    const [isVoteBeingSubmitted, setIsVoteBeingSubmitted] = (0, $8NFma.useState)(false);
    // get inventory
    (0, $8NFma.useEffect)(()=>{
        const setData = async ()=>{
            const processed_data = await Promise.all(candidates.map(async (candidate)=>{
                let img_url = $fecaacaaae2aa15e$var$default_candidate_img_url;
                const kerberos = candidate.kerberos;
                try {
                    const candidate_image_url = `${$fecaacaaae2aa15e$var$endpoint}/hall_councilor/candidate_image?election_id=${election_id}&kerberos=${kerberos}`;
                    // Try to fetch the image. If we get an error (e.g.,
                    // 404), we fall back to the default candidate image.
                    // Otherwise we use the candidate's image.
                    await (0, $81tj9.default).get(candidate_image_url);
                    img_url = candidate_image_url;
                } catch (e) {
                    console.error(e);
                }
                return {
                    id: candidate.kerberos,
                    name: `${candidate.first_name} ${candidate.last_name}`,
                    img_url: img_url,
                    raw_candidate: candidate,
                    kerberos: candidate.kerberos
                };
            }));
            // Stable-shuffle the data
            const chance = new (0, (/*@__PURE__*/$parcel$interopDefault($78jzq)))(rng_seed);
            const all_items = chance.shuffle(processed_data);
            setAllItems(all_items);
            if (initial_ranked_kerberoses === null) {
                // Left column contains every candidate
                setItemsAIds(all_items.map(({ id: id })=>id));
                setItemsBIds([]);
            } else {
                // Left column contains all non-ranked items
                const futureA = all_items.filter((item)=>!initial_ranked_kerberoses.includes(item.kerberos));
                // Right column has ranked candidates
                const futureB = [];
                for (const kerberos of initial_ranked_kerberoses){
                    const matches = all_items.filter((item)=>item.kerberos === kerberos);
                    if (matches.length > 0) {
                        const match = matches[0];
                        futureB.push(match);
                    } else console.error(`Could not find applicant with kerberos ${kerberos} in applicant list, but was in saved vote!`);
                }
                console.log(futureB);
                setItemsAIds(futureA.map((item)=>item.id));
                setItemsBIds(futureB.map((item)=>item.id));
            }
        };
        setData();
    }, []);
    const [activeId, setActiveId] = (0, $8NFma.useState)(null);
    const containerA_id = "CONTA";
    const containerB_id = "CONTB";
    const { setNodeRefA: setNodeRefA } = (0, $6f3a0c2935d691fb$export$d74e5d67dc2b3176)({
        id: containerA_id
    });
    const { setNodeRefB: setNodeRefB } = (0, $6f3a0c2935d691fb$export$d74e5d67dc2b3176)({
        id: containerB_id
    });
    const sensors = (0, $6f3a0c2935d691fb$export$19012f58216d597f)((0, $6f3a0c2935d691fb$export$cc72dd71f4ec69eb)((0, $6f3a0c2935d691fb$export$b26af955418d6638), {
        activationConstraint: {
            distance: 10
        }
    }), (0, $6f3a0c2935d691fb$export$cc72dd71f4ec69eb)((0, $6f3a0c2935d691fb$export$44d67f2a438aeba9), {
        coordinateGetter: (0, $5216a8e68f2fc577$export$a6f27ecf02eb3a67)
    }));
    function handleDragStart(event) {
        setActiveId(event.active.id);
    }
    function handleDragEnd(event) {
        const { active: active, over: over } = event;
        const container_id = over.data.current.sortable.containerId;
        if (active.id !== over.id) {
            // Item moved within a list. Update the corresponding list order.
            const setItemsIds = container_id === containerA_id ? setItemsAIds : setItemsBIds;
            setItemsIds((item_ids)=>{
                const oldIndex = item_ids.indexOf(active.id);
                const newIndex = item_ids.indexOf(over.id);
                return (0, $5216a8e68f2fc577$export$5d49d615ad5ea2b0)(item_ids, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragOver(event) {
        const { active: active, over: over } = event;
        const old_container_id = active.data.current.sortable.containerId;
        const new_container_id = over === null ? null : over.data.current.sortable.containerId;
        const changed_list = over === null || old_container_id !== new_container_id;
        if (changed_list) {
            // Item was moved from one list to the other. Update lists.
            const old_list = old_container_id === containerA_id ? itemsAIds : itemsBIds;
            const new_list = old_container_id === containerA_id ? itemsBIds : itemsAIds;
            const setOldList = old_container_id === containerA_id ? setItemsAIds : setItemsBIds;
            const setNewList = old_container_id === containerA_id ? setItemsBIds : setItemsAIds;
            const oldIndex = old_list.indexOf(active.id);
            const item = old_list[oldIndex];
            setOldList(old_list.filter((item_id)=>item_id !== activeId));
            setNewList([
                ...new_list,
                item
            ]);
        }
    }
    // Find active item
    const items = all_items.map((item)=>/*#__PURE__*/ (0, $1IdZj.jsx)($fecaacaaae2aa15e$var$Item, {
            name: item.name,
            img_url: item.img_url,
            open_application_callback: ()=>openApplicationModal(item)
        }));
    const all_ids = activeId ? all_items.map((item)=>item.id) : null;
    const active_item_index = all_ids ? all_ids.indexOf(activeId) : null;
    // But for some reason the correct line
    // (immediately below this comment) produces incorrect behavior
    // exactly when active_item_index is zero, for reasons I cannot
    // take the time to understand right now, so I'll do a hack instead,
    // which is semantically correct.
    //const active_item = active_item_index ? items[active_item_index] : null;
    const active_item = active_item_index ? items[active_item_index] : items.length > 0 ? items[0] : null;
    const column_style = {
        background: "white",
        "margin-left": "auto",
        "margin-right": "auto",
        overflow: "scroll",
        "min-height": "10vh",
        outline: "dashed grey",
        "margin-top": "1em"
    };
    const item_map = new Map();
    for (const item of all_items)item_map.set(item.id, item);
    async function handleVote() {
        // Check the minimum number of candidates have been selected
        const actual_min_candidates = Math.min(min_candidates, all_items.length);
        if (itemsBIds.length < actual_min_candidates) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).error(`You must choose at least ${actual_min_candidates} candidates!`);
            return;
        }
        // Simple way to turn athena email (xyz@mit.edu) into kerberos (xyz)
        const ranked_candidate_kerberoses = itemsBIds.map((item_id)=>item_map.get(item_id).kerberos);
        const vote = {
            election_id: election_id,
            pass_code: pass_code,
            ranked_candidate_kerberoses: ranked_candidate_kerberoses
        };
        // Start request
        setIsVoteBeingSubmitted(true);
        const response = (0, $81tj9.default).post(`${$fecaacaaae2aa15e$var$endpoint}/hall_councilor/vote`, {
            ...vote
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).promise(response, {
            loading: "Submitting vote...",
            success: "Successfully submitted vote!",
            error: "Failed to submit vote!"
        });
        try {
            const { data: data } = await response;
            const pass_code = data.pass_code;
            on_vote_submit(pass_code);
        } catch (e) {
            console.error(e);
        } finally{
            setIsVoteBeingSubmitted(false);
        }
    }
    function openApplicationModal(item) {
        setApplicationModalItem(item);
        setShowApplicationModal(true);
    }
    function format_ordinal(i) {
        const last_digit = i % 10;
        const suffix = last_digit === 0 ? "th" : last_digit === 1 ? "st" : last_digit === 2 ? "nd" : last_digit === 3 ? "rd" : "th";
        return `${i}${suffix}`;
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "col-md-3",
                    style: {
                        margin: "auto",
                        width: "6em"
                    },
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $kKP1P.default), {
                        onClick: ()=>handleVote(),
                        disabled: isVoteBeingSubmitted,
                        children: [
                            !isVoteBeingSubmitted && "Submit",
                            isVoteBeingSubmitted && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                className: "spinner-border",
                                role: "status",
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                                    className: "sr-only",
                                    children: "Loading..."
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                children: "Drag and drop candidates from the left list to the right list to rank them. Your first choice should be at the top of the list."
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "row",
                style: {
                    "padding-top": "1em"
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $6f3a0c2935d691fb$export$2d5c5ceac203fc1e), {
                    sensors: sensors,
                    collisionDetection: (0, $6f3a0c2935d691fb$export$953346c40b5eb62a),
                    onDragStart: handleDragStart,
                    onDragEnd: handleDragEnd,
                    onDragOver: handleDragOver,
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "col-md-3",
                            style: column_style,
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("h3", {
                                    children: [
                                        "Candidate List (",
                                        itemsAIds.length,
                                        "/",
                                        all_items.length,
                                        " not ranked)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5216a8e68f2fc577$export$86155fde54f06e6a), {
                                    items: itemsAIds,
                                    strategy: (0, $5216a8e68f2fc577$export$fe2be640df2ffb9e),
                                    id: containerA_id,
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        ref: setNodeRefA,
                                        children: itemsAIds.map((item_id)=>{
                                            const item = item_map.get(item_id);
                                            return /*#__PURE__*/ (0, $1IdZj.jsx)($fecaacaaae2aa15e$var$SortableItem, {
                                                id: item.id,
                                                name: item.name,
                                                img_url: item.img_url,
                                                application_url: item.application_url,
                                                open_application_callback: ()=>openApplicationModal(item)
                                            });
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "col-md-3",
                            style: column_style,
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("h3", {
                                    children: [
                                        "My ranking (",
                                        itemsBIds.length,
                                        "/",
                                        all_items.length,
                                        " ",
                                        "ranked)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5216a8e68f2fc577$export$86155fde54f06e6a), {
                                    items: itemsBIds,
                                    strategy: (0, $5216a8e68f2fc577$export$fe2be640df2ffb9e),
                                    id: containerB_id,
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                        ref: setNodeRefB,
                                        children: itemsBIds.map((item_id, i)=>{
                                            const item = item_map.get(item_id);
                                            return /*#__PURE__*/ (0, $1IdZj.jsx)($fecaacaaae2aa15e$var$SortableItem, {
                                                id: item.id,
                                                name: `${item.name} (${format_ordinal(i + 1)} choice)`,
                                                img_url: item.img_url,
                                                application_url: item.application_url,
                                                open_application_callback: ()=>openApplicationModal(item)
                                            });
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6f3a0c2935d691fb$export$aca73479aa40659d), {
                            children: active_item
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($fecaacaaae2aa15e$var$ApplicationModal, {
                show: showApplicationModal,
                item: applicationModalItem,
                handleClose: ()=>setShowApplicationModal(false)
            })
        ]
    });
}
function $fecaacaaae2aa15e$export$3f59c37be8329737({ candidates: candidates, min_candidates: min_candidates, rng_seed: rng_seed, election_id: election_id, has_voted: has_voted }) {
    const [stateful_has_voted, setStatefulHasVoted] = (0, $8NFma.useState)(has_voted);
    const [pass_code, setPasscode] = (0, $8NFma.useState)(null);
    const [initial_ranked_kerberoses, setInitialRankedKerberoses] = (0, $8NFma.useState)(null);
    const [inputPasscode, setInputPasscode] = (0, $8NFma.useState)("");
    const [acknowledgePasscode, setAcknowledgePasscode] = (0, $8NFma.useState)(null);
    const [isPasscodeBeingSubmitted, setIsPasscodeBeingSubmitted] = (0, $8NFma.useState)(false);
    async function onPasscodeSubmit() {
        // Validate passcode before user
        setIsPasscodeBeingSubmitted(true);
        const previous_vote_promise = (0, $81tj9.default).get(`${$fecaacaaae2aa15e$var$endpoint}/hall_councilor/vote`, {
            params: {
                election_id: election_id,
                pass_code: inputPasscode
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).promise(previous_vote_promise, {
            loading: "Validating passcode...",
            success: "Successfully validated passcode!",
            error: "Failed to validate passcode!"
        });
        try {
            const previous_vote = await previous_vote_promise;
            const ranked_kerberoses = previous_vote.data.ranked_candidate_kerberoses;
            setPasscode(inputPasscode);
            setInitialRankedKerberoses(ranked_kerberoses);
        } catch (e) {
            console.error(e);
        } finally{
            setIsPasscodeBeingSubmitted(false);
        }
    }
    function on_vote_submit(pass_code) {
        setAcknowledgePasscode(pass_code);
    }
    function on_acknowledge_pass_code() {
        setPasscode(null);
        setInitialRankedKerberoses(null);
        setInputPasscode("");
        setStatefulHasVoted(true);
        setAcknowledgePasscode(null);
    }
    const passcode_component = /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                    children: "You have previously voted. Please provide your passcode to edit your vote."
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                className: "form-control mb-3",
                value: inputPasscode,
                onChange: (e)=>{
                    setInputPasscode(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $kKP1P.default), {
                onClick: ()=>onPasscodeSubmit(),
                disabled: isPasscodeBeingSubmitted,
                children: [
                    !isPasscodeBeingSubmitted && "Submit",
                    isPasscodeBeingSubmitted && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "spinner-border",
                        role: "status",
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                            className: "sr-only",
                            children: "Loading..."
                        })
                    })
                ]
            })
        ]
    });
    const acknowledge_pass_code_component = /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)("h5", {
                children: "Notice"
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                children: "Your vote for hall councilor has been recorded. An email has been sent to confirm your submission. Should you wish to change your vote later, please make sure to enter your passcode when voting or you will be unable to change your vote."
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                children: [
                    "Please keep this code in your records until results have been announced. While it has been emailed to you,",
                    " ",
                    /*#__PURE__*/ (0, $1IdZj.jsx)("b", {
                        children: "it will not be shown again here."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)("b", {
                        children: "Your Passcode:"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("code", {
                        children: acknowledgePasscode
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                onClick: ()=>on_acknowledge_pass_code(),
                children: "Ok"
            })
        ]
    });
    const show_voting_ui = stateful_has_voted && pass_code !== null || !stateful_has_voted;
    const show_acknowledge_pass_code = acknowledgePasscode !== null;
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            show_voting_ui && !show_acknowledge_pass_code && /*#__PURE__*/ (0, $1IdZj.jsx)($fecaacaaae2aa15e$var$DragAndDropForm, {
                candidates: candidates,
                min_candidates: min_candidates,
                rng_seed: rng_seed,
                election_id: election_id,
                pass_code: pass_code,
                initial_ranked_kerberoses: initial_ranked_kerberoses,
                on_vote_submit: on_vote_submit
            }),
            show_acknowledge_pass_code && acknowledge_pass_code_component,
            !show_voting_ui && !show_acknowledge_pass_code && passcode_component,
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4tbyZ.Toaster), {})
            })
        ]
    });
}



var $52kL4 = parcelRequire("52kL4");
var $ePGyo = parcelRequire("ePGyo");

var $hX1NX = parcelRequire("hX1NX");

var $2szKO = parcelRequire("2szKO");

const $72b9fa7068397304$var$endpoint = '/api/1';
const $72b9fa7068397304$var$AdminInterface = ({ updateActiveElections: updateActiveElections })=>{
    const [hallNameMap, setHallNameMap] = (0, $8NFma.useState)([]);
    const [elections, setElections] = (0, $8NFma.useState)([]);
    const [electionOption, setElectionOption] = (0, $8NFma.useState)(null);
    const [isCreating, setIsCreating] = (0, $8NFma.useState)(false);
    const [description, setDescription] = (0, $8NFma.useState)('');
    const [applicationStartDate, setApplicationStartDate] = (0, $8NFma.useState)(new Date().toISOString().split('T')[0]);
    const [applicationEndDate, setApplicationEndDate] = (0, $8NFma.useState)(new Date().toISOString().split('T')[0]);
    const [meetHcDatetime, setMeetHcDatetime] = (0, $8NFma.useState)((0, $2szKO.tzAwareNow)());
    const [electionStartDate, setElectionStartDate] = (0, $8NFma.useState)(new Date().toISOString().split('T')[0]);
    const [electionEndDate, setElectionEndDate] = (0, $8NFma.useState)(new Date().toISOString().split('T')[0]);
    const [openHalls, setOpenHalls] = (0, $8NFma.useState)([]);
    const elections_endpoint = `${$72b9fa7068397304$var$endpoint}/hall_councilor/list_elections`;
    const modify_endpoint = `${$72b9fa7068397304$var$endpoint}/hall_councilor/election`;
    /* ============ Helper functions =============== */ const generateOptions = (elections)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).orderBy(elections, [
            'election_end_date'
        ], 'desc').map((x)=>{
            return {
                label: `${x.description} ${x.voting_open || x.applications_open ? '' : '(inactive)'}`,
                voting_open: x.voting_open,
                applications_open: x.applications_open,
                value: x.election_id
            };
        });
    };
    /* ============ Handlers =============== */ const handleCreateElection = ()=>{
        if (!isCreating) {
            setIsCreating(true);
            setDescription('');
            setApplicationStartDate(new Date().toISOString().split('T')[0]);
            setApplicationEndDate(new Date().toISOString().split('T')[0]);
            setMeetHcDatetime((0, $2szKO.tzAwareNow)());
            setElectionStartDate(new Date().toISOString().split('T')[0]);
            setElectionEndDate(new Date().toISOString().split('T')[0]);
            setOpenHalls(hallNameMap.map((h)=>h.officer_id));
        } else {
            setIsCreating(false);
            updateElectionOption(elections, electionOption);
        }
    };
    const updateElectionOption = (elections, option)=>{
        setElectionOption(option);
        const election = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).find(elections, [
            'election_id',
            option.value
        ]);
        setDescription(election.description);
        setElectionEndDate(election.election_date);
        setApplicationStartDate(election.application_start_date);
        setApplicationEndDate(election.application_end_date);
        setMeetHcDatetime(election.meet_hc_datetime);
        setElectionStartDate(election.election_start_date);
        setElectionEndDate(election.election_end_date);
        setOpenHalls(election.open_halls.map((h)=>h.officer_id));
    };
    const handleCreateSave = async ()=>{
        const update_promise = (0, $81tj9.default).post(modify_endpoint, {
            election_id: isCreating ? null : electionOption.value,
            election_date: electionEndDate,
            description: description,
            application_start_date: applicationStartDate,
            application_end_date: applicationEndDate,
            meet_hc_datetime: meetHcDatetime,
            election_start_date: electionStartDate,
            election_end_date: electionEndDate,
            open_halls: openHalls
        });
        if (isCreating) (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).promise(update_promise, {
            loading: 'Creating election...',
            success: 'Created election!',
            error: 'Failed to create election!'
        });
        else (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).promise(update_promise, {
            loading: 'Updating election...',
            success: 'Updated election!',
            error: 'Failed to update election!'
        });
        try {
            const { data: data } = await update_promise;
            setIsCreating(false);
            const newElections = [
                ...(0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).filter(elections, (e)=>e.election_id !== data.election_id),
                data
            ];
            const newOption = generateOptions([
                data
            ])[0];
            setElections(newElections);
            updateElectionOption(newElections, newOption);
            updateActiveElections();
        } catch (e) {
            console.error(e);
        }
    };
    const handleDelete = async ()=>{
        const data_promise = (0, $81tj9.default).delete(modify_endpoint, {
            params: {
                election_id: electionOption.value
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).promise(data_promise, {
            loading: 'Deleting election...',
            success: 'Deleted election!',
            error: 'Failed to delete election!'
        });
        try {
            await data_promise;
            const newElections = [
                ...(0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).filter(elections, (e)=>e.election_id !== electionOption.value)
            ];
            const newOption = generateOptions([
                newElections.at(-1)
            ])[0];
            setElections(newElections);
            updateElectionOption(newElections, newOption);
            updateActiveElections();
        } catch (e) {
            console.error(e);
        }
    };
    const toggleOpenHall = (officer_id)=>{
        if (openHalls.includes(officer_id)) setOpenHalls(openHalls.filter((h)=>h != officer_id));
        else setOpenHalls([
            officer_id,
            ...openHalls
        ]);
    };
    /* ============ Effects =============== */ // get the election list
    (0, $8NFma.useEffect)(()=>{
        const setData = async ()=>{
            const elections_promise = (0, $81tj9.default).get(elections_endpoint, {
                params: {
                    active_only: false
                }
            });
            try {
                const { data: election_data } = await elections_promise;
                setHallNameMap(election_data.hall_names);
                setElections(election_data.elections);
                updateElectionOption(election_data.elections, generateOptions(election_data.elections)[0]);
            } catch (e) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).error('Unable to get list of elections!');
                console.error(e);
            }
        };
        setData();
    }, []);
    /* ============ Rendering =============== */ const election = (0, $8NFma.useMemo)(()=>electionOption === null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).find(elections, [
            'election_id',
            electionOption.value
        ]), [
        elections,
        electionOption
    ]);
    const needsSave = election !== null && (description != election.description || electionStartDate != election.election_start_date || electionEndDate != election.election_end_date || meetHcDatetime != election.meet_hc_datetime || applicationStartDate != election.application_start_date || applicationEndDate != election.application_end_date || (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).xor(openHalls, election.open_halls.map((h)=>h.officer_id)).length != 0);
    const selectOptions = generateOptions(elections);
    if (isCreating) selectOptions.unshift({
        label: 'New election',
        value: null
    });
    const style_preicons = (data)=>({
            alignItems: 'center',
            display: 'flex',
            ':after': {
                // You need nested quotes because the outer quotes gets "stripped"
                // going into the CSS
                content: `"${data.voting_open ? '\\f772' : ''}   ${data.applications_open ? '\\f4ff' : ''}"`,
                fontFamily: '"Font Awesome 5 Free"',
                fontWeight: 900,
                display: 'block',
                whiteSpace: 'pre',
                marginLeft: 8
            }
        });
    const selectStyles = {
        option: (styles, { data: data })=>{
            return {
                ...styles,
                color: data.voting_open || data.applications_open ? 'black' : '#aaa',
                ...style_preicons(data)
            };
        },
        singleValue: (styles, { data: data })=>({
                ...styles,
                ...style_preicons(data)
            })
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8B2uX.default), {
        className: "mb-3",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $8B2uX.default).Body, {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8B2uX.default).Title, {
                    children: "Admin interface"
                }),
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default), {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            controlId: "electionSelect",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    children: "Select election"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $gNm81.default), {
                                    className: "mb-3 gx-5",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $lHJBw.default), {
                                            className: "col-md-6",
                                            options: selectOptions,
                                            styles: selectStyles,
                                            value: isCreating ? selectOptions[0] : electionOption,
                                            isDisabled: isCreating,
                                            onChange: (option)=>updateElectionOption(elections, option)
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                                            className: "col-md-3 ms-4 me-auto",
                                            style: {
                                                width: '12em'
                                            },
                                            onClick: handleCreateElection,
                                            children: isCreating ? 'Cancel' : 'Create new election'
                                        })
                                    ]
                                })
                            ]
                        }),
                        electionOption !== null && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("hr", {}),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                                    className: "mb-2",
                                    controlId: "description",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                            children: "Election name"
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                            type: "text",
                                            placeholder: "Enter election name",
                                            value: description,
                                            onChange: (e)=>{
                                                setDescription(e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                    className: "mb-2 d-flex",
                                    style: {
                                        gap: '10px'
                                    },
                                    children: [
                                        election.applications_open && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eWs7Q.default), {
                                            bg: "primary",
                                            children: "Applications open"
                                        }),
                                        election.voting_open && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eWs7Q.default), {
                                            bg: "primary",
                                            children: "Voting open"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $gNm81.default), {
                                    className: "mb-3 gy-4",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                                            className: "col-md-2",
                                            style: {
                                                minWidth: '13em'
                                            },
                                            controlId: "date",
                                            children: [
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                                    children: "Application start date"
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                                    class: "form-control",
                                                    type: "date",
                                                    value: applicationStartDate,
                                                    onChange: (e)=>{
                                                        setApplicationStartDate(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Text, {
                                                    className: "text-muted",
                                                    children: "Specify the application start date. Applications will open at 12:00:00 am on this day."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                                            className: "col-md-2",
                                            style: {
                                                minWidth: '13em'
                                            },
                                            controlId: "date",
                                            children: [
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                                    children: "Application end date"
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                                    class: "form-control",
                                                    type: "date",
                                                    value: applicationEndDate,
                                                    onChange: (e)=>{
                                                        setApplicationEndDate(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Text, {
                                                    className: "text-muted",
                                                    children: "Specify the application end date. Applications will close at 11:59:59 pm on this day."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                                            className: "col-md-2 mx-auto",
                                            style: {
                                                minWidth: '20em'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                                    children: "Meet the HC event"
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2szKO.TzAwareDatetimePicker), {
                                                    hideDistance: true,
                                                    innerStyle: {
                                                        padding: '6px 12px 6px 12px'
                                                    },
                                                    id: "meet_hc_dt",
                                                    val: meetHcDatetime,
                                                    setVal: setMeetHcDatetime,
                                                    restrictTo15: true
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Text, {
                                                    className: "text-muted",
                                                    children: 'Specify the date and time of the "Meet the HC" event that candidates are expected to attend.'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                                            className: "col-md-2",
                                            style: {
                                                minWidth: '13em'
                                            },
                                            controlId: "date",
                                            children: [
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                                    children: "Election start date"
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                                    class: "form-control",
                                                    type: "date",
                                                    value: electionStartDate,
                                                    onChange: (e)=>{
                                                        setElectionStartDate(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Text, {
                                                    className: "text-muted",
                                                    children: "Specify the voting start date. The election will open at 12:00:00 am on this day."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                                            className: "col-md-2",
                                            style: {
                                                minWidth: '13em'
                                            },
                                            controlId: "date",
                                            children: [
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                                    children: "Election end date"
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                                    class: "form-control",
                                                    type: "date",
                                                    value: electionEndDate,
                                                    onChange: (e)=>{
                                                        setElectionEndDate(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Text, {
                                                    className: "text-muted",
                                                    children: "Specify the voting end date. The election will close at 11:59:59 pm on this day."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("h4", {
                                    className: "mt-3",
                                    children: "Open halls"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $gNm81.default), {
                                    className: "px-3 mb-3",
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).sortBy(hallNameMap, 'officer_name').map((hall)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                                            id: `open-hall-admin--${hall.officer_id}`,
                                            style: {
                                                maxWidth: '15em'
                                            },
                                            inline: true,
                                            label: hall.officer_name,
                                            type: "checkbox",
                                            checked: openHalls.includes(hall.officer_id),
                                            onChange: ()=>toggleOpenHall(hall.officer_id)
                                        }))
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                                            variant: "primary",
                                            onClick: handleCreateSave,
                                            disabled: !isCreating && !needsSave,
                                            children: isCreating ? 'Create' : 'Save'
                                        }),
                                        isCreating || /*#__PURE__*/ (0, $1IdZj.jsx)((0, $hX1NX.default), {
                                            className: "ms-auto me-2",
                                            onDelete: handleDelete,
                                            delayTimeMs: 1000
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $72b9fa7068397304$var$candidate_img_style = {
    width: '20em',
    margin: 'auto',
    padding: '1em'
};
const $72b9fa7068397304$var$PlanRadioButtons = ({ label: label, id: id, value: value, onChange: onChange })=>{
    const targetOnChange = (e)=>onChange(e.currentTarget.value);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                className: "col-sm-8",
                children: label
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                inline: true,
                type: "radio",
                name: id,
                id: `${id}-yes`,
                value: "yes",
                label: "yes",
                checked: value === 'yes',
                onChange: targetOnChange
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                inline: true,
                type: "radio",
                name: id,
                id: `${id}-no`,
                value: "no",
                label: "no",
                checked: value === 'no',
                onChange: targetOnChange
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                inline: true,
                type: "radio",
                name: id,
                id: `${id}-unsure`,
                value: "unsure",
                label: "unsure",
                checked: value === 'unsure',
                onChange: targetOnChange
            })
        ]
    });
};
const $72b9fa7068397304$var$ApplicationModal = ({ show: show, onClose: onClose, onSubmit: onSubmit, application_election: application_election })=>{
    const [availHouseMeeting, setAvailHouseMeeting] = (0, $8NFma.useState)('yes');
    const [availBrunch, setAvailBrunch] = (0, $8NFma.useState)('yes');
    const [availRetreat, setAvailRetreat] = (0, $8NFma.useState)('yes');
    const [availSummer, setAvailSummer] = (0, $8NFma.useState)('yes');
    const [availOrientation, setAvailOrientation] = (0, $8NFma.useState)('yes');
    const [summerPlans, setSummerPlans] = (0, $8NFma.useState)('');
    const [applicationReason, setApplicationReason] = (0, $8NFma.useState)('');
    const [eventPlan, setEventPlan] = (0, $8NFma.useState)('');
    const [previousExperience, setPreviousExperience] = (0, $8NFma.useState)('');
    const [currentInvolvement, setCurrentInvolvement] = (0, $8NFma.useState)('');
    const [msgs, setMsgs] = (0, $8NFma.useState)({});
    const [acceptResponsibilities, setAcceptResponsibilities] = (0, $8NFma.useState)(false);
    const [acceptCampaignPolicy, setAcceptCampaignPolicy] = (0, $8NFma.useState)(false);
    const [confirmingWithdraw, setConfirmingWithdraw] = (0, $8NFma.useState)(false);
    const [withdraw, setWithdraw] = (0, $8NFma.useState)(false);
    // https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
    // Reset the withdraw state whenever the modal is re-shown
    const [lastShow, setLastShow] = (0, $8NFma.useState)(show);
    if (show !== lastShow) {
        setLastShow(show);
        setConfirmingWithdraw(false);
        setWithdraw(false);
    }
    (0, $8NFma.useEffect)(()=>{
        const fetchApplication = async ()=>{
            try {
                const { data: data } = await (0, $81tj9.default).get(`${$72b9fa7068397304$var$endpoint}/hall_councilor/application`, {
                    params: {
                        election_id: application_election.election_id
                    }
                });
                setAvailHouseMeeting(data.house_meeting);
                setAvailBrunch(data.brunch);
                setAvailRetreat(data.retreat);
                setAvailSummer(data.most_of_summer);
                setAvailOrientation(data.orientation);
                setSummerPlans(data.summer_plans);
                setApplicationReason(data.reasons);
                setEventPlan(data.plans);
                setPreviousExperience(data.experience);
                setCurrentInvolvement(data.involvement);
                setMsgs(data.apply_to_halls);
                setAcceptResponsibilities(true);
                setAcceptCampaignPolicy(true);
                setWithdraw(data.withdrawn);
            } catch (e) {
                console.error(e);
            }
        };
        fetchApplication();
    }, []);
    const ID_TO_NAME = {};
    application_election.open_halls.forEach((open_hall)=>{
        ID_TO_NAME[open_hall.officer_id] = open_hall.officer_name.replace('Hall Councilor', '');
    });
    const handleApplyToHalls = (officer_id)=>{
        if (officer_id in msgs) {
            let newMsgs = {
                ...msgs
            };
            delete newMsgs[officer_id];
            setMsgs(newMsgs);
        } else {
            let newMsgs = {
                ...msgs
            };
            newMsgs[officer_id] = '';
            setMsgs(newMsgs);
        }
    };
    function hall_compare(hall_a, hall_b) {
        // Sort halls by officer name
        return hall_a.officer_name > hall_b.officer_name;
    }
    const open_halls_grid_style = {
        display: 'flex',
        'flex-wrap': 'wrap',
        'justify-content': 'space-between'
    };
    const open_halls_check_style = {
        flex: '0 0 25%',
        'margin-bottom': '0.5 rem'
    };
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $4N26z.default), {
        show: show,
        onHide: onClose,
        size: "lg",
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4N26z.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $4N26z.default).Title, {
                    children: [
                        `${application_election.description}`,
                        " application"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4N26z.default).Body, {
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default), {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Label, {
                                    children: [
                                        'You currently have this "My Account" photo: (',
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                            href: "/secure/profile.php",
                                            children: "change photo on your profile page"
                                        }),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: "d-flex",
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                                        src: `${$72b9fa7068397304$var$endpoint}/residents/self_image`,
                                        style: $72b9fa7068397304$var$candidate_img_style
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    children: "What are your current summer plans?"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                    as: "textarea",
                                    rows: 3,
                                    value: summerPlans,
                                    onChange: (e)=>setSummerPlans(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    children: "What are your reasons for applying?"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                    as: "textarea",
                                    rows: 3,
                                    value: applicationReason,
                                    onChange: (e)=>setApplicationReason(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    children: "What are your plans for organizing events and encouraging resident participation?"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                    as: "textarea",
                                    rows: 3,
                                    value: eventPlan,
                                    onChange: (e)=>setEventPlan(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    children: "What relevant previous experience do you have for this role?"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                    as: "textarea",
                                    rows: 3,
                                    value: previousExperience,
                                    onChange: (e)=>setPreviousExperience(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    children: "What is your current involvement with SP? Do you attend events? Have you interacted with officers? Are you a helper?"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                    as: "textarea",
                                    rows: 3,
                                    value: currentInvolvement,
                                    onChange: (e)=>setCurrentInvolvement(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            className: "mb-5",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    style: {
                                        fontWeight: 'bold'
                                    },
                                    children: "Will you be attending the following events?"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$PlanRadioButtons, {
                                    label: "the late April / early May transition house meeting",
                                    id: "transition_hm",
                                    value: availHouseMeeting,
                                    onChange: setAvailHouseMeeting
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$PlanRadioButtons, {
                                    label: "the late April / early May transition brunch",
                                    id: "transition_brunch",
                                    value: availBrunch,
                                    onChange: setAvailBrunch
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$PlanRadioButtons, {
                                    label: "the late May officer retreat",
                                    id: "officer_retreat",
                                    value: availRetreat,
                                    onChange: setAvailRetreat
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$PlanRadioButtons, {
                                    label: "Will you be here for most of the summer?",
                                    id: "during_summer",
                                    value: availSummer,
                                    onChange: setAvailSummer
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$PlanRadioButtons, {
                                    label: "Will you be here during orientation (late August to mid September)?",
                                    id: "during_orientation",
                                    value: availOrientation,
                                    onChange: setAvailOrientation
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Label, {
                                    style: {
                                        fontWeight: 'bold'
                                    },
                                    children: "Open halls"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    style: open_halls_grid_style,
                                    children: application_election.open_halls.sort(hall_compare).map((open_hall, idx)=>/*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                                            id: `open-hall-checkbox-${idx}`,
                                            inline: true,
                                            label: open_hall.officer_name,
                                            type: "checkbox",
                                            checked: open_hall.officer_id in msgs,
                                            onChange: ()=>handleApplyToHalls(open_hall.officer_id),
                                            style: open_halls_check_style
                                        }))
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                                Object.keys(msgs).map((officer_id)=>/*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Label, {
                                                children: [
                                                    "Message specific to ",
                                                    ID_TO_NAME[officer_id]
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Control, {
                                                as: "textarea",
                                                rows: 3,
                                                value: msgs[officer_id],
                                                onChange: (e)=>{
                                                    let newMsgs = {
                                                        ...msgs
                                                    };
                                                    newMsgs[officer_id] = e.target.value;
                                                    setMsgs(newMsgs);
                                                }
                                            })
                                        ]
                                    }))
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                                    children: "Expectations"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                    children: "Typically, hall councilors organize activities (independently or collaboratively) every four weeks. Hall councilors are expected to organize a range of activities to encourage resident participation, and are encouraged to collaborate with other hall councilors and other officers to broaden the scope of events that can be held."
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                    children: "It is Sidney Pacific policy that if an officer fails to fulfill his or her responsibilities, he or she will lose Sidney Pacific housing privileges."
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                                    label: "I understand and agree to the above",
                                    type: "checkbox",
                                    id: "responsibilitiesAccept",
                                    checked: acceptResponsibilities,
                                    onChange: ()=>{
                                        setAcceptResponsibilities(!acceptResponsibilities);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                                    children: "Campaigning policy"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                    children: "Campaigning for Hall Councilor positions is governed by the bylaws (Bylaw Amendment Jan 22 2019):"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("ol", {
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                            children: "Candidates may send campaign-related emails to halls for which they are running via the appropriate mailing list."
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                            children: "Candidates are not allowed to spend their own, individual money on any products or services related to a campaign or distribute any products or services as promotional materials to residents of halls for which they are running."
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                            children: "However, candidates are allowed to use up to $30 - $40 (depending on the number of HC applicants) of SP funding set by SPEC (via the established spending and reimbursement process) to host events for the residents of hallways in order to meet residents and promote their candidacy. Note that this is not required of candidates."
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                            children: "Candidates may promote their candidacy by talking to individual residents."
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                            children: "Candidates cannot receive public endorsements from members of the SP Hall Council, Executive Council, or Trustees."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                                    children: [
                                        "Contact",
                                        ' ',
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
                                            href: "mailto:sp-trustees@mit.edu",
                                            children: "sp-trustees@mit.edu"
                                        }),
                                        " if you have any questions."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                                    label: "I understand and agree to the above",
                                    id: "campaignPolicyAccept",
                                    type: "checkbox",
                                    checked: acceptCampaignPolicy,
                                    onChange: ()=>{
                                        setAcceptCampaignPolicy(!acceptCampaignPolicy);
                                    }
                                }),
                                confirmingWithdraw && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("hr", {}),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default).Check, {
                                            label: "I understand and agree to WITHDRAW my application. Note this action is IRREVERSIBLE.",
                                            type: "checkbox",
                                            id: "withdrawConfirm",
                                            checked: withdraw,
                                            onChange: ()=>{
                                                setWithdraw(!withdraw);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $4N26z.default).Footer, {
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                        variant: "secondary",
                        onClick: onClose,
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                        variant: "primary",
                        onClick: ()=>{
                            const payload = {
                                house_meeting: availHouseMeeting,
                                brunch: availBrunch,
                                retreat: availRetreat,
                                most_of_summer: availSummer,
                                orientation: availOrientation,
                                summer_plans: summerPlans,
                                reasons: applicationReason,
                                plans: eventPlan,
                                experience: previousExperience,
                                involvement: currentInvolvement,
                                apply_to_halls: msgs,
                                election_id: application_election.election_id
                            };
                            onSubmit(payload);
                        },
                        disabled: !(acceptResponsibilities && acceptCampaignPolicy),
                        children: "Submit"
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                        variant: "danger",
                        onClick: ()=>{
                            if (!confirmingWithdraw) setConfirmingWithdraw(true);
                            else onSubmit({
                                withdrawn: true,
                                election_id: application_election.election_id
                            });
                        },
                        disabled: confirmingWithdraw && !withdraw,
                        children: confirmingWithdraw ? 'Confirm withdraw' : 'Withdraw'
                    })
                ]
            })
        ]
    });
};
const $72b9fa7068397304$var$ApplicationInterface = ({ application_elections: application_elections, electionStatus: electionStatus, updateActiveElections: updateActiveElections })=>{
    const [showModal, setShowModal] = (0, $8NFma.useState)(Array(application_elections.length).fill(false));
    const onClick = (modal_idx)=>{
        let showModalNew = [
            ...showModal
        ];
        showModalNew[modal_idx] = !showModalNew[modal_idx];
        setShowModal(showModalNew);
    };
    let buttonStyles = {
        ...electionStatus
    };
    Object.keys(buttonStyles).forEach((s)=>{
        if (buttonStyles[s].includes('Apply')) buttonStyles[s] = 'primary';
        else if (buttonStyles[s].includes('Edit')) buttonStyles[s] = 'success';
        else buttonStyles[s] = 'danger';
    });
    const onClickSubmit = async (modal_idx, payload)=>{
        if ('withdrawn' in payload) {
            // call the withdraw endpoint with no value
            await (0, $81tj9.default).post(`${$72b9fa7068397304$var$endpoint}/hall_councilor/withdraw_application`, {
                election_id: payload.election_id
            });
            updateActiveElections();
        } else {
            // call the update endpoint with the payload
            await (0, $81tj9.default).post(`${$72b9fa7068397304$var$endpoint}/hall_councilor/application`, payload);
            updateActiveElections();
        }
        onClick(modal_idx);
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8B2uX.default), {
        className: "mb-3",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $8B2uX.default).Body, {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8B2uX.default).Title, {
                    children: "Apply to be a Hall Councilor"
                }),
                application_elections.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $h9Lvm.default), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $h9Lvm.default).Group, {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                                children: "Introduction"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                children: "The Hall Councilors serve as the first contact point between residents and the greater Sidney-Pacific community. They are energetic, outgoing, and self-motivated individuals who are committed to facilitating the residential program. Hall Councilors are blessed with the freedom to hold monthly events, of their own design, to bring together members of the Sidney-Pacific community. Simple examples range from holding study groups or game nights in the common area with snacks, to playing sports and participating on trips together. Unlike other officers, Hall Councilors are generally not constrained by event type. As such, the Hall Councilors play an important role in looking after the residents, making sure residents feel welcome during orientation and part of the Sidney Pacific community during the year."
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                children: 'On a house government level, the responsibilities of Hall Councilors include "representing the interests of their respective Halls to the House Council." As the only members of the House Council directly elected by the residents, Hall Councilors have an important role in house policymaking; this is reflected in the fact that their votes are weighted twice as much as those of other officers. Hall Councilors are expected to attend and participate in monthly House Council meetings and Hall Councilor meetings.'
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                    children: 'In addition, Hall Councilors are responsible for "organizing activities and encouraging interactions among the residents at the Hall level" (SP Constitution).'
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                                children: [
                                    "To summarize, the responsibilities of Hall Councilors include:",
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                                children: "Organizing activities"
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                                children: "Representing the interests of their respective Halls to the House Council, and"
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                                children: "Encouraging interactions among the residents at the Hall level."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                children: "Hall Councilors have a termly budget to organize hall activities or procure hall resources. They have a lot of flexibility to develop programs which foster a greater sense of community within the halls."
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                children: "Hall Councilors are expected to attend and participate in monthly House Council meetings, and Hall Councilor meetings, house events, and other activities."
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                children: "Please note that a substantial amount of social events, relationship-building with other officers and residents, and learning about the Sidney Pacific government structure occurs in the summer. Although residents are not required to be present at Sidney Pacific during the summer to run for Hall Councilor, it is strongly recommended that Hall Councilor applicants be living in Sidney Pacific during the summer."
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                                children: "General Procedures"
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "Any current resident of Sidney Pacific may apply for a hall councilor position in any open hall."
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "All residents will vote for the candidates for their current halls."
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "If you are also applying for other officer positions, you will receive interviews for those positions separately."
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "Hall Councilors will be expected to attend the May House Council meeting in late April / early May, the officers' transition brunch in late April / early May, and the officers' retreat in mid May."
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                                        children: "Hall Councilors are not required to live in their respective Halls."
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                    children: "Applications"
                }),
                application_elections.length == 0 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8B2uX.default).Subtitle, {
                    className: "mb-2 text-muted",
                    children: "There are no applications open right now"
                }),
                application_elections.map((application_election, idx)=>/*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)("h4", {
                                children: application_election.description
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                        children: [
                                            "Applications are open until",
                                            ' ',
                                            /*#__PURE__*/ (0, $1IdZj.jsxs)("b", {
                                                children: [
                                                    (0, $52kL4.default)((0, $ePGyo.default)(application_election.application_end_date), 'MMMM dd'),
                                                    ' ',
                                                    "11:59pm"
                                                ]
                                            }),
                                            ". However, we strongly encourage you to submit your applications as early as possible so that residents have a chance to read your statement."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                        children: [
                                            "Meet the Hall Councilors events will be held on",
                                            ' ',
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("b", {
                                                children: (0, $52kL4.default)((0, $ePGyo.default)(application_election.meet_hc_datetime), "MMMM dd 'at' HH:mm")
                                            }),
                                            ". This is an opportunity for residents and potential candidates to meet the current Hall Councilors and learn more about the role."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("li", {
                                        children: [
                                            "Voting begins on",
                                            ' ',
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("b", {
                                                children: (0, $52kL4.default)((0, $ePGyo.default)(application_election.election_start_date), 'MMMM dd')
                                            }),
                                            ". Voting ends on",
                                            ' ',
                                            /*#__PURE__*/ (0, $1IdZj.jsxs)("b", {
                                                children: [
                                                    (0, $52kL4.default)((0, $ePGyo.default)(application_election.election_end_date), 'MMMM dd'),
                                                    ", 00:00:00."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            Object.keys(electionStatus).length >= 0 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $kKP1P.default), {
                                variant: buttonStyles[application_election.election_id],
                                disabled: buttonStyles[application_election.election_id] === 'danger',
                                onClick: ()=>onClick(idx),
                                children: electionStatus[application_election.election_id]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$ApplicationModal, {
                                show: showModal[idx],
                                onClose: ()=>onClick(idx),
                                onSubmit: (payload)=>onClickSubmit(idx, payload),
                                application_election: application_election
                            })
                        ]
                    }, `application-election-modal-${idx}`))
            ]
        })
    });
};
const $72b9fa7068397304$var$VotingInterface = ({ voting_elections: voting_elections, rng_seed: rng_seed, voting_for_hall: voting_for_hall })=>{
    const vote_components = [];
    for (const election of voting_elections){
        if (!election.election.voting_open) continue;
        const min_candidates = 5 // TODO: parametrize
        ;
        const election_id = election.election.election_id;
        const candidates = election.candidates;
        vote_components.push(/*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("h4", {
                    children: election.election.description
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $fecaacaaae2aa15e$export$3f59c37be8329737), {
                    candidates: candidates,
                    min_candidates: min_candidates,
                    rng_seed: rng_seed,
                    election_id: election_id,
                    has_voted: election.has_voted
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8B2uX.default), {
        className: "mb-3",
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $8B2uX.default).Body, {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $8B2uX.default).Title, {
                    children: [
                        "Vote for ",
                        voting_for_hall.officer_name
                    ]
                }),
                voting_elections.length == 0 && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $8B2uX.default).Subtitle, {
                    className: "mb-2 text-muted",
                    children: "There are no hall councilor votes open right now"
                }),
                voting_elections.length > 0 && /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Introduction"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: "Residents have the opportunity to contribute to the Sidney Pacific community by electing Hall Councilors. Please carefully consider the responsibilities of the hall councilor as you read the candidate statements and place your vote."
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: 'The Hall Councilors serve as the first contact point between the residents and the greater Sidney Pacific community. They are energetic, outgoing, and self-motivated individuals who are committed to facilitating the residential program. The responsibilities of Hall Councilors include "representing the interests of their respective Halls to the House Council" (SP Constitution). As the only members of the House Council directly elected by the residents, the Hall Councilors have an important role in house policymaking; this is reflected in the fact that their votes are weighted twice as much as those of other officers. Hall Councilors are expected to attend and participate in monthly House Council meetings and Hall Councilor meetings beginning in May.'
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: 'In addition, Hall Councilors are responsible for "organizing activities and encouraging interactions among the residents at the Hall level" (SP Constitution). The Hall Councilors play an important role in looking after the residents, making sure residents feel welcome during orientation and part of the Sidney Pacific community during the year. Hall Councilors will have a termly budget to organize hall activities or procure hall resources. They have a lot of flexibility to develop programs which foster a greater sense of community within the halls. Please note, a lot of social events, relationship-building with other officers and residents, and learning about the Sidney Pacific government structure occurs in the summer. Although residents are not required to be present at Sidney Pacific during the summer to run for Hall Councilor, the strongest and most active hall councilors have historically been those living at Sidney Pacific during the summer.'
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "About elections"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: "Voting is anonymous. After you submit your vote, a random code will be generated and saved with your vote in the database. A copy of this code as well as a record of your vote will be emailed to you at the address specified below. Please save this email, as it will provide a way of verifying votes if necessary, while keeping the process anonymous. You may change your vote once you have submitted it only if you provide the passcode provided to you when you first voted."
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Information from the Sidney-Pacific Bylaws"
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            children: "Voters will be asked to rank a minimum of five candidates (or all candidates if their number is smaller than five) in order of preference and the votes will be counted using the Partial Preferential method. If no candidate receives a majority of first choice votes, the candidate with the fewest first place votes will be eliminated and that candidate's votes will go to the candidate that was listed as a second choice. This process will continue until a candidate receives a majority of the votes and is declared the winner. The first runner-up is determined by eliminating the winner from the votes cast and applying the partial preferential method as described above among the remaining candidates. This process is repeated until a complete order of finish for all candidates is determined. The winning candidate in any election shall be granted the option to accept office. If the option is not exercised within a time period specified by the trustees (not less than three days), it shall pass to the runners-up, in order of finish, resting with each for a period of one day, until the office is accepted."
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                            children: "Voting"
                        }),
                        vote_components
                    ]
                })
            ]
        })
    });
};
const $72b9fa7068397304$var$HcElections = ({ isAdmin: isAdmin, isTrustee: isTrustee, rng_seed: rng_seed })=>{
    const [elections, setElections] = (0, $8NFma.useState)(null);
    const [electionStatus, setElectionStatus] = (0, $8NFma.useState)({});
    const election_endpoint = `${$72b9fa7068397304$var$endpoint}/hall_councilor/active_elections`;
    const updateActiveElections = async ()=>{
        const election_promise = (0, $81tj9.default).get(election_endpoint);
        try {
            const { data: election_data } = await election_promise;
            setElections(election_data);
            const app_reqs = election_data.apply_elections.map((application_election)=>(0, $81tj9.default).get(`${$72b9fa7068397304$var$endpoint}/hall_councilor/application`, {
                    params: {
                        election_id: application_election.election_id
                    }
                }).catch((e)=>Promise.resolve({
                        election_id: application_election.election_id,
                        status: 'Apply'
                    })));
            let raw_data = await Promise.all(app_reqs);
            let newApplications = {};
            raw_data.forEach((_raw_data)=>{
                if (_raw_data.status === 'Apply') newApplications[_raw_data.election_id] = _raw_data.status;
                else if (_raw_data.data.withdrawn) newApplications[_raw_data.data.election_id] = 'You application was withdrawn. Please contact Chair of the Halls to re-open your application.';
                else newApplications[_raw_data.data.election_id] = 'Edit your application';
            });
            setElectionStatus(newApplications);
        } catch (e) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4tbyZ))).error('Unable to get list of elections details!');
            console.error(e);
        }
    };
    // get the election list
    (0, $8NFma.useEffect)(()=>{
        updateActiveElections();
    }, []);
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
        children: [
            isAdmin && /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$AdminInterface, {
                updateActiveElections: updateActiveElections
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$VotingInterface, {
                voting_elections: elections !== null ? elections.vote_elections : [],
                rng_seed: rng_seed,
                voting_for_hall: elections !== null ? elections.voting_for : 'Hall Councilors'
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$ApplicationInterface, {
                application_elections: elections !== null ? elections.apply_elections : [],
                electionStatus: electionStatus,
                updateActiveElections: updateActiveElections
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4tbyZ.Toaster), {})
            })
        ]
    });
};
var $72b9fa7068397304$export$2e2bcd8739ae039 = $72b9fa7068397304$var$HcElections;
const $72b9fa7068397304$var$container = document.getElementById('app');
const $72b9fa7068397304$var$is_admin = $72b9fa7068397304$var$container.dataset.hasAdminPermission === 'true';
const $72b9fa7068397304$var$is_trustee = $72b9fa7068397304$var$container.dataset.hasTrusteePermission === 'true';
const $72b9fa7068397304$var$rng_seed = $72b9fa7068397304$var$container.dataset.rngSeed;
const $72b9fa7068397304$var$root = (0, $6T1J1.createRoot)($72b9fa7068397304$var$container);
$72b9fa7068397304$var$root.render(/*#__PURE__*/ (0, $1IdZj.jsx)($72b9fa7068397304$var$HcElections, {
    isAdmin: $72b9fa7068397304$var$is_admin,
    isTrustee: $72b9fa7068397304$var$is_trustee,
    rng_seed: $72b9fa7068397304$var$rng_seed
}));

})();
//# sourceMappingURL=hc_elections.js.map
